import { jsx as V, jsxs as x1, Fragment as w4 } from "react/jsx-runtime";
import * as s1 from "react";
import J1, { useState as m1, useEffect as g1, useMemo as j1, useCallback as o1, createContext as C6, useContext as e4, useRef as v1, forwardRef as G4, useImperativeHandle as E6, useLayoutEffect as H9, cloneElement as A6, Component as ce, Fragment as l6, useTransition as W9 } from "react";
import { useLoader as ue, useThree as S6, useFrame as j9, Canvas as me } from "@react-three/fiber";
import { Loader as de, FileLoader as fe, Matrix3 as H4, Vector2 as M1, Vector3 as L1, Box2 as xe, ShapeUtils as he, Shape as X9, Path as E3, BufferGeometry as R6, Float32BufferAttribute as A3, SRGBColorSpace as pe, ShapePath as E4, Color as m2, Group as ge, BufferAttribute as be, ExtrudeGeometry as O6, MeshBasicMaterial as I4, DoubleSide as d2, ShapeGeometry as S3, Mesh as Y2, CanvasTexture as Z9, CurvePath as _e, LineCurve3 as ve, TubeGeometry as ye, Raycaster as Ie, PlaneGeometry as Ce, Box3 as Y9, PerspectiveCamera as B2, SpriteMaterial as Ee, Texture as Ae, MeshPhongMaterial as Se } from "three";
import { useFont as J9, Html as T6, MapControls as Re, Stats as Oe } from "@react-three/drei";
import J4, { createPortal as Te } from "react-dom";
const we = pe;
class w6 extends de {
  /**
   * Constructs a new SVG loader.
   *
   * @param {LoadingManager} [manager] - The loading manager.
   */
  constructor(t) {
    super(t), this.defaultDPI = 90, this.defaultUnit = "px";
  }
  /**
   * Starts loading from the given URL and passes the loaded SVG asset
   * to the `onLoad()` callback.
   *
   * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
   * @param {function({paths:Array<ShapePath>,xml:string})} onLoad - Executed when the loading process has been finished.
   * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
   * @param {onErrorCallback} onError - Executed when errors occur.
   */
  load(t, l, r, n) {
    const o = this, i = new fe(o.manager);
    i.setPath(o.path), i.setRequestHeader(o.requestHeader), i.setWithCredentials(o.withCredentials), i.load(t, function(q) {
      try {
        l(o.parse(q));
      } catch (a) {
        n ? n(a) : console.error(a), o.manager.itemError(t);
      }
    }, r, n);
  }
  /**
   * Parses the given SVG data and returns the resulting data.
   *
   * @param {string} text - The raw SVG data as a string.
   * @return {{paths:Array<ShapePath>,xml:string}} An object holding an array of shape paths and the
   * SVG XML document.
   */
  parse(t) {
    const l = this;
    function r(S, E) {
      if (S.nodeType !== 1) return;
      const g = m(S);
      let x = !1, R = null;
      switch (S.nodeName) {
        case "svg":
          E = v(S, E);
          break;
        case "style":
          o(S);
          break;
        case "g":
          E = v(S, E);
          break;
        case "path":
          E = v(S, E), S.hasAttribute("d") && (R = n(S));
          break;
        case "rect":
          E = v(S, E), R = a(S);
          break;
        case "polygon":
          E = v(S, E), R = s(S);
          break;
        case "polyline":
          E = v(S, E), R = c(S);
          break;
        case "circle":
          E = v(S, E), R = u(S);
          break;
        case "ellipse":
          E = v(S, E), R = _(S);
          break;
        case "line":
          E = v(S, E), R = A(S);
          break;
        case "defs":
          x = !0;
          break;
        case "use":
          E = v(S, E);
          const K = (S.getAttributeNS("http://www.w3.org/1999/xlink", "href") || "").substring(1), z = S.viewportElement.getElementById(K);
          z ? r(z, E) : console.warn("SVGLoader: 'use node' references non-existent node id: " + K);
          break;
      }
      R && (E.fill !== void 0 && E.fill !== "none" && R.color.setStyle(E.fill, we), I(R, M), k.push(R), R.userData = { node: S, style: E });
      const Y = S.childNodes;
      for (let B = 0; B < Y.length; B++) {
        const K = Y[B];
        x && K.nodeName !== "style" && K.nodeName !== "defs" || r(K, E);
      }
      g && (e1.pop(), e1.length > 0 ? M.copy(e1[e1.length - 1]) : M.identity());
    }
    function n(S) {
      const E = new E4(), g = new M1(), x = new M1(), R = new M1();
      let Y = !0, B = !1;
      const K = S.getAttribute("d");
      if (K === "" || K === "none") return null;
      const z = K.match(/[a-df-z][^a-df-z]*/ig);
      for (let l1 = 0, U = z.length; l1 < U; l1++) {
        const J = z[l1], N = J.charAt(0), D = J.slice(1).trim();
        Y === !0 && (B = !0, Y = !1);
        let O;
        switch (N) {
          case "M":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 2)
              g.x = O[y + 0], g.y = O[y + 1], x.x = g.x, x.y = g.y, y === 0 ? E.moveTo(g.x, g.y) : E.lineTo(g.x, g.y), y === 0 && R.copy(g);
            break;
          case "H":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y++)
              g.x = O[y], x.x = g.x, x.y = g.y, E.lineTo(g.x, g.y), y === 0 && B === !0 && R.copy(g);
            break;
          case "V":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y++)
              g.y = O[y], x.x = g.x, x.y = g.y, E.lineTo(g.x, g.y), y === 0 && B === !0 && R.copy(g);
            break;
          case "L":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 2)
              g.x = O[y + 0], g.y = O[y + 1], x.x = g.x, x.y = g.y, E.lineTo(g.x, g.y), y === 0 && B === !0 && R.copy(g);
            break;
          case "C":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 6)
              E.bezierCurveTo(
                O[y + 0],
                O[y + 1],
                O[y + 2],
                O[y + 3],
                O[y + 4],
                O[y + 5]
              ), x.x = O[y + 2], x.y = O[y + 3], g.x = O[y + 4], g.y = O[y + 5], y === 0 && B === !0 && R.copy(g);
            break;
          case "S":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 4)
              E.bezierCurveTo(
                b(g.x, x.x),
                b(g.y, x.y),
                O[y + 0],
                O[y + 1],
                O[y + 2],
                O[y + 3]
              ), x.x = O[y + 0], x.y = O[y + 1], g.x = O[y + 2], g.y = O[y + 3], y === 0 && B === !0 && R.copy(g);
            break;
          case "Q":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 4)
              E.quadraticCurveTo(
                O[y + 0],
                O[y + 1],
                O[y + 2],
                O[y + 3]
              ), x.x = O[y + 0], x.y = O[y + 1], g.x = O[y + 2], g.y = O[y + 3], y === 0 && B === !0 && R.copy(g);
            break;
          case "T":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 2) {
              const i1 = b(g.x, x.x), y1 = b(g.y, x.y);
              E.quadraticCurveTo(
                i1,
                y1,
                O[y + 0],
                O[y + 1]
              ), x.x = i1, x.y = y1, g.x = O[y + 0], g.y = O[y + 1], y === 0 && B === !0 && R.copy(g);
            }
            break;
          case "A":
            O = h(D, [3, 4], 7);
            for (let y = 0, n1 = O.length; y < n1; y += 7) {
              if (O[y + 5] == g.x && O[y + 6] == g.y) continue;
              const i1 = g.clone();
              g.x = O[y + 5], g.y = O[y + 6], x.x = g.x, x.y = g.y, i(
                E,
                O[y],
                O[y + 1],
                O[y + 2],
                O[y + 3],
                O[y + 4],
                i1,
                g
              ), y === 0 && B === !0 && R.copy(g);
            }
            break;
          case "m":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 2)
              g.x += O[y + 0], g.y += O[y + 1], x.x = g.x, x.y = g.y, y === 0 ? E.moveTo(g.x, g.y) : E.lineTo(g.x, g.y), y === 0 && R.copy(g);
            break;
          case "h":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y++)
              g.x += O[y], x.x = g.x, x.y = g.y, E.lineTo(g.x, g.y), y === 0 && B === !0 && R.copy(g);
            break;
          case "v":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y++)
              g.y += O[y], x.x = g.x, x.y = g.y, E.lineTo(g.x, g.y), y === 0 && B === !0 && R.copy(g);
            break;
          case "l":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 2)
              g.x += O[y + 0], g.y += O[y + 1], x.x = g.x, x.y = g.y, E.lineTo(g.x, g.y), y === 0 && B === !0 && R.copy(g);
            break;
          case "c":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 6)
              E.bezierCurveTo(
                g.x + O[y + 0],
                g.y + O[y + 1],
                g.x + O[y + 2],
                g.y + O[y + 3],
                g.x + O[y + 4],
                g.y + O[y + 5]
              ), x.x = g.x + O[y + 2], x.y = g.y + O[y + 3], g.x += O[y + 4], g.y += O[y + 5], y === 0 && B === !0 && R.copy(g);
            break;
          case "s":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 4)
              E.bezierCurveTo(
                b(g.x, x.x),
                b(g.y, x.y),
                g.x + O[y + 0],
                g.y + O[y + 1],
                g.x + O[y + 2],
                g.y + O[y + 3]
              ), x.x = g.x + O[y + 0], x.y = g.y + O[y + 1], g.x += O[y + 2], g.y += O[y + 3], y === 0 && B === !0 && R.copy(g);
            break;
          case "q":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 4)
              E.quadraticCurveTo(
                g.x + O[y + 0],
                g.y + O[y + 1],
                g.x + O[y + 2],
                g.y + O[y + 3]
              ), x.x = g.x + O[y + 0], x.y = g.y + O[y + 1], g.x += O[y + 2], g.y += O[y + 3], y === 0 && B === !0 && R.copy(g);
            break;
          case "t":
            O = h(D);
            for (let y = 0, n1 = O.length; y < n1; y += 2) {
              const i1 = b(g.x, x.x), y1 = b(g.y, x.y);
              E.quadraticCurveTo(
                i1,
                y1,
                g.x + O[y + 0],
                g.y + O[y + 1]
              ), x.x = i1, x.y = y1, g.x = g.x + O[y + 0], g.y = g.y + O[y + 1], y === 0 && B === !0 && R.copy(g);
            }
            break;
          case "a":
            O = h(D, [3, 4], 7);
            for (let y = 0, n1 = O.length; y < n1; y += 7) {
              if (O[y + 5] == 0 && O[y + 6] == 0) continue;
              const i1 = g.clone();
              g.x += O[y + 5], g.y += O[y + 6], x.x = g.x, x.y = g.y, i(
                E,
                O[y],
                O[y + 1],
                O[y + 2],
                O[y + 3],
                O[y + 4],
                i1,
                g
              ), y === 0 && B === !0 && R.copy(g);
            }
            break;
          case "Z":
          case "z":
            E.currentPath.autoClose = !0, E.currentPath.curves.length > 0 && (g.copy(R), E.currentPath.currentPoint.copy(g), Y = !0);
            break;
          default:
            console.warn(J);
        }
        B = !1;
      }
      return E;
    }
    function o(S) {
      if (!(!S.sheet || !S.sheet.cssRules || !S.sheet.cssRules.length))
        for (let E = 0; E < S.sheet.cssRules.length; E++) {
          const g = S.sheet.cssRules[E];
          if (g.type !== 1) continue;
          const x = g.selectorText.split(/,/gm).filter(Boolean).map((R) => R.trim());
          for (let R = 0; R < x.length; R++) {
            const Y = Object.fromEntries(
              Object.entries(g.style).filter(([, B]) => B !== "")
            );
            t1[x[R]] = Object.assign(
              t1[x[R]] || {},
              Y
            );
          }
        }
    }
    function i(S, E, g, x, R, Y, B, K) {
      if (E == 0 || g == 0) {
        S.lineTo(K.x, K.y);
        return;
      }
      x = x * Math.PI / 180, E = Math.abs(E), g = Math.abs(g);
      const z = (B.x - K.x) / 2, l1 = (B.y - K.y) / 2, U = Math.cos(x) * z + Math.sin(x) * l1, J = -Math.sin(x) * z + Math.cos(x) * l1;
      let N = E * E, D = g * g;
      const O = U * U, y = J * J, n1 = O / N + y / D;
      if (n1 > 1) {
        const C4 = Math.sqrt(n1);
        E = C4 * E, g = C4 * g, N = E * E, D = g * g;
      }
      const i1 = N * y + D * O, y1 = (N * D - i1) / i1;
      let I1 = Math.sqrt(Math.max(0, y1));
      R === Y && (I1 = -I1);
      const N1 = I1 * E * J / g, l4 = -I1 * g * U / E, _1 = Math.cos(x) * N1 - Math.sin(x) * l4 + (B.x + K.x) / 2, i4 = Math.sin(x) * N1 + Math.cos(x) * l4 + (B.y + K.y) / 2, U1 = q(1, 0, (U - N1) / E, (J - l4) / g), c4 = q((U - N1) / E, (J - l4) / g, (-U - N1) / E, (-J - l4) / g) % (Math.PI * 2);
      S.currentPath.absellipse(_1, i4, E, g, U1, U1 + c4, Y === 0, x);
    }
    function q(S, E, g, x) {
      const R = S * g + E * x, Y = Math.sqrt(S * S + E * E) * Math.sqrt(g * g + x * x);
      let B = Math.acos(Math.max(-1, Math.min(1, R / Y)));
      return S * x - E * g < 0 && (B = -B), B;
    }
    function a(S) {
      const E = f(S.getAttribute("x") || 0), g = f(S.getAttribute("y") || 0), x = f(S.getAttribute("rx") || S.getAttribute("ry") || 0), R = f(S.getAttribute("ry") || S.getAttribute("rx") || 0), Y = f(S.getAttribute("width")), B = f(S.getAttribute("height")), K = 1 - 0.551915024494, z = new E4();
      return z.moveTo(E + x, g), z.lineTo(E + Y - x, g), (x !== 0 || R !== 0) && z.bezierCurveTo(
        E + Y - x * K,
        g,
        E + Y,
        g + R * K,
        E + Y,
        g + R
      ), z.lineTo(E + Y, g + B - R), (x !== 0 || R !== 0) && z.bezierCurveTo(
        E + Y,
        g + B - R * K,
        E + Y - x * K,
        g + B,
        E + Y - x,
        g + B
      ), z.lineTo(E + x, g + B), (x !== 0 || R !== 0) && z.bezierCurveTo(
        E + x * K,
        g + B,
        E,
        g + B - R * K,
        E,
        g + B - R
      ), z.lineTo(E, g + R), (x !== 0 || R !== 0) && z.bezierCurveTo(E, g + R * K, E + x * K, g, E + x, g), z;
    }
    function s(S) {
      function E(Y, B, K) {
        const z = f(B), l1 = f(K);
        R === 0 ? x.moveTo(z, l1) : x.lineTo(z, l1), R++;
      }
      const g = /([+-]?\d*\.?\d+(?:e[+-]?\d+)?)(?:,|\s)([+-]?\d*\.?\d+(?:e[+-]?\d+)?)/g, x = new E4();
      let R = 0;
      return S.getAttribute("points").replace(g, E), x.currentPath.autoClose = !0, x;
    }
    function c(S) {
      function E(Y, B, K) {
        const z = f(B), l1 = f(K);
        R === 0 ? x.moveTo(z, l1) : x.lineTo(z, l1), R++;
      }
      const g = /([+-]?\d*\.?\d+(?:e[+-]?\d+)?)(?:,|\s)([+-]?\d*\.?\d+(?:e[+-]?\d+)?)/g, x = new E4();
      let R = 0;
      return S.getAttribute("points").replace(g, E), x.currentPath.autoClose = !1, x;
    }
    function u(S) {
      const E = f(S.getAttribute("cx") || 0), g = f(S.getAttribute("cy") || 0), x = f(S.getAttribute("r") || 0), R = new E3();
      R.absarc(E, g, x, 0, Math.PI * 2);
      const Y = new E4();
      return Y.subPaths.push(R), Y;
    }
    function _(S) {
      const E = f(S.getAttribute("cx") || 0), g = f(S.getAttribute("cy") || 0), x = f(S.getAttribute("rx") || 0), R = f(S.getAttribute("ry") || 0), Y = new E3();
      Y.absellipse(E, g, x, R, 0, Math.PI * 2);
      const B = new E4();
      return B.subPaths.push(Y), B;
    }
    function A(S) {
      const E = f(S.getAttribute("x1") || 0), g = f(S.getAttribute("y1") || 0), x = f(S.getAttribute("x2") || 0), R = f(S.getAttribute("y2") || 0), Y = new E4();
      return Y.moveTo(E, g), Y.lineTo(x, R), Y.currentPath.autoClose = !1, Y;
    }
    function v(S, E) {
      E = Object.assign({}, E);
      let g = {};
      if (S.hasAttribute("class")) {
        const B = S.getAttribute("class").split(/\s/).filter(Boolean).map((K) => K.trim());
        for (let K = 0; K < B.length; K++)
          g = Object.assign(g, t1["." + B[K]]);
      }
      S.hasAttribute("id") && (g = Object.assign(g, t1["#" + S.getAttribute("id")]));
      function x(B, K, z) {
        z === void 0 && (z = function(U) {
          return U.startsWith("url") && console.warn("SVGLoader: url access in attributes is not implemented."), U;
        }), S.hasAttribute(B) && (E[K] = z(S.getAttribute(B))), g[B] && (E[K] = z(g[B])), S.style && S.style[B] !== "" && (E[K] = z(S.style[B]));
      }
      function R(B) {
        return Math.max(0, Math.min(1, f(B)));
      }
      function Y(B) {
        return Math.max(0, f(B));
      }
      return x("fill", "fill"), x("fill-opacity", "fillOpacity", R), x("fill-rule", "fillRule"), x("opacity", "opacity", R), x("stroke", "stroke"), x("stroke-opacity", "strokeOpacity", R), x("stroke-width", "strokeWidth", Y), x("stroke-linejoin", "strokeLineJoin"), x("stroke-linecap", "strokeLineCap"), x("stroke-miterlimit", "strokeMiterLimit", Y), x("visibility", "visibility"), E;
    }
    function b(S, E) {
      return S - (E - S);
    }
    function h(S, E, g) {
      if (typeof S != "string")
        throw new TypeError("Invalid input: " + typeof S);
      const x = {
        WHITESPACE: /[ \t\r\n]/,
        DIGIT: /[\d]/,
        SIGN: /[-+]/,
        POINT: /\./,
        COMMA: /,/,
        EXP: /e/i,
        FLAGS: /[01]/
      }, R = 0, Y = 1, B = 2, K = 3;
      let z = R, l1 = !0, U = "", J = "";
      const N = [];
      function D(i1, y1, I1) {
        const N1 = new SyntaxError('Unexpected character "' + i1 + '" at index ' + y1 + ".");
        throw N1.partial = I1, N1;
      }
      function O() {
        U !== "" && (J === "" ? N.push(Number(U)) : N.push(Number(U) * Math.pow(10, Number(J)))), U = "", J = "";
      }
      let y;
      const n1 = S.length;
      for (let i1 = 0; i1 < n1; i1++) {
        if (y = S[i1], Array.isArray(E) && E.includes(N.length % g) && x.FLAGS.test(y)) {
          z = Y, U = y, O();
          continue;
        }
        if (z === R) {
          if (x.WHITESPACE.test(y))
            continue;
          if (x.DIGIT.test(y) || x.SIGN.test(y)) {
            z = Y, U = y;
            continue;
          }
          if (x.POINT.test(y)) {
            z = B, U = y;
            continue;
          }
          x.COMMA.test(y) && (l1 && D(y, i1, N), l1 = !0);
        }
        if (z === Y) {
          if (x.DIGIT.test(y)) {
            U += y;
            continue;
          }
          if (x.POINT.test(y)) {
            U += y, z = B;
            continue;
          }
          if (x.EXP.test(y)) {
            z = K;
            continue;
          }
          x.SIGN.test(y) && U.length === 1 && x.SIGN.test(U[0]) && D(y, i1, N);
        }
        if (z === B) {
          if (x.DIGIT.test(y)) {
            U += y;
            continue;
          }
          if (x.EXP.test(y)) {
            z = K;
            continue;
          }
          x.POINT.test(y) && U[U.length - 1] === "." && D(y, i1, N);
        }
        if (z === K) {
          if (x.DIGIT.test(y)) {
            J += y;
            continue;
          }
          if (x.SIGN.test(y)) {
            if (J === "") {
              J += y;
              continue;
            }
            J.length === 1 && x.SIGN.test(J) && D(y, i1, N);
          }
        }
        x.WHITESPACE.test(y) ? (O(), z = R, l1 = !1) : x.COMMA.test(y) ? (O(), z = R, l1 = !0) : x.SIGN.test(y) ? (O(), z = Y, U = y) : x.POINT.test(y) ? (O(), z = B, U = y) : D(y, i1, N);
      }
      return O(), N;
    }
    const d = ["mm", "cm", "in", "pt", "pc", "px"], C = {
      mm: {
        mm: 1,
        cm: 0.1,
        in: 1 / 25.4,
        pt: 72 / 25.4,
        pc: 6 / 25.4,
        px: -1
      },
      cm: {
        mm: 10,
        cm: 1,
        in: 1 / 2.54,
        pt: 72 / 2.54,
        pc: 6 / 2.54,
        px: -1
      },
      in: {
        mm: 25.4,
        cm: 2.54,
        in: 1,
        pt: 72,
        pc: 6,
        px: -1
      },
      pt: {
        mm: 25.4 / 72,
        cm: 2.54 / 72,
        in: 1 / 72,
        pt: 1,
        pc: 6 / 72,
        px: -1
      },
      pc: {
        mm: 25.4 / 6,
        cm: 2.54 / 6,
        in: 1 / 6,
        pt: 72 / 6,
        pc: 1,
        px: -1
      },
      px: {
        px: 1
      }
    };
    function f(S) {
      let E = "px";
      if (typeof S == "string" || S instanceof String)
        for (let x = 0, R = d.length; x < R; x++) {
          const Y = d[x];
          if (S.endsWith(Y)) {
            E = Y, S = S.substring(0, S.length - Y.length);
            break;
          }
        }
      let g;
      return E === "px" && l.defaultUnit !== "px" ? g = C.in[l.defaultUnit] / l.defaultDPI : (g = C[E][l.defaultUnit], g < 0 && (g = C[E].in * l.defaultDPI)), g * parseFloat(S);
    }
    function m(S) {
      if (!(S.hasAttribute("transform") || S.nodeName === "use" && (S.hasAttribute("x") || S.hasAttribute("y"))))
        return null;
      const E = p(S);
      return e1.length > 0 && E.premultiply(e1[e1.length - 1]), M.copy(E), e1.push(E), E;
    }
    function p(S) {
      const E = new H4(), g = Q;
      if (S.nodeName === "use" && (S.hasAttribute("x") || S.hasAttribute("y"))) {
        const x = f(S.getAttribute("x")), R = f(S.getAttribute("y"));
        E.translate(x, R);
      }
      if (S.hasAttribute("transform")) {
        const x = S.getAttribute("transform").split(")");
        for (let R = x.length - 1; R >= 0; R--) {
          const Y = x[R].trim();
          if (Y === "") continue;
          const B = Y.indexOf("("), K = Y.length;
          if (B > 0 && B < K) {
            const z = Y.slice(0, B), l1 = h(Y.slice(B + 1));
            switch (g.identity(), z) {
              case "translate":
                if (l1.length >= 1) {
                  const U = l1[0];
                  let J = 0;
                  l1.length >= 2 && (J = l1[1]), g.translate(U, J);
                }
                break;
              case "rotate":
                if (l1.length >= 1) {
                  let U = 0, J = 0, N = 0;
                  U = l1[0] * Math.PI / 180, l1.length >= 3 && (J = l1[1], N = l1[2]), Z.makeTranslation(-J, -N), X.makeRotation(U), G.multiplyMatrices(X, Z), Z.makeTranslation(J, N), g.multiplyMatrices(Z, G);
                }
                break;
              case "scale":
                if (l1.length >= 1) {
                  const U = l1[0];
                  let J = U;
                  l1.length >= 2 && (J = l1[1]), g.scale(U, J);
                }
                break;
              case "skewX":
                l1.length === 1 && g.set(
                  1,
                  Math.tan(l1[0] * Math.PI / 180),
                  0,
                  0,
                  1,
                  0,
                  0,
                  0,
                  1
                );
                break;
              case "skewY":
                l1.length === 1 && g.set(
                  1,
                  0,
                  0,
                  Math.tan(l1[0] * Math.PI / 180),
                  1,
                  0,
                  0,
                  0,
                  1
                );
                break;
              case "matrix":
                l1.length === 6 && g.set(
                  l1[0],
                  l1[2],
                  l1[4],
                  l1[1],
                  l1[3],
                  l1[5],
                  0,
                  0,
                  1
                );
                break;
            }
          }
          E.premultiply(g);
        }
      }
      return E;
    }
    function I(S, E) {
      function g(B) {
        F.set(B.x, B.y, 1).applyMatrix3(E), B.set(F.x, F.y);
      }
      function x(B) {
        const K = B.xRadius, z = B.yRadius, l1 = Math.cos(B.aRotation), U = Math.sin(B.aRotation), J = new L1(K * l1, K * U, 0), N = new L1(-z * U, z * l1, 0), D = J.applyMatrix3(E), O = N.applyMatrix3(E), y = Q.set(
          D.x,
          O.x,
          0,
          D.y,
          O.y,
          0,
          0,
          0,
          1
        ), n1 = Z.copy(y).invert(), I1 = X.copy(n1).transpose().multiply(n1).elements, N1 = $(I1[0], I1[1], I1[4]), l4 = Math.sqrt(N1.rt1), _1 = Math.sqrt(N1.rt2);
        if (B.xRadius = 1 / l4, B.yRadius = 1 / _1, B.aRotation = Math.atan2(N1.sn, N1.cs), !((B.aEndAngle - B.aStartAngle) % (2 * Math.PI) < Number.EPSILON)) {
          const U1 = Z.set(
            l4,
            0,
            0,
            0,
            _1,
            0,
            0,
            0,
            1
          ), c4 = X.set(
            N1.cs,
            N1.sn,
            0,
            -N1.sn,
            N1.cs,
            0,
            0,
            0,
            1
          ), C4 = U1.multiply(c4).multiply(y), t4 = (C2) => {
            const { x: r2, y: k4 } = new L1(Math.cos(C2), Math.sin(C2), 0).applyMatrix3(C4);
            return Math.atan2(k4, r2);
          };
          B.aStartAngle = t4(B.aStartAngle), B.aEndAngle = t4(B.aEndAngle), w(E) && (B.aClockwise = !B.aClockwise);
        }
      }
      function R(B) {
        const K = L(E), z = j(E);
        B.xRadius *= K, B.yRadius *= z;
        const l1 = K > Number.EPSILON ? Math.atan2(E.elements[1], E.elements[0]) : Math.atan2(-E.elements[3], E.elements[4]);
        B.aRotation += l1, w(E) && (B.aStartAngle *= -1, B.aEndAngle *= -1, B.aClockwise = !B.aClockwise);
      }
      const Y = S.subPaths;
      for (let B = 0, K = Y.length; B < K; B++) {
        const l1 = Y[B].curves;
        for (let U = 0; U < l1.length; U++) {
          const J = l1[U];
          J.isLineCurve ? (g(J.v1), g(J.v2)) : J.isCubicBezierCurve ? (g(J.v0), g(J.v1), g(J.v2), g(J.v3)) : J.isQuadraticBezierCurve ? (g(J.v0), g(J.v1), g(J.v2)) : J.isEllipseCurve && (a1.set(J.aX, J.aY), g(a1), J.aX = a1.x, J.aY = a1.y, T(E) ? x(J) : R(J));
        }
      }
    }
    function w(S) {
      const E = S.elements;
      return E[0] * E[4] - E[1] * E[3] < 0;
    }
    function T(S) {
      const E = S.elements, g = E[0] * E[3] + E[1] * E[4];
      if (g === 0) return !1;
      const x = L(S), R = j(S);
      return Math.abs(g / (x * R)) > Number.EPSILON;
    }
    function L(S) {
      const E = S.elements;
      return Math.sqrt(E[0] * E[0] + E[1] * E[1]);
    }
    function j(S) {
      const E = S.elements;
      return Math.sqrt(E[3] * E[3] + E[4] * E[4]);
    }
    function $(S, E, g) {
      let x, R, Y, B, K;
      const z = S + g, l1 = S - g, U = Math.sqrt(l1 * l1 + 4 * E * E);
      return z > 0 ? (x = 0.5 * (z + U), K = 1 / x, R = S * K * g - E * K * E) : z < 0 ? R = 0.5 * (z - U) : (x = 0.5 * U, R = -0.5 * U), l1 > 0 ? Y = l1 + U : Y = l1 - U, Math.abs(Y) > 2 * Math.abs(E) ? (K = -2 * E / Y, B = 1 / Math.sqrt(1 + K * K), Y = K * B) : Math.abs(E) === 0 ? (Y = 1, B = 0) : (K = -0.5 * Y / E, Y = 1 / Math.sqrt(1 + K * K), B = K * Y), l1 > 0 && (K = Y, Y = -B, B = K), { rt1: x, rt2: R, cs: Y, sn: B };
    }
    const k = [], t1 = {}, e1 = [], Q = new H4(), Z = new H4(), X = new H4(), G = new H4(), a1 = new M1(), F = new L1(), M = new H4(), H = new DOMParser().parseFromString(t, "image/svg+xml");
    return r(H.documentElement, {
      fill: "#000",
      fillOpacity: 1,
      strokeOpacity: 1,
      strokeWidth: 1,
      strokeLineJoin: "miter",
      strokeLineCap: "butt",
      strokeMiterLimit: 4
    }), { paths: k, xml: H.documentElement };
  }
  /**
   * Creates from the given shape path and array of shapes.
   *
   * @param {ShapePath} shapePath - The shape path.
   * @return {Array<Shape>} An array of shapes.
   */
  static createShapes(t) {
    const r = {
      ORIGIN: 0,
      DESTINATION: 1,
      BETWEEN: 2,
      LEFT: 3,
      RIGHT: 4,
      BEHIND: 5,
      BEYOND: 6
    }, n = {
      loc: r.ORIGIN,
      t: 0
    };
    function o(b, h, d, C) {
      const f = b.x, m = h.x, p = d.x, I = C.x, w = b.y, T = h.y, L = d.y, j = C.y, $ = (I - p) * (w - L) - (j - L) * (f - p), k = (m - f) * (w - L) - (T - w) * (f - p), t1 = (j - L) * (m - f) - (I - p) * (T - w), e1 = $ / t1, Q = k / t1;
      if (t1 === 0 && $ !== 0 || e1 <= 0 || e1 >= 1 || Q < 0 || Q > 1)
        return null;
      if ($ === 0 && t1 === 0) {
        for (let Z = 0; Z < 2; Z++)
          if (i(Z === 0 ? d : C, b, h), n.loc == r.ORIGIN) {
            const X = Z === 0 ? d : C;
            return { x: X.x, y: X.y, t: n.t };
          } else if (n.loc == r.BETWEEN) {
            const X = +(f + n.t * (m - f)).toPrecision(10), G = +(w + n.t * (T - w)).toPrecision(10);
            return { x: X, y: G, t: n.t };
          }
        return null;
      } else {
        for (let G = 0; G < 2; G++)
          if (i(G === 0 ? d : C, b, h), n.loc == r.ORIGIN) {
            const a1 = G === 0 ? d : C;
            return { x: a1.x, y: a1.y, t: n.t };
          }
        const Z = +(f + e1 * (m - f)).toPrecision(10), X = +(w + e1 * (T - w)).toPrecision(10);
        return { x: Z, y: X, t: e1 };
      }
    }
    function i(b, h, d) {
      const C = d.x - h.x, f = d.y - h.y, m = b.x - h.x, p = b.y - h.y, I = C * p - m * f;
      if (b.x === h.x && b.y === h.y) {
        n.loc = r.ORIGIN, n.t = 0;
        return;
      }
      if (b.x === d.x && b.y === d.y) {
        n.loc = r.DESTINATION, n.t = 1;
        return;
      }
      if (I < -Number.EPSILON) {
        n.loc = r.LEFT;
        return;
      }
      if (I > Number.EPSILON) {
        n.loc = r.RIGHT;
        return;
      }
      if (C * m < 0 || f * p < 0) {
        n.loc = r.BEHIND;
        return;
      }
      if (Math.sqrt(C * C + f * f) < Math.sqrt(m * m + p * p)) {
        n.loc = r.BEYOND;
        return;
      }
      let w;
      C !== 0 ? w = m / C : w = p / f, n.loc = r.BETWEEN, n.t = w;
    }
    function q(b, h) {
      const d = [], C = [];
      for (let f = 1; f < b.length; f++) {
        const m = b[f - 1], p = b[f];
        for (let I = 1; I < h.length; I++) {
          const w = h[I - 1], T = h[I], L = o(m, p, w, T);
          L !== null && d.find((j) => j.t <= L.t + Number.EPSILON && j.t >= L.t - Number.EPSILON) === void 0 && (d.push(L), C.push(new M1(L.x, L.y)));
        }
      }
      return C;
    }
    function a(b, h, d) {
      const C = new M1();
      h.getCenter(C);
      const f = [];
      return d.forEach((m) => {
        m.boundingBox.containsPoint(C) && q(b, m.points).forEach((I) => {
          f.push({ identifier: m.identifier, isCW: m.isCW, point: I });
        });
      }), f.sort((m, p) => m.point.x - p.point.x), f;
    }
    function s(b, h, d, C, f) {
      (f == null || f === "") && (f = "nonzero");
      const m = new M1();
      b.boundingBox.getCenter(m);
      const p = [new M1(d, m.y), new M1(C, m.y)], I = a(p, b.boundingBox, h);
      I.sort((k, t1) => k.point.x - t1.point.x);
      const w = [], T = [];
      I.forEach((k) => {
        k.identifier === b.identifier ? w.push(k) : T.push(k);
      });
      const L = w[0].point.x, j = [];
      let $ = 0;
      for (; $ < T.length && T[$].point.x < L; )
        j.length > 0 && j[j.length - 1] === T[$].identifier ? j.pop() : j.push(T[$].identifier), $++;
      if (j.push(b.identifier), f === "evenodd") {
        const k = j.length % 2 === 0, t1 = j[j.length - 2];
        return { identifier: b.identifier, isHole: k, for: t1 };
      } else if (f === "nonzero") {
        let k = !0, t1 = null, e1 = null;
        for (let Q = 0; Q < j.length; Q++) {
          const Z = j[Q];
          k ? (e1 = h[Z].isCW, k = !1, t1 = Z) : e1 !== h[Z].isCW && (e1 = h[Z].isCW, k = !0);
        }
        return { identifier: b.identifier, isHole: k, for: t1 };
      } else
        console.warn('fill-rule: "' + f + '" is currently not implemented.');
    }
    let c = 999999999, u = -999999999, _ = t.subPaths.map((b) => {
      const h = b.getPoints();
      let d = -999999999, C = 999999999, f = -999999999, m = 999999999;
      for (let p = 0; p < h.length; p++) {
        const I = h[p];
        I.y > d && (d = I.y), I.y < C && (C = I.y), I.x > f && (f = I.x), I.x < m && (m = I.x);
      }
      return u <= f && (u = f + 1), c >= m && (c = m - 1), { curves: b.curves, points: h, isCW: he.isClockWise(h), identifier: -1, boundingBox: new xe(new M1(m, C), new M1(f, d)) };
    });
    _ = _.filter((b) => b.points.length > 1);
    for (let b = 0; b < _.length; b++)
      _[b].identifier = b;
    const A = _.map((b) => s(b, _, c, u, t.userData ? t.userData.style.fillRule : void 0)), v = [];
    return _.forEach((b) => {
      if (!A[b.identifier].isHole) {
        const d = new X9();
        d.curves = b.curves, A.filter((f) => f.isHole && f.for === b.identifier).forEach((f) => {
          const m = _[f.identifier], p = new E3();
          p.curves = m.curves, d.holes.push(p);
        }), v.push(d);
      }
    }), v;
  }
  /**
   * Returns a stroke style object from the given parameters.
   *
   * @param {number} [width=1] - The stroke width.
   * @param {string} [color='#000'] - The stroke color, as  returned by {@link Color#getStyle}.
   * @param {'round'|'bevel'|'miter'|'miter-limit'} [lineJoin='miter'] - The line join style.
   * @param {'round'|'square'|'butt'} [lineCap='butt'] - The line cap style.
   * @param {number} [miterLimit=4] - Maximum join length, in multiples of the `width` parameter (join is truncated if it exceeds that distance).
   * @return {Object} The style object.
   */
  static getStrokeStyle(t, l, r, n, o) {
    return t = t !== void 0 ? t : 1, l = l !== void 0 ? l : "#000", r = r !== void 0 ? r : "miter", n = n !== void 0 ? n : "butt", o = o !== void 0 ? o : 4, {
      strokeColor: l,
      strokeWidth: t,
      strokeLineJoin: r,
      strokeLineCap: n,
      strokeMiterLimit: o
    };
  }
  /**
   * Creates a stroke from an array of points.
   *
   * @param {Array<Vector2>} points - The points in 2D space. Minimum 2 points. The path can be open or closed (last point equals to first point).
   * @param {Object} style - Object with SVG properties as returned by `SVGLoader.getStrokeStyle()`, or `SVGLoader.parse()` in the `path.userData.style` object.
   * @param {number} [arcDivisions=12] - Arc divisions for round joins and endcaps.
   * @param {number} [minDistance=0.001] - Points closer to this distance will be merged.
   * @return {?BufferGeometry} The stroke geometry. UV coordinates are generated ('u' along path. 'v' across it, from left to right).
   * Returns `null` if not geometry was generated.
   */
  static pointsToStroke(t, l, r, n) {
    const o = [], i = [], q = [];
    if (w6.pointsToStrokeWithBuffers(t, l, r, n, o, i, q) === 0)
      return null;
    const a = new R6();
    return a.setAttribute("position", new A3(o, 3)), a.setAttribute("normal", new A3(i, 3)), a.setAttribute("uv", new A3(q, 2)), a;
  }
  /**
   * Creates a stroke from an array of points.
   *
   * @param {Array<Vector2>} points - The points in 2D space. Minimum 2 points.
   * @param {Object} style - Object with SVG properties as returned by `SVGLoader.getStrokeStyle()`, or `SVGLoader.parse()` in the `path.userData.style` object.
   * @param {number} [arcDivisions=12] - Arc divisions for round joins and endcaps.
   * @param {number} [minDistance=0.001] - Points closer to this distance will be merged.
   * @param {Array<number>} vertices - An array holding vertices.
   * @param {Array<number>} normals - An array holding normals.
   * @param {Array<number>} uvs - An array holding uvs.
   * @param {number} [vertexOffset=0] - The vertex offset.
   * @return {number} The number of vertices.
   */
  static pointsToStrokeWithBuffers(t, l, r, n, o, i, q, a) {
    const s = new M1(), c = new M1(), u = new M1(), _ = new M1(), A = new M1(), v = new M1(), b = new M1(), h = new M1(), d = new M1(), C = new M1(), f = new M1(), m = new M1(), p = new M1(), I = new M1(), w = new M1(), T = new M1(), L = new M1();
    r = r !== void 0 ? r : 12, n = n !== void 0 ? n : 1e-3, a = a !== void 0 ? a : 0, t = l1(t);
    const j = t.length;
    if (j < 2) return 0;
    const $ = t[0].equals(t[j - 1]);
    let k, t1 = t[0], e1;
    const Q = l.strokeWidth / 2, Z = 1 / (j - 1);
    let X = 0, G, a1, F, M, H = !1, W = 0, S = a * 3, E = a * 2;
    g(t[0], t[1], s).multiplyScalar(Q), h.copy(t[0]).sub(s), d.copy(t[0]).add(s), C.copy(h), f.copy(d);
    for (let U = 1; U < j; U++) {
      k = t[U], U === j - 1 ? $ ? e1 = t[1] : e1 = void 0 : e1 = t[U + 1];
      const J = s;
      if (g(t1, k, J), u.copy(J).multiplyScalar(Q), m.copy(k).sub(u), p.copy(k).add(u), G = X + Z, a1 = !1, e1 !== void 0) {
        g(k, e1, c), u.copy(c).multiplyScalar(Q), I.copy(k).sub(u), w.copy(k).add(u), F = !0, u.subVectors(e1, t1), J.dot(u) < 0 && (F = !1), U === 1 && (H = F), u.subVectors(e1, k), u.normalize();
        const N = Math.abs(J.dot(u));
        if (N > Number.EPSILON) {
          const D = Q / N;
          u.multiplyScalar(-D), _.subVectors(k, t1), A.copy(_).setLength(D).add(u), T.copy(A).negate();
          const O = A.length(), y = _.length();
          _.divideScalar(y), v.subVectors(e1, k);
          const n1 = v.length();
          switch (v.divideScalar(n1), _.dot(T) < y && v.dot(T) < n1 && (a1 = !0), L.copy(A).add(k), T.add(k), M = !1, a1 ? F ? (w.copy(T), p.copy(T)) : (I.copy(T), m.copy(T)) : Y(), l.strokeLineJoin) {
            case "bevel":
              B(F, a1, G);
              break;
            case "round":
              K(F, a1), F ? R(k, m, I, G, 0) : R(k, w, p, G, 1);
              break;
            case "miter":
            case "miter-clip":
            default:
              const i1 = Q * l.strokeMiterLimit / O;
              if (i1 < 1)
                if (l.strokeLineJoin !== "miter-clip") {
                  B(F, a1, G);
                  break;
                } else
                  K(F, a1), F ? (v.subVectors(L, m).multiplyScalar(i1).add(m), b.subVectors(L, I).multiplyScalar(i1).add(I), x(m, G, 0), x(v, G, 0), x(k, G, 0.5), x(k, G, 0.5), x(v, G, 0), x(b, G, 0), x(k, G, 0.5), x(b, G, 0), x(I, G, 0)) : (v.subVectors(L, p).multiplyScalar(i1).add(p), b.subVectors(L, w).multiplyScalar(i1).add(w), x(p, G, 1), x(v, G, 1), x(k, G, 0.5), x(k, G, 0.5), x(v, G, 1), x(b, G, 1), x(k, G, 0.5), x(b, G, 1), x(w, G, 1));
              else
                a1 ? (F ? (x(d, X, 1), x(h, X, 0), x(L, G, 0), x(d, X, 1), x(L, G, 0), x(T, G, 1)) : (x(d, X, 1), x(h, X, 0), x(L, G, 1), x(h, X, 0), x(T, G, 0), x(L, G, 1)), F ? I.copy(L) : w.copy(L)) : F ? (x(m, G, 0), x(L, G, 0), x(k, G, 0.5), x(k, G, 0.5), x(L, G, 0), x(I, G, 0)) : (x(p, G, 1), x(L, G, 1), x(k, G, 0.5), x(k, G, 0.5), x(L, G, 1), x(w, G, 1)), M = !0;
              break;
          }
        } else
          Y();
      } else
        Y();
      !$ && U === j - 1 && z(t[0], C, f, F, !0, X), X = G, t1 = k, h.copy(I), d.copy(w);
    }
    if (!$)
      z(k, m, p, F, !1, G);
    else if (a1 && o) {
      let U = L, J = T;
      H !== F && (U = T, J = L), F ? (M || H) && (J.toArray(o, 0 * 3), J.toArray(o, 3 * 3), M && U.toArray(o, 1 * 3)) : (M || !H) && (J.toArray(o, 1 * 3), J.toArray(o, 3 * 3), M && U.toArray(o, 0 * 3));
    }
    return W;
    function g(U, J, N) {
      return N.subVectors(J, U), N.set(-N.y, N.x).normalize();
    }
    function x(U, J, N) {
      o && (o[S] = U.x, o[S + 1] = U.y, o[S + 2] = 0, i && (i[S] = 0, i[S + 1] = 0, i[S + 2] = 1), S += 3, q && (q[E] = J, q[E + 1] = N, E += 2)), W += 3;
    }
    function R(U, J, N, D, O) {
      s.copy(J).sub(U).normalize(), c.copy(N).sub(U).normalize();
      let y = Math.PI;
      const n1 = s.dot(c);
      Math.abs(n1) < 1 && (y = Math.abs(Math.acos(n1))), y /= r, u.copy(J);
      for (let i1 = 0, y1 = r - 1; i1 < y1; i1++)
        _.copy(u).rotateAround(U, y), x(u, D, O), x(_, D, O), x(U, D, 0.5), u.copy(_);
      x(_, D, O), x(N, D, O), x(U, D, 0.5);
    }
    function Y() {
      x(d, X, 1), x(h, X, 0), x(m, G, 0), x(d, X, 1), x(m, G, 0), x(p, G, 1);
    }
    function B(U, J, N) {
      J ? U ? (x(d, X, 1), x(h, X, 0), x(m, G, 0), x(d, X, 1), x(m, G, 0), x(T, G, 1), x(m, N, 0), x(I, N, 0), x(T, N, 0.5)) : (x(d, X, 1), x(h, X, 0), x(p, G, 1), x(h, X, 0), x(T, G, 0), x(p, G, 1), x(p, N, 1), x(T, N, 0), x(w, N, 1)) : U ? (x(m, N, 0), x(I, N, 0), x(k, N, 0.5)) : (x(p, N, 1), x(w, N, 0), x(k, N, 0.5));
    }
    function K(U, J) {
      J && (U ? (x(d, X, 1), x(h, X, 0), x(m, G, 0), x(d, X, 1), x(m, G, 0), x(T, G, 1), x(m, X, 0), x(k, G, 0.5), x(T, G, 1), x(k, G, 0.5), x(I, X, 0), x(T, G, 1)) : (x(d, X, 1), x(h, X, 0), x(p, G, 1), x(h, X, 0), x(T, G, 0), x(p, G, 1), x(p, X, 1), x(T, G, 0), x(k, G, 0.5), x(k, G, 0.5), x(T, G, 0), x(w, X, 1)));
    }
    function z(U, J, N, D, O, y) {
      switch (l.strokeLineCap) {
        case "round":
          O ? R(U, N, J, y, 0.5) : R(U, J, N, y, 0.5);
          break;
        case "square":
          if (O)
            s.subVectors(J, U), c.set(s.y, -s.x), u.addVectors(s, c).add(U), _.subVectors(c, s).add(U), D ? (u.toArray(o, 1 * 3), _.toArray(o, 0 * 3), _.toArray(o, 3 * 3)) : (u.toArray(o, 1 * 3), q[3 * 2 + 1] === 1 ? _.toArray(o, 3 * 3) : u.toArray(o, 3 * 3), _.toArray(o, 0 * 3));
          else {
            s.subVectors(N, U), c.set(s.y, -s.x), u.addVectors(s, c).add(U), _.subVectors(c, s).add(U);
            const n1 = o.length;
            D ? (u.toArray(o, n1 - 1 * 3), _.toArray(o, n1 - 2 * 3), _.toArray(o, n1 - 4 * 3)) : (_.toArray(o, n1 - 2 * 3), u.toArray(o, n1 - 1 * 3), _.toArray(o, n1 - 4 * 3));
          }
          break;
      }
    }
    function l1(U) {
      let J = !1;
      for (let D = 1, O = U.length - 1; D < O; D++)
        if (U[D].distanceTo(U[D + 1]) < n) {
          J = !0;
          break;
        }
      if (!J) return U;
      const N = [];
      N.push(U[0]);
      for (let D = 1, O = U.length - 1; D < O; D++)
        U[D].distanceTo(U[D + 1]) >= n && N.push(U[D]);
      return N.push(U[U.length - 1]), N;
    }
  }
}
const ze = {
  fill: "fill",
  "fill-opacity": "fill-opacity",
  "fill-rule": "fill-rule",
  stroke: "stroke",
  "stroke-width": "stroke-width",
  "stroke-opacity": "stroke-opacity",
  opacity: "opacity"
}, Ne = (e) => {
  const t = {};
  return e.split(";").forEach((l) => {
    const r = l.indexOf(":");
    if (r === -1) return;
    const n = l.slice(0, r).trim().toLowerCase(), o = l.slice(r + 1).trim();
    n && o && (t[n] = o);
  }), t;
}, Me = (e) => {
  const t = /* @__PURE__ */ new Map(), l = e.replace(/\/\*[\s\S]*?\*\//g, "");
  for (const r of l.matchAll(/([^{]+)\{([^}]*)\}/g)) {
    const n = r[1].split(",").map((i) => i.trim()), o = Ne(r[2]);
    n.forEach((i) => {
      const q = i.match(/^\.([a-zA-Z0-9_-]+)$/);
      if (!q) return;
      const a = q[1];
      t.set(a, {
        ...t.get(a) || {},
        ...o
      });
    });
  }
  return t;
}, Pe = (e) => {
  if (typeof DOMParser > "u" || typeof XMLSerializer > "u")
    return e;
  const t = new DOMParser().parseFromString(e, "image/svg+xml");
  if (t.querySelector("parsererror"))
    return e;
  const l = /* @__PURE__ */ new Map();
  return t.querySelectorAll("style").forEach((r) => {
    Me(r.textContent || "").forEach((o, i) => {
      l.set(i, {
        ...l.get(i) || {},
        ...o
      });
    });
  }), l.size === 0 ? e : (t.querySelectorAll("[class]").forEach((r) => {
    const o = (r.getAttribute("class") || "").split(/\s+/).map((i) => i.trim()).filter(Boolean).reduce((i, q) => ({ ...i, ...l.get(q) || {} }), {});
    Object.entries(o).forEach(([i, q]) => {
      const a = ze[i];
      a && !r.hasAttribute(a) && r.setAttribute(a, q);
    });
  }), new XMLSerializer().serializeToString(t));
};
class Le extends w6 {
  parse(t) {
    return super.parse(Pe(t));
  }
}
const Fe = {
  0: {
    ha: 919,
    x_min: 72,
    x_max: 849,
    o: "m 460 -8 q 260 51 347 -8 q 122 220 172 110 q 72 486 72 331 q 122 752 72 642 q 260 922 172 863 q 460 981 347 981 q 660 922 572 981 q 798 752 747 863 q 849 486 849 642 q 798 220 849 331 q 660 51 747 110 q 460 -8 572 -8 m 460 83 q 610 130 546 83 q 710 266 674 176 q 746 486 746 356 q 710 706 746 617 q 610 842 674 796 q 460 889 546 889 q 311 842 376 889 q 210 706 246 796 q 174 486 174 617 q 210 266 174 356 q 311 130 246 176 q 460 83 376 83 z "
  },
  1: {
    ha: 501,
    x_min: 13,
    x_max: 342,
    o: "m 242 0 l 242 883 l 13 883 l 13 972 l 342 972 l 342 0 l 242 0 z "
  },
  2: {
    ha: 789,
    x_min: 25,
    x_max: 736,
    o: "m 54 0 l 54 71 l 458 467 q 542 562 514 521 q 579 639 569 603 q 589 707 589 675 q 531 840 589 792 q 361 889 474 889 q 209 863 275 889 q 96 781 143 836 l 25 842 q 171 944 82 908 q 369 981 260 981 q 540 949 468 981 q 652 858 613 918 q 692 718 692 799 q 678 625 692 671 q 631 528 665 579 q 532 414 597 478 l 161 50 l 133 89 l 736 89 l 736 0 l 54 0 z "
  },
  3: {
    ha: 783,
    x_min: 13,
    x_max: 715,
    o: "m 363 -8 q 163 26 257 -8 q 13 117 69 60 l 61 196 q 188 115 108 147 q 363 83 268 83 q 548 136 483 83 q 613 278 613 189 q 549 419 613 367 q 350 472 486 472 l 281 472 l 281 546 l 581 922 l 594 883 l 53 883 l 53 972 l 678 972 l 678 901 l 378 525 l 329 557 l 367 557 q 628 479 542 557 q 715 279 715 401 q 676 132 715 197 q 559 29 638 67 q 363 -8 481 -8 z "
  },
  4: {
    ha: 918,
    x_min: 56,
    x_max: 899,
    o: "m 56 256 l 56 328 l 571 972 l 682 972 l 171 328 l 117 344 l 899 344 l 899 256 l 56 256 m 604 0 l 604 256 l 607 344 l 607 569 l 704 569 l 704 0 l 604 0 z "
  },
  5: {
    ha: 786,
    x_min: 31,
    x_max: 732,
    o: "m 379 -8 q 181 26 275 -8 q 31 117 86 60 l 79 196 q 205 115 125 147 q 378 83 285 83 q 566 138 501 83 q 631 282 631 193 q 601 390 631 344 q 500 460 571 435 q 306 485 429 485 l 99 485 l 149 972 l 681 972 l 681 883 l 189 883 l 240 932 l 197 524 l 146 574 l 328 574 q 564 538 475 574 q 692 437 653 501 q 732 286 732 372 q 693 137 732 204 q 576 31 654 69 q 379 -8 499 -8 z "
  },
  6: {
    ha: 846,
    x_min: 72,
    x_max: 803,
    o: "m 471 -8 q 253 49 342 -8 q 118 216 164 107 q 72 478 72 325 q 128 755 72 643 q 285 924 185 867 q 517 981 385 981 q 642 968 582 981 q 747 928 701 956 l 707 847 q 621 883 669 872 q 518 893 572 893 q 267 793 361 893 q 174 494 174 693 q 177 419 174 464 q 193 329 181 374 l 158 356 q 218 478 174 428 q 329 556 263 529 q 475 582 396 582 q 646 546 572 582 q 761 444 719 510 q 803 290 803 379 q 760 133 803 200 q 641 28 717 65 q 471 -8 565 -8 m 467 76 q 590 102 536 76 q 674 176 643 128 q 704 288 704 224 q 638 440 704 383 q 460 497 572 497 q 329 469 385 497 q 242 394 274 442 q 210 285 210 346 q 239 184 210 232 q 326 106 268 136 q 467 76 383 76 l 471 -8 z"
  },
  7: {
    ha: 818,
    x_min: 44,
    x_max: 758,
    o: "m 243 0 l 643 883 l 143 883 l 143 701 l 44 701 l 44 972 l 758 972 l 758 901 l 351 0 l 243 0 z "
  },
  8: {
    ha: 886,
    x_min: 67,
    x_max: 819,
    o: "m 442 -8 q 241 25 325 -8 q 112 122 157 58 q 67 271 67 185 q 110 413 67 354 q 238 504 154 472 q 442 536 322 536 q 644 504 560 536 q 774 413 729 472 q 819 271 819 354 q 774 122 819 185 q 643 25 728 58 q 442 -8 558 -8 m 442 76 q 644 129 571 76 q 717 272 717 182 q 644 415 717 363 q 442 467 571 467 q 240 415 313 467 q 168 272 168 363 q 240 129 168 182 q 442 76 313 76 m 442 479 q 258 508 333 479 q 142 592 182 538 q 101 724 101 647 q 144 862 101 804 q 263 950 186 919 q 442 981 339 981 q 622 950 544 981 q 742 862 699 919 q 785 724 785 804 q 744 592 785 647 q 627 508 704 538 q 442 479 550 479 m 442 546 q 619 593 556 546 q 683 719 683 640 q 617 849 683 803 q 442 896 551 896 q 267 849 332 896 q 201 721 201 803 q 265 593 201 640 q 442 546 328 546 z "
  },
  9: {
    ha: 846,
    x_min: 43,
    x_max: 774,
    o: "m 375 981 q 593 923 504 981 q 728 757 682 865 q 774 494 774 649 q 717 218 774 331 q 561 49 661 106 q 329 -8 461 -8 q 205 4 264 -8 q 99 44 146 17 l 139 125 q 226 90 176 100 q 328 79 275 79 q 578 179 485 79 q 672 478 672 279 q 669 554 672 510 q 653 643 665 599 l 688 617 q 628 494 674 544 q 517 417 583 443 q 371 390 451 390 q 201 426 275 390 q 85 528 126 463 q 43 682 43 593 q 86 840 43 774 q 205 944 129 907 q 375 981 281 981 m 379 896 q 256 870 310 896 q 172 797 203 844 q 142 685 142 750 q 208 532 142 589 q 386 475 274 475 q 517 503 461 475 q 605 579 574 531 q 636 688 636 628 q 607 789 636 742 q 521 866 578 836 q 379 896 464 896 z "
  },
  A: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Á: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ă: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ắ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ặ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 m 499 -264 q 457 -247 475 -264 q 439 -204 439 -231 q 457 -161 439 -178 q 499 -144 475 -144 q 541 -161 524 -144 q 558 -204 558 -178 q 541 -247 558 -231 q 499 -264 524 -264 z "
  },
  Ằ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ẳ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ẵ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ǎ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Â: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ấ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ậ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 m 499 -264 q 457 -247 475 -264 q 439 -204 439 -231 q 457 -161 439 -178 q 499 -144 475 -144 q 541 -161 524 -144 q 558 -204 558 -178 q 541 -247 558 -231 q 499 -264 524 -264 z "
  },
  Ầ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ẩ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ẫ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ȁ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ä: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ạ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 m 499 -264 q 457 -247 475 -264 q 439 -204 439 -231 q 457 -161 439 -178 q 499 -144 475 -144 q 541 -161 524 -144 q 558 -204 558 -178 q 541 -247 558 -231 q 499 -264 524 -264 z "
  },
  À: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ả: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ȃ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ā: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Ą: {
    ha: 996,
    x_min: 3,
    x_max: 1022,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 m 904 -306 q 793 -269 835 -306 q 751 -174 751 -233 q 769 -103 751 -140 q 829 -31 786 -67 q 947 38 872 6 l 993 0 q 890 -58 926 -29 q 838 -113 853 -86 q 824 -167 824 -140 q 849 -225 824 -206 q 914 -244 875 -244 q 960 -237 938 -244 q 1000 -218 983 -231 l 1022 -272 q 967 -297 997 -287 q 904 -306 938 -306 z "
  },
  Å: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 m 497 1069 q 423 1089 456 1069 q 372 1140 390 1108 q 353 1211 353 1172 q 372 1283 353 1250 q 424 1337 392 1317 q 497 1357 457 1357 q 572 1337 539 1357 q 624 1283 604 1317 q 643 1211 643 1250 q 624 1140 643 1172 q 572 1089 604 1108 q 497 1069 539 1069 m 497 1118 q 565 1145 539 1118 q 592 1211 592 1172 q 565 1280 592 1251 q 497 1308 539 1308 q 431 1281 457 1308 q 404 1211 404 1253 q 430 1144 404 1171 q 497 1118 456 1118 z "
  },
  Ǻ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 m 497 1069 q 423 1089 456 1069 q 372 1140 390 1108 q 353 1211 353 1172 q 372 1283 353 1250 q 424 1337 392 1317 q 497 1357 457 1357 q 572 1337 539 1357 q 624 1283 604 1317 q 643 1211 643 1250 q 624 1140 643 1172 q 572 1089 604 1108 q 497 1069 539 1069 m 497 1118 q 565 1145 539 1118 q 592 1211 592 1172 q 565 1280 592 1251 q 497 1308 539 1308 q 431 1281 457 1308 q 404 1211 404 1253 q 430 1144 404 1171 q 497 1118 456 1118 m 606 1289 l 547 1310 l 688 1449 l 743 1404 l 606 1289 z "
  },
  Ã: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 z "
  },
  Æ: {
    ha: 1435,
    x_min: 3,
    x_max: 1351,
    o: "m 3 0 l 596 972 l 697 972 l 697 883 l 606 883 l 669 925 l 110 0 l 3 0 m 235 260 l 246 343 l 697 343 l 697 260 l 235 260 m 756 538 l 1271 538 l 1271 450 l 756 450 l 756 538 m 767 89 l 1351 89 l 1351 0 l 664 0 l 664 972 l 1331 972 l 1331 883 l 767 883 l 767 89 z "
  },
  Ǽ: {
    ha: 1435,
    x_min: 3,
    x_max: 1351,
    o: "m 3 0 l 596 972 l 697 972 l 697 883 l 606 883 l 669 925 l 110 0 l 3 0 m 235 260 l 246 343 l 697 343 l 697 260 l 235 260 m 756 538 l 1271 538 l 1271 450 l 756 450 l 756 538 m 767 89 l 1351 89 l 1351 0 l 664 0 l 664 972 l 1331 972 l 1331 883 l 767 883 l 767 89 z"
  },
  B: {
    ha: 1047,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 578 972 q 830 907 740 972 q 919 722 919 842 q 883 589 919 643 q 783 507 846 535 q 828 484 761 513 q 933 399 896 456 q 971 260 971 343 q 880 68 971 136 q 606 0 789 0 l 158 0 m 261 85 l 604 85 q 800 128 732 85 q 868 268 868 172 q 800 406 868 363 q 604 450 732 450 l 250 450 l 250 535 l 571 535 q 752 579 688 535 q 817 711 817 624 q 752 844 817 800 q 571 888 688 888 l 261 888 l 261 85 l 158 0 z"
  },
  C: {
    ha: 999,
    x_min: 72,
    x_max: 938,
    o: "m 581 -8 q 378 28 471 -8 q 217 132 285 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 217 840 149 774 q 379 944 286 907 q 582 981 472 981 q 781 945 688 981 q 938 839 874 910 l 872 774 q 740 862 813 835 q 585 889 668 889 q 422 859 497 889 q 292 774 347 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 399 q 292 198 236 253 q 422 113 347 143 q 585 83 497 83 q 740 111 668 83 q 872 200 813 139 l 938 135 q 781 28 874 64 q 581 -8 688 -8 z "
  },
  Ć: {
    ha: 999,
    x_min: 72,
    x_max: 938,
    o: "m 581 -8 q 378 28 471 -8 q 217 132 285 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 217 840 149 774 q 379 944 286 907 q 582 981 472 981 q 781 945 688 981 q 938 839 874 910 l 872 774 q 740 862 813 835 q 585 889 668 889 q 422 859 497 889 q 292 774 347 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 399 q 292 198 236 253 q 422 113 347 143 q 585 83 497 83 q 740 111 668 83 q 872 200 813 139 l 938 135 q 781 28 874 64 q 581 -8 688 -8 z "
  },
  Č: {
    ha: 999,
    x_min: 72,
    x_max: 938,
    o: "m 581 -8 q 378 28 471 -8 q 217 132 285 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 217 840 149 774 q 379 944 286 907 q 582 981 472 981 q 781 945 688 981 q 938 839 874 910 l 872 774 q 740 862 813 835 q 585 889 668 889 q 422 859 497 889 q 292 774 347 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 399 q 292 198 236 253 q 422 113 347 143 q 585 83 497 83 q 740 111 668 83 q 872 200 813 139 l 938 135 q 781 28 874 64 q 581 -8 688 -8 z "
  },
  Ç: {
    ha: 999,
    x_min: 72,
    x_max: 938,
    o: "m 581 -8 q 378 28 471 -8 q 217 132 285 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 217 840 149 774 q 379 944 286 907 q 582 981 472 981 q 781 945 688 981 q 938 839 874 910 l 872 774 q 740 862 813 835 q 585 889 668 889 q 422 859 497 889 q 292 774 347 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 399 q 292 198 236 253 q 422 113 347 143 q 585 83 497 83 q 740 111 668 83 q 872 200 813 139 l 938 135 q 781 28 874 64 q 581 -8 688 -8 m 531 -306 q 467 -297 496 -306 q 414 -274 439 -289 l 438 -221 q 481 -240 458 -233 q 529 -247 504 -247 q 593 -230 571 -247 q 615 -182 615 -212 q 594 -136 615 -154 q 529 -118 572 -118 l 497 -118 l 531 8 l 590 8 l 569 -72 q 657 -108 626 -76 q 688 -185 688 -139 q 644 -273 688 -240 q 531 -306 600 -306 z "
  },
  Ḉ: {
    ha: 999,
    x_min: 72,
    x_max: 938,
    o: "m 581 -8 q 378 28 471 -8 q 217 132 285 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 217 840 149 774 q 379 944 286 907 q 582 981 472 981 q 781 945 688 981 q 938 839 874 910 l 872 774 q 740 862 813 835 q 585 889 668 889 q 422 859 497 889 q 292 774 347 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 399 q 292 198 236 253 q 422 113 347 143 q 585 83 497 83 q 740 111 668 83 q 872 200 813 139 l 938 135 q 781 28 874 64 q 581 -8 688 -8 m 531 -306 q 467 -297 496 -306 q 414 -274 439 -289 l 438 -221 q 481 -240 458 -233 q 529 -247 504 -247 q 593 -230 571 -247 q 615 -182 615 -212 q 594 -136 615 -154 q 529 -118 572 -118 l 497 -118 l 531 8 l 590 8 l 569 -72 q 657 -108 626 -76 q 688 -185 688 -139 q 644 -273 688 -240 q 531 -306 600 -306 z "
  },
  Ĉ: {
    ha: 999,
    x_min: 72,
    x_max: 938,
    o: "m 581 -8 q 378 28 471 -8 q 217 132 285 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 217 840 149 774 q 379 944 286 907 q 582 981 472 981 q 781 945 688 981 q 938 839 874 910 l 872 774 q 740 862 813 835 q 585 889 668 889 q 422 859 497 889 q 292 774 347 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 399 q 292 198 236 253 q 422 113 347 143 q 585 83 497 83 q 740 111 668 83 q 872 200 813 139 l 938 135 q 781 28 874 64 q 581 -8 688 -8 z "
  },
  Ċ: {
    ha: 999,
    x_min: 72,
    x_max: 938,
    o: "m 581 -8 q 378 28 471 -8 q 217 132 285 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 217 840 149 774 q 379 944 286 907 q 582 981 472 981 q 781 945 688 981 q 938 839 874 910 l 872 774 q 740 862 813 835 q 585 889 668 889 q 422 859 497 889 q 292 774 347 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 399 q 292 198 236 253 q 422 113 347 143 q 585 83 497 83 q 740 111 668 83 q 872 200 813 139 l 938 135 q 781 28 874 64 q 581 -8 688 -8 z "
  },
  D: {
    ha: 1147,
    x_min: 158,
    x_max: 1075,
    o: "m 158 0 l 158 972 l 554 972 q 827 910 710 972 q 1010 739 944 849 q 1075 486 1075 629 q 1010 233 1075 343 q 827 62 944 124 q 554 0 710 0 l 158 0 m 261 89 l 549 89 q 773 140 678 89 q 921 280 868 190 q 974 486 974 369 q 921 693 974 604 q 773 833 868 782 q 549 883 678 883 l 261 883 l 261 89 z "
  },
  Ǆ: {
    ha: 2022,
    x_min: 158,
    x_max: 1968,
    o: "m 158 0 l 158 972 l 554 972 q 827 910 710 972 q 1010 739 944 849 q 1075 486 1075 629 q 1010 233 1075 343 q 827 62 944 124 q 554 0 710 0 l 158 0 m 261 89 l 549 89 q 773 140 678 89 q 921 280 868 190 q 974 486 974 369 q 921 693 974 604 q 773 833 868 782 q 549 883 678 883 l 261 883 l 261 89 z "
  },
  Ð: {
    ha: 1154,
    x_min: 18,
    x_max: 1082,
    o: "m 165 0 l 165 972 l 561 972 q 834 910 717 972 q 1017 739 951 849 q 1082 486 1082 629 q 1017 233 1082 343 q 834 62 951 124 q 561 0 717 0 l 165 0 m 268 89 l 556 89 q 780 140 685 89 q 928 280 875 190 q 981 486 981 369 q 928 693 981 604 q 780 833 875 782 q 556 883 685 883 l 268 883 l 268 89 m 18 454 l 18 536 l 557 536 l 557 454 l 18 454 z "
  },
  Ď: {
    ha: 1147,
    x_min: 158,
    x_max: 1075,
    o: "m 158 0 l 158 972 l 554 972 q 827 910 710 972 q 1010 739 944 849 q 1075 486 1075 629 q 1010 233 1075 343 q 827 62 944 124 q 554 0 710 0 l 158 0 m 261 89 l 549 89 q 773 140 678 89 q 921 280 868 190 q 974 486 974 369 q 921 693 974 604 q 773 833 868 782 q 549 883 678 883 l 261 883 l 261 89 z "
  },
  Đ: {
    ha: 1154,
    x_min: 18,
    x_max: 1082,
    o: "m 165 0 l 165 972 l 561 972 q 834 910 717 972 q 1017 739 951 849 q 1082 486 1082 629 q 1017 233 1082 343 q 834 62 951 124 q 561 0 717 0 l 165 0 m 268 89 l 556 89 q 780 140 685 89 q 928 280 875 190 q 981 486 981 369 q 928 693 981 604 q 780 833 875 782 q 556 883 685 883 l 268 883 l 268 89 m 18 454 l 18 536 l 557 536 l 557 454 l 18 454 z "
  },
  Ḍ: {
    ha: 1147,
    x_min: 158,
    x_max: 1075,
    o: "m 158 0 l 158 972 l 554 972 q 827 910 710 972 q 1010 739 944 849 q 1075 486 1075 629 q 1010 233 1075 343 q 827 62 944 124 q 554 0 710 0 l 158 0 m 261 89 l 549 89 q 773 140 678 89 q 921 280 868 190 q 974 486 974 369 q 921 693 974 604 q 773 833 868 782 q 549 883 678 883 l 261 883 l 261 89 m 539 -264 q 497 -247 515 -264 q 479 -204 479 -231 q 497 -161 479 -178 q 539 -144 515 -144 q 581 -161 564 -144 q 599 -204 599 -178 q 581 -247 599 -231 q 539 -264 564 -264 z "
  },
  Ḏ: {
    ha: 1147,
    x_min: 158,
    x_max: 1075,
    o: "m 158 0 l 158 972 l 554 972 q 827 910 710 972 q 1010 739 944 849 q 1075 486 1075 629 q 1010 233 1075 343 q 827 62 944 124 q 554 0 710 0 l 158 0 m 261 89 l 549 89 q 773 140 678 89 q 921 280 868 190 q 974 486 974 369 q 921 693 974 604 q 773 833 868 782 q 549 883 678 883 l 261 883 l 261 89 m 325 -235 l 325 -169 l 753 -169 l 753 -235 l 325 -235 z "
  },
  ǅ: {
    ha: 1857,
    x_min: 158,
    x_max: 1800,
    o: "m 158 0 l 158 972 l 554 972 q 827 910 710 972 q 1010 739 944 849 q 1075 486 1075 629 q 1010 233 1075 343 q 827 62 944 124 q 554 0 710 0 l 158 0 m 261 89 l 549 89 q 773 140 678 89 q 921 280 868 190 q 974 486 974 369 q 921 693 974 604 q 773 833 868 782 q 549 883 678 883 l 261 883 l 261 89 z "
  },
  E: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  É: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ĕ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ě: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ḝ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 m 481 -306 q 417 -297 446 -306 q 364 -274 389 -289 l 388 -221 q 431 -240 408 -233 q 479 -247 454 -247 q 543 -230 521 -247 q 565 -182 565 -212 q 544 -136 565 -154 q 479 -118 522 -118 l 447 -118 l 481 8 l 540 8 l 519 -72 q 607 -108 576 -76 q 638 -185 638 -139 q 594 -273 638 -240 q 481 -306 550 -306 z "
  },
  Ê: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ế: {
    ha: 929,
    x_min: 158,
    x_max: 908,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ệ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 m 511 -264 q 469 -247 488 -264 q 451 -204 451 -231 q 469 -161 451 -178 q 511 -144 488 -144 q 553 -161 536 -144 q 571 -204 571 -178 q 553 -247 571 -231 q 511 -264 536 -264 z "
  },
  Ề: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ể: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ễ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ȅ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ë: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ė: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ẹ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 m 511 -264 q 469 -247 488 -264 q 451 -204 451 -231 q 469 -161 451 -178 q 511 -144 488 -144 q 553 -161 536 -144 q 571 -204 571 -178 q 553 -247 571 -231 q 511 -264 536 -264 z "
  },
  È: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ẻ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ȇ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ē: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ḗ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ḕ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ę: {
    ha: 929,
    x_min: 158,
    x_max: 874,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 m 757 -306 q 646 -269 688 -306 q 604 -174 604 -233 q 622 -103 604 -140 q 682 -31 639 -67 q 800 38 725 6 l 846 0 q 742 -58 779 -29 q 691 -113 706 -86 q 676 -167 676 -140 q 702 -225 676 -206 q 767 -244 728 -244 q 813 -237 790 -244 q 853 -218 836 -231 l 875 -272 q 820 -297 850 -287 q 757 -306 790 -306 z "
  },
  Ẽ: {
    ha: 929,
    x_min: 158,
    x_max: 846,
    o: "m 250 538 l 764 538 l 764 450 l 250 450 l 250 538 m 261 89 l 846 89 l 846 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 89 z "
  },
  Ʒ: {
    ha: 854,
    x_min: 44,
    x_max: 778,
    o: "m 410 -8 q 197 26 294 -8 q 44 114 100 60 l 85 194 q 219 113 135 146 q 407 81 304 81 q 606 134 538 81 q 675 279 675 188 q 607 421 675 368 q 394 474 539 474 l 322 474 l 322 546 l 646 922 l 654 885 l 81 885 l 81 972 l 735 972 l 735 901 l 413 525 l 372 556 l 410 556 q 615 521 533 556 q 737 424 696 486 q 778 279 778 361 q 737 132 778 197 q 614 29 696 67 q 410 -8 532 -8 z "
  },
  Ǯ: {
    ha: 854,
    x_min: 44,
    x_max: 778,
    o: "m 410 -8 q 197 26 294 -8 q 44 114 100 60 l 85 194 q 219 113 135 146 q 407 81 304 81 q 606 134 538 81 q 675 279 675 188 q 607 421 675 368 q 394 474 539 474 l 322 474 l 322 546 l 646 922 l 654 885 l 81 885 l 81 972 l 735 972 l 735 901 l 413 525 l 372 556 l 410 556 q 615 521 533 556 q 737 424 696 486 q 778 279 778 361 q 737 132 778 197 q 614 29 696 67 q 410 -8 532 -8 z "
  },
  F: {
    ha: 879,
    x_min: 158,
    x_max: 825,
    o: "m 250 501 l 764 501 l 764 413 l 250 413 l 250 501 m 261 0 l 158 0 l 158 972 l 825 972 l 825 883 l 261 883 l 261 0 z "
  },
  G: {
    ha: 1074,
    x_min: 72,
    x_max: 947,
    o: "m 585 -8 q 380 28 474 -8 q 217 132 286 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 790 946 697 981 q 947 840 882 911 l 883 775 q 749 863 822 836 q 590 889 675 889 q 424 859 500 889 q 292 774 349 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 292 198 236 253 q 424 113 349 143 q 589 83 500 83 q 747 108 672 83 q 883 193 821 133 l 942 115 q 779 23 872 54 q 585 -8 686 -8 m 843 128 l 843 486 l 942 486 l 942 115 l 843 128 z "
  },
  Ğ: {
    ha: 1074,
    x_min: 72,
    x_max: 947,
    o: "m 585 -8 q 380 28 474 -8 q 217 132 286 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 790 946 697 981 q 947 840 882 911 l 883 775 q 749 863 822 836 q 590 889 675 889 q 424 859 500 889 q 292 774 349 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 292 198 236 253 q 424 113 349 143 q 589 83 500 83 q 747 108 672 83 q 883 193 821 133 l 942 115 q 779 23 872 54 q 585 -8 686 -8 m 843 128 l 843 486 l 942 486 l 942 115 l 843 128 z "
  },
  Ǧ: {
    ha: 1074,
    x_min: 72,
    x_max: 947,
    o: "m 585 -8 q 380 28 474 -8 q 217 132 286 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 790 946 697 981 q 947 840 882 911 l 883 775 q 749 863 822 836 q 590 889 675 889 q 424 859 500 889 q 292 774 349 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 292 198 236 253 q 424 113 349 143 q 589 83 500 83 q 747 108 672 83 q 883 193 821 133 l 942 115 q 779 23 872 54 q 585 -8 686 -8 m 843 128 l 843 486 l 942 486 l 942 115 l 843 128 z "
  },
  Ĝ: {
    ha: 1074,
    x_min: 72,
    x_max: 947,
    o: "m 585 -8 q 380 28 474 -8 q 217 132 286 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 790 946 697 981 q 947 840 882 911 l 883 775 q 749 863 822 836 q 590 889 675 889 q 424 859 500 889 q 292 774 349 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 292 198 236 253 q 424 113 349 143 q 589 83 500 83 q 747 108 672 83 q 883 193 821 133 l 942 115 q 779 23 872 54 q 585 -8 686 -8 m 843 128 l 843 486 l 942 486 l 942 115 l 843 128 z "
  },
  Ģ: {
    ha: 1074,
    x_min: 72,
    x_max: 947,
    o: "m 585 -8 q 380 28 474 -8 q 217 132 286 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 790 946 697 981 q 947 840 882 911 l 883 775 q 749 863 822 836 q 590 889 675 889 q 424 859 500 889 q 292 774 349 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 292 198 236 253 q 424 113 349 143 q 589 83 500 83 q 747 108 672 83 q 883 193 821 133 l 942 115 q 779 23 872 54 q 585 -8 686 -8 m 843 128 l 843 486 l 942 486 l 942 115 l 843 128 m 513 -364 l 551 -214 l 561 -253 q 518 -237 535 -253 q 501 -199 501 -222 q 518 -160 501 -175 q 561 -144 535 -144 q 605 -160 589 -144 q 621 -199 621 -176 q 617 -228 621 -212 q 606 -261 614 -243 l 567 -364 l 513 -364 z "
  },
  Ġ: {
    ha: 1074,
    x_min: 72,
    x_max: 947,
    o: "m 585 -8 q 380 28 474 -8 q 217 132 286 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 790 946 697 981 q 947 840 882 911 l 883 775 q 749 863 822 836 q 590 889 675 889 q 424 859 500 889 q 292 774 349 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 292 198 236 253 q 424 113 349 143 q 589 83 500 83 q 747 108 672 83 q 883 193 821 133 l 942 115 q 779 23 872 54 q 585 -8 686 -8 m 843 128 l 843 486 l 942 486 l 942 115 l 843 128 z "
  },
  Ḡ: {
    ha: 1074,
    x_min: 72,
    x_max: 947,
    o: "m 585 -8 q 380 28 474 -8 q 217 132 286 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 790 946 697 981 q 947 840 882 911 l 883 775 q 749 863 822 836 q 590 889 675 889 q 424 859 500 889 q 292 774 349 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 292 198 236 253 q 424 113 349 143 q 589 83 500 83 q 747 108 672 83 q 883 193 821 133 l 942 115 q 779 23 872 54 q 585 -8 686 -8 m 843 128 l 843 486 l 942 486 l 942 115 l 843 128 z "
  },
  Ǥ: {
    ha: 1119,
    x_min: 72,
    x_max: 1088,
    o: "m 565 286 l 565 369 l 1088 369 l 1088 286 l 565 286 m 585 -8 q 380 28 474 -8 q 217 132 286 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 790 946 697 981 q 947 840 882 911 l 883 775 q 749 863 822 836 q 590 889 675 889 q 424 859 500 889 q 292 774 349 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 292 198 236 253 q 424 113 349 143 q 589 83 500 83 q 747 108 672 83 q 883 193 821 133 l 942 115 q 779 23 872 54 q 585 -8 686 -8 m 843 128 l 843 486 l 942 486 l 942 115 l 843 128 z "
  },
  H: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 869 972 l 971 972 l 971 0 l 869 0 l 869 972 m 261 0 l 158 0 l 158 972 l 261 972 l 261 0 m 879 449 l 250 449 l 250 539 l 879 539 l 879 449 z "
  },
  Ħ: {
    ha: 1143,
    x_min: 18,
    x_max: 1125,
    o: "m 876 972 l 978 972 l 978 0 l 876 0 l 876 972 m 268 0 l 165 0 l 165 972 l 268 972 l 268 0 m 886 449 l 257 449 l 257 539 l 886 539 l 886 449 m 17 719 l 17 803 l 1124 803 l 1124 719 l 17 719 z "
  },
  Ḫ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 869 972 l 971 972 l 971 0 l 869 0 l 869 972 m 261 0 l 158 0 l 158 972 l 261 972 l 261 0 m 879 449 l 250 449 l 250 539 l 879 539 l 879 449 m 564 -285 q 416 -239 476 -285 q 353 -117 356 -193 l 419 -117 q 463 -198 421 -168 q 564 -228 504 -228 q 667 -198 625 -228 q 708 -117 708 -168 l 775 -117 q 712 -239 772 -193 q 564 -285 651 -285 z "
  },
  Ȟ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 869 972 l 971 972 l 971 0 l 869 0 l 869 972 m 261 0 l 158 0 l 158 972 l 261 972 l 261 0 m 879 449 l 250 449 l 250 539 l 879 539 l 879 449 z "
  },
  Ĥ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 869 972 l 971 972 l 971 0 l 869 0 l 869 972 m 261 0 l 158 0 l 158 972 l 261 972 l 261 0 m 879 449 l 250 449 l 250 539 l 879 539 l 879 449 z "
  },
  Ḥ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 869 972 l 971 972 l 971 0 l 869 0 l 869 972 m 261 0 l 158 0 l 158 972 l 261 972 l 261 0 m 879 449 l 250 449 l 250 539 l 879 539 l 879 449 m 564 -264 q 522 -247 540 -264 q 504 -204 504 -231 q 522 -161 504 -178 q 564 -144 540 -144 q 606 -161 589 -144 q 624 -204 624 -178 q 606 -247 624 -231 q 564 -264 589 -264 z "
  },
  I: {
    ha: 419,
    x_min: 158,
    x_max: 261,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Ĳ: {
    ha: 997,
    x_min: 136,
    x_max: 847,
    o: "m 454 -8 q 279 18 361 -8 q 136 88 197 44 l 178 169 q 308 106 236 128 q 457 83 379 83 q 669 165 593 83 q 744 415 744 247 l 744 972 l 847 972 l 847 419 q 798 183 847 278 q 661 40 749 88 q 454 -8 574 -8 m 150 419 l 150 972 l 253 972 l 253 419 l 150 419 z "
  },
  Í: {
    ha: 419,
    x_min: 119,
    x_max: 442,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Ĭ: {
    ha: 419,
    x_min: -1,
    x_max: 421,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Î: {
    ha: 419,
    x_min: -19,
    x_max: 439,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Ȉ: {
    ha: 419,
    x_min: -103,
    x_max: 367,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Ï: {
    ha: 419,
    x_min: 26,
    x_max: 393,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Ḯ: {
    ha: 419,
    x_min: 29,
    x_max: 413,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  İ: {
    ha: 419,
    x_min: 143,
    x_max: 276,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Ị: {
    ha: 419,
    x_min: 150,
    x_max: 269,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 m 210 -264 q 168 -247 186 -264 q 150 -204 150 -231 q 168 -161 150 -178 q 210 -144 186 -144 q 252 -161 235 -144 q 269 -204 269 -178 q 252 -247 269 -231 q 210 -264 235 -264 z "
  },
  Ì: {
    ha: 419,
    x_min: -22,
    x_max: 300,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Ỉ: {
    ha: 419,
    x_min: 90,
    x_max: 338,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Ȋ: {
    ha: 419,
    x_min: -1,
    x_max: 421,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Ī: {
    ha: 419,
    x_min: 35,
    x_max: 385,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Į: {
    ha: 419,
    x_min: 108,
    x_max: 314,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 m 232 -306 q 142 -271 176 -306 q 108 -179 108 -236 q 133 -74 108 -131 q 225 38 158 -18 l 261 0 q 194 -94 208 -53 q 181 -169 181 -136 q 199 -226 181 -206 q 243 -246 218 -246 q 271 -240 258 -246 q 294 -226 283 -235 l 314 -276 q 232 -306 283 -306 z "
  },
  Ĩ: {
    ha: 419,
    x_min: -10,
    x_max: 428,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  J: {
    ha: 696,
    x_min: -6,
    x_max: 546,
    o: "m 263 -8 q 109 28 181 -8 q -6 131 38 64 l 54 200 q 147 111 94 142 q 264 81 200 81 q 444 294 444 81 l 444 883 l 89 883 l 89 972 l 546 972 l 546 299 q 474 68 546 144 q 263 -8 403 -8 z "
  },
  Ĵ: {
    ha: 696,
    x_min: -6,
    x_max: 547,
    o: "m 263 -8 q 109 28 181 -8 q -6 131 38 64 l 54 200 q 147 111 94 142 q 264 81 200 81 q 444 294 444 81 l 444 883 l 89 883 l 89 972 l 546 972 l 546 299 q 474 68 546 144 q 263 -8 403 -8 z "
  },
  K: {
    ha: 988,
    x_min: 158,
    x_max: 979,
    o: "m 247 242 l 243 367 l 832 972 l 950 972 l 521 522 l 463 460 l 247 242 m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 m 857 0 l 438 483 l 507 558 l 979 0 l 857 0 z "
  },
  Ǩ: {
    ha: 988,
    x_min: 158,
    x_max: 979,
    o: "m 247 242 l 243 367 l 832 972 l 950 972 l 521 522 l 463 460 l 247 242 m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 m 857 0 l 438 483 l 507 558 l 979 0 l 857 0 z "
  },
  Ķ: {
    ha: 988,
    x_min: 158,
    x_max: 979,
    o: "m 247 242 l 243 367 l 832 972 l 950 972 l 521 522 l 463 460 l 247 242 m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 m 857 0 l 438 483 l 507 558 l 979 0 l 857 0 m 469 -364 l 508 -214 l 518 -253 q 475 -237 492 -253 q 458 -199 458 -222 q 475 -160 458 -175 q 518 -144 492 -144 q 562 -160 546 -144 q 578 -199 578 -176 q 574 -228 578 -212 q 563 -261 571 -243 l 524 -364 l 469 -364 z "
  },
  L: {
    ha: 818,
    x_min: 158,
    x_max: 806,
    o: "m 158 0 l 158 972 l 261 972 l 261 89 l 806 89 l 806 0 l 158 0 z "
  },
  Ǉ: {
    ha: 1514,
    x_min: 158,
    x_max: 1364,
    o: "m 158 0 l 158 972 l 261 972 l 261 89 l 806 89 l 806 0 l 158 0 m 1081 -8 q 927 28 999 -8 q 813 131 856 64 l 872 200 q 965 111 913 142 q 1082 81 1018 81 q 1263 294 1263 81 l 1263 883 l 907 883 l 907 972 l 1364 972 l 1364 299 q 1292 68 1364 144 q 1081 -8 1221 -8 z "
  },
  Ĺ: {
    ha: 818,
    x_min: 119,
    x_max: 806,
    o: "m 158 0 l 158 972 l 261 972 l 261 89 l 806 89 l 806 0 l 158 0 z "
  },
  Ľ: {
    ha: 818,
    x_min: 158,
    x_max: 806,
    o: "m 158 0 l 158 972 l 261 972 l 261 89 l 806 89 l 806 0 l 158 0 m 611 750 l 611 1011 l 694 1011 l 682 750 l 611 750 z "
  },
  Ļ: {
    ha: 818,
    x_min: 158,
    x_max: 806,
    o: "m 158 0 l 158 972 l 261 972 l 261 89 l 806 89 l 806 0 l 158 0 m 449 -364 l 488 -214 l 497 -253 q 454 -237 471 -253 q 438 -199 438 -222 q 454 -160 438 -175 q 497 -144 471 -144 q 541 -160 525 -144 q 557 -199 557 -176 q 553 -228 557 -212 q 542 -261 550 -243 l 503 -364 l 449 -364 z "
  },
  Ŀ: {
    ha: 818,
    x_min: 158,
    x_max: 806,
    o: "m 158 0 l 158 972 l 261 972 l 261 89 l 806 89 l 806 0 l 158 0 m 618 461 q 570 481 590 461 q 550 531 550 501 q 570 581 550 561 q 618 600 590 600 q 667 581 647 600 q 686 531 686 561 q 667 481 686 501 q 618 461 647 461 z "
  },
  Ḷ: {
    ha: 818,
    x_min: 158,
    x_max: 806,
    o: "m 158 0 l 158 972 l 261 972 l 261 89 l 806 89 l 806 0 l 158 0 m 497 -264 q 456 -247 474 -264 q 438 -204 438 -231 q 456 -161 438 -178 q 497 -144 474 -144 q 540 -161 522 -144 q 557 -204 557 -178 q 540 -247 557 -231 q 497 -264 522 -264 z "
  },
  ǈ: {
    ha: 1199,
    x_min: 158,
    x_max: 1085,
    o: "m 158 0 l 158 972 l 261 972 l 261 89 l 806 89 l 806 0 l 158 0 z "
  },
  Ḻ: {
    ha: 818,
    x_min: 158,
    x_max: 806,
    o: "m 158 0 l 158 972 l 261 972 l 261 89 l 806 89 l 806 0 l 158 0 m 283 -235 l 283 -169 l 711 -169 l 711 -235 l 283 -235 z "
  },
  Ł: {
    ha: 825,
    x_min: 26,
    x_max: 813,
    o: "m 165 0 l 165 972 l 268 972 l 268 89 l 813 89 l 813 0 l 165 0 m 72 360 l 26 418 l 432 724 l 479 664 l 72 360 z "
  },
  M: {
    ha: 1326,
    x_min: 158,
    x_max: 1168,
    o: "m 158 0 l 158 972 l 243 972 l 688 214 l 643 214 l 1083 972 l 1168 972 l 1168 0 l 1069 0 l 1069 818 l 1093 818 l 688 124 l 639 124 l 231 818 l 257 818 l 257 0 l 158 0 z "
  },
  Ṃ: {
    ha: 1326,
    x_min: 158,
    x_max: 1168,
    o: "m 158 0 l 158 972 l 243 972 l 688 214 l 643 214 l 1083 972 l 1168 972 l 1168 0 l 1069 0 l 1069 818 l 1093 818 l 688 124 l 639 124 l 231 818 l 257 818 l 257 0 l 158 0 m 663 -264 q 621 -247 639 -264 q 603 -204 603 -231 q 621 -161 603 -178 q 663 -144 639 -144 q 705 -161 688 -144 q 722 -204 722 -178 q 705 -247 722 -231 q 663 -264 688 -264 z "
  },
  N: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 z "
  },
  Ǌ: {
    ha: 1826,
    x_min: 158,
    x_max: 1675,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 m 1392 -8 q 1238 28 1310 -8 q 1124 131 1167 64 l 1183 200 q 1276 111 1224 142 q 1393 81 1329 81 q 1574 294 1574 81 l 1574 883 l 1218 883 l 1218 972 l 1675 972 l 1675 299 q 1603 68 1675 144 q 1392 -8 1532 -8 z "
  },
  Ń: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 z "
  },
  Ň: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 z "
  },
  Ņ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 m 515 -364 l 554 -214 l 564 -253 q 521 -237 538 -253 q 504 -199 504 -222 q 521 -160 504 -175 q 564 -144 538 -144 q 608 -160 592 -144 q 624 -199 624 -176 q 620 -228 624 -212 q 608 -261 617 -243 l 569 -364 l 515 -364 z "
  },
  Ṅ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 z "
  },
  Ṇ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 m 564 -264 q 522 -247 540 -264 q 504 -204 504 -231 q 522 -161 504 -178 q 564 -144 540 -144 q 606 -161 589 -144 q 624 -204 624 -178 q 606 -247 624 -231 q 564 -264 589 -264 z "
  },
  Ŋ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 m 690 -276 q 551 -245 617 -276 q 443 -157 486 -214 l 494 -85 q 581 -160 531 -133 q 690 -187 631 -187 q 869 28 869 -187 l 869 972 l 971 972 l 971 39 q 900 -199 971 -121 q 690 -276 829 -276 z "
  },
  ǋ: {
    ha: 1510,
    x_min: 158,
    x_max: 1396,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 z "
  },
  Ṉ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 m 350 -235 l 350 -169 l 778 -169 l 778 -235 l 350 -235 z "
  },
  Ñ: {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 z "
  },
  O: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ó: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ŏ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ô: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ố: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ộ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 m 583 -264 q 542 -247 560 -264 q 524 -204 524 -231 q 542 -161 524 -178 q 583 -144 560 -144 q 626 -161 608 -144 q 643 -204 643 -178 q 626 -247 643 -231 q 583 -264 608 -264 z "
  },
  Ồ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ổ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ỗ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ȍ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ö: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ȫ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ȱ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ọ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 m 583 -264 q 542 -247 560 -264 q 524 -204 524 -231 q 542 -161 524 -178 q 583 -144 560 -144 q 626 -161 608 -144 q 643 -204 643 -178 q 626 -247 643 -231 q 583 -264 608 -264 z "
  },
  Ò: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ỏ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ơ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 735 971 672 981 q 861 961 799 961 q 964 988 929 961 q 999 1067 999 1014 q 990 1115 999 1093 q 971 1156 982 1136 l 1036 1181 q 1063 1126 1053 1157 q 1072 1064 1072 1096 q 1017 938 1072 982 q 857 894 961 894 q 780 899 822 894 q 700 908 738 903 l 822 924 q 965 821 904 886 q 1060 670 1026 756 q 1093 486 1093 585 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 114 671 83 q 874 199 819 144 q 960 326 929 253 q 990 486 990 400 q 960 646 990 572 q 874 774 929 719 q 745 858 819 828 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 327 174 400 q 291 199 236 254 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ớ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 735 971 672 981 q 861 961 799 961 q 964 988 929 961 q 999 1067 999 1014 q 990 1115 999 1093 q 971 1156 982 1136 l 1036 1181 q 1063 1126 1053 1157 q 1072 1064 1072 1096 q 1017 938 1072 982 q 857 894 961 894 q 780 899 822 894 q 700 908 738 903 l 822 924 q 965 821 904 886 q 1060 670 1026 756 q 1093 486 1093 585 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 114 671 83 q 874 199 819 144 q 960 326 929 253 q 990 486 990 400 q 960 646 990 572 q 874 774 929 719 q 745 858 819 828 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 327 174 400 q 291 199 236 254 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ợ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 735 971 672 981 q 861 961 799 961 q 964 988 929 961 q 999 1067 999 1014 q 990 1115 999 1093 q 971 1156 982 1136 l 1036 1181 q 1063 1126 1053 1157 q 1072 1064 1072 1096 q 1017 938 1072 982 q 857 894 961 894 q 780 899 822 894 q 700 908 738 903 l 822 924 q 965 821 904 886 q 1060 670 1026 756 q 1093 486 1093 585 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 114 671 83 q 874 199 819 144 q 960 326 929 253 q 990 486 990 400 q 960 646 990 572 q 874 774 929 719 q 745 858 819 828 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 327 174 400 q 291 199 236 254 q 421 113 346 143 q 583 83 496 83 m 583 -264 q 542 -247 560 -264 q 524 -204 524 -231 q 542 -161 524 -178 q 583 -144 560 -144 q 626 -161 608 -144 q 643 -204 643 -178 q 626 -247 643 -231 q 583 -264 608 -264 z "
  },
  Ờ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 735 971 672 981 q 861 961 799 961 q 964 988 929 961 q 999 1067 999 1014 q 990 1115 999 1093 q 971 1156 982 1136 l 1036 1181 q 1063 1126 1053 1157 q 1072 1064 1072 1096 q 1017 938 1072 982 q 857 894 961 894 q 780 899 822 894 q 700 908 738 903 l 822 924 q 965 821 904 886 q 1060 670 1026 756 q 1093 486 1093 585 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 114 671 83 q 874 199 819 144 q 960 326 929 253 q 990 486 990 400 q 960 646 990 572 q 874 774 929 719 q 745 858 819 828 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 327 174 400 q 291 199 236 254 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ở: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 735 971 672 981 q 861 961 799 961 q 964 988 929 961 q 999 1067 999 1014 q 990 1115 999 1093 q 971 1156 982 1136 l 1036 1181 q 1063 1126 1053 1157 q 1072 1064 1072 1096 q 1017 938 1072 982 q 857 894 961 894 q 780 899 822 894 q 700 908 738 903 l 822 924 q 965 821 904 886 q 1060 670 1026 756 q 1093 486 1093 585 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 114 671 83 q 874 199 819 144 q 960 326 929 253 q 990 486 990 400 q 960 646 990 572 q 874 774 929 719 q 745 858 819 828 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 327 174 400 q 291 199 236 254 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ỡ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 735 971 672 981 q 861 961 799 961 q 964 988 929 961 q 999 1067 999 1014 q 990 1115 999 1093 q 971 1156 982 1136 l 1036 1181 q 1063 1126 1053 1157 q 1072 1064 1072 1096 q 1017 938 1072 982 q 857 894 961 894 q 780 899 822 894 q 700 908 738 903 l 822 924 q 965 821 904 886 q 1060 670 1026 756 q 1093 486 1093 585 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 114 671 83 q 874 199 819 144 q 960 326 929 253 q 990 486 990 400 q 960 646 990 572 q 874 774 929 719 q 745 858 819 828 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 327 174 400 q 291 199 236 254 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ő: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ȏ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ō: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ṓ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ṑ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ǫ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 589 -306 q 477 -269 518 -306 q 436 -174 436 -233 q 453 -103 436 -140 q 513 -29 469 -65 q 631 38 557 7 l 626 -6 q 603 -8 614 -7 q 583 -8 593 -8 q 380 28 472 -8 q 218 132 288 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 380 944 288 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1042 262 1093 361 q 906 98 992 163 q 717 8 821 33 q 610 -33 657 -6 q 535 -94 563 -60 q 508 -167 508 -128 q 534 -225 508 -206 q 599 -244 560 -244 q 644 -237 621 -244 q 683 -218 667 -231 l 707 -272 q 652 -297 682 -287 q 589 -306 622 -306 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 400 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ø: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 m 121 -97 l 964 1069 l 1046 1069 l 204 -97 l 121 -97 z "
  },
  Ǿ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 m 121 -97 l 964 1069 l 1046 1069 l 204 -97 l 121 -97 z "
  },
  Õ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ṍ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ṏ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Ȭ: {
    ha: 1165,
    x_min: 72,
    x_max: 1093,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 583 83 q 745 113 671 83 q 874 198 819 143 q 960 326 929 253 q 990 486 990 399 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 291 198 236 253 q 421 113 346 143 q 583 83 496 83 z "
  },
  Œ: {
    ha: 1557,
    x_min: 72,
    x_max: 1474,
    o: "m 593 0 q 320 62 438 0 q 138 233 203 124 q 72 485 72 342 q 138 738 72 628 q 320 910 203 849 q 593 972 438 972 l 813 972 l 813 883 l 597 883 q 374 833 469 883 q 226 692 279 782 q 174 485 174 603 q 226 279 174 368 q 374 140 279 190 q 597 89 469 89 l 813 89 l 813 0 l 593 0 m 878 538 l 1392 538 l 1392 450 l 878 450 l 878 538 m 888 89 l 1474 89 l 1474 0 l 786 0 l 786 972 l 1453 972 l 1453 883 l 888 883 l 888 89 z "
  },
  P: {
    ha: 997,
    x_min: 158,
    x_max: 919,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 347 824 388 q 522 307 646 307 l 215 307 l 261 356 l 261 0 l 158 1 m 261 347 l 215 397 l 519 397 q 741 460 665 397 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 z "
  },
  Þ: {
    ha: 997,
    x_min: 158,
    x_max: 919,
    o: "m 235 179 l 235 269 l 519 269 q 741 333 665 269 q 817 514 817 397 q 741 693 817 629 q 519 757 665 757 l 235 757 l 235 846 l 522 846 q 735 806 646 846 q 872 692 824 765 q 919 514 919 618 q 872 335 919 410 q 735 219 824 260 q 522 179 646 179 l 235 179 m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 z "
  },
  Q: {
    ha: 1165,
    x_min: 72,
    x_max: 1138,
    o: "m 583 -8 q 380 28 474 -8 q 217 133 286 65 q 110 290 149 200 q 72 486 72 379 q 110 683 72 593 q 217 840 149 772 q 379 944 286 907 q 583 981 472 981 q 786 944 693 981 q 948 840 879 907 q 1055 683 1017 774 q 1093 486 1093 593 q 1055 289 1093 379 q 948 132 1017 199 q 786 28 879 65 q 583 -8 693 -8 m 901 -193 q 815 -182 857 -193 q 731 -147 774 -171 q 644 -83 689 -122 q 547 11 600 -44 l 660 39 q 744 -46 703 -12 q 824 -95 785 -79 q 903 -111 864 -111 q 1088 -22 1011 -111 l 1138 -82 q 901 -193 1046 -193 m 583 83 q 745 113 671 83 q 874 199 819 143 q 960 327 929 254 q 990 486 990 400 q 960 647 990 574 q 874 774 929 719 q 745 859 819 829 q 583 889 671 889 q 421 859 496 889 q 291 774 346 829 q 205 647 236 719 q 174 486 174 574 q 205 327 174 400 q 291 199 236 254 q 421 113 346 143 q 583 83 496 83 z "
  },
  R: {
    ha: 1004,
    x_min: 158,
    x_max: 935,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 348 824 388 q 522 308 646 308 l 215 308 l 261 356 l 261 0 l 158 1 m 822 0 l 572 353 l 683 353 l 935 0 l 822 0 m 261 347 l 215 396 l 519 396 q 741 460 665 396 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 z "
  },
  Ŕ: {
    ha: 1004,
    x_min: 158,
    x_max: 935,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 348 824 388 q 522 308 646 308 l 215 308 l 261 356 l 261 0 l 158 0 m 822 0 l 572 353 l 683 353 l 935 0 l 822 0 m 261 347 l 215 396 l 519 396 q 741 460 665 396 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 z "
  },
  Ř: {
    ha: 1004,
    x_min: 158,
    x_max: 935,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 348 824 388 q 522 308 646 308 l 215 308 l 261 356 l 261 0 l 158 0 m 822 0 l 572 353 l 683 353 l 935 0 l 822 0 m 261 347 l 215 396 l 519 396 q 741 460 665 396 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 z "
  },
  Ŗ: {
    ha: 1004,
    x_min: 158,
    x_max: 935,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 348 824 388 q 522 308 646 308 l 215 308 l 261 356 l 261 0 l 158 0 m 822 0 l 572 353 l 683 353 l 935 0 l 822 0 m 261 347 l 215 396 l 519 396 q 741 460 665 396 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 m 464 -364 l 503 -214 l 513 -253 q 469 -237 486 -253 q 453 -199 453 -222 q 469 -160 453 -175 q 513 -144 486 -144 q 556 -160 540 -144 q 572 -199 572 -176 q 569 -228 572 -212 q 557 -261 565 -243 l 518 -364 l 464 -364 z "
  },
  Ȑ: {
    ha: 1004,
    x_min: 158,
    x_max: 935,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 348 824 388 q 522 308 646 308 l 215 308 l 261 356 l 261 0 l 158 0 m 822 0 l 572 353 l 683 353 l 935 0 l 822 0 m 261 347 l 215 396 l 519 396 q 741 460 665 396 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 z "
  },
  Ṛ: {
    ha: 1004,
    x_min: 158,
    x_max: 935,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 348 824 388 q 522 308 646 308 l 215 308 l 261 356 l 261 0 l 158 0 m 822 0 l 572 353 l 683 353 l 935 0 l 822 0 m 261 347 l 215 396 l 519 396 q 741 460 665 396 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 m 513 -264 q 471 -247 489 -264 q 453 -204 453 -231 q 471 -161 453 -178 q 513 -144 489 -144 q 555 -161 538 -144 q 572 -204 572 -178 q 555 -247 572 -231 q 513 -264 538 -264 z "
  },
  Ȓ: {
    ha: 1004,
    x_min: 158,
    x_max: 935,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 348 824 388 q 522 308 646 308 l 215 308 l 261 356 l 261 0 l 158 0 m 822 0 l 572 353 l 683 353 l 935 0 l 822 0 m 261 347 l 215 396 l 519 396 q 741 460 665 396 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 z "
  },
  Ṟ: {
    ha: 1004,
    x_min: 158,
    x_max: 935,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 348 824 388 q 522 308 646 308 l 215 308 l 261 356 l 261 0 l 158 0 m 822 0 l 572 353 l 683 353 l 935 0 l 822 0 m 261 347 l 215 396 l 519 396 q 741 460 665 396 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 m 299 -235 l 299 -169 l 726 -169 l 726 -235 l 299 -235 z "
  },
  S: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 z "
  },
  Ś: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 z "
  },
  Ṥ: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 z "
  },
  "Ꞌ": {
    ha: 335,
    x_min: 117,
    x_max: 218,
    o: "m 117 414 l 117 972 l 218 972 l 207 414 l 117 414 z "
  },
  Š: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 z "
  },
  Ṧ: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 z "
  },
  Ş: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 m 415 -306 q 352 -297 381 -306 q 299 -274 324 -289 l 322 -221 q 366 -240 343 -233 q 414 -247 389 -247 q 478 -230 456 -247 q 500 -182 500 -212 q 478 -136 500 -154 q 414 -118 457 -118 l 382 -118 l 415 8 l 475 8 l 454 -72 q 542 -108 511 -76 q 572 -185 572 -139 q 528 -273 572 -240 q 415 -306 485 -306 z "
  },
  Ŝ: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 z "
  },
  Ș: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 m 397 -364 l 436 -214 l 446 -253 q 403 -237 419 -253 q 386 -199 386 -222 q 403 -160 386 -175 q 446 -144 419 -144 q 490 -160 474 -144 q 506 -199 506 -176 q 502 -228 506 -212 q 490 -261 499 -243 l 451 -364 l 397 -364 z "
  },
  Ṡ: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 z "
  },
  Ṣ: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 m 446 -264 q 404 -247 422 -264 q 386 -204 386 -231 q 404 -161 386 -178 q 446 -144 422 -144 q 488 -161 471 -144 q 506 -204 506 -178 q 488 -247 506 -231 q 446 -264 471 -264 z "
  },
  Ṩ: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 m 446 -264 q 404 -247 422 -264 q 386 -204 386 -231 q 404 -161 386 -178 q 446 -144 422 -144 q 488 -161 471 -144 q 506 -204 506 -178 q 488 -247 506 -231 q 446 -264 471 -264 z "
  },
  "ẞ": {
    ha: 1050,
    x_min: 150,
    x_max: 974,
    o: "m 639 -8 q 540 0 586 -8 q 450 28 493 8 l 468 114 q 547 88 504 97 q 638 79 589 79 q 807 130 744 79 q 869 279 869 181 q 806 429 869 379 q 633 479 742 479 q 572 475 603 479 q 515 463 540 471 l 494 515 l 828 878 l 838 808 q 715 873 783 853 q 572 893 647 893 q 334 809 415 893 q 253 567 253 725 l 253 0 l 150 0 l 150 571 q 199 790 150 699 q 342 931 249 882 q 567 981 435 981 q 683 970 625 981 q 792 939 740 960 q 883 885 843 918 l 883 817 l 579 488 l 540 546 q 592 557 564 554 q 649 560 619 560 q 816 527 743 560 q 931 431 889 494 q 974 275 974 368 q 932 120 974 183 q 815 24 890 57 q 639 -8 739 -8 z "
  },
  Ə: {
    ha: 1135,
    x_min: 72,
    x_max: 1063,
    o: "m 568 -8 q 370 28 461 -8 q 213 133 279 65 q 109 291 146 200 q 72 490 72 382 l 72 521 l 974 521 l 974 433 l 139 433 l 174 486 q 203 323 174 397 q 284 194 232 249 q 408 110 336 140 q 568 81 481 81 q 723 110 651 81 q 848 193 794 139 q 931 321 901 247 q 960 481 960 394 l 960 490 q 929 649 960 576 q 844 775 899 721 q 715 859 789 829 q 557 889 642 889 q 443 877 499 889 q 338 840 388 865 q 246 776 289 815 l 185 847 q 288 920 231 890 q 415 965 346 950 q 557 981 483 981 q 759 944 667 981 q 919 840 851 907 q 1025 683 988 774 q 1063 488 1063 593 q 1025 292 1063 382 q 920 134 988 201 q 763 29 853 67 q 568 -8 672 -8 z "
  },
  T: {
    ha: 797,
    x_min: 6,
    x_max: 792,
    o: "m 347 0 l 347 883 l 6 883 l 6 972 l 792 972 l 792 883 l 450 883 l 450 0 l 347 0 z "
  },
  Ŧ: {
    ha: 797,
    x_min: 6,
    x_max: 792,
    o: "m 347 0 l 347 883 l 6 883 l 6 972 l 792 972 l 792 883 l 450 883 l 450 0 l 347 0 m 129 438 l 129 519 l 668 519 l 668 438 l 129 438 z "
  },
  Ť: {
    ha: 797,
    x_min: 6,
    x_max: 792,
    o: "m 347 0 l 347 883 l 6 883 l 6 972 l 792 972 l 792 883 l 450 883 l 450 0 l 347 0 z "
  },
  Ţ: {
    ha: 797,
    x_min: 6,
    x_max: 792,
    o: "m 347 0 l 347 883 l 6 883 l 6 972 l 792 972 l 792 883 l 450 883 l 450 0 l 347 0 m 368 -306 q 305 -297 333 -306 q 251 -274 276 -289 l 275 -221 q 319 -240 296 -233 q 367 -247 342 -247 q 431 -230 408 -247 q 453 -182 453 -212 q 431 -136 453 -154 q 367 -118 410 -118 l 335 -118 l 368 8 l 428 8 l 407 -72 q 494 -108 464 -76 q 525 -185 525 -139 q 481 -273 525 -240 q 368 -306 438 -306 z "
  },
  Ț: {
    ha: 797,
    x_min: 6,
    x_max: 792,
    o: "m 347 0 l 347 883 l 6 883 l 6 972 l 792 972 l 792 883 l 450 883 l 450 0 l 347 0 m 350 -364 l 389 -214 l 399 -253 q 356 -237 372 -253 q 339 -199 339 -222 q 356 -160 339 -175 q 399 -144 372 -144 q 442 -160 426 -144 q 458 -199 458 -176 q 455 -228 458 -212 q 443 -261 451 -243 l 404 -364 l 350 -364 z "
  },
  Ṭ: {
    ha: 797,
    x_min: 6,
    x_max: 792,
    o: "m 347 0 l 347 883 l 6 883 l 6 972 l 792 972 l 792 883 l 450 883 l 450 0 l 347 0 m 399 -264 q 357 -247 375 -264 q 339 -204 339 -231 q 357 -161 339 -178 q 399 -144 375 -144 q 441 -161 424 -144 q 458 -204 458 -178 q 441 -247 458 -231 q 399 -264 424 -264 z "
  },
  Ṯ: {
    ha: 797,
    x_min: 6,
    x_max: 792,
    o: "m 347 0 l 347 883 l 6 883 l 6 972 l 792 972 l 792 883 l 450 883 l 450 0 l 347 0 m 185 -235 l 185 -169 l 613 -169 l 613 -235 l 185 -235 z "
  },
  U: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ú: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ŭ: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ǔ: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Û: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ȕ: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ü: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ụ: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 m 550 -264 q 508 -247 526 -264 q 490 -204 490 -231 q 508 -161 490 -178 q 550 -144 526 -144 q 592 -161 575 -144 q 610 -204 610 -178 q 592 -247 610 -231 q 550 -264 575 -264 z "
  },
  Ù: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ủ: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ư: {
    ha: 1107,
    x_min: 150,
    x_max: 1088,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 m 901 897 l 901 972 l 922 972 q 992 1000 971 972 q 1014 1067 1014 1028 q 1006 1115 1014 1093 q 986 1156 999 1138 l 1051 1181 q 1078 1127 1068 1157 q 1088 1064 1088 1097 q 1046 944 1088 990 q 922 897 1004 897 l 901 897 z "
  },
  Ứ: {
    ha: 1107,
    x_min: 150,
    x_max: 1088,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 m 901 897 l 901 972 l 922 972 q 992 1000 971 972 q 1014 1067 1014 1028 q 1006 1115 1014 1093 q 986 1156 999 1138 l 1051 1181 q 1078 1127 1068 1157 q 1088 1064 1088 1097 q 1046 944 1088 990 q 922 897 1004 897 l 901 897 z "
  },
  Ự: {
    ha: 1107,
    x_min: 150,
    x_max: 1088,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 m 901 897 l 901 972 l 922 972 q 992 1000 971 972 q 1014 1067 1014 1028 q 1006 1115 1014 1093 q 986 1156 999 1138 l 1051 1181 q 1078 1127 1068 1157 q 1088 1064 1088 1097 q 1046 944 1088 990 q 922 897 1004 897 l 901 897 m 550 -264 q 508 -247 526 -264 q 490 -204 490 -231 q 508 -161 490 -178 q 550 -144 526 -144 q 592 -161 575 -144 q 610 -204 610 -178 q 592 -247 610 -231 q 550 -264 575 -264 z "
  },
  Ừ: {
    ha: 1107,
    x_min: 150,
    x_max: 1088,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 m 901 897 l 901 972 l 922 972 q 992 1000 971 972 q 1014 1067 1014 1028 q 1006 1115 1014 1093 q 986 1156 999 1138 l 1051 1181 q 1078 1127 1068 1157 q 1088 1064 1088 1097 q 1046 944 1088 990 q 922 897 1004 897 l 901 897 z "
  },
  Ử: {
    ha: 1107,
    x_min: 150,
    x_max: 1088,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 m 901 897 l 901 972 l 922 972 q 992 1000 971 972 q 1014 1067 1014 1028 q 1006 1115 1014 1093 q 986 1156 999 1138 l 1051 1181 q 1078 1127 1068 1157 q 1088 1064 1088 1097 q 1046 944 1088 990 q 922 897 1004 897 l 901 897 z "
  },
  Ữ: {
    ha: 1107,
    x_min: 150,
    x_max: 1088,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 m 901 897 l 901 972 l 922 972 q 992 1000 971 972 q 1014 1067 1014 1028 q 1006 1115 1014 1093 q 986 1156 999 1138 l 1051 1181 q 1078 1127 1068 1157 q 1088 1064 1088 1097 q 1046 944 1088 990 q 922 897 1004 897 l 901 897 z "
  },
  Ű: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ȗ: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ū: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ṻ: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ų: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 849 972 l 949 972 l 949 415 q 882 149 949 246 q 700 11 815 51 q 569 -50 614 -18 q 510 -112 525 -82 q 494 -167 494 -142 q 520 -225 494 -206 q 585 -244 546 -244 q 630 -237 607 -244 q 669 -218 653 -231 l 692 -272 q 638 -297 668 -287 q 574 -306 607 -306 q 463 -269 504 -306 q 421 -174 421 -233 q 438 -103 421 -140 q 498 -31 456 -67 q 617 36 540 6 l 607 -6 q 578 -8 593 -7 q 550 -8 564 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 z "
  },
  Ů: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 m 549 1069 q 474 1089 507 1069 q 423 1140 442 1108 q 404 1211 404 1172 q 424 1283 404 1250 q 476 1337 443 1317 q 549 1357 508 1357 q 623 1337 590 1357 q 675 1283 656 1317 q 694 1211 694 1250 q 675 1140 694 1172 q 623 1089 656 1108 q 549 1069 590 1069 m 549 1118 q 617 1145 590 1118 q 643 1211 643 1172 q 617 1280 643 1251 q 549 1308 590 1308 q 482 1281 508 1308 q 456 1211 456 1253 q 481 1144 456 1171 q 549 1118 507 1118 z "
  },
  Ũ: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  Ṹ: {
    ha: 1100,
    x_min: 150,
    x_max: 949,
    o: "m 550 -8 q 257 99 364 -8 q 150 415 150 206 l 150 972 l 253 972 l 253 419 q 331 165 253 247 q 550 83 408 83 q 771 165 693 83 q 849 419 849 247 l 849 972 l 949 972 l 949 415 q 842 99 949 206 q 550 -8 736 -8 z "
  },
  V: {
    ha: 969,
    x_min: 4,
    x_max: 967,
    o: "m 435 0 l 4 972 l 115 972 l 518 57 l 457 57 l 863 972 l 967 972 l 536 0 l 435 0 z "
  },
  W: {
    ha: 1543,
    x_min: 51,
    x_max: 1493,
    o: "m 379 0 l 51 972 l 157 972 l 438 135 l 728 972 l 822 972 l 1100 130 l 1394 972 l 1493 972 l 1165 0 l 1057 0 l 772 828 l 486 0 l 379 0 z "
  },
  Ẃ: {
    ha: 1543,
    x_min: 51,
    x_max: 1493,
    o: "m 379 0 l 51 972 l 157 972 l 464 57 l 411 57 l 728 972 l 822 972 l 1135 57 l 1085 57 l 1394 972 l 1493 972 l 1165 0 l 1057 0 l 758 868 l 786 868 l 486 0 l 379 0 z "
  },
  Ŵ: {
    ha: 1543,
    x_min: 51,
    x_max: 1493,
    o: "m 379 0 l 51 972 l 157 972 l 464 57 l 411 57 l 728 972 l 822 972 l 1135 57 l 1085 57 l 1394 972 l 1493 972 l 1165 0 l 1057 0 l 758 868 l 786 868 l 486 0 l 379 0 z "
  },
  Ẅ: {
    ha: 1543,
    x_min: 51,
    x_max: 1493,
    o: "m 379 0 l 51 972 l 157 972 l 464 57 l 411 57 l 728 972 l 822 972 l 1135 57 l 1085 57 l 1394 972 l 1493 972 l 1165 0 l 1057 0 l 758 868 l 786 868 l 486 0 l 379 0 z "
  },
  Ẁ: {
    ha: 1543,
    x_min: 51,
    x_max: 1493,
    o: "m 379 0 l 51 972 l 157 972 l 464 57 l 411 57 l 728 972 l 822 972 l 1135 57 l 1085 57 l 1394 972 l 1493 972 l 1165 0 l 1057 0 l 758 868 l 786 868 l 486 0 l 379 0 z "
  },
  X: {
    ha: 911,
    x_min: 24,
    x_max: 888,
    o: "m 24 0 l 422 539 l 422 460 l 47 972 l 165 972 l 481 544 l 435 543 l 750 972 l 861 972 l 490 467 l 490 539 l 888 0 l 768 0 l 432 457 l 475 457 l 142 0 l 24 0 z "
  },
  Y: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 z "
  },
  Ý: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 z "
  },
  Ŷ: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 z "
  },
  Ÿ: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 z "
  },
  Ẏ: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 z "
  },
  Ỵ: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 m 440 -264 q 399 -247 417 -264 q 381 -204 381 -231 q 399 -161 381 -178 q 440 -144 417 -144 q 483 -161 465 -144 q 500 -204 500 -178 q 483 -247 500 -231 q 440 -264 465 -264 z "
  },
  Ỳ: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 z "
  },
  Ỷ: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 z "
  },
  Ȳ: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 z "
  },
  Ỹ: {
    ha: 882,
    x_min: 1,
    x_max: 881,
    o: "m 390 0 l 390 361 l 414 297 l 1 972 l 111 972 l 474 379 l 415 379 l 778 972 l 881 972 l 468 297 l 492 361 l 492 0 l 390 0 z "
  },
  Z: {
    ha: 904,
    x_min: 63,
    x_max: 860,
    o: "m 63 0 l 63 71 l 738 922 l 749 883 l 72 883 l 72 972 l 843 972 l 843 901 l 169 50 l 157 89 l 860 89 l 860 0 l 63 0 z "
  },
  Ź: {
    ha: 904,
    x_min: 63,
    x_max: 860,
    o: "m 63 0 l 63 71 l 738 922 l 749 883 l 72 883 l 72 972 l 843 972 l 843 901 l 169 50 l 157 89 l 860 89 l 860 0 l 63 0 z "
  },
  Ž: {
    ha: 904,
    x_min: 63,
    x_max: 860,
    o: "m 63 0 l 63 71 l 738 922 l 749 883 l 72 883 l 72 972 l 843 972 l 843 901 l 169 50 l 157 89 l 860 89 l 860 0 l 63 0 z "
  },
  Ż: {
    ha: 904,
    x_min: 63,
    x_max: 860,
    o: "m 63 0 l 63 71 l 738 922 l 749 883 l 72 883 l 72 972 l 843 972 l 843 901 l 169 50 l 157 89 l 860 89 l 860 0 l 63 0 z "
  },
  Ẓ: {
    ha: 904,
    x_min: 63,
    x_max: 860,
    o: "m 63 0 l 63 71 l 738 922 l 749 883 l 72 883 l 72 972 l 843 972 l 843 901 l 169 50 l 157 89 l 860 89 l 860 0 l 63 0 m 472 -264 q 431 -247 449 -264 q 413 -204 413 -231 q 431 -161 413 -178 q 472 -144 449 -144 q 515 -161 497 -144 q 532 -204 532 -178 q 515 -247 532 -231 q 472 -264 497 -264 z "
  },
  a: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 z "
  },
  á: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 306 843 l 496 1015 l 628 1015 l 403 843 l 306 843 z "
  },
  ă: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 396 836 q 248 884 308 836 q 185 1015 188 932 l 254 1015 q 298 929 257 961 q 396 897 339 897 q 495 929 454 897 q 538 1015 536 961 l 607 1015 q 544 884 604 932 q 396 836 483 836 z "
  },
  ắ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 z "
  },
  ặ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 399 -264 q 357 -247 375 -264 q 339 -204 339 -231 q 357 -161 339 -178 q 399 -144 375 -144 q 441 -161 424 -144 q 458 -204 458 -178 q 441 -247 458 -231 q 399 -264 424 -264 m 396 836 q 248 884 308 836 q 185 1015 188 932 l 254 1015 q 298 929 257 961 q 396 897 339 897 q 495 929 454 897 q 538 1015 536 961 l 607 1015 q 544 884 604 932 q 396 836 483 836 z "
  },
  ằ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 z "
  },
  ẳ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 z "
  },
  ẵ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 z "
  },
  ǎ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 346 843 l 167 1015 l 258 1015 l 435 869 l 357 869 l 533 1015 l 625 1015 l 446 843 l 346 843 z "
  },
  â: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 167 843 l 346 1015 l 446 1015 l 625 843 l 533 843 l 357 990 l 435 990 l 258 843 l 167 843 z "
  },
  ấ: {
    ha: 819,
    x_min: 76,
    x_max: 811,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 z "
  },
  ậ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 399 -264 q 357 -247 375 -264 q 339 -204 339 -231 q 357 -161 339 -178 q 399 -144 375 -144 q 441 -161 424 -144 q 458 -204 458 -178 q 441 -247 458 -231 q 399 -264 424 -264 m 167 843 l 346 1015 l 446 1015 l 625 843 l 533 843 l 357 990 l 435 990 l 258 843 l 167 843 z "
  },
  ầ: {
    ha: 819,
    x_min: 76,
    x_max: 693,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 z "
  },
  ẩ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 z "
  },
  ẫ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 z "
  },
  ȁ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 465 843 l 308 1015 l 418 1015 l 553 843 l 465 843 m 239 843 l 83 1015 l 193 1015 l 326 843 l 239 843 z "
  },
  ä: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 519 875 q 478 892 496 875 q 460 935 460 908 q 478 978 460 961 q 519 994 496 994 q 562 978 544 994 q 579 935 579 961 q 562 892 579 908 q 519 875 544 875 m 272 875 q 230 892 247 875 q 213 935 213 908 q 230 978 213 961 q 272 994 247 994 q 314 978 296 994 q 332 935 332 961 q 314 892 332 908 q 272 875 296 875 z "
  },
  ạ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 399 -264 q 357 -247 375 -264 q 339 -204 339 -231 q 357 -161 339 -178 q 399 -144 375 -144 q 441 -161 424 -144 q 458 -204 458 -178 q 441 -247 458 -231 q 399 -264 424 -264 z "
  },
  à: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 389 843 l 164 1015 l 296 1015 l 486 843 l 389 843 z "
  },
  ả: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 414 833 l 379 876 q 441 919 421 896 q 461 975 461 943 q 440 1024 461 1004 q 385 1043 419 1043 q 301 1017 342 1043 l 278 1065 q 333 1092 301 1083 q 393 1101 364 1101 q 488 1069 451 1101 q 525 982 525 1036 q 498 897 525 933 q 414 833 471 860 z "
  },
  ȃ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 185 843 q 248 974 188 926 q 396 1021 308 1021 q 544 974 483 1021 q 607 843 604 926 l 538 843 q 495 929 536 897 q 396 961 454 961 q 298 929 339 961 q 254 843 257 897 l 185 843 z "
  },
  ā: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 182 896 l 182 961 l 610 961 l 610 896 l 182 896 z "
  },
  ą: {
    ha: 819,
    x_min: 76,
    x_max: 718,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 600 -306 q 489 -269 531 -306 q 447 -174 447 -233 q 465 -103 447 -140 q 525 -31 482 -67 q 643 38 568 6 l 689 0 q 585 -58 622 -29 q 534 -113 549 -86 q 519 -167 519 -140 q 545 -225 519 -206 q 610 -244 571 -244 q 656 -237 633 -244 q 696 -218 679 -231 l 718 -272 q 663 -297 693 -287 q 600 -306 633 -306 z "
  },
  å: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 394 826 q 320 846 353 826 q 269 897 288 865 q 250 968 250 929 q 269 1040 250 1007 q 322 1094 289 1074 q 394 1114 354 1114 q 469 1094 436 1114 q 521 1040 501 1074 q 540 968 540 1007 q 521 897 540 929 q 469 846 501 865 q 394 826 436 826 m 394 875 q 463 902 436 875 q 489 968 489 929 q 463 1037 489 1008 q 394 1065 436 1065 q 328 1038 354 1065 q 301 968 301 1010 q 327 901 301 928 q 394 875 353 875 z "
  },
  ǻ: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 394 826 q 320 846 353 826 q 269 897 288 865 q 250 968 250 929 q 269 1040 250 1007 q 322 1094 289 1074 q 394 1114 354 1114 q 469 1094 436 1114 q 521 1040 501 1074 q 540 968 540 1007 q 521 897 540 929 q 469 846 501 865 q 394 826 436 826 m 394 875 q 463 902 436 875 q 489 968 489 929 q 463 1037 489 1008 q 394 1065 436 1065 q 328 1038 354 1065 q 301 968 301 1010 q 327 901 301 928 q 394 875 353 875 m 503 1046 l 444 1067 l 585 1206 l 640 1161 l 503 1046 z "
  },
  ã: {
    ha: 819,
    x_min: 76,
    x_max: 689,
    o: "m 594 0 l 594 161 l 590 188 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 393 736 307 736 q 612 666 535 736 q 689 453 689 596 l 689 0 l 594 0 m 343 -7 q 201 20 261 -7 q 108 95 140 47 q 76 206 76 143 q 103 309 76 263 q 192 384 131 356 q 358 413 254 413 l 610 413 l 610 339 l 361 339 q 215 301 256 339 q 174 208 174 264 q 222 108 174 146 q 358 71 271 71 q 502 109 442 71 q 590 219 563 147 l 613 151 q 516 36 585 79 q 343 -7 447 -7 m 490 851 q 433 865 458 851 q 388 898 408 879 q 349 931 368 917 q 308 946 329 946 q 258 922 276 946 q 236 857 239 899 l 176 857 q 213 968 179 926 q 301 1010 247 1010 q 359 995 333 1010 q 405 962 385 981 q 444 929 425 943 q 483 915 463 915 q 535 938 515 915 q 556 1001 554 961 l 615 1001 q 579 893 614 935 q 490 851 544 851 z "
  },
  æ: {
    ha: 1369,
    x_min: 76,
    x_max: 1306,
    o: "m 353 -7 q 149 53 222 -7 q 76 208 76 113 q 103 308 76 263 q 192 383 131 354 q 358 411 254 411 l 607 411 l 607 338 l 361 338 q 215 301 256 338 q 174 210 174 264 q 223 108 174 146 q 360 71 272 71 q 528 126 465 71 q 590 279 590 182 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 392 736 307 736 q 588 683 517 736 q 676 525 660 631 l 632 533 q 757 681 674 626 q 950 736 840 736 q 1091 709 1026 736 q 1203 633 1156 682 q 1278 518 1251 585 q 1306 371 1306 451 q 1305 353 1306 361 q 1303 338 1304 346 l 669 338 l 669 411 l 1250 411 l 1210 379 q 1174 524 1210 464 q 1079 618 1139 585 q 949 651 1019 651 q 819 618 879 651 q 724 524 760 585 q 689 376 689 463 l 689 361 q 726 215 689 278 q 827 116 763 151 q 978 81 892 81 q 1102 104 1046 81 q 1201 176 1158 128 l 1257 113 q 1135 23 1208 53 q 975 -7 1063 -7 q 819 21 892 -7 q 692 106 746 49 q 608 249 638 163 l 672 247 q 610 97 658 153 q 494 17 563 42 q 353 -7 426 -7 z "
  },
  ǽ: {
    ha: 1369,
    x_min: 76,
    x_max: 1306,
    o: "m 353 -7 q 149 53 222 -7 q 76 208 76 113 q 103 308 76 263 q 192 383 131 354 q 358 411 254 411 l 607 411 l 607 338 l 361 338 q 215 301 256 338 q 174 210 174 264 q 223 108 174 146 q 360 71 272 71 q 528 126 465 71 q 590 279 590 182 l 590 457 q 538 600 590 550 q 383 650 486 650 q 249 626 313 650 q 140 564 185 603 l 96 638 q 229 710 151 685 q 392 736 307 736 q 588 683 517 736 q 676 525 660 631 l 632 533 q 757 681 674 626 q 950 736 840 736 q 1091 709 1026 736 q 1203 633 1156 682 q 1278 518 1251 585 q 1306 371 1306 451 q 1305 353 1306 361 q 1303 338 1304 346 l 669 338 l 669 411 l 1250 411 l 1210 379 q 1174 524 1210 464 q 1079 618 1139 585 q 949 651 1019 651 q 819 618 879 651 q 724 524 760 585 q 689 376 689 463 l 689 361 q 726 215 689 278 q 827 116 763 151 q 978 81 892 81 q 1102 104 1046 81 q 1201 176 1158 128 l 1257 113 q 1135 23 1208 53 q 975 -7 1063 -7 q 819 21 892 -7 q 692 106 746 49 q 608 249 638 163 l 672 247 q 610 97 658 153 q 494 17 563 42 q 353 -7 426 -7 m 550 843 l 740 1015 l 872 1015 l 647 843 l 550 843 z "
  },
  b: {
    ha: 942,
    x_min: 138,
    x_max: 878,
    o: "m 514 -7 q 342 37 418 -7 q 221 164 265 81 q 176 365 176 247 q 222 567 176 485 q 343 693 267 650 q 514 736 419 736 q 701 690 618 736 q 831 560 783 643 q 878 365 878 476 q 831 172 878 256 q 701 40 783 88 q 514 -7 618 -7 m 138 0 l 138 1031 l 236 1031 l 236 514 l 222 367 l 232 219 l 232 0 l 138 0 m 507 81 q 646 116 585 81 q 743 216 707 151 q 779 365 779 281 q 743 515 779 451 q 646 615 707 579 q 507 650 585 650 q 367 615 429 650 q 270 515 306 579 q 235 365 235 451 q 270 216 235 281 q 367 116 306 151 q 507 81 429 81 z "
  },
  c: {
    ha: 782,
    x_min: 64,
    x_max: 726,
    o: "m 440 -7 q 247 41 332 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 247 689 161 642 q 440 736 332 736 q 608 700 533 736 q 726 592 683 664 l 653 542 q 560 624 615 597 q 439 650 504 650 q 299 615 361 650 q 200 515 236 579 q 164 365 164 451 q 200 215 164 279 q 299 116 236 151 q 439 81 361 81 q 560 107 504 81 q 653 188 615 133 l 726 138 q 608 30 683 67 q 440 -7 533 -7 z "
  },
  ć: {
    ha: 782,
    x_min: 64,
    x_max: 726,
    o: "m 440 -7 q 247 41 332 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 247 689 161 642 q 440 736 332 736 q 608 700 533 736 q 726 592 683 664 l 653 542 q 560 624 615 597 q 439 650 504 650 q 299 615 361 650 q 200 515 236 579 q 164 365 164 451 q 200 215 164 279 q 299 116 236 151 q 439 81 361 81 q 560 107 504 81 q 653 188 615 133 l 726 138 q 608 30 683 67 q 440 -7 533 -7 m 325 843 l 515 1015 l 647 1015 l 422 843 l 325 843 z "
  },
  č: {
    ha: 782,
    x_min: 64,
    x_max: 726,
    o: "m 440 -7 q 247 41 332 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 247 689 161 642 q 440 736 332 736 q 608 700 533 736 q 726 592 683 664 l 653 542 q 560 624 615 597 q 439 650 504 650 q 299 615 361 650 q 200 515 236 579 q 164 365 164 451 q 200 215 164 279 q 299 116 236 151 q 439 81 361 81 q 560 107 504 81 q 653 188 615 133 l 726 138 q 608 30 683 67 q 440 -7 533 -7 m 365 843 l 186 1015 l 278 1015 l 454 869 l 376 869 l 553 1015 l 644 1015 l 465 843 l 365 843 z "
  },
  ç: {
    ha: 782,
    x_min: 64,
    x_max: 726,
    o: "m 440 -7 q 247 41 332 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 247 689 161 642 q 440 736 332 736 q 608 700 533 736 q 726 592 683 664 l 653 542 q 560 624 615 597 q 439 650 504 650 q 299 615 361 650 q 200 515 236 579 q 164 365 164 451 q 200 215 164 279 q 299 116 236 151 q 439 81 361 81 q 560 107 504 81 q 653 188 615 133 l 726 138 q 608 30 683 67 q 440 -7 533 -7 m 382 -306 q 319 -297 347 -306 q 265 -274 290 -289 l 289 -221 q 333 -240 310 -233 q 381 -247 356 -247 q 444 -230 422 -247 q 467 -182 467 -212 q 445 -136 467 -154 q 381 -118 424 -118 l 349 -118 l 382 8 l 442 8 l 421 -72 q 508 -108 478 -76 q 539 -185 539 -139 q 495 -273 539 -240 q 382 -306 451 -306 z "
  },
  ḉ: {
    ha: 782,
    x_min: 64,
    x_max: 726,
    o: "m 440 -7 q 247 41 332 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 247 689 161 642 q 440 736 332 736 q 608 700 533 736 q 726 592 683 664 l 653 542 q 560 624 615 597 q 439 650 504 650 q 299 615 361 650 q 200 515 236 579 q 164 365 164 451 q 200 215 164 279 q 299 116 236 151 q 439 81 361 81 q 560 107 504 81 q 653 188 615 133 l 726 138 q 608 30 683 67 q 440 -7 533 -7 m 382 -306 q 319 -297 347 -306 q 265 -274 290 -289 l 289 -221 q 333 -240 310 -233 q 381 -247 356 -247 q 444 -230 422 -247 q 467 -182 467 -212 q 445 -136 467 -154 q 381 -118 424 -118 l 349 -118 l 382 8 l 442 8 l 421 -72 q 508 -108 478 -76 q 539 -185 539 -139 q 495 -273 539 -240 q 382 -306 451 -306 m 325 843 l 515 1015 l 647 1015 l 422 843 l 325 843 z "
  },
  ĉ: {
    ha: 782,
    x_min: 64,
    x_max: 726,
    o: "m 440 -7 q 247 41 332 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 247 689 161 642 q 440 736 332 736 q 608 700 533 736 q 726 592 683 664 l 653 542 q 560 624 615 597 q 439 650 504 650 q 299 615 361 650 q 200 515 236 579 q 164 365 164 451 q 200 215 164 279 q 299 116 236 151 q 439 81 361 81 q 560 107 504 81 q 653 188 615 133 l 726 138 q 608 30 683 67 q 440 -7 533 -7 m 186 843 l 365 1015 l 465 1015 l 644 843 l 553 843 l 376 990 l 454 990 l 278 843 l 186 843 z "
  },
  ċ: {
    ha: 782,
    x_min: 64,
    x_max: 726,
    o: "m 440 -7 q 247 41 332 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 247 689 161 642 q 440 736 332 736 q 608 700 533 736 q 726 592 683 664 l 653 542 q 560 624 615 597 q 439 650 504 650 q 299 615 361 650 q 200 515 236 579 q 164 365 164 451 q 200 215 164 279 q 299 116 236 151 q 439 81 361 81 q 560 107 504 81 q 653 188 615 133 l 726 138 q 608 30 683 67 q 440 -7 533 -7 m 415 875 q 368 894 388 875 q 349 942 349 914 q 368 990 349 971 q 415 1008 388 1008 q 463 990 443 1008 q 482 942 482 971 q 463 894 482 914 q 415 875 443 875 z "
  },
  d: {
    ha: 942,
    x_min: 64,
    x_max: 804,
    o: "m 428 -7 q 241 40 324 -7 q 111 172 158 88 q 64 365 64 256 q 111 560 64 476 q 241 690 158 643 q 428 736 324 736 q 599 693 524 736 q 720 567 675 650 q 765 365 765 485 q 721 164 765 247 q 601 37 676 81 q 428 -7 525 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 574 615 636 579 q 435 650 513 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 710 0 l 710 219 l 719 367 l 706 514 l 706 1031 l 804 1031 l 804 0 l 710 0 z "
  },
  ð: {
    ha: 879,
    x_min: 64,
    x_max: 815,
    o: "m 406 -8 q 230 29 307 -8 q 108 136 153 67 q 64 299 64 206 q 108 461 64 392 q 231 568 153 531 q 411 606 310 606 q 563 575 494 606 q 677 485 632 544 q 733 342 722 426 l 696 329 q 712 419 708 374 q 715 503 715 465 q 671 729 715 638 q 544 867 626 821 q 351 914 463 914 q 240 905 292 914 q 147 883 189 896 l 131 968 q 231 989 174 981 q 351 997 288 997 q 595 939 492 997 q 757 766 699 881 q 815 482 815 651 q 767 222 815 332 q 628 51 719 111 q 406 -8 538 -8 m 411 76 q 555 108 496 76 q 644 191 614 140 q 675 299 675 242 q 642 413 675 363 q 553 492 610 463 q 419 521 496 521 q 232 460 300 521 q 164 299 164 399 q 195 182 164 232 q 282 104 226 132 q 411 76 338 76 m 211 685 l 183 753 l 733 982 l 761 914 l 211 685 z "
  },
  ď: {
    ha: 942,
    x_min: 64,
    x_max: 1017,
    o: "m 428 -7 q 241 40 324 -7 q 111 172 158 88 q 64 365 64 256 q 111 560 64 476 q 241 690 158 643 q 428 736 324 736 q 599 693 524 736 q 720 567 675 650 q 765 365 765 485 q 721 164 765 247 q 601 37 676 81 q 428 -7 525 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 574 615 636 579 q 435 650 513 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 710 0 l 710 219 l 719 367 l 706 514 l 706 1031 l 804 1031 l 804 0 l 710 0 m 933 808 l 933 1069 l 1017 1069 l 1004 808 l 933 808 z "
  },
  đ: {
    ha: 942,
    x_min: 64,
    x_max: 942,
    o: "m 428 -7 q 241 40 324 -7 q 111 172 158 88 q 64 365 64 256 q 111 560 64 476 q 241 690 158 643 q 428 736 324 736 q 599 693 524 736 q 720 567 675 650 q 765 365 765 485 q 721 164 765 247 q 601 37 676 81 q 428 -7 525 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 574 615 636 579 q 435 650 513 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 710 0 l 710 219 l 719 367 l 706 514 l 706 1031 l 804 1031 l 804 0 l 710 0 m 400 843 l 400 915 l 942 915 l 942 843 l 400 843 z "
  },
  ḍ: {
    ha: 942,
    x_min: 64,
    x_max: 804,
    o: "m 428 -7 q 241 40 324 -7 q 111 172 158 88 q 64 365 64 256 q 111 560 64 476 q 241 690 158 643 q 428 736 324 736 q 599 693 524 736 q 720 567 675 650 q 765 365 765 485 q 721 164 765 247 q 601 37 676 81 q 428 -7 525 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 574 615 636 579 q 435 650 513 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 710 0 l 710 219 l 719 367 l 706 514 l 706 1031 l 804 1031 l 804 0 l 710 0 m 472 -264 q 431 -247 449 -264 q 413 -204 413 -231 q 431 -161 413 -178 q 472 -144 449 -144 q 515 -161 497 -144 q 532 -204 532 -178 q 515 -247 532 -231 q 472 -264 497 -264 z "
  },
  ḏ: {
    ha: 942,
    x_min: 64,
    x_max: 804,
    o: "m 428 -7 q 241 40 324 -7 q 111 172 158 88 q 64 365 64 256 q 111 560 64 476 q 241 690 158 643 q 428 736 324 736 q 599 693 524 736 q 720 567 675 650 q 765 365 765 485 q 721 164 765 247 q 601 37 676 81 q 428 -7 525 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 574 615 636 579 q 435 650 513 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 710 0 l 710 219 l 719 367 l 706 514 l 706 1031 l 804 1031 l 804 0 l 710 0 m 258 -235 l 258 -169 l 686 -169 l 686 -235 l 258 -235 z "
  },
  ǆ: {
    ha: 1669,
    x_min: 64,
    x_max: 1593,
    o: "m 428 -7 q 241 40 324 -7 q 111 172 158 88 q 64 365 64 256 q 111 560 64 476 q 241 690 158 643 q 428 736 324 736 q 599 693 524 736 q 720 567 675 650 q 765 365 765 485 q 721 164 765 247 q 601 37 676 81 q 428 -7 525 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 574 615 636 579 q 435 650 513 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 710 0 l 710 219 l 719 367 l 706 514 l 706 1031 l 804 1031 l 804 0 l 710 0 z "
  },
  e: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 z "
  },
  é: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 329 843 l 519 1015 l 651 1015 l 426 843 l 329 843 z "
  },
  ĕ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 419 836 q 272 884 332 836 q 208 1015 211 932 l 278 1015 q 322 929 281 961 q 419 897 363 897 q 519 929 478 897 q 561 1015 560 961 l 631 1015 q 567 884 628 932 q 419 836 507 836 z "
  },
  ě: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 369 843 l 190 1015 l 282 1015 l 458 869 l 381 869 l 557 1015 l 649 1015 l 469 843 l 369 843 z "
  },
  ḝ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 389 -306 q 326 -297 354 -306 q 272 -274 297 -289 l 296 -221 q 340 -240 317 -233 q 388 -247 363 -247 q 451 -230 429 -247 q 474 -182 474 -212 q 452 -136 474 -154 q 388 -118 431 -118 l 356 -118 l 389 8 l 449 8 l 428 -72 q 515 -108 485 -76 q 546 -185 546 -139 q 502 -273 546 -240 q 389 -306 458 -306 m 419 836 q 272 884 332 836 q 208 1015 211 932 l 278 1015 q 322 929 281 961 q 419 897 363 897 q 519 929 478 897 q 561 1015 560 961 l 631 1015 q 567 884 628 932 q 419 836 507 836 z "
  },
  ê: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 190 843 l 369 1015 l 469 1015 l 649 843 l 557 843 l 381 990 l 458 990 l 282 843 l 190 843 z "
  },
  ế: {
    ha: 839,
    x_min: 64,
    x_max: 835,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 z "
  },
  ệ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 419 -264 q 378 -247 396 -264 q 360 -204 360 -231 q 378 -161 360 -178 q 419 -144 396 -144 q 462 -161 444 -144 q 479 -204 479 -178 q 462 -247 479 -231 q 419 -264 444 -264 m 190 843 l 369 1015 l 469 1015 l 649 843 l 557 843 l 381 990 l 458 990 l 282 843 l 190 843 z "
  },
  ề: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 z "
  },
  ể: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 z "
  },
  ễ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 z "
  },
  ȅ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 489 843 l 332 1015 l 442 1015 l 576 843 l 489 843 m 263 843 l 107 1015 l 217 1015 l 350 843 l 263 843 z "
  },
  ë: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 543 875 q 501 892 519 875 q 483 935 483 908 q 501 978 483 961 q 543 994 519 994 q 585 978 568 994 q 603 935 603 961 q 585 892 603 908 q 543 875 568 875 m 296 875 q 253 892 271 875 q 236 935 236 908 q 253 978 236 961 q 296 994 271 994 q 338 978 319 994 q 356 935 356 961 q 338 892 356 908 q 296 875 319 875 z "
  },
  ė: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 419 875 q 372 894 392 875 q 353 942 353 914 q 372 990 353 971 q 419 1008 392 1008 q 467 990 447 1008 q 486 942 486 971 q 467 894 486 914 q 419 875 447 875 z "
  },
  ẹ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 419 -264 q 378 -247 396 -264 q 360 -204 360 -231 q 378 -161 360 -178 q 419 -144 396 -144 q 462 -161 444 -144 q 479 -204 479 -178 q 462 -247 479 -231 q 419 -264 444 -264 z "
  },
  è: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 413 843 l 188 1015 l 319 1015 l 510 843 l 413 843 z "
  },
  ẻ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 438 833 l 403 876 q 465 919 444 896 q 485 975 485 943 q 464 1024 485 1004 q 408 1043 443 1043 q 325 1017 365 1043 l 301 1065 q 356 1092 325 1083 q 417 1101 388 1101 q 512 1069 475 1101 q 549 982 549 1036 q 522 897 549 933 q 438 833 494 860 z "
  },
  ȇ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 208 843 q 272 974 211 926 q 419 1021 332 1021 q 567 974 507 1021 q 631 843 628 926 l 561 843 q 519 929 560 897 q 419 961 478 961 q 322 929 363 961 q 278 843 281 897 l 208 843 z "
  },
  ē: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 206 896 l 206 961 l 633 961 l 633 896 l 206 896 z "
  },
  ḗ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 z "
  },
  ḕ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 z "
  },
  ę: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 597 -306 q 487 -269 529 -306 q 444 -169 444 -232 q 470 -72 444 -125 q 563 35 496 -18 l 594 19 q 524 0 561 7 q 447 -7 488 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 705 88 718 99 q 676 63 692 76 q 577 -34 611 7 q 530 -106 543 -75 q 517 -164 517 -136 q 542 -225 517 -206 q 608 -244 568 -244 q 653 -237 631 -244 q 693 -218 676 -231 l 715 -272 q 660 -297 690 -287 q 597 -306 631 -306 z "
  },
  ẽ: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 447 -7 q 247 41 333 -7 q 113 173 161 89 q 64 365 64 257 q 110 557 64 474 q 238 688 157 640 q 421 736 319 736 q 603 690 524 736 q 729 559 683 643 q 775 365 775 475 q 774 351 775 358 q 774 335 774 343 l 139 335 l 139 408 l 721 408 l 682 379 q 648 520 682 458 q 556 617 614 582 q 421 651 497 651 q 286 617 346 651 q 193 519 226 582 q 160 376 160 457 l 160 361 q 197 215 160 278 q 299 116 233 151 q 450 81 365 81 q 574 104 517 81 q 674 176 632 128 l 729 113 q 608 24 681 54 q 447 -7 535 -7 m 514 851 q 457 865 482 851 q 412 898 432 879 q 372 931 392 917 q 332 946 353 946 q 281 922 300 946 q 260 857 263 899 l 200 857 q 237 968 203 926 q 325 1010 271 1010 q 383 995 357 1010 q 428 962 408 981 q 467 929 449 943 q 507 915 486 915 q 558 938 539 915 q 579 1001 578 961 l 639 1001 q 603 893 638 935 q 514 851 568 851 z "
  },
  ə: {
    ha: 839,
    x_min: 64,
    x_max: 775,
    o: "m 392 736 q 592 688 506 736 q 726 557 678 640 q 775 365 775 474 q 728 173 775 257 q 601 41 682 89 q 418 -7 521 -7 q 235 40 315 -7 q 110 172 156 88 q 64 365 64 256 q 65 379 64 371 q 65 394 65 388 l 700 394 l 700 321 l 118 321 l 157 350 q 191 210 157 272 q 283 113 225 149 q 418 78 342 78 q 553 113 494 78 q 646 211 613 149 q 679 353 679 274 l 679 369 q 642 515 679 453 q 540 614 606 578 q 389 650 475 650 q 264 626 321 650 q 165 553 207 603 l 110 618 q 233 706 160 676 q 392 736 306 736 z "
  },
  ʒ: {
    ha: 714,
    x_min: -31,
    x_max: 664,
    o: "m 314 -278 q 115 -242 207 -278 q -31 -150 22 -207 l 10 -69 q 135 -153 56 -121 q 311 -186 215 -186 q 498 -131 433 -186 q 563 17 563 -76 q 499 165 563 110 q 300 219 436 219 l 231 219 l 231 290 l 535 679 l 543 642 l 3 642 l 3 729 l 624 729 l 624 658 l 321 269 l 279 301 l 317 301 q 577 223 490 301 q 664 17 664 144 q 624 -133 664 -67 q 508 -238 585 -199 q 314 -278 431 -278 z "
  },
  ǯ: {
    ha: 714,
    x_min: -31,
    x_max: 664,
    o: "m 314 -278 q 115 -242 207 -278 q -31 -150 22 -207 l 10 -69 q 135 -153 56 -121 q 311 -186 215 -186 q 498 -131 433 -186 q 563 17 563 -76 q 499 165 563 110 q 300 219 436 219 l 231 219 l 231 290 l 535 679 l 543 642 l 3 642 l 3 729 l 624 729 l 624 658 l 321 269 l 279 301 l 317 301 q 577 223 490 301 q 664 17 664 144 q 624 -133 664 -67 q 508 -238 585 -199 q 314 -278 431 -278 m 257 843 l 78 1015 l 169 1015 l 346 869 l 268 869 l 444 1015 l 536 1015 l 357 843 l 257 843 z "
  },
  f: {
    ha: 471,
    x_min: 24,
    x_max: 521,
    o: "m 154 0 l 154 821 q 211 978 154 918 q 375 1038 268 1038 q 456 1026 417 1038 q 521 992 494 1015 l 488 918 q 439 945 467 936 q 379 954 411 954 q 283 919 317 954 q 250 817 250 885 l 250 706 l 253 660 l 253 0 l 154 0 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 z "
  },
  g: {
    ha: 951,
    x_min: 64,
    x_max: 814,
    o: "m 449 -276 q 257 -247 349 -276 q 108 -164 165 -218 l 158 -89 q 285 -162 210 -135 q 446 -189 361 -189 q 650 -124 585 -189 q 715 76 715 -60 l 715 258 l 729 383 l 719 508 l 719 729 l 814 729 l 814 89 q 722 -188 814 -100 q 449 -276 629 -276 m 431 28 q 243 73 326 28 q 112 199 160 118 q 64 383 64 279 q 112 567 64 488 q 243 692 160 647 q 431 736 326 736 q 606 696 528 736 q 729 576 683 656 q 775 383 775 497 q 729 190 775 269 q 606 69 683 111 q 431 28 528 28 m 440 115 q 583 149 521 115 q 682 244 646 183 q 718 383 718 304 q 682 522 718 463 q 583 616 646 582 q 440 650 521 650 q 298 616 361 650 q 199 522 235 582 q 164 383 164 463 q 199 244 164 304 q 298 149 235 183 q 440 115 361 115 z "
  },
  ğ: {
    ha: 951,
    x_min: 64,
    x_max: 814,
    o: "m 449 -276 q 257 -247 349 -276 q 108 -164 165 -218 l 158 -89 q 285 -162 210 -135 q 446 -189 361 -189 q 650 -124 585 -189 q 715 76 715 -60 l 715 258 l 729 383 l 719 508 l 719 729 l 814 729 l 814 89 q 722 -188 814 -100 q 449 -276 629 -276 m 431 28 q 243 73 326 28 q 112 199 160 118 q 64 383 64 279 q 112 567 64 488 q 243 692 160 647 q 431 736 326 736 q 606 696 528 736 q 729 576 683 656 q 775 383 775 497 q 729 190 775 269 q 606 69 683 111 q 431 28 528 28 m 440 115 q 583 149 521 115 q 682 244 646 183 q 718 383 718 304 q 682 522 718 463 q 583 616 646 582 q 440 650 521 650 q 298 616 361 650 q 199 522 235 582 q 164 383 164 463 q 199 244 164 304 q 298 149 235 183 q 440 115 361 115 m 451 836 q 303 884 364 836 q 240 1015 243 932 l 310 1015 q 353 929 313 961 q 451 897 394 897 q 551 929 510 897 q 593 1015 592 961 l 663 1015 q 599 884 660 932 q 451 836 539 836 z "
  },
  ǧ: {
    ha: 951,
    x_min: 64,
    x_max: 814,
    o: "m 449 -276 q 257 -247 349 -276 q 108 -164 165 -218 l 158 -89 q 285 -162 210 -135 q 446 -189 361 -189 q 650 -124 585 -189 q 715 76 715 -60 l 715 258 l 729 383 l 719 508 l 719 729 l 814 729 l 814 89 q 722 -188 814 -100 q 449 -276 629 -276 m 431 28 q 243 73 326 28 q 112 199 160 118 q 64 383 64 279 q 112 567 64 488 q 243 692 160 647 q 431 736 326 736 q 606 696 528 736 q 729 576 683 656 q 775 383 775 497 q 729 190 775 269 q 606 69 683 111 q 431 28 528 28 m 440 115 q 583 149 521 115 q 682 244 646 183 q 718 383 718 304 q 682 522 718 463 q 583 616 646 582 q 440 650 521 650 q 298 616 361 650 q 199 522 235 582 q 164 383 164 463 q 199 244 164 304 q 298 149 235 183 q 440 115 361 115 m 401 843 l 222 1015 l 314 1015 l 490 869 l 413 869 l 589 1015 l 681 1015 l 501 843 l 401 843 z "
  },
  ĝ: {
    ha: 951,
    x_min: 64,
    x_max: 814,
    o: "m 449 -276 q 257 -247 349 -276 q 108 -164 165 -218 l 158 -89 q 285 -162 210 -135 q 446 -189 361 -189 q 650 -124 585 -189 q 715 76 715 -60 l 715 258 l 729 383 l 719 508 l 719 729 l 814 729 l 814 89 q 722 -188 814 -100 q 449 -276 629 -276 m 431 28 q 243 73 326 28 q 112 199 160 118 q 64 383 64 279 q 112 567 64 488 q 243 692 160 647 q 431 736 326 736 q 606 696 528 736 q 729 576 683 656 q 775 383 775 497 q 729 190 775 269 q 606 69 683 111 q 431 28 528 28 m 440 115 q 583 149 521 115 q 682 244 646 183 q 718 383 718 304 q 682 522 718 463 q 583 616 646 582 q 440 650 521 650 q 298 616 361 650 q 199 522 235 582 q 164 383 164 463 q 199 244 164 304 q 298 149 235 183 q 440 115 361 115 m 222 843 l 401 1015 l 501 1015 l 681 843 l 589 843 l 413 990 l 490 990 l 314 843 l 222 843 z "
  },
  ģ: {
    ha: 951,
    x_min: 64,
    x_max: 814,
    o: "m 449 -276 q 257 -247 349 -276 q 108 -164 165 -218 l 158 -89 q 285 -162 210 -135 q 446 -189 361 -189 q 650 -124 585 -189 q 715 76 715 -60 l 715 258 l 729 383 l 719 508 l 719 729 l 814 729 l 814 89 q 722 -188 814 -100 q 449 -276 629 -276 m 431 28 q 243 73 326 28 q 112 199 160 118 q 64 383 64 279 q 112 567 64 488 q 243 692 160 647 q 431 736 326 736 q 606 696 528 736 q 729 576 683 656 q 775 383 775 497 q 729 190 775 269 q 606 69 683 111 q 431 28 528 28 m 440 115 q 583 149 521 115 q 682 244 646 183 q 718 383 718 304 q 682 522 718 463 q 583 616 646 582 q 440 650 521 650 q 298 616 361 650 q 199 522 235 582 q 164 383 164 463 q 199 244 164 304 q 298 149 235 183 q 440 115 361 115 m 451 836 q 404 853 421 836 q 388 890 388 869 q 392 918 388 904 q 403 950 396 932 l 451 1085 l 511 1085 l 463 906 l 451 944 q 498 930 481 944 q 515 890 515 915 q 499 852 515 868 q 451 836 482 836 z "
  },
  ġ: {
    ha: 951,
    x_min: 64,
    x_max: 814,
    o: "m 449 -276 q 257 -247 349 -276 q 108 -164 165 -218 l 158 -89 q 285 -162 210 -135 q 446 -189 361 -189 q 650 -124 585 -189 q 715 76 715 -60 l 715 258 l 729 383 l 719 508 l 719 729 l 814 729 l 814 89 q 722 -188 814 -100 q 449 -276 629 -276 m 431 28 q 243 73 326 28 q 112 199 160 118 q 64 383 64 279 q 112 567 64 488 q 243 692 160 647 q 431 736 326 736 q 606 696 528 736 q 729 576 683 656 q 775 383 775 497 q 729 190 775 269 q 606 69 683 111 q 431 28 528 28 m 440 115 q 583 149 521 115 q 682 244 646 183 q 718 383 718 304 q 682 522 718 463 q 583 616 646 582 q 440 650 521 650 q 298 616 361 650 q 199 522 235 582 q 164 383 164 463 q 199 244 164 304 q 298 149 235 183 q 440 115 361 115 m 451 875 q 404 894 424 875 q 385 942 385 914 q 404 990 385 971 q 451 1008 424 1008 q 499 990 479 1008 q 518 942 518 971 q 499 894 518 914 q 451 875 479 875 z "
  },
  ḡ: {
    ha: 951,
    x_min: 64,
    x_max: 814,
    o: "m 449 -276 q 257 -247 349 -276 q 108 -164 165 -218 l 158 -89 q 285 -162 210 -135 q 446 -189 361 -189 q 650 -124 585 -189 q 715 76 715 -60 l 715 258 l 729 383 l 719 508 l 719 729 l 814 729 l 814 89 q 722 -188 814 -100 q 449 -276 629 -276 m 431 28 q 243 73 326 28 q 112 199 160 118 q 64 383 64 279 q 112 567 64 488 q 243 692 160 647 q 431 736 326 736 q 606 696 528 736 q 729 576 683 656 q 775 383 775 497 q 729 190 775 269 q 606 69 683 111 q 431 28 528 28 m 440 115 q 583 149 521 115 q 682 244 646 183 q 718 383 718 304 q 682 522 718 463 q 583 616 646 582 q 440 650 521 650 q 298 616 361 650 q 199 522 235 582 q 164 383 164 463 q 199 244 164 304 q 298 149 235 183 q 440 115 361 115 m 238 896 l 238 961 l 665 961 l 665 896 l 238 896 z "
  },
  ǥ: {
    ha: 960,
    x_min: 64,
    x_max: 903,
    o: "m 449 -276 q 257 -247 349 -276 q 108 -164 165 -218 l 158 -89 q 285 -162 210 -135 q 446 -189 361 -189 q 650 -124 585 -189 q 715 76 715 -60 l 715 258 l 729 383 l 719 508 l 719 729 l 814 729 l 814 89 q 722 -188 814 -100 q 449 -276 629 -276 m 400 -86 l 400 -15 l 903 -15 l 903 -86 l 400 -86 m 431 49 q 243 92 326 49 q 112 214 160 136 q 64 393 64 292 q 112 573 64 496 q 243 693 160 650 q 431 736 326 736 q 606 697 528 736 q 729 581 683 657 q 775 393 775 504 q 729 205 775 282 q 606 88 683 128 q 431 49 528 49 m 440 132 q 583 165 521 132 q 682 258 646 199 q 718 393 718 317 q 682 529 718 471 q 583 620 646 588 q 440 653 521 653 q 298 620 361 653 q 199 529 235 588 q 164 393 164 471 q 199 258 164 317 q 298 165 235 199 q 440 132 361 132 z "
  },
  h: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 1031 l 236 1031 l 236 529 l 217 567 q 328 691 251 646 q 510 736 404 736 z "
  },
  ħ: {
    ha: 939,
    x_min: 0,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 1031 l 236 1031 l 236 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 0 843 l 0 915 l 542 915 l 542 843 l 0 843 z "
  },
  ḫ: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 1031 l 236 1031 l 236 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 472 -285 q 324 -239 385 -285 q 261 -117 264 -193 l 328 -117 q 371 -198 329 -168 q 472 -228 413 -228 q 575 -198 533 -228 q 617 -117 617 -168 l 683 -117 q 620 -239 681 -193 q 472 -285 560 -285 z "
  },
  ȟ: {
    ha: 939,
    x_min: -43,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 1031 l 236 1031 l 236 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 138 1144 l -42 1317 l 50 1317 l 226 1171 l 149 1171 l 325 1317 l 417 1317 l 238 1144 l 138 1144 z "
  },
  ĥ: {
    ha: 939,
    x_min: -43,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 1031 l 236 1031 l 236 529 l 217 567 q 328 691 251 646 q 510 736 404 736 z "
  },
  ḥ: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 1031 l 236 1031 l 236 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 472 -264 q 431 -247 449 -264 q 413 -204 413 -231 q 431 -161 413 -178 q 472 -144 449 -144 q 515 -161 497 -144 q 532 -204 532 -178 q 515 -247 532 -231 q 472 -264 497 -264 z "
  },
  i: {
    ha: 374,
    x_min: 115,
    x_max: 260,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 188 890 q 136 911 157 890 q 115 961 115 932 q 136 1010 115 990 q 188 1031 157 1031 q 239 1011 218 1031 q 260 963 260 992 q 240 911 260 932 q 188 890 219 890 z "
  },
  ı: {
    ha: 374,
    x_min: 138,
    x_max: 236,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 z "
  },
  í: {
    ha: 374,
    x_min: 96,
    x_max: 419,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 97 843 l 288 1015 l 419 1015 l 194 843 l 97 843 z "
  },
  ĭ: {
    ha: 374,
    x_min: 10,
    x_max: 364,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 188 836 q 62 884 113 836 q 11 1015 11 932 l 76 1015 q 107 929 76 961 q 188 897 138 897 q 268 929 238 897 q 299 1015 299 961 l 364 1015 q 314 884 364 932 q 188 836 264 836 z "
  },
  î: {
    ha: 374,
    x_min: -8,
    x_max: 382,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m -7 843 l 139 1015 l 236 1015 l 382 843 l 293 843 l 154 990 l 221 990 l 82 843 l -7 843 z "
  },
  ȉ: {
    ha: 374,
    x_min: -126,
    x_max: 344,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 257 843 l 100 1015 l 210 1015 l 344 843 l 257 843 m 31 843 l -125 1015 l -15 1015 l 118 843 l 31 843 z "
  },
  ï: {
    ha: 374,
    x_min: 38,
    x_max: 336,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 279 875 q 239 892 256 875 q 222 935 222 910 q 239 976 222 958 q 279 993 256 993 q 321 976 304 993 q 338 935 338 960 q 321 892 338 910 q 279 875 304 875 m 96 875 q 54 892 71 875 q 38 935 38 910 q 54 976 38 958 q 96 993 71 993 q 137 976 121 993 q 153 935 153 960 q 137 892 153 910 q 96 875 121 875 z "
  },
  ḯ: {
    ha: 374,
    x_min: 7,
    x_max: 390,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 z "
  },
  ị: {
    ha: 374,
    x_min: 115,
    x_max: 260,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 188 890 q 136 911 157 890 q 115 961 115 932 q 136 1010 115 990 q 188 1031 157 1031 q 239 1011 218 1031 q 260 963 260 992 q 240 911 260 932 q 188 890 219 890 m 188 -264 q 146 -247 164 -264 q 128 -204 128 -231 q 146 -161 128 -178 q 188 -144 164 -144 q 230 -161 213 -144 q 247 -204 247 -178 q 230 -247 247 -231 q 188 -264 213 -264 z "
  },
  ì: {
    ha: 374,
    x_min: -46,
    x_max: 278,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 181 843 l -44 1015 l 88 1015 l 278 843 l 181 843 z "
  },
  ỉ: {
    ha: 374,
    x_min: 68,
    x_max: 315,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 206 833 l 171 876 q 233 919 213 896 q 253 975 253 943 q 232 1024 253 1004 q 176 1043 211 1043 q 93 1017 133 1043 l 69 1065 q 124 1092 93 1083 q 185 1101 156 1101 q 280 1069 243 1101 q 317 982 317 1036 q 290 897 317 933 q 206 833 263 860 z "
  },
  ȋ: {
    ha: 374,
    x_min: 10,
    x_max: 364,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 11 843 q 62 974 11 926 q 188 1021 113 1021 q 314 974 264 1021 q 364 843 364 926 l 299 843 q 268 929 299 897 q 188 961 238 961 q 107 929 138 961 q 76 843 76 897 l 11 843 z "
  },
  ĳ: {
    ha: 756,
    x_min: 115,
    x_max: 640,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 188 890 q 136 911 157 890 q 115 961 115 932 q 136 1010 115 990 q 188 1031 157 1031 q 239 1011 218 1031 q 260 963 260 992 q 240 911 260 932 q 188 890 219 890 z "
  },
  ī: {
    ha: 374,
    x_min: 13,
    x_max: 361,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 13 896 l 13 961 l 363 961 l 363 896 l 13 896 z "
  },
  į: {
    ha: 374,
    x_min: 85,
    x_max: 290,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 188 890 q 136 911 157 890 q 115 961 115 932 q 136 1010 115 990 q 188 1031 157 1031 q 239 1011 218 1031 q 260 963 260 992 q 240 911 260 932 q 188 890 219 890 m 207 -306 q 117 -271 151 -306 q 83 -179 83 -236 q 108 -74 83 -131 q 200 38 133 -18 l 236 0 q 169 -94 183 -53 q 156 -169 156 -136 q 174 -226 156 -206 q 218 -246 193 -246 q 246 -240 233 -246 q 269 -226 258 -235 l 289 -276 q 207 -306 258 -306 z "
  },
  ĩ: {
    ha: 374,
    x_min: 3,
    x_max: 371,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 267 851 q 216 865 238 851 q 177 898 194 879 q 145 931 160 917 q 113 946 131 946 q 76 922 89 946 q 63 857 63 899 l 3 857 q 31 969 3 929 q 108 1010 60 1010 q 160 995 139 1010 q 198 963 181 981 q 230 931 215 944 q 263 917 244 917 q 299 940 286 917 q 313 1001 313 963 l 372 1001 q 344 892 372 932 q 267 851 317 851 z "
  },
  j: {
    ha: 381,
    x_min: -125,
    x_max: 267,
    o: "m 29 -276 q -56 -265 -15 -276 q -125 -229 -97 -253 l -90 -154 q 24 -192 -46 -192 q 113 -157 82 -192 q 144 -54 144 -122 l 144 729 l 243 729 l 243 -54 q 188 -216 243 -156 q 29 -276 133 -276 m 194 890 q 143 911 164 890 q 122 961 122 932 q 143 1010 122 990 q 194 1031 164 1031 q 246 1011 225 1031 q 267 963 267 992 q 247 911 267 932 q 194 890 226 890 z "
  },
  "ȷ": {
    ha: 381,
    x_min: -125,
    x_max: 243,
    o: "m 29 -276 q -56 -265 -15 -276 q -125 -229 -97 -253 l -90 -154 q 24 -192 -46 -192 q 113 -157 82 -192 q 144 -54 144 -122 l 144 729 l 243 729 l 243 -54 q 188 -216 243 -156 q 29 -276 133 -276 z "
  },
  ĵ: {
    ha: 381,
    x_min: -125,
    x_max: 389,
    o: "m 29 -276 q -56 -265 -15 -276 q -125 -229 -97 -253 l -90 -154 q 24 -192 -46 -192 q 113 -157 82 -192 q 144 -54 144 -122 l 144 729 l 243 729 l 243 -54 q 188 -216 243 -156 q 29 -276 133 -276 m 0 843 l 146 1015 l 243 1015 l 389 843 l 300 843 l 161 990 l 228 990 l 89 843 l 0 843 z "
  },
  k: {
    ha: 835,
    x_min: 138,
    x_max: 824,
    o: "m 215 189 l 218 315 l 672 729 l 793 729 l 472 422 l 417 375 l 215 189 m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m 703 0 l 399 379 l 463 456 l 824 0 l 703 0 z "
  },
  ǩ: {
    ha: 835,
    x_min: -43,
    x_max: 824,
    o: "m 215 189 l 218 315 l 672 729 l 793 729 l 472 422 l 417 375 l 215 189 m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m 703 0 l 399 379 l 463 456 l 824 0 l 703 0 m 138 1144 l -42 1317 l 50 1317 l 226 1171 l 149 1171 l 325 1317 l 417 1317 l 238 1144 l 138 1144 z "
  },
  ķ: {
    ha: 835,
    x_min: 138,
    x_max: 824,
    o: "m 215 189 l 218 315 l 672 729 l 793 729 l 472 422 l 417 375 l 215 189 m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m 703 0 l 399 379 l 463 456 l 824 0 l 703 0 m 383 -364 l 422 -214 l 432 -253 q 389 -237 406 -253 q 372 -199 372 -222 q 389 -160 372 -175 q 432 -144 406 -144 q 476 -160 460 -144 q 492 -199 492 -176 q 488 -228 492 -212 q 476 -261 485 -243 l 438 -364 l 383 -364 z "
  },
  ĸ: {
    ha: 819,
    x_min: 138,
    x_max: 824,
    o: "m 215 189 l 218 315 l 672 729 l 793 729 l 472 422 l 417 375 l 215 189 m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 703 0 l 399 379 l 463 456 l 824 0 l 703 0 z "
  },
  l: {
    ha: 374,
    x_min: 138,
    x_max: 236,
    o: "m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 z "
  },
  ĺ: {
    ha: 374,
    x_min: 96,
    x_max: 419,
    o: "m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m 97 1144 l 288 1317 l 419 1317 l 194 1144 l 97 1144 z "
  },
  ľ: {
    ha: 374,
    x_min: 138,
    x_max: 447,
    o: "m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m 364 808 l 364 1069 l 447 1069 l 435 808 l 364 808 z "
  },
  ļ: {
    ha: 374,
    x_min: 128,
    x_max: 247,
    o: "m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m 139 -364 l 178 -214 l 188 -253 q 144 -237 161 -253 q 128 -199 128 -222 q 144 -160 128 -175 q 188 -144 161 -144 q 231 -160 215 -144 q 247 -199 247 -176 q 244 -228 247 -212 q 232 -261 240 -243 l 193 -364 l 139 -364 z "
  },
  ŀ: {
    ha: 436,
    x_min: 138,
    x_max: 469,
    o: "m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m 404 428 q 358 447 376 428 q 339 493 339 467 q 358 539 339 519 q 404 558 376 558 q 451 539 432 558 q 469 493 469 519 q 451 447 469 467 q 404 428 432 428 z "
  },
  ḷ: {
    ha: 374,
    x_min: 128,
    x_max: 247,
    o: "m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m 188 -264 q 146 -247 164 -264 q 128 -204 128 -231 q 146 -161 128 -178 q 188 -144 164 -144 q 230 -161 213 -144 q 247 -204 247 -178 q 230 -247 247 -231 q 188 -264 213 -264 z "
  },
  ǉ: {
    ha: 756,
    x_min: 138,
    x_max: 640,
    o: "m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m 403 -276 q 317 -265 358 -276 q 249 -229 276 -253 l 283 -154 q 397 -192 328 -192 q 487 -157 456 -192 q 518 -54 518 -122 l 518 729 l 617 729 l 617 -54 q 562 -216 617 -156 q 403 -276 507 -276 m 568 890 q 517 911 538 890 q 496 961 496 932 q 517 1010 496 990 q 568 1031 538 1031 q 619 1011 599 1031 q 640 963 640 992 q 620 911 640 932 q 568 890 600 890 z "
  },
  ḻ: {
    ha: 374,
    x_min: -26,
    x_max: 401,
    o: "m 138 0 l 138 1031 l 236 1031 l 236 0 l 138 0 m -26 -235 l -26 -169 l 401 -169 l 401 -235 l -26 -235 z "
  },
  ł: {
    ha: 388,
    x_min: 4,
    x_max: 385,
    o: "m 144 0 l 144 1031 l 243 1031 l 243 0 l 144 0 m 49 338 l 3 397 l 339 650 l 383 589 l 49 338 z "
  },
  m: {
    ha: 1474,
    x_min: 138,
    x_max: 1343,
    o: "m 1049 736 q 1203 702 1138 736 q 1306 599 1269 668 q 1343 424 1343 529 l 1343 0 l 1244 0 l 1244 414 q 1190 588 1244 529 q 1035 647 1135 647 q 905 616 960 647 q 820 526 850 585 q 790 383 790 467 l 790 0 l 692 0 l 692 414 q 636 588 692 529 q 481 647 581 647 q 351 616 407 647 q 266 526 296 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 532 l 217 567 q 324 691 250 646 q 500 736 399 736 q 682 683 607 736 q 779 522 757 629 l 740 538 q 853 681 772 626 q 1049 736 935 736 z "
  },
  ṃ: {
    ha: 1474,
    x_min: 138,
    x_max: 1343,
    o: "m 1049 736 q 1203 702 1138 736 q 1306 599 1269 668 q 1343 424 1343 529 l 1343 0 l 1244 0 l 1244 414 q 1190 588 1244 529 q 1035 647 1135 647 q 905 616 960 647 q 820 526 850 585 q 790 383 790 467 l 790 0 l 692 0 l 692 414 q 636 588 692 529 q 481 647 581 647 q 351 616 407 647 q 266 526 296 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 532 l 217 567 q 324 691 250 646 q 500 736 399 736 q 682 683 607 736 q 779 522 757 629 l 740 538 q 853 681 772 626 q 1049 736 935 736 m 739 -264 q 697 -247 715 -264 q 679 -204 679 -231 q 697 -161 679 -178 q 739 -144 715 -144 q 781 -161 764 -144 q 799 -204 799 -178 q 781 -247 799 -231 q 739 -264 764 -264 z "
  },
  n: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 z "
  },
  ń: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 382 843 l 572 1015 l 704 1015 l 479 843 l 382 843 z "
  },
  ŉ: {
    ha: 1001,
    x_min: 32,
    x_max: 871,
    o: "m 572 736 q 728 702 661 736 q 834 599 796 668 q 872 424 872 529 l 872 0 l 774 0 l 774 414 q 716 588 774 529 q 554 647 658 647 q 419 616 476 647 q 330 526 361 585 q 299 383 299 467 l 299 0 l 200 0 l 200 729 l 294 729 l 294 529 l 279 567 q 390 691 314 646 q 572 736 467 736 z "
  },
  ň: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 422 843 l 243 1015 l 335 1015 l 511 869 l 433 869 l 610 1015 l 701 1015 l 522 843 l 422 843 z "
  },
  ņ: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 424 -364 l 463 -214 l 472 -253 q 429 -237 446 -253 q 413 -199 413 -222 q 429 -160 413 -175 q 472 -144 446 -144 q 516 -160 500 -144 q 532 -199 532 -176 q 528 -228 532 -212 q 517 -261 525 -243 l 478 -364 l 424 -364 z "
  },
  ṅ: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 472 875 q 425 894 444 875 q 406 942 406 914 q 425 990 406 971 q 472 1008 444 1008 q 519 990 500 1008 q 539 942 539 971 q 519 894 539 914 q 472 875 500 875 z "
  },
  ṇ: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 472 -264 q 431 -247 449 -264 q 413 -204 413 -231 q 431 -161 413 -178 q 472 -144 449 -144 q 515 -161 497 -144 q 532 -204 532 -178 q 515 -247 532 -231 q 472 -264 497 -264 z "
  },
  ŋ: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 -54 q 754 -216 810 -156 q 596 -276 699 -276 q 510 -265 551 -276 q 442 -229 468 -253 l 476 -154 q 590 -192 519 -192 q 680 -157 649 -192 q 711 -54 711 -122 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 z "
  },
  ǌ: {
    ha: 1321,
    x_min: 138,
    x_max: 1206,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 968 -276 q 883 -265 924 -276 q 814 -229 842 -253 l 849 -154 q 963 -192 893 -192 q 1052 -157 1021 -192 q 1083 -54 1083 -122 l 1083 729 l 1182 729 l 1182 -54 q 1127 -216 1182 -156 q 968 -276 1072 -276 m 1133 890 q 1082 911 1103 890 q 1061 961 1061 932 q 1082 1010 1061 990 q 1133 1031 1103 1031 q 1185 1011 1164 1031 q 1206 963 1206 992 q 1185 911 1206 932 q 1133 890 1165 890 z "
  },
  ṉ: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 258 -235 l 258 -169 l 686 -169 l 686 -235 l 258 -235 z "
  },
  ñ: {
    ha: 939,
    x_min: 138,
    x_max: 810,
    o: "m 510 736 q 666 702 599 736 q 772 599 733 668 q 810 424 810 529 l 810 0 l 711 0 l 711 414 q 653 588 711 529 q 492 647 596 647 q 356 616 414 647 q 267 526 299 585 q 236 383 236 467 l 236 0 l 138 0 l 138 729 l 232 729 l 232 529 l 217 567 q 328 691 251 646 q 510 736 404 736 m 567 851 q 510 865 535 851 q 465 898 485 879 q 425 931 444 917 q 385 946 406 946 q 334 922 353 946 q 313 857 315 899 l 253 857 q 290 968 256 926 q 378 1010 324 1010 q 435 995 410 1010 q 481 962 461 981 q 520 929 501 943 q 560 915 539 915 q 611 938 592 915 q 632 1001 631 961 l 692 1001 q 656 893 690 935 q 567 851 621 851 z "
  },
  o: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ó: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 344 843 l 535 1015 l 667 1015 l 442 843 l 344 843 z "
  },
  ŏ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 435 836 q 287 884 347 836 q 224 1015 226 932 l 293 1015 q 337 929 296 961 q 435 897 378 897 q 534 929 493 897 q 576 1015 575 961 l 646 1015 q 583 884 643 932 q 435 836 522 836 z "
  },
  ô: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 206 843 l 385 1015 l 485 1015 l 664 843 l 572 843 l 396 990 l 474 990 l 297 843 l 206 843 z "
  },
  ố: {
    ha: 871,
    x_min: 64,
    x_max: 850,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ộ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 435 -264 q 393 -247 411 -264 q 375 -204 375 -231 q 393 -161 375 -178 q 435 -144 411 -144 q 477 -161 460 -144 q 494 -204 494 -178 q 477 -247 494 -231 q 435 -264 460 -264 m 206 843 l 385 1015 l 485 1015 l 664 843 l 572 843 l 396 990 l 474 990 l 297 843 l 206 843 z "
  },
  ồ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ổ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ỗ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ȍ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 504 843 l 347 1015 l 457 1015 l 592 843 l 504 843 m 278 843 l 122 1015 l 232 1015 l 365 843 l 278 843 z "
  },
  ö: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 558 875 q 517 892 535 875 q 499 935 499 908 q 517 978 499 961 q 558 994 535 994 q 601 978 583 994 q 618 935 618 961 q 601 892 618 908 q 558 875 583 875 m 311 875 q 269 892 286 875 q 251 935 251 908 q 269 978 251 961 q 311 994 286 994 q 353 978 335 994 q 371 935 371 961 q 353 892 371 908 q 311 875 335 875 z "
  },
  ȫ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ȱ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ọ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 435 -264 q 393 -247 411 -264 q 375 -204 375 -231 q 393 -161 375 -178 q 435 -144 411 -144 q 477 -161 460 -144 q 494 -204 494 -178 q 477 -247 494 -231 q 435 -264 460 -264 z "
  },
  ò: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 428 843 l 203 1015 l 335 1015 l 525 843 l 428 843 z "
  },
  ỏ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 453 833 l 418 876 q 480 919 460 896 q 500 975 500 943 q 479 1024 500 1004 q 424 1043 458 1043 q 340 1017 381 1043 l 317 1065 q 372 1092 340 1083 q 432 1101 403 1101 q 527 1069 490 1101 q 564 982 564 1036 q 537 897 564 933 q 453 833 510 860 z "
  },
  ơ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 244 41 328 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 245 688 161 640 q 436 736 329 736 q 499 735 474 736 q 551 731 525 733 q 608 728 576 728 q 694 757 667 728 q 721 825 721 786 q 713 873 721 851 q 693 914 704 894 l 757 939 q 783 885 774 915 q 793 822 793 854 q 772 738 793 775 q 708 681 750 701 q 603 660 665 660 q 566 662 585 660 q 524 667 547 664 l 572 713 q 742 583 678 675 q 807 365 807 490 q 759 173 807 257 q 627 41 711 89 q 435 -7 543 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 435 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ớ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 244 41 328 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 245 688 161 640 q 436 736 329 736 q 499 735 474 736 q 551 731 525 733 q 608 728 576 728 q 694 757 667 728 q 721 825 721 786 q 713 873 721 851 q 693 914 704 894 l 757 939 q 783 885 774 915 q 793 822 793 854 q 772 738 793 775 q 708 681 750 701 q 603 660 665 660 q 566 662 585 660 q 524 667 547 664 l 572 713 q 742 583 678 675 q 807 365 807 490 q 759 173 807 257 q 627 41 711 89 q 435 -7 543 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 435 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 344 843 l 535 1015 l 667 1015 l 442 843 l 344 843 z "
  },
  ợ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 244 41 328 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 245 688 161 640 q 436 736 329 736 q 499 735 474 736 q 551 731 525 733 q 608 728 576 728 q 694 757 667 728 q 721 825 721 786 q 713 873 721 851 q 693 914 704 894 l 757 939 q 783 885 774 915 q 793 822 793 854 q 772 738 793 775 q 708 681 750 701 q 603 660 665 660 q 566 662 585 660 q 524 667 547 664 l 572 713 q 742 583 678 675 q 807 365 807 490 q 759 173 807 257 q 627 41 711 89 q 435 -7 543 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 435 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 435 -264 q 393 -247 411 -264 q 375 -204 375 -231 q 393 -161 375 -178 q 435 -144 411 -144 q 477 -161 460 -144 q 494 -204 494 -178 q 477 -247 494 -231 q 435 -264 460 -264 z "
  },
  ờ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 244 41 328 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 245 688 161 640 q 436 736 329 736 q 499 735 474 736 q 551 731 525 733 q 608 728 576 728 q 694 757 667 728 q 721 825 721 786 q 713 873 721 851 q 693 914 704 894 l 757 939 q 783 885 774 915 q 793 822 793 854 q 772 738 793 775 q 708 681 750 701 q 603 660 665 660 q 566 662 585 660 q 524 667 547 664 l 572 713 q 742 583 678 675 q 807 365 807 490 q 759 173 807 257 q 627 41 711 89 q 435 -7 543 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 435 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 428 843 l 203 1015 l 335 1015 l 525 843 l 428 843 z "
  },
  ở: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 244 41 328 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 245 688 161 640 q 436 736 329 736 q 499 735 474 736 q 551 731 525 733 q 608 728 576 728 q 694 757 667 728 q 721 825 721 786 q 713 873 721 851 q 693 914 704 894 l 757 939 q 783 885 774 915 q 793 822 793 854 q 772 738 793 775 q 708 681 750 701 q 603 660 665 660 q 566 662 585 660 q 524 667 547 664 l 572 713 q 742 583 678 675 q 807 365 807 490 q 759 173 807 257 q 627 41 711 89 q 435 -7 543 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 435 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 453 833 l 418 876 q 480 919 460 896 q 500 975 500 943 q 479 1024 500 1004 q 424 1043 458 1043 q 340 1017 381 1043 l 317 1065 q 372 1092 340 1083 q 432 1101 403 1101 q 527 1069 490 1101 q 564 982 564 1036 q 537 897 564 933 q 453 833 510 860 z "
  },
  ỡ: {
    ha: 876,
    x_min: 64,
    x_max: 807,
    o: "m 526 851 q 472 865 496 851 q 429 898 449 879 q 392 931 410 917 q 353 946 374 946 q 306 922 324 946 q 286 857 288 899 l 231 857 q 264 968 232 926 q 349 1010 296 1010 q 401 995 378 1010 q 444 962 425 981 q 482 929 464 943 q 519 915 500 915 q 569 938 550 915 q 589 1001 588 961 l 644 1001 q 610 893 642 935 q 526 851 578 851 m 435 -7 q 244 41 328 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 245 688 161 640 q 436 736 329 736 q 499 735 474 736 q 551 731 525 733 q 608 728 576 728 q 694 757 667 728 q 721 825 721 786 q 713 873 721 851 q 693 914 704 894 l 757 939 q 783 885 774 915 q 793 822 793 854 q 772 738 793 775 q 708 681 750 701 q 603 660 665 660 q 566 662 585 660 q 524 667 547 664 l 572 713 q 742 583 678 675 q 807 365 807 490 q 759 173 807 257 q 627 41 711 89 q 435 -7 543 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 435 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ő: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 504 843 l 638 1015 l 747 1015 l 592 843 l 504 843 m 278 843 l 413 1015 l 522 1015 l 365 843 l 278 843 z "
  },
  ȏ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 224 843 q 287 974 226 926 q 435 1021 347 1021 q 583 974 522 1021 q 646 843 643 926 l 576 843 q 534 929 575 897 q 435 961 493 961 q 337 929 378 961 q 293 843 296 897 l 224 843 z "
  },
  ō: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 221 896 l 221 961 l 649 961 l 649 896 l 221 896 z "
  },
  ṓ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ṑ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ǫ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 475 -306 q 364 -269 406 -306 q 322 -176 322 -233 q 339 -103 322 -140 q 397 -29 356 -65 q 511 38 439 7 l 513 0 q 470 -6 488 -4 q 435 -7 453 -7 q 244 41 328 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 688 161 640 q 435 736 328 736 q 627 688 543 736 q 759 558 711 640 q 807 365 807 475 q 749 157 807 246 q 592 24 690 68 q 467 -47 508 -14 q 410 -110 425 -81 q 396 -167 396 -139 q 422 -225 396 -206 q 486 -244 447 -244 q 531 -237 508 -244 q 571 -218 554 -231 l 593 -272 q 539 -297 569 -287 q 475 -306 508 -306 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 435 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ø: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 93 -99 l 708 825 l 774 825 l 160 -99 l 93 -99 z "
  },
  ǿ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 93 -99 l 708 825 l 774 825 l 160 -99 l 93 -99 m 343 843 l 533 1015 l 665 1015 l 440 843 l 343 843 z "
  },
  õ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 529 851 q 472 865 497 851 q 427 898 447 879 q 388 931 407 917 q 347 946 368 946 q 297 922 315 946 q 275 857 278 899 l 215 857 q 252 968 218 926 q 340 1010 286 1010 q 398 995 372 1010 q 444 962 424 981 q 483 929 464 943 q 522 915 501 915 q 574 938 554 915 q 594 1001 593 961 l 654 1001 q 618 893 653 935 q 529 851 583 851 z "
  },
  ṍ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ṏ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  ȭ: {
    ha: 871,
    x_min: 64,
    x_max: 807,
    o: "m 435 -7 q 245 41 329 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 689 161 642 q 435 736 328 736 q 627 689 543 736 q 759 558 711 642 q 807 365 807 475 q 759 173 807 257 q 626 41 711 89 q 435 -7 542 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 436 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 z "
  },
  œ: {
    ha: 1483,
    x_min: 64,
    x_max: 1419,
    o: "m 435 -7 q 244 41 328 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 244 688 161 640 q 435 736 328 736 q 624 688 543 736 q 751 558 706 640 q 797 365 797 475 q 751 173 797 257 q 624 41 706 89 q 435 -7 543 -7 m 435 81 q 575 116 514 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 575 615 636 579 q 435 650 514 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 1092 -7 q 894 41 979 -7 q 761 173 808 89 q 714 365 714 257 q 759 557 714 474 q 883 688 804 640 q 1065 736 963 736 q 1248 690 1168 736 q 1374 559 1328 643 q 1419 365 1419 475 q 1419 351 1419 358 q 1418 335 1418 343 l 783 335 l 783 408 l 1365 408 l 1326 379 q 1292 520 1326 458 q 1200 617 1258 582 q 1065 651 1142 651 q 931 617 989 651 q 838 519 872 582 q 804 376 804 457 l 804 361 q 841 215 804 278 q 944 116 878 151 q 1094 81 1010 81 q 1219 104 1161 81 q 1317 176 1276 128 l 1372 113 q 1251 24 1324 54 q 1092 -7 1179 -7 z "
  },
  p: {
    ha: 942,
    x_min: 138,
    x_max: 878,
    o: "m 514 -7 q 343 37 419 -7 q 222 163 267 81 q 176 365 176 246 q 221 567 176 485 q 342 693 265 650 q 514 736 418 736 q 701 690 618 736 q 831 559 783 643 q 878 365 878 475 q 831 171 878 254 q 701 40 783 88 q 514 -7 618 -7 m 138 -269 l 138 729 l 232 729 l 232 510 l 222 364 l 236 217 l 236 -269 l 138 -269 m 507 81 q 646 116 585 81 q 743 216 707 151 q 779 365 779 281 q 743 514 779 450 q 646 614 707 578 q 507 650 585 650 q 367 614 429 650 q 270 514 306 578 q 235 365 235 450 q 270 216 235 281 q 367 116 306 151 q 507 81 429 81 z "
  },
  þ: {
    ha: 942,
    x_min: 138,
    x_max: 878,
    o: "m 514 -7 q 343 37 419 -7 q 222 163 267 81 q 176 365 176 246 q 221 567 176 485 q 342 693 265 650 q 514 736 418 736 q 701 690 618 736 q 831 559 783 643 q 878 365 878 475 q 831 171 878 254 q 701 40 783 88 q 514 -7 618 -7 m 138 -269 l 138 1031 l 236 1031 l 236 510 l 222 364 l 236 217 l 236 -269 l 138 -269 m 507 81 q 646 116 585 81 q 743 216 707 151 q 779 365 779 281 q 743 514 779 450 q 646 614 707 578 q 507 650 585 650 q 367 614 429 650 q 270 514 306 578 q 235 365 235 450 q 270 216 235 281 q 367 116 306 151 q 507 81 429 81 z "
  },
  q: {
    ha: 942,
    x_min: 64,
    x_max: 804,
    o: "m 428 -7 q 241 40 324 -7 q 111 171 158 88 q 64 365 64 254 q 111 559 64 475 q 241 690 158 643 q 428 736 324 736 q 601 693 525 736 q 721 567 676 650 q 765 365 765 485 q 720 163 765 246 q 599 37 675 81 q 428 -7 524 -7 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 514 707 450 q 574 614 636 578 q 435 650 513 650 q 297 614 358 650 q 200 514 236 578 q 164 365 164 450 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 706 -269 l 706 217 l 719 364 l 710 510 l 710 729 l 804 729 l 804 -269 l 706 -269 z "
  },
  r: {
    ha: 557,
    x_min: 138,
    x_max: 504,
    o: "m 138 0 l 138 729 l 232 729 l 232 531 l 222 565 q 325 692 253 649 q 504 736 397 736 l 504 640 q 493 641 499 640 q 482 642 488 642 q 301 572 367 642 q 236 372 236 501 l 236 0 l 138 0 z "
  },
  ŕ: {
    ha: 557,
    x_min: 138,
    x_max: 554,
    o: "m 138 0 l 138 729 l 232 729 l 232 531 l 222 565 q 325 692 253 649 q 504 736 397 736 l 504 640 q 493 641 499 640 q 482 642 488 642 q 301 572 367 642 q 236 372 236 501 l 236 0 l 138 0 m 232 843 l 422 1015 l 554 1015 l 329 843 l 232 843 z "
  },
  ř: {
    ha: 557,
    x_min: 92,
    x_max: 551,
    o: "m 138 0 l 138 729 l 232 729 l 232 531 l 222 565 q 325 692 253 649 q 504 736 397 736 l 504 640 q 493 641 499 640 q 482 642 488 642 q 301 572 367 642 q 236 372 236 501 l 236 0 l 138 0 m 272 843 l 93 1015 l 185 1015 l 361 869 l 283 869 l 460 1015 l 551 1015 l 372 843 l 272 843 z "
  },
  ŗ: {
    ha: 557,
    x_min: 128,
    x_max: 504,
    o: "m 138 0 l 138 729 l 232 729 l 232 531 l 222 565 q 325 692 253 649 q 504 736 397 736 l 504 640 q 493 641 499 640 q 482 642 488 642 q 301 572 367 642 q 236 372 236 501 l 236 0 l 138 0 m 139 -364 l 178 -214 l 188 -253 q 144 -237 161 -253 q 128 -199 128 -222 q 144 -160 128 -175 q 188 -144 161 -144 q 231 -160 215 -144 q 247 -199 247 -176 q 244 -228 247 -212 q 232 -261 240 -243 l 193 -364 l 139 -364 z "
  },
  ȑ: {
    ha: 557,
    x_min: 8,
    x_max: 504,
    o: "m 138 0 l 138 729 l 232 729 l 232 531 l 222 565 q 325 692 253 649 q 504 736 397 736 l 504 640 q 493 641 499 640 q 482 642 488 642 q 301 572 367 642 q 236 372 236 501 l 236 0 l 138 0 m 392 843 l 235 1015 l 344 1015 l 479 843 l 392 843 m 165 843 l 10 1015 l 119 1015 l 253 843 l 165 843 z "
  },
  ṛ: {
    ha: 557,
    x_min: 128,
    x_max: 504,
    o: "m 138 0 l 138 729 l 232 729 l 232 531 l 222 565 q 325 692 253 649 q 504 736 397 736 l 504 640 q 493 641 499 640 q 482 642 488 642 q 301 572 367 642 q 236 372 236 501 l 236 0 l 138 0 m 188 -264 q 146 -247 164 -264 q 128 -204 128 -231 q 146 -161 128 -178 q 188 -144 164 -144 q 230 -161 213 -144 q 247 -204 247 -178 q 230 -247 247 -231 q 188 -264 213 -264 z "
  },
  ȓ: {
    ha: 557,
    x_min: 110,
    x_max: 533,
    o: "m 138 0 l 138 729 l 232 729 l 232 531 l 222 565 q 325 692 253 649 q 504 736 397 736 l 504 640 q 493 641 499 640 q 482 642 488 642 q 301 572 367 642 q 236 372 236 501 l 236 0 l 138 0 m 111 843 q 174 974 114 926 q 322 1021 235 1021 q 470 974 410 1021 q 533 843 531 926 l 464 843 q 422 929 463 897 q 322 961 381 961 q 224 929 265 961 q 181 843 183 897 l 111 843 z "
  },
  ṟ: {
    ha: 557,
    x_min: -26,
    x_max: 504,
    o: "m 138 0 l 138 729 l 232 729 l 232 531 l 222 565 q 325 692 253 649 q 504 736 397 736 l 504 640 q 493 641 499 640 q 482 642 488 642 q 301 572 367 642 q 236 372 236 501 l 236 0 l 138 0 m -26 -235 l -26 -169 l 401 -169 l 401 -235 l -26 -235 z "
  },
  s: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 z "
  },
  ś: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 m 247 843 l 438 1015 l 569 1015 l 344 843 l 247 843 z "
  },
  ṥ: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 z "
  },
  "ꞌ": {
    ha: 333,
    x_min: 117,
    x_max: 217,
    o: "m 117 413 l 118 906 l 217 906 l 204 413 l 117 413 z "
  },
  š: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 m 288 843 l 108 1015 l 200 1015 l 376 869 l 299 869 l 475 1015 l 567 1015 l 388 843 l 288 843 z "
  },
  ṧ: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 z "
  },
  ş: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 m 307 -306 q 244 -297 272 -306 q 190 -274 215 -289 l 214 -221 q 258 -240 235 -233 q 306 -247 281 -247 q 369 -230 347 -247 q 392 -182 392 -212 q 370 -136 392 -154 q 306 -118 349 -118 l 274 -118 l 307 8 l 367 8 l 346 -72 q 433 -108 403 -76 q 464 -185 464 -139 q 420 -273 464 -240 q 307 -306 376 -306 z "
  },
  ŝ: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 m 108 843 l 288 1015 l 388 1015 l 567 843 l 475 843 l 299 990 l 376 990 l 200 843 l 108 843 z "
  },
  ș: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 m 289 -364 l 328 -214 l 338 -253 q 294 -237 311 -253 q 278 -199 278 -222 q 294 -160 278 -175 q 338 -144 311 -144 q 381 -160 365 -144 q 397 -199 397 -176 q 394 -228 397 -212 q 382 -261 390 -243 l 343 -364 l 289 -364 z "
  },
  ṡ: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 m 338 875 q 290 894 310 875 q 271 942 271 914 q 290 990 271 971 q 338 1008 310 1008 q 385 990 365 1008 q 404 942 404 971 q 385 894 404 914 q 338 875 365 875 z "
  },
  ṣ: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 m 338 -264 q 296 -247 314 -264 q 278 -204 278 -231 q 296 -161 278 -178 q 338 -144 314 -144 q 380 -161 363 -144 q 397 -204 397 -178 q 380 -247 397 -231 q 338 -264 363 -264 z "
  },
  ṩ: {
    ha: 678,
    x_min: 36,
    x_max: 635,
    o: "m 333 -7 q 163 19 243 -7 q 36 83 82 44 l 81 161 q 194 103 125 128 q 340 79 264 79 q 490 112 444 79 q 536 199 536 144 q 510 262 536 239 q 443 297 485 285 q 350 317 401 308 q 248 336 299 325 q 156 369 197 347 q 88 428 114 390 q 63 528 63 465 q 96 635 63 588 q 194 709 129 682 q 351 736 258 736 q 493 717 422 736 q 610 668 564 699 l 567 589 q 463 637 518 622 q 351 651 407 651 q 206 617 253 651 q 160 531 160 583 q 185 465 160 489 q 253 428 211 442 q 347 407 296 415 q 448 387 397 399 q 541 355 499 375 q 609 298 583 335 q 635 201 635 261 q 599 91 635 138 q 497 19 564 44 q 333 -7 429 -7 m 338 -264 q 296 -247 314 -264 q 278 -204 278 -231 q 296 -161 278 -178 q 338 -144 314 -144 q 380 -161 363 -144 q 397 -204 397 -178 q 380 -247 397 -231 q 338 -264 363 -264 m 338 875 q 290 894 310 875 q 271 942 271 914 q 290 990 271 971 q 338 1008 310 1008 q 385 990 365 1008 q 404 942 404 971 q 385 894 404 914 q 338 875 365 875 z "
  },
  ß: {
    ha: 928,
    x_min: 138,
    x_max: 864,
    o: "m 535 -7 q 453 -1 494 -7 q 378 15 411 4 l 396 99 q 457 84 425 89 q 531 79 489 79 q 652 103 600 79 q 734 172 704 126 q 764 279 764 217 q 697 425 764 374 q 521 476 629 476 l 440 476 l 440 561 q 621 618 556 563 q 686 768 686 674 q 630 901 686 850 q 472 951 574 951 q 300 888 364 951 q 236 700 236 825 l 236 0 l 138 0 l 138 692 q 181 883 138 807 q 299 999 224 960 q 472 1038 375 1038 q 638 1003 568 1038 q 744 908 707 968 q 782 772 782 849 q 758 660 782 710 q 696 577 735 611 q 609 525 657 543 q 514 507 561 507 l 553 549 q 712 517 642 549 q 823 424 782 485 q 864 276 864 364 q 821 124 864 188 q 703 27 778 61 q 535 -7 629 -7 z "
  },
  ſ: {
    ha: 410,
    x_min: 39,
    x_max: 535,
    o: "m 169 0 l 169 821 q 226 978 169 918 q 389 1038 283 1038 q 469 1026 431 1038 q 535 992 508 1015 l 501 918 q 453 945 481 936 q 394 954 425 954 q 300 919 332 954 q 268 817 268 885 l 268 0 l 169 0 m 39 647 l 39 729 l 221 729 l 221 647 l 39 647 z "
  },
  t: {
    ha: 564,
    x_min: 24,
    x_max: 522,
    o: "m 368 -7 q 210 49 265 -7 q 154 206 154 104 l 154 890 l 253 890 l 253 211 q 285 113 253 147 q 379 78 318 78 q 488 115 444 78 l 522 44 q 452 6 493 18 q 368 -7 411 -7 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 z "
  },
  ŧ: {
    ha: 578,
    x_min: 31,
    x_max: 529,
    o: "m 375 -7 q 217 49 272 -7 q 161 206 161 104 l 161 890 l 260 890 l 260 211 q 292 113 260 147 q 386 78 325 78 q 494 115 451 78 l 529 44 q 459 6 500 18 q 375 -7 418 -7 m 31 647 l 31 729 l 482 729 l 482 647 l 31 647 m 47 374 l 47 444 l 467 444 l 467 374 l 47 374 z "
  },
  ť: {
    ha: 564,
    x_min: 24,
    x_max: 522,
    o: "m 368 -7 q 210 49 265 -7 q 154 206 154 104 l 154 890 l 253 890 l 253 211 q 285 113 253 147 q 379 78 318 78 q 488 115 444 78 l 522 44 q 452 6 493 18 q 368 -7 411 -7 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 m 379 831 l 379 1061 l 458 1061 l 446 831 l 379 831 z "
  },
  ţ: {
    ha: 564,
    x_min: 24,
    x_max: 522,
    o: "m 368 -7 q 210 49 265 -7 q 154 206 154 104 l 154 890 l 253 890 l 253 211 q 285 113 253 147 q 379 78 318 78 q 488 115 444 78 l 522 44 q 452 6 493 18 q 368 -7 411 -7 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 m 315 -306 q 252 -297 281 -306 q 199 -274 224 -289 l 222 -221 q 266 -240 243 -233 q 314 -247 289 -247 q 378 -230 356 -247 q 400 -182 400 -212 q 378 -136 400 -154 q 314 -118 357 -118 l 282 -118 l 315 8 l 375 8 l 354 -72 q 442 -108 411 -76 q 472 -185 472 -139 q 428 -273 472 -240 q 315 -306 385 -306 z "
  },
  ț: {
    ha: 564,
    x_min: 24,
    x_max: 522,
    o: "m 368 -7 q 210 49 265 -7 q 154 206 154 104 l 154 890 l 253 890 l 253 211 q 285 113 253 147 q 379 78 318 78 q 488 115 444 78 l 522 44 q 452 6 493 18 q 368 -7 411 -7 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 m 297 -364 l 336 -214 l 346 -253 q 303 -237 319 -253 q 286 -199 286 -222 q 303 -160 286 -175 q 346 -144 319 -144 q 390 -160 374 -144 q 406 -199 406 -176 q 402 -228 406 -212 q 390 -261 399 -243 l 351 -364 l 297 -364 z "
  },
  ẗ: {
    ha: 564,
    x_min: 19,
    x_max: 522,
    o: "m 368 -7 q 210 49 265 -7 q 154 206 154 104 l 154 890 l 253 890 l 253 211 q 285 113 253 147 q 379 78 318 78 q 488 115 444 78 l 522 44 q 452 6 493 18 q 368 -7 411 -7 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 m 328 1035 q 286 1051 304 1035 q 268 1094 268 1068 q 286 1138 268 1121 q 328 1154 304 1154 q 370 1138 353 1154 q 388 1094 388 1121 q 370 1051 388 1068 q 328 1035 353 1035 m 81 1035 q 38 1051 56 1035 q 21 1094 21 1068 q 38 1138 21 1121 q 81 1154 56 1154 q 122 1138 104 1154 q 140 1094 140 1121 q 122 1051 140 1068 q 81 1035 104 1035 z "
  },
  ṭ: {
    ha: 564,
    x_min: 24,
    x_max: 522,
    o: "m 368 -7 q 210 49 265 -7 q 154 206 154 104 l 154 890 l 253 890 l 253 211 q 285 113 253 147 q 379 78 318 78 q 488 115 444 78 l 522 44 q 452 6 493 18 q 368 -7 411 -7 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 m 346 -264 q 304 -247 322 -264 q 286 -204 286 -231 q 304 -161 286 -178 q 346 -144 322 -144 q 388 -161 371 -144 q 406 -204 406 -178 q 388 -247 406 -231 q 346 -264 371 -264 z "
  },
  ṯ: {
    ha: 564,
    x_min: 24,
    x_max: 560,
    o: "m 368 -7 q 210 49 265 -7 q 154 206 154 104 l 154 890 l 253 890 l 253 211 q 285 113 253 147 q 379 78 318 78 q 488 115 444 78 l 522 44 q 452 6 493 18 q 368 -7 411 -7 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 m 132 -235 l 132 -169 l 560 -169 l 560 -235 l 132 -235 z "
  },
  u: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 z "
  },
  ú: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 374 843 l 564 1015 l 696 1015 l 471 843 l 374 843 z "
  },
  ŭ: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 464 836 q 316 884 376 836 q 253 1015 256 932 l 322 1015 q 366 929 325 961 q 464 897 407 897 q 563 929 522 897 q 606 1015 604 961 l 675 1015 q 612 884 672 932 q 464 836 551 836 z "
  },
  ǔ: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 414 843 l 235 1015 l 326 1015 l 503 869 l 425 869 l 601 1015 l 693 1015 l 514 843 l 414 843 z "
  },
  û: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 235 843 l 414 1015 l 514 1015 l 693 843 l 601 843 l 425 990 l 503 990 l 326 843 l 235 843 z "
  },
  ȕ: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 533 843 l 376 1015 l 486 1015 l 621 843 l 533 843 m 307 843 l 151 1015 l 261 1015 l 394 843 l 307 843 z "
  },
  ü: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 588 875 q 546 892 564 875 q 528 935 528 908 q 546 978 528 961 q 588 994 564 994 q 630 978 613 994 q 647 935 647 961 q 630 892 647 908 q 588 875 613 875 m 340 875 q 298 892 315 875 q 281 935 281 908 q 298 978 281 961 q 340 994 315 994 q 382 978 364 994 q 400 935 400 961 q 382 892 400 908 q 340 875 364 875 z "
  },
  ụ: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 464 -264 q 422 -247 440 -264 q 404 -204 404 -231 q 422 -161 404 -178 q 464 -144 440 -144 q 506 -161 489 -144 q 524 -204 524 -178 q 506 -247 524 -231 q 464 -264 489 -264 z "
  },
  ù: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 457 843 l 232 1015 l 364 1015 l 554 843 l 457 843 z "
  },
  ủ: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 482 833 l 447 876 q 509 919 489 896 q 529 975 529 943 q 508 1024 529 1004 q 453 1043 488 1043 q 369 1017 410 1043 l 346 1065 q 401 1092 369 1083 q 461 1101 432 1101 q 556 1069 519 1101 q 593 982 593 1036 q 566 897 593 933 q 482 833 539 860 z "
  },
  ư: {
    ha: 942,
    x_min: 131,
    x_max: 914,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 728 654 l 728 729 l 749 729 q 819 757 797 729 q 840 824 840 785 q 833 872 840 850 q 813 913 825 894 l 878 938 q 904 884 894 914 q 914 821 914 854 q 872 701 914 747 q 749 654 831 654 l 728 654 z "
  },
  ứ: {
    ha: 942,
    x_min: 131,
    x_max: 914,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 728 654 l 728 729 l 749 729 q 819 757 797 729 q 840 824 840 785 q 833 872 840 850 q 813 913 825 894 l 878 938 q 904 884 894 914 q 914 821 914 854 q 872 701 914 747 q 749 654 831 654 l 728 654 m 374 843 l 564 1015 l 696 1015 l 471 843 l 374 843 z "
  },
  ự: {
    ha: 942,
    x_min: 131,
    x_max: 914,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 728 654 l 728 729 l 749 729 q 819 757 797 729 q 840 824 840 785 q 833 872 840 850 q 813 913 825 894 l 878 938 q 904 884 894 914 q 914 821 914 854 q 872 701 914 747 q 749 654 831 654 l 728 654 m 464 -264 q 422 -247 440 -264 q 404 -204 404 -231 q 422 -161 404 -178 q 464 -144 440 -144 q 506 -161 489 -144 q 524 -204 524 -178 q 506 -247 524 -231 q 464 -264 489 -264 z "
  },
  ừ: {
    ha: 942,
    x_min: 131,
    x_max: 914,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 728 654 l 728 729 l 749 729 q 819 757 797 729 q 840 824 840 785 q 833 872 840 850 q 813 913 825 894 l 878 938 q 904 884 894 914 q 914 821 914 854 q 872 701 914 747 q 749 654 831 654 l 728 654 m 457 843 l 232 1015 l 364 1015 l 554 843 l 457 843 z "
  },
  ử: {
    ha: 942,
    x_min: 131,
    x_max: 914,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 728 654 l 728 729 l 749 729 q 819 757 797 729 q 840 824 840 785 q 833 872 840 850 q 813 913 825 894 l 878 938 q 904 884 894 914 q 914 821 914 854 q 872 701 914 747 q 749 654 831 654 l 728 654 m 482 833 l 447 876 q 509 919 489 896 q 529 975 529 943 q 508 1024 529 1004 q 453 1043 488 1043 q 369 1017 410 1043 l 346 1065 q 401 1092 369 1083 q 461 1101 432 1101 q 556 1069 519 1101 q 593 982 593 1036 q 566 897 593 933 q 482 833 539 860 z "
  },
  ữ: {
    ha: 942,
    x_min: 131,
    x_max: 914,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 728 654 l 728 729 l 749 729 q 819 757 797 729 q 840 824 840 785 q 833 872 840 850 q 813 913 825 894 l 878 938 q 904 884 894 914 q 914 821 914 854 q 872 701 914 747 q 749 654 831 654 l 728 654 m 558 851 q 501 865 526 851 q 456 898 476 879 q 417 931 436 917 q 376 946 397 946 q 326 922 344 946 q 304 857 307 899 l 244 857 q 281 968 247 926 q 369 1010 315 1010 q 427 995 401 1010 q 473 962 453 981 q 512 929 493 943 q 551 915 531 915 q 603 938 583 915 q 624 1001 622 961 l 683 1001 q 647 893 682 935 q 558 851 613 851 z "
  },
  ű: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 533 843 l 667 1015 l 776 1015 l 621 843 l 533 843 m 307 843 l 442 1015 l 551 1015 l 394 843 l 307 843 z "
  },
  ȗ: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 253 843 q 316 974 256 926 q 464 1021 376 1021 q 612 974 551 1021 q 675 843 672 926 l 606 843 q 563 929 604 897 q 464 961 522 961 q 366 929 407 961 q 322 843 325 897 l 253 843 z "
  },
  ū: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 250 896 l 250 961 l 678 961 l 678 896 l 250 896 z "
  },
  ṻ: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 z "
  },
  ų: {
    ha: 933,
    x_min: 131,
    x_max: 825,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 707 -306 q 596 -269 638 -306 q 554 -174 554 -233 q 572 -103 554 -140 q 632 -31 589 -67 q 750 38 675 6 l 796 0 q 692 -58 729 -29 q 641 -113 656 -86 q 626 -167 626 -140 q 652 -225 626 -206 q 717 -244 678 -244 q 763 -237 740 -244 q 803 -218 786 -231 l 825 -272 q 770 -297 800 -287 q 707 -306 740 -306 z "
  },
  ů: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 463 826 q 388 846 421 826 q 337 897 356 865 q 318 968 318 929 q 338 1040 318 1007 q 390 1094 357 1074 q 463 1114 422 1114 q 537 1094 504 1114 q 589 1040 569 1074 q 608 968 608 1007 q 589 897 608 929 q 537 846 569 865 q 463 826 504 826 m 463 875 q 531 902 504 875 q 557 968 557 929 q 531 1037 557 1008 q 463 1065 504 1065 q 396 1038 422 1065 q 369 968 369 1010 q 395 901 369 928 q 463 875 421 875 z "
  },
  ũ: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 m 558 851 q 501 865 526 851 q 456 898 476 879 q 417 931 436 917 q 376 946 397 946 q 326 922 344 946 q 304 857 307 899 l 244 857 q 281 968 247 926 q 369 1010 315 1010 q 427 995 401 1010 q 473 962 453 981 q 512 929 493 943 q 551 915 531 915 q 603 938 583 915 q 624 1001 622 961 l 683 1001 q 647 893 682 935 q 558 851 613 851 z "
  },
  ṹ: {
    ha: 933,
    x_min: 131,
    x_max: 796,
    o: "m 439 -7 q 276 28 346 -7 q 169 132 207 63 q 131 306 131 201 l 131 729 l 229 729 l 229 317 q 287 141 229 200 q 449 82 344 82 q 581 113 525 82 q 667 204 638 144 q 697 347 697 264 l 697 729 l 796 729 l 796 0 l 701 0 l 701 200 l 717 164 q 609 38 682 83 q 439 -7 536 -7 z "
  },
  v: {
    ha: 753,
    x_min: 1,
    x_max: 751,
    o: "m 325 0 l 1 729 l 104 729 l 401 53 l 353 53 l 654 729 l 751 729 l 426 0 l 325 0 z "
  },
  w: {
    ha: 1221,
    x_min: 11,
    x_max: 1210,
    o: "m 286 0 l 11 729 l 106 729 l 356 53 l 313 53 l 569 729 l 654 729 l 908 53 l 865 53 l 1119 729 l 1210 729 l 933 0 l 840 0 l 596 636 l 625 636 l 379 0 l 286 0 z "
  },
  ẃ: {
    ha: 1221,
    x_min: 11,
    x_max: 1210,
    o: "m 286 0 l 11 729 l 106 729 l 356 53 l 313 53 l 569 729 l 654 729 l 908 53 l 865 53 l 1119 729 l 1210 729 l 933 0 l 840 0 l 596 636 l 625 636 l 379 0 l 286 0 m 518 842 l 708 1014 l 840 1014 l 615 842 l 518 842 z "
  },
  ŵ: {
    ha: 1221,
    x_min: 11,
    x_max: 1210,
    o: "m 286 0 l 11 729 l 106 729 l 356 53 l 313 53 l 569 729 l 654 729 l 908 53 l 865 53 l 1119 729 l 1210 729 l 933 0 l 840 0 l 596 636 l 625 636 l 379 0 l 286 0 m 379 842 l 558 1014 l 658 1014 l 838 842 l 746 842 l 569 989 l 647 989 l 471 842 l 379 842 z "
  },
  ẅ: {
    ha: 1221,
    x_min: 11,
    x_max: 1210,
    o: "m 286 0 l 11 729 l 106 729 l 356 53 l 313 53 l 569 729 l 654 729 l 908 53 l 865 53 l 1119 729 l 1210 729 l 933 0 l 840 0 l 596 636 l 625 636 l 379 0 l 286 0 m 732 874 q 690 890 708 874 q 672 933 672 907 q 690 976 672 960 q 732 993 708 993 q 774 976 757 993 q 792 933 792 960 q 774 890 792 907 q 732 874 757 874 m 485 874 q 442 890 460 874 q 425 933 425 907 q 442 976 425 960 q 485 993 460 993 q 526 976 508 993 q 544 933 544 960 q 526 890 544 907 q 485 874 508 874 z "
  },
  ẁ: {
    ha: 1221,
    x_min: 11,
    x_max: 1210,
    o: "m 286 0 l 11 729 l 106 729 l 356 53 l 313 53 l 569 729 l 654 729 l 908 53 l 865 53 l 1119 729 l 1210 729 l 933 0 l 840 0 l 596 636 l 625 636 l 379 0 l 286 0 m 601 842 l 376 1014 l 508 1014 l 699 842 l 601 842 z "
  },
  x: {
    ha: 742,
    x_min: 26,
    x_max: 715,
    o: "m 26 0 l 335 400 l 333 351 l 40 729 l 151 729 l 392 417 l 350 418 l 590 729 l 699 729 l 403 347 l 404 400 l 715 0 l 603 0 l 349 333 l 388 328 l 138 0 l 26 0 z "
  },
  y: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 z "
  },
  ý: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 m 267 843 l 457 1015 l 589 1015 l 364 843 l 267 843 z "
  },
  ŷ: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 m 128 843 l 307 1015 l 407 1015 l 586 843 l 494 843 l 318 990 l 396 990 l 219 843 l 128 843 z "
  },
  ÿ: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 m 481 875 q 439 892 457 875 q 421 935 421 908 q 439 978 421 961 q 481 994 457 994 q 523 978 506 994 q 540 935 540 961 q 523 892 540 908 q 481 875 506 875 m 233 875 q 191 892 208 875 q 174 935 174 908 q 191 978 174 961 q 233 994 208 994 q 275 978 257 994 q 293 935 293 961 q 275 892 293 908 q 233 875 257 875 z "
  },
  ẏ: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 m 357 875 q 310 894 329 875 q 290 942 290 914 q 310 990 290 971 q 357 1008 329 1008 q 404 990 385 1008 q 424 942 424 971 q 404 894 424 914 q 357 875 385 875 z "
  },
  ỵ: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 m 539 -264 q 497 -247 515 -264 q 479 -204 479 -231 q 497 -161 479 -178 q 539 -144 515 -144 q 581 -161 564 -144 q 599 -204 599 -178 q 581 -247 599 -231 q 539 -264 564 -264 z "
  },
  ỳ: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 m 350 843 l 125 1015 l 257 1015 l 447 843 l 350 843 z "
  },
  ỷ: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 m 375 833 l 340 876 q 402 919 382 896 q 422 975 422 943 q 401 1024 422 1004 q 346 1043 381 1043 q 263 1017 303 1043 l 239 1065 q 294 1092 263 1083 q 354 1101 325 1101 q 449 1069 413 1101 q 486 982 486 1036 q 459 897 486 933 q 375 833 432 860 z "
  },
  ȳ: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 m 143 896 l 143 961 l 571 961 l 571 896 l 143 896 z "
  },
  ỹ: {
    ha: 753,
    x_min: -35,
    x_max: 751,
    o: "m 143 -276 q 45 -260 92 -276 q -35 -210 -1 -243 l 11 -136 q 72 -177 39 -162 q 144 -192 104 -192 q 228 -165 193 -192 q 296 -69 264 -137 l 343 38 l 354 53 l 654 729 l 751 729 l 386 -87 q 319 -200 356 -158 q 239 -259 282 -242 q 143 -276 196 -276 m 338 -21 l 1 729 l 104 729 l 401 60 l 338 -21 m 451 851 q 394 865 419 851 q 349 898 369 879 q 310 931 329 917 q 269 946 290 946 q 219 922 238 946 q 197 857 200 899 l 138 857 q 174 968 140 926 q 263 1010 208 1010 q 320 995 294 1010 q 366 962 346 981 q 405 929 386 943 q 444 915 424 915 q 496 938 476 915 q 517 1001 515 961 l 576 1001 q 540 893 575 935 q 451 851 506 851 z "
  },
  z: {
    ha: 710,
    x_min: 58,
    x_max: 653,
    o: "m 58 0 l 58 65 l 544 681 l 565 647 l 67 647 l 67 729 l 643 729 l 643 665 l 158 49 l 133 82 l 653 82 l 653 0 l 58 0 z "
  },
  ź: {
    ha: 710,
    x_min: 58,
    x_max: 653,
    o: "m 58 0 l 58 65 l 544 681 l 565 647 l 67 647 l 67 729 l 643 729 l 643 665 l 158 49 l 133 82 l 653 82 l 653 0 l 58 0 m 265 843 l 456 1015 l 588 1015 l 363 843 l 265 843 z "
  },
  ž: {
    ha: 710,
    x_min: 58,
    x_max: 653,
    o: "m 58 0 l 58 65 l 544 681 l 565 647 l 67 647 l 67 729 l 643 729 l 643 665 l 158 49 l 133 82 l 653 82 l 653 0 l 58 0 m 306 843 l 126 1015 l 218 1015 l 394 869 l 317 869 l 493 1015 l 585 1015 l 406 843 l 306 843 z "
  },
  ż: {
    ha: 710,
    x_min: 58,
    x_max: 653,
    o: "m 58 0 l 58 65 l 544 681 l 565 647 l 67 647 l 67 729 l 643 729 l 643 665 l 158 49 l 133 82 l 653 82 l 653 0 l 58 0 m 356 875 q 308 894 328 875 q 289 942 289 914 q 308 990 289 971 q 356 1008 328 1008 q 403 990 383 1008 q 422 942 422 971 q 403 894 422 914 q 356 875 383 875 z "
  },
  ẓ: {
    ha: 710,
    x_min: 58,
    x_max: 653,
    o: "m 58 0 l 58 65 l 544 681 l 565 647 l 67 647 l 67 729 l 643 729 l 643 665 l 158 49 l 133 82 l 653 82 l 653 0 l 58 0 m 365 -264 q 324 -247 342 -264 q 306 -204 306 -231 q 324 -161 306 -178 q 365 -144 342 -144 q 408 -161 390 -144 q 425 -204 425 -178 q 408 -247 425 -231 q 365 -264 390 -264 z "
  },
  ﬁ: {
    ha: 846,
    x_min: 24,
    x_max: 731,
    o: "m 154 0 l 154 821 q 211 978 154 918 q 375 1038 268 1038 q 456 1026 417 1038 q 521 992 494 1015 l 488 918 q 439 945 467 936 q 379 954 411 954 q 283 919 317 954 q 250 817 250 885 l 250 706 l 253 660 l 253 0 l 154 0 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 m 608 0 l 608 729 l 707 729 l 707 0 l 608 0 m 658 890 q 607 911 628 890 q 586 961 586 932 q 607 1010 586 990 q 658 1031 628 1031 q 710 1011 689 1031 q 731 963 731 992 q 710 911 731 932 q 658 890 690 890 z "
  },
  ﬂ: {
    ha: 846,
    x_min: 24,
    x_max: 707,
    o: "m 154 0 l 154 821 q 211 978 154 918 q 375 1038 268 1038 q 456 1026 417 1038 q 521 992 494 1015 l 488 918 q 439 945 467 936 q 379 954 411 954 q 283 919 317 954 q 250 817 250 885 l 250 706 l 253 660 l 253 0 l 154 0 m 24 647 l 24 729 l 475 729 l 475 647 l 24 647 m 608 0 l 608 1031 l 707 1031 l 707 0 l 608 0 z "
  },
  ª: {
    ha: 557,
    x_min: 57,
    x_max: 458,
    o: "m 390 597 l 390 692 l 385 707 l 385 867 q 353 951 385 924 q 257 978 321 978 q 170 965 211 978 q 100 926 129 951 l 71 975 q 158 1019 106 1003 q 264 1036 210 1036 q 408 994 358 1036 q 458 864 458 951 l 458 597 l 390 597 m 228 593 q 101 629 144 593 q 57 719 57 665 q 99 808 57 772 q 239 844 140 844 l 399 844 l 399 796 l 247 796 q 154 776 182 796 q 126 724 126 756 q 157 665 126 686 q 243 644 188 644 q 332 665 297 644 q 385 725 367 686 l 399 681 q 340 617 383 642 q 228 593 296 593 z "
  },
  º: {
    ha: 575,
    x_min: 47,
    x_max: 528,
    o: "m 288 593 q 164 622 218 593 q 78 701 110 650 q 47 815 47 751 q 78 930 47 881 q 164 1008 110 979 q 288 1036 218 1036 q 411 1008 357 1036 q 497 930 465 979 q 528 815 528 881 q 497 701 528 751 q 411 622 465 650 q 288 593 357 593 m 288 656 q 408 700 361 656 q 456 815 456 744 q 408 931 456 888 q 288 975 361 975 q 167 931 214 975 q 119 815 119 886 q 167 700 119 744 q 288 656 214 656 z "
  },
  А: {
    ha: 1033,
    x_min: 22,
    x_max: 1013,
    o: "m 21 0 l 465 972 l 567 972 l 1011 0 l 903 0 l 494 913 l 536 913 l 128 0 l 21 0 m 196 260 l 226 343 l 792 343 l 822 260 l 196 260 z "
  },
  Б: {
    ha: 1008,
    x_min: 164,
    x_max: 935,
    o: "m 164 0 l 164 972 l 875 972 l 875 885 l 265 885 l 265 567 l 583 567 q 845 497 756 567 q 935 290 935 426 q 838 75 935 150 q 561 0 742 0 l 164 0 m 265 82 l 560 82 q 763 134 694 82 q 832 286 832 186 q 560 485 832 485 l 265 485 l 265 82 z "
  },
  В: {
    ha: 1040,
    x_min: 164,
    x_max: 947,
    o: "m 164 0 l 164 972 l 568 972 q 810 909 722 972 q 899 724 899 846 q 814 541 899 603 q 592 479 729 479 l 615 514 q 863 450 778 514 q 947 263 947 386 q 859 69 947 138 q 594 0 771 0 l 164 0 m 265 82 l 594 82 q 782 128 718 82 q 846 269 846 174 q 782 408 846 364 q 594 453 718 453 l 265 453 l 265 82 m 265 532 l 563 532 q 735 577 675 532 q 796 711 796 622 q 735 845 796 800 q 563 890 675 890 l 265 890 l 265 532 z "
  },
  Г: {
    ha: 794,
    x_min: 164,
    x_max: 782,
    o: "m 164 0 l 164 972 l 782 972 l 782 883 l 238 883 l 264 910 l 265 0 l 164 0 z "
  },
  Ѓ: {
    ha: 794,
    x_min: 164,
    x_max: 782,
    o: "m 164 0 l 164 972 l 782 972 l 782 883 l 238 883 l 264 910 l 265 0 l 164 0 z "
  },
  Ґ: {
    ha: 799,
    x_min: 164,
    x_max: 782,
    o: "m 164 0 l 164 972 l 686 972 l 686 1172 l 782 1172 l 782 883 l 265 883 l 265 0 l 164 0 z "
  },
  Д: {
    ha: 1103,
    x_min: 15,
    x_max: 1057,
    o: "m 810 49 l 810 883 l 344 883 l 336 647 q 323 437 332 538 q 295 256 314 336 q 245 126 276 176 q 164 68 214 76 l 51 89 q 144 129 107 86 q 201 250 181 172 q 231 432 221 328 q 244 657 240 536 l 256 972 l 911 972 l 911 49 l 810 49 m 15 -218 l 17 89 l 1057 89 l 1057 -218 l 961 -218 l 961 0 l 113 0 l 111 -218 l 15 -218 z "
  },
  Е: {
    ha: 915,
    x_min: 164,
    x_max: 851,
    o: "m 256 538 l 769 538 l 769 450 l 256 450 l 256 538 m 267 89 l 851 89 l 851 0 l 164 0 l 164 972 l 831 972 l 831 883 l 267 883 l 267 89 z "
  },
  Ѐ: {
    ha: 915,
    x_min: 164,
    x_max: 851,
    o: "m 256 538 l 769 538 l 769 450 l 256 450 l 256 538 m 267 89 l 851 89 l 851 0 l 164 0 l 164 972 l 831 972 l 831 883 l 267 883 l 267 89 z "
  },
  Ё: {
    ha: 915,
    x_min: 164,
    x_max: 851,
    o: "m 256 538 l 769 538 l 769 450 l 256 450 l 256 538 m 267 89 l 851 89 l 851 0 l 164 0 l 164 972 l 831 972 l 831 883 l 267 883 l 267 89 z "
  },
  Ж: {
    ha: 1404,
    x_min: 33,
    x_max: 1371,
    o: "m 1251 0 l 928 485 l 1015 535 l 1371 0 l 1251 0 m 721 446 l 721 536 l 999 536 l 999 446 l 721 446 m 1019 475 l 925 492 l 1235 972 l 1346 972 l 1019 475 m 153 0 l 33 0 l 389 535 l 476 485 l 153 0 m 753 0 l 653 0 l 653 972 l 753 972 l 753 0 m 683 446 l 406 446 l 406 536 l 683 536 l 683 446 m 385 475 l 58 972 l 169 972 l 478 492 l 385 475 z "
  },
  З: {
    ha: 883,
    x_min: 49,
    x_max: 792,
    o: "m 49 117 l 86 190 q 230 108 150 135 q 390 80 310 81 q 538 103 471 79 q 647 173 606 126 q 689 286 689 219 q 622 417 689 371 q 435 463 554 463 l 226 463 l 226 546 l 429 546 q 590 590 532 546 q 647 711 647 633 q 615 806 647 767 q 526 867 582 846 q 400 891 469 889 q 256 873 331 893 q 113 810 182 853 l 79 894 q 258 966 165 946 q 439 979 351 986 q 597 939 526 972 q 708 851 667 906 q 750 722 750 797 q 715 600 750 653 q 616 519 679 547 q 467 490 553 490 l 472 521 q 641 490 569 521 q 752 403 713 460 q 792 272 792 347 q 756 147 792 201 q 659 55 721 92 q 521 2 597 18 q 361 -7 444 -14 q 197 30 278 0 q 49 117 117 60 z "
  },
  И: {
    ha: 1144,
    x_min: 164,
    x_max: 981,
    o: "m 164 0 l 164 972 l 265 972 l 265 167 l 888 972 l 981 972 l 981 0 l 879 0 l 879 804 l 257 0 l 164 0 z "
  },
  Й: {
    ha: 1144,
    x_min: 164,
    x_max: 981,
    o: "m 164 0 l 164 972 l 265 972 l 265 167 l 888 972 l 981 972 l 981 0 l 879 0 l 879 804 l 257 0 l 164 0 m 569 1043 q 405 1090 465 1043 q 343 1222 344 1138 l 419 1222 q 462 1135 421 1167 q 569 1103 503 1103 q 677 1135 636 1103 q 719 1222 718 1167 l 796 1222 q 733 1090 794 1138 q 569 1043 672 1043 z "
  },
  Ѝ: {
    ha: 1144,
    x_min: 164,
    x_max: 981,
    o: "m 164 0 l 164 972 l 265 972 l 265 167 l 888 972 l 981 972 l 981 0 l 879 0 l 879 804 l 257 0 l 164 0 z "
  },
  "Ҋ": {
    ha: 1178,
    x_min: 164,
    x_max: 1119,
    o: "m 164 0 l 164 972 l 265 972 l 265 167 l 888 972 l 981 972 l 981 0 l 879 0 l 879 804 l 257 0 l 164 0 m 569 1043 q 405 1090 465 1043 q 343 1222 344 1138 l 419 1222 q 462 1135 421 1167 q 569 1103 503 1103 q 677 1135 636 1103 q 719 1222 718 1167 l 796 1222 q 733 1090 794 1138 q 569 1043 672 1043 m 943 -218 l 1007 28 l 1050 0 l 879 0 l 879 89 l 1118 89 l 1025 -218 l 943 -218 z "
  },
  К: {
    ha: 975,
    x_min: 164,
    x_max: 947,
    o: "m 829 0 l 456 485 l 539 535 l 947 0 l 829 0 m 164 0 l 164 972 l 264 972 l 264 0 l 164 0 m 233 446 l 233 536 l 538 536 l 538 446 l 233 446 m 547 475 l 453 492 l 815 972 l 926 972 l 547 475 z "
  },
  Ќ: {
    ha: 975,
    x_min: 164,
    x_max: 947,
    o: "m 829 0 l 456 485 l 539 535 l 947 0 l 829 0 m 164 0 l 164 972 l 264 972 l 264 0 l 164 0 m 233 446 l 233 536 l 538 536 l 538 446 l 233 446 m 547 475 l 453 492 l 815 972 l 926 972 l 547 475 z "
  },
  Л: {
    ha: 1090,
    x_min: 15,
    x_max: 926,
    o: "m 93 -8 q 56 -6 74 -8 q 15 1 38 -4 l 24 93 q 69 88 47 88 q 170 137 132 88 q 228 290 208 186 q 253 556 247 393 l 267 972 l 926 972 l 926 0 l 825 0 l 825 911 l 851 883 l 332 883 l 357 913 l 344 558 q 324 306 339 413 q 279 130 308 200 q 204 26 250 60 q 93 -8 158 -8 z "
  },
  М: {
    ha: 1338,
    x_min: 164,
    x_max: 1174,
    o: "m 164 0 l 164 972 l 249 972 l 693 214 l 649 214 l 1089 972 l 1174 972 l 1174 0 l 1075 0 l 1075 818 l 1099 818 l 693 124 l 644 124 l 236 818 l 263 818 l 263 0 l 164 0 z "
  },
  Н: {
    ha: 1140,
    x_min: 164,
    x_max: 976,
    o: "m 875 972 l 976 972 l 976 0 l 875 0 l 875 972 m 267 0 l 164 0 l 164 972 l 267 972 l 267 0 m 885 449 l 256 449 l 256 539 l 885 539 l 885 449 z "
  },
  О: {
    ha: 1182,
    x_min: 79,
    x_max: 1101,
    o: "m 590 -8 q 387 28 481 -8 q 224 133 293 65 q 117 290 156 200 q 79 486 79 379 q 117 683 79 593 q 224 840 156 772 q 386 944 293 907 q 590 981 479 981 q 793 944 700 981 q 955 840 886 907 q 1062 683 1024 774 q 1100 486 1100 593 q 1062 289 1100 379 q 955 132 1024 199 q 793 28 886 65 q 590 -8 700 -8 m 590 83 q 752 113 678 83 q 881 198 826 143 q 967 326 936 253 q 997 486 997 399 q 967 647 997 574 q 881 774 936 719 q 752 859 826 829 q 590 889 678 889 q 428 859 503 889 q 298 774 353 829 q 212 647 243 719 q 181 486 181 574 q 212 326 181 400 q 298 198 243 253 q 428 113 353 143 q 590 83 503 83 z "
  },
  П: {
    ha: 1146,
    x_min: 164,
    x_max: 982,
    o: "m 164 0 l 164 972 l 982 972 l 982 0 l 881 0 l 881 911 l 907 883 l 239 883 l 265 911 l 265 0 l 164 0 z "
  },
  Р: {
    ha: 985,
    x_min: 164,
    x_max: 925,
    o: "m 164 0 l 164 972 l 528 972 q 740 933 651 972 q 877 819 829 893 q 925 639 925 744 q 877 462 925 536 q 740 347 829 388 q 528 307 651 307 l 221 307 l 267 356 l 267 0 l 164 0 m 267 347 l 221 397 l 525 397 q 747 460 671 397 q 822 639 822 524 q 747 819 822 756 q 525 883 671 883 l 221 883 l 267 932 l 267 347 z "
  },
  С: {
    ha: 994,
    x_min: 81,
    x_max: 946,
    o: "m 589 -8 q 386 28 479 -8 q 225 132 293 65 q 119 289 157 199 q 81 486 81 379 q 119 683 81 593 q 226 840 157 774 q 388 944 294 907 q 590 981 481 981 q 789 945 696 981 q 946 839 882 910 l 881 774 q 749 862 821 835 q 593 889 676 889 q 431 859 506 889 q 300 774 356 829 q 213 647 244 719 q 182 486 182 574 q 213 326 182 399 q 300 198 244 253 q 431 113 356 143 q 593 83 506 83 q 749 111 676 83 q 881 200 821 139 l 946 135 q 789 28 882 64 q 589 -8 696 -8 z "
  },
  Т: {
    ha: 817,
    x_min: 15,
    x_max: 800,
    o: "m 357 0 l 357 911 l 385 883 l 15 883 l 15 972 l 800 972 l 800 883 l 432 883 l 458 911 l 458 0 l 357 0 z "
  },
  У: {
    ha: 944,
    x_min: 29,
    x_max: 928,
    o: "m 147 96 q 281 83 218 68 q 396 181 343 97 l 443 256 l 453 268 l 825 972 l 928 972 l 486 158 q 381 32 442 74 q 253 -12 321 -10 q 118 13 186 -15 l 147 96 m 450 175 l 29 972 l 139 972 l 506 260 l 450 175 z "
  },
  Ў: {
    ha: 944,
    x_min: 29,
    x_max: 928,
    o: "m 147 96 q 281 83 218 68 q 396 181 343 97 l 443 256 l 453 268 l 825 972 l 928 972 l 486 158 q 381 32 442 74 q 253 -12 321 -10 q 118 13 186 -15 l 147 96 m 450 175 l 29 972 l 139 972 l 506 260 l 450 175 m 463 1043 q 298 1090 358 1043 q 236 1222 238 1138 l 313 1222 q 355 1135 314 1167 q 463 1103 396 1103 q 570 1135 529 1103 q 613 1222 611 1167 l 689 1222 q 626 1090 688 1138 q 463 1043 565 1043 z "
  },
  Ф: {
    ha: 1274,
    x_min: 69,
    x_max: 1204,
    o: "m 624 67 q 326 116 450 67 q 136 260 203 165 q 69 488 69 354 q 136 715 69 621 q 326 858 203 808 q 624 908 450 908 q 631 908 625 908 q 642 908 636 908 q 649 908 647 908 q 947 858 824 908 q 1138 715 1071 808 q 1204 488 1204 621 q 1138 260 1204 354 q 949 116 1072 165 q 653 67 825 67 q 644 67 650 67 q 631 67 638 67 q 624 67 625 67 m 635 147 q 640 147 638 147 q 644 147 643 147 q 894 188 790 149 q 1051 303 997 228 q 1106 488 1106 379 q 1051 672 1106 597 q 894 787 996 747 q 647 826 792 826 q 642 826 646 826 q 635 826 638 826 q 383 788 488 826 q 224 673 279 749 q 168 488 168 597 q 224 301 168 376 q 385 186 281 225 q 635 147 490 147 m 589 -33 l 589 1006 l 685 1006 l 685 -33 l 589 -33 z "
  },
  Х: {
    ha: 903,
    x_min: 31,
    x_max: 872,
    o: "m 56 972 l 174 972 l 450 588 l 725 972 l 846 972 l 514 506 l 872 0 l 751 0 l 450 418 l 149 0 l 31 0 l 388 501 l 56 972 z "
  },
  Ч: {
    ha: 1015,
    x_min: 82,
    x_max: 850,
    o: "m 768 411 q 602 354 685 374 q 443 335 519 335 q 177 417 272 335 q 82 651 82 500 l 82 972 l 183 972 l 183 663 q 255 488 183 550 q 453 425 326 425 q 608 445 528 425 q 768 503 689 465 l 768 411 m 750 0 l 750 972 l 850 972 l 850 0 l 750 0 z "
  },
  Ц: {
    ha: 1149,
    x_min: 164,
    x_max: 1108,
    o: "m 164 0 l 164 972 l 265 972 l 265 89 l 853 89 l 853 972 l 954 972 l 954 0 l 164 0 m 1013 -228 l 1013 28 l 1039 0 l 853 0 l 853 89 l 1108 89 l 1108 -228 l 1013 -228 z "
  },
  Ш: {
    ha: 1519,
    x_min: 164,
    x_max: 1356,
    o: "m 735 89 l 710 61 l 710 972 l 811 972 l 811 61 l 783 89 l 1282 89 l 1254 61 l 1254 972 l 1356 972 l 1356 0 l 164 0 l 164 972 l 265 972 l 265 61 l 239 89 l 735 89 z "
  },
  Щ: {
    ha: 1551,
    x_min: 164,
    x_max: 1507,
    o: "m 735 89 l 710 61 l 710 972 l 811 972 l 811 61 l 783 89 l 1282 89 l 1254 61 l 1254 972 l 1356 972 l 1356 0 l 164 0 l 164 972 l 265 972 l 265 61 l 239 89 l 735 89 m 1411 -218 l 1411 28 l 1439 0 l 1253 0 l 1253 89 l 1507 89 l 1507 -218 l 1411 -218 z "
  },
  Џ: {
    ha: 1119,
    x_min: 164,
    x_max: 954,
    o: "m 954 972 l 954 0 l 607 0 l 607 -228 l 511 -228 l 511 0 l 164 0 l 164 972 l 265 972 l 265 89 l 853 89 l 853 972 l 954 972 z "
  },
  Ь: {
    ha: 986,
    x_min: 164,
    x_max: 925,
    o: "m 571 625 q 834 548 743 625 q 925 319 925 471 q 828 81 925 163 q 550 0 731 0 l 164 0 l 164 972 l 265 972 l 265 625 l 571 625 m 547 82 q 752 142 682 82 q 822 317 822 201 q 753 487 822 432 q 547 542 683 542 l 265 542 l 265 82 l 547 82 z "
  },
  Ъ: {
    ha: 1139,
    x_min: 15,
    x_max: 1078,
    o: "m 725 625 q 987 548 896 625 q 1078 319 1078 471 q 981 81 1078 163 q 703 0 883 0 l 318 0 l 318 883 l 15 883 l 15 972 l 419 972 l 419 625 l 725 625 m 701 82 q 906 142 836 82 q 976 317 976 201 q 907 487 976 432 q 701 542 838 542 l 419 542 l 419 82 l 701 82 z "
  },
  Ы: {
    ha: 1358,
    x_min: 164,
    x_max: 1194,
    o: "m 571 625 q 834 548 743 625 q 925 319 925 471 q 828 81 925 163 q 550 0 731 0 l 164 0 l 164 972 l 265 972 l 265 625 l 571 625 m 547 82 q 752 142 682 82 q 822 317 822 201 q 753 487 822 432 q 547 542 683 542 l 265 542 l 265 82 l 547 82 m 1093 0 l 1093 972 l 1194 972 l 1194 0 l 1093 0 z "
  },
  Љ: {
    ha: 1647,
    x_min: 15,
    x_max: 1586,
    o: "m 93 -8 q 56 -6 74 -8 q 15 1 38 -4 l 24 93 q 69 88 47 88 q 170 137 132 88 q 228 290 208 186 q 253 556 247 393 l 267 972 l 926 972 l 926 0 l 825 0 l 825 911 l 851 883 l 332 883 l 357 913 l 344 558 q 324 306 339 413 q 279 130 308 200 q 204 26 250 60 q 93 -8 158 -8 m 1232 625 q 1495 548 1404 625 q 1586 319 1586 471 q 1489 81 1586 163 q 1211 0 1392 0 l 825 0 l 825 972 l 926 972 l 926 625 l 1232 625 m 1208 82 q 1413 142 1343 82 q 1483 317 1483 201 q 1414 487 1483 432 q 1208 542 1344 542 l 926 542 l 926 82 l 1208 82 z "
  },
  Њ: {
    ha: 1644,
    x_min: 164,
    x_max: 1589,
    o: "m 164 0 l 164 972 l 265 972 l 265 572 l 853 572 l 853 972 l 954 972 l 954 0 l 853 0 l 853 483 l 265 483 l 265 0 l 164 0 m 954 54 l 928 82 l 1232 82 q 1419 138 1353 82 q 1486 290 1486 193 q 1420 441 1486 389 q 1232 493 1354 493 l 928 493 l 954 522 l 954 54 m 853 0 l 853 972 l 954 972 l 954 544 l 928 576 l 1257 576 q 1501 503 1414 576 q 1589 296 1589 429 q 1496 78 1589 157 q 1238 0 1403 0 l 853 0 z "
  },
  Ѕ: {
    ha: 871,
    x_min: 75,
    x_max: 799,
    o: "m 436 -8 q 228 27 328 -8 q 75 118 129 63 l 115 197 q 253 113 167 147 q 436 79 340 79 q 585 102 528 79 q 670 164 643 125 q 697 250 697 203 q 665 342 697 307 q 579 397 632 376 q 463 432 526 417 q 335 465 399 447 q 217 511 271 482 q 131 588 164 540 q 99 714 99 636 q 137 847 99 786 q 254 944 175 907 q 457 981 333 981 q 619 958 539 981 q 758 894 700 935 l 724 813 q 591 874 661 854 q 456 893 521 893 q 311 869 368 893 q 227 806 254 846 q 200 717 200 767 q 233 625 200 660 q 319 571 265 590 q 436 536 372 551 q 563 503 500 521 q 680 456 626 485 q 766 381 733 428 q 799 257 799 333 q 760 126 799 186 q 641 28 721 65 q 436 -8 561 -8 z "
  },
  Є: {
    ha: 982,
    x_min: 82,
    x_max: 933,
    o: "m 688 519 l 688 435 l 150 435 l 150 519 l 688 519 m 565 -8 q 374 28 463 -8 q 220 132 286 65 q 118 289 154 199 q 82 486 82 379 q 118 683 82 593 q 220 840 154 774 q 374 944 286 907 q 565 981 463 981 q 773 944 678 981 q 933 838 868 908 l 869 772 q 733 862 808 835 q 571 889 657 889 q 417 858 488 889 q 295 774 347 828 q 214 647 243 719 q 185 486 185 574 q 214 326 185 399 q 295 199 243 253 q 417 114 347 144 q 571 83 488 83 q 733 111 657 83 q 869 200 808 139 l 933 135 q 773 28 868 64 q 565 -8 678 -8 z "
  },
  Э: {
    ha: 981,
    x_min: 49,
    x_max: 899,
    o: "m 293 453 l 293 538 l 831 538 l 831 453 l 293 453 m 415 981 q 607 944 519 981 q 760 840 694 907 q 863 683 826 774 q 899 486 899 593 q 863 289 899 379 q 760 132 826 199 q 607 28 694 65 q 415 -8 519 -8 q 208 28 304 -8 q 49 135 113 64 l 113 200 q 249 110 174 138 q 411 83 324 83 q 563 114 493 83 q 685 199 633 144 q 767 326 738 253 q 796 486 796 399 q 767 647 796 574 q 685 774 738 719 q 563 858 633 828 q 411 889 493 889 q 249 861 324 889 q 113 772 174 833 l 49 838 q 208 944 113 908 q 415 981 304 981 z "
  },
  І: {
    ha: 429,
    x_min: 164,
    x_max: 265,
    o: "m 164 0 l 164 972 l 265 972 l 265 0 l 164 0 z "
  },
  Ї: {
    ha: 419,
    x_min: 26,
    x_max: 393,
    o: "m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 m 333 1083 q 292 1100 310 1083 q 274 1143 274 1117 q 292 1186 274 1169 q 333 1203 310 1203 q 376 1186 358 1203 q 393 1143 393 1169 q 376 1100 393 1117 q 333 1083 358 1083 m 86 1083 q 44 1100 61 1083 q 26 1143 26 1117 q 44 1186 26 1169 q 86 1203 61 1203 q 128 1186 110 1203 q 146 1143 146 1169 q 128 1100 146 1117 q 86 1083 110 1083 z "
  },
  Ј: {
    ha: 732,
    x_min: 29,
    x_max: 582,
    o: "m 299 -8 q 145 28 217 -8 q 31 131 74 64 l 90 200 q 183 111 131 142 q 300 81 236 81 q 481 294 481 81 l 481 883 l 125 883 l 125 972 l 582 972 l 582 299 q 510 68 582 144 q 299 -8 439 -8 z "
  },
  Ћ: {
    ha: 1160,
    x_min: 15,
    x_max: 1086,
    o: "m 357 0 l 357 911 l 385 883 l 15 883 l 15 972 l 825 972 l 825 883 l 432 883 l 458 911 l 458 0 l 357 0 m 438 510 q 603 565 525 547 q 753 583 681 583 q 994 506 903 583 q 1086 271 1086 429 l 1086 0 l 985 0 l 985 260 q 917 433 985 374 q 733 492 850 492 q 438 414 604 492 l 438 510 z "
  },
  Ю: {
    ha: 1517,
    x_min: 164,
    x_max: 1435,
    o: "m 164 0 l 164 972 l 265 972 l 265 540 l 517 540 l 517 447 l 265 447 l 265 0 l 164 0 m 949 -8 q 756 28 844 -8 q 602 132 668 65 q 500 289 536 199 q 464 486 464 379 q 500 683 464 593 q 602 840 536 774 q 756 944 668 907 q 949 981 844 981 q 1142 944 1053 981 q 1296 840 1231 907 q 1398 683 1361 774 q 1435 486 1435 593 q 1398 289 1435 379 q 1296 132 1361 199 q 1142 28 1231 65 q 949 -8 1053 -8 m 949 83 q 1101 113 1031 83 q 1222 197 1171 143 q 1303 324 1274 251 q 1332 486 1332 397 q 1303 648 1332 575 q 1222 775 1274 721 q 1101 859 1171 829 q 949 889 1031 889 q 798 859 868 889 q 676 775 728 829 q 596 648 625 721 q 567 486 567 575 q 596 324 567 397 q 676 197 625 251 q 798 113 728 143 q 949 83 868 83 z "
  },
  Я: {
    ha: 1017,
    x_min: 92,
    x_max: 853,
    o: "m 751 0 l 751 322 l 779 294 l 461 294 q 262 335 344 294 q 135 449 179 375 q 92 628 92 524 q 139 816 92 739 q 273 933 186 893 q 475 972 360 972 l 853 972 l 853 0 l 751 0 m 92 0 l 331 342 l 436 342 l 201 0 l 92 0 m 751 351 l 751 913 l 779 883 l 479 883 q 269 819 343 883 q 194 631 194 754 q 264 447 194 511 q 469 382 333 382 l 779 382 l 751 351 z "
  },
  Ђ: {
    ha: 1146,
    x_min: 17,
    x_max: 1088,
    o: "m 360 0 l 360 911 l 386 883 l 17 883 l 17 972 l 831 972 l 831 883 l 433 883 l 460 911 l 460 0 l 360 0 m 653 7 l 667 93 q 780 82 724 79 q 883 108 836 85 q 958 176 931 132 q 986 288 986 219 q 940 425 986 375 q 817 491 894 475 q 641 490 739 507 q 439 424 543 472 l 440 517 q 687 582 569 569 q 894 566 804 594 q 1036 469 985 538 q 1088 290 1088 400 q 1051 133 1088 196 q 951 36 1014 69 q 812 -4 889 3 q 653 7 735 -11 z "
  },
  Ѣ: {
    ha: 1114,
    x_min: 26,
    x_max: 1053,
    o: "m 290 0 l 290 1031 l 392 1031 l 392 621 l 701 621 q 963 544 874 621 q 1053 317 1053 467 q 957 81 1053 163 q 679 0 861 0 l 290 0 m 392 82 l 678 82 q 881 140 813 82 q 949 313 949 199 q 678 539 949 539 l 392 539 l 392 82 m 26 782 l 26 860 l 696 860 l 696 782 l 26 782 z "
  },
  Ѫ: {
    ha: 1228,
    x_min: 31,
    x_max: 1197,
    o: "m 31 0 l 133 226 q 228 388 175 325 q 347 482 282 451 q 488 513 413 513 l 504 513 l 140 901 l 140 972 l 1088 972 l 1088 906 l 721 513 l 740 513 q 882 482 817 513 q 1001 388 947 451 q 1096 226 1056 325 l 1197 0 l 1090 0 l 1003 200 q 880 378 953 321 q 715 435 807 435 l 663 435 l 663 0 l 567 0 l 567 435 l 515 435 q 347 378 421 435 q 225 200 274 321 l 138 0 l 31 0 m 257 892 l 614 513 l 615 513 l 971 892 l 257 892 z "
  },
  Ѳ: {
    ha: 1182,
    x_min: 79,
    x_max: 1101,
    o: "m 590 981 q 793 944 700 981 q 956 840 886 907 q 1063 683 1025 774 q 1101 486 1101 593 q 1063 289 1101 379 q 956 132 1025 199 q 793 28 886 65 q 590 -8 700 -8 q 388 28 481 -8 q 225 133 294 65 q 117 290 156 200 q 79 486 79 379 q 117 683 79 593 q 225 840 156 772 q 388 944 294 907 q 590 981 481 981 m 590 889 q 438 863 508 889 q 312 788 367 836 q 224 673 257 739 q 185 528 192 607 l 996 528 q 956 673 989 607 q 868 788 922 739 q 743 863 814 836 q 590 889 672 889 m 590 83 q 743 110 672 83 q 868 185 814 136 q 956 300 922 233 q 996 446 989 367 l 185 446 q 224 300 192 367 q 312 185 257 233 q 438 110 367 136 q 590 83 508 83 z "
  },
  Ѵ: {
    ha: 1039,
    x_min: 26,
    x_max: 1024,
    o: "m 426 0 l 26 972 l 138 972 l 478 147 l 700 760 q 825 949 751 897 q 1024 969 899 1000 l 1011 869 q 873 851 924 890 q 782 700 822 813 l 528 0 l 426 0 z "
  },
  Ғ: {
    ha: 844,
    x_min: 49,
    x_max: 815,
    o: "m 49 413 l 49 490 l 717 490 l 717 413 l 49 413 m 197 0 l 197 972 l 815 972 l 815 883 l 271 883 l 299 910 l 299 0 l 197 0 z "
  },
  Ҕ: {
    ha: 974,
    x_min: 164,
    x_max: 900,
    o: "m 164 0 l 164 972 l 810 972 l 810 883 l 239 883 l 265 911 l 265 0 l 164 0 m 446 -185 l 464 -99 q 634 -86 558 -118 q 755 18 710 -54 q 800 190 800 90 q 768 331 800 272 q 681 425 736 390 q 557 467 626 460 q 410 451 488 474 q 256 375 332 429 l 246 463 q 436 541 342 521 q 614 547 531 561 q 762 488 697 533 q 863 369 826 443 q 900 197 900 294 q 865 19 900 99 q 768 -112 831 -60 q 624 -185 706 -165 q 446 -185 542 -204 z "
  },
  Җ: {
    ha: 1461,
    x_min: 33,
    x_max: 1442,
    o: "m 1251 0 l 928 485 l 1015 535 l 1371 0 l 1251 0 m 721 446 l 721 536 l 999 536 l 999 446 l 721 446 m 1019 475 l 925 492 l 1235 972 l 1346 972 l 1019 475 m 153 0 l 33 0 l 389 535 l 476 485 l 153 0 m 753 0 l 653 0 l 653 972 l 753 972 l 753 0 m 683 446 l 406 446 l 406 536 l 683 536 l 683 446 m 385 475 l 58 972 l 169 972 l 478 492 l 385 475 m 1347 -218 l 1347 28 l 1375 0 l 1253 0 l 1253 89 l 1443 89 l 1443 -218 l 1347 -218 z "
  },
  Ҙ: {
    ha: 883,
    x_min: 49,
    x_max: 792,
    o: "m 49 117 l 86 190 q 230 108 150 135 q 390 80 310 81 q 538 103 471 79 q 647 173 606 126 q 689 286 689 219 q 622 417 689 371 q 435 463 554 463 l 226 463 l 226 546 l 429 546 q 590 590 532 546 q 647 711 647 633 q 615 806 647 767 q 526 867 582 846 q 400 891 469 889 q 256 873 331 893 q 113 810 182 853 l 79 894 q 258 966 165 946 q 439 979 351 986 q 597 939 526 972 q 708 851 667 906 q 750 722 750 797 q 715 600 750 653 q 616 519 679 547 q 467 490 553 490 l 472 521 q 641 490 569 521 q 752 403 713 460 q 792 272 792 347 q 756 147 792 201 q 659 55 721 92 q 521 2 597 18 q 361 -7 444 -14 q 197 30 278 0 q 49 117 117 60 m 465 25 l 465 -218 l 371 -218 l 371 25 l 465 25 z "
  },
  Қ: {
    ha: 1039,
    x_min: 164,
    x_max: 1021,
    o: "m 829 0 l 456 485 l 539 535 l 947 0 l 829 0 m 164 0 l 164 972 l 264 972 l 264 0 l 164 0 m 233 446 l 233 536 l 538 536 l 538 446 l 233 446 m 547 475 l 453 492 l 815 972 l 926 972 l 547 475 m 925 -218 l 925 28 l 953 0 l 831 0 l 831 89 l 1021 89 l 1021 -218 l 925 -218 z "
  },
  Ҝ: {
    ha: 1010,
    x_min: 164,
    x_max: 979,
    o: "m 860 0 l 517 485 l 600 535 l 979 0 l 860 0 m 164 0 l 164 972 l 264 972 l 264 0 l 164 0 m 233 446 l 233 536 l 585 536 l 585 446 l 233 446 m 383 238 l 383 747 l 463 747 l 463 238 l 383 238 m 608 475 l 514 492 l 842 972 l 953 972 l 608 475 z "
  },
  Ҟ: {
    ha: 1006,
    x_min: 51,
    x_max: 978,
    o: "m 51 767 l 51 842 l 549 842 l 549 767 l 51 767 m 860 0 l 486 485 l 569 535 l 978 0 l 860 0 m 194 0 l 194 972 l 294 972 l 294 0 l 194 0 m 264 446 l 264 536 l 568 536 l 568 446 l 264 446 m 578 475 l 483 492 l 846 972 l 957 972 l 578 475 z "
  },
  Ҡ: {
    ha: 1129,
    x_min: 15,
    x_max: 1101,
    o: "m 15 883 l 15 972 l 419 972 l 419 883 l 15 883 m 985 0 l 610 485 l 693 535 l 1101 0 l 985 0 m 319 0 l 319 972 l 419 972 l 419 0 l 319 0 m 388 446 l 388 536 l 692 536 l 692 446 l 388 446 m 701 475 l 608 492 l 969 972 l 1081 972 l 701 475 z "
  },
  Ң: {
    ha: 1174,
    x_min: 164,
    x_max: 1132,
    o: "m 875 972 l 976 972 l 976 0 l 875 0 l 875 972 m 267 0 l 164 0 l 164 972 l 267 972 l 267 0 m 885 449 l 256 449 l 256 539 l 885 539 l 885 449 m 1036 -218 l 1036 28 l 1064 0 l 878 0 l 878 89 l 1132 89 l 1132 -218 l 1036 -218 z "
  },
  Ҥ: {
    ha: 1511,
    x_min: 164,
    x_max: 1496,
    o: "m 875 972 l 976 972 l 976 0 l 875 0 l 875 972 m 267 0 l 164 0 l 164 972 l 267 972 l 267 0 m 885 449 l 256 449 l 256 539 l 885 539 l 885 449 m 878 0 l 878 972 l 1496 972 l 1496 883 l 951 883 l 978 910 l 979 0 l 878 0 z "
  },
  "Ԥ": {
    ha: 1179,
    x_min: 164,
    x_max: 1135,
    o: "m 164 0 l 164 972 l 982 972 l 982 0 l 881 0 l 881 911 l 907 883 l 239 883 l 265 911 l 265 0 l 164 0 m 1039 -218 l 1039 28 l 1067 0 l 881 0 l 881 89 l 1135 89 l 1135 -218 l 1039 -218 z "
  },
  Ҩ: {
    ha: 1350,
    x_min: 88,
    x_max: 1246,
    o: "m 619 -8 q 404 29 501 -8 q 235 136 307 67 q 126 301 164 206 q 88 508 88 396 q 155 780 88 657 q 343 978 222 903 l 419 928 q 250 748 311 858 q 189 506 189 638 q 246 278 189 376 q 403 124 303 179 q 638 69 504 69 q 836 106 746 69 q 992 210 926 143 q 1093 366 1057 276 q 1129 561 1129 456 q 1096 733 1129 660 q 1003 848 1063 807 q 863 889 943 889 q 719 847 781 889 q 624 728 658 804 q 589 553 589 653 q 640 321 589 422 q 781 156 692 219 q 986 75 869 93 q 1233 93 1103 57 l 1246 15 q 1013 -8 1125 -17 q 806 45 901 1 q 638 163 710 89 q 526 336 567 238 q 486 553 486 435 q 534 774 486 678 q 667 926 582 871 q 864 981 751 981 q 1057 928 974 981 q 1186 784 1140 876 q 1232 572 1232 692 q 1202 389 1232 476 q 1116 228 1172 301 q 984 103 1060 156 q 816 21 908 50 q 619 -8 724 -8 z "
  },
  Ҫ: {
    ha: 994,
    x_min: 81,
    x_max: 946,
    o: "m 589 -8 q 386 28 479 -8 q 225 132 293 65 q 119 289 157 199 q 81 486 81 379 q 119 683 81 593 q 226 840 157 774 q 388 944 294 907 q 590 981 481 981 q 789 945 696 981 q 946 839 882 910 l 881 774 q 749 862 821 835 q 593 889 676 889 q 431 859 506 889 q 300 774 356 829 q 213 647 244 719 q 182 486 182 574 q 213 326 182 399 q 300 198 244 253 q 431 113 356 143 q 593 83 506 83 q 749 111 676 83 q 881 200 821 139 l 946 135 q 789 28 882 64 q 589 -8 696 -8 m 618 25 l 618 -218 l 524 -218 l 524 25 l 618 25 z "
  },
  Ҭ: {
    ha: 817,
    x_min: 15,
    x_max: 800,
    o: "m 357 0 l 357 911 l 385 883 l 15 883 l 15 972 l 800 972 l 800 883 l 432 883 l 458 911 l 458 0 l 357 0 m 515 -218 l 515 28 l 543 0 l 357 0 l 357 89 l 611 89 l 611 -218 l 515 -218 z "
  },
  Ү: {
    ha: 906,
    x_min: 13,
    x_max: 892,
    o: "m 401 0 l 401 361 l 425 297 l 13 972 l 122 972 l 485 379 l 426 379 l 789 972 l 892 972 l 481 297 l 503 361 l 503 0 l 401 0 z "
  },
  Ұ: {
    ha: 906,
    x_min: 13,
    x_max: 892,
    o: "m 157 307 l 157 379 l 743 379 l 743 307 l 157 307 m 401 0 l 401 361 l 425 297 l 13 972 l 122 972 l 485 379 l 426 379 l 789 972 l 892 972 l 481 297 l 503 361 l 503 0 l 401 0 z "
  },
  Ҳ: {
    ha: 958,
    x_min: 31,
    x_max: 942,
    o: "m 56 972 l 174 972 l 450 588 l 725 972 l 846 972 l 514 506 l 872 0 l 751 0 l 450 418 l 149 0 l 31 0 l 388 501 l 56 972 m 846 -218 l 846 28 l 874 0 l 751 0 l 751 89 l 942 89 l 942 -218 l 846 -218 z "
  },
  Ҵ: {
    ha: 1343,
    x_min: 17,
    x_max: 1303,
    o: "m 358 0 l 358 911 l 386 883 l 17 883 l 17 972 l 771 972 l 771 883 l 432 883 l 460 911 l 460 0 l 358 0 m 358 -1 l 358 971 l 460 971 l 460 89 l 1047 89 l 1047 971 l 1149 971 l 1149 -1 l 358 -1 m 1208 -229 l 1208 28 l 1233 -1 l 1047 -1 l 1047 89 l 1303 89 l 1303 -229 l 1208 -229 z "
  },
  Ҷ: {
    ha: 1049,
    x_min: 82,
    x_max: 1004,
    o: "m 768 411 q 602 354 685 374 q 443 335 519 335 q 177 417 272 335 q 82 651 82 500 l 82 972 l 183 972 l 183 663 q 255 488 183 550 q 453 425 326 425 q 608 445 528 425 q 768 503 689 465 l 768 411 m 750 0 l 750 972 l 850 972 l 850 0 l 750 0 m 908 -218 l 908 28 l 936 0 l 750 0 l 750 89 l 1004 89 l 1004 -218 l 908 -218 z "
  },
  Ҹ: {
    ha: 1015,
    x_min: 82,
    x_max: 850,
    o: "m 419 128 l 419 636 l 497 636 l 497 128 l 419 128 m 768 411 q 601 354 683 374 q 443 335 518 335 q 177 417 272 335 q 82 651 82 500 l 82 972 l 182 972 l 182 663 q 253 488 182 550 q 453 425 325 425 q 608 445 528 425 q 768 503 688 465 l 768 411 m 749 0 l 749 972 l 850 972 l 850 0 l 749 0 z "
  },
  Һ: {
    ha: 1015,
    x_min: 164,
    x_max: 933,
    o: "m 832 0 l 832 310 q 761 485 832 424 q 561 547 690 547 q 408 527 489 547 q 247 469 326 507 l 246 561 q 414 619 331 600 q 571 638 497 638 q 838 555 743 638 q 933 321 933 472 l 933 0 l 832 0 m 164 0 l 164 972 l 265 972 l 265 0 l 164 0 z "
  },
  "Ԧ": {
    ha: 1108,
    x_min: 164,
    x_max: 1086,
    o: "m 832 0 l 832 310 q 761 485 832 424 q 561 547 690 547 q 408 527 489 547 q 247 469 326 507 l 246 561 q 414 619 331 600 q 571 638 497 638 q 838 555 743 638 q 933 321 933 472 l 933 0 l 832 0 m 164 0 l 164 972 l 265 972 l 265 0 l 164 0 m 990 -218 l 990 28 l 1018 0 l 832 0 l 832 89 l 1086 89 l 1086 -218 l 990 -218 z "
  },
  Ҽ: {
    ha: 1353,
    x_min: 43,
    x_max: 1293,
    o: "m 808 -8 q 619 25 710 -8 q 459 122 529 58 q 349 276 389 185 q 308 483 308 368 q 347 688 308 596 q 455 844 386 779 q 613 945 524 910 q 803 981 703 981 q 993 946 904 981 q 1149 845 1082 911 q 1255 690 1217 779 q 1293 489 1293 600 q 1292 461 1293 476 q 1289 433 1290 446 l 272 433 q 143 465 194 433 q 67 548 92 496 q 48 663 43 600 q 89 790 53 726 l 183 769 q 147 683 156 726 q 152 602 139 639 q 199 543 165 565 q 283 521 232 521 l 1215 521 l 1189 486 q 1160 650 1190 576 q 1078 778 1131 724 q 955 861 1025 832 q 803 890 885 890 q 650 860 721 890 q 525 776 579 831 q 441 648 471 722 q 411 485 411 574 q 443 318 411 393 q 531 191 475 243 q 658 111 588 139 q 810 83 729 83 q 968 113 888 83 q 1119 204 1049 142 l 1193 138 q 1007 27 1107 63 q 808 -8 907 -8 z "
  },
  Ҿ: {
    ha: 1353,
    x_min: 43,
    x_max: 1293,
    o: "m 808 -8 q 619 25 710 -8 q 459 122 529 58 q 349 276 389 185 q 308 483 308 368 q 347 688 308 596 q 455 844 386 779 q 613 945 524 910 q 803 981 703 981 q 993 946 904 981 q 1149 845 1082 911 q 1255 690 1217 779 q 1293 489 1293 600 q 1292 461 1293 476 q 1289 433 1290 446 l 272 433 q 143 465 194 433 q 67 548 92 496 q 48 663 43 600 q 89 790 53 726 l 183 769 q 147 683 156 726 q 152 602 139 639 q 199 543 165 565 q 283 521 232 521 l 1215 521 l 1189 486 q 1160 650 1190 576 q 1078 778 1131 724 q 955 861 1025 832 q 803 890 885 890 q 650 860 721 890 q 525 776 579 831 q 441 648 471 722 q 411 485 411 574 q 443 318 411 393 q 531 191 475 243 q 658 111 588 139 q 810 83 729 83 q 968 113 888 83 q 1119 204 1049 142 l 1193 138 q 1007 27 1107 63 q 808 -8 907 -8 m 858 25 l 858 -218 l 764 -218 l 764 25 l 858 25 z "
  },
  Ӏ: {
    ha: 431,
    x_min: 164,
    x_max: 267,
    o: "m 164 0 l 164 972 l 267 972 l 267 0 l 164 0 z "
  },
  Ӂ: {
    ha: 1404,
    x_min: 33,
    x_max: 1371,
    o: "m 1251 0 l 928 485 l 1015 535 l 1371 0 l 1251 0 m 721 446 l 721 536 l 999 536 l 999 446 l 721 446 m 1019 475 l 925 492 l 1235 972 l 1346 972 l 1019 475 m 153 0 l 33 0 l 389 535 l 476 485 l 153 0 m 753 0 l 653 0 l 653 972 l 753 972 l 753 0 m 683 446 l 406 446 l 406 536 l 683 536 l 683 446 m 385 475 l 58 972 l 169 972 l 478 492 l 385 475 m 704 1043 q 540 1090 600 1043 q 478 1222 479 1138 l 554 1222 q 597 1135 556 1167 q 704 1103 638 1103 q 812 1135 771 1103 q 854 1222 853 1167 l 931 1222 q 868 1090 929 1138 q 704 1043 807 1043 z "
  },
  Ӄ: {
    ha: 975,
    x_min: 164,
    x_max: 935,
    o: "m 164 0 l 164 972 l 264 972 l 264 0 l 164 0 m 233 446 l 233 536 l 525 536 l 525 446 l 233 446 m 553 483 l 454 492 l 814 972 l 925 972 l 553 483 m 724 -278 q 568 -237 644 -278 l 597 -158 q 704 -189 656 -189 q 792 -155 760 -189 q 825 -58 825 -121 q 798 56 825 -8 q 721 190 771 119 q 603 331 671 260 q 458 468 536 403 l 538 525 q 747 314 657 418 q 885 114 836 210 q 935 -61 935 18 q 877 -220 935 -162 q 724 -278 819 -278 z "
  },
  Ӈ: {
    ha: 1133,
    x_min: 164,
    x_max: 969,
    o: "m 600 -229 l 633 -154 q 711 -188 671 -181 q 788 -185 751 -196 q 846 -144 824 -174 q 868 -67 868 -114 l 868 443 l 265 443 l 265 0 l 164 0 l 164 972 l 265 972 l 265 533 l 868 533 l 868 972 l 969 972 l 969 -72 q 932 -197 969 -150 q 838 -264 894 -244 q 717 -274 782 -283 q 600 -229 653 -265 z "
  },
  "Ӊ": {
    ha: 1174,
    x_min: 164,
    x_max: 1117,
    o: "m 875 972 l 976 972 l 976 0 l 875 0 l 875 972 m 267 0 l 164 0 l 164 972 l 267 972 l 267 0 m 885 449 l 256 449 l 256 539 l 885 539 l 885 449 m 942 -218 l 1006 28 l 1049 0 l 878 0 l 878 89 l 1117 89 l 1024 -218 l 942 -218 z "
  },
  Ӌ: {
    ha: 1011,
    x_min: 81,
    x_max: 847,
    o: "m 442 353 q 175 434 269 353 q 81 663 81 515 l 81 972 l 181 972 l 181 674 q 252 503 181 564 q 450 443 324 443 q 605 463 525 443 q 765 521 685 483 l 765 429 q 599 372 682 392 q 442 353 517 353 m 579 -218 l 579 89 l 847 89 l 847 0 l 661 0 l 675 28 l 675 -218 l 579 -218 m 746 0 l 746 972 l 847 972 l 847 0 l 746 0 z "
  },
  "Ӎ": {
    ha: 1379,
    x_min: 164,
    x_max: 1321,
    o: "m 164 0 l 164 972 l 249 972 l 693 214 l 649 214 l 1089 972 l 1174 972 l 1174 0 l 1075 0 l 1075 818 l 1099 818 l 693 124 l 644 124 l 236 818 l 263 818 l 263 0 l 164 0 m 1146 -218 l 1210 28 l 1253 0 l 1082 0 l 1082 89 l 1321 89 l 1228 -218 l 1146 -218 z "
  },
  Ӑ: {
    ha: 1033,
    x_min: 22,
    x_max: 1013,
    o: "m 21 0 l 465 972 l 567 972 l 1011 0 l 903 0 l 494 913 l 536 913 l 128 0 l 21 0 m 196 260 l 226 343 l 792 343 l 822 260 l 196 260 m 517 1043 q 352 1090 413 1043 q 290 1222 292 1138 l 367 1222 q 409 1135 368 1167 q 517 1103 450 1103 q 624 1135 583 1103 q 667 1222 665 1167 l 743 1222 q 681 1090 742 1138 q 517 1043 619 1043 z "
  },
  Ӓ: {
    ha: 1033,
    x_min: 22,
    x_max: 1013,
    o: "m 21 0 l 465 972 l 567 972 l 1011 0 l 903 0 l 494 913 l 536 913 l 128 0 l 21 0 m 196 260 l 226 343 l 792 343 l 822 260 l 196 260 z "
  },
  Ӕ: {
    ha: 1424,
    x_min: 13,
    x_max: 1361,
    o: "m 13 0 l 606 972 l 707 972 l 707 883 l 615 883 l 679 925 l 119 0 l 13 0 m 244 260 l 256 343 l 707 343 l 707 260 l 244 260 m 765 538 l 1281 538 l 1281 450 l 765 450 l 765 538 m 776 89 l 1361 89 l 1361 0 l 674 0 l 674 972 l 1340 972 l 1340 883 l 776 883 l 776 89 z "
  },
  Ӗ: {
    ha: 915,
    x_min: 164,
    x_max: 851,
    o: "m 256 538 l 769 538 l 769 450 l 256 450 l 256 538 m 267 89 l 851 89 l 851 0 l 164 0 l 164 972 l 831 972 l 831 883 l 267 883 l 267 89 m 499 1043 q 334 1090 394 1043 q 272 1222 274 1138 l 349 1222 q 391 1135 350 1167 q 499 1103 432 1103 q 606 1135 565 1103 q 649 1222 647 1167 l 725 1222 q 663 1090 724 1138 q 499 1043 601 1043 z "
  },
  Ә: {
    ha: 1144,
    x_min: 60,
    x_max: 1064,
    o: "m 558 -8 q 365 26 456 -8 q 206 127 275 61 q 99 283 138 193 q 60 483 60 374 q 60 508 60 496 q 64 533 61 521 l 1029 533 l 1029 457 l 136 457 l 163 486 q 192 324 163 397 q 276 196 222 250 q 403 112 331 142 q 558 82 475 82 q 715 112 642 82 q 844 196 789 142 q 931 324 900 250 q 961 488 961 399 q 928 654 961 579 q 838 781 896 729 q 707 861 781 833 q 551 889 633 889 q 390 860 472 889 q 235 768 308 831 l 161 835 q 351 945 250 910 q 554 981 453 981 q 747 947 656 981 q 910 851 839 914 q 1023 696 982 788 q 1064 489 1064 604 q 1024 285 1064 376 q 915 128 985 193 q 753 27 844 63 q 558 -8 663 -8 z "
  },
  Ӛ: {
    ha: 1144,
    x_min: 60,
    x_max: 1064,
    o: "m 558 -8 q 365 26 456 -8 q 206 127 275 61 q 99 283 138 193 q 60 483 60 374 q 60 508 60 496 q 64 533 61 521 l 1029 533 l 1029 457 l 136 457 l 163 486 q 192 324 163 397 q 276 196 222 250 q 403 112 331 142 q 558 82 475 82 q 715 112 642 82 q 844 196 789 142 q 931 324 900 250 q 961 488 961 399 q 928 654 961 579 q 838 781 896 729 q 707 861 781 833 q 551 889 633 889 q 390 860 472 889 q 235 768 308 831 l 161 835 q 351 945 250 910 q 554 981 453 981 q 747 947 656 981 q 910 851 839 914 q 1023 696 982 788 q 1064 489 1064 604 q 1024 285 1064 376 q 915 128 985 193 q 753 27 844 63 q 558 -8 663 -8 z "
  },
  Ӝ: {
    ha: 1404,
    x_min: 33,
    x_max: 1371,
    o: "m 1251 0 l 928 485 l 1015 535 l 1371 0 l 1251 0 m 721 446 l 721 536 l 999 536 l 999 446 l 721 446 m 1019 475 l 925 492 l 1235 972 l 1346 972 l 1019 475 m 153 0 l 33 0 l 389 535 l 476 485 l 153 0 m 753 0 l 653 0 l 653 972 l 753 972 l 753 0 m 683 446 l 406 446 l 406 536 l 683 536 l 683 446 m 385 475 l 58 972 l 169 972 l 478 492 l 385 475 z "
  },
  Ӟ: {
    ha: 883,
    x_min: 49,
    x_max: 792,
    o: "m 49 117 l 86 190 q 230 108 150 135 q 390 80 310 81 q 538 103 471 79 q 647 173 606 126 q 689 286 689 219 q 622 417 689 371 q 435 463 554 463 l 226 463 l 226 546 l 429 546 q 590 590 532 546 q 647 711 647 633 q 615 806 647 767 q 526 867 582 846 q 400 891 469 889 q 256 873 331 893 q 113 810 182 853 l 79 894 q 258 966 165 946 q 439 979 351 986 q 597 939 526 972 q 708 851 667 906 q 750 722 750 797 q 715 600 750 653 q 616 519 679 547 q 467 490 553 490 l 472 521 q 641 490 569 521 q 752 403 713 460 q 792 272 792 347 q 756 147 792 201 q 659 55 721 92 q 521 2 597 18 q 361 -7 444 -14 q 197 30 278 0 q 49 117 117 60 z "
  },
  Ӡ: {
    ha: 854,
    x_min: 44,
    x_max: 778,
    o: "m 410 -8 q 197 26 294 -8 q 44 114 100 60 l 85 194 q 219 113 135 146 q 407 81 304 81 q 606 134 538 81 q 675 279 675 188 q 607 421 675 368 q 394 474 539 474 l 322 474 l 322 546 l 646 922 l 654 885 l 81 885 l 81 972 l 735 972 l 735 901 l 413 525 l 372 556 l 410 556 q 615 521 533 556 q 737 424 696 486 q 778 279 778 361 q 737 132 778 197 q 614 29 696 67 q 410 -8 532 -8 z "
  },
  Ӣ: {
    ha: 1144,
    x_min: 164,
    x_max: 981,
    o: "m 164 0 l 164 972 l 265 972 l 265 167 l 888 972 l 981 972 l 981 0 l 879 0 l 879 804 l 257 0 l 164 0 z "
  },
  Ӥ: {
    ha: 1144,
    x_min: 164,
    x_max: 981,
    o: "m 164 0 l 164 972 l 265 972 l 265 167 l 888 972 l 981 972 l 981 0 l 879 0 l 879 804 l 257 0 l 164 0 z "
  },
  Ӧ: {
    ha: 1182,
    x_min: 79,
    x_max: 1101,
    o: "m 590 -8 q 387 28 481 -8 q 224 133 293 65 q 117 290 156 200 q 79 486 79 379 q 117 683 79 593 q 224 840 156 772 q 386 944 293 907 q 590 981 479 981 q 793 944 700 981 q 955 840 886 907 q 1062 683 1024 774 q 1100 486 1100 593 q 1062 289 1100 379 q 955 132 1024 199 q 793 28 886 65 q 590 -8 700 -8 m 590 83 q 752 113 678 83 q 881 198 826 143 q 967 326 936 253 q 997 486 997 399 q 967 647 997 574 q 881 774 936 719 q 752 859 826 829 q 590 889 678 889 q 428 859 503 889 q 298 774 353 829 q 212 647 243 719 q 181 486 181 574 q 212 326 181 400 q 298 198 243 253 q 428 113 353 143 q 590 83 503 83 z "
  },
  Ө: {
    ha: 1182,
    x_min: 79,
    x_max: 1101,
    o: "m 590 981 q 793 944 700 981 q 956 840 886 907 q 1063 683 1025 774 q 1101 486 1101 593 q 1063 289 1101 379 q 956 132 1025 199 q 793 28 886 65 q 590 -8 700 -8 q 388 28 481 -8 q 225 133 294 65 q 117 290 156 200 q 79 486 79 379 q 117 683 79 593 q 225 840 156 772 q 388 944 294 907 q 590 981 481 981 m 590 889 q 438 863 508 889 q 312 788 367 836 q 224 673 257 739 q 185 528 192 607 l 996 528 q 956 673 989 607 q 868 788 922 739 q 743 863 814 836 q 590 889 672 889 m 590 83 q 743 110 672 83 q 868 185 814 136 q 956 300 922 233 q 996 446 989 367 l 185 446 q 224 300 192 367 q 312 185 257 233 q 438 110 367 136 q 590 83 508 83 z "
  },
  Ӫ: {
    ha: 1182,
    x_min: 79,
    x_max: 1101,
    o: "m 590 981 q 793 944 700 981 q 956 840 886 907 q 1063 683 1025 774 q 1101 486 1101 593 q 1063 289 1101 379 q 956 132 1025 199 q 793 28 886 65 q 590 -8 700 -8 q 388 28 481 -8 q 225 133 294 65 q 117 290 156 200 q 79 486 79 379 q 117 683 79 593 q 225 840 156 772 q 388 944 294 907 q 590 981 481 981 m 590 889 q 438 863 508 889 q 312 788 367 836 q 224 673 257 739 q 185 528 192 607 l 996 528 q 956 673 989 607 q 868 788 922 739 q 743 863 814 836 q 590 889 672 889 m 590 83 q 743 110 672 83 q 868 185 814 136 q 956 300 922 233 q 996 446 989 367 l 185 446 q 224 300 192 367 q 312 185 257 233 q 438 110 367 136 q 590 83 508 83 z "
  },
  Ӭ: {
    ha: 981,
    x_min: 49,
    x_max: 899,
    o: "m 293 453 l 293 538 l 831 538 l 831 453 l 293 453 m 415 981 q 607 944 519 981 q 760 840 694 907 q 863 683 826 774 q 899 486 899 593 q 863 289 899 379 q 760 132 826 199 q 607 28 694 65 q 415 -8 519 -8 q 208 28 304 -8 q 49 135 113 64 l 113 200 q 249 110 174 138 q 411 83 324 83 q 563 114 493 83 q 685 199 633 144 q 767 326 738 253 q 796 486 796 399 q 767 647 796 574 q 685 774 738 719 q 563 858 633 828 q 411 889 493 889 q 249 861 324 889 q 113 772 174 833 l 49 838 q 208 944 113 908 q 415 981 304 981 z "
  },
  Ӯ: {
    ha: 944,
    x_min: 29,
    x_max: 928,
    o: "m 147 96 q 281 83 218 68 q 396 181 343 97 l 443 256 l 453 268 l 825 972 l 928 972 l 486 158 q 381 32 442 74 q 253 -12 321 -10 q 118 13 186 -15 l 147 96 m 450 175 l 29 972 l 139 972 l 506 260 l 450 175 z "
  },
  Ӱ: {
    ha: 944,
    x_min: 29,
    x_max: 928,
    o: "m 147 96 q 281 83 218 68 q 396 181 343 97 l 443 256 l 453 268 l 825 972 l 928 972 l 486 158 q 381 32 442 74 q 253 -12 321 -10 q 118 13 186 -15 l 147 96 m 450 175 l 29 972 l 139 972 l 506 260 l 450 175 z "
  },
  Ӳ: {
    ha: 944,
    x_min: 29,
    x_max: 928,
    o: "m 147 96 q 281 83 218 68 q 396 181 343 97 l 443 256 l 453 268 l 825 972 l 928 972 l 486 158 q 381 32 442 74 q 253 -12 321 -10 q 118 13 186 -15 l 147 96 m 450 175 l 29 972 l 139 972 l 506 260 l 450 175 z "
  },
  Ӵ: {
    ha: 1015,
    x_min: 82,
    x_max: 850,
    o: "m 768 411 q 602 354 685 374 q 443 335 519 335 q 177 417 272 335 q 82 651 82 500 l 82 972 l 183 972 l 183 663 q 255 488 183 550 q 453 425 326 425 q 608 445 528 425 q 768 503 689 465 l 768 411 m 750 0 l 750 972 l 850 972 l 850 0 l 750 0 z "
  },
  "Ӷ": {
    ha: 794,
    x_min: 164,
    x_max: 782,
    o: "m 164 0 l 164 972 l 782 972 l 782 883 l 238 883 l 264 910 l 265 0 l 164 0 m 322 -218 l 322 28 l 350 0 l 164 0 l 164 89 l 418 89 l 418 -218 l 322 -218 z "
  },
  Ӹ: {
    ha: 1358,
    x_min: 164,
    x_max: 1194,
    o: "m 571 625 q 834 548 743 625 q 925 319 925 471 q 828 81 925 163 q 550 0 731 0 l 164 0 l 164 972 l 265 972 l 265 625 l 571 625 m 547 82 q 752 142 682 82 q 822 317 822 201 q 753 487 822 432 q 547 542 683 542 l 265 542 l 265 82 l 547 82 m 1093 0 l 1093 972 l 1194 972 l 1194 0 l 1093 0 z "
  },
  "Ӻ": {
    ha: 846,
    x_min: 49,
    x_max: 817,
    o: "m 197 0 l 197 972 l 817 972 l 817 883 l 299 883 l 299 0 l 197 0 m 236 -276 q 153 -265 194 -276 q 76 -228 111 -253 l 110 -156 q 221 -192 158 -192 q 311 -158 276 -192 q 346 -56 346 -124 l 346 22 l 376 0 l 197 0 l 197 89 l 444 89 l 444 -69 q 417 -181 444 -135 q 344 -252 390 -228 q 236 -276 297 -276 m 49 413 l 49 490 l 717 490 l 717 413 l 49 413 z "
  },
  "Ӽ": {
    ha: 904,
    x_min: 28,
    x_max: 861,
    o: "m 28 0 l 392 500 l 51 972 l 169 972 l 456 576 l 740 972 l 853 972 l 513 501 l 461 439 l 147 0 l 28 0 m 650 -278 q 572 -267 611 -278 q 496 -237 533 -257 l 524 -164 q 631 -194 579 -194 q 719 -160 686 -194 q 751 -64 751 -126 q 724 43 751 -17 q 651 169 697 103 q 549 306 606 235 q 435 449 493 376 l 500 521 q 634 352 569 433 q 750 197 699 271 q 831 57 801 124 q 861 -68 861 -10 q 833 -181 861 -135 q 758 -253 806 -228 q 650 -278 711 -278 z "
  },
  "Ӿ": {
    ha: 928,
    x_min: 44,
    x_max: 886,
    o: "m 136 460 l 136 538 l 781 538 l 781 460 l 136 460 m 69 972 l 188 972 l 464 588 l 740 972 l 860 972 l 528 506 l 886 0 l 765 0 l 464 418 l 164 0 l 44 0 l 403 501 l 69 972 z "
  },
  "Ԑ": {
    ha: 882,
    x_min: 90,
    x_max: 833,
    o: "m 833 117 q 685 30 767 60 q 521 -7 604 0 q 361 2 438 -14 q 223 55 285 18 q 126 147 161 92 q 90 272 90 201 q 130 403 90 347 q 241 490 169 460 q 410 521 313 521 l 415 490 q 266 519 329 490 q 167 600 203 547 q 132 722 132 653 q 174 852 132 797 q 285 940 215 907 q 443 980 356 972 q 624 967 531 988 q 803 894 717 946 l 769 811 q 626 874 700 854 q 482 892 551 893 q 356 869 413 890 q 267 807 300 847 q 235 711 235 767 q 292 590 235 633 q 453 546 350 546 l 656 546 l 656 463 l 447 463 q 261 417 328 463 q 194 286 194 371 q 235 173 194 219 q 344 103 276 126 q 492 80 411 79 q 652 108 572 81 q 796 190 732 135 l 833 117 z "
  },
  "Ԓ": {
    ha: 1092,
    x_min: 15,
    x_max: 928,
    o: "m 558 -229 l 592 -154 q 670 -188 629 -181 q 747 -185 711 -196 q 804 -144 782 -174 q 826 -67 826 -114 l 826 883 l 357 883 l 344 558 q 324 306 339 413 q 279 128 308 199 q 204 24 250 58 q 93 -10 158 -10 q 56 -8 75 -10 q 15 0 38 -6 l 24 92 q 69 86 47 86 q 169 135 132 86 q 226 288 207 185 q 253 556 246 392 l 268 972 l 928 972 l 928 -72 q 891 -197 928 -150 q 797 -264 854 -244 q 676 -274 740 -283 q 558 -229 613 -265 z "
  },
  "Ԛ": {
    ha: 1188,
    x_min: 79,
    x_max: 1146,
    o: "m 590 -8 q 387 28 481 -8 q 224 133 293 65 q 117 290 156 200 q 79 486 79 379 q 117 683 79 593 q 224 840 156 772 q 386 944 293 907 q 590 981 479 981 q 793 944 700 981 q 955 840 886 907 q 1062 683 1024 774 q 1100 486 1100 593 q 1062 289 1100 379 q 955 132 1024 199 q 793 28 886 65 q 590 -8 700 -8 m 908 -193 q 822 -182 864 -193 q 738 -147 781 -171 q 651 -83 696 -122 q 554 11 607 -44 l 667 39 q 751 -46 710 -12 q 831 -95 792 -79 q 910 -111 871 -111 q 1094 -22 1018 -111 l 1144 -82 q 908 -193 1053 -193 m 590 83 q 752 113 678 83 q 881 199 826 143 q 967 327 936 254 q 997 486 997 400 q 967 647 997 574 q 881 774 936 719 q 752 859 826 829 q 590 889 678 889 q 428 859 503 889 q 298 774 353 829 q 212 647 243 719 q 181 486 181 574 q 212 327 181 400 q 298 199 243 254 q 428 113 353 143 q 590 83 503 83 z "
  },
  "Ԝ": {
    ha: 1489,
    x_min: 36,
    x_max: 1453,
    o: "m 360 0 l 36 972 l 143 972 l 446 57 l 390 57 l 701 972 l 796 972 l 1101 57 l 1049 57 l 1354 972 l 1453 972 l 1131 0 l 1024 0 l 733 867 l 761 867 l 467 0 l 360 0 z "
  },
  Ҍ: {
    ha: 1021,
    x_min: 46,
    x_max: 960,
    o: "m 199 0 l 199 1031 l 300 1031 l 300 621 l 608 621 q 870 544 781 621 q 960 317 960 467 q 864 81 960 163 q 586 0 768 0 l 199 0 m 300 82 l 586 82 q 789 140 721 82 q 857 313 857 199 q 586 539 857 539 l 300 539 l 300 82 m 46 782 l 46 860 l 610 860 l 610 782 l 46 782 z "
  },
  Ҏ: {
    ha: 1017,
    x_min: 164,
    x_max: 925,
    o: "m 164 0 l 164 972 l 528 972 q 740 932 651 972 q 877 817 829 892 q 925 636 925 743 q 877 455 925 531 q 740 340 829 379 q 528 300 651 300 l 239 300 l 267 329 l 267 0 l 164 0 m 267 358 l 239 389 l 525 389 q 747 453 671 389 q 822 636 822 518 q 747 819 822 756 q 525 883 671 883 l 239 883 l 267 913 l 267 358 m 908 178 l 850 131 l 485 608 l 542 656 l 908 178 z "
  },
  "Ԩ": {
    ha: 1135,
    x_min: -101,
    x_max: 971,
    o: "m -101 -229 l -68 -154 q 10 -188 -31 -181 q 85 -185 50 -196 q 144 -144 121 -174 q 167 -67 167 -114 l 167 972 l 267 972 l 267 533 l 869 533 l 869 972 l 971 972 l 971 0 l 869 0 l 869 443 l 267 443 l 267 -72 q 230 -197 267 -150 q 136 -264 193 -244 q 16 -274 79 -283 q -101 -229 -47 -265 z "
  },
  "Ԯ": {
    ha: 1124,
    x_min: 15,
    x_max: 1079,
    o: "m 93 -10 q 56 -8 74 -10 q 15 0 38 -6 l 24 92 q 69 86 47 86 q 170 135 132 86 q 228 288 208 185 q 253 556 247 392 l 267 972 l 926 972 l 926 0 l 825 0 l 825 911 l 851 883 l 332 883 l 357 913 l 344 558 q 324 306 339 413 q 279 128 308 199 q 204 24 250 58 q 93 -10 158 -10 m 983 -218 l 983 28 l 1011 0 l 825 0 l 825 89 l 1079 89 l 1079 -218 l 983 -218 z "
  },
  а: {
    ha: 810,
    x_min: 75,
    x_max: 688,
    o: "m 593 0 l 593 161 l 589 188 l 589 457 q 537 600 589 550 q 382 650 485 650 q 247 626 311 650 q 139 564 183 603 l 94 638 q 228 710 150 685 q 392 736 306 736 q 610 666 533 736 q 688 453 688 596 l 688 0 l 593 0 m 342 -7 q 199 20 260 -7 q 107 95 139 47 q 75 206 75 143 q 102 309 75 263 q 191 384 129 356 q 357 413 253 413 l 608 413 l 608 339 l 360 339 q 213 301 254 339 q 172 208 172 264 q 221 108 172 146 q 357 71 269 71 q 501 109 440 71 q 589 219 561 147 l 611 151 q 515 36 583 79 q 342 -7 446 -7 z "
  },
  б: {
    ha: 915,
    x_min: 94,
    x_max: 844,
    o: "m 468 -8 q 310 21 379 -8 q 193 110 242 50 q 119 258 144 169 q 94 463 94 346 q 114 645 94 567 q 168 781 133 724 q 249 877 203 838 q 351 941 296 917 q 464 978 406 965 l 792 1054 l 808 963 l 500 893 q 430 874 471 886 q 347 836 389 861 q 268 767 304 811 q 210 652 232 722 q 189 478 189 582 q 190 442 189 456 q 194 415 192 429 q 197 372 196 400 l 154 408 q 217 556 169 493 q 335 655 264 619 q 494 690 407 690 q 675 647 596 690 q 799 525 754 603 q 844 344 844 447 q 798 163 844 243 q 667 37 751 82 q 468 -8 582 -8 m 479 74 q 617 109 557 74 q 710 206 676 144 q 744 343 744 267 q 710 476 744 418 q 617 569 676 535 q 478 603 557 603 q 340 570 400 603 q 247 479 281 538 q 213 344 213 421 q 247 207 213 268 q 341 110 281 146 q 479 74 401 74 z "
  },
  в: {
    ha: 844,
    x_min: 140,
    x_max: 754,
    o: "m 140 0 l 140 729 l 463 729 q 658 682 586 729 q 729 543 729 635 q 661 406 729 454 q 482 358 593 358 l 501 388 q 693 339 632 388 q 754 199 754 290 q 685 52 754 104 q 472 0 617 0 l 140 0 m 236 78 l 468 78 q 609 108 561 78 q 657 204 657 138 q 614 301 657 271 q 478 332 571 332 l 236 332 l 236 78 m 236 406 l 456 406 q 585 438 540 406 q 631 531 631 469 q 585 622 631 592 q 456 653 540 653 l 236 653 l 236 406 z "
  },
  г: {
    ha: 660,
    x_min: 140,
    x_max: 657,
    o: "m 140 0 l 140 729 l 657 729 l 657 643 l 214 643 l 239 668 l 239 0 l 140 0 z "
  },
  ѓ: {
    ha: 660,
    x_min: 140,
    x_max: 657,
    o: "m 140 0 l 140 729 l 657 729 l 657 643 l 214 643 l 239 668 l 239 0 l 140 0 m 313 842 l 503 1014 l 635 1014 l 410 842 l 313 842 z "
  },
  ґ: {
    ha: 624,
    x_min: 140,
    x_max: 619,
    o: "m 140 0 l 140 729 l 528 729 l 528 881 l 619 881 l 619 643 l 239 643 l 239 0 l 140 0 z "
  },
  д: {
    ha: 904,
    x_min: 13,
    x_max: 853,
    o: "m 640 47 l 640 643 l 289 643 l 281 481 q 272 336 278 407 q 251 206 265 265 q 210 110 236 147 q 142 68 183 74 l 43 86 q 114 117 86 85 q 157 207 142 150 q 179 337 172 264 q 190 486 186 410 l 200 729 l 739 729 l 739 47 l 640 47 m 13 -176 l 13 86 l 853 86 l 853 -176 l 760 -176 l 760 0 l 106 0 l 106 -176 l 13 -176 z "
  },
  е: {
    ha: 858,
    x_min: 71,
    x_max: 781,
    o: "m 453 -7 q 253 41 339 -7 q 118 173 167 89 q 69 365 69 257 q 116 557 69 474 q 244 688 163 640 q 426 736 325 736 q 609 690 529 736 q 735 559 689 643 q 781 365 781 475 q 780 351 781 358 q 779 335 779 343 l 144 335 l 144 408 l 726 408 l 688 379 q 653 520 688 458 q 561 617 619 582 q 426 651 503 651 q 292 617 351 651 q 199 519 232 582 q 165 376 165 457 l 165 361 q 202 215 165 278 q 305 116 239 151 q 456 81 371 81 q 580 104 522 81 q 679 176 638 128 l 735 113 q 613 24 686 54 q 453 -7 540 -7 z "
  },
  ѐ: {
    ha: 868,
    x_min: 71,
    x_max: 781,
    o: "m 453 -7 q 253 41 339 -7 q 118 173 167 89 q 69 365 69 257 q 116 557 69 474 q 244 688 163 640 q 426 736 325 736 q 609 690 529 736 q 735 559 689 643 q 781 365 781 475 q 780 351 781 358 q 779 335 779 343 l 144 335 l 144 408 l 726 408 l 688 379 q 653 520 688 458 q 561 617 619 582 q 426 651 503 651 q 292 617 351 651 q 199 519 232 582 q 165 376 165 457 l 165 361 q 202 215 165 278 q 305 116 239 151 q 456 81 371 81 q 580 104 522 81 q 679 176 638 128 l 735 113 q 613 24 686 54 q 453 -7 540 -7 m 418 843 l 193 1015 l 325 1015 l 515 843 l 418 843 z "
  },
  ё: {
    ha: 858,
    x_min: 71,
    x_max: 781,
    o: "m 453 -7 q 253 41 339 -7 q 118 173 167 89 q 69 365 69 257 q 116 557 69 474 q 244 688 163 640 q 426 736 325 736 q 609 690 529 736 q 735 559 689 643 q 781 365 781 475 q 780 351 781 358 q 779 335 779 343 l 144 335 l 144 408 l 726 408 l 688 379 q 653 520 688 458 q 561 617 619 582 q 426 651 503 651 q 292 617 351 651 q 199 519 232 582 q 165 376 165 457 l 165 361 q 202 215 165 278 q 305 116 239 151 q 456 81 371 81 q 580 104 522 81 q 679 176 638 128 l 735 113 q 613 24 686 54 q 453 -7 540 -7 m 550 875 q 508 892 526 875 q 490 935 490 908 q 508 978 490 961 q 550 994 526 994 q 592 978 575 994 q 610 935 610 961 q 592 892 610 908 q 550 875 575 875 m 303 875 q 260 892 278 875 q 243 935 243 908 q 260 978 243 961 q 303 994 278 994 q 344 978 326 994 q 363 935 363 961 q 344 892 363 908 q 303 875 326 875 z "
  },
  ж: {
    ha: 1147,
    x_min: 24,
    x_max: 1124,
    o: "m 1006 0 l 756 361 l 838 410 l 1124 0 l 1006 0 m 592 325 l 592 410 l 822 410 l 822 325 l 592 325 m 847 354 l 753 368 l 996 729 l 1103 729 l 847 354 m 142 0 l 24 0 l 310 410 l 390 361 l 142 0 m 622 0 l 524 0 l 524 729 l 622 729 l 622 0 m 554 325 l 325 325 l 325 410 l 554 410 l 554 325 m 301 354 l 44 729 l 151 729 l 393 368 l 301 354 z "
  },
  з: {
    ha: 742,
    x_min: 42,
    x_max: 658,
    o: "m 336 -8 q 499 19 426 -8 q 615 97 572 47 q 658 211 658 146 q 588 343 658 294 q 393 392 518 392 l 389 365 q 515 388 460 365 q 604 450 571 410 q 638 544 638 490 q 596 649 638 606 q 484 717 554 693 q 326 738 414 740 q 199 720 263 738 q 72 669 136 703 l 100 593 q 215 637 157 622 q 328 653 274 651 q 435 639 388 653 q 509 597 482 625 q 536 531 536 569 q 513 468 536 494 q 449 428 490 442 q 353 414 407 414 l 235 414 l 235 342 l 360 342 q 504 309 451 342 q 557 218 557 276 q 529 146 557 178 q 451 96 501 114 q 333 76 401 78 q 196 97 265 76 q 74 156 126 117 l 42 82 q 179 14 101 36 q 336 -8 257 -8 z "
  },
  и: {
    ha: 956,
    x_min: 140,
    x_max: 814,
    o: "m 140 0 l 140 729 l 239 729 l 239 150 l 726 729 l 814 729 l 814 0 l 715 0 l 715 581 l 229 0 l 140 0 z "
  },
  й: {
    ha: 956,
    x_min: 140,
    x_max: 814,
    o: "m 140 0 l 140 729 l 239 729 l 239 150 l 726 729 l 814 729 l 814 0 l 715 0 l 715 581 l 229 0 l 140 0 m 471 835 q 323 881 379 835 q 264 1015 267 928 l 335 1015 q 374 928 336 960 q 471 896 411 896 q 569 928 531 896 q 608 1015 607 960 l 679 1015 q 621 881 678 928 q 471 835 564 835 z "
  },
  ѝ: {
    ha: 956,
    x_min: 140,
    x_max: 814,
    o: "m 140 0 l 140 729 l 239 729 l 239 150 l 726 729 l 814 729 l 814 0 l 715 0 l 715 581 l 229 0 l 140 0 m 465 843 l 240 1015 l 372 1015 l 563 843 l 465 843 z "
  },
  "ҋ": {
    ha: 982,
    x_min: 140,
    x_max: 933,
    o: "m 140 0 l 140 729 l 239 729 l 239 150 l 726 729 l 814 729 l 814 0 l 715 0 l 715 581 l 229 0 l 140 0 m 472 836 q 324 884 385 836 q 261 1015 264 932 l 331 1015 q 374 929 333 961 q 472 897 415 897 q 572 929 531 897 q 614 1015 613 961 l 683 1015 q 620 884 681 932 q 472 836 560 836 m 778 -160 l 829 26 l 889 0 l 717 0 l 717 86 l 935 86 l 858 -160 l 778 -160 z "
  },
  к: {
    ha: 807,
    x_min: 140,
    x_max: 792,
    o: "m 675 0 l 375 361 l 457 410 l 792 0 l 675 0 m 140 0 l 140 729 l 239 729 l 239 0 l 140 0 m 208 325 l 208 410 l 443 410 l 443 325 l 208 325 m 465 354 l 374 368 l 664 729 l 771 729 l 465 354 z "
  },
  ќ: {
    ha: 807,
    x_min: 140,
    x_max: 792,
    o: "m 675 0 l 375 361 l 457 410 l 792 0 l 675 0 m 140 0 l 140 729 l 239 729 l 239 0 l 140 0 m 208 325 l 208 410 l 443 410 l 443 325 l 208 325 m 465 354 l 374 368 l 664 729 l 771 729 l 465 354 m 325 843 l 515 1015 l 647 1015 l 422 843 l 325 843 z "
  },
  л: {
    ha: 878,
    x_min: 7,
    x_max: 738,
    o: "m 7 1 l 14 86 q 33 83 24 85 q 49 81 42 81 q 120 114 93 81 q 161 203 147 147 q 181 328 175 258 q 190 469 186 399 l 203 729 l 738 729 l 738 0 l 639 0 l 639 672 l 664 643 l 267 643 l 290 674 l 279 463 q 265 282 275 368 q 233 131 254 196 q 174 28 211 65 q 78 -8 136 -8 q 44 -6 61 -8 q 7 1 26 -3 z "
  },
  м: {
    ha: 1097,
    x_min: 140,
    x_max: 957,
    o: "m 140 0 l 140 729 l 240 729 l 571 169 l 529 169 l 865 729 l 957 729 l 957 0 l 867 0 l 867 617 l 885 608 l 571 89 l 526 89 l 210 614 l 231 618 l 231 0 l 140 0 z "
  },
  н: {
    ha: 938,
    x_min: 140,
    x_max: 797,
    o: "m 140 0 l 140 729 l 239 729 l 239 407 l 699 407 l 699 729 l 797 729 l 797 0 l 699 0 l 699 322 l 239 322 l 239 0 l 140 0 z "
  },
  о: {
    ha: 883,
    x_min: 69,
    x_max: 813,
    o: "m 440 -7 q 251 41 335 -7 q 118 173 167 89 q 69 365 69 257 q 118 558 69 475 q 250 689 167 642 q 440 736 333 736 q 633 689 549 736 q 765 558 717 642 q 813 365 813 475 q 765 173 813 257 q 632 41 717 89 q 440 -7 547 -7 m 440 81 q 581 116 519 81 q 677 216 642 151 q 713 365 713 281 q 677 515 713 451 q 581 615 642 579 q 442 650 519 650 q 303 615 364 650 q 206 515 242 579 q 169 365 169 451 q 206 216 169 281 q 303 116 242 151 q 440 81 364 81 z "
  },
  п: {
    ha: 936,
    x_min: 140,
    x_max: 796,
    o: "m 140 0 l 140 729 l 796 729 l 796 0 l 697 0 l 697 669 l 722 643 l 214 643 l 239 669 l 239 0 l 140 0 z "
  },
  р: {
    ha: 953,
    x_min: 142,
    x_max: 882,
    o: "m 517 -7 q 346 37 422 -7 q 224 163 269 81 q 179 365 179 246 q 224 567 179 485 q 344 693 268 650 q 517 736 421 736 q 703 690 621 736 q 833 559 786 643 q 881 365 881 475 q 833 171 881 254 q 703 40 786 88 q 517 -7 621 -7 m 140 -269 l 140 729 l 235 729 l 235 510 l 225 364 l 239 217 l 239 -269 l 140 -269 m 510 81 q 649 116 588 81 q 746 216 710 151 q 782 365 782 281 q 746 514 782 450 q 649 614 710 578 q 510 650 588 650 q 370 614 432 650 q 273 514 308 578 q 238 365 238 450 q 273 216 238 281 q 370 116 308 151 q 510 81 432 81 z "
  },
  с: {
    ha: 782,
    x_min: 69,
    x_max: 732,
    o: "m 446 -7 q 252 41 338 -7 q 118 173 167 89 q 69 365 69 257 q 118 558 69 475 q 252 689 167 642 q 446 736 338 736 q 614 700 539 736 q 732 592 689 664 l 658 542 q 565 624 621 597 q 444 650 510 650 q 304 615 367 650 q 206 515 242 579 q 169 365 169 451 q 206 215 169 279 q 304 116 242 151 q 444 81 367 81 q 565 107 510 81 q 658 188 621 133 l 732 138 q 614 30 689 67 q 446 -7 539 -7 z "
  },
  т: {
    ha: 657,
    x_min: 3,
    x_max: 654,
    o: "m 279 0 l 279 669 l 304 643 l 3 643 l 3 729 l 654 729 l 654 643 l 353 643 l 378 669 l 378 0 l 279 0 z "
  },
  у: {
    ha: 775,
    x_min: -25,
    x_max: 761,
    o: "m 153 -276 q 55 -260 101 -276 q -25 -210 8 -243 l 21 -136 q 81 -177 49 -162 q 154 -192 114 -192 q 238 -165 203 -192 q 306 -69 274 -137 l 353 38 l 364 53 l 664 729 l 761 729 l 396 -87 q 328 -200 365 -158 q 249 -259 292 -242 q 153 -276 206 -276 m 347 -21 l 11 729 l 114 729 l 411 60 l 347 -21 z "
  },
  ў: {
    ha: 775,
    x_min: -25,
    x_max: 761,
    o: "m 153 -276 q 55 -260 101 -276 q -25 -210 8 -243 l 21 -136 q 81 -177 49 -162 q 154 -192 114 -192 q 238 -165 203 -192 q 306 -69 274 -137 l 353 38 l 364 53 l 664 729 l 761 729 l 396 -87 q 328 -200 365 -158 q 249 -259 292 -242 q 153 -276 206 -276 m 347 -21 l 11 729 l 114 729 l 411 60 l 347 -21 m 367 835 q 219 881 275 835 q 160 1015 163 928 l 231 1015 q 269 928 232 960 q 367 896 307 896 q 465 928 426 896 q 504 1015 503 960 l 575 1015 q 517 881 574 928 q 367 835 460 835 z "
  },
  ф: {
    ha: 1090,
    x_min: 68,
    x_max: 1022,
    o: "m 550 -8 q 544 -8 550 -8 q 534 -8 539 -8 q 526 -8 529 -8 q 189 90 310 -7 q 68 367 68 188 q 190 640 68 543 q 532 738 311 736 q 538 738 533 738 q 547 738 543 738 q 553 738 551 738 q 899 640 775 736 q 1022 367 1022 543 q 898 89 1022 186 q 550 -8 774 -8 m 549 78 q 756 112 672 78 q 882 210 839 146 q 925 367 925 274 q 882 520 925 457 q 756 617 839 583 q 549 650 672 650 q 541 650 547 650 q 533 650 535 650 q 331 616 413 650 q 207 519 249 582 q 165 367 165 457 q 208 211 165 275 q 332 113 250 147 q 533 78 414 79 q 542 78 536 78 q 549 78 547 78 m 496 -269 l 496 1031 l 592 1031 l 592 -269 l 496 -269 z "
  },
  х: {
    ha: 731,
    x_min: 21,
    x_max: 710,
    o: "m 21 0 l 329 400 l 328 351 l 35 729 l 146 729 l 386 417 l 344 418 l 585 729 l 693 729 l 397 347 l 399 400 l 710 0 l 597 0 l 343 333 l 382 328 l 132 0 l 21 0 z "
  },
  ч: {
    ha: 832,
    x_min: 65,
    x_max: 692,
    o: "m 601 308 q 473 265 538 281 q 344 249 408 249 q 140 308 215 249 q 65 490 65 367 l 65 729 l 163 729 l 163 496 q 217 371 163 413 q 363 329 271 329 q 479 344 418 329 q 603 386 540 358 l 601 308 m 593 0 l 593 729 l 692 729 l 692 0 l 593 0 z "
  },
  ц: {
    ha: 950,
    x_min: 140,
    x_max: 901,
    o: "m 140 0 l 140 729 l 239 729 l 239 86 l 685 86 l 685 729 l 783 729 l 783 0 l 140 0 m 808 -176 l 808 8 l 833 0 l 685 0 l 685 86 l 901 86 l 901 -176 l 808 -176 z "
  },
  ш: {
    ha: 1289,
    x_min: 140,
    x_max: 1149,
    o: "m 619 86 l 597 60 l 597 729 l 696 729 l 696 60 l 669 86 l 1076 86 l 1050 60 l 1050 729 l 1149 729 l 1149 0 l 140 0 l 140 729 l 239 729 l 239 60 l 214 86 l 619 86 z "
  },
  щ: {
    ha: 1289,
    x_min: 140,
    x_max: 1261,
    o: "m 619 86 l 597 60 l 597 729 l 696 729 l 696 60 l 669 86 l 1076 86 l 1050 60 l 1050 729 l 1149 729 l 1149 0 l 140 0 l 140 729 l 239 729 l 239 60 l 214 86 l 619 86 m 1168 -160 l 1168 26 l 1193 0 l 1044 0 l 1044 86 l 1261 86 l 1261 -160 l 1168 -160 z "
  },
  џ: {
    ha: 888,
    x_min: 140,
    x_max: 747,
    o: "m 747 729 l 747 0 l 492 0 l 492 -176 l 397 -176 l 397 0 l 140 0 l 140 729 l 239 729 l 239 86 l 649 86 l 649 729 l 747 729 z "
  },
  ь: {
    ha: 782,
    x_min: 140,
    x_max: 735,
    o: "m 454 472 q 663 411 592 471 q 735 239 735 351 q 658 60 735 122 q 435 -1 581 -3 l 140 0 l 140 729 l 239 729 l 239 475 l 454 472 m 429 74 q 583 115 531 72 q 635 239 635 157 q 583 359 635 321 q 429 399 532 397 l 239 401 l 239 76 l 429 74 z "
  },
  ъ: {
    ha: 863,
    x_min: 3,
    x_max: 815,
    o: "m 539 475 q 745 414 675 475 q 815 242 815 353 q 739 62 815 124 q 519 0 663 0 l 231 0 l 231 643 l 3 643 l 3 729 l 329 729 l 329 475 l 539 475 m 518 76 q 665 118 615 76 q 715 242 715 160 q 518 400 715 400 l 329 400 l 329 76 l 518 76 z "
  },
  ы: {
    ha: 1090,
    x_min: 140,
    x_max: 950,
    o: "m 851 0 l 851 729 l 950 729 l 950 0 l 851 0 m 447 472 q 657 411 585 471 q 729 239 729 351 q 651 60 729 122 q 429 -1 574 -3 l 140 0 l 140 729 l 239 729 l 239 475 l 447 472 m 422 74 q 577 115 525 72 q 629 239 629 157 q 578 359 629 321 q 422 399 526 397 l 239 401 l 239 76 l 422 74 z "
  },
  љ: {
    ha: 1279,
    x_min: 7,
    x_max: 1233,
    o: "m 7 1 l 14 86 q 33 83 24 85 q 49 81 42 81 q 120 114 93 81 q 161 203 147 147 q 181 328 175 258 q 190 469 186 399 l 203 729 l 738 729 l 738 0 l 639 0 l 639 672 l 664 643 l 267 643 l 290 674 l 279 463 q 265 282 275 368 q 233 131 254 196 q 174 28 211 65 q 78 -8 136 -8 q 44 -6 61 -8 q 7 1 26 -3 m 951 472 q 1160 411 1089 471 q 1232 239 1232 351 q 1155 60 1232 122 q 932 -1 1078 -3 l 638 0 l 638 729 l 736 729 l 736 475 l 951 472 m 926 74 q 1080 115 1028 72 q 1132 239 1132 157 q 1081 359 1132 321 q 926 399 1029 397 l 736 401 l 736 76 l 926 74 z "
  },
  њ: {
    ha: 1311,
    x_min: 140,
    x_max: 1271,
    o: "m 1006 436 q 1201 381 1132 436 q 1271 225 1271 326 q 1196 60 1271 119 q 986 0 1121 0 l 683 0 l 683 351 l 239 351 l 239 0 l 140 0 l 140 729 l 239 729 l 239 436 l 683 436 l 683 729 l 782 729 l 782 436 l 1006 436 m 983 75 q 1122 113 1074 75 q 1171 219 1171 151 q 1122 321 1171 286 q 983 356 1074 356 l 782 356 l 782 75 l 983 75 z "
  },
  ѕ: {
    ha: 733,
    x_min: 65,
    x_max: 664,
    o: "m 363 -7 q 192 19 272 -7 q 65 83 111 44 l 110 161 q 224 103 154 128 q 369 79 293 79 q 519 112 474 79 q 565 199 565 144 q 540 262 565 239 q 472 297 514 285 q 379 317 431 308 q 277 336 328 325 q 185 369 226 347 q 117 428 143 390 q 92 528 92 465 q 125 635 92 588 q 223 709 158 682 q 381 736 288 736 q 522 717 451 736 q 639 668 593 699 l 596 589 q 492 637 547 622 q 381 651 436 651 q 235 617 282 651 q 189 531 189 583 q 215 465 189 489 q 283 428 240 442 q 376 407 325 415 q 477 387 426 399 q 570 355 528 375 q 638 298 613 335 q 664 201 664 261 q 628 91 664 138 q 526 19 593 44 q 363 -7 458 -7 z "
  },
  є: {
    ha: 794,
    x_min: 68,
    x_max: 751,
    o: "m 553 396 l 553 322 l 129 322 l 129 396 l 553 396 m 456 -7 q 257 41 344 -7 q 119 174 169 89 q 68 365 68 258 q 119 558 68 474 q 257 690 169 642 q 456 738 344 738 q 622 710 546 738 q 751 626 699 682 l 694 569 q 587 635 646 614 q 458 656 528 656 q 306 618 374 656 q 199 515 239 581 q 160 365 160 449 q 199 215 160 281 q 306 112 239 150 q 458 74 374 74 q 587 95 528 74 q 694 163 646 117 l 751 106 q 622 22 699 50 q 456 -7 546 -7 z "
  },
  э: {
    ha: 793,
    x_min: 42,
    x_max: 726,
    o: "m 242 333 l 242 408 l 665 408 l 665 333 l 242 333 m 339 736 q 538 688 450 736 q 676 556 625 640 q 726 365 726 472 q 676 174 726 258 q 538 40 625 89 q 339 -8 450 -8 q 172 20 249 -8 q 42 103 94 49 l 100 161 q 207 95 147 117 q 335 74 267 74 q 488 112 421 74 q 594 216 556 150 q 633 365 633 282 q 594 515 633 449 q 488 618 556 581 q 335 656 421 656 q 207 634 267 656 q 100 568 147 613 l 42 625 q 172 708 94 681 q 339 736 249 736 z "
  },
  і: {
    ha: 379,
    x_min: 118,
    x_max: 263,
    o: "m 140 0 l 140 729 l 239 729 l 239 0 l 140 0 m 190 890 q 139 911 160 890 q 118 961 118 932 q 139 1010 118 990 q 190 1031 160 1031 q 242 1011 221 1031 q 263 963 263 992 q 242 911 263 932 q 190 890 222 890 z "
  },
  ї: {
    ha: 374,
    x_min: 38,
    x_max: 336,
    o: "m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 279 875 q 239 892 256 875 q 222 935 222 910 q 239 976 222 958 q 279 993 256 993 q 321 976 304 993 q 338 935 338 960 q 321 892 338 910 q 279 875 304 875 m 96 875 q 54 892 71 875 q 38 935 38 910 q 54 976 38 958 q 96 993 71 993 q 137 976 121 993 q 153 935 153 960 q 137 892 153 910 q 96 875 121 875 z "
  },
  ј: {
    ha: 381,
    x_min: -128,
    x_max: 264,
    o: "m 26 -276 q -59 -265 -18 -276 q -128 -229 -100 -253 l -93 -154 q 21 -192 -49 -192 q 110 -157 79 -192 q 142 -54 142 -122 l 142 729 l 240 729 l 240 -54 q 185 -216 240 -156 q 26 -276 131 -276 m 192 890 q 140 911 161 890 q 119 961 119 932 q 140 1010 119 990 q 192 1031 161 1031 q 243 1011 222 1031 q 264 963 264 992 q 244 911 264 932 q 192 890 224 890 z "
  },
  ћ: {
    ha: 931,
    x_min: -46,
    x_max: 813,
    o: "m -46 847 l -46 910 l 586 910 l 586 847 l -46 847 m 513 736 q 669 702 603 736 q 774 599 736 668 q 813 424 813 529 l 813 0 l 714 0 l 714 414 q 657 588 714 529 q 496 647 600 647 q 359 616 417 647 q 271 526 301 585 q 240 383 240 467 l 240 0 l 142 0 l 142 1031 l 240 1031 l 240 529 l 221 567 q 331 691 256 646 q 513 736 407 736 z "
  },
  ю: {
    ha: 1201,
    x_min: 140,
    x_max: 1131,
    o: "m 140 0 l 140 729 l 239 729 l 239 415 l 461 415 l 461 325 l 239 325 l 239 0 l 140 0 m 768 -7 q 581 41 664 -7 q 451 173 499 89 q 404 365 404 257 q 451 558 404 475 q 581 689 499 642 q 768 736 664 736 q 954 689 872 736 q 1083 558 1036 642 q 1131 365 1131 475 q 1083 173 1131 257 q 954 41 1036 89 q 768 -7 872 -7 m 768 79 q 904 115 844 79 q 999 216 964 151 q 1033 365 1033 281 q 999 515 1033 451 q 904 615 964 579 q 768 650 844 650 q 633 615 693 650 q 538 515 572 579 q 503 365 503 451 q 538 216 503 281 q 633 115 572 151 q 768 79 693 79 z "
  },
  я: {
    ha: 842,
    x_min: 78,
    x_max: 701,
    o: "m 611 0 l 611 263 l 629 242 l 382 242 q 163 303 242 242 q 83 481 83 364 q 168 667 83 606 q 394 729 253 729 l 701 729 l 701 0 l 611 0 m 78 0 l 278 281 l 381 281 l 185 0 l 78 0 m 611 292 l 611 672 l 629 643 l 397 643 q 240 604 296 643 q 183 478 183 565 q 390 315 183 315 l 629 315 l 611 292 z "
  },
  ђ: {
    ha: 931,
    x_min: -10,
    x_max: 813,
    o: "m 600 -276 q 513 -265 554 -276 q 444 -229 472 -253 l 479 -154 q 593 -192 524 -192 q 683 -157 651 -192 q 714 -54 714 -122 l 714 414 q 657 588 714 529 q 496 647 600 647 q 359 616 417 647 q 271 526 301 585 q 240 383 240 467 l 240 0 l 142 0 l 142 1031 l 236 1031 l 236 529 l 221 567 q 331 691 256 646 q 513 736 407 736 q 669 702 603 736 q 774 599 736 668 q 813 424 813 529 l 813 -54 q 758 -216 813 -156 q 600 -276 703 -276 m -10 843 l -10 915 l 582 915 l 582 843 l -10 843 z "
  },
  ѣ: {
    ha: 828,
    x_min: 3,
    x_max: 782,
    o: "m 3 682 l 3 757 l 560 757 l 560 682 l 3 682 m 500 472 q 710 411 638 471 q 782 239 782 351 q 704 60 782 122 q 482 -1 626 -3 l 188 0 l 188 1031 l 286 1031 l 286 475 l 500 472 m 476 74 q 630 115 578 72 q 682 239 682 157 q 631 359 682 321 q 476 399 579 397 l 286 401 l 286 76 l 476 74 z "
  },
  ѫ: {
    ha: 944,
    x_min: 28,
    x_max: 918,
    o: "m 28 0 l 100 167 q 172 292 132 243 q 261 365 211 342 q 371 388 311 388 l 575 388 q 685 365 636 388 q 774 292 735 342 q 846 167 814 243 l 918 0 l 819 0 l 758 143 q 676 274 725 232 q 556 317 626 317 l 514 317 l 514 0 l 428 0 l 428 317 l 390 317 q 270 274 321 317 q 186 143 219 232 l 126 0 l 28 0 m 471 388 l 729 660 l 214 660 l 471 388 m 389 369 l 108 665 l 108 729 l 833 729 l 833 665 l 553 369 l 389 369 z "
  },
  ѳ: {
    ha: 897,
    x_min: 69,
    x_max: 828,
    o: "m 449 736 q 644 689 558 736 q 778 558 729 642 q 828 365 828 475 q 778 173 828 257 q 644 41 729 89 q 449 -7 558 -7 q 253 41 339 -7 q 119 173 168 89 q 69 365 69 257 q 119 558 69 475 q 254 689 168 642 q 449 736 340 736 m 449 657 q 311 625 372 657 q 212 536 250 593 q 167 401 174 479 l 731 401 q 685 535 724 478 q 586 625 647 593 q 449 657 525 657 m 449 74 q 586 106 525 74 q 685 195 647 138 q 731 331 724 253 l 167 331 q 211 195 174 253 q 310 106 249 138 q 449 74 372 74 z "
  },
  ѵ: {
    ha: 799,
    x_min: 14,
    x_max: 796,
    o: "m 333 0 l 14 729 l 122 729 l 414 54 l 356 54 l 551 574 q 613 688 581 649 q 689 736 644 728 q 796 728 733 744 l 785 631 q 719 636 744 642 q 674 601 693 631 q 629 510 654 571 l 432 0 l 333 0 z "
  },
  ғ: {
    ha: 697,
    x_min: 64,
    x_max: 678,
    o: "m 64 288 l 64 360 l 579 360 l 579 288 l 64 288 m 161 0 l 161 729 l 678 729 l 678 643 l 235 643 l 260 668 l 260 0 l 161 0 z "
  },
  ҕ: {
    ha: 822,
    x_min: 140,
    x_max: 783,
    o: "m 140 0 l 140 729 l 639 729 l 639 643 l 214 643 l 239 669 l 239 0 l 140 0 m 340 -267 l 363 -181 q 532 -172 460 -197 q 644 -85 604 -147 q 683 64 683 -24 q 653 197 683 144 q 574 276 624 249 q 463 306 524 303 q 339 289 401 308 q 221 229 276 269 l 218 319 q 378 381 297 365 q 533 385 460 397 q 662 332 606 372 q 751 226 718 292 q 783 68 783 160 q 751 -91 783 -21 q 659 -207 718 -161 q 519 -269 600 -253 q 340 -267 438 -285 z "
  },
  җ: {
    ha: 1197,
    x_min: 24,
    x_max: 1188,
    o: "m 1006 0 l 756 361 l 838 410 l 1124 0 l 1006 0 m 592 325 l 592 410 l 822 410 l 822 325 l 592 325 m 847 354 l 753 368 l 996 729 l 1103 729 l 847 354 m 142 0 l 24 0 l 310 410 l 390 361 l 142 0 m 622 0 l 524 0 l 524 729 l 622 729 l 622 0 m 554 325 l 325 325 l 325 410 l 554 410 l 554 325 m 301 354 l 44 729 l 151 729 l 393 368 l 301 354 m 1097 -161 l 1097 26 l 1124 0 l 1004 0 l 1004 85 l 1188 85 l 1188 -161 l 1097 -161 z "
  },
  ҙ: {
    ha: 742,
    x_min: 42,
    x_max: 658,
    o: "m 336 -8 q 499 19 426 -8 q 615 97 572 47 q 658 211 658 146 q 588 343 658 294 q 393 392 518 392 l 389 365 q 515 388 460 365 q 604 450 571 410 q 638 544 638 490 q 596 649 638 606 q 484 717 554 693 q 326 738 414 740 q 199 720 263 738 q 72 669 136 703 l 100 593 q 215 637 157 622 q 328 653 274 651 q 435 639 388 653 q 509 597 482 625 q 536 531 536 569 q 513 468 536 494 q 449 428 490 442 q 353 414 407 414 l 235 414 l 235 342 l 360 342 q 504 309 451 342 q 557 218 557 276 q 529 146 557 178 q 451 96 501 114 q 333 76 401 78 q 196 97 265 76 q 74 156 126 117 l 42 82 q 179 14 101 36 q 336 -8 257 -8 m 388 24 l 294 24 l 294 -160 l 388 -160 l 388 24 z "
  },
  қ: {
    ha: 807,
    x_min: 140,
    x_max: 858,
    o: "m 675 0 l 375 361 l 457 410 l 792 0 l 675 0 m 140 0 l 140 729 l 239 729 l 239 0 l 140 0 m 208 325 l 208 410 l 443 410 l 443 325 l 208 325 m 465 354 l 374 368 l 664 729 l 771 729 l 465 354 m 768 -161 l 768 26 l 794 0 l 675 0 l 675 85 l 858 85 l 858 -161 l 768 -161 z "
  },
  ҝ: {
    ha: 829,
    x_min: 138,
    x_max: 807,
    o: "m 692 0 l 429 361 l 508 408 l 807 0 l 692 0 m 138 0 l 138 729 l 236 729 l 236 0 l 138 0 m 207 325 l 207 410 l 492 410 l 492 325 l 207 325 m 517 354 l 426 368 l 681 729 l 786 729 l 517 354 m 325 178 l 325 560 l 397 560 l 397 178 l 325 178 z "
  },
  ҟ: {
    ha: 807,
    x_min: 1,
    x_max: 792,
    o: "m 1 843 l 1 917 l 460 915 l 460 843 l 1 843 m 675 0 l 375 361 l 457 410 l 792 0 l 675 0 m 142 0 l 142 1031 l 240 1031 l 240 0 l 142 0 m 210 325 l 210 410 l 443 410 l 443 325 l 210 325 m 465 354 l 374 368 l 664 729 l 771 729 l 465 354 z "
  },
  ҡ: {
    ha: 897,
    x_min: 3,
    x_max: 882,
    o: "m 3 644 l 3 729 l 329 729 l 329 644 l 3 644 m 765 0 l 465 361 l 547 410 l 882 0 l 765 0 m 231 0 l 231 729 l 329 729 l 329 0 l 231 0 m 299 325 l 299 410 l 533 410 l 533 325 l 299 325 m 556 354 l 464 368 l 754 729 l 861 729 l 556 354 z "
  },
  ң: {
    ha: 963,
    x_min: 140,
    x_max: 914,
    o: "m 140 0 l 140 729 l 239 729 l 239 407 l 699 407 l 699 729 l 797 729 l 797 0 l 699 0 l 699 322 l 239 322 l 239 0 l 140 0 m 821 -160 l 821 26 l 846 0 l 697 0 l 697 86 l 914 86 l 914 -160 l 821 -160 z "
  },
  ҥ: {
    ha: 1218,
    x_min: 140,
    x_max: 1215,
    o: "m 140 0 l 140 729 l 239 729 l 239 407 l 699 407 l 699 729 l 797 729 l 797 0 l 699 0 l 699 322 l 239 322 l 239 0 l 140 0 m 699 0 l 699 729 l 1215 729 l 1215 643 l 772 643 l 797 668 l 797 0 l 699 0 z "
  },
  "ԥ": {
    ha: 936,
    x_min: 140,
    x_max: 913,
    o: "m 140 0 l 140 729 l 796 729 l 796 0 l 697 0 l 697 669 l 722 643 l 214 643 l 239 669 l 239 0 l 140 0 m 821 -160 l 821 26 l 846 0 l 697 0 l 697 86 l 914 86 l 914 -160 l 821 -160 z "
  },
  ҩ: {
    ha: 1103,
    x_min: 72,
    x_max: 1010,
    o: "m 504 -8 q 278 41 376 -8 q 126 179 181 90 q 72 385 72 268 q 125 590 72 496 q 272 739 178 683 l 347 693 q 217 558 264 639 q 171 382 171 478 q 215 217 171 288 q 336 106 258 146 q 518 67 414 67 q 718 113 631 67 q 855 241 806 160 q 904 428 904 322 q 879 546 904 494 q 808 626 854 597 q 703 654 763 654 q 593 624 640 654 q 519 541 546 594 q 493 417 493 488 q 533 248 493 321 q 644 129 574 175 q 806 71 714 83 q 1001 85 899 58 l 1010 11 q 824 -8 914 -14 q 656 31 733 -1 q 521 119 579 64 q 430 250 463 175 q 397 415 397 325 q 435 585 397 513 q 543 698 474 657 q 704 739 613 739 q 860 700 793 739 q 964 592 926 661 q 1001 433 1001 524 q 963 259 1001 339 q 857 119 925 179 q 699 25 789 58 q 504 -8 608 -8 z "
  },
  ҫ: {
    ha: 782,
    x_min: 69,
    x_max: 732,
    o: "m 446 -7 q 252 41 338 -7 q 118 173 167 89 q 69 365 69 257 q 118 558 69 475 q 252 689 167 642 q 446 736 338 736 q 614 700 539 736 q 732 592 689 664 l 658 542 q 565 624 621 597 q 444 650 510 650 q 304 615 367 650 q 206 515 242 579 q 169 365 169 451 q 206 215 169 279 q 304 116 242 151 q 444 81 367 81 q 565 107 510 81 q 658 188 621 133 l 732 138 q 614 30 689 67 q 446 -7 539 -7 m 485 24 l 485 -160 l 392 -160 l 392 24 l 485 24 z "
  },
  ҭ: {
    ha: 657,
    x_min: 3,
    x_max: 654,
    o: "m 279 0 l 279 669 l 304 643 l 3 643 l 3 729 l 654 729 l 654 643 l 353 643 l 378 669 l 378 0 l 279 0 m 401 -160 l 401 26 l 426 0 l 279 0 l 279 86 l 494 86 l 494 -160 l 401 -160 z "
  },
  ү: {
    ha: 776,
    x_min: 14,
    x_max: 764,
    o: "m 360 -51 l 14 729 l 118 729 l 414 53 l 365 53 l 667 729 l 764 729 l 417 -51 l 360 -51 m 438 49 l 438 -269 l 339 -269 l 339 49 l 438 49 z "
  },
  ұ: {
    ha: 776,
    x_min: 14,
    x_max: 764,
    o: "m 100 -28 l 100 43 l 675 43 l 675 -28 l 100 -28 m 360 -51 l 14 729 l 118 729 l 414 53 l 365 53 l 667 729 l 764 729 l 417 -51 l 360 -51 m 438 49 l 438 -269 l 339 -269 l 339 49 l 438 49 z "
  },
  ҳ: {
    ha: 731,
    x_min: 21,
    x_max: 779,
    o: "m 21 0 l 329 400 l 328 351 l 35 729 l 146 729 l 386 417 l 344 418 l 585 729 l 693 729 l 397 347 l 399 400 l 710 0 l 597 0 l 343 333 l 382 328 l 132 0 l 21 0 m 689 -161 l 689 26 l 715 0 l 596 0 l 596 85 l 779 85 l 779 -161 l 689 -161 z "
  },
  ҵ: {
    ha: 1051,
    x_min: 3,
    x_max: 996,
    o: "m 279 0 l 279 729 l 378 729 l 378 86 l 789 86 l 789 729 l 888 729 l 888 0 l 279 0 m 903 -160 l 903 26 l 926 0 l 789 0 l 789 86 l 996 86 l 996 -160 l 903 -160 m 614 729 l 614 643 l 3 643 l 3 729 l 614 729 z "
  },
  ҷ: {
    ha: 863,
    x_min: 65,
    x_max: 808,
    o: "m 601 308 q 473 265 538 281 q 344 249 408 249 q 140 308 215 249 q 65 490 65 367 l 65 729 l 163 729 l 163 496 q 217 371 163 413 q 363 329 271 329 q 479 344 418 329 q 603 386 540 358 l 601 308 m 593 0 l 593 729 l 692 729 l 692 0 l 593 0 m 717 -160 l 717 26 l 742 0 l 593 0 l 593 86 l 810 86 l 810 -160 l 717 -160 z "
  },
  ҹ: {
    ha: 832,
    x_min: 64,
    x_max: 692,
    o: "m 340 103 l 340 489 l 413 489 l 413 103 l 340 103 m 601 308 q 472 265 538 281 q 343 249 407 249 q 140 308 215 249 q 64 490 64 367 l 64 729 l 163 729 l 163 496 q 217 371 163 413 q 361 329 271 329 q 478 344 417 329 q 601 386 539 358 l 601 308 m 593 0 l 593 729 l 692 729 l 692 0 l 593 0 z "
  },
  һ: {
    ha: 931,
    x_min: 142,
    x_max: 813,
    o: "m 513 736 q 669 702 601 736 q 774 599 736 668 q 813 424 813 529 l 813 0 l 714 0 l 714 414 q 656 588 714 529 q 494 647 599 647 q 359 616 417 647 q 270 526 301 585 q 239 383 239 467 l 239 0 l 140 0 l 140 1031 l 239 1031 l 239 529 l 219 567 q 331 691 254 646 q 513 736 407 736 z "
  },
  "ԧ": {
    ha: 961,
    x_min: 140,
    x_max: 921,
    o: "m 714 0 l 714 411 q 656 585 714 526 q 496 644 599 644 q 360 613 418 644 q 270 522 301 581 q 239 381 239 463 l 194 417 q 239 587 199 515 q 351 697 279 658 q 519 736 424 736 q 673 702 607 736 q 776 599 739 668 q 813 426 813 529 l 813 0 l 714 0 m 140 0 l 140 1031 l 239 1031 l 239 0 l 140 0 m 828 -160 l 828 26 l 874 0 l 714 0 l 714 86 l 921 86 l 921 -160 l 828 -160 z "
  },
  ҽ: {
    ha: 1044,
    x_min: 28,
    x_max: 982,
    o: "m 292 335 l 218 335 q 85 371 132 335 q 33 467 39 407 q 65 599 28 528 l 149 578 q 121 496 121 535 q 148 433 121 457 q 229 408 175 408 l 292 408 l 292 335 m 642 -7 q 436 41 525 -7 q 297 173 347 89 q 246 365 246 257 q 294 557 246 474 q 426 688 342 640 q 615 736 510 736 q 804 690 722 736 q 934 559 886 643 q 982 365 982 475 q 981 351 982 358 q 979 335 981 343 l 324 335 l 324 408 l 926 408 l 885 379 q 851 520 886 458 q 755 617 815 582 q 615 651 694 651 q 476 617 536 651 q 380 519 415 582 q 344 376 344 457 l 344 361 q 383 215 344 278 q 490 116 422 151 q 644 81 557 81 q 774 104 715 81 q 876 176 833 128 l 933 113 q 808 24 883 54 q 642 -7 733 -7 z "
  },
  ҿ: {
    ha: 1044,
    x_min: 28,
    x_max: 982,
    o: "m 292 335 l 218 335 q 85 371 132 335 q 33 467 39 407 q 65 599 28 528 l 149 578 q 121 496 121 535 q 148 433 121 457 q 229 408 175 408 l 292 408 l 292 335 m 642 -7 q 436 41 525 -7 q 297 173 347 89 q 246 365 246 257 q 294 557 246 474 q 426 688 342 640 q 615 736 510 736 q 804 690 722 736 q 934 559 886 643 q 982 365 982 475 q 981 351 982 358 q 979 335 981 343 l 324 335 l 324 408 l 926 408 l 885 379 q 851 520 886 458 q 755 617 815 582 q 615 651 694 651 q 476 617 536 651 q 380 519 415 582 q 344 376 344 457 l 344 361 q 383 215 344 278 q 490 116 422 151 q 644 81 557 81 q 774 104 715 81 q 876 176 833 128 l 933 113 q 808 24 883 54 q 642 -7 733 -7 m 671 24 l 671 -160 l 578 -160 l 578 24 l 671 24 z "
  },
  "ӏ": {
    ha: 381,
    x_min: 142,
    x_max: 240,
    o: "m 142 0 l 142 1031 l 240 1031 l 240 0 l 142 0 z "
  },
  ӂ: {
    ha: 1147,
    x_min: 24,
    x_max: 1124,
    o: "m 1006 0 l 756 361 l 838 410 l 1124 0 l 1006 0 m 592 325 l 592 410 l 822 410 l 822 325 l 592 325 m 847 354 l 753 368 l 996 729 l 1103 729 l 847 354 m 142 0 l 24 0 l 310 410 l 390 361 l 142 0 m 622 0 l 524 0 l 524 729 l 622 729 l 622 0 m 554 325 l 325 325 l 325 410 l 554 410 l 554 325 m 301 354 l 44 729 l 151 729 l 393 368 l 301 354 m 572 835 q 424 881 481 835 q 365 1015 368 928 l 436 1015 q 475 928 438 960 q 572 896 513 896 q 670 928 632 896 q 710 1015 708 960 l 781 1015 q 722 881 779 928 q 572 835 665 835 z "
  },
  ӄ: {
    ha: 807,
    x_min: 140,
    x_max: 771,
    o: "m 560 -276 q 407 -236 485 -276 l 436 -161 q 546 -193 496 -193 q 636 -158 601 -193 q 671 -65 671 -124 q 634 71 671 -3 q 532 219 597 144 q 382 357 467 294 l 457 413 q 622 256 551 339 q 731 89 692 172 q 769 -69 769 6 q 743 -178 769 -132 q 669 -251 717 -225 q 560 -276 622 -276 m 140 0 l 140 729 l 239 729 l 239 0 l 140 0 m 208 325 l 208 410 l 443 410 l 443 325 l 208 325 m 465 354 l 374 368 l 664 729 l 771 729 l 465 354 z "
  },
  "ӆ": {
    ha: 904,
    x_min: 7,
    x_max: 856,
    o: "m 7 1 l 14 86 q 33 83 24 85 q 49 81 42 81 q 120 114 93 81 q 161 203 147 147 q 181 328 175 258 q 190 469 186 399 l 203 729 l 738 729 l 738 0 l 639 0 l 639 672 l 664 643 l 267 643 l 290 674 l 279 463 q 265 282 275 368 q 233 131 254 196 q 174 28 211 65 q 78 -8 136 -8 q 44 -6 61 -8 q 7 1 26 -3 m 700 -160 l 751 26 l 811 0 l 639 0 l 639 86 l 857 86 l 781 -160 l 700 -160 z "
  },
  ӈ: {
    ha: 947,
    x_min: 140,
    x_max: 807,
    o: "m 597 -276 q 511 -265 553 -276 q 442 -229 469 -253 l 475 -154 q 585 -192 518 -192 q 676 -157 644 -192 q 708 -54 708 -122 l 708 322 l 239 322 l 239 0 l 140 0 l 140 729 l 239 729 l 239 407 l 708 407 l 708 729 l 807 729 l 807 -60 q 753 -217 807 -157 q 597 -276 699 -276 z "
  },
  "ӊ": {
    ha: 964,
    x_min: 140,
    x_max: 915,
    o: "m 140 0 l 140 729 l 239 729 l 239 407 l 699 407 l 699 729 l 797 729 l 797 0 l 699 0 l 699 322 l 239 322 l 239 0 l 140 0 m 760 -160 l 811 26 l 871 0 l 699 0 l 699 86 l 917 86 l 840 -160 l 760 -160 z "
  },
  ӌ: {
    ha: 829,
    x_min: 61,
    x_max: 689,
    o: "m 340 264 q 137 323 213 264 q 61 506 61 382 l 61 729 l 160 729 l 160 510 q 213 387 160 428 q 360 346 267 346 q 599 403 472 346 l 597 324 q 469 279 535 294 q 340 264 404 264 m 463 -160 l 463 82 l 681 82 l 681 0 l 531 0 l 557 26 l 557 -160 l 463 -160 m 590 0 l 590 729 l 689 729 l 689 0 l 590 0 z "
  },
  "ӎ": {
    ha: 1133,
    x_min: 140,
    x_max: 1085,
    o: "m 140 0 l 140 729 l 240 729 l 571 169 l 529 169 l 865 729 l 957 729 l 957 0 l 867 0 l 867 617 l 885 608 l 571 89 l 526 89 l 210 614 l 231 618 l 231 0 l 140 0 m 928 -160 l 979 26 l 1039 0 l 867 0 l 867 86 l 1085 86 l 1008 -160 l 928 -160 z "
  },
  ӑ: {
    ha: 810,
    x_min: 75,
    x_max: 688,
    o: "m 593 0 l 593 161 l 589 188 l 589 457 q 537 600 589 550 q 382 650 485 650 q 247 626 311 650 q 139 564 183 603 l 94 638 q 228 710 150 685 q 392 736 306 736 q 610 666 533 736 q 688 453 688 596 l 688 0 l 593 0 m 342 -7 q 199 20 260 -7 q 107 95 139 47 q 75 206 75 143 q 102 309 75 263 q 191 384 129 356 q 357 413 253 413 l 608 413 l 608 339 l 360 339 q 213 301 254 339 q 172 208 172 264 q 221 108 172 146 q 357 71 269 71 q 501 109 440 71 q 589 219 561 147 l 611 151 q 515 36 583 79 q 342 -7 446 -7 m 393 835 q 245 881 301 835 q 186 1015 189 928 l 257 1015 q 296 928 258 960 q 393 896 333 896 q 491 928 453 896 q 531 1015 529 960 l 601 1015 q 543 881 600 928 q 393 835 486 835 z "
  },
  ӓ: {
    ha: 810,
    x_min: 75,
    x_max: 688,
    o: "m 593 0 l 593 161 l 589 188 l 589 457 q 537 600 589 550 q 382 650 485 650 q 247 626 311 650 q 139 564 183 603 l 94 638 q 228 710 150 685 q 392 736 306 736 q 610 666 533 736 q 688 453 688 596 l 688 0 l 593 0 m 342 -7 q 199 20 260 -7 q 107 95 139 47 q 75 206 75 143 q 102 309 75 263 q 191 384 129 356 q 357 413 253 413 l 608 413 l 608 339 l 360 339 q 213 301 254 339 q 172 208 172 264 q 221 108 172 146 q 357 71 269 71 q 501 109 440 71 q 589 219 561 147 l 611 151 q 515 36 583 79 q 342 -7 446 -7 m 518 875 q 476 892 494 875 q 458 935 458 908 q 476 978 458 961 q 518 994 494 994 q 560 978 543 994 q 578 935 578 961 q 560 892 578 908 q 518 875 543 875 m 271 875 q 228 892 246 875 q 211 935 211 908 q 228 978 211 961 q 271 994 246 994 q 313 978 294 994 q 331 935 331 961 q 313 892 331 908 q 271 875 294 875 z "
  },
  ӕ: {
    ha: 1375,
    x_min: 75,
    x_max: 1304,
    o: "m 351 -7 q 148 53 221 -7 q 75 208 75 113 q 102 308 75 263 q 191 383 129 354 q 357 411 253 411 l 606 411 l 606 338 l 360 338 q 213 301 254 338 q 172 210 172 264 q 222 108 172 146 q 358 71 271 71 q 526 126 464 71 q 589 279 589 182 l 589 457 q 537 600 589 550 q 382 650 485 650 q 247 626 311 650 q 139 564 183 603 l 94 638 q 228 710 150 685 q 390 736 306 736 q 587 683 515 736 q 675 525 658 631 l 631 533 q 756 681 672 626 q 949 736 839 736 q 1090 709 1025 736 q 1202 633 1154 682 q 1277 518 1250 585 q 1304 371 1304 451 q 1303 353 1304 361 q 1301 338 1303 346 l 668 338 l 668 411 l 1249 411 l 1208 379 q 1173 524 1208 464 q 1078 618 1138 585 q 947 651 1018 651 q 818 618 878 651 q 723 524 758 585 q 688 376 688 463 l 688 361 q 724 215 688 278 q 826 116 761 151 q 976 81 890 81 q 1101 104 1044 81 q 1200 176 1157 128 l 1256 113 q 1134 23 1207 53 q 974 -7 1061 -7 q 817 21 890 -7 q 690 106 744 49 q 607 249 636 163 l 671 247 q 609 97 657 153 q 493 17 561 42 q 351 -7 425 -7 z "
  },
  ӗ: {
    ha: 868,
    x_min: 71,
    x_max: 781,
    o: "m 453 -7 q 253 41 339 -7 q 118 173 167 89 q 69 365 69 257 q 116 557 69 474 q 244 688 163 640 q 426 736 325 736 q 609 690 529 736 q 735 559 689 643 q 781 365 781 475 q 780 351 781 358 q 779 335 779 343 l 144 335 l 144 408 l 726 408 l 688 379 q 653 520 688 458 q 561 617 619 582 q 426 651 503 651 q 292 617 351 651 q 199 519 232 582 q 165 376 165 457 l 165 361 q 202 215 165 278 q 305 116 239 151 q 456 81 371 81 q 580 104 522 81 q 679 176 638 128 l 735 113 q 613 24 686 54 q 453 -7 540 -7 m 425 835 q 277 881 333 835 q 218 1015 221 928 l 289 1015 q 328 928 290 960 q 425 896 365 896 q 523 928 485 896 q 563 1015 561 960 l 633 1015 q 575 881 632 928 q 425 835 518 835 z "
  },
  ә: {
    ha: 857,
    x_min: 76,
    x_max: 788,
    o: "m 403 736 q 604 688 518 736 q 739 557 690 640 q 788 365 788 474 q 741 173 788 257 q 614 41 694 89 q 429 -7 533 -7 q 248 40 328 -7 q 122 172 168 88 q 76 365 76 256 q 76 379 76 371 q 78 394 76 388 l 713 394 l 713 321 l 129 321 l 169 350 q 203 210 169 272 q 295 113 236 149 q 429 78 354 78 q 565 113 506 78 q 657 211 624 149 q 690 353 690 274 l 690 369 q 653 515 690 453 q 551 614 617 578 q 401 650 486 650 q 276 626 333 650 q 178 553 219 603 l 122 618 q 245 706 172 676 q 403 736 318 736 z "
  },
  ӛ: {
    ha: 857,
    x_min: 76,
    x_max: 788,
    o: "m 403 736 q 604 688 518 736 q 739 557 690 640 q 788 365 788 474 q 741 173 788 257 q 614 41 694 89 q 429 -7 533 -7 q 248 40 328 -7 q 122 172 168 88 q 76 365 76 256 q 76 379 76 371 q 78 394 76 388 l 713 394 l 713 321 l 129 321 l 169 350 q 203 210 169 272 q 295 113 236 149 q 429 78 354 78 q 565 113 506 78 q 657 211 624 149 q 690 353 690 274 l 690 369 q 653 515 690 453 q 551 614 617 578 q 401 650 486 650 q 276 626 333 650 q 178 553 219 603 l 122 618 q 245 706 172 676 q 403 736 318 736 m 556 875 q 514 892 532 875 q 496 935 496 908 q 514 978 496 961 q 556 994 532 994 q 598 978 581 994 q 615 935 615 961 q 598 892 615 908 q 556 875 581 875 m 308 875 q 266 892 283 875 q 249 935 249 908 q 266 978 249 961 q 308 994 283 994 q 350 978 332 994 q 368 935 368 961 q 350 892 368 908 q 308 875 332 875 z "
  },
  ӝ: {
    ha: 1147,
    x_min: 24,
    x_max: 1124,
    o: "m 1006 0 l 756 361 l 838 410 l 1124 0 l 1006 0 m 592 325 l 592 410 l 822 410 l 822 325 l 592 325 m 847 354 l 753 368 l 996 729 l 1103 729 l 847 354 m 142 0 l 24 0 l 310 410 l 390 361 l 142 0 m 622 0 l 524 0 l 524 729 l 622 729 l 622 0 m 554 325 l 325 325 l 325 410 l 554 410 l 554 325 m 301 354 l 44 729 l 151 729 l 393 368 l 301 354 m 697 875 q 656 892 674 875 q 638 935 638 908 q 656 978 638 961 q 697 994 674 994 q 740 978 722 994 q 757 935 757 961 q 740 892 757 908 q 697 875 722 875 m 450 875 q 408 892 425 875 q 390 935 390 908 q 408 978 390 961 q 450 994 425 994 q 492 978 474 994 q 510 935 510 961 q 492 892 510 908 q 450 875 474 875 z "
  },
  ӟ: {
    ha: 742,
    x_min: 42,
    x_max: 658,
    o: "m 336 -8 q 499 19 426 -8 q 615 97 572 47 q 658 211 658 146 q 588 343 658 294 q 393 392 518 392 l 389 365 q 515 388 460 365 q 604 450 571 410 q 638 544 638 490 q 596 649 638 606 q 484 717 554 693 q 326 738 414 740 q 199 720 263 738 q 72 669 136 703 l 100 593 q 215 637 157 622 q 328 653 274 651 q 435 639 388 653 q 509 597 482 625 q 536 531 536 569 q 513 468 536 494 q 449 428 490 442 q 353 414 407 414 l 235 414 l 235 342 l 360 342 q 504 309 451 342 q 557 218 557 276 q 529 146 557 178 q 451 96 501 114 q 333 76 401 78 q 196 97 265 76 q 74 156 126 117 l 42 82 q 179 14 101 36 q 336 -8 257 -8 m 479 875 q 438 892 456 875 q 419 935 419 908 q 438 978 419 961 q 479 994 456 994 q 522 978 504 994 q 539 935 539 961 q 522 892 539 908 q 479 875 504 875 m 232 875 q 190 892 207 875 q 172 935 172 908 q 190 978 172 961 q 232 994 207 994 q 274 978 256 994 q 292 935 292 961 q 274 892 292 908 q 232 875 256 875 z "
  },
  ӡ: {
    ha: 714,
    x_min: -31,
    x_max: 664,
    o: "m 314 -278 q 115 -242 207 -278 q -31 -150 22 -207 l 10 -69 q 135 -153 56 -121 q 311 -186 215 -186 q 498 -131 433 -186 q 563 17 563 -76 q 499 165 563 110 q 300 219 436 219 l 231 219 l 231 290 l 535 679 l 543 642 l 3 642 l 3 729 l 624 729 l 624 658 l 321 269 l 279 301 l 317 301 q 577 223 490 301 q 664 17 664 144 q 624 -133 664 -67 q 508 -238 585 -199 q 314 -278 431 -278 z "
  },
  ӣ: {
    ha: 956,
    x_min: 140,
    x_max: 814,
    o: "m 140 0 l 140 729 l 239 729 l 239 150 l 726 729 l 814 729 l 814 0 l 715 0 l 715 581 l 229 0 l 140 0 m 258 896 l 258 961 l 686 961 l 686 896 l 258 896 z "
  },
  ӥ: {
    ha: 956,
    x_min: 140,
    x_max: 814,
    o: "m 140 0 l 140 729 l 239 729 l 239 150 l 726 729 l 814 729 l 814 0 l 715 0 l 715 581 l 229 0 l 140 0 m 596 875 q 554 892 572 875 q 536 935 536 908 q 554 978 536 961 q 596 994 572 994 q 638 978 621 994 q 656 935 656 961 q 638 892 656 908 q 596 875 621 875 m 349 875 q 306 892 324 875 q 289 935 289 908 q 306 978 289 961 q 349 994 324 994 q 390 978 372 994 q 408 935 408 961 q 390 892 408 908 q 349 875 372 875 z "
  },
  ӧ: {
    ha: 883,
    x_min: 69,
    x_max: 813,
    o: "m 440 -7 q 251 41 335 -7 q 118 173 167 89 q 69 365 69 257 q 118 558 69 475 q 250 689 167 642 q 440 736 333 736 q 633 689 549 736 q 765 558 717 642 q 813 365 813 475 q 765 173 813 257 q 632 41 717 89 q 440 -7 547 -7 m 440 81 q 581 116 519 81 q 677 216 642 151 q 713 365 713 281 q 677 515 713 451 q 581 615 642 579 q 442 650 519 650 q 303 615 364 650 q 206 515 242 579 q 169 365 169 451 q 206 216 169 281 q 303 116 242 151 q 440 81 364 81 m 564 875 q 522 892 540 875 q 504 935 504 908 q 522 978 504 961 q 564 994 540 994 q 606 978 589 994 q 624 935 624 961 q 606 892 624 908 q 564 875 589 875 m 317 875 q 274 892 292 875 q 257 935 257 908 q 274 978 257 961 q 317 994 292 994 q 358 978 340 994 q 376 935 376 961 q 358 892 376 908 q 317 875 340 875 z "
  },
  ө: {
    ha: 897,
    x_min: 69,
    x_max: 828,
    o: "m 449 736 q 644 689 558 736 q 778 558 729 642 q 828 365 828 475 q 778 173 828 257 q 644 41 729 89 q 449 -7 558 -7 q 253 41 339 -7 q 119 173 168 89 q 69 365 69 257 q 119 558 69 475 q 254 689 168 642 q 449 736 340 736 m 449 657 q 311 625 372 657 q 212 536 250 593 q 167 401 174 479 l 731 401 q 685 535 724 478 q 586 625 647 593 q 449 657 525 657 m 449 74 q 586 106 525 74 q 685 195 647 138 q 731 331 724 253 l 167 331 q 211 195 174 253 q 310 106 249 138 q 449 74 372 74 z "
  },
  ӫ: {
    ha: 897,
    x_min: 69,
    x_max: 828,
    o: "m 449 736 q 644 689 558 736 q 778 558 729 642 q 828 365 828 475 q 778 173 828 257 q 644 41 729 89 q 449 -7 558 -7 q 253 41 339 -7 q 119 173 168 89 q 69 365 69 257 q 119 558 69 475 q 254 689 168 642 q 449 736 340 736 m 449 657 q 311 625 372 657 q 212 536 250 593 q 167 401 174 479 l 731 401 q 685 535 724 478 q 586 625 647 593 q 449 657 525 657 m 449 74 q 586 106 525 74 q 685 195 647 138 q 731 331 724 253 l 167 331 q 211 195 174 253 q 310 106 249 138 q 449 74 372 74 m 572 875 q 531 892 549 875 q 513 935 513 908 q 531 978 513 961 q 572 994 549 994 q 615 978 597 994 q 632 935 632 961 q 615 892 632 908 q 572 875 597 875 m 325 875 q 283 892 300 875 q 265 935 265 908 q 283 978 265 961 q 325 994 300 994 q 367 978 349 994 q 385 935 385 961 q 367 892 385 908 q 325 875 349 875 z "
  },
  ӭ: {
    ha: 793,
    x_min: 42,
    x_max: 726,
    o: "m 242 333 l 242 408 l 665 408 l 665 333 l 242 333 m 339 736 q 538 688 450 736 q 676 556 625 640 q 726 365 726 472 q 676 174 726 258 q 538 40 625 89 q 339 -8 450 -8 q 172 20 249 -8 q 42 103 94 49 l 100 161 q 207 95 147 117 q 335 74 267 74 q 488 112 421 74 q 594 216 556 150 q 633 365 633 282 q 594 515 633 449 q 488 618 556 581 q 335 656 421 656 q 207 634 267 656 q 100 568 147 613 l 42 625 q 172 708 94 681 q 339 736 249 736 m 483 875 q 442 892 460 875 q 424 935 424 908 q 442 978 424 961 q 483 994 460 994 q 526 978 508 994 q 543 935 543 961 q 526 892 543 908 q 483 875 508 875 m 236 875 q 194 892 211 875 q 176 935 176 908 q 194 978 176 961 q 236 994 211 994 q 278 978 260 994 q 296 935 296 961 q 278 892 296 908 q 236 875 260 875 z "
  },
  ӯ: {
    ha: 775,
    x_min: -25,
    x_max: 761,
    o: "m 153 -276 q 55 -260 101 -276 q -25 -210 8 -243 l 21 -136 q 81 -177 49 -162 q 154 -192 114 -192 q 238 -165 203 -192 q 306 -69 274 -137 l 353 38 l 364 53 l 664 729 l 761 729 l 396 -87 q 328 -200 365 -158 q 249 -259 292 -242 q 153 -276 206 -276 m 347 -21 l 11 729 l 114 729 l 411 60 l 347 -21 m 153 896 l 153 961 l 581 961 l 581 896 l 153 896 z "
  },
  ӱ: {
    ha: 775,
    x_min: -25,
    x_max: 761,
    o: "m 153 -276 q 55 -260 101 -276 q -25 -210 8 -243 l 21 -136 q 81 -177 49 -162 q 154 -192 114 -192 q 238 -165 203 -192 q 306 -69 274 -137 l 353 38 l 364 53 l 664 729 l 761 729 l 396 -87 q 328 -200 365 -158 q 249 -259 292 -242 q 153 -276 206 -276 m 347 -21 l 11 729 l 114 729 l 411 60 l 347 -21 m 490 875 q 449 892 467 875 q 431 935 431 908 q 449 978 431 961 q 490 994 467 994 q 533 978 515 994 q 550 935 550 961 q 533 892 550 908 q 490 875 515 875 m 243 875 q 201 892 218 875 q 183 935 183 908 q 201 978 183 961 q 243 994 218 994 q 285 978 267 994 q 303 935 303 961 q 285 892 303 908 q 243 875 267 875 z "
  },
  ӳ: {
    ha: 775,
    x_min: -25,
    x_max: 761,
    o: "m 153 -276 q 55 -260 101 -276 q -25 -210 8 -243 l 21 -136 q 81 -177 49 -162 q 154 -192 114 -192 q 238 -165 203 -192 q 306 -69 274 -137 l 353 38 l 364 53 l 664 729 l 761 729 l 396 -87 q 328 -200 365 -158 q 249 -259 292 -242 q 153 -276 206 -276 m 347 -21 l 11 729 l 114 729 l 411 60 l 347 -21 m 436 843 l 569 1015 l 679 1015 l 524 843 l 436 843 m 210 843 l 344 1015 l 454 1015 l 297 843 l 210 843 z "
  },
  ӵ: {
    ha: 832,
    x_min: 65,
    x_max: 692,
    o: "m 601 308 q 473 265 538 281 q 344 249 408 249 q 140 308 215 249 q 65 490 65 367 l 65 729 l 163 729 l 163 496 q 217 371 163 413 q 363 329 271 329 q 479 344 418 329 q 603 386 540 358 l 601 308 m 593 0 l 593 729 l 692 729 l 692 0 l 593 0 m 499 875 q 457 892 475 875 q 439 935 439 908 q 457 978 439 961 q 499 994 475 994 q 541 978 524 994 q 558 935 558 961 q 541 892 558 908 q 499 875 524 875 m 251 875 q 209 892 226 875 q 192 935 192 908 q 209 978 192 961 q 251 994 226 994 q 293 978 275 994 q 311 935 311 961 q 293 892 311 908 q 251 875 275 875 z "
  },
  "ӷ": {
    ha: 660,
    x_min: 140,
    x_max: 657,
    o: "m 140 0 l 140 729 l 657 729 l 657 643 l 214 643 l 239 668 l 239 0 l 140 0 m 264 -160 l 264 26 l 289 0 l 140 0 l 140 86 l 357 86 l 357 -160 l 264 -160 z "
  },
  ӹ: {
    ha: 1090,
    x_min: 140,
    x_max: 950,
    o: "m 851 0 l 851 729 l 950 729 l 950 0 l 851 0 m 447 472 q 657 411 585 471 q 729 239 729 351 q 651 60 729 122 q 429 -1 574 -3 l 140 0 l 140 729 l 239 729 l 239 475 l 447 472 m 422 74 q 577 115 525 72 q 629 239 629 157 q 578 359 629 321 q 422 399 526 397 l 239 401 l 239 76 l 422 74 m 690 875 q 649 892 667 875 q 631 935 631 908 q 649 978 631 961 q 690 994 667 994 q 733 978 715 994 q 750 935 750 961 q 733 892 750 908 q 690 875 715 875 m 443 875 q 401 892 418 875 q 383 935 383 908 q 401 978 383 961 q 443 994 418 994 q 485 978 467 994 q 503 935 503 961 q 485 892 503 908 q 443 875 467 875 z "
  },
  "ӻ": {
    ha: 664,
    x_min: 18,
    x_max: 631,
    o: "m 168 0 l 168 729 l 631 729 l 631 643 l 267 643 l 267 0 l 168 0 m 174 -276 q 88 -264 129 -276 q 18 -228 46 -251 l 50 -156 q 101 -183 71 -174 q 163 -193 131 -193 q 253 -158 222 -193 q 285 -53 285 -122 l 285 22 l 315 0 l 168 0 l 168 86 l 383 86 l 383 -64 q 359 -175 383 -128 q 288 -249 335 -222 q 174 -276 242 -276 m 56 308 l 56 381 l 574 381 l 574 308 l 56 308 z "
  },
  "ӽ": {
    ha: 728,
    x_min: 24,
    x_max: 708,
    o: "m 24 0 l 308 375 l 40 729 l 151 729 l 365 447 l 582 729 l 692 729 l 136 0 l 24 0 m 500 -276 q 346 -233 421 -276 l 378 -158 q 431 -183 403 -174 q 488 -193 460 -193 q 576 -160 542 -193 q 610 -76 610 -126 q 583 20 610 -33 q 495 150 556 74 q 335 342 435 226 l 403 404 q 543 234 485 307 q 638 106 601 161 q 692 6 675 51 q 708 -82 708 -40 q 681 -185 708 -142 q 608 -253 654 -229 q 500 -276 561 -276 z "
  },
  "ӿ": {
    ha: 771,
    x_min: 40,
    x_max: 731,
    o: "m 40 0 l 350 403 l 347 346 l 56 729 l 169 729 l 407 418 l 365 417 l 607 729 l 714 729 l 419 347 l 421 407 l 731 0 l 614 0 l 365 331 l 403 326 l 151 0 l 40 0 m 129 333 l 129 406 l 643 406 l 643 333 l 129 333 z "
  },
  "ԑ": {
    ha: 742,
    x_min: 83,
    x_max: 700,
    o: "m 406 -8 q 242 19 315 -8 q 126 97 169 47 q 83 211 83 146 q 153 343 83 294 q 347 392 224 392 l 353 365 q 226 388 282 365 q 138 450 171 410 q 104 544 104 490 q 146 649 104 606 q 258 717 188 693 q 415 738 328 740 q 543 720 479 738 q 669 669 607 703 l 642 593 q 527 637 585 622 q 414 653 469 651 q 307 639 354 653 q 233 597 260 625 q 206 531 206 569 q 229 468 206 494 q 294 428 253 442 q 388 414 335 414 l 507 414 l 507 342 l 382 342 q 238 309 290 342 q 185 218 185 276 q 213 146 185 178 q 290 96 240 114 q 408 76 340 78 q 546 97 476 76 q 667 156 615 117 l 700 82 q 563 14 640 36 q 406 -8 485 -8 z "
  },
  "ԓ": {
    ha: 878,
    x_min: 7,
    x_max: 738,
    o: "m 526 -276 q 440 -265 482 -276 q 371 -229 399 -253 l 404 -154 q 514 -192 449 -192 q 606 -157 574 -192 q 639 -54 639 -122 l 639 672 l 664 643 l 267 643 l 290 674 l 279 463 q 265 282 275 368 q 233 131 254 196 q 174 28 211 65 q 78 -10 136 -10 q 44 -6 61 -10 q 7 1 26 -3 l 14 85 q 33 82 24 83 q 49 81 42 81 q 120 114 93 81 q 161 203 147 147 q 181 328 175 258 q 190 469 186 399 l 203 729 l 738 729 l 738 -58 q 683 -217 738 -157 q 526 -276 629 -276 z "
  },
  "ԛ": {
    ha: 953,
    x_min: 71,
    x_max: 811,
    o: "m 435 -7 q 248 40 331 -7 q 118 171 165 88 q 71 365 71 254 q 118 559 71 475 q 248 690 165 643 q 435 736 331 736 q 608 693 532 736 q 728 567 683 650 q 772 365 772 485 q 727 163 772 246 q 606 37 682 81 q 435 -7 531 -7 m 442 81 q 581 116 519 81 q 678 216 643 151 q 714 365 714 281 q 678 514 714 450 q 581 614 643 578 q 442 650 519 650 q 304 614 365 650 q 207 514 243 578 q 171 365 171 450 q 207 216 171 281 q 304 116 243 151 q 442 81 365 81 m 713 -269 l 713 217 l 726 364 l 717 510 l 717 729 l 811 729 l 811 -269 l 713 -269 z "
  },
  "ԝ": {
    ha: 1289,
    x_min: 19,
    x_max: 1268,
    o: "m 306 0 l 19 729 l 122 729 l 382 53 l 333 53 l 601 729 l 693 729 l 956 53 l 908 53 l 1172 729 l 1268 729 l 983 0 l 882 0 l 631 636 l 660 636 l 407 0 l 306 0 z "
  },
  ҍ: {
    ha: 824,
    x_min: 32,
    x_max: 778,
    o: "m 183 0 l 183 729 l 282 729 l 282 463 l 496 461 q 706 403 633 460 q 778 235 778 347 q 700 58 778 118 q 478 -1 622 -3 l 183 0 m 472 74 q 626 113 574 72 q 678 235 678 154 q 626 351 678 317 q 472 388 575 386 l 282 389 l 282 76 l 472 74 m 32 563 l 32 636 l 556 636 l 556 563 l 32 563 z "
  },
  ҏ: {
    ha: 968,
    x_min: 142,
    x_max: 883,
    o: "m 529 -7 q 356 38 431 -7 q 240 167 282 83 q 199 364 199 250 q 240 563 199 479 q 355 691 281 646 q 529 736 429 736 q 710 690 631 736 q 837 559 790 643 q 883 364 883 475 q 837 170 883 254 q 710 40 790 86 q 529 -7 631 -7 m 142 -269 l 142 729 l 236 729 l 236 510 l 226 364 l 240 215 l 240 -269 l 142 -269 m 513 79 q 653 115 590 79 q 751 215 715 150 q 786 364 786 279 q 750 514 786 450 q 652 614 714 578 q 513 650 590 650 q 372 614 435 650 q 274 514 310 578 q 239 364 239 450 q 274 215 239 279 q 372 115 310 150 q 513 79 435 79 m 864 -42 l 807 -86 l 542 249 l 600 294 l 864 -42 z "
  },
  "ԩ": {
    ha: 938,
    x_min: -125,
    x_max: 797,
    o: "m 699 729 l 797 729 l 797 0 l 699 0 l 699 324 l 240 324 l 240 -60 q 186 -217 240 -157 q 32 -276 132 -276 q -55 -265 -12 -276 q -125 -229 -97 -253 l -92 -154 q 18 -192 -49 -192 q 110 -157 78 -192 q 142 -54 142 -122 l 142 729 l 240 729 l 240 410 l 699 410 l 699 729 z "
  },
  "ԯ": {
    ha: 903,
    x_min: 7,
    x_max: 854,
    o: "m 7 1 l 14 86 q 33 83 24 85 q 49 81 42 81 q 120 114 93 81 q 161 203 147 147 q 181 328 175 258 q 190 469 186 399 l 203 729 l 738 729 l 738 0 l 639 0 l 639 672 l 664 643 l 267 643 l 290 674 l 279 463 q 265 282 275 368 q 233 131 254 196 q 174 28 211 65 q 78 -8 136 -8 q 44 -6 61 -8 q 7 1 26 -3 m 761 -160 l 761 26 l 786 0 l 638 0 l 638 86 l 854 86 l 854 -160 l 761 -160 z "
  },
  Δ: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 549 972 l 993 0 l 3 0 l 447 972 l 549 972 m 126 40 l 96 89 l 897 89 l 867 40 l 476 913 l 518 913 l 126 40 z "
  },
  Ω: {
    ha: 1253,
    x_min: 13,
    x_max: 1240,
    o: "m 13 0 l 13 90 l 324 90 q 169 267 222 161 q 117 494 117 372 q 155 690 117 601 q 263 844 193 779 q 425 945 332 910 q 626 981 518 981 q 828 945 736 981 q 990 844 921 910 q 1098 690 1060 779 q 1136 494 1136 601 q 1083 267 1136 372 q 929 90 1031 161 l 1240 90 l 1240 0 l 771 0 l 771 83 q 967 258 900 150 q 1033 490 1033 365 q 1003 651 1033 578 q 919 777 974 724 q 790 860 864 831 q 626 889 715 889 q 464 860 539 889 q 335 777 389 831 q 250 651 281 724 q 219 490 219 578 q 286 257 219 365 q 482 83 353 149 l 482 0 l 13 0 z "
  },
  μ: {
    ha: 942,
    x_min: 138,
    x_max: 804,
    o: "m 138 -269 l 138 729 l 236 729 l 236 317 q 294 141 236 200 q 457 82 351 82 q 589 113 533 82 q 675 204 644 144 q 706 347 706 264 l 706 729 l 804 729 l 804 0 l 710 0 l 710 203 l 726 176 q 665 73 706 114 q 571 13 624 32 q 458 -7 518 -7 q 310 28 372 -7 q 217 132 249 64 l 236 176 l 236 -269 l 138 -269 z "
  },
  π: {
    ha: 1003,
    x_min: -8,
    x_max: 992,
    o: "m 47 365 q 6 440 21 397 q -8 522 -8 482 q 20 628 -8 581 q 103 702 49 675 q 233 729 157 729 l 992 729 l 990 647 l 244 647 q 122 610 163 647 q 82 507 82 574 q 93 449 82 479 q 124 392 104 418 l 47 365 m 249 0 l 326 676 l 425 676 l 347 0 l 249 0 m 672 0 l 672 676 l 769 676 l 769 0 l 672 0 z "
  },
  Å: {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 3 0 l 447 972 l 549 972 l 993 0 l 885 0 l 476 913 l 518 913 l 110 0 l 3 0 m 178 260 l 208 343 l 774 343 l 804 260 l 178 260 m 497 1069 q 423 1089 456 1069 q 372 1140 390 1108 q 353 1211 353 1172 q 372 1283 353 1250 q 423 1335 390 1315 q 497 1356 456 1356 q 572 1335 539 1356 q 624 1283 604 1315 q 643 1211 643 1250 q 624 1140 643 1172 q 572 1089 604 1108 q 497 1069 539 1069 m 497 1117 q 565 1144 539 1117 q 592 1211 592 1171 q 565 1279 592 1251 q 497 1307 538 1307 q 430 1280 457 1307 q 403 1211 403 1253 q 429 1144 403 1171 q 497 1117 456 1117 z "
  },
  K: {
    ha: 988,
    x_min: 158,
    x_max: 979,
    o: "m 247 242 l 243 367 l 832 972 l 950 972 l 521 522 l 463 460 l 247 242 m 158 0 l 158 972 l 261 972 l 261 0 l 158 0 m 857 0 l 438 483 l 507 558 l 979 0 l 857 0 z "
  },
  "₀": {
    ha: 597,
    x_min: 44,
    x_max: 553,
    o: "m 299 -144 q 115 -65 185 -144 q 44 150 44 14 q 115 364 44 285 q 299 443 185 443 q 483 364 413 443 q 553 150 553 285 q 483 -65 553 14 q 299 -144 413 -144 m 299 -81 q 428 -21 378 -81 q 479 150 479 39 q 428 320 479 261 q 299 379 378 379 q 169 320 219 379 q 118 150 118 261 q 169 -21 118 39 q 299 -81 219 -81 z "
  },
  "₁": {
    ha: 597,
    x_min: 117,
    x_max: 511,
    o: "m 361 -124 l 315 -76 l 511 -76 l 511 -139 l 117 -139 l 117 -76 l 331 -76 l 285 -124 l 285 410 l 318 375 l 126 375 l 126 438 l 361 438 l 361 -124 z "
  },
  "₂": {
    ha: 597,
    x_min: 44,
    x_max: 522,
    o: "m 67 -139 l 67 -90 l 331 143 q 402 222 385 192 q 419 281 419 251 q 383 350 419 321 q 265 379 347 379 q 168 363 213 379 q 96 315 124 347 l 44 356 q 138 421 81 399 q 269 443 194 443 q 438 397 382 443 q 494 285 494 351 q 473 203 494 242 q 386 106 451 164 l 149 -104 l 125 -76 l 522 -76 l 522 -139 l 67 -139 z "
  },
  "₃": {
    ha: 597,
    x_min: 43,
    x_max: 521,
    o: "m 281 -144 q 140 -124 204 -144 q 43 -71 76 -104 l 75 -15 q 161 -62 107 -43 q 281 -81 215 -81 q 406 -51 365 -81 q 446 28 446 -21 q 406 107 446 78 q 283 136 367 136 l 225 136 l 225 188 l 424 403 l 435 375 l 58 375 l 58 438 l 493 438 l 493 389 l 296 172 l 264 193 l 296 193 q 463 147 406 193 q 521 28 521 101 q 494 -59 521 -19 q 413 -122 467 -99 q 281 -144 360 -144 z "
  },
  "₄": {
    ha: 597,
    x_min: 38,
    x_max: 556,
    o: "m 38 8 l 38 58 l 324 438 l 407 438 l 119 58 l 82 69 l 556 69 l 556 8 l 38 8 m 361 -139 l 361 8 l 367 69 l 367 196 l 433 196 l 433 -139 l 361 -139 z "
  },
  "₅": {
    ha: 597,
    x_min: 47,
    x_max: 524,
    o: "m 283 -144 q 144 -124 208 -144 q 47 -71 79 -104 l 78 -15 q 164 -62 110 -43 q 283 -81 218 -81 q 409 -51 368 -81 q 450 28 450 -21 q 407 103 450 76 q 251 131 364 131 l 96 131 l 129 438 l 486 438 l 486 375 l 157 375 l 194 410 l 167 160 l 129 193 l 263 193 q 417 172 360 193 q 499 114 474 151 q 524 28 524 76 q 497 -60 524 -21 q 416 -122 469 -99 q 283 -144 363 -144 z "
  },
  "₆": {
    ha: 597,
    x_min: 58,
    x_max: 546,
    o: "m 324 -144 q 127 -69 196 -144 q 58 142 58 6 q 97 304 58 238 q 203 407 135 371 q 365 443 272 443 q 444 435 404 443 q 513 411 485 428 l 486 353 q 428 373 460 367 q 364 379 397 379 q 196 320 260 379 q 132 153 132 261 q 135 109 132 135 q 144 60 138 83 l 125 85 q 193 174 136 140 q 329 208 250 208 q 442 187 394 208 q 518 126 490 165 q 546 36 546 88 q 517 -59 546 -18 q 440 -122 489 -100 q 324 -144 390 -144 m 322 -86 q 432 -53 392 -86 q 472 32 472 -21 q 432 118 472 85 q 317 151 392 151 q 201 118 246 151 q 157 32 157 85 q 174 -23 157 4 q 228 -68 190 -50 q 322 -86 265 -86 z "
  },
  "₇": {
    ha: 597,
    x_min: 54,
    x_max: 551,
    o: "m 189 -139 l 478 408 l 501 375 l 88 375 l 121 411 l 121 271 l 54 271 l 54 438 l 551 438 l 551 389 l 272 -139 l 189 -139 z "
  },
  "₈": {
    ha: 597,
    x_min: 43,
    x_max: 554,
    o: "m 297 -144 q 161 -124 218 -144 q 74 -66 104 -103 q 43 19 43 -29 q 73 106 43 71 q 160 161 103 142 q 297 181 217 181 q 437 161 379 181 q 524 106 494 142 q 554 19 554 71 q 524 -66 554 -29 q 435 -124 493 -103 q 297 -144 378 -144 m 297 -86 q 433 -56 385 -86 q 481 24 481 -26 q 433 103 481 72 q 297 133 385 133 q 164 103 211 133 q 117 24 117 72 q 164 -56 117 -26 q 297 -86 211 -86 m 297 143 q 124 182 185 143 q 64 290 64 221 q 127 401 64 358 q 297 443 190 443 q 469 400 406 443 q 533 289 533 357 q 472 182 533 221 q 297 143 411 143 m 297 189 q 418 217 376 189 q 460 288 460 244 q 417 358 460 332 q 297 385 374 385 q 179 358 221 385 q 138 289 138 332 q 179 217 138 246 q 297 189 221 189 z "
  },
  "₉": {
    ha: 597,
    x_min: 51,
    x_max: 539,
    o: "m 232 -144 q 153 -137 193 -144 q 85 -112 114 -129 l 111 -54 q 169 -74 139 -68 q 233 -81 200 -81 q 402 -21 339 -81 q 465 146 465 39 q 463 190 465 164 q 453 239 460 215 l 472 214 q 405 125 461 160 q 268 90 349 90 q 156 112 204 90 q 79 172 107 133 q 51 263 51 211 q 80 358 51 318 q 158 421 108 399 q 274 443 208 443 q 470 369 401 443 q 539 157 539 294 q 501 -5 539 63 q 394 -108 463 -72 q 232 -144 325 -144 m 281 147 q 396 181 351 147 q 440 267 440 215 q 424 322 440 294 q 370 367 407 349 q 275 385 333 385 q 165 353 206 385 q 124 267 124 321 q 165 181 124 215 q 281 147 206 147 z "
  },
  "⁰": {
    ha: 597,
    x_min: 44,
    x_max: 553,
    o: "m 299 449 q 115 528 185 449 q 44 743 44 607 q 115 957 44 878 q 299 1036 185 1036 q 483 957 413 1036 q 553 743 553 878 q 483 528 553 607 q 299 449 413 449 m 299 513 q 428 572 378 513 q 479 743 479 632 q 428 913 479 854 q 299 972 378 972 q 169 913 219 972 q 118 743 118 854 q 169 572 118 632 q 299 513 219 513 z "
  },
  "¹": {
    ha: 597,
    x_min: 117,
    x_max: 511,
    o: "m 361 469 l 315 517 l 511 517 l 511 454 l 117 454 l 117 517 l 331 517 l 285 469 l 285 1003 l 318 968 l 126 968 l 126 1031 l 361 1031 l 361 469 z "
  },
  "²": {
    ha: 597,
    x_min: 44,
    x_max: 522,
    o: "m 67 454 l 67 503 l 331 736 q 402 815 385 785 q 419 874 419 844 q 383 943 419 914 q 265 972 347 972 q 168 956 213 972 q 96 908 124 940 l 44 949 q 138 1014 81 992 q 269 1036 194 1036 q 438 990 382 1036 q 494 878 494 944 q 473 796 494 835 q 386 699 451 757 l 149 489 l 125 517 l 522 517 l 522 454 l 67 454 z "
  },
  "³": {
    ha: 597,
    x_min: 43,
    x_max: 521,
    o: "m 281 449 q 140 469 204 449 q 43 522 76 489 l 75 578 q 161 531 107 550 q 281 513 215 513 q 406 542 365 513 q 446 621 446 572 q 406 700 446 671 q 283 729 367 729 l 225 729 l 225 781 l 424 996 l 435 968 l 58 968 l 58 1031 l 493 1031 l 493 982 l 296 765 l 264 786 l 296 786 q 463 740 406 786 q 521 621 521 694 q 494 534 521 574 q 413 472 467 494 q 281 449 360 449 z "
  },
  "⁴": {
    ha: 597,
    x_min: 38,
    x_max: 556,
    o: "m 38 601 l 38 651 l 324 1031 l 407 1031 l 119 651 l 82 663 l 556 663 l 556 601 l 38 601 m 361 454 l 361 601 l 367 663 l 367 789 l 433 789 l 433 454 l 361 454 z "
  },
  "⁵": {
    ha: 597,
    x_min: 47,
    x_max: 524,
    o: "m 283 449 q 144 469 208 449 q 47 522 79 489 l 78 578 q 164 531 110 550 q 283 513 218 513 q 409 542 368 513 q 450 621 450 572 q 407 697 450 669 q 251 724 364 724 l 96 724 l 129 1031 l 486 1031 l 486 968 l 157 968 l 194 1003 l 167 753 l 129 786 l 263 786 q 417 765 360 786 q 499 707 474 744 q 524 621 524 669 q 497 533 524 572 q 416 472 469 494 q 283 449 363 449 z "
  },
  "⁶": {
    ha: 597,
    x_min: 58,
    x_max: 546,
    o: "m 324 449 q 127 524 196 449 q 58 735 58 599 q 97 897 58 831 q 203 1000 135 964 q 365 1036 272 1036 q 444 1028 404 1036 q 513 1004 485 1021 l 486 946 q 428 966 460 960 q 364 972 397 972 q 196 913 260 972 q 132 746 132 854 q 135 702 132 728 q 144 653 138 676 l 125 678 q 193 767 136 733 q 329 801 250 801 q 442 780 394 801 q 518 719 490 758 q 546 629 546 681 q 517 534 546 575 q 440 471 489 493 q 324 449 390 449 m 322 507 q 432 540 392 507 q 472 625 472 572 q 432 711 472 678 q 317 744 392 744 q 201 711 246 744 q 157 625 157 678 q 174 570 157 597 q 228 525 190 543 q 322 507 265 507 z "
  },
  "⁷": {
    ha: 597,
    x_min: 54,
    x_max: 551,
    o: "m 189 454 l 478 1001 l 501 968 l 88 968 l 121 1004 l 121 864 l 54 864 l 54 1031 l 551 1031 l 551 982 l 272 454 l 189 454 z "
  },
  "⁸": {
    ha: 597,
    x_min: 43,
    x_max: 554,
    o: "m 297 449 q 161 469 218 449 q 74 527 104 490 q 43 613 43 564 q 73 699 43 664 q 160 754 103 735 q 297 774 217 774 q 437 754 379 774 q 524 699 494 735 q 554 613 554 664 q 524 527 554 564 q 435 469 493 490 q 297 449 378 449 m 297 507 q 433 537 385 507 q 481 617 481 567 q 433 696 481 665 q 297 726 385 726 q 164 696 211 726 q 117 617 117 665 q 164 537 117 567 q 297 507 211 507 m 297 736 q 124 775 185 736 q 64 883 64 814 q 127 994 64 951 q 297 1036 190 1036 q 469 993 406 1036 q 533 882 533 950 q 472 775 533 814 q 297 736 411 736 m 297 782 q 418 810 376 782 q 460 881 460 838 q 417 951 460 925 q 297 978 374 978 q 179 951 221 978 q 138 882 138 925 q 179 810 138 839 q 297 782 221 782 z "
  },
  "⁹": {
    ha: 597,
    x_min: 51,
    x_max: 539,
    o: "m 232 449 q 153 456 193 449 q 85 481 114 464 l 111 539 q 169 519 139 525 q 233 513 200 513 q 402 572 339 513 q 465 739 465 632 q 463 783 465 757 q 453 832 460 808 l 472 807 q 405 718 461 753 q 268 683 349 683 q 156 705 204 683 q 79 765 107 726 q 51 856 51 804 q 80 951 51 911 q 158 1014 108 992 q 274 1036 208 1036 q 470 962 401 1036 q 539 750 539 888 q 501 588 539 656 q 394 485 463 521 q 232 449 325 449 m 281 740 q 396 774 351 740 q 440 860 440 808 q 424 915 440 888 q 370 960 407 942 q 275 978 333 978 q 165 946 206 978 q 124 860 124 914 q 165 774 124 808 q 281 740 206 740 z "
  },
  "⁄": {
    ha: 235,
    x_min: -256,
    x_max: 490,
    o: "m -256 0 l 408 972 l 490 972 l -174 0 l -256 0 z "
  },
  "½": {
    ha: 1429,
    x_min: 117,
    x_max: 1354,
    o: "m 361 411 l 315 458 l 511 458 l 511 396 l 117 396 l 117 458 l 331 458 l 285 411 l 285 944 l 318 910 l 126 910 l 126 972 l 361 972 l 361 411 m 342 0 l 1006 972 l 1088 972 l 424 0 l 342 0 m 899 0 l 899 49 l 1163 282 q 1234 360 1217 331 q 1251 419 1251 390 q 1215 489 1251 460 q 1097 518 1179 518 q 1000 502 1044 518 q 928 454 956 486 l 876 494 q 969 560 913 538 q 1101 582 1026 582 q 1270 536 1214 582 q 1326 424 1326 490 q 1305 342 1326 381 q 1218 244 1283 303 l 981 35 l 957 63 l 1354 63 l 1354 0 l 899 0 z "
  },
  "⅓": {
    ha: 1429,
    x_min: 117,
    x_max: 1353,
    o: "m 361 411 l 315 458 l 511 458 l 511 396 l 117 396 l 117 458 l 331 458 l 285 411 l 285 944 l 318 910 l 126 910 l 126 972 l 361 972 l 361 411 m 342 0 l 1006 972 l 1088 972 l 424 0 l 342 0 m 1113 -6 q 972 15 1036 -6 q 875 68 908 35 l 907 124 q 993 77 939 96 q 1113 58 1047 58 q 1238 88 1197 58 q 1278 167 1278 118 q 1238 246 1278 217 q 1115 275 1199 275 l 1057 275 l 1057 326 l 1256 542 l 1267 514 l 890 514 l 890 576 l 1325 576 l 1325 528 l 1128 311 l 1096 332 l 1128 332 q 1295 286 1238 332 q 1353 167 1353 240 q 1326 80 1353 119 q 1245 17 1299 40 q 1113 -6 1192 -6 z "
  },
  "⅔": {
    ha: 1429,
    x_min: 44,
    x_max: 1353,
    o: "m 67 396 l 67 444 l 331 678 q 402 756 385 726 q 419 815 419 786 q 383 885 419 856 q 265 914 347 914 q 168 898 213 914 q 96 850 124 882 l 44 890 q 138 956 81 933 q 269 978 194 978 q 438 932 382 978 q 494 819 494 886 q 473 738 494 776 q 386 640 451 699 l 149 431 l 125 458 l 522 458 l 522 396 l 67 396 m 342 0 l 1006 972 l 1088 972 l 424 0 l 342 0 m 1113 -6 q 972 15 1036 -6 q 875 68 908 35 l 907 124 q 993 77 939 96 q 1113 58 1047 58 q 1238 88 1197 58 q 1278 167 1278 118 q 1238 246 1278 217 q 1115 275 1199 275 l 1057 275 l 1057 326 l 1256 542 l 1267 514 l 890 514 l 890 576 l 1325 576 l 1325 528 l 1128 311 l 1096 332 l 1128 332 q 1295 286 1238 332 q 1353 167 1353 240 q 1326 80 1353 119 q 1245 17 1299 40 q 1113 -6 1192 -6 z "
  },
  "¼": {
    ha: 1429,
    x_min: 117,
    x_max: 1388,
    o: "m 361 411 l 315 458 l 511 458 l 511 396 l 117 396 l 117 458 l 331 458 l 285 411 l 285 944 l 318 910 l 126 910 l 126 972 l 361 972 l 361 411 m 342 0 l 1006 972 l 1088 972 l 424 0 l 342 0 m 869 147 l 869 197 l 1156 576 l 1239 576 l 951 197 l 914 208 l 1388 208 l 1388 147 l 869 147 m 1193 0 l 1193 147 l 1199 208 l 1199 335 l 1265 335 l 1265 0 l 1193 0 z "
  },
  "¾": {
    ha: 1429,
    x_min: 43,
    x_max: 1388,
    o: "m 281 390 q 140 410 204 390 q 43 464 76 431 l 75 519 q 161 473 107 492 q 281 454 215 454 q 406 484 365 454 q 446 563 446 514 q 406 642 446 613 q 283 671 367 671 l 225 671 l 225 722 l 424 938 l 435 910 l 58 910 l 58 972 l 493 972 l 493 924 l 296 707 l 264 728 l 296 728 q 463 682 406 728 q 521 563 521 636 q 494 476 521 515 q 413 413 467 436 q 281 390 360 390 m 342 0 l 1006 972 l 1088 972 l 424 0 l 342 0 m 869 147 l 869 197 l 1156 576 l 1239 576 l 951 197 l 914 208 l 1388 208 l 1388 147 l 869 147 m 1193 0 l 1193 147 l 1199 208 l 1199 335 l 1265 335 l 1265 0 l 1193 0 z "
  },
  "⅛": {
    ha: 1429,
    x_min: 117,
    x_max: 1386,
    o: "m 361 411 l 315 458 l 511 458 l 511 396 l 117 396 l 117 458 l 331 458 l 285 411 l 285 944 l 318 910 l 126 910 l 126 972 l 361 972 l 361 411 m 342 0 l 1006 972 l 1088 972 l 424 0 l 342 0 m 1129 -6 q 993 15 1050 -6 q 906 73 936 36 q 875 158 875 110 q 905 245 875 210 q 992 300 935 281 q 1129 319 1049 319 q 1269 300 1211 319 q 1356 245 1326 281 q 1386 158 1386 210 q 1356 73 1386 110 q 1267 15 1325 36 q 1129 -6 1210 -6 m 1129 53 q 1265 83 1217 53 q 1313 163 1313 113 q 1265 242 1313 211 q 1129 272 1217 272 q 996 242 1043 272 q 949 163 949 211 q 996 83 949 113 q 1129 53 1043 53 m 1129 282 q 956 321 1017 282 q 896 429 896 360 q 959 540 896 497 q 1129 582 1022 582 q 1301 539 1238 582 q 1365 428 1365 496 q 1304 321 1365 360 q 1129 282 1243 282 m 1129 328 q 1250 356 1208 328 q 1292 426 1292 383 q 1249 497 1292 471 q 1129 524 1206 524 q 1011 497 1053 524 q 969 428 969 471 q 1011 356 969 385 q 1129 328 1053 328 z "
  },
  "⅜": {
    ha: 1429,
    x_min: 43,
    x_max: 1386,
    o: "m 281 390 q 140 410 204 390 q 43 464 76 431 l 75 519 q 161 473 107 492 q 281 454 215 454 q 406 484 365 454 q 446 563 446 514 q 406 642 446 613 q 283 671 367 671 l 225 671 l 225 722 l 424 938 l 435 910 l 58 910 l 58 972 l 493 972 l 493 924 l 296 707 l 264 728 l 296 728 q 463 682 406 728 q 521 563 521 636 q 494 476 521 515 q 413 413 467 436 q 281 390 360 390 m 342 0 l 1006 972 l 1088 972 l 424 0 l 342 0 m 1129 -6 q 993 15 1050 -6 q 906 73 936 36 q 875 158 875 110 q 905 245 875 210 q 992 300 935 281 q 1129 319 1049 319 q 1269 300 1211 319 q 1356 245 1326 281 q 1386 158 1386 210 q 1356 73 1386 110 q 1267 15 1325 36 q 1129 -6 1210 -6 m 1129 53 q 1265 83 1217 53 q 1313 163 1313 113 q 1265 242 1313 211 q 1129 272 1217 272 q 996 242 1043 272 q 949 163 949 211 q 996 83 949 113 q 1129 53 1043 53 m 1129 282 q 956 321 1017 282 q 896 429 896 360 q 959 540 896 497 q 1129 582 1022 582 q 1301 539 1238 582 q 1365 428 1365 496 q 1304 321 1365 360 q 1129 282 1243 282 m 1129 328 q 1250 356 1208 328 q 1292 426 1292 383 q 1249 497 1292 471 q 1129 524 1206 524 q 1011 497 1053 524 q 969 428 969 471 q 1011 356 969 385 q 1129 328 1053 328 z "
  },
  "⅝": {
    ha: 1429,
    x_min: 47,
    x_max: 1386,
    o: "m 283 390 q 144 410 208 390 q 47 464 79 431 l 78 519 q 164 473 110 492 q 283 454 218 454 q 409 484 368 454 q 450 563 450 514 q 407 638 450 611 q 251 665 364 665 l 96 665 l 129 972 l 486 972 l 486 910 l 157 910 l 194 944 l 167 694 l 129 728 l 263 728 q 417 707 360 728 q 499 649 474 686 q 524 563 524 611 q 497 475 524 514 q 416 413 469 436 q 283 390 363 390 m 342 0 l 1006 972 l 1088 972 l 424 0 l 342 0 m 1129 -6 q 993 15 1050 -6 q 906 73 936 36 q 875 158 875 110 q 905 245 875 210 q 992 300 935 281 q 1129 319 1049 319 q 1269 300 1211 319 q 1356 245 1326 281 q 1386 158 1386 210 q 1356 73 1386 110 q 1267 15 1325 36 q 1129 -6 1210 -6 m 1129 53 q 1265 83 1217 53 q 1313 163 1313 113 q 1265 242 1313 211 q 1129 272 1217 272 q 996 242 1043 272 q 949 163 949 211 q 996 83 949 113 q 1129 53 1043 53 m 1129 282 q 956 321 1017 282 q 896 429 896 360 q 959 540 896 497 q 1129 582 1022 582 q 1301 539 1238 582 q 1365 428 1365 496 q 1304 321 1365 360 q 1129 282 1243 282 m 1129 328 q 1250 356 1208 328 q 1292 426 1292 383 q 1249 497 1292 471 q 1129 524 1206 524 q 1011 497 1053 524 q 969 428 969 471 q 1011 356 969 385 q 1129 328 1053 328 z "
  },
  "⅞": {
    ha: 1429,
    x_min: 54,
    x_max: 1386,
    o: "m 189 396 l 478 943 l 501 910 l 88 910 l 121 946 l 121 806 l 54 806 l 54 972 l 551 972 l 551 924 l 272 396 l 189 396 m 342 0 l 1006 972 l 1088 972 l 424 0 l 342 0 m 1129 -6 q 993 15 1050 -6 q 906 73 936 36 q 875 158 875 110 q 905 245 875 210 q 992 300 935 281 q 1129 319 1049 319 q 1269 300 1211 319 q 1356 245 1326 281 q 1386 158 1386 210 q 1356 73 1386 110 q 1267 15 1325 36 q 1129 -6 1210 -6 m 1129 53 q 1265 83 1217 53 q 1313 163 1313 113 q 1265 242 1313 211 q 1129 272 1217 272 q 996 242 1043 272 q 949 163 949 211 q 996 83 949 113 q 1129 53 1043 53 m 1129 282 q 956 321 1017 282 q 896 429 896 360 q 959 540 896 497 q 1129 582 1022 582 q 1301 539 1238 582 q 1365 428 1365 496 q 1304 321 1365 360 q 1129 282 1243 282 m 1129 328 q 1250 356 1208 328 q 1292 426 1292 383 q 1249 497 1292 471 q 1129 524 1206 524 q 1011 497 1053 524 q 969 428 969 471 q 1011 356 969 385 q 1129 328 1053 328 z "
  },
  ".": {
    ha: 294,
    x_min: 74,
    x_max: 221,
    o: "m 147 -7 q 95 15 117 -7 q 74 69 74 38 q 95 124 74 103 q 147 144 117 144 q 199 124 178 144 q 221 69 221 103 q 199 15 221 38 q 147 -7 178 -7 z "
  },
  ",": {
    ha: 294,
    x_min: 75,
    x_max: 221,
    o: "m 78 -203 l 139 54 l 150 -6 q 97 15 118 -6 q 75 69 75 36 q 97 124 75 103 q 149 144 118 144 q 201 122 181 144 q 221 69 221 100 q 219 47 221 58 q 214 22 218 36 q 203 -11 210 8 l 144 -203 l 78 -203 z "
  },
  ":": {
    ha: 294,
    x_min: 74,
    x_max: 221,
    o: "m 147 585 q 95 607 117 585 q 74 661 74 629 q 95 715 74 694 q 147 736 117 736 q 199 715 178 736 q 221 661 221 694 q 199 607 221 629 q 147 585 178 585 m 147 -7 q 95 15 117 -7 q 74 69 74 38 q 95 124 74 103 q 147 144 117 144 q 199 124 178 144 q 221 69 221 103 q 199 15 221 38 q 147 -7 178 -7 z "
  },
  ";": {
    ha: 294,
    x_min: 74,
    x_max: 221,
    o: "m 147 585 q 95 607 117 585 q 74 661 74 629 q 95 715 74 694 q 147 736 117 736 q 199 715 178 736 q 221 661 221 694 q 199 607 221 629 q 147 585 178 585 m 78 -203 l 139 54 l 150 -6 q 97 15 118 -6 q 75 69 75 36 q 97 124 75 103 q 149 144 118 144 q 201 122 181 144 q 221 69 221 100 q 219 47 221 58 q 214 22 218 36 q 203 -11 210 8 l 144 -203 l 78 -203 z "
  },
  "…": {
    ha: 899,
    x_min: 74,
    x_max: 825,
    o: "m 147 -7 q 95 15 117 -7 q 74 69 74 38 q 95 124 74 103 q 147 144 117 144 q 199 124 178 144 q 221 69 221 103 q 199 15 221 38 q 147 -7 178 -7 m 449 -7 q 397 15 418 -7 q 375 69 375 38 q 397 124 375 103 q 449 144 418 144 q 501 124 479 144 q 522 69 522 103 q 501 15 522 38 q 449 -7 479 -7 m 751 -7 q 699 15 721 -7 q 678 69 678 38 q 699 124 678 103 q 751 144 721 144 q 803 124 782 144 q 825 69 825 103 q 803 15 825 38 q 751 -7 782 -7 z "
  },
  "!": {
    ha: 361,
    x_min: 107,
    x_max: 253,
    o: "m 142 292 l 122 972 l 239 972 l 218 292 l 142 292 m 181 -7 q 128 15 150 -7 q 107 65 107 36 q 128 116 107 96 q 181 136 150 136 q 233 116 213 136 q 253 65 253 96 q 233 15 253 36 q 181 -7 213 -7 z "
  },
  "¡": {
    ha: 361,
    x_min: 107,
    x_max: 253,
    o: "m 218 438 l 239 -214 l 122 -214 l 142 438 l 218 438 m 181 736 q 233 715 213 736 q 253 664 253 694 q 233 614 253 635 q 181 593 213 593 q 128 614 150 593 q 107 664 107 635 q 128 715 107 694 q 181 736 150 736 z "
  },
  "?": {
    ha: 788,
    x_min: 18,
    x_max: 683,
    o: "m 326 292 q 345 392 326 350 q 392 465 364 433 q 453 525 421 497 q 515 581 486 553 q 563 644 544 610 q 581 724 581 678 q 522 846 581 799 q 357 893 464 893 q 203 865 268 893 q 92 781 138 836 l 18 836 q 161 943 74 906 q 364 981 249 981 q 533 951 461 981 q 644 868 604 922 q 683 739 683 814 q 665 637 683 679 q 617 562 646 594 q 556 501 589 529 q 494 443 524 472 q 447 378 465 414 q 429 292 429 342 l 326 292 m 378 -7 q 327 15 349 -7 q 306 65 306 36 q 327 116 306 96 q 378 136 349 136 q 431 116 410 136 q 451 65 451 96 q 431 15 451 36 q 378 -7 410 -7 z "
  },
  "¿": {
    ha: 788,
    x_min: 104,
    x_max: 769,
    o: "m 424 -222 q 255 -193 326 -222 q 144 -111 183 -164 q 104 11 104 -58 q 123 109 104 68 q 171 181 142 150 q 231 238 200 211 q 292 293 263 265 q 340 356 322 321 q 358 438 358 390 l 461 438 q 442 344 461 383 q 395 273 424 304 q 334 215 367 242 q 273 160 301 188 q 226 99 244 132 q 207 22 207 65 q 265 -89 207 -43 q 431 -135 324 -135 q 585 -106 519 -135 q 696 -22 650 -78 l 769 -78 q 627 -184 714 -146 q 424 -222 540 -222 m 410 593 q 358 614 379 593 q 338 664 338 635 q 358 715 338 694 q 410 736 379 736 q 461 715 440 736 q 482 664 482 694 q 461 614 482 635 q 410 593 440 593 z "
  },
  "·": {
    ha: 350,
    x_min: 101,
    x_max: 249,
    o: "m 175 300 q 123 322 144 300 q 101 376 101 344 q 123 431 101 410 q 175 453 144 453 q 228 431 207 453 q 249 376 249 410 q 228 322 249 344 q 175 300 207 300 z "
  },
  "•": {
    ha: 410,
    x_min: 101,
    x_max: 310,
    o: "m 206 274 q 153 288 178 274 q 115 325 129 301 q 101 381 101 349 q 115 433 101 410 q 153 471 129 457 q 206 485 178 485 q 257 471 233 485 q 295 433 281 457 q 310 381 310 410 q 295 325 310 349 q 257 288 281 301 q 206 274 233 274 z "
  },
  "*": {
    ha: 536,
    x_min: 31,
    x_max: 506,
    o: "m 506 876 l 314 768 l 314 790 l 506 682 l 474 624 l 285 733 l 300 740 l 300 528 l 236 528 l 238 740 l 251 733 l 64 624 l 31 682 l 224 790 l 224 768 l 31 876 l 64 935 l 251 825 l 238 818 l 236 1031 l 300 1031 l 300 818 l 285 825 l 474 935 l 506 876 z "
  },
  "#": {
    ha: 967,
    x_min: 40,
    x_max: 925,
    o: "m 567 0 l 686 972 l 761 972 l 642 0 l 567 0 m 40 264 l 40 340 l 881 340 l 881 264 l 40 264 m 206 0 l 325 972 l 401 972 l 281 0 l 206 0 m 85 632 l 85 708 l 925 708 l 925 632 l 85 632 z "
  },
  "/": {
    ha: 465,
    x_min: -35,
    x_max: 514,
    o: "m -35 -139 l 424 1169 l 514 1169 l 56 -139 l -35 -139 z "
  },
  "\\": {
    ha: 465,
    x_min: -49,
    x_max: 500,
    o: "m 500 -139 l 410 -139 l -49 1169 l 42 1169 l 500 -139 z "
  },
  "(": {
    ha: 457,
    x_min: 144,
    x_max: 400,
    o: "m 306 -269 q 187 23 229 -143 q 144 381 144 189 q 187 740 144 572 q 306 1031 229 907 l 400 1031 q 280 727 318 888 q 242 381 242 567 q 280 34 242 194 q 400 -269 318 -126 l 306 -269 z "
  },
  ")": {
    ha: 457,
    x_min: 56,
    x_max: 313,
    o: "m 150 -269 l 56 -269 q 177 34 139 -126 q 215 381 215 194 q 177 727 215 567 q 56 1031 139 888 l 150 1031 q 271 740 229 907 q 313 381 313 572 q 271 23 313 189 q 150 -269 229 -143 z "
  },
  "{": {
    ha: 464,
    x_min: 83,
    x_max: 435,
    o: "m 382 -269 q 241 -223 289 -269 q 193 -85 193 -176 l 193 268 q 177 322 193 306 q 131 339 161 339 l 83 339 l 83 422 l 131 422 q 177 439 161 422 q 193 493 193 456 l 193 846 q 241 985 193 939 q 382 1031 289 1031 l 435 1031 l 435 949 l 397 949 q 318 919 344 949 q 292 838 292 890 l 292 494 q 282 429 292 453 q 252 393 272 406 q 200 374 232 381 l 200 388 q 252 369 232 382 q 282 332 272 356 q 292 267 292 308 l 292 -76 q 318 -158 292 -129 q 397 -187 344 -187 l 435 -187 l 435 -269 l 382 -269 z "
  },
  "}": {
    ha: 464,
    x_min: 29,
    x_max: 381,
    o: "m 81 -269 l 29 -269 l 29 -187 l 67 -187 q 147 -158 121 -187 q 172 -76 172 -129 l 172 267 q 182 332 172 308 q 213 369 192 356 q 264 388 233 382 l 264 374 q 213 393 233 381 q 182 429 192 406 q 172 494 172 453 l 172 838 q 147 919 172 890 q 67 949 121 949 l 29 949 l 29 1031 l 81 1031 q 223 985 175 1031 q 271 846 271 939 l 271 493 q 288 439 271 456 q 333 422 304 422 l 381 422 l 381 339 l 333 339 q 288 322 304 339 q 271 268 271 306 l 271 -85 q 223 -223 271 -176 q 81 -269 175 -269 z "
  },
  "[": {
    ha: 442,
    x_min: 158,
    x_max: 413,
    o: "m 158 -269 l 158 1031 l 413 1031 l 413 949 l 257 949 l 257 -187 l 413 -187 l 413 -269 l 158 -269 z "
  },
  "]": {
    ha: 442,
    x_min: 29,
    x_max: 283,
    o: "m 283 -269 l 29 -269 l 29 -187 l 185 -187 l 185 949 l 29 949 l 29 1031 l 283 1031 l 283 -269 z "
  },
  "-": {
    ha: 531,
    x_min: 83,
    x_max: 447,
    o: "m 83 333 l 83 419 l 447 419 l 447 333 l 83 333 z "
  },
  "­": {
    ha: 531,
    x_min: 83,
    x_max: 447,
    o: "m 83 333 l 83 419 l 447 419 l 447 333 l 83 333 z "
  },
  "–": {
    ha: 694,
    x_min: 0,
    x_max: 694,
    o: "m 0 342 l 0 413 l 694 413 l 694 342 l 0 342 z "
  },
  "—": {
    ha: 1389,
    x_min: 0,
    x_max: 1389,
    o: "m 0 342 l 0 413 l 1389 413 l 1389 342 l 0 342 z "
  },
  "‒": {
    ha: 972,
    x_min: 67,
    x_max: 906,
    o: "m 67 458 l 67 529 l 906 529 l 906 458 l 67 458 z "
  },
  "―": {
    ha: 1389,
    x_min: 0,
    x_max: 1389,
    o: "m 0 342 l 0 413 l 1389 413 l 1389 342 l 0 342 z "
  },
  "‐": {
    ha: 531,
    x_min: 83,
    x_max: 447,
    o: "m 83 333 l 83 419 l 447 419 l 447 333 l 83 333 z "
  },
  _: {
    ha: 694,
    x_min: 0,
    x_max: 694,
    o: "m 0 -67 l 0 0 l 694 0 l 694 -67 l 0 -67 z "
  },
  "‚": {
    ha: 294,
    x_min: 75,
    x_max: 221,
    o: "m 78 -203 l 139 54 l 150 -6 q 97 15 118 -6 q 75 69 75 36 q 97 124 75 103 q 149 144 118 144 q 201 122 181 144 q 221 69 221 100 q 219 47 221 58 q 214 22 218 36 q 203 -11 210 8 l 144 -203 l 78 -203 z "
  },
  "„": {
    ha: 531,
    x_min: 75,
    x_max: 457,
    o: "m 78 -203 l 139 54 l 150 -6 q 97 15 118 -6 q 75 69 75 36 q 97 124 75 103 q 149 144 118 144 q 201 122 181 144 q 221 69 221 100 q 219 47 221 58 q 214 22 218 36 q 203 -11 210 8 l 144 -203 l 78 -203 m 314 -203 l 375 54 l 386 -6 q 333 15 354 -6 q 311 69 311 36 q 333 124 311 103 q 385 144 354 144 q 437 122 417 144 q 457 69 457 100 q 456 47 457 58 q 450 22 454 36 q 439 -11 446 8 l 381 -203 l 314 -203 z "
  },
  "“": {
    ha: 531,
    x_min: 74,
    x_max: 456,
    o: "m 217 1031 l 156 774 l 144 833 q 199 813 178 833 q 219 760 219 793 q 199 706 219 726 q 147 685 178 685 q 94 706 114 685 q 74 760 74 728 q 75 782 74 772 q 81 806 76 792 q 92 839 85 819 l 150 1031 l 217 1031 m 453 1031 l 392 774 l 381 833 q 435 813 414 833 q 456 760 456 793 q 435 706 456 726 q 383 685 414 685 q 330 706 350 685 q 310 760 310 728 q 311 782 310 772 q 317 806 313 792 q 328 839 321 819 l 386 1031 l 453 1031 z "
  },
  "”": {
    ha: 531,
    x_min: 75,
    x_max: 457,
    o: "m 78 692 l 139 947 l 150 889 q 97 909 118 889 q 75 963 75 929 q 97 1017 75 996 q 149 1038 118 1038 q 201 1016 181 1038 q 221 963 221 994 q 219 940 221 951 q 215 916 218 929 q 204 883 211 903 l 144 692 l 78 692 m 314 692 l 375 947 l 386 889 q 333 909 354 889 q 311 963 311 929 q 333 1017 311 996 q 385 1038 354 1038 q 437 1016 417 1038 q 457 963 457 994 q 456 940 457 951 q 451 916 454 929 q 440 883 447 903 l 381 692 l 314 692 z "
  },
  "‘": {
    ha: 294,
    x_min: 74,
    x_max: 219,
    o: "m 217 1031 l 156 774 l 144 833 q 199 813 178 833 q 219 760 219 793 q 199 706 219 726 q 147 685 178 685 q 94 706 114 685 q 74 760 74 728 q 75 782 74 772 q 81 806 76 792 q 92 839 85 819 l 150 1031 l 217 1031 z "
  },
  "’": {
    ha: 294,
    x_min: 75,
    x_max: 221,
    o: "m 78 692 l 139 947 l 150 889 q 97 909 118 889 q 75 963 75 929 q 97 1017 75 996 q 149 1038 118 1038 q 201 1016 181 1038 q 221 963 221 994 q 219 940 221 951 q 215 916 218 929 q 204 883 211 903 l 144 692 l 78 692 z "
  },
  "«": {
    ha: 663,
    x_min: 69,
    x_max: 611,
    o: "m 271 103 l 69 365 l 271 628 l 363 628 l 165 365 l 363 103 l 271 103 m 518 103 l 317 365 l 518 628 l 610 628 l 413 365 l 610 103 l 518 103 z "
  },
  "»": {
    ha: 663,
    x_min: 53,
    x_max: 593,
    o: "m 144 103 l 53 103 l 250 365 l 53 628 l 144 628 l 346 365 l 144 103 m 392 103 l 300 103 l 497 365 l 300 628 l 392 628 l 593 365 l 392 103 z "
  },
  "‹": {
    ha: 415,
    x_min: 69,
    x_max: 363,
    o: "m 271 103 l 69 365 l 271 628 l 363 628 l 165 365 l 363 103 l 271 103 z "
  },
  "›": {
    ha: 415,
    x_min: 53,
    x_max: 346,
    o: "m 144 103 l 53 103 l 250 365 l 53 628 l 144 628 l 346 365 l 144 103 z "
  },
  '"': {
    ha: 518,
    x_min: 96,
    x_max: 421,
    o: "m 103 606 l 96 972 l 183 972 l 176 606 l 103 606 m 340 606 l 333 972 l 421 972 l 414 606 l 340 606 z "
  },
  "'": {
    ha: 281,
    x_min: 96,
    x_max: 183,
    o: "m 103 606 l 96 972 l 183 972 l 176 606 l 103 606 z "
  },
  "⟨": {
    ha: 444,
    x_min: 61,
    x_max: 374,
    o: "m 285 -269 l 61 381 l 285 1031 l 374 1031 l 157 381 l 374 -269 l 285 -269 z "
  },
  "⟩": {
    ha: 444,
    x_min: 71,
    x_max: 383,
    o: "m 160 1031 l 383 381 l 160 -269 l 71 -269 l 288 381 l 71 1031 l 160 1031 z "
  },
  " ": {
    ha: 972,
    x_min: 0,
    x_max: 0,
    o: ""
  },
  " ": {
    ha: 139,
    x_min: 0,
    x_max: 0,
    o: ""
  },
  " ": {
    ha: 294,
    x_min: 0,
    x_max: 0,
    o: ""
  },
  " ": {
    ha: 364,
    x_min: 0,
    x_max: 0,
    o: ""
  },
  " ": {
    ha: 364,
    x_min: 0,
    x_max: 0,
    o: ""
  },
  " ": {
    ha: 182,
    x_min: 0,
    x_max: 0,
    o: ""
  },
  "​": {
    ha: 0,
    x_min: 0,
    x_max: 0,
    o: ""
  },
  "\r": {
    ha: 364,
    x_min: 0,
    x_max: 0,
    o: ""
  },
  "₵": {
    ha: 999,
    x_min: 72,
    x_max: 938,
    o: "m 521 -167 l 521 1139 l 590 1139 l 590 -167 l 521 -167 m 581 -8 q 378 28 471 -8 q 217 132 285 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 217 840 149 774 q 378 944 285 907 q 581 981 471 981 q 781 945 688 981 q 938 839 874 910 l 872 774 q 740 862 813 835 q 585 889 668 889 q 422 859 497 889 q 292 774 347 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 399 q 292 198 236 253 q 422 113 347 143 q 585 83 497 83 q 740 111 668 83 q 872 200 813 139 l 938 135 q 781 28 874 64 q 581 -8 688 -8 z "
  },
  "¢": {
    ha: 782,
    x_min: 64,
    x_max: 726,
    o: "m 397 -167 l 397 896 l 465 896 l 465 -167 l 397 -167 m 440 -7 q 247 41 332 -7 q 113 173 161 89 q 64 365 64 257 q 113 558 64 475 q 247 689 161 642 q 440 736 332 736 q 608 700 533 736 q 726 592 683 664 l 653 542 q 560 624 615 597 q 439 650 504 650 q 299 615 361 650 q 200 515 236 579 q 164 365 164 451 q 200 215 164 279 q 299 116 236 151 q 439 81 361 81 q 560 107 504 81 q 653 188 615 133 l 726 138 q 608 30 683 67 q 440 -7 533 -7 z "
  },
  "₡": {
    ha: 999,
    x_min: 72,
    x_max: 938,
    o: "m 458 -167 l 790 1139 l 856 1139 l 524 -167 l 458 -167 m 251 -167 l 583 1139 l 649 1139 l 317 -167 l 251 -167 m 581 -8 q 378 28 471 -8 q 217 132 285 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 217 840 149 774 q 378 944 285 907 q 581 981 471 981 q 781 945 688 981 q 938 839 874 910 l 872 774 q 740 862 813 835 q 585 889 668 889 q 422 859 497 889 q 292 774 347 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 399 q 292 198 236 253 q 422 113 347 143 q 585 83 497 83 q 740 111 668 83 q 872 200 813 139 l 938 135 q 781 28 874 64 q 581 -8 688 -8 z "
  },
  "¤": {
    ha: 972,
    x_min: 47,
    x_max: 925,
    o: "m 210 657 l 47 819 l 104 882 l 268 719 l 210 657 m 104 0 l 47 63 l 210 225 l 268 163 l 104 0 m 867 0 l 704 163 l 763 225 l 925 63 l 867 0 m 763 657 l 704 719 l 867 882 l 925 819 l 763 657 m 486 72 q 339 101 408 72 q 217 181 269 131 q 135 299 165 232 q 106 442 106 365 q 135 585 106 518 q 217 704 165 653 q 339 785 269 756 q 486 814 408 814 q 635 785 565 814 q 757 704 704 756 q 840 585 810 653 q 869 442 869 518 q 840 299 869 365 q 757 181 810 232 q 635 101 704 131 q 486 72 565 72 m 486 156 q 638 194 569 156 q 747 298 706 233 q 788 442 788 363 q 747 586 788 521 q 638 691 706 651 q 486 731 569 731 q 336 691 404 731 q 228 586 268 651 q 188 442 188 521 q 228 298 188 363 q 336 194 268 233 q 486 156 404 156 z "
  },
  $: {
    ha: 854,
    x_min: 65,
    x_max: 789,
    o: "m 397 -167 l 397 1139 l 467 1139 l 467 -167 l 397 -167 m 426 -8 q 219 27 318 -8 q 65 118 119 63 l 106 197 q 244 113 157 147 q 426 79 331 79 q 576 102 518 79 q 660 164 633 125 q 688 250 688 203 q 655 342 688 307 q 569 397 622 376 q 453 432 517 417 q 325 465 389 447 q 208 511 261 482 q 122 588 154 540 q 89 714 89 636 q 127 847 89 786 q 244 944 165 907 q 447 981 324 981 q 610 958 529 981 q 749 894 690 935 l 714 813 q 581 874 651 854 q 446 893 511 893 q 301 869 358 893 q 217 806 244 846 q 190 717 190 767 q 223 625 190 660 q 309 571 256 590 q 426 536 363 551 q 553 503 490 521 q 670 456 617 485 q 756 381 724 428 q 789 257 789 333 q 750 126 789 186 q 631 28 711 65 q 426 -8 551 -8 z "
  },
  "₫": {
    ha: 942,
    x_min: 64,
    x_max: 942,
    o: "m 428 -7 q 241 40 324 -7 q 111 172 158 88 q 64 365 64 256 q 111 560 64 476 q 241 690 158 643 q 428 736 324 736 q 599 693 524 736 q 720 567 675 650 q 765 365 765 485 q 721 164 765 247 q 601 37 676 81 q 428 -7 525 -7 m 93 -181 l 93 -119 l 807 -119 l 807 -181 l 93 -181 m 435 81 q 574 116 513 81 q 672 216 636 151 q 707 365 707 281 q 672 515 707 451 q 574 615 636 579 q 435 650 513 650 q 297 615 358 650 q 200 515 236 579 q 164 365 164 451 q 200 216 164 281 q 297 116 236 151 q 435 81 358 81 m 710 0 l 710 219 l 719 367 l 706 514 l 706 1031 l 804 1031 l 804 0 l 710 0 m 400 849 l 400 910 l 942 910 l 942 849 l 400 849 z "
  },
  "€": {
    ha: 1114,
    x_min: 42,
    x_max: 1054,
    o: "m 42 360 l 42 421 l 786 421 l 786 360 l 42 360 m 42 551 l 42 613 l 786 613 l 786 551 l 42 551 m 696 -8 q 494 28 588 -8 q 333 132 401 65 q 226 289 264 199 q 188 486 188 379 q 226 683 188 593 q 333 840 264 774 q 494 944 401 907 q 696 981 588 981 q 897 945 804 981 q 1054 839 989 910 l 988 774 q 856 862 929 835 q 701 889 783 889 q 538 859 613 889 q 407 774 463 829 q 321 647 351 719 q 290 486 290 574 q 321 326 290 399 q 407 198 351 253 q 538 113 463 143 q 701 83 613 83 q 856 111 783 83 q 988 200 929 139 l 1054 135 q 897 28 989 64 q 696 -8 804 -8 z "
  },
  ƒ: {
    ha: 608,
    x_min: -125,
    x_max: 658,
    o: "m 25 -276 q -60 -265 -19 -276 q -125 -229 -100 -253 l -85 -154 q 22 -192 -44 -192 q 117 -157 81 -192 q 163 -54 154 -122 l 271 821 q 345 978 282 918 q 511 1038 408 1038 q 594 1026 554 1038 q 658 990 633 1014 l 615 915 q 570 944 597 935 q 513 953 543 953 q 413 918 450 953 q 367 815 376 883 l 353 706 l 350 660 l 261 -60 q 188 -217 249 -157 q 25 -276 126 -276 m 118 636 l 128 718 l 578 718 l 568 636 l 118 636 z "
  },
  "₣": {
    ha: 908,
    x_min: 42,
    x_max: 854,
    o: "m 42 181 l 42 242 l 603 242 l 603 181 l 42 181 m 279 501 l 793 501 l 793 413 l 279 413 l 279 501 m 290 0 l 188 0 l 188 972 l 854 972 l 854 883 l 290 883 l 290 0 z "
  },
  "₲": {
    ha: 1074,
    x_min: 72,
    x_max: 947,
    o: "m 521 -167 l 521 1139 l 590 1139 l 590 -167 l 521 -167 m 585 -8 q 380 28 474 -8 q 217 132 286 65 q 110 289 149 199 q 72 486 72 379 q 110 683 72 593 q 218 840 149 774 q 381 944 288 907 q 586 981 475 981 q 790 946 697 981 q 947 840 882 911 l 883 775 q 749 863 822 836 q 590 889 675 889 q 424 859 500 889 q 292 774 349 829 q 205 647 236 719 q 174 486 174 574 q 205 326 174 400 q 292 198 236 253 q 424 113 349 143 q 589 83 500 83 q 747 108 672 83 q 883 193 821 133 l 942 115 q 779 23 872 54 q 585 -8 686 -8 m 843 128 l 843 486 l 942 486 l 942 115 l 843 128 z "
  },
  "₴": {
    ha: 1146,
    x_min: 135,
    x_max: 1004,
    o: "m 581 -10 q 378 26 460 -10 q 256 122 297 61 q 215 257 215 182 q 228 331 215 300 q 264 386 242 363 l 431 386 q 373 351 399 369 q 333 309 347 333 q 318 250 318 285 q 345 164 318 203 q 430 102 372 125 q 578 79 488 79 q 764 110 676 79 q 903 189 851 142 l 936 111 q 778 24 874 57 q 581 -10 682 -10 m 135 363 l 135 422 l 1004 422 l 1004 363 l 135 363 m 135 554 l 135 614 l 1004 614 l 1004 554 l 135 554 m 690 582 q 751 618 724 600 q 797 660 779 636 q 814 717 814 685 q 788 806 814 767 q 704 869 761 846 q 558 893 647 893 q 422 875 493 893 q 288 819 351 857 l 260 901 q 400 960 322 939 q 556 982 478 982 q 755 946 675 982 q 875 849 835 910 q 915 714 915 789 q 903 639 915 671 q 869 582 890 607 l 690 582 z "
  },
  "₭": {
    ha: 872,
    x_min: 42,
    x_max: 864,
    o: "m 42 451 l 42 521 l 760 521 l 760 451 l 42 451 m 188 0 l 188 972 l 289 972 l 289 0 l 188 0 m 740 0 l 292 486 l 415 486 l 864 0 l 740 0 m 740 972 l 864 972 l 415 486 l 292 486 l 740 972 z "
  },
  "₤": {
    ha: 885,
    x_min: 42,
    x_max: 863,
    o: "m 42 0 l 42 89 l 844 89 l 844 0 l 42 0 m 199 18 l 199 638 q 242 819 199 742 q 373 938 286 896 q 585 981 460 981 q 738 963 669 981 q 863 907 807 946 l 825 822 q 712 874 775 858 q 576 889 649 889 q 369 824 438 889 q 300 638 300 758 l 300 18 l 199 18 m 42 360 l 42 421 l 685 421 l 685 360 l 42 360 m 42 551 l 42 613 l 685 613 l 685 551 l 42 551 z "
  },
  "₺": {
    ha: 965,
    x_min: 42,
    x_max: 904,
    o: "m 199 0 l 199 972 l 299 972 l 299 89 l 375 89 q 696 194 589 89 q 803 489 803 299 l 904 489 q 843 224 904 333 q 660 58 782 115 q 356 0 538 0 l 199 0 m 42 301 l 42 367 l 685 704 l 685 639 l 42 301 m 42 497 l 42 563 l 685 900 l 685 835 l 42 497 z "
  },
  "₼": {
    ha: 1276,
    x_min: 158,
    x_max: 1118,
    o: "m 158 0 l 158 426 q 219 731 158 607 q 389 917 281 854 q 639 981 497 981 q 888 917 781 981 q 1057 731 996 854 q 1118 426 1118 607 l 1118 0 l 1022 0 l 1022 424 q 976 685 1022 581 q 845 840 931 789 q 639 892 760 892 q 433 840 519 892 q 301 684 347 788 q 254 424 254 581 l 254 0 l 158 0 m 604 167 l 604 1139 l 672 1139 l 672 167 l 604 167 z "
  },
  "₦": {
    ha: 1208,
    x_min: 42,
    x_max: 1167,
    o: "m 199 0 l 199 972 l 282 972 l 953 128 l 908 128 l 908 972 l 1010 972 l 1010 0 l 926 0 l 256 844 l 300 844 l 300 0 l 199 0 m 42 360 l 42 421 l 1167 421 l 1167 360 l 42 360 m 42 551 l 42 613 l 1167 613 l 1167 551 l 42 551 z "
  },
  "₧": {
    ha: 2246,
    x_min: 158,
    x_max: 2201,
    o: "m 158 0 l 158 972 l 522 972 q 735 933 646 972 q 872 819 824 893 q 919 639 919 744 q 872 462 919 536 q 735 347 824 388 q 522 307 646 307 l 215 307 l 261 356 l 261 0 l 158 0 m 261 347 l 215 397 l 519 397 q 741 460 665 397 q 817 639 817 524 q 741 819 817 756 q 519 883 665 883 l 215 883 l 261 932 l 261 347 m 1372 -7 q 1214 49 1269 -7 q 1158 206 1158 104 l 1158 890 l 1257 890 l 1257 211 q 1290 113 1257 147 q 1383 78 1322 78 q 1492 115 1449 78 l 1526 44 q 1456 6 1497 18 q 1372 -7 1415 -7 m 1028 647 l 1028 729 l 1479 729 l 1479 647 l 1028 647 m 1900 -7 q 1729 19 1810 -7 q 1603 83 1649 44 l 1647 161 q 1761 103 1692 128 q 1907 79 1831 79 q 2057 112 2011 79 q 2103 199 2103 144 q 2077 262 2103 239 q 2010 297 2051 285 q 1917 317 1968 308 q 1815 336 1865 325 q 1722 369 1764 347 q 1655 428 1681 390 q 1629 528 1629 465 q 1663 635 1629 588 q 1760 709 1696 682 q 1918 736 1825 736 q 2060 717 1989 736 q 2176 668 2131 699 l 2133 589 q 2029 637 2085 622 q 1918 651 1974 651 q 1773 617 1819 651 q 1726 531 1726 583 q 1752 465 1726 489 q 1820 428 1778 442 q 1913 407 1863 415 q 2015 387 1964 399 q 2108 355 2065 375 q 2176 298 2150 335 q 2201 201 2201 261 q 2166 91 2201 138 q 2063 19 2131 44 q 1900 -7 1996 -7 z "
  },
  "₱": {
    ha: 1157,
    x_min: 42,
    x_max: 1115,
    o: "m 42 514 l 42 574 l 1115 574 l 1115 514 l 42 514 m 42 706 l 42 765 l 1115 765 l 1115 706 l 42 706 m 199 0 l 199 972 l 561 972 q 774 933 685 972 q 910 819 863 893 q 958 639 958 744 q 910 462 958 536 q 774 347 863 388 q 561 307 685 307 l 254 307 l 300 356 l 300 0 l 199 0 m 300 347 l 254 397 l 560 397 q 781 460 704 397 q 857 639 857 524 q 781 819 857 756 q 560 883 704 883 l 254 883 l 300 932 l 300 347 z "
  },
  "₽": {
    ha: 1026,
    x_min: 42,
    x_max: 949,
    o: "m 188 0 l 188 972 l 551 972 q 842 889 736 972 q 949 650 949 806 q 842 410 949 493 q 551 326 736 326 l 244 326 l 290 375 l 290 0 l 188 0 m 290 367 l 244 414 l 553 414 q 770 475 694 414 q 846 649 846 536 q 770 822 846 761 q 553 883 694 883 l 244 883 l 290 932 l 290 367 m 42 181 l 42 242 l 603 242 l 603 181 l 42 181 z "
  },
  "₹": {
    ha: 997,
    x_min: 33,
    x_max: 928,
    o: "m 158 343 l 158 432 l 381 432 q 605 496 532 432 q 678 663 678 560 q 601 845 678 778 q 374 911 524 913 l 33 910 l 33 972 l 928 972 l 928 911 l 553 911 l 582 939 q 732 830 685 904 q 779 661 779 756 q 732 491 779 563 q 596 381 685 419 q 383 343 507 343 l 158 343 m 683 0 l 429 385 l 542 385 l 796 0 l 683 0 m 33 717 l 33 779 l 928 779 l 928 717 l 33 717 z "
  },
  "£": {
    ha: 885,
    x_min: 42,
    x_max: 863,
    o: "m 199 18 l 199 638 q 242 819 199 742 q 373 938 286 896 q 585 981 460 981 q 738 963 669 981 q 863 907 807 946 l 825 822 q 712 874 775 858 q 576 889 649 889 q 369 824 438 889 q 300 638 300 758 l 300 18 l 199 18 m 42 0 l 42 89 l 844 89 l 844 0 l 42 0 m 42 451 l 42 521 l 685 521 l 685 451 l 42 451 z "
  },
  "₸": {
    ha: 997,
    x_min: 110,
    x_max: 896,
    o: "m 451 0 l 451 722 l 110 722 l 110 785 l 896 785 l 896 722 l 553 722 l 553 0 l 451 0 m 110 910 l 110 972 l 896 972 l 896 910 l 110 910 z "
  },
  "₮": {
    ha: 936,
    x_min: 75,
    x_max: 863,
    o: "m 417 0 l 417 911 l 444 883 l 75 883 l 75 972 l 863 972 l 863 883 l 492 883 l 519 911 l 519 0 l 417 0 m 172 165 l 172 231 l 764 529 l 764 465 l 172 165 m 172 363 l 172 426 l 764 725 l 764 661 l 172 363 z "
  },
  "₩": {
    ha: 1626,
    x_min: 42,
    x_max: 1585,
    o: "m 406 0 l 64 972 l 171 972 l 492 57 l 436 57 l 767 972 l 864 972 l 1190 57 l 1138 57 l 1461 972 l 1563 972 l 1221 0 l 1113 0 l 800 868 l 828 868 l 514 0 l 406 0 m 42 360 l 42 421 l 1585 421 l 1585 360 l 42 360 m 42 551 l 42 613 l 1585 613 l 1585 551 l 42 551 z "
  },
  "¥": {
    ha: 965,
    x_min: 1,
    x_max: 964,
    o: "m 432 0 l 432 422 l 456 354 l 1 972 l 110 972 l 514 425 l 454 425 l 858 972 l 964 972 l 510 354 l 533 422 l 533 0 l 432 0 m 126 181 l 126 242 l 839 242 l 839 181 l 126 181 m 126 372 l 126 433 l 839 433 l 839 372 l 126 372 z "
  },
  "∙": {
    ha: 378,
    x_min: 115,
    x_max: 263,
    o: "m 189 408 q 137 431 158 408 q 115 485 115 453 q 137 540 115 518 q 189 561 158 561 q 242 540 221 561 q 263 485 263 518 q 242 431 263 453 q 189 408 221 408 z "
  },
  "⁒": {
    ha: 714,
    x_min: 118,
    x_max: 594,
    o: "m 144 0 l 490 972 l 569 972 l 222 0 l 144 0 m 525 0 q 477 20 497 0 q 457 68 457 40 q 477 116 457 96 q 525 136 497 136 q 574 116 554 136 q 594 68 594 96 q 574 20 594 40 q 525 0 554 0 m 188 836 q 139 856 160 836 q 118 904 118 876 q 139 953 118 933 q 188 972 160 972 q 235 953 215 972 q 256 904 256 933 q 235 856 256 876 q 188 836 215 836 z "
  },
  "∕": {
    ha: 465,
    x_min: -35,
    x_max: 514,
    o: "m -35 -139 l 424 1169 l 514 1169 l 56 -139 l -35 -139 z "
  },
  "+": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 356 192 l 356 781 l 443 781 l 443 192 l 356 192 m 97 444 l 97 526 l 701 526 l 701 444 l 97 444 z "
  },
  "−": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 97 444 l 97 526 l 701 526 l 701 444 l 97 444 z "
  },
  "×": {
    ha: 799,
    x_min: 158,
    x_max: 640,
    o: "m 158 301 l 585 731 l 640 671 l 214 242 l 158 301 m 158 671 l 214 731 l 640 301 l 585 242 l 158 671 z "
  },
  "÷": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 97 444 l 97 526 l 701 526 l 701 444 l 97 444 m 399 153 q 353 172 372 153 q 333 221 333 192 q 353 269 333 250 q 399 288 372 288 q 446 269 426 288 q 465 221 465 250 q 446 172 465 192 q 399 153 426 153 m 399 685 q 353 704 372 685 q 333 751 333 724 q 353 801 333 782 q 399 819 372 819 q 446 801 426 819 q 465 751 465 782 q 446 704 465 724 q 399 685 426 685 z "
  },
  "=": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 97 606 l 97 688 l 701 688 l 701 606 l 97 606 m 97 285 l 97 367 l 701 367 l 701 285 l 97 285 z "
  },
  "≠": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 151 114 l 563 858 l 647 858 l 236 114 l 151 114 m 97 285 l 97 367 l 701 367 l 701 285 l 97 285 m 97 606 l 97 688 l 701 688 l 701 606 l 97 606 z "
  },
  ">": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 97 199 l 97 285 l 665 508 l 665 464 l 97 688 l 97 774 l 701 532 l 701 440 l 97 199 z "
  },
  "<": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 701 199 l 97 440 l 97 532 l 701 774 l 701 688 l 133 464 l 133 508 l 701 285 l 701 199 z "
  },
  "≥": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 97 243 l 97 331 l 667 551 l 667 497 l 97 718 l 97 806 l 701 568 l 701 481 l 97 243 m 701 0 l 97 0 l 97 82 l 701 82 l 701 0 z "
  },
  "≤": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 701 243 l 97 481 l 97 568 l 701 806 l 701 718 l 132 497 l 132 551 l 701 331 l 701 243 m 97 0 l 97 82 l 701 82 l 701 0 l 97 0 z "
  },
  "±": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 97 0 l 97 82 l 701 82 l 701 0 l 97 0 m 356 240 l 356 821 l 443 821 l 443 240 l 356 240 m 97 489 l 97 572 l 701 572 l 701 489 l 97 489 z "
  },
  "≈": {
    ha: 799,
    x_min: 86,
    x_max: 713,
    o: "m 540 536 q 453 558 490 536 q 386 607 417 579 q 326 656 356 635 q 261 676 297 676 q 184 641 213 676 q 153 544 156 606 l 86 544 q 137 701 89 649 q 258 754 185 754 q 345 733 308 754 q 412 683 382 711 q 472 634 442 656 q 538 613 501 613 q 615 649 586 613 q 646 747 644 686 l 713 747 q 663 590 710 643 q 540 536 615 536 m 540 218 q 453 239 490 218 q 386 288 417 260 q 326 337 356 315 q 261 358 297 358 q 184 322 213 358 q 153 225 156 286 l 86 225 q 137 383 89 331 q 258 435 185 435 q 345 414 308 435 q 412 365 382 393 q 472 316 442 338 q 538 294 501 294 q 615 331 586 294 q 646 428 644 367 l 713 428 q 663 271 710 324 q 540 218 615 218 z "
  },
  "~": {
    ha: 799,
    x_min: 86,
    x_max: 713,
    o: "m 540 378 q 453 399 490 378 q 386 449 417 421 q 326 497 356 476 q 261 518 297 518 q 184 483 213 518 q 153 386 156 447 l 86 386 q 137 543 89 490 q 258 596 185 596 q 345 574 308 596 q 412 525 382 553 q 472 476 442 497 q 538 454 501 454 q 615 491 586 454 q 646 588 644 528 l 713 588 q 663 431 710 483 q 540 378 615 378 z "
  },
  "¬": {
    ha: 799,
    x_min: 97,
    x_max: 701,
    o: "m 701 528 l 701 196 l 614 196 l 614 446 l 97 446 l 97 528 l 701 528 z "
  },
  "^": {
    ha: 800,
    x_min: 115,
    x_max: 685,
    o: "m 115 199 l 358 774 l 443 774 l 685 199 l 603 199 l 379 739 l 421 739 l 197 199 l 115 199 z "
  },
  "∅": {
    ha: 799,
    x_min: 58,
    x_max: 742,
    o: "m 92 132 l 58 168 l 708 776 l 742 740 l 92 132 m 400 167 q 254 206 321 167 q 149 311 188 244 q 110 457 110 378 q 149 603 110 538 q 255 707 189 668 q 400 746 321 746 q 547 707 481 746 q 651 603 613 668 q 690 457 690 538 q 651 311 690 378 q 547 206 613 244 q 400 167 481 167 m 400 238 q 511 267 461 238 q 590 347 561 297 q 619 457 619 397 q 590 567 619 518 q 511 646 561 617 q 400 675 461 675 q 290 646 339 675 q 211 567 240 617 q 182 457 182 518 q 211 347 182 397 q 290 267 240 297 q 400 238 339 238 z "
  },
  "∞": {
    ha: 1278,
    x_min: 64,
    x_max: 1214,
    o: "m 946 222 q 813 247 868 222 q 719 311 757 271 q 650 399 681 351 q 592 495 619 447 q 530 583 564 543 q 450 648 496 624 q 338 672 404 672 q 240 647 283 672 q 171 581 196 622 q 146 486 146 539 q 171 392 146 433 q 240 325 196 350 q 338 300 283 300 q 450 324 404 300 q 530 389 496 349 q 592 477 564 429 q 650 573 619 525 q 719 661 681 621 q 813 726 757 701 q 946 750 868 750 q 1083 716 1024 750 q 1178 623 1143 682 q 1214 488 1214 564 q 1178 351 1214 411 q 1083 257 1143 292 q 946 222 1024 222 m 333 222 q 196 257 257 222 q 99 351 135 292 q 64 486 64 411 q 99 622 64 563 q 196 716 135 682 q 333 750 257 750 q 466 726 411 750 q 560 661 521 701 q 628 574 599 621 q 687 478 658 526 q 749 389 715 429 q 828 324 782 349 q 940 300 874 300 q 1039 325 996 300 q 1107 392 1082 350 q 1132 488 1132 435 q 1107 582 1132 540 q 1039 648 1082 624 q 940 672 996 672 q 828 648 874 672 q 749 583 782 624 q 687 495 715 543 q 628 399 658 447 q 560 311 599 351 q 466 247 521 271 q 333 222 411 222 z "
  },
  "∫": {
    ha: 535,
    x_min: -50,
    x_max: 585,
    o: "m 107 -276 q 20 -265 61 -276 q -50 -229 -21 -253 l -17 -154 q 94 -192 26 -192 q 185 -157 153 -192 q 218 -54 218 -122 l 218 824 q 273 980 218 921 q 428 1039 328 1039 q 514 1028 472 1039 q 585 992 556 1017 l 550 918 q 502 946 531 936 q 440 956 474 956 q 349 920 381 956 q 317 818 317 885 l 317 -60 q 262 -217 317 -157 q 107 -276 207 -276 z "
  },
  Ω: {
    ha: 1253,
    x_min: 13,
    x_max: 1240,
    o: "m 13 0 l 13 90 l 324 90 q 169 267 222 161 q 117 494 117 372 q 155 690 117 601 q 263 844 193 779 q 425 945 332 910 q 626 981 518 981 q 828 945 736 981 q 990 844 921 910 q 1098 690 1060 779 q 1136 494 1136 601 q 1083 267 1136 372 q 929 90 1031 161 l 1240 90 l 1240 0 l 771 0 l 771 83 q 967 258 900 150 q 1033 490 1033 365 q 1003 651 1033 578 q 919 777 974 724 q 790 860 864 831 q 626 889 715 889 q 464 860 539 889 q 335 777 389 831 q 250 651 281 724 q 219 490 219 578 q 286 257 219 365 q 482 83 353 149 l 482 0 l 13 0 z "
  },
  "∆": {
    ha: 996,
    x_min: 3,
    x_max: 993,
    o: "m 549 972 l 993 0 l 3 0 l 447 972 l 549 972 m 126 40 l 96 89 l 897 89 l 867 40 l 476 913 l 518 913 l 126 40 z "
  },
  "∏": {
    ha: 1129,
    x_min: 158,
    x_max: 971,
    o: "m 158 -269 l 158 972 l 971 972 l 971 -269 l 869 -269 l 869 879 l 261 879 l 261 -269 l 158 -269 z "
  },
  "∑": {
    ha: 904,
    x_min: 63,
    x_max: 860,
    o: "m 63 -269 l 63 -199 l 564 389 l 564 317 l 79 901 l 79 972 l 851 972 l 851 883 l 169 883 l 188 921 l 629 388 l 629 317 l 169 -215 l 154 -181 l 860 -181 l 860 -269 l 63 -269 z "
  },
  "√": {
    ha: 1106,
    x_min: 97,
    x_max: 1103,
    o: "m 1007 1031 l 1103 1031 l 649 -269 l 547 -269 l 278 446 l 97 446 l 97 528 l 350 528 l 610 -175 l 586 -175 l 1007 1031 z "
  },
  µ: {
    ha: 942,
    x_min: 138,
    x_max: 804,
    o: "m 138 -269 l 138 729 l 236 729 l 236 317 q 294 141 236 200 q 457 82 351 82 q 589 113 533 82 q 675 204 644 144 q 706 347 706 264 l 706 729 l 804 729 l 804 0 l 710 0 l 710 203 l 726 176 q 665 73 706 114 q 571 13 624 32 q 458 -7 518 -7 q 310 28 372 -7 q 217 132 249 64 l 236 176 l 236 -269 l 138 -269 z "
  },
  "∂": {
    ha: 972,
    x_min: 111,
    x_max: 861,
    o: "m 453 -8 q 278 29 356 -8 q 156 136 200 67 q 111 299 111 206 q 156 461 111 392 q 278 568 200 531 q 457 606 357 606 q 610 575 542 606 q 723 485 678 544 q 781 342 768 426 l 742 329 q 758 419 754 374 q 763 503 763 465 q 718 724 763 633 q 592 863 674 815 q 397 911 510 911 q 288 903 340 911 q 192 882 236 896 l 176 967 q 278 989 221 981 q 397 997 336 997 q 647 938 543 997 q 806 763 750 878 q 861 482 861 647 q 814 222 861 332 q 676 51 767 111 q 453 -8 585 -8 m 458 76 q 602 108 543 76 q 692 191 661 140 q 722 299 722 242 q 690 413 722 363 q 599 492 657 463 q 467 521 542 521 q 278 460 347 521 q 210 299 210 399 q 241 182 210 232 q 328 104 272 132 q 458 76 385 76 z "
  },
  "%": {
    ha: 1151,
    x_min: 58,
    x_max: 1093,
    o: "m 203 0 l 867 972 l 949 972 l 285 0 l 203 0 m 278 451 q 163 484 213 451 q 85 576 113 517 q 58 715 58 636 q 85 854 58 794 q 163 947 113 914 q 278 979 213 979 q 392 947 343 979 q 469 854 442 914 q 497 715 497 794 q 469 576 497 636 q 392 484 442 517 q 278 451 343 451 m 278 514 q 387 567 346 514 q 428 715 428 621 q 387 863 428 810 q 278 917 346 917 q 168 863 208 917 q 128 715 128 810 q 168 567 128 621 q 278 514 208 514 m 874 -7 q 760 26 810 -7 q 682 118 710 58 q 654 257 654 178 q 682 396 654 336 q 760 488 710 456 q 874 521 810 521 q 990 488 940 521 q 1066 396 1039 456 q 1093 257 1093 336 q 1066 118 1093 178 q 990 26 1039 58 q 874 -7 940 -7 m 874 56 q 983 109 942 56 q 1024 257 1024 163 q 983 405 1024 351 q 874 458 942 458 q 765 405 806 458 q 724 257 724 351 q 765 109 724 163 q 874 56 806 56 z "
  },
  "‰": {
    ha: 1653,
    x_min: 58,
    x_max: 1594,
    o: "m 203 0 l 867 972 l 949 972 l 285 0 l 203 0 m 278 451 q 163 484 213 451 q 85 576 113 517 q 58 715 58 636 q 85 854 58 794 q 163 947 113 914 q 278 979 213 979 q 392 947 343 979 q 469 854 442 914 q 497 715 497 794 q 469 576 497 636 q 392 484 442 517 q 278 451 343 451 m 278 514 q 387 567 346 514 q 428 715 428 621 q 387 863 428 810 q 278 917 346 917 q 168 863 208 917 q 128 715 128 810 q 168 567 128 621 q 278 514 208 514 m 874 -7 q 760 26 810 -7 q 682 118 710 58 q 654 257 654 178 q 682 396 654 336 q 760 488 710 456 q 874 521 810 521 q 990 488 940 521 q 1066 396 1039 456 q 1093 257 1093 336 q 1066 118 1093 178 q 990 26 1039 58 q 874 -7 940 -7 m 874 56 q 983 109 942 56 q 1024 257 1024 163 q 983 405 1024 351 q 874 458 942 458 q 765 405 806 458 q 724 257 724 351 q 765 109 724 163 q 874 56 806 56 m 1375 -7 q 1261 26 1311 -7 q 1183 117 1211 58 q 1156 257 1156 176 q 1183 397 1156 338 q 1261 488 1211 456 q 1375 521 1311 521 q 1491 488 1442 521 q 1567 396 1540 456 q 1594 257 1594 336 q 1567 118 1594 178 q 1491 26 1540 58 q 1375 -7 1442 -7 m 1375 56 q 1484 109 1443 56 q 1525 257 1525 163 q 1484 405 1525 351 q 1375 458 1443 458 q 1266 405 1307 458 q 1225 257 1225 351 q 1266 109 1225 163 q 1375 56 1307 56 z "
  },
  "↑": {
    ha: 833,
    x_min: 144,
    x_max: 689,
    o: "m 144 400 l 144 489 l 415 676 l 689 489 l 689 400 l 415 579 l 144 400 m 375 88 l 375 599 l 457 599 l 457 88 l 375 88 z "
  },
  "↗": {
    ha: 833,
    x_min: 182,
    x_max: 686,
    o: "m 242 588 l 301 651 l 625 590 l 686 263 l 625 200 l 558 522 l 242 588 m 182 204 l 544 565 l 601 503 l 240 142 l 182 204 z "
  },
  "→": {
    ha: 833,
    x_min: 103,
    x_max: 686,
    o: "m 500 651 l 686 379 l 500 104 l 407 104 l 586 379 l 407 651 l 500 651 m 607 417 l 607 340 l 103 340 l 103 417 l 607 417 z "
  },
  "↘": {
    ha: 833,
    x_min: 183,
    x_max: 685,
    o: "m 625 575 l 685 513 l 626 186 l 301 124 l 242 188 l 563 256 l 625 575 m 242 633 l 603 272 l 544 211 l 183 572 l 242 633 z "
  },
  "↓": {
    ha: 833,
    x_min: 161,
    x_max: 706,
    o: "m 706 358 l 706 268 l 435 81 l 161 268 l 161 358 l 435 178 l 706 358 m 475 669 l 475 158 l 393 158 l 393 669 l 475 669 z "
  },
  "↙": {
    ha: 833,
    x_min: 167,
    x_max: 671,
    o: "m 611 196 l 551 132 l 228 193 l 167 521 l 228 583 l 294 261 l 611 196 m 671 579 l 308 218 l 251 281 l 613 642 l 671 579 z "
  },
  "←": {
    ha: 833,
    x_min: 147,
    x_max: 731,
    o: "m 333 106 l 147 378 l 333 653 l 426 653 l 247 378 l 426 106 l 333 106 m 226 340 l 226 417 l 731 417 l 731 340 l 226 340 z "
  },
  "↖": {
    ha: 833,
    x_min: 168,
    x_max: 669,
    o: "m 228 208 l 168 271 l 226 597 l 551 660 l 611 596 l 290 528 l 228 208 m 611 150 l 250 511 l 308 572 l 669 211 l 611 150 z "
  },
  "↔": {
    ha: 954,
    x_min: 69,
    x_max: 885,
    o: "m 604 106 l 783 378 l 604 653 l 697 653 l 885 378 l 697 106 l 604 106 m 256 106 l 69 378 l 256 653 l 350 653 l 169 378 l 350 106 l 256 106 m 144 340 l 144 417 l 806 417 l 806 340 l 144 340 z "
  },
  "↕": {
    ha: 833,
    x_min: 143,
    x_max: 689,
    o: "m 144 601 l 144 692 l 415 879 l 689 692 l 689 601 l 415 782 l 144 601 m 417 71 l 143 258 l 143 349 l 417 168 l 686 349 l 686 258 l 417 71 m 375 151 l 375 801 l 457 801 l 457 151 l 375 151 z "
  },
  "◆": {
    ha: 833,
    x_min: 35,
    x_max: 797,
    o: "m 35 368 l 417 750 l 797 368 l 417 -12 l 35 368 z "
  },
  "◇": {
    ha: 833,
    x_min: 35,
    x_max: 797,
    o: "m 35 368 l 417 750 l 797 368 l 417 -12 l 35 368 m 118 368 l 417 76 l 714 368 l 417 660 l 118 368 z "
  },
  "◊": {
    ha: 696,
    x_min: 64,
    x_max: 632,
    o: "m 347 31 l 64 458 l 349 882 l 632 458 l 347 31 m 347 149 l 557 458 l 349 767 l 139 458 l 347 149 z "
  },
  "■": {
    ha: 833,
    x_min: 147,
    x_max: 686,
    o: "m 147 99 l 147 638 l 686 638 l 686 99 l 147 99 z "
  },
  "□": {
    ha: 833,
    x_min: 147,
    x_max: 686,
    o: "m 147 99 l 147 638 l 686 638 l 686 99 l 147 99 m 207 161 l 626 161 l 626 575 l 207 575 l 207 161 z "
  },
  "▲": {
    ha: 833,
    x_min: 121,
    x_max: 713,
    o: "m 121 72 l 417 664 l 713 72 l 121 72 z "
  },
  "▶": {
    ha: 833,
    x_min: 160,
    x_max: 751,
    o: "m 160 665 l 751 369 l 160 74 l 160 665 z "
  },
  "▼": {
    ha: 833,
    x_min: 121,
    x_max: 713,
    o: "m 121 664 l 713 664 l 417 72 l 121 664 z "
  },
  "◀": {
    ha: 835,
    x_min: 81,
    x_max: 672,
    o: "m 672 72 l 81 368 l 672 664 l 672 72 z "
  },
  "△": {
    ha: 833,
    x_min: 121,
    x_max: 713,
    o: "m 121 72 l 417 664 l 713 72 l 121 72 m 203 126 l 631 126 l 417 544 l 203 126 z "
  },
  "▷": {
    ha: 833,
    x_min: 160,
    x_max: 751,
    o: "m 160 665 l 751 369 l 160 74 l 160 665 m 211 579 l 211 160 l 638 369 l 211 579 z "
  },
  "▽": {
    ha: 833,
    x_min: 121,
    x_max: 713,
    o: "m 121 664 l 713 664 l 417 72 l 121 664 m 203 610 l 417 192 l 631 610 l 203 610 z "
  },
  "◁": {
    ha: 833,
    x_min: 81,
    x_max: 672,
    o: "m 672 72 l 81 368 l 672 664 l 672 72 m 621 158 l 621 578 l 194 368 l 621 158 z "
  },
  "@": {
    ha: 1435,
    x_min: 72,
    x_max: 1363,
    o: "m 715 -278 q 454 -231 572 -278 q 251 -101 336 -185 q 119 99 165 -17 q 72 353 72 215 q 119 606 72 492 q 252 805 165 721 q 458 935 339 889 q 721 981 578 981 q 980 936 863 981 q 1183 810 1097 892 q 1316 617 1269 729 q 1363 368 1363 504 q 1335 167 1363 251 q 1257 38 1308 83 q 1133 -7 1206 -7 q 1019 36 1063 -7 q 976 157 976 79 l 976 267 l 988 356 l 974 494 l 974 704 l 1064 704 l 1064 178 q 1089 96 1064 119 q 1150 72 1114 72 q 1225 107 1193 72 q 1274 208 1257 142 q 1292 367 1292 274 q 1250 589 1292 489 q 1132 761 1208 689 q 951 872 1056 833 q 721 910 847 910 q 489 869 594 910 q 308 755 383 829 q 190 578 232 681 q 149 353 149 476 q 190 126 149 229 q 306 -51 231 24 q 485 -166 381 -125 q 715 -207 589 -207 q 849 -192 778 -207 q 982 -146 921 -176 l 1006 -214 q 864 -262 943 -246 q 715 -278 785 -278 m 699 -7 q 522 40 600 -7 q 399 167 444 86 q 354 353 354 249 q 399 538 354 457 q 522 664 444 618 q 699 710 600 710 q 869 667 794 710 q 985 544 943 624 q 1028 353 1028 464 q 985 161 1028 242 q 869 37 943 81 q 699 -7 796 -7 m 711 74 q 847 108 786 74 q 941 206 907 143 q 975 353 975 269 q 941 499 975 438 q 847 595 907 561 q 711 629 786 629 q 574 595 633 629 q 480 499 514 561 q 446 353 446 436 q 480 207 446 269 q 574 109 514 144 q 711 74 633 74 z "
  },
  "&": {
    ha: 929,
    x_min: 68,
    x_max: 911,
    o: "m 394 -8 q 226 23 300 -8 q 110 110 153 54 q 68 239 68 165 q 96 353 68 301 q 185 456 124 406 q 350 563 247 507 q 487 647 438 611 q 557 715 536 682 q 578 785 578 747 q 541 872 578 839 q 436 906 504 906 q 322 869 363 906 q 282 774 282 832 q 291 718 282 744 q 326 660 300 692 q 397 579 351 628 l 911 50 l 854 -15 l 318 536 q 241 626 269 588 q 201 699 213 664 q 190 772 190 733 q 220 881 190 835 q 306 953 250 928 q 436 979 361 979 q 555 956 504 979 q 634 890 606 933 q 663 786 663 847 q 637 688 663 733 q 553 598 611 642 q 394 500 494 554 q 256 411 307 451 q 185 333 206 371 q 164 249 164 294 q 194 156 164 196 q 277 95 224 117 q 400 74 331 74 q 574 114 497 74 q 702 236 650 154 q 778 442 754 318 l 857 417 q 767 183 831 278 q 608 40 703 89 q 394 -8 514 -8 z "
  },
  "¶": {
    ha: 878,
    x_min: 29,
    x_max: 719,
    o: "m 314 -139 l 314 549 q 166 580 231 550 q 65 664 101 610 q 29 790 29 718 q 66 919 29 865 q 170 1001 103 972 q 328 1031 238 1031 l 719 1031 l 719 -139 l 636 -139 l 636 953 l 397 953 l 397 -139 l 314 -139 z "
  },
  "§": {
    ha: 681,
    x_min: 39,
    x_max: 638,
    o: "m 472 204 l 400 257 q 502 303 461 267 q 543 400 543 339 q 518 472 543 444 q 453 516 493 500 q 363 544 413 532 q 266 569 314 556 q 177 606 218 583 q 111 665 136 628 q 86 763 86 703 q 122 878 86 829 q 226 953 158 926 q 388 979 293 979 q 478 971 431 979 q 567 947 525 963 q 638 908 610 931 l 604 833 q 499 883 557 867 q 381 899 442 899 q 228 865 281 899 q 175 765 175 832 q 200 697 175 722 q 265 656 225 671 q 354 628 306 640 q 451 601 403 615 q 540 564 500 588 q 606 501 581 540 q 631 400 631 463 q 585 277 631 329 q 472 204 540 225 m 319 -146 q 213 -134 267 -146 q 113 -101 158 -122 q 39 -54 68 -81 l 72 22 q 183 -40 115 -14 q 322 -65 250 -65 q 460 -31 410 -65 q 510 68 510 3 q 485 138 510 113 q 420 180 460 164 q 332 208 381 196 q 234 233 283 219 q 144 269 185 246 q 79 331 104 292 q 54 431 54 369 q 99 556 54 506 q 211 628 144 607 l 281 576 q 182 531 222 567 q 142 435 142 494 q 167 362 142 389 q 232 318 192 335 q 322 290 272 301 q 419 265 371 279 q 509 228 468 251 q 574 167 550 206 q 599 69 599 129 q 564 -44 599 4 q 467 -119 529 -93 q 319 -146 404 -146 z "
  },
  "©": {
    ha: 1124,
    x_min: 72,
    x_max: 1053,
    o: "m 561 -4 q 368 33 457 -4 q 213 138 279 71 q 109 294 146 206 q 72 486 72 383 q 110 678 72 589 q 214 834 147 767 q 370 939 281 901 q 564 976 460 976 q 758 940 668 976 q 913 836 847 903 q 1016 681 979 769 q 1053 489 1053 593 q 1015 295 1053 385 q 910 138 978 206 q 754 33 843 71 q 561 -4 665 -4 m 560 47 q 733 81 654 47 q 873 175 813 115 q 967 316 933 235 q 1000 489 1000 397 q 967 661 1000 582 q 876 800 935 740 q 737 892 817 860 q 564 925 657 925 q 389 892 469 925 q 249 798 308 858 q 157 658 190 738 q 124 486 124 579 q 157 315 124 394 q 249 174 190 235 q 388 81 308 114 q 560 47 468 47 m 574 197 q 425 234 490 197 q 322 336 360 271 q 285 486 285 401 q 322 636 285 571 q 425 738 360 701 q 574 775 490 775 q 702 747 644 775 q 794 668 760 718 l 735 624 q 664 683 706 664 q 572 703 622 703 q 466 676 513 703 q 392 600 419 649 q 364 486 364 551 q 392 372 364 421 q 466 297 419 324 q 572 269 513 269 q 664 289 622 269 q 735 349 706 308 l 794 306 q 702 226 760 254 q 574 197 644 197 z "
  },
  "®": {
    ha: 1124,
    x_min: 72,
    x_max: 1053,
    o: "m 561 -4 q 368 33 457 -4 q 213 138 279 71 q 109 294 146 206 q 72 486 72 383 q 110 678 72 589 q 214 834 147 767 q 370 939 281 901 q 564 976 460 976 q 758 940 668 976 q 913 836 847 903 q 1016 681 979 769 q 1053 489 1053 593 q 1015 295 1053 385 q 910 138 978 206 q 754 33 843 71 q 561 -4 665 -4 m 740 206 l 600 422 l 675 422 l 815 206 l 740 206 m 560 47 q 733 81 654 47 q 873 175 813 115 q 967 316 933 235 q 1000 489 1000 397 q 967 661 1000 582 q 876 800 935 740 q 737 892 817 860 q 564 925 657 925 q 389 892 469 925 q 249 798 308 858 q 157 658 190 738 q 124 486 124 579 q 157 315 124 394 q 249 174 190 235 q 388 81 308 114 q 560 47 468 47 m 371 206 l 371 767 l 588 767 q 751 716 692 767 q 810 581 810 665 q 751 442 810 492 q 588 392 692 392 l 443 392 l 443 206 l 371 206 m 442 453 l 583 453 q 698 486 657 453 q 739 581 739 519 q 698 673 739 640 q 583 706 657 706 l 442 706 l 442 453 z "
  },
  "™": {
    ha: 1418,
    x_min: 6,
    x_max: 1260,
    o: "m 603 396 l 603 972 l 665 972 l 949 531 l 917 531 l 1197 972 l 1258 972 l 1260 396 l 1188 396 l 1186 864 l 1201 864 l 949 467 l 914 467 l 656 864 l 676 864 l 676 396 l 603 396 m 222 396 l 222 908 l 6 908 l 6 972 l 514 972 l 514 908 l 297 908 l 297 396 l 222 396 z "
  },
  "°": {
    ha: 582,
    x_min: 69,
    x_max: 513,
    o: "m 290 539 q 178 569 229 539 q 99 648 128 599 q 69 760 69 697 q 99 871 69 821 q 178 950 128 921 q 290 979 229 979 q 403 950 353 979 q 483 871 454 921 q 513 760 513 821 q 483 649 513 699 q 403 569 454 599 q 290 539 353 539 m 292 597 q 373 619 336 597 q 431 678 410 642 q 451 760 451 714 q 431 842 451 806 q 373 900 410 879 q 292 921 336 921 q 209 900 246 921 q 151 842 172 879 q 131 760 131 806 q 151 677 131 714 q 209 619 172 640 q 292 597 246 597 z "
  },
  "′": {
    ha: 281,
    x_min: 96,
    x_max: 183,
    o: "m 103 606 l 96 972 l 183 972 l 176 606 l 103 606 z "
  },
  "″": {
    ha: 518,
    x_min: 96,
    x_max: 421,
    o: "m 103 606 l 96 972 l 183 972 l 176 606 l 103 606 m 340 606 l 333 972 l 421 972 l 414 606 l 340 606 z "
  },
  "|": {
    ha: 408,
    x_min: 158,
    x_max: 250,
    o: "m 158 -269 l 158 1031 l 250 1031 l 250 -269 l 158 -269 z "
  },
  "¦": {
    ha: 408,
    x_min: 158,
    x_max: 250,
    o: "m 158 544 l 158 1031 l 250 1031 l 250 544 l 158 544 m 158 -269 l 158 217 l 250 217 l 250 -269 l 158 -269 z "
  },
  ℓ: {
    ha: 647,
    x_min: 54,
    x_max: 592,
    o: "m 318 -3 q 211 29 249 -3 q 163 118 174 61 q 157 251 151 175 l 75 192 l 54 239 l 167 324 l 236 732 q 320 916 261 857 q 451 975 379 975 q 551 936 510 975 q 592 819 592 897 q 567 694 592 758 q 494 563 542 629 q 381 432 447 497 q 233 303 314 367 q 234 129 214 189 q 335 69 254 69 q 452 105 399 69 q 556 197 506 140 l 592 158 q 463 38 531 78 q 318 -3 394 -3 m 247 388 q 402 537 339 461 q 499 685 465 613 q 532 817 532 758 q 508 892 532 869 q 450 915 483 915 q 366 873 406 915 q 308 736 326 831 l 247 388 z "
  },
  "†": {
    ha: 760,
    x_min: 42,
    x_max: 718,
    o: "m 331 -269 l 331 538 l 42 538 l 42 625 l 331 625 l 331 972 l 429 972 l 429 625 l 718 625 l 718 538 l 429 538 l 429 -269 l 331 -269 z "
  },
  "‡": {
    ha: 760,
    x_min: 42,
    x_max: 718,
    o: "m 718 538 l 429 538 l 429 165 l 718 165 l 718 78 l 429 78 l 429 -269 l 331 -269 l 331 78 l 42 78 l 42 165 l 331 165 l 331 538 l 42 538 l 42 625 l 331 625 l 331 972 l 429 972 l 429 625 l 718 625 l 718 538 z "
  },
  "℮": {
    ha: 1232,
    x_min: 72,
    x_max: 1161,
    o: "m 617 -4 q 406 34 504 -4 q 232 140 307 72 q 115 295 157 207 q 72 485 72 383 q 115 676 72 588 q 232 833 157 765 q 406 938 307 900 q 617 976 504 976 q 828 938 729 976 q 1002 833 928 900 q 1119 676 1076 765 q 1161 485 1161 588 l 1161 474 l 279 474 q 271 468 271 474 l 271 201 q 275 184 271 192 q 283 169 279 176 q 431 61 340 97 q 618 25 521 25 q 815 69 724 25 q 968 186 906 114 l 1047 186 q 861 49 975 101 q 617 -4 747 -4 m 279 500 l 956 500 q 964 508 964 500 l 964 776 q 949 808 964 796 q 800 910 885 872 q 618 947 715 947 q 435 908 521 947 q 285 804 350 869 q 275 790 279 799 q 271 771 271 782 l 271 508 q 279 500 271 500 z "
  },
  "№": {
    ha: 1667,
    x_min: 158,
    x_max: 1589,
    o: "m 158 0 l 158 972 l 243 972 l 914 128 l 869 128 l 869 972 l 971 972 l 971 0 l 886 0 l 217 844 l 261 844 l 261 0 l 158 0 m 1136 347 l 1136 415 l 1561 415 l 1561 347 l 1136 347 m 1349 536 q 1225 565 1279 536 q 1140 643 1171 593 q 1108 758 1108 693 q 1140 872 1108 822 q 1225 951 1171 922 q 1349 979 1279 979 q 1472 951 1418 979 q 1558 872 1526 922 q 1589 758 1589 822 q 1558 643 1589 693 q 1472 565 1526 593 q 1349 536 1418 536 m 1349 599 q 1470 643 1424 599 q 1517 758 1517 688 q 1470 874 1517 831 q 1349 918 1424 918 q 1228 874 1276 918 q 1181 758 1181 829 q 1228 643 1181 688 q 1349 599 1276 599 z "
  },
  ʼ: {
    ha: 308,
    x_min: 82,
    x_max: 228,
    o: "m 85 692 l 146 947 l 157 889 q 103 909 125 889 q 82 963 82 929 q 103 1017 82 996 q 156 1038 125 1038 q 208 1016 188 1038 q 228 963 228 994 q 226 940 228 951 q 222 916 225 929 q 211 883 218 903 l 151 692 l 85 692 z "
  },
  ʻ: {
    ha: 369,
    x_min: 106,
    x_max: 251,
    o: "m 249 1167 l 188 910 l 176 969 q 231 949 210 969 q 251 896 251 929 q 231 842 251 863 q 179 821 210 821 q 126 842 146 821 q 106 896 106 864 q 107 918 106 908 q 113 942 108 928 q 124 975 117 956 l 182 1167 l 249 1167 z "
  },
  "ʺ": {
    ha: 518,
    x_min: 96,
    x_max: 421,
    o: "m 103 606 l 96 972 l 183 972 l 176 606 l 103 606 m 340 606 l 333 972 l 421 972 l 414 606 l 340 606 z "
  },
  "ˉ": {
    ha: 833,
    x_min: 203,
    x_max: 631,
    o: "m 203 896 l 203 961 l 631 961 l 631 896 l 203 896 z "
  },
  "ˋ": {
    ha: 833,
    x_min: 185,
    x_max: 507,
    o: "m 410 843 l 185 1015 l 317 1015 l 507 843 l 410 843 z "
  },
  "ʹ": {
    ha: 281,
    x_min: 96,
    x_max: 183,
    o: "m 103 606 l 96 972 l 183 972 l 176 606 l 103 606 z "
  },
  ʿ: {
    ha: 833,
    x_min: 268,
    x_max: 415,
    o: "m 415 826 q 340 846 374 826 q 288 897 307 865 q 268 968 268 929 q 288 1040 268 1007 q 340 1094 307 1074 q 415 1114 374 1114 l 415 1064 q 349 1036 375 1064 q 322 968 322 1008 q 348 903 322 929 q 415 876 374 876 l 415 826 z "
  },
  ʾ: {
    ha: 833,
    x_min: 415,
    x_max: 563,
    o: "m 415 826 l 415 876 q 483 903 457 876 q 510 968 510 929 q 483 1036 510 1008 q 415 1064 457 1064 l 415 1114 q 491 1093 458 1114 q 543 1040 524 1072 q 563 968 563 1008 q 544 897 563 929 q 492 846 525 865 q 415 826 458 826 z "
  },
  "ˊ": {
    ha: 833,
    x_min: 326,
    x_max: 649,
    o: "m 326 843 l 517 1015 l 649 1015 l 424 843 l 326 843 z "
  },
  "ˌ": {
    ha: 231,
    x_min: 79,
    x_max: 151,
    o: "m 79 -301 l 79 -42 l 151 -42 l 151 -301 l 79 -301 z "
  },
  "ˈ": {
    ha: 231,
    x_min: 79,
    x_max: 151,
    o: "m 79 713 l 79 972 l 151 972 l 151 713 l 79 713 z "
  },
  "̈": {
    ha: 0,
    x_min: 233,
    x_max: 600,
    o: "m 540 875 q 499 892 517 875 q 481 935 481 908 q 499 978 481 961 q 540 994 517 994 q 583 978 565 994 q 600 935 600 961 q 583 892 600 908 q 540 875 565 875 m 293 875 q 251 892 268 875 q 233 935 233 908 q 251 978 233 961 q 293 994 268 994 q 335 978 317 994 q 353 935 353 961 q 335 892 353 908 q 293 875 317 875 z "
  },
  "̇": {
    ha: 0,
    x_min: 350,
    x_max: 483,
    o: "m 417 875 q 369 894 389 875 q 350 942 350 914 q 369 990 350 971 q 417 1008 389 1008 q 464 990 444 1008 q 483 942 483 971 q 464 894 483 914 q 417 875 444 875 z "
  },
  "̀": {
    ha: 0,
    x_min: 185,
    x_max: 507,
    o: "m 410 843 l 185 1015 l 317 1015 l 507 843 l 410 843 z "
  },
  "́": {
    ha: 0,
    x_min: 326,
    x_max: 649,
    o: "m 326 843 l 517 1015 l 649 1015 l 424 843 l 326 843 z "
  },
  "̋": {
    ha: 0,
    x_min: 260,
    x_max: 729,
    o: "m 486 843 l 619 1015 l 729 1015 l 574 843 l 486 843 m 260 843 l 394 1015 l 504 1015 l 347 843 l 260 843 z "
  },
  "̂": {
    ha: 0,
    x_min: 188,
    x_max: 646,
    o: "m 188 843 l 367 1015 l 467 1015 l 646 843 l 554 843 l 378 990 l 456 990 l 279 843 l 188 843 z "
  },
  "̌": {
    ha: 0,
    x_min: 188,
    x_max: 646,
    o: "m 367 843 l 188 1015 l 279 1015 l 456 869 l 378 869 l 554 1015 l 646 1015 l 467 843 l 367 843 z "
  },
  "̆": {
    ha: 0,
    x_min: 206,
    x_max: 628,
    o: "m 417 836 q 269 884 329 836 q 206 1015 208 932 l 275 1015 q 319 929 278 961 q 417 897 360 897 q 516 929 475 897 q 558 1015 557 961 l 628 1015 q 565 884 625 932 q 417 836 504 836 z "
  },
  "̊": {
    ha: 0,
    x_min: 271,
    x_max: 561,
    o: "m 415 826 q 341 846 374 826 q 290 897 308 865 q 271 968 271 929 q 290 1040 271 1007 q 342 1094 310 1074 q 415 1114 375 1114 q 490 1094 457 1114 q 542 1040 522 1074 q 561 968 561 1007 q 542 897 561 929 q 490 846 522 865 q 415 826 457 826 m 415 875 q 483 902 457 875 q 510 968 510 929 q 483 1037 510 1008 q 415 1065 457 1065 q 349 1038 375 1065 q 322 968 322 1010 q 348 901 322 928 q 415 875 374 875 z "
  },
  "̃": {
    ha: 0,
    x_min: 197,
    x_max: 636,
    o: "m 511 851 q 454 865 479 851 q 409 898 429 879 q 369 931 389 917 q 329 946 350 946 q 278 922 297 946 q 257 857 260 899 l 197 857 q 234 968 200 926 q 322 1010 268 1010 q 380 995 354 1010 q 426 962 406 981 q 465 929 446 943 q 504 915 483 915 q 556 938 536 915 q 576 1001 575 961 l 636 1001 q 600 893 635 935 q 511 851 565 851 z "
  },
  "̄": {
    ha: 0,
    x_min: 203,
    x_max: 631,
    o: "m 203 896 l 203 961 l 631 961 l 631 896 l 203 896 z "
  },
  "̉": {
    ha: 0,
    x_min: 299,
    x_max: 546,
    o: "m 435 833 l 400 876 q 462 919 442 896 q 482 975 482 943 q 461 1024 482 1004 q 406 1043 440 1043 q 322 1017 363 1043 l 299 1065 q 353 1092 322 1083 q 414 1101 385 1101 q 509 1069 472 1101 q 546 982 546 1036 q 519 897 546 933 q 435 833 492 860 z "
  },
  "̏": {
    ha: 0,
    x_min: 104,
    x_max: 574,
    o: "m 486 843 l 329 1015 l 439 1015 l 574 843 l 486 843 m 260 843 l 104 1015 l 214 1015 l 347 843 l 260 843 z "
  },
  "̑": {
    ha: 0,
    x_min: 206,
    x_max: 628,
    o: "m 206 843 q 269 974 208 926 q 417 1021 329 1021 q 565 974 504 1021 q 628 843 625 926 l 558 843 q 516 929 557 897 q 417 961 475 961 q 319 929 360 961 q 275 843 278 897 l 206 843 z "
  },
  "̒": {
    ha: 0,
    x_min: 353,
    x_max: 481,
    o: "m 417 836 q 369 853 386 836 q 353 890 353 869 q 357 918 353 904 q 368 950 361 932 l 417 1085 l 476 1085 l 428 906 l 417 944 q 463 930 446 944 q 481 890 481 915 q 464 852 481 868 q 417 836 447 836 z "
  },
  "̛": {
    ha: 0,
    x_min: 396,
    x_max: 582,
    o: "m 396 654 l 396 729 l 417 729 q 487 757 465 729 q 508 824 508 785 q 501 872 508 850 q 481 913 493 894 l 546 938 q 572 884 563 914 q 582 821 582 854 q 540 701 582 747 q 417 654 499 654 l 396 654 z "
  },
  "̣": {
    ha: 0,
    x_min: 357,
    x_max: 476,
    o: "m 417 -264 q 375 -247 393 -264 q 357 -204 357 -231 q 375 -161 357 -178 q 417 -144 393 -144 q 459 -161 442 -144 q 476 -204 476 -178 q 459 -247 476 -231 q 417 -264 442 -264 z "
  },
  "̤": {
    ha: 0,
    x_min: 244,
    x_max: 590,
    o: "m 532 -260 q 491 -243 508 -260 q 474 -201 474 -226 q 491 -161 474 -178 q 532 -144 508 -144 q 573 -161 556 -144 q 590 -201 590 -178 q 573 -243 590 -226 q 532 -260 556 -260 m 301 -260 q 261 -243 278 -260 q 244 -201 244 -226 q 261 -161 244 -178 q 301 -144 278 -144 q 343 -161 326 -144 q 360 -201 360 -178 q 343 -243 360 -226 q 301 -260 326 -260 z "
  },
  "̦": {
    ha: 0,
    x_min: 357,
    x_max: 476,
    o: "m 368 -364 l 407 -214 l 417 -253 q 374 -237 390 -253 q 357 -199 357 -222 q 374 -160 357 -175 q 417 -144 390 -144 q 460 -160 444 -144 q 476 -199 476 -176 q 473 -228 476 -212 q 461 -261 469 -243 l 422 -364 l 368 -364 z "
  },
  "̧": {
    ha: 0,
    x_min: 269,
    x_max: 543,
    o: "m 386 -306 q 323 -297 351 -306 q 269 -274 294 -289 l 293 -221 q 337 -240 314 -233 q 385 -247 360 -247 q 449 -230 426 -247 q 471 -182 471 -212 q 449 -136 471 -154 q 385 -118 428 -118 l 353 -118 l 386 8 l 446 8 l 425 -72 q 513 -108 482 -76 q 543 -185 543 -139 q 499 -273 543 -240 q 386 -306 456 -306 z "
  },
  "̨": {
    ha: 0,
    x_min: 176,
    x_max: 447,
    o: "m 329 -306 q 218 -269 260 -306 q 176 -174 176 -233 q 194 -103 176 -140 q 254 -31 211 -67 q 372 38 297 6 l 418 0 q 315 -58 351 -29 q 263 -113 278 -86 q 249 -167 249 -140 q 274 -225 249 -206 q 339 -244 300 -244 q 385 -237 363 -244 q 425 -218 408 -231 l 447 -272 q 392 -297 422 -287 q 329 -306 363 -306 z "
  },
  "̮": {
    ha: 0,
    x_min: 206,
    x_max: 628,
    o: "m 417 -285 q 269 -239 329 -285 q 206 -117 208 -193 l 272 -117 q 315 -198 274 -168 q 417 -228 357 -228 q 519 -198 478 -228 q 561 -117 561 -168 l 628 -117 q 565 -239 625 -193 q 417 -285 504 -285 z "
  },
  "̱": {
    ha: 0,
    x_min: 203,
    x_max: 631,
    o: "m 203 -235 l 203 -169 l 631 -169 l 631 -235 l 203 -235 z "
  },
  "̵": {
    ha: 0,
    x_min: 146,
    x_max: 688,
    o: "m 146 574 l 146 646 l 688 646 l 688 574 l 146 574 z "
  },
  "̶": {
    ha: 0,
    x_min: 36,
    x_max: 1143,
    o: "m 36 568 l 36 651 l 1143 651 l 1143 568 l 36 568 z "
  },
  "̷": {
    ha: 0,
    x_min: 72,
    x_max: 453,
    o: "m 118 376 l 72 436 l 408 689 l 453 628 l 118 376 z "
  },
  "̸": {
    ha: 0,
    x_min: 88,
    x_max: 768,
    o: "m 88 -97 l 703 826 l 768 826 l 154 -97 l 88 -97 z "
  },
  "´": {
    ha: 833,
    x_min: 326,
    x_max: 649,
    o: "m 326 843 l 517 1015 l 649 1015 l 424 843 l 326 843 z "
  },
  "˘": {
    ha: 833,
    x_min: 206,
    x_max: 628,
    o: "m 417 836 q 269 884 329 836 q 206 1015 208 932 l 275 1015 q 319 929 278 961 q 417 897 360 897 q 516 929 475 897 q 558 1015 557 961 l 628 1015 q 565 884 625 932 q 417 836 504 836 z "
  },
  "ˇ": {
    ha: 833,
    x_min: 188,
    x_max: 646,
    o: "m 367 843 l 188 1015 l 279 1015 l 456 869 l 378 869 l 554 1015 l 646 1015 l 467 843 l 367 843 z "
  },
  "¸": {
    ha: 833,
    x_min: 269,
    x_max: 543,
    o: "m 386 -306 q 323 -297 351 -306 q 269 -274 294 -289 l 293 -221 q 337 -240 314 -233 q 385 -247 360 -247 q 449 -230 426 -247 q 471 -182 471 -212 q 449 -136 471 -154 q 385 -118 428 -118 l 353 -118 l 386 8 l 446 8 l 425 -72 q 513 -108 482 -76 q 543 -185 543 -139 q 499 -273 543 -240 q 386 -306 456 -306 z "
  },
  "ˆ": {
    ha: 833,
    x_min: 188,
    x_max: 646,
    o: "m 188 843 l 367 1015 l 467 1015 l 646 843 l 554 843 l 378 990 l 456 990 l 279 843 l 188 843 z "
  },
  "¨": {
    ha: 833,
    x_min: 233,
    x_max: 600,
    o: "m 540 875 q 499 892 517 875 q 481 935 481 908 q 499 978 481 961 q 540 994 517 994 q 583 978 565 994 q 600 935 600 961 q 583 892 600 908 q 540 875 565 875 m 293 875 q 251 892 268 875 q 233 935 233 908 q 251 978 233 961 q 293 994 268 994 q 335 978 317 994 q 353 935 353 961 q 335 892 353 908 q 293 875 317 875 z "
  },
  "˙": {
    ha: 833,
    x_min: 350,
    x_max: 483,
    o: "m 417 875 q 369 894 389 875 q 350 942 350 914 q 369 990 350 971 q 417 1008 389 1008 q 464 990 444 1008 q 483 942 483 971 q 464 894 483 914 q 417 875 444 875 z "
  },
  "`": {
    ha: 833,
    x_min: 185,
    x_max: 507,
    o: "m 410 843 l 185 1015 l 317 1015 l 507 843 l 410 843 z "
  },
  "˝": {
    ha: 833,
    x_min: 260,
    x_max: 729,
    o: "m 486 843 l 619 1015 l 729 1015 l 574 843 l 486 843 m 260 843 l 394 1015 l 504 1015 l 347 843 l 260 843 z "
  },
  "¯": {
    ha: 833,
    x_min: 203,
    x_max: 631,
    o: "m 203 896 l 203 961 l 631 961 l 631 896 l 203 896 z "
  },
  "˛": {
    ha: 833,
    x_min: 176,
    x_max: 447,
    o: "m 329 -306 q 218 -269 260 -306 q 176 -174 176 -233 q 194 -103 176 -140 q 254 -31 211 -67 q 372 38 297 6 l 418 0 q 315 -58 351 -29 q 263 -113 278 -86 q 249 -167 249 -140 q 274 -225 249 -206 q 339 -244 300 -244 q 385 -237 363 -244 q 425 -218 408 -231 l 447 -272 q 392 -297 422 -287 q 329 -306 363 -306 z "
  },
  "˚": {
    ha: 833,
    x_min: 271,
    x_max: 561,
    o: "m 415 826 q 341 846 374 826 q 290 897 308 865 q 271 968 271 929 q 290 1040 271 1007 q 342 1094 310 1074 q 415 1114 375 1114 q 490 1094 457 1114 q 542 1040 522 1074 q 561 968 561 1007 q 542 897 561 929 q 490 846 522 865 q 415 826 457 826 m 415 875 q 483 902 457 875 q 510 968 510 929 q 483 1037 510 1008 q 415 1065 457 1065 q 349 1038 375 1065 q 322 968 322 1010 q 348 901 322 928 q 415 875 374 875 z "
  },
  "˜": {
    ha: 833,
    x_min: 197,
    x_max: 636,
    o: "m 511 851 q 454 865 479 851 q 409 898 429 879 q 369 931 389 917 q 329 946 350 946 q 278 922 297 946 q 257 857 260 899 l 197 857 q 234 968 200 926 q 322 1010 268 1010 q 380 995 354 1010 q 426 962 406 981 q 465 929 446 943 q 504 915 483 915 q 556 938 536 915 q 576 1001 575 961 l 636 1001 q 600 893 635 935 q 511 851 565 851 z "
  },
  "\0": {
    ha: 0,
    x_min: 0,
    x_max: 0,
    o: ""
  },
  Ҧ: {
    ha: 1672,
    x_min: 164,
    x_max: 1613,
    o: "m 1157 -183 l 1175 -99 q 1305 -100 1244 -114 q 1412 -46 1365 -86 q 1485 55 1458 -6 q 1511 190 1511 115 q 1480 330 1511 271 q 1394 424 1449 389 q 1271 466 1340 458 q 1124 452 1201 474 q 968 375 1046 431 l 965 468 q 1153 542 1060 524 q 1330 547 1247 561 q 1476 486 1413 532 q 1576 367 1540 440 q 1613 197 1613 294 q 1576 19 1613 99 q 1477 -114 1540 -61 q 1332 -185 1414 -167 q 1157 -183 1250 -204 m 164 0 l 164 972 l 982 972 l 982 0 l 881 0 l 881 911 l 907 883 l 239 883 l 265 911 l 265 0 l 164 0 z "
  },
  ҧ: {
    ha: 1346,
    x_min: 140,
    x_max: 1314,
    o: "m 140 0 l 140 729 l 774 729 l 774 0 l 675 0 l 675 669 l 700 643 l 214 643 l 239 669 l 239 0 l 140 0 m 869 -267 l 890 -181 q 1060 -172 989 -197 q 1172 -85 1132 -147 q 1213 64 1213 -24 q 1183 197 1213 144 q 1103 276 1153 249 q 992 306 1053 303 q 868 289 931 308 q 750 229 806 269 l 747 319 q 908 381 828 365 q 1061 385 989 397 q 1190 332 1133 372 q 1281 226 1247 292 q 1314 68 1314 160 q 1281 -91 1314 -21 q 1189 -207 1249 -161 q 1048 -269 1129 -253 q 869 -267 967 -285 z "
  }
}, Be = "Montserrat", Ge = 1344, De = -349, ke = -139, Ve = 69, He = {
  yMin: -364,
  xMin: -256,
  yMax: 1449,
  xMax: 2201
}, We = 1e3, je = {
  format: 0,
  copyright: "Copyright 2011 The Montserrat Project Authors (https://github.com/JulietaUla/Montserrat)",
  fontFamily: "Montserrat",
  fontSubfamily: "Regular",
  uniqueID: "8.000;ULA;Montserrat-Regular",
  fullName: "Montserrat Regular",
  version: "Version 8.000",
  postScriptName: "Montserrat-Regular",
  manufacturer: "Julieta Ulanovsky",
  designer: "Julieta Ulanovsky",
  manufacturerURL: "http://www.zkysky.com.ar/",
  designerURL: "http://www.zkysky.com.ar/",
  licence: "This Font Software is licensed under the SIL Open Font License, Version 1.1. This license is available with a FAQ at: http://scripts.sil.org/OFL",
  licenceURL: "http://scripts.sil.org/OFL",
  unknown1: "MontserratRoman",
  unknown2: "Weight",
  unknown3: "Thin",
  unknown4: "ExtraLight",
  unknown5: "Light",
  unknown6: "Regular",
  unknown7: "Medium",
  unknown8: "SemiBold",
  unknown9: "Bold",
  unknown10: "ExtraBold",
  unknown11: "Black",
  unknown12: "MontserratRoman-Thin",
  unknown13: "MontserratRoman-ExtraLight",
  unknown14: "MontserratRoman-Light",
  unknown15: "MontserratRoman-Regular",
  unknown16: "MontserratRoman-Medium",
  unknown17: "MontserratRoman-SemiBold",
  unknown18: "MontserratRoman-Bold",
  unknown19: "MontserratRoman-ExtraBold",
  unknown20: "MontserratRoman-Black",
  unknown21: "Italic",
  unknown22: "Roman"
}, Xe = "normal", Ze = "normal", U9 = {
  glyphs: Fe,
  familyName: Be,
  ascender: Ge,
  descender: De,
  underlinePosition: ke,
  underlineThickness: Ve,
  boundingBox: He,
  resolution: We,
  original_font_information: je,
  cssFontWeight: Xe,
  cssFontStyle: Ze
}, P1 = (e) => {
  const t = e.toString().replace("#", "");
  return new m2(t.length === 6 ? parseInt("0x" + t, 16) : t);
}, $9 = (e) => e instanceof m2 ? e.clone() : typeof e == "string" ? P1(e) : new m2(e.r, e.g, e.b), Ye = (e, t = 0.92) => $9(e).multiplyScalar(t), K9 = (e) => {
  let t;
  const l = document.getElementById(`map-special-svg-${e}`);
  if (l) {
    const r = l.querySelector("svg");
    if (r) {
      const n = r.cloneNode(!0);
      n.querySelectorAll("[fill]").forEach((i) => {
        i.setAttribute("fill", "#FFFFFF");
      }), t = new XMLSerializer().serializeToString(n);
    }
  }
  return t;
}, Je = (e) => (e = e.slice(-10), e.length === 10 ? `${e.slice(0, 3)}.${e.slice(3, 6)}.${e.slice(-4)}` : e), J2 = (e, t) => t.IMAGE_PROXY_URL && /^https?:\/\//i.test(e.trim()) ? t.IMAGE_PROXY_URL + encodeURIComponent(e) : e, f8 = { x: 0, y: 0, z: 0 }, x4 = {
  camera: f8,
  controls: f8
}, H1 = {
  MAP_STYLE: "2D",
  MAP_BACKGROUND_COLOR: "#FFFFFF",
  ACCENT_COLOR: "#4EA5FF",
  STORE_DEFAULT_COLOR: "#E2E2E2",
  STORE_TEXT_COLOR: "#444444",
  STORE_HEIGHT: 12,
  WALL_COLOR: "#888888",
  BOUNDARY_COLOR: "#888888",
  BASE_COLOR: "#25292B",
  OVERLAY_COLOR: "#FFFFFF",
  WALL_THICKNESS: 0.6,
  BOUNDARY_THICKNESS: 0.8,
  OVERLAY_OPACITY: 0.7,
  KIOSK_SIZE: 15,
  ZOOM_STEP: 100,
  SELECTED_ZOOM_LIMIT: 1200,
  CAMERA_MAX_DISTANCE: 2e3,
  CAMERA_MIN_DISTANCE: 300
}, u4 = {
  PARKING_LINE_THICKNESS: 0.6,
  PARKING_LINE_COLOR: P1("#DDDDDD"),
  PARKING_ICON_COLOR: P1("#CCCCCC"),
  PARKING_LANE_COLOR: P1("#F6F6F6"),
  GREEN_AREA_COLOR: P1("#C4DDAB"),
  WATER_AREA_COLOR: P1("#5cc0f9")
}, R3 = (e) => ({
  ...e,
  ...u4
}), y4 = {
  MAP_BACKGROUND_COLOR: P1(H1.MAP_BACKGROUND_COLOR),
  HOST: "WEBSITE",
  DEVICE: "desktop",
  KIOSK_ID: 0,
  CENTER_ID: 0,
  SELECTED_RETAILER_ID: 0,
  STATS: !1,
  STYLE: H1.MAP_STYLE,
  DEBUG: !1,
  ACCENT_COLOR: P1(H1.ACCENT_COLOR),
  STORE_DEFAULT_COLOR: P1(H1.STORE_DEFAULT_COLOR),
  STORE_HEIGHT: H1.STORE_HEIGHT,
  WALL_THICKNESS: H1.WALL_THICKNESS,
  BOUNDARY_THICKNESS: H1.BOUNDARY_THICKNESS,
  ...u4,
  WALL_COLOR: P1(H1.WALL_COLOR),
  BOUNDARY_COLOR: P1(H1.BOUNDARY_COLOR),
  BASE_COLOR: P1(H1.BASE_COLOR),
  STORE_TEXT_COLOR: P1(H1.STORE_TEXT_COLOR),
  OVERLAY_COLOR: P1(H1.OVERLAY_COLOR),
  OVERLAY_OPACITY: H1.OVERLAY_OPACITY,
  CAMERA_CONTROLS_STATES: {
    display_app: x4,
    desktop: x4,
    tablet: x4,
    mobile: x4,
    perFloor: null
  },
  ORIGINAL_CAMERA_POSITION: null,
  // loaded and fit to canvas loaded area without any custom positions
  DEFAULT_CAMERA_POSITION: null,
  // custom default camera position
  DEFAULT_CONTROLS_TARGET: null,
  // custom default controls target
  DEFAULT_SELECTED_STORE: null,
  CAMERA: {
    fov: 75,
    far: 1e4,
    minDistance: 0.1,
    maxDistance: 5e3,
    animSpeed: 0.2
  },
  KIOSK_SIZE: H1.KIOSK_SIZE,
  ZOOM_STEP: H1.ZOOM_STEP,
  SELECTED_ZOOM_LIMIT: H1.SELECTED_ZOOM_LIMIT
}, G2 = {
  id: 0,
  retailer_id: null,
  kiosk_id: null,
  map_obj_name: "",
  obj_type: "retailer",
  layer_type: "retail_name",
  value: "",
  custom_text: "",
  custom_image: "",
  bg_color: "",
  transparent: !1,
  text_color: "",
  size: 8,
  rotate: 0,
  offset_x: 0,
  offset_y: 0,
  lock_size: !1
}, U2 = "custom-layer-", x8 = 20;
function Ue(e) {
  Ke(e);
  const t = $e(e);
  return e.on = t.on, e.off = t.off, e.fire = t.fire, e;
}
function $e(e) {
  let t = /* @__PURE__ */ Object.create(null);
  return {
    on: function(l, r, n) {
      if (typeof r != "function")
        throw new Error("callback is expected to be a function");
      let o = t[l];
      return o || (o = t[l] = []), o.push({ callback: r, ctx: n }), e;
    },
    off: function(l, r) {
      if (typeof l > "u")
        return t = /* @__PURE__ */ Object.create(null), e;
      if (t[l])
        if (typeof r != "function")
          delete t[l];
        else {
          const i = t[l];
          for (let q = 0; q < i.length; ++q)
            i[q].callback === r && i.splice(q, 1);
        }
      return e;
    },
    fire: function(l) {
      const r = t[l];
      if (!r)
        return e;
      let n;
      arguments.length > 1 && (n = Array.prototype.slice.call(arguments, 1));
      for (let o = 0; o < r.length; ++o) {
        const i = r[o];
        i.callback.apply(i.ctx, n);
      }
      return e;
    }
  };
}
function Ke(e) {
  if (!e)
    throw new Error("Eventify cannot use falsy object as events subject");
  const t = ["on", "fire", "off"];
  for (let l = 0; l < t.length; ++l)
    if (e.hasOwnProperty(t[l]))
      throw new Error("Subject cannot be eventified, since it already has property '" + t[l] + "'");
}
function Qe(e) {
  if (e = e || {}, "uniqueLinkId" in e && (console.warn(
    "ngraph.graph: Starting from version 0.14 `uniqueLinkId` is deprecated.\nUse `multigraph` option instead\n",
    `
`,
    `Note: there is also change in default behavior: From now on each graph
is considered to be not a multigraph by default (each edge is unique).`
  ), e.multigraph = e.uniqueLinkId), e.multigraph === void 0 && (e.multigraph = !1), typeof Map != "function")
    throw new Error("ngraph.graph requires `Map` to be defined. Please polyfill it before using ngraph");
  var t = /* @__PURE__ */ new Map(), l = /* @__PURE__ */ new Map(), r = {}, n = 0, o = e.multigraph ? m : f, i = [], q = X, a = X, s = X, c = X, u = {
    /**
     * Sometimes duck typing could be slow. Giving clients a hint about data structure
     * via explicit version number here:
     */
    version: 20,
    /**
     * Adds node to the graph. If node with given id already exists in the graph
     * its data is extended with whatever comes in 'data' argument.
     *
     * @param nodeId the node's identifier. A string or number is preferred.
     * @param [data] additional data for the node being added. If node already
     *   exists its data object is augmented with the new one.
     *
     * @return {node} The newly added node or node with given id if it already exists.
     */
    addNode: b,
    /**
     * Adds a link to the graph. The function always create a new
     * link between two nodes. If one of the nodes does not exists
     * a new node is created.
     *
     * @param fromId link start node id;
     * @param toId link end node id;
     * @param [data] additional data to be set on the new link;
     *
     * @return {link} The newly created link
     */
    addLink: C,
    /**
     * Removes link from the graph. If link does not exist does nothing.
     *
     * @param link - object returned by addLink() or getLinks() methods.
     *
     * @returns true if link was removed; false otherwise.
     */
    removeLink: T,
    /**
     * Removes node with given id from the graph. If node does not exist in the graph
     * does nothing.
     *
     * @param nodeId node's identifier passed to addNode() function.
     *
     * @returns true if node was removed; false otherwise.
     */
    removeNode: d,
    /**
     * Gets node with given identifier. If node does not exist undefined value is returned.
     *
     * @param nodeId requested node identifier;
     *
     * @return {node} in with requested identifier or undefined if no such node exists.
     */
    getNode: h,
    /**
     * Gets number of nodes in this graph.
     *
     * @return number of nodes in the graph.
     */
    getNodeCount: p,
    /**
     * Gets total number of links in the graph.
     */
    getLinkCount: I,
    /**
     * Synonym for `getLinkCount()`
     */
    getEdgeCount: I,
    /**
     * Synonym for `getLinkCount()`
     */
    getLinksCount: I,
    /**
     * Synonym for `getNodeCount()`
     */
    getNodesCount: p,
    /**
     * Gets all links (inbound and outbound) from the node with given id.
     * If node with given id is not found null is returned.
     *
     * @param nodeId requested node identifier.
     *
     * @return Set of links from and to requested node if such node exists;
     *   otherwise null is returned.
     */
    getLinks: w,
    /**
     * Invokes callback on each node of the graph.
     *
     * @param {Function(node)} callback Function to be invoked. The function
     *   is passed one argument: visited node.
     */
    forEachNode: F,
    /**
     * Invokes callback on every linked (adjacent) node to the given one.
     *
     * @param nodeId Identifier of the requested node.
     * @param {Function(node, link)} callback Function to be called on all linked nodes.
     *   The function is passed two parameters: adjacent node and link object itself.
     * @param oriented if true graph treated as oriented.
     */
    forEachLinkedNode: e1,
    /**
     * Enumerates all links in the graph
     *
     * @param {Function(link)} callback Function to be called on all links in the graph.
     *   The function is passed one parameter: graph's link object.
     *
     * Link object contains at least the following fields:
     *  fromId - node id where link starts;
     *  toId - node id where link ends,
     *  data - additional data passed to graph.addLink() method.
     */
    forEachLink: t1,
    /**
     * Suspend all notifications about graph changes until
     * endUpdate is called.
     */
    beginUpdate: s,
    /**
     * Resumes all notifications about graph changes and fires
     * graph 'changed' event in case there are any pending changes.
     */
    endUpdate: c,
    /**
     * Removes all nodes and links from the graph.
     */
    clear: k,
    /**
     * Detects whether there is a link between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     * NOTE: this function is synonym for getLink()
     *
     * @returns link if there is one. null otherwise.
     */
    hasLink: j,
    /**
     * Detects whether there is a node with given id
     * 
     * Operation complexity is O(1)
     * NOTE: this function is synonym for getNode()
     *
     * @returns node if there is one; Falsy value otherwise.
     */
    hasNode: h,
    /**
     * Gets an edge between two nodes.
     * Operation complexity is O(n) where n - number of links of a node.
     *
     * @param {string} fromId link start identifier
     * @param {string} toId link end identifier
     *
     * @returns link if there is one; undefined otherwise.
     */
    getLink: j,
    /**
     * Gets a link by its id.
     *
     * @param {string} linkId link identifier
     *
     * @returns link if there is one; undefined otherwise.
     */
    getLinkById: $
  };
  return Ue(u), _(), u;
  function _() {
    var M = u.on;
    u.on = H;
    function H() {
      return u.beginUpdate = s = G, u.endUpdate = c = a1, q = A, a = v, u.on = M, M.apply(u, arguments);
    }
  }
  function A(M, H) {
    i.push({
      link: M,
      changeType: H
    });
  }
  function v(M, H) {
    i.push({
      node: M,
      changeType: H
    });
  }
  function b(M, H) {
    if (M === void 0)
      throw new Error("Invalid node identifier");
    s();
    var W = h(M);
    return W ? (W.data = H, a(W, "update")) : (W = new e0(M, H), a(W, "add")), t.set(M, W), c(), W;
  }
  function h(M) {
    return t.get(M);
  }
  function d(M) {
    var H = h(M);
    if (!H)
      return !1;
    s();
    var W = H.links;
    return W && (W.forEach(L), H.links = null), t.delete(M), a(H, "remove"), c(), !0;
  }
  function C(M, H, W) {
    s();
    var S = h(M) || b(M), E = h(H) || b(H), g = o(M, H, W), x = l.has(g.id);
    return l.set(g.id, g), h8(S, g), M !== H && h8(E, g), q(g, x ? "update" : "add"), c(), g;
  }
  function f(M, H, W) {
    var S = A2(M, H), E = l.get(S);
    return E ? (E.data = W, E) : new p8(M, H, W, S);
  }
  function m(M, H, W) {
    var S = A2(M, H), E = r.hasOwnProperty(S);
    if (E || j(M, H)) {
      E || (r[S] = 0);
      var g = "@" + ++r[S];
      S = A2(M + g, H + g);
    }
    return new p8(M, H, W, S);
  }
  function p() {
    return t.size;
  }
  function I() {
    return l.size;
  }
  function w(M) {
    var H = h(M);
    return H ? H.links : null;
  }
  function T(M, H) {
    return H !== void 0 && (M = j(M, H)), L(M);
  }
  function L(M) {
    if (!M || !l.get(M.id)) return !1;
    s(), l.delete(M.id);
    var H = h(M.fromId), W = h(M.toId);
    return H && H.links.delete(M), W && W.links.delete(M), q(M, "remove"), c(), !0;
  }
  function j(M, H) {
    if (!(M === void 0 || H === void 0))
      return l.get(A2(M, H));
  }
  function $(M) {
    if (M !== void 0)
      return l.get(M);
  }
  function k() {
    s(), F(function(M) {
      d(M.id);
    }), c();
  }
  function t1(M) {
    if (typeof M == "function")
      for (var H = l.values(), W = H.next(); !W.done; ) {
        if (M(W.value))
          return !0;
        W = H.next();
      }
  }
  function e1(M, H, W) {
    var S = h(M);
    if (S && S.links && typeof H == "function")
      return W ? Z(S.links, M, H) : Q(S.links, M, H);
  }
  function Q(M, H, W) {
    for (var S, E = M.values(), g = E.next(); !g.done; ) {
      var x = g.value, R = x.fromId === H ? x.toId : x.fromId;
      if (S = W(t.get(R), x), S)
        return !0;
      g = E.next();
    }
  }
  function Z(M, H, W) {
    for (var S, E = M.values(), g = E.next(); !g.done; ) {
      var x = g.value;
      if (x.fromId === H && (S = W(t.get(x.toId), x), S))
        return !0;
      g = E.next();
    }
  }
  function X() {
  }
  function G() {
    n += 1;
  }
  function a1() {
    n -= 1, n === 0 && i.length > 0 && (u.fire("changed", i), i.length = 0);
  }
  function F(M) {
    if (typeof M != "function")
      throw new Error("Function is expected to iterate over graph nodes. You passed " + M);
    for (var H = t.values(), W = H.next(); !W.done; ) {
      if (M(W.value))
        return !0;
      W = H.next();
    }
  }
}
function e0(e, t) {
  this.id = e, this.links = null, this.data = t;
}
function h8(e, t) {
  e.links ? e.links.add(t) : e.links = /* @__PURE__ */ new Set([t]);
}
function p8(e, t, l, r) {
  this.fromId = e, this.toId = t, this.data = l, this.id = r;
}
function A2(e, t) {
  return e.toString() + "👉 " + t.toString();
}
function M4(e, t) {
  if (!new.target) return new M4(e, t);
  if (Array.isArray(e) || (t = e, e = []), t = t || {}, this.data = e || [], this.length = this.data.length, this.compare = t.compare || l0, this.setNodeId = t.setNodeId || t0, this.length > 0)
    for (var l = this.length >> 1; l >= 0; l--) this._down(l);
  if (t.setNodeId)
    for (var l = 0; l < this.length; ++l)
      this.setNodeId(this.data[l], l);
}
function t0() {
}
function l0(e, t) {
  return e - t;
}
M4.prototype = {
  push: function(e) {
    this.data.push(e), this.setNodeId(e, this.length), this.length++, this._up(this.length - 1);
  },
  pop: function() {
    if (this.length !== 0) {
      var e = this.data[0];
      return this.length--, this.length > 0 && (this.data[0] = this.data[this.length], this.setNodeId(this.data[0], 0), this._down(0)), this.data.pop(), e;
    }
  },
  peek: function() {
    return this.data[0];
  },
  updateItem: function(e) {
    this._down(e), this._up(e);
  },
  _up: function(e) {
    for (var t = this.data, l = this.compare, r = this.setNodeId, n = t[e]; e > 0; ) {
      var o = e - 1 >> 1, i = t[o];
      if (l(n, i) >= 0) break;
      t[e] = i, r(i, e), e = o;
    }
    t[e] = n, r(n, e);
  },
  _down: function(e) {
    for (var t = this.data, l = this.compare, r = this.length >> 1, n = t[e], o = this.setNodeId; e < r; ) {
      var i = (e << 1) + 1, q = i + 1, a = t[i];
      if (q < this.length && l(t[q], a) < 0 && (i = q, a = t[q]), l(a, n) >= 0) break;
      t[e] = a, o(a, e), e = i;
    }
    t[e] = n, o(n, e);
  }
};
function n0(e) {
  this.node = e, this.parent = null, this.closed = !1, this.open = 0, this.distanceToSource = Number.POSITIVE_INFINITY, this.fScore = Number.POSITIVE_INFINITY, this.heapIndex = -1;
}
function Q9() {
  var e = 0, t = [];
  return {
    createNewState: r,
    reset: l
  };
  function l() {
    e = 0;
  }
  function r(n) {
    var o = t[e];
    return o ? (o.node = n, o.parent = null, o.closed = !1, o.open = 0, o.distanceToSource = Number.POSITIVE_INFINITY, o.fScore = Number.POSITIVE_INFINITY, o.heapIndex = -1) : (o = new n0(n), t[e] = o), e++, o;
  }
}
function z6(e, t) {
  var l = e.x - t.x, r = e.y - t.y;
  return Math.sqrt(l * l + r * r);
}
function N6(e, t) {
  var l = e.x - t.x, r = e.y - t.y;
  return Math.abs(l) + Math.abs(r);
}
const e5 = [];
typeof Object.freeze == "function" && Object.freeze(e5);
const G1 = {
  // Path search settings
  heuristic: r0,
  distance: o0,
  blocked: i0,
  compareFScore: a0,
  NO_PATH: e5,
  // heap settings
  setHeapIndex: q0,
  // nba:
  setH1: u0,
  setH2: m0,
  compareF1Score: s0,
  compareF2Score: c0
};
function r0() {
  return 0;
}
function o0() {
  return 1;
}
function i0() {
  return !1;
}
function a0(e, t) {
  var l = e.fScore - t.fScore;
  return l;
}
function q0(e, t) {
  e.heapIndex = t;
}
function s0(e, t) {
  return e.f1 - t.f1;
}
function c0(e, t) {
  return e.f2 - t.f2;
}
function u0(e, t) {
  e.h1 = t;
}
function m0(e, t) {
  e.h2 = t;
}
var d0 = G1.NO_PATH;
function M6(e, t) {
  t = t || {};
  var l = t.oriented, r = t.blocked;
  r || (r = G1.blocked);
  var n = t.heuristic;
  n || (n = G1.heuristic);
  var o = t.distance;
  o || (o = G1.distance);
  var i = Q9();
  return {
    /**
     * Finds a path between node `fromId` and `toId`.
     * @returns {Array} of nodes between `toId` and `fromId`. Empty array is returned
     * if no path is found.
     */
    find: q
  };
  function q(a, s) {
    var c = e.getNode(a);
    if (!c) throw new Error("fromId is not defined in this graph: " + a);
    var u = e.getNode(s);
    if (!u) throw new Error("toId is not defined in this graph: " + s);
    i.reset();
    var _ = /* @__PURE__ */ new Map(), A = new M4({
      compare: G1.compareFScore,
      setNodeId: G1.setHeapIndex
    }), v = i.createNewState(c);
    _.set(a, v), v.fScore = n(c, u), v.distanceToSource = 0, A.push(v), v.open = 1;
    for (var b; A.length > 0; ) {
      if (b = A.pop(), f0(b, u)) return x0(b);
      b.closed = !0, e.forEachLinkedNode(b.node.id, h, l);
    }
    return d0;
    function h(d, C) {
      var f = _.get(d.id);
      if (f || (f = i.createNewState(d), _.set(d.id, f)), !f.closed && (f.open === 0 && (A.push(f), f.open = 1), !r(d, b.node, C))) {
        var m = b.distanceToSource + o(d, b.node, C);
        m >= f.distanceToSource || (f.parent = b, f.distanceToSource = m, f.fScore = m + n(f.node, u), A.updateItem(f.heapIndex));
      }
    }
  }
}
M6.l2 = z6;
M6.l1 = N6;
function f0(e, t) {
  return e.node === t;
}
function x0(e) {
  for (var t = [e.node], l = e.parent; l; )
    t.push(l.node), l = l.parent;
  return t;
}
var o2 = 1, O3 = 2, h0 = G1.NO_PATH;
function P6(e, t) {
  t = t || {};
  var l = t.oriented, r = t.blocked;
  r || (r = G1.blocked);
  var n = t.heuristic;
  n || (n = G1.heuristic);
  var o = t.distance;
  o || (o = G1.distance);
  var i = Q9();
  return {
    find: q
  };
  function q(a, s) {
    var c = e.getNode(a);
    if (!c) throw new Error("fromId is not defined in this graph: " + a);
    var u = e.getNode(s);
    if (!u) throw new Error("toId is not defined in this graph: " + s);
    if (c === u) return [c];
    i.reset();
    var _ = l ? L : T, A = /* @__PURE__ */ new Map(), v = new M4({
      compare: G1.compareFScore,
      setNodeId: G1.setHeapIndex
    }), b = new M4({
      compare: G1.compareFScore,
      setNodeId: G1.setHeapIndex
    }), h = i.createNewState(c);
    A.set(a, h), h.fScore = n(c, u), h.distanceToSource = 0, v.push(h), h.open = o2;
    var d = i.createNewState(u);
    d.fScore = n(u, c), d.distanceToSource = 0, b.push(d), d.open = O3;
    for (var C = Number.POSITIVE_INFINITY, f, m, p = v, I = o2; v.length > 0 && b.length > 0; ) {
      v.length < b.length ? (I = o2, p = v) : (I = O3, p = b);
      var w = p.pop();
      if (w.closed = !0, !(w.distanceToSource > C) && (e.forEachLinkedNode(w.node.id, _), f && m))
        return $(f, m);
    }
    return h0;
    function T(t1, e1) {
      return k(t1, e1, w);
    }
    function L(t1, e1) {
      if (I === o2) {
        if (e1.fromId === w.node.id) return k(t1, e1, w);
      } else if (I === O3 && e1.toId === w.node.id)
        return k(t1, e1, w);
    }
    function j(t1) {
      var e1 = t1.open;
      return !!(e1 && e1 !== I);
    }
    function $(t1, e1) {
      for (var Q = [], Z = t1; Z; )
        Q.push(Z.node), Z = Z.parent;
      for (var X = e1; X; )
        Q.unshift(X.node), X = X.parent;
      return Q;
    }
    function k(t1, e1, Q) {
      var Z = A.get(t1.id);
      if (Z || (Z = i.createNewState(t1), A.set(t1.id, Z)), !Z.closed && !r(Z.node, Q.node, e1)) {
        if (j(Z)) {
          var X = Z.distanceToSource + Q.distanceToSource;
          X < C && (f = Z, m = Q, C = X);
          return;
        }
        var G = Q.distanceToSource + o(Z.node, Q.node, e1);
        if (!(G >= Z.distanceToSource)) {
          var a1 = I === o2 ? u : c, F = G + n(Z.node, a1);
          F >= C || (Z.fScore = F, Z.open === 0 && (p.push(Z), p.updateItem(Z.heapIndex), Z.open = I), Z.parent = Q, Z.distanceToSource = G);
        }
      }
    }
  }
}
P6.l2 = z6;
P6.l1 = N6;
function p0(e) {
  this.node = e, this.p1 = null, this.p2 = null, this.closed = !1, this.g1 = Number.POSITIVE_INFINITY, this.g2 = Number.POSITIVE_INFINITY, this.f1 = Number.POSITIVE_INFINITY, this.f2 = Number.POSITIVE_INFINITY, this.h1 = -1, this.h2 = -1;
}
function g0() {
  var e = 0, t = [];
  return {
    /**
     * Creates a new NBASearchState instance
     */
    createNewState: r,
    /**
     * Marks all created instances available for recycling.
     */
    reset: l
  };
  function l() {
    e = 0;
  }
  function r(n) {
    var o = t[e];
    return o ? (o.node = n, o.p1 = null, o.p2 = null, o.closed = !1, o.g1 = Number.POSITIVE_INFINITY, o.g2 = Number.POSITIVE_INFINITY, o.f1 = Number.POSITIVE_INFINITY, o.f2 = Number.POSITIVE_INFINITY, o.h1 = -1, o.h2 = -1) : (o = new p0(n), t[e] = o), e++, o;
  }
}
var b0 = G1.NO_PATH;
function L6(e, t) {
  t = t || {};
  var l = t.oriented, r = t.quitFast, n = t.blocked;
  n || (n = G1.blocked);
  var o = t.heuristic;
  o || (o = G1.heuristic);
  var i = t.distance;
  i || (i = G1.distance);
  var q = g0();
  return {
    /**
     * Finds a path between node `fromId` and `toId`.
     * @returns {Array} of nodes between `toId` and `fromId`. Empty array is returned
     * if no path is found.
     */
    find: a
  };
  function a(s, c) {
    var u = e.getNode(s);
    if (!u) throw new Error("fromId is not defined in this graph: " + s);
    var _ = e.getNode(c);
    if (!_) throw new Error("toId is not defined in this graph: " + c);
    q.reset();
    var A = l ? Q : k, v = l ? e1 : t1, b = /* @__PURE__ */ new Map(), h = new M4({
      compare: G1.compareF1Score,
      setNodeId: G1.setH1
    }), d = new M4({
      compare: G1.compareF2Score,
      setNodeId: G1.setH2
    }), C, f = Number.POSITIVE_INFINITY, m = q.createNewState(u);
    b.set(s, m), m.g1 = 0;
    var p = o(u, _);
    m.f1 = p, h.push(m);
    var I = q.createNewState(_);
    b.set(c, I), I.g2 = 0;
    var w = p;
    I.f2 = w, d.push(I);
    for (var T; d.length && h.length && (h.length < d.length ? j() : $(), !(r && C)); )
      ;
    var L = _0(C);
    return L;
    function j() {
      T = h.pop(), !T.closed && (T.closed = !0, T.f1 < f && T.g1 + w - o(u, T.node) < f && e.forEachLinkedNode(T.node.id, A), h.length > 0 && (p = h.peek().f1));
    }
    function $() {
      T = d.pop(), !T.closed && (T.closed = !0, T.f2 < f && T.g2 + p - o(T.node, _) < f && e.forEachLinkedNode(T.node.id, v), d.length > 0 && (w = d.peek().f2));
    }
    function k(Z, X) {
      var G = b.get(Z.id);
      if (G || (G = q.createNewState(Z), b.set(Z.id, G)), !G.closed && !n(T.node, Z, X)) {
        var a1 = T.g1 + i(T.node, Z, X);
        a1 < G.g1 && (G.g1 = a1, G.f1 = a1 + o(G.node, _), G.p1 = T, G.h1 < 0 ? h.push(G) : h.updateItem(G.h1));
        var F = G.g1 + G.g2;
        F < f && (f = F, C = G);
      }
    }
    function t1(Z, X) {
      var G = b.get(Z.id);
      if (G || (G = q.createNewState(Z), b.set(Z.id, G)), !G.closed && !n(T.node, Z, X)) {
        var a1 = T.g2 + i(T.node, Z, X);
        a1 < G.g2 && (G.g2 = a1, G.f2 = a1 + o(u, G.node), G.p2 = T, G.h2 < 0 ? d.push(G) : d.updateItem(G.h2));
        var F = G.g1 + G.g2;
        F < f && (f = F, C = G);
      }
    }
    function e1(Z, X) {
      if (X.toId === T.node.id) return t1(Z, X);
    }
    function Q(Z, X) {
      if (X.fromId === T.node.id) return k(Z, X);
    }
  }
}
L6.l2 = z6;
L6.l1 = N6;
function _0(e) {
  if (!e) return b0;
  for (var t = [e.node], l = e.p1; l; )
    t.push(l.node), l = l.p1;
  for (var r = e.p2; r; )
    t.unshift(r.node), r = r.p2;
  return t;
}
const v0 = {
  aStar: M6,
  aGreedy: P6,
  nba: L6
};
function t5(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: y0 } = Object.prototype, { getPrototypeOf: $4 } = Object, { iterator: g2, toStringTag: l5 } = Symbol, $2 = (({ hasOwnProperty: e }) => (t, l) => e.call(t, l))(Object.prototype), f2 = (e, t) => {
  let l = e;
  const r = [];
  for (; l != null && l !== Object.prototype; ) {
    if (r.indexOf(l) !== -1)
      return !1;
    if (r.push(l), $2(l, t))
      return !0;
    l = $4(l);
  }
  return !1;
}, I0 = (e, t) => e != null && f2(e, t) ? e[t] : void 0, F6 = /* @__PURE__ */ ((e) => (t) => {
  const l = y0.call(t);
  return e[l] || (e[l] = l.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), s4 = (e) => (e = e.toLowerCase(), (t) => F6(t) === e), u3 = (e) => (t) => typeof t === e, { isArray: P4 } = Array, L4 = u3("undefined");
function Q4(e) {
  return e !== null && !L4(e) && e.constructor !== null && !L4(e.constructor) && n4(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const n5 = s4("ArrayBuffer");
function C0(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && n5(e.buffer), t;
}
const E0 = u3("string"), n4 = u3("function"), r5 = u3("number"), e2 = (e) => e !== null && typeof e == "object", A0 = (e) => e === !0 || e === !1, D2 = (e) => {
  if (!e2(e))
    return !1;
  const t = $4(e);
  return (t === null || t === Object.prototype || $4(t) === null) && // Treat any genuine (non-Object.prototype-polluted) Symbol.toStringTag or
  // Symbol.iterator as evidence the value is a tagged/iterable type rather
  // than a plain object, while ignoring keys injected onto Object.prototype.
  !f2(e, l5) && !f2(e, g2);
}, S0 = (e) => {
  if (!e2(e) || Q4(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, R0 = s4("Date"), O0 = s4("File"), T0 = (e) => !!(e && typeof e.uri < "u"), w0 = (e) => e && typeof e.getParts < "u", z0 = s4("Blob"), N0 = s4("FileList"), M0 = s4("Set"), P0 = (e) => e2(e) && n4(e.pipe);
function L0() {
  return typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {};
}
const g8 = L0(), b8 = typeof g8.FormData < "u" ? g8.FormData : void 0, F0 = (e) => {
  if (!e) return !1;
  if (b8 && e instanceof b8) return !0;
  const t = $4(e);
  if (!t || t === Object.prototype || !n4(e.append)) return !1;
  const l = F6(e);
  return l === "formdata" || // detect form-data instance
  l === "object" && n4(e.toString) && e.toString() === "[object FormData]";
}, B0 = s4("URLSearchParams"), [G0, D0, k0, V0] = [
  "ReadableStream",
  "Request",
  "Response",
  "Headers"
].map(s4), H0 = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function b2(e, t, { allOwnKeys: l = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let r, n;
  if (typeof e != "object" && (e = [e]), P4(e))
    for (r = 0, n = e.length; r < n; r++)
      t.call(null, e[r], r, e);
  else {
    if (Q4(e))
      return;
    const o = l ? Object.getOwnPropertyNames(e) : Object.keys(e), i = o.length;
    let q;
    for (r = 0; r < i; r++)
      q = o[r], t.call(null, e[q], q, e);
  }
}
function o5(e, t) {
  if (Q4(e))
    return null;
  t = t.toLowerCase();
  const l = Object.keys(e);
  let r = l.length, n;
  for (; r-- > 0; )
    if (n = l[r], t === n.toLowerCase())
      return n;
  return null;
}
const T4 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, i5 = (e) => !L4(e) && e !== T4;
function n6(...e) {
  const { caseless: t, skipUndefined: l } = i5(this) && this || {}, r = {}, n = (o, i) => {
    if (i === "__proto__" || i === "constructor" || i === "prototype")
      return;
    const q = t && typeof i == "string" && o5(r, i) || i, a = $2(r, q) ? r[q] : void 0;
    D2(a) && D2(o) ? r[q] = n6(a, o) : D2(o) ? r[q] = n6({}, o) : P4(o) ? r[q] = o.slice() : (!l || !L4(o)) && (r[q] = o);
  };
  for (let o = 0, i = e.length; o < i; o++) {
    const q = e[o];
    if (!q || Q4(q) || (b2(q, n), typeof q != "object" || P4(q)))
      continue;
    const a = Object.getOwnPropertySymbols(q);
    for (let s = 0; s < a.length; s++) {
      const c = a[s];
      tt.call(q, c) && n(q[c], c);
    }
  }
  return r;
}
const W0 = (e, t, l, { allOwnKeys: r } = {}) => (b2(
  t,
  (n, o) => {
    l && n4(n) ? Object.defineProperty(e, o, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot
      // hijack defineProperty's accessor-vs-data resolution.
      __proto__: null,
      value: t5(n, l),
      writable: !0,
      enumerable: !0,
      configurable: !0
    }) : Object.defineProperty(e, o, {
      __proto__: null,
      value: n,
      writable: !0,
      enumerable: !0,
      configurable: !0
    });
  },
  { allOwnKeys: r }
), e), j0 = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), X0 = (e, t, l, r) => {
  e.prototype = Object.create(t.prototype, r), Object.defineProperty(e.prototype, "constructor", {
    __proto__: null,
    value: e,
    writable: !0,
    enumerable: !1,
    configurable: !0
  }), Object.defineProperty(e, "super", {
    __proto__: null,
    value: t.prototype
  }), l && Object.assign(e.prototype, l);
}, Z0 = (e, t, l, r) => {
  let n, o, i;
  const q = {};
  if (t = t || {}, e == null) return t;
  do {
    for (n = Object.getOwnPropertyNames(e), o = n.length; o-- > 0; )
      i = n[o], (!r || r(i, e, t)) && !q[i] && (t[i] = e[i], q[i] = !0);
    e = l !== !1 && $4(e);
  } while (e && (!l || l(e, t)) && e !== Object.prototype);
  return t;
}, Y0 = (e, t, l) => {
  e = String(e), (l === void 0 || l > e.length) && (l = e.length), l -= t.length;
  const r = e.indexOf(t, l);
  return r !== -1 && r === l;
}, J0 = (e) => {
  if (!e) return null;
  if (P4(e)) return e;
  let t = e.length;
  if (!r5(t)) return null;
  const l = new Array(t);
  for (; t-- > 0; )
    l[t] = e[t];
  return l;
}, U0 = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && $4(Uint8Array)), $0 = (e, t) => {
  const r = (e && e[g2]).call(e);
  let n;
  for (; (n = r.next()) && !n.done; ) {
    const o = n.value;
    t.call(e, o[0], o[1]);
  }
}, K0 = (e, t) => {
  let l;
  const r = [];
  for (; (l = e.exec(t)) !== null; )
    r.push(l);
  return r;
}, Q0 = s4("HTMLFormElement"), et = (e) => e.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function(l, r, n) {
  return r.toUpperCase() + n;
}), { propertyIsEnumerable: tt } = Object.prototype, lt = s4("RegExp"), a5 = (e, t) => {
  const l = Object.getOwnPropertyDescriptors(e), r = {};
  b2(l, (n, o) => {
    let i;
    (i = t(n, o, e)) !== !1 && (r[o] = i || n);
  }), Object.defineProperties(e, r);
}, nt = (e) => {
  a5(e, (t, l) => {
    if (n4(e) && ["arguments", "caller", "callee"].includes(l))
      return !1;
    const r = e[l];
    if (n4(r)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + l + "'");
      });
    }
  });
}, rt = (e, t) => {
  const l = {}, r = (n) => {
    n.forEach((o) => {
      l[o] = !0;
    });
  };
  return P4(e) ? r(e) : r(String(e).split(t)), l;
}, ot = () => {
}, it = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function at(e) {
  return !!(e && n4(e.append) && e[l5] === "FormData" && e[g2]);
}
const qt = (e) => {
  const t = /* @__PURE__ */ new WeakSet(), l = (r) => {
    if (e2(r)) {
      if (t.has(r))
        return;
      if (Q4(r))
        return r;
      if (!("toJSON" in r)) {
        t.add(r);
        let n;
        if (M0(r)) {
          n = [];
          for (const o of r) {
            const i = l(o);
            !L4(i) && n.push(i);
          }
        } else
          n = P4(r) ? [] : {}, b2(r, (o, i) => {
            const q = l(o);
            !L4(q) && (n[i] = q);
          });
        return t.delete(r), n;
      }
    }
    return r;
  };
  return l(e);
}, st = s4("AsyncFunction"), ct = (e) => e && (e2(e) || n4(e)) && n4(e.then) && n4(e.catch), q5 = ((e, t) => e ? setImmediate : t ? ((l, r) => (T4.addEventListener(
  "message",
  ({ source: n, data: o }) => {
    n === T4 && o === l && r.length && r.shift()();
  },
  !1
), (n) => {
  r.push(n), T4.postMessage(l, "*");
}))(`axios@${Math.random()}`, []) : (l) => setTimeout(l))(typeof setImmediate == "function", n4(T4.postMessage)), ut = typeof queueMicrotask < "u" ? queueMicrotask.bind(T4) : typeof process < "u" && process.nextTick || q5, s5 = (e) => e != null && n4(e[g2]), mt = (e) => e != null && f2(e, g2) && s5(e), P = {
  isArray: P4,
  isArrayBuffer: n5,
  isBuffer: Q4,
  isFormData: F0,
  isArrayBufferView: C0,
  isString: E0,
  isNumber: r5,
  isBoolean: A0,
  isObject: e2,
  isPlainObject: D2,
  isEmptyObject: S0,
  isReadableStream: G0,
  isRequest: D0,
  isResponse: k0,
  isHeaders: V0,
  isUndefined: L4,
  isDate: R0,
  isFile: O0,
  isReactNativeBlob: T0,
  isReactNative: w0,
  isBlob: z0,
  isRegExp: lt,
  isFunction: n4,
  isStream: P0,
  isURLSearchParams: B0,
  isTypedArray: U0,
  isFileList: N0,
  forEach: b2,
  merge: n6,
  extend: W0,
  trim: H0,
  stripBOM: j0,
  inherits: X0,
  toFlatObject: Z0,
  kindOf: F6,
  kindOfTest: s4,
  endsWith: Y0,
  toArray: J0,
  forEachEntry: $0,
  matchAll: K0,
  isHTMLForm: Q0,
  hasOwnProperty: $2,
  hasOwnProp: $2,
  // an alias to avoid ESLint no-prototype-builtins detection
  hasOwnInPrototypeChain: f2,
  getSafeProp: I0,
  reduceDescriptors: a5,
  freezeMethods: nt,
  toObjectSet: rt,
  toCamelCase: et,
  noop: ot,
  toFiniteNumber: it,
  findKey: o5,
  global: T4,
  isContextDefined: i5,
  isSpecCompliantForm: at,
  toJSONObject: qt,
  isAsyncFn: st,
  isThenable: ct,
  setImmediate: q5,
  asap: ut,
  isIterable: s5,
  isSafeIterable: mt
}, dt = P.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), ft = (e) => {
  const t = {};
  let l, r, n;
  return e && e.split(`
`).forEach(function(i) {
    n = i.indexOf(":"), l = i.substring(0, n).trim().toLowerCase(), r = i.substring(n + 1).trim();
    const q = P.hasOwnProp(t, l);
    !l || q && P.hasOwnProp(dt, l) || (l === "set-cookie" ? q ? t[l].push(r) : t[l] = [r] : t[l] = q ? t[l] + ", " + r : r);
  }), t;
};
function xt(e) {
  let t = 0, l = e.length;
  for (; t < l; ) {
    const r = e.charCodeAt(t);
    if (r !== 9 && r !== 32)
      break;
    t += 1;
  }
  for (; l > t; ) {
    const r = e.charCodeAt(l - 1);
    if (r !== 9 && r !== 32)
      break;
    l -= 1;
  }
  return t === 0 && l === e.length ? e : e.slice(t, l);
}
const ht = new RegExp("[\\u0000-\\u0008\\u000a-\\u001f\\u007f]+", "g"), pt = new RegExp("[^\\u0009\\u0020-\\u007e\\u0080-\\u00ff]+", "g");
function B6(e, t) {
  return P.isArray(e) ? e.map((l) => B6(l, t)) : xt(String(e).replace(t, ""));
}
const gt = (e) => B6(e, ht), bt = (e) => B6(e, pt);
function c5(e) {
  const t = /* @__PURE__ */ Object.create(null);
  return P.forEach(e.toJSON(), (l, r) => {
    t[r] = bt(l);
  }), t;
}
const _8 = Symbol("internals");
function i2(e) {
  return e && String(e).trim().toLowerCase();
}
function k2(e) {
  return e === !1 || e == null ? e : P.isArray(e) ? e.map(k2) : gt(String(e));
}
function _t(e) {
  const t = /* @__PURE__ */ Object.create(null), l = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let r;
  for (; r = l.exec(e); )
    t[r[1]] = r[2];
  return t;
}
const vt = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/;
function T3(e) {
  let t = 0, l = e.length;
  for (; t < l; ) {
    const r = e.charCodeAt(t);
    if (r !== 9 && r !== 32)
      break;
    t += 1;
  }
  for (; l > t; ) {
    const r = e.charCodeAt(l - 1);
    if (r !== 9 && r !== 32)
      break;
    l -= 1;
  }
  return t === 0 && l === e.length ? e : e.slice(t, l);
}
function yt(e) {
  const t = e.length - 1;
  if (t < 1 || e.charCodeAt(0) !== 34 || e.charCodeAt(t) !== 34)
    return e;
  let l = "";
  for (let r = 1; r < t; r++) {
    const n = e.charCodeAt(r);
    if (n === 34 || n === 92 && (r += 1, r >= t))
      return e;
    l += e[r];
  }
  return l;
}
function It(e) {
  const t = /* @__PURE__ */ Object.create(null), l = String(e);
  let r = 0, n = !1, o = !1;
  function i(q) {
    const a = T3(l.slice(r, q)), s = a.indexOf("=");
    if (s < 1)
      return;
    const c = T3(a.slice(0, s));
    if (!vt.test(c))
      return;
    const u = c.toLowerCase();
    if (u === "__proto__" || u === "constructor" || u === "prototype")
      return;
    const _ = T3(a.slice(s + 1));
    t[u] = yt(_);
  }
  for (let q = 0; q < l.length; q++) {
    const a = l.charCodeAt(q);
    n ? o ? o = !1 : a === 92 ? o = !0 : a === 34 && (n = !1) : a === 34 ? n = !0 : (a === 44 || a === 59) && (i(q), r = q + 1);
  }
  return i(l.length), t;
}
const Ct = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function w3(e, t, l, r, n) {
  if (P.isFunction(r))
    return r.call(this, t, l);
  if (n && (t = l), !!P.isString(t)) {
    if (P.isString(r))
      return t.indexOf(r) !== -1;
    if (P.isRegExp(r))
      return r.test(t);
  }
}
function Et(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, l, r) => l.toUpperCase() + r);
}
function At(e, t) {
  const l = P.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((r) => {
    Object.defineProperty(e, r + l, {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: function(n, o, i) {
        return this[r].call(this, t, n, o, i);
      },
      configurable: !0
    });
  });
}
let Q1 = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, l, r) {
    const n = this;
    function o(q, a, s) {
      const c = i2(a);
      if (!c)
        return;
      const u = P.findKey(n, c);
      (!u || n[u] === void 0 || s === !0 || s === void 0 && n[u] !== !1) && (n[u || a] = k2(q));
    }
    const i = (q, a) => P.forEach(q, (s, c) => o(s, c, a));
    if (P.isPlainObject(t) || t instanceof this.constructor)
      i(t, l);
    else if (P.isString(t) && (t = t.trim()) && !Ct(t))
      i(ft(t), l);
    else if (P.isObject(t) && P.isSafeIterable(t)) {
      let q = /* @__PURE__ */ Object.create(null), a, s;
      for (const c of t) {
        if (!P.isArray(c))
          throw new TypeError("Object iterator must return a key-value pair");
        s = c[0], P.hasOwnProp(q, s) ? (a = q[s], q[s] = P.isArray(a) ? [...a, c[1]] : [a, c[1]]) : q[s] = c[1];
      }
      i(q, l);
    } else
      t != null && o(l, t, r);
    return this;
  }
  get(t, l) {
    if (t = i2(t), t) {
      const r = P.findKey(this, t);
      if (r) {
        const n = this[r];
        if (!l)
          return n;
        if (l === !0)
          return _t(n);
        if (P.isFunction(l))
          return l.call(this, n, r);
        if (P.isRegExp(l))
          return l.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, l) {
    if (t = i2(t), t) {
      const r = P.findKey(this, t);
      return !!(r && this[r] !== void 0 && (!l || w3(this, this[r], r, l)));
    }
    return !1;
  }
  delete(t, l) {
    const r = this;
    let n = !1;
    function o(i) {
      if (i = i2(i), i) {
        const q = P.findKey(r, i);
        q && (!l || w3(r, r[q], q, l)) && (delete r[q], n = !0);
      }
    }
    return P.isArray(t) ? t.forEach(o) : o(t), n;
  }
  clear(t) {
    const l = Object.keys(this);
    let r = l.length, n = !1;
    for (; r--; ) {
      const o = l[r];
      (!t || w3(this, this[o], o, t, !0)) && (delete this[o], n = !0);
    }
    return n;
  }
  normalize(t) {
    const l = this, r = {};
    return P.forEach(this, (n, o) => {
      const i = P.findKey(r, o);
      if (i) {
        l[i] = k2(n), delete l[o];
        return;
      }
      const q = t ? Et(o) : String(o).trim();
      q !== o && delete l[o], l[q] = k2(n), r[q] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const l = /* @__PURE__ */ Object.create(null);
    return P.forEach(this, (r, n) => {
      r != null && r !== !1 && (l[n] = t && P.isArray(r) ? r.join(", ") : r);
    }), l;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, l]) => t + ": " + l).join(`
`);
  }
  getSetCookie() {
    const t = this.get("set-cookie");
    return P.isArray(t) ? t : t == null || t === !1 ? [] : [t];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static parseParameters(t) {
    return It(t);
  }
  static concat(t, ...l) {
    const r = new this(t);
    return l.forEach((n) => r.set(n)), r;
  }
  static accessor(t) {
    const r = (this[_8] = this[_8] = {
      accessors: {}
    }).accessors, n = this.prototype;
    function o(i) {
      const q = i2(i);
      r[q] || (At(n, i), r[q] = !0);
    }
    return P.isArray(t) ? t.forEach(o) : o(t), this;
  }
};
Q1.accessor([
  "Content-Type",
  "Content-Length",
  "Accept",
  "Accept-Encoding",
  "User-Agent",
  "Authorization"
]);
P.reduceDescriptors(Q1.prototype, ({ value: e }, t) => {
  let l = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(r) {
      this[l] = r;
    }
  };
});
P.freezeMethods(Q1);
const K2 = "[REDACTED ****]";
function St(e) {
  if (P.hasOwnProp(e, "toJSON"))
    return !0;
  let t = Object.getPrototypeOf(e);
  for (; t && t !== Object.prototype; ) {
    if (P.hasOwnProp(t, "toJSON"))
      return !0;
    t = Object.getPrototypeOf(t);
  }
  return !1;
}
function Rt(e, t) {
  const l = new Set(t.map((o) => String(o).toLowerCase())), r = [], n = (o) => {
    if (o === null || typeof o != "object" || P.isBuffer(o)) return o;
    if (r.indexOf(o) !== -1) return;
    o instanceof Q1 && (o = o.toJSON()), r.push(o);
    let i;
    if (P.isArray(o))
      i = [], o.forEach((q, a) => {
        const s = n(q);
        P.isUndefined(s) || (i[a] = s);
      });
    else {
      if (!P.isPlainObject(o) && St(o))
        return r.pop(), o;
      i = /* @__PURE__ */ Object.create(null);
      for (const [q, a] of Object.entries(o)) {
        const s = l.has(q.toLowerCase()) ? K2 : n(a);
        P.isUndefined(s) || (i[q] = s);
      }
    }
    return r.pop(), i;
  };
  return n(e);
}
function v8(e) {
  try {
    return String(e);
  } catch {
    return "";
  }
}
function Ot(e) {
  return e.errors.map((l) => {
    try {
      return l && l.message ? v8(l.message) : v8(l);
    } catch {
      return "";
    }
  }).filter(Boolean).join("; ") || e.name || "AggregateError";
}
let c1 = class u5 extends Error {
  static from(t, l, r, n, o, i) {
    let q = t.message;
    !q && P.isArray(t.errors) && t.errors.length && (q = Ot(t));
    const a = new u5(q, l || t.code, r, n, o);
    return Object.defineProperty(a, "cause", {
      __proto__: null,
      value: t,
      writable: !0,
      enumerable: !1,
      configurable: !0
    }), a.name = t.name, t.status != null && a.status == null && (a.status = t.status), i && Object.assign(a, i), a;
  }
  /**
   * Create an Error with the specified message, config, error code, request and response.
   *
   * @param {string} message The error message.
   * @param {string} [code] The error code (for example, 'ECONNABORTED').
   * @param {Object} [config] The config.
   * @param {Object} [request] The request.
   * @param {Object} [response] The response.
   *
   * @returns {Error} The created error.
   */
  constructor(t, l, r, n, o) {
    super(t), Object.defineProperty(this, "message", {
      // Null-proto descriptor so a polluted Object.prototype.get cannot turn
      // this data descriptor into an accessor descriptor on the way in.
      __proto__: null,
      value: t,
      enumerable: !0,
      writable: !0,
      configurable: !0
    }), this.name = "AxiosError", this.isAxiosError = !0, l && (this.code = l), r && (this.config = r), n && (this.request = n), o && (this.response = o, this.status = o.status);
  }
  toJSON() {
    const t = this.config, l = t && P.hasOwnProp(t, "redact") ? t.redact : void 0, r = P.isArray(l) && l.length > 0 ? Rt(t, l) : P.toJSONObject(t);
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: r,
      code: this.code,
      status: this.status
    };
  }
};
c1.ERR_BAD_OPTION_VALUE = "ERR_BAD_OPTION_VALUE";
c1.ERR_BAD_OPTION = "ERR_BAD_OPTION";
c1.ECONNABORTED = "ECONNABORTED";
c1.ETIMEDOUT = "ETIMEDOUT";
c1.ECONNREFUSED = "ECONNREFUSED";
c1.ERR_NETWORK = "ERR_NETWORK";
c1.ERR_FR_TOO_MANY_REDIRECTS = "ERR_FR_TOO_MANY_REDIRECTS";
c1.ERR_DEPRECATED = "ERR_DEPRECATED";
c1.ERR_BAD_RESPONSE = "ERR_BAD_RESPONSE";
c1.ERR_BAD_REQUEST = "ERR_BAD_REQUEST";
c1.ERR_CANCELED = "ERR_CANCELED";
c1.ERR_NOT_SUPPORT = "ERR_NOT_SUPPORT";
c1.ERR_INVALID_URL = "ERR_INVALID_URL";
c1.ERR_FORM_DATA_DEPTH_EXCEEDED = "ERR_FORM_DATA_DEPTH_EXCEEDED";
const Tt = null, m5 = 100;
function r6(e) {
  return P.isPlainObject(e) || P.isArray(e);
}
function d5(e) {
  return P.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function z3(e, t, l) {
  return e ? e.concat(t).map(function(n, o) {
    return n = d5(n), !l && o ? "[" + n + "]" : n;
  }).join(l ? "." : "") : t;
}
function wt(e) {
  return P.isArray(e) && !e.some(r6);
}
const zt = P.toFlatObject(P, {}, null, function(t) {
  return /^is[A-Z]/.test(t);
});
function m3(e, t, l) {
  if (!P.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), l = P.toFlatObject(
    l,
    {
      metaTokens: !0,
      dots: !1,
      indexes: !1
    },
    !1,
    function(C, f) {
      return !P.isUndefined(f[C]);
    }
  );
  const r = l.metaTokens, n = l.visitor || v, o = l.dots, i = l.indexes, q = l.Blob || typeof Blob < "u" && Blob, a = l.maxDepth === void 0 ? m5 : l.maxDepth, s = q && P.isSpecCompliantForm(t), c = [];
  if (!P.isFunction(n))
    throw new TypeError("visitor must be a function");
  function u(d) {
    if (d === null) return "";
    if (P.isDate(d))
      return d.toISOString();
    if (P.isBoolean(d))
      return d.toString();
    if (!s && P.isBlob(d))
      throw new c1("Blob is not supported. Use a Buffer instead.");
    if (P.isArrayBuffer(d) || P.isTypedArray(d)) {
      if (s && typeof q == "function")
        return new q([d]);
      throw new c1("Blob is not supported. Use a Buffer instead.", c1.ERR_NOT_SUPPORT);
    }
    return d;
  }
  function _(d) {
    if (d > a)
      throw new c1(
        "Object is too deeply nested (" + d + " levels). Max depth: " + a,
        c1.ERR_FORM_DATA_DEPTH_EXCEEDED
      );
  }
  function A(d, C) {
    if (a === 1 / 0)
      return JSON.stringify(d);
    const f = [];
    return JSON.stringify(d, function(p, I) {
      if (!P.isObject(I))
        return I;
      for (; f.length && f[f.length - 1] !== this; )
        f.pop();
      return f.push(I), _(C + f.length - 1), I;
    });
  }
  function v(d, C, f) {
    let m = d;
    if (P.isReactNative(t) && P.isReactNativeBlob(d))
      return t.append(z3(f, C, o), u(d)), !1;
    if (d && !f && typeof d == "object") {
      if (P.endsWith(C, "{}"))
        C = r ? C : C.slice(0, -2), d = A(d, 1);
      else if (P.isArray(d) && wt(d) || (P.isFileList(d) || P.endsWith(C, "[]")) && (m = P.toArray(d)))
        return C = d5(C), m.forEach(function(I, w) {
          !(P.isUndefined(I) || I === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? z3([C], w, o) : i === null ? C : C + "[]",
            u(I)
          );
        }), !1;
    }
    return r6(d) ? !0 : (t.append(z3(f, C, o), u(d)), !1);
  }
  const b = Object.assign(zt, {
    defaultVisitor: v,
    convertValue: u,
    isVisitable: r6
  });
  function h(d, C, f = 0) {
    if (!P.isUndefined(d)) {
      if (_(f), c.indexOf(d) !== -1)
        throw new Error("Circular reference detected in " + C.join("."));
      c.push(d), P.forEach(d, function(p, I) {
        (!(P.isUndefined(p) || p === null) && n.call(t, p, P.isString(I) ? I.trim() : I, C, b)) === !0 && h(p, C ? C.concat(I) : [I], f + 1);
      }), c.pop();
    }
  }
  if (!P.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function y8(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20/g, function(r) {
    return t[r];
  });
}
function G6(e, t) {
  this._pairs = [], e && m3(e, this, t);
}
const f5 = G6.prototype;
f5.append = function(t, l) {
  this._pairs.push([t, l]);
};
f5.toString = function(t) {
  const l = t ? (r) => t.call(this, r, y8) : y8;
  return this._pairs.map(function(n) {
    return l(n[0]) + "=" + l(n[1]);
  }, "").join("&");
};
function Nt(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function x5(e, t, l) {
  if (!t)
    return e;
  e = e || "";
  const r = P.isFunction(l) ? {
    serialize: l
  } : l, n = P.getSafeProp(r, "encode") || Nt, o = P.getSafeProp(r, "serialize");
  let i;
  if (o ? i = o(t, r) : i = P.isURLSearchParams(t) ? t.toString() : new G6(t, r).toString(n), i) {
    const q = e.indexOf("#");
    q !== -1 && (e = e.slice(0, q)), e += (e.indexOf("?") === -1 ? "?" : "&") + i;
  }
  return e;
}
class I8 {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   * @param {Object} options The options for the interceptor, synchronous and runWhen
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, l, r) {
    return this.handlers.push({
      fulfilled: t,
      rejected: l,
      synchronous: r ? r.synchronous : !1,
      runWhen: r ? r.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    P.forEach(this.handlers, function(r) {
      r !== null && t(r);
    });
  }
}
const D6 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1,
  legacyInterceptorReqResOrdering: !0,
  advertiseZstdAcceptEncoding: !1,
  validateStatusUndefinedResolves: !0
}, Mt = typeof URLSearchParams < "u" ? URLSearchParams : G6, Pt = typeof FormData < "u" ? FormData : null, Lt = typeof Blob < "u" ? Blob : null, Ft = {
  isBrowser: !0,
  classes: {
    URLSearchParams: Mt,
    FormData: Pt,
    Blob: Lt
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, k6 = typeof window < "u" && typeof document < "u", o6 = typeof navigator == "object" && navigator || void 0, Bt = k6 && (!o6 || ["ReactNative", "NativeScript", "NS"].indexOf(o6.product) < 0), Gt = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", Dt = k6 && window.location.href || "http://localhost", kt = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: k6,
  hasStandardBrowserEnv: Bt,
  hasStandardBrowserWebWorkerEnv: Gt,
  navigator: o6,
  origin: Dt
}, Symbol.toStringTag, { value: "Module" })), Y1 = {
  ...kt,
  ...Ft
};
function Vt(e, t) {
  return m3(e, new Y1.classes.URLSearchParams(), {
    visitor: function(l, r, n, o) {
      return Y1.isNode && P.isBuffer(l) ? (this.append(r, l.toString("base64")), !1) : o.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
const C8 = m5;
function h5(e) {
  if (e > C8)
    throw new c1(
      "FormData field is too deeply nested (" + e + " levels). Max depth: " + C8,
      c1.ERR_FORM_DATA_DEPTH_EXCEEDED
    );
}
function Ht(e) {
  const t = [], l = /[^.[\]]+|\[([^.[\]]*)]/g;
  let r;
  for (; (r = l.exec(e)) !== null; )
    h5(t.length), t.push(r[0] === "[]" ? "" : r[1] || r[0]);
  return t;
}
function Wt(e) {
  const t = {}, l = Object.keys(e);
  let r;
  const n = l.length;
  let o;
  for (r = 0; r < n; r++)
    o = l[r], t[o] = e[o];
  return t;
}
function p5(e) {
  function t(l, r, n, o) {
    h5(o);
    let i = l[o++];
    if (i === "__proto__") return !0;
    const q = Number.isFinite(+i), a = o >= l.length;
    return i = !i && P.isArray(n) ? n.length : i, a ? (P.hasOwnProp(n, i) ? n[i] = P.isArray(n[i]) ? n[i].concat(r) : [n[i], r] : n[i] = r, !q) : ((!P.hasOwnProp(n, i) || !P.isObject(n[i])) && (n[i] = []), t(l, r, n[i], o) && P.isArray(n[i]) && (n[i] = Wt(n[i])), !q);
  }
  if (P.isFormData(e) && P.isFunction(e.entries)) {
    const l = {};
    return P.forEachEntry(e, (r, n) => {
      t(Ht(r), n, l, 0);
    }), l;
  }
  return null;
}
const W4 = (e, t) => e != null && P.hasOwnProp(e, t) ? e[t] : void 0;
function jt(e, t, l) {
  if (P.isString(e))
    try {
      return (t || JSON.parse)(e), P.trim(e);
    } catch (r) {
      if (r.name !== "SyntaxError")
        throw r;
    }
  return (l || JSON.stringify)(e);
}
const _2 = {
  transitional: D6,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [
    function(t, l) {
      const r = l.getContentType() || "", n = r.indexOf("application/json") > -1, o = P.isObject(t);
      if (o && P.isHTMLForm(t) && (t = new FormData(t)), P.isFormData(t))
        return n ? JSON.stringify(p5(t)) : t;
      if (P.isArrayBuffer(t) || P.isBuffer(t) || P.isStream(t) || P.isFile(t) || P.isBlob(t) || P.isReadableStream(t))
        return t;
      if (P.isArrayBufferView(t))
        return t.buffer;
      if (P.isURLSearchParams(t))
        return l.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), t.toString();
      let q;
      if (o) {
        const a = W4(this, "formSerializer");
        if (r.indexOf("application/x-www-form-urlencoded") > -1)
          return Vt(t, a).toString();
        if ((q = P.isFileList(t)) || r.indexOf("multipart/form-data") > -1) {
          const s = W4(this, "env"), c = s && s.FormData;
          return m3(
            q ? { "files[]": t } : t,
            c && new c(),
            a
          );
        }
      }
      return o || n ? (l.setContentType("application/json", !1), jt(t)) : t;
    }
  ],
  transformResponse: [
    function(t) {
      const l = W4(this, "transitional") || _2.transitional, r = l && l.forcedJSONParsing, n = W4(this, "responseType"), o = n === "json";
      if (P.isResponse(t) || P.isReadableStream(t))
        return t;
      if (t && P.isString(t) && (r && !n || o)) {
        const q = !(l && l.silentJSONParsing) && o;
        try {
          return JSON.parse(t, W4(this, "parseReviver"));
        } catch (a) {
          if (q)
            throw a.name === "SyntaxError" ? c1.from(a, c1.ERR_BAD_RESPONSE, this, null, W4(this, "response")) : a;
        }
      }
      return t;
    }
  ],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Y1.classes.FormData,
    Blob: Y1.classes.Blob
  },
  validateStatus: function(t) {
    return t >= 200 && t < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
P.forEach(["delete", "get", "head", "post", "put", "patch", "query"], (e) => {
  _2.headers[e] = {};
});
function N3(e, t) {
  const l = this || _2, r = t || l, n = Q1.from(r.headers);
  let o = r.data;
  return P.forEach(e, function(q) {
    o = q.call(l, o, n.normalize(), t ? t.status : void 0);
  }), n.normalize(), o;
}
function g5(e) {
  return !!(e && e.__CANCEL__);
}
let v2 = class extends c1 {
  /**
   * A `CanceledError` is an object that is thrown when an operation is canceled.
   *
   * @param {string=} message The message.
   * @param {Object=} config The config.
   * @param {Object=} request The request.
   *
   * @returns {CanceledError} The created error.
   */
  constructor(t, l, r) {
    super(t ?? "canceled", c1.ERR_CANCELED, l, r), this.name = "CanceledError", this.__CANCEL__ = !0;
  }
};
function b5(e, t, l) {
  const r = l.config.validateStatus;
  !l.status || !r || r(l.status) ? e(l) : t(new c1(
    "Request failed with status code " + l.status,
    l.status >= 400 && l.status < 500 ? c1.ERR_BAD_REQUEST : c1.ERR_BAD_RESPONSE,
    l.config,
    l.request,
    l
  ));
}
function Xt(e) {
  const t = /^([-+\w]{1,25}):(?:\/\/)?/.exec(e);
  return t && t[1] || "";
}
function Zt(e, t) {
  e = e || 10;
  const l = new Array(e), r = new Array(e);
  let n = 0, o = 0, i;
  return t = t !== void 0 ? t : 1e3, function(a) {
    const s = Date.now(), c = r[o];
    i || (i = s), l[n] = a, r[n] = s;
    let u = o, _ = 0;
    for (; u !== n; )
      _ += l[u++], u = u % e;
    if (n = (n + 1) % e, n === o && (o = (o + 1) % e), s - i < t)
      return;
    const A = c && s - c;
    return A ? Math.round(_ * 1e3 / A) : void 0;
  };
}
function Yt(e, t) {
  let l = 0, r = 1e3 / t, n, o;
  const i = (s, c = Date.now()) => {
    l = c, n = null, o && (clearTimeout(o), o = null), e(...s);
  };
  return [(...s) => {
    const c = Date.now(), u = c - l;
    u >= r ? i(s, c) : (n = s, o || (o = setTimeout(() => {
      o = null, i(n);
    }, r - u)));
  }, () => n && i(n)];
}
const Q2 = (e, t, l = 3) => {
  let r = 0;
  const n = Zt(50, 250);
  return Yt((o) => {
    if (!o || typeof o.loaded != "number")
      return;
    const i = o.loaded, q = o.lengthComputable ? o.total : void 0, a = Math.max(0, q != null ? Math.min(i, q) : i), s = Math.max(0, a - r), c = n(s);
    r = Math.max(r, a);
    const u = {
      loaded: a,
      total: q,
      progress: q ? a / q : void 0,
      bytes: s,
      rate: c || void 0,
      estimated: c && q ? (q - a) / c : void 0,
      event: o,
      lengthComputable: q != null,
      [t ? "download" : "upload"]: !0
    };
    e(u);
  }, l);
}, E8 = (e, t) => {
  const l = e != null;
  return [
    (r) => t[0]({
      lengthComputable: l,
      total: e,
      loaded: r
    }),
    t[1]
  ];
}, A8 = (e, t = P.asap) => (...l) => t(() => e(...l)), Jt = Y1.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (l) => (l = new URL(l, Y1.origin), e.protocol === l.protocol && e.host === l.host && (t || e.port === l.port)))(
  new URL(Y1.origin),
  Y1.navigator && /(msie|trident)/i.test(Y1.navigator.userAgent)
) : () => !0, Ut = Y1.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, l, r, n, o, i) {
      if (typeof document > "u") return;
      const q = [`${e}=${encodeURIComponent(t)}`];
      P.isNumber(l) && q.push(`expires=${new Date(l).toUTCString()}`), P.isString(r) && q.push(`path=${r}`), P.isString(n) && q.push(`domain=${n}`), o === !0 && q.push("secure"), P.isString(i) && q.push(`SameSite=${i}`), document.cookie = q.join("; ");
    },
    read(e) {
      if (typeof document > "u") return null;
      const t = document.cookie.split(";");
      for (let l = 0; l < t.length; l++) {
        const r = t[l].replace(/^\s+/, ""), n = r.indexOf("=");
        if (n !== -1 && r.slice(0, n) === e)
          try {
            return decodeURIComponent(r.slice(n + 1));
          } catch {
            return r.slice(n + 1);
          }
      }
      return null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5, "/");
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function $t(e) {
  return typeof e != "string" ? !1 : /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function Kt(e, t) {
  if (!t)
    return e;
  let l = e.length;
  for (; l > 0 && e.charCodeAt(l - 1) === 47; )
    l--;
  return e.slice(0, l) + "/" + t.replace(/^\/+/, "");
}
const Qt = /^https?:(?!\/\/)/i, el = /[\t\n\r]/g;
function tl(e) {
  let t = 0;
  for (; t < e.length && e.charCodeAt(t) <= 32; )
    t++;
  return e.slice(t);
}
function ll(e) {
  return tl(e).replace(el, "");
}
function nl(e) {
  return e && e.replace(/(^|&)([^=&]*=)?[^&]+/g, (t, l, r = "") => `${l}${r}${K2}`);
}
function rl(e) {
  const t = e.replace(/^(https?:\/{0,2})[^/?#]*@/i, `$1${K2}@`), l = t.indexOf("#"), n = (l === -1 ? t : t.slice(0, l)).replace(
    /([?&][^=&#]*=)[^&#]*/g,
    `$1${K2}`
  );
  return l === -1 ? n : `${n}#${nl(t.slice(l + 1))}`;
}
function S8(e, t) {
  if (typeof e == "string") {
    const l = ll(e);
    if (Qt.test(l))
      throw new c1(
        `Invalid URL ${JSON.stringify(rl(l))}: missing "//" after protocol`,
        c1.ERR_INVALID_URL,
        t
      );
  }
}
function _5(e, t, l, r) {
  S8(t, r);
  let n = !$t(t);
  return e && (n || l === !1) ? (S8(e, r), Kt(e, t)) : t;
}
const R8 = (e) => e instanceof Q1 ? { ...e } : e, ol = (e) => Object.getOwnPropertySymbols && Object.getOwnPropertyDescriptor ? Object.keys(e).concat(
  Object.getOwnPropertySymbols(e).filter(
    (t) => Object.getOwnPropertyDescriptor(e, t).enumerable
  )
) : Object.keys(e);
function F4(e, t) {
  e = e || {}, t = t || {};
  const l = /* @__PURE__ */ Object.create(null);
  Object.defineProperty(l, "hasOwnProperty", {
    // Null-proto descriptor so a polluted Object.prototype.get cannot turn
    // this data descriptor into an accessor descriptor on the way in.
    __proto__: null,
    value: Object.prototype.hasOwnProperty,
    enumerable: !1,
    writable: !0,
    configurable: !0
  });
  function r(c, u, _, A) {
    return P.isPlainObject(c) && P.isPlainObject(u) ? P.merge.call({ caseless: A }, c, u) : P.isPlainObject(u) ? P.merge({}, u) : P.isArray(u) ? u.slice() : u;
  }
  function n(c, u, _, A) {
    if (P.isUndefined(u)) {
      if (!P.isUndefined(c))
        return r(void 0, c, _, A);
    } else return r(c, u, _, A);
  }
  function o(c, u) {
    if (!P.isUndefined(u))
      return r(void 0, u);
  }
  function i(c, u) {
    if (P.isUndefined(u)) {
      if (!P.isUndefined(c))
        return r(void 0, c);
    } else return r(void 0, u);
  }
  function q(c) {
    const u = P.hasOwnProp(t, "transitional") ? t.transitional : void 0;
    if (!P.isUndefined(u))
      if (P.isPlainObject(u)) {
        if (P.hasOwnProp(u, c))
          return u[c];
      } else
        return;
    const _ = P.hasOwnProp(e, "transitional") ? e.transitional : void 0;
    if (P.isPlainObject(_) && P.hasOwnProp(_, c))
      return _[c];
  }
  function a(c, u, _) {
    if (P.hasOwnProp(t, _))
      return r(c, u);
    if (P.hasOwnProp(e, _))
      return r(void 0, c);
  }
  const s = {
    url: o,
    method: o,
    data: o,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    allowedSocketPaths: i,
    responseEncoding: i,
    validateStatus: a,
    headers: (c, u, _) => n(R8(c), R8(u), _, !0)
  };
  return P.forEach(ol({ ...e, ...t }), function(u) {
    if (u === "__proto__" || u === "constructor" || u === "prototype") return;
    const _ = P.hasOwnProp(s, u) ? s[u] : n, A = P.hasOwnProp(e, u) ? e[u] : void 0, v = P.hasOwnProp(t, u) ? t[u] : void 0, b = _(A, v, u);
    P.isUndefined(b) && _ !== a || (l[u] = b);
  }), P.hasOwnProp(t, "validateStatus") && P.isUndefined(t.validateStatus) && q("validateStatusUndefinedResolves") === !1 && (P.hasOwnProp(e, "validateStatus") ? l.validateStatus = r(void 0, e.validateStatus) : delete l.validateStatus), l;
}
const il = ["content-type", "content-length"];
function al(e, t, l) {
  if (l !== "content-only") {
    e.set(t);
    return;
  }
  Object.entries(t || {}).forEach(([r, n]) => {
    il.includes(r.toLowerCase()) && e.set(r, n);
  });
}
const ql = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (t, l) => String.fromCharCode(parseInt(l, 16))
);
function v5(e) {
  const t = F4({}, e), l = (_) => P.hasOwnProp(t, _) ? t[_] : void 0, r = l("data");
  let n = l("withXSRFToken");
  const o = l("xsrfHeaderName"), i = l("xsrfCookieName");
  let q = l("headers");
  const a = l("auth"), s = l("baseURL"), c = l("allowAbsoluteUrls"), u = l("url");
  if (t.headers = q = Q1.from(q), t.url = x5(
    _5(s, u, c, t),
    l("params"),
    l("paramsSerializer")
  ), a) {
    const _ = P.getSafeProp(a, "username") || "", A = P.getSafeProp(a, "password") || "";
    try {
      q.set(
        "Authorization",
        "Basic " + btoa(_ + ":" + (A ? ql(A) : ""))
      );
    } catch (v) {
      throw c1.from(v, c1.ERR_BAD_OPTION_VALUE, e);
    }
  }
  if (P.isFormData(r) && (Y1.hasStandardBrowserEnv || Y1.hasStandardBrowserWebWorkerEnv || P.isReactNative(r) ? q.setContentType(void 0) : P.isFunction(r.getHeaders) && al(q, r.getHeaders(), l("formDataHeaderPolicy"))), Y1.hasStandardBrowserEnv && (P.isFunction(n) && (n = n(t)), n === !0 || n == null && Jt(t.url))) {
    const A = o && i && Ut.read(i);
    A && q.set(o, A);
  }
  return t;
}
const sl = typeof XMLHttpRequest < "u", cl = sl && function(e) {
  return new Promise(function(l, r) {
    const n = v5(e);
    let o = n.data;
    const i = Q1.from(n.headers).normalize();
    let { responseType: q, onUploadProgress: a, onDownloadProgress: s } = n, c, u, _, A, v;
    function b() {
      A && A(), v && v(), n.cancelToken && n.cancelToken.unsubscribe(c), n.signal && n.signal.removeEventListener("abort", c);
    }
    let h = new XMLHttpRequest();
    h.open(n.method.toUpperCase(), n.url, !0), h.timeout = n.timeout;
    function d() {
      if (!h)
        return;
      const f = Q1.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), p = {
        data: !q || q === "text" || q === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: f,
        config: e,
        request: h
      };
      b5(
        function(w) {
          l(w), b();
        },
        function(w) {
          r(w), b();
        },
        p
      ), h = null;
    }
    "onloadend" in h ? h.onloadend = d : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.startsWith("file:")) || setTimeout(d);
    }, h.onabort = function() {
      h && (r(new c1("Request aborted", c1.ECONNABORTED, e, h)), b(), h = null);
    }, h.onerror = function(m) {
      const p = m && m.message ? m.message : "Network Error", I = new c1(p, c1.ERR_NETWORK, e, h);
      I.event = m || null, r(I), b(), h = null;
    }, h.ontimeout = function() {
      let m = n.timeout ? "timeout of " + n.timeout + "ms exceeded" : "timeout exceeded";
      const p = n.transitional || D6;
      n.timeoutErrorMessage && (m = n.timeoutErrorMessage), r(
        new c1(
          m,
          p.clarifyTimeoutError ? c1.ETIMEDOUT : c1.ECONNABORTED,
          e,
          h
        )
      ), b(), h = null;
    }, o === void 0 && i.setContentType(null), "setRequestHeader" in h && P.forEach(c5(i), function(m, p) {
      h.setRequestHeader(p, m);
    }), P.isUndefined(n.withCredentials) || (h.withCredentials = !!n.withCredentials), q && q !== "json" && (h.responseType = n.responseType), s && ([_, v] = Q2(s, !0), h.addEventListener("progress", _)), a && h.upload && ([u, A] = Q2(a), h.upload.addEventListener("progress", u), h.upload.addEventListener("loadend", A)), (n.cancelToken || n.signal) && (c = (f) => {
      h && (r(!f || f.type ? new v2(null, e, h) : f), h.abort(), b(), h = null);
    }, n.cancelToken && n.cancelToken.subscribe(c), n.signal && (n.signal.aborted ? c() : n.signal.addEventListener("abort", c)));
    const C = Xt(n.url);
    if (C && !Y1.protocols.includes(C)) {
      r(
        new c1(
          "Unsupported protocol " + C + ":",
          c1.ERR_BAD_REQUEST,
          e
        )
      ), b();
      return;
    }
    h.send(o || null);
  });
}, ul = (e, t) => {
  if (e = e ? e.filter(Boolean) : [], !t && !e.length)
    return;
  const l = new AbortController();
  let r = !1;
  const n = function(a) {
    if (!r) {
      r = !0, i();
      const s = a instanceof Error ? a : this.reason;
      l.abort(
        s instanceof c1 ? s : new v2(s instanceof Error ? s.message : s)
      );
    }
  };
  let o = t && setTimeout(() => {
    o = null, n(new c1(`timeout of ${t}ms exceeded`, c1.ETIMEDOUT));
  }, t);
  const i = () => {
    e && (o && clearTimeout(o), o = null, e.forEach((a) => {
      a.unsubscribe ? a.unsubscribe(n) : a.removeEventListener("abort", n);
    }), e = null);
  };
  e.forEach((a) => {
    if (!r) {
      if (a.aborted) {
        n.call(a);
        return;
      }
      a.addEventListener("abort", n, { once: !0 });
    }
  });
  const { signal: q } = l;
  return q.unsubscribe = () => P.asap(i), q;
}, ml = function* (e, t) {
  let l = e.byteLength;
  if (l < t) {
    yield e;
    return;
  }
  let r = 0, n;
  for (; r < l; )
    n = r + t, yield e.slice(r, n), r = n;
}, dl = async function* (e, t) {
  for await (const l of fl(e))
    yield* ml(l, t);
}, fl = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: l, value: r } = await t.read();
      if (l)
        break;
      yield r;
    }
  } finally {
    await t.cancel();
  }
}, O8 = (e, t, l, r) => {
  const n = dl(e, t);
  let o = 0, i, q = (a) => {
    i || (i = !0, r && r(a));
  };
  return new ReadableStream(
    {
      async pull(a) {
        try {
          const { done: s, value: c } = await n.next();
          if (s) {
            q(), a.close();
            return;
          }
          let u = c.byteLength;
          if (l) {
            let _ = o += u;
            l(_);
          }
          a.enqueue(new Uint8Array(c));
        } catch (s) {
          throw q(s), s;
        }
      },
      cancel(a) {
        return q(a), n.return();
      }
    },
    {
      highWaterMark: 2
    }
  );
}, T8 = (e) => e >= 48 && e <= 57 || e >= 65 && e <= 70 || e >= 97 && e <= 102, y5 = (e, t, l) => t + 2 < l && T8(e.charCodeAt(t + 1)) && T8(e.charCodeAt(t + 2)), w8 = (e) => e <= 57 ? e - 48 : (e & 223) - 55, xl = (e) => e >= 65 && e <= 90 || // A-Z
e >= 97 && e <= 122 || // a-z
e >= 48 && e <= 57 || // 0-9
e === 43 || // +
e === 47 || // /
e === 45 || // - (base64url)
e === 95, hl = (e) => e === 9 || e === 10 || e === 12 || e === 13 || e === 32, pl = (e) => {
  const t = Math.floor(e / 4), l = e % 4;
  return t * 3 + (l === 2 ? 1 : l === 3 ? 2 : 0);
}, gl = (e) => {
  const t = e.length;
  let l = 0;
  return t > 0 && e.charCodeAt(t - 1) === 61 && (l++, t > 1 && e.charCodeAt(t - 2) === 61 && l++), Math.floor((t - l) * 3 / 4);
}, bl = (e) => {
  const t = e.length;
  let l = 0, r = 0, n = !1;
  for (let o = 0; o < t; o++) {
    let i = e.charCodeAt(o);
    if (i === 37 && y5(e, o, t) && (i = w8(e.charCodeAt(o + 1)) * 16 + w8(e.charCodeAt(o + 2)), o += 2), !hl(i)) {
      if (i === 61) {
        r++;
        continue;
      }
      if (!xl(i) || r > 0) {
        n = !0;
        continue;
      }
      l++;
    }
  }
  return n || r > 2 || r > 0 && (l + r) % 4 !== 0 || l % 4 === 1 ? gl(e) : pl(l);
}, _l = (e, t) => {
  if (!e || typeof e != "string" || !e.startsWith("data:")) return 0;
  const l = e.indexOf(",");
  if (l < 0) return 0;
  const r = e.slice(5, l), n = e.slice(l + 1);
  if (/;base64/i.test(r))
    return t(n);
  let i = 0;
  for (let q = 0, a = n.length; q < a; q++) {
    const s = n.charCodeAt(q);
    if (s === 37 && y5(n, q, a))
      i += 1, q += 2;
    else if (s < 128)
      i += 1;
    else if (s < 2048)
      i += 2;
    else if (s >= 55296 && s <= 56319 && q + 1 < a) {
      const c = n.charCodeAt(q + 1);
      c >= 56320 && c <= 57343 ? (i += 4, q++) : i += 3;
    } else
      i += 3;
  }
  return i;
};
function vl(e) {
  const t = typeof e == "string" ? e.indexOf("#") : -1;
  return _l(
    t === -1 ? e : e.slice(0, t),
    bl
  );
}
const V6 = "1.19.0", z8 = 64 * 1024, { isFunction: S2 } = P, yl = (e) => encodeURIComponent(e).replace(
  /%([0-9A-F]{2})/gi,
  (t, l) => String.fromCharCode(parseInt(l, 16))
), N8 = (e) => {
  if (!P.isString(e))
    return e;
  try {
    return decodeURIComponent(e);
  } catch {
    return e;
  }
}, M8 = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, Il = (e) => {
  const t = e.indexOf("://");
  let l = e;
  return t !== -1 && (l = l.slice(t + 3)), l.includes("@") || l.includes(":");
}, Cl = (e) => {
  const t = P.global !== void 0 && P.global !== null ? P.global : globalThis, { ReadableStream: l, TextEncoder: r } = t;
  e = P.merge.call(
    {
      skipUndefined: !0
    },
    {
      Request: t.Request,
      Response: t.Response
    },
    e
  );
  const { fetch: n, Request: o, Response: i } = e, q = n ? S2(n) : typeof fetch == "function", a = S2(o), s = S2(i);
  if (!q)
    return !1;
  const c = q && S2(l), u = q && (typeof r == "function" ? /* @__PURE__ */ ((d) => (C) => d.encode(C))(new r()) : async (d) => new Uint8Array(await new o(d).arrayBuffer())), _ = a && c && M8(() => {
    let d = !1;
    const C = new o(Y1.origin, {
      body: new l(),
      method: "POST",
      get duplex() {
        return d = !0, "half";
      }
    }), f = C.headers.has("Content-Type");
    return C.body != null && C.body.cancel(), d && !f;
  }), A = s && c && M8(() => P.isReadableStream(new i("").body)), v = {
    stream: A && ((d) => d.body)
  };
  q && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((d) => {
    !v[d] && (v[d] = (C, f) => {
      let m = C && C[d];
      if (m)
        return m.call(C);
      throw new c1(
        `Response type '${d}' is not supported`,
        c1.ERR_NOT_SUPPORT,
        f
      );
    });
  });
  const b = async (d) => {
    if (d == null)
      return 0;
    if (P.isBlob(d))
      return d.size;
    if (P.isSpecCompliantForm(d))
      return (await new o(Y1.origin, {
        method: "POST",
        body: d
      }).arrayBuffer()).byteLength;
    if (P.isArrayBufferView(d) || P.isArrayBuffer(d))
      return d.byteLength;
    if (P.isURLSearchParams(d) && (d = d + ""), P.isString(d))
      return (await u(d)).byteLength;
  }, h = async (d, C) => {
    const f = P.toFiniteNumber(d.getContentLength());
    return f ?? b(C);
  };
  return async (d) => {
    let {
      url: C,
      method: f,
      data: m,
      signal: p,
      cancelToken: I,
      timeout: w,
      onDownloadProgress: T,
      onUploadProgress: L,
      responseType: j,
      headers: $,
      withCredentials: k = "same-origin",
      fetchOptions: t1,
      maxContentLength: e1,
      maxBodyLength: Q
    } = v5(d);
    const Z = P.isNumber(e1) && e1 > -1, X = P.isNumber(Q) && Q > -1, G = (g) => P.hasOwnProp(d, g) ? d[g] : void 0;
    let a1 = n || fetch;
    j = j ? (j + "").toLowerCase() : "text";
    let F = ul(
      [p, I && I.toAbortSignal()],
      w
    ), M = null;
    const H = F && F.unsubscribe && (() => {
      F.unsubscribe();
    });
    let W, S = null;
    const E = () => new c1(
      "Request body larger than maxBodyLength limit",
      c1.ERR_BAD_REQUEST,
      d,
      M
    );
    try {
      let g;
      const x = G("auth");
      if (x) {
        const N = P.getSafeProp(x, "username") || "", D = P.getSafeProp(x, "password") || "";
        g = {
          username: N,
          password: D
        };
      }
      if (Il(C)) {
        const N = new URL(C, Y1.origin);
        if (!g && (N.username || N.password)) {
          const D = N8(N.username), O = N8(N.password);
          g = {
            username: D,
            password: O
          };
        }
        (N.username || N.password) && (N.username = "", N.password = "", C = N.href);
      }
      if (g && ($.delete("authorization"), $.set(
        "Authorization",
        "Basic " + btoa(yl((g.username || "") + ":" + (g.password || "")))
      )), Z && typeof C == "string" && C.startsWith("data:") && vl(C) > e1)
        throw new c1(
          "maxContentLength size of " + e1 + " exceeded",
          c1.ERR_BAD_RESPONSE,
          d,
          M
        );
      if (X && f !== "get" && f !== "head") {
        const N = await b(m);
        if (typeof N == "number" && isFinite(N) && (W = N, N > Q))
          throw E();
      }
      const R = X && (P.isReadableStream(m) || P.isStream(m)), Y = (N, D, O) => O8(
        N,
        z8,
        (y) => {
          if (X && y > Q)
            throw S = E();
          D && D(y);
        },
        O
      );
      if (_ && f !== "get" && f !== "head" && (L || R)) {
        if (W = W ?? await h($, m), W !== 0 || R) {
          let N = new o(C, {
            method: "POST",
            body: m,
            duplex: "half"
          }), D;
          if (P.isFormData(m) && (D = N.headers.get("content-type")) && $.setContentType(D), N.body) {
            const [O, y] = L && E8(
              W,
              Q2(A8(L))
            ) || [];
            m = Y(N.body, O, y);
          }
        }
      } else if (R && !a && c && f !== "get" && f !== "head")
        m = Y(m);
      else if (R && a && !_ && f !== "get" && f !== "head")
        throw new c1(
          "Stream request bodies are not supported by the current fetch implementation",
          c1.ERR_NOT_SUPPORT,
          d,
          M
        );
      P.isString(k) || (k = k ? "include" : "omit");
      const B = a && "credentials" in o.prototype;
      if (P.isFormData(m)) {
        const N = $.getContentType();
        N && /^multipart\/form-data/i.test(N) && !/boundary=/i.test(N) && $.delete("content-type");
      }
      $.set("User-Agent", "axios/" + V6, !1);
      const K = {
        ...t1,
        signal: F,
        method: f.toUpperCase(),
        headers: c5($.normalize()),
        body: m,
        duplex: "half",
        credentials: B ? k : void 0
      };
      M = a && new o(C, K);
      let z = await (a ? a1(M, t1) : a1(C, K));
      const l1 = Q1.from(z.headers);
      if (Z) {
        const N = P.toFiniteNumber(l1.getContentLength());
        if (N != null && N > e1)
          throw new c1(
            "maxContentLength size of " + e1 + " exceeded",
            c1.ERR_BAD_RESPONSE,
            d,
            M
          );
      }
      const U = A && (j === "stream" || j === "response");
      if (A && z.body && (T || Z || U && H)) {
        const N = {};
        ["status", "statusText", "headers"].forEach((y1) => {
          N[y1] = z[y1];
        });
        const D = P.toFiniteNumber(l1.getContentLength()), [O, y] = T && E8(
          D,
          Q2(A8(T), !0)
        ) || [];
        let n1 = 0;
        const i1 = (y1) => {
          if (Z && (n1 = y1, n1 > e1))
            throw new c1(
              "maxContentLength size of " + e1 + " exceeded",
              c1.ERR_BAD_RESPONSE,
              d,
              M
            );
          O && O(y1);
        };
        z = new i(
          O8(z.body, z8, i1, () => {
            y && y(), H && H();
          }),
          N
        );
      }
      j = j || "text";
      let J = await v[P.findKey(v, j) || "text"](
        z,
        d
      );
      if (Z && !A && !U) {
        let N;
        if (J != null && (typeof J.byteLength == "number" ? N = J.byteLength : typeof J.size == "number" ? N = J.size : typeof J == "string" && (N = typeof r == "function" ? new r().encode(J).byteLength : J.length)), typeof N == "number" && N > e1)
          throw new c1(
            "maxContentLength size of " + e1 + " exceeded",
            c1.ERR_BAD_RESPONSE,
            d,
            M
          );
      }
      return !U && H && H(), await new Promise((N, D) => {
        b5(N, D, {
          data: J,
          headers: Q1.from(z.headers),
          status: z.status,
          statusText: z.statusText,
          config: d,
          request: M
        });
      });
    } catch (g) {
      if (H && H(), F && F.aborted && F.reason instanceof c1) {
        const x = F.reason;
        throw x.config = d, M && (x.request = M), g !== x && Object.defineProperty(x, "cause", {
          __proto__: null,
          value: g,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), x;
      }
      if (S)
        throw M && !S.request && (S.request = M), S;
      if (g instanceof c1)
        throw M && !g.request && (g.request = M), g;
      if (g && g.name === "TypeError" && /Load failed|fetch/i.test(g.message)) {
        const x = new c1(
          "Network Error",
          c1.ERR_NETWORK,
          d,
          M,
          g && g.response
        );
        throw Object.defineProperty(x, "cause", {
          __proto__: null,
          value: g.cause || g,
          writable: !0,
          enumerable: !1,
          configurable: !0
        }), x;
      }
      throw c1.from(g, g && g.code, d, M, g && g.response);
    }
  };
}, El = /* @__PURE__ */ new Map(), I5 = (e) => {
  let t = e && e.env || {};
  const { fetch: l, Request: r, Response: n } = t, o = [r, n, l];
  let i = o.length, q = i, a, s, c = El;
  for (; q--; )
    a = o[q], s = c.get(a), s === void 0 && c.set(a, s = q ? /* @__PURE__ */ new Map() : Cl(t)), c = s;
  return s;
};
I5();
const H6 = {
  http: Tt,
  xhr: cl,
  fetch: {
    get: I5
  }
};
P.forEach(H6, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { __proto__: null, value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { __proto__: null, value: t });
  }
});
const P8 = (e) => `- ${e}`, Al = (e) => P.isFunction(e) || e === null || e === !1;
function Sl(e, t) {
  e = P.isArray(e) ? e : [e];
  const { length: l } = e;
  let r, n;
  const o = {};
  for (let i = 0; i < l; i++) {
    r = e[i];
    let q;
    if (n = r, !Al(r) && (n = H6[(q = String(r)).toLowerCase()], n === void 0))
      throw new c1(`Unknown adapter '${q}'`);
    if (n && (P.isFunction(n) || (n = n.get(t))))
      break;
    o[q || "#" + i] = n;
  }
  if (!n) {
    const i = Object.entries(o).map(
      ([a, s]) => `adapter ${a} ` + (s === !1 ? "is not supported by the environment" : "is not available in the build")
    );
    let q = l ? i.length > 1 ? `since :
` + i.map(P8).join(`
`) : " " + P8(i[0]) : "as no adapter specified";
    throw new c1(
      "There is no suitable adapter to dispatch the request " + q,
      c1.ERR_NOT_SUPPORT
    );
  }
  return n;
}
const C5 = {
  /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */
  getAdapter: Sl,
  /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */
  adapters: H6
};
function M3(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new v2(null, e);
}
function P3(e) {
  return M3(e), e.headers = Q1.from(e.headers), e.data = N3.call(e, e.transformRequest), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), C5.getAdapter(e.adapter || _2.adapter, e)(e).then(
    function(r) {
      M3(e), e.response = r;
      try {
        r.data = N3.call(e, e.transformResponse, r);
      } finally {
        delete e.response;
      }
      return r.headers = Q1.from(r.headers), r;
    },
    function(r) {
      if (!g5(r) && (M3(e), r && r.response)) {
        e.response = r.response;
        try {
          r.response.data = N3.call(
            e,
            e.transformResponse,
            r.response
          );
        } finally {
          delete e.response;
        }
        r.response.headers = Q1.from(r.response.headers);
      }
      return Promise.reject(r);
    }
  );
}
const d3 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  d3[e] = function(r) {
    return typeof r === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const L8 = {};
d3.transitional = function(t, l, r) {
  function n(o, i) {
    return "[Axios v" + V6 + "] Transitional option '" + o + "'" + i + (r ? ". " + r : "");
  }
  return (o, i, q) => {
    if (t === !1)
      throw new c1(
        n(i, " has been removed" + (l ? " in " + l : "")),
        c1.ERR_DEPRECATED
      );
    return l && !L8[i] && (L8[i] = !0, console.warn(
      n(
        i,
        " has been deprecated since v" + l + " and will be removed in the near future"
      )
    )), t ? t(o, i, q) : !0;
  };
};
d3.spelling = function(t) {
  return (l, r) => (console.warn(`${r} is likely a misspelling of ${t}`), !0);
};
function Rl(e, t, l) {
  if (typeof e != "object" || e === null)
    throw new c1("options must be an object", c1.ERR_BAD_OPTION_VALUE);
  const r = Object.keys(e);
  let n = r.length;
  for (; n-- > 0; ) {
    const o = r[n], i = Object.prototype.hasOwnProperty.call(t, o) ? t[o] : void 0;
    if (i) {
      const q = e[o], a = q === void 0 || i(q, o, e);
      if (a !== !0)
        throw new c1(
          "option " + o + " must be " + a,
          c1.ERR_BAD_OPTION_VALUE
        );
      continue;
    }
    if (l !== !0)
      throw new c1("Unknown option " + o, c1.ERR_BAD_OPTION);
  }
}
const V2 = {
  assertOptions: Rl,
  validators: d3
}, $1 = V2.validators;
let z4 = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new I8(),
      response: new I8()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, l) {
    try {
      return await this._request(t, l);
    } catch (r) {
      if (r instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const o = (() => {
          if (!n.stack)
            return "";
          const i = n.stack.indexOf(`
`);
          return i === -1 ? "" : n.stack.slice(i + 1);
        })();
        try {
          if (!r.stack)
            r.stack = o;
          else if (o) {
            const i = o.indexOf(`
`), q = i === -1 ? -1 : o.indexOf(`
`, i + 1), a = q === -1 ? "" : o.slice(q + 1);
            String(r.stack).endsWith(a) || (r.stack += `
` + o);
          }
        } catch {
        }
      }
      throw r;
    }
  }
  _request(t, l) {
    typeof t == "string" ? (l = l || {}, l.url = t) : l = t || {}, l = F4(this.defaults, l);
    const { transitional: r, paramsSerializer: n, headers: o } = l;
    r !== void 0 && V2.assertOptions(
      r,
      {
        silentJSONParsing: $1.transitional($1.boolean),
        forcedJSONParsing: $1.transitional($1.boolean),
        clarifyTimeoutError: $1.transitional($1.boolean),
        legacyInterceptorReqResOrdering: $1.transitional($1.boolean),
        advertiseZstdAcceptEncoding: $1.transitional($1.boolean),
        validateStatusUndefinedResolves: $1.transitional($1.boolean)
      },
      !1
    ), n != null && (P.isFunction(n) ? l.paramsSerializer = {
      serialize: n
    } : V2.assertOptions(
      n,
      {
        encode: $1.function,
        serialize: $1.function
      },
      !0
    )), l.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? l.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : l.allowAbsoluteUrls = !0), V2.assertOptions(
      l,
      {
        baseUrl: $1.spelling("baseURL"),
        withXsrfToken: $1.spelling("withXSRFToken")
      },
      !0
    ), l.method = (l.method || this.defaults.method || "get").toLowerCase();
    let i = o && P.merge(o.common, o[l.method]);
    o && P.forEach(["delete", "get", "head", "post", "put", "patch", "query", "common"], (v) => {
      delete o[v];
    }), l.headers = Q1.concat(i, o);
    const q = [];
    let a = !0;
    this.interceptors.request.forEach(function(b) {
      if (typeof b.runWhen == "function" && b.runWhen(l) === !1)
        return;
      a = a && b.synchronous;
      const h = l.transitional || D6;
      h && h.legacyInterceptorReqResOrdering ? q.unshift(b.fulfilled, b.rejected) : q.push(b.fulfilled, b.rejected);
    });
    const s = [];
    this.interceptors.response.forEach(function(b) {
      s.push(b.fulfilled, b.rejected);
    });
    let c, u = 0, _;
    if (!a) {
      const v = [P3.bind(this), void 0];
      for (v.unshift(...q), v.push(...s), _ = v.length, c = Promise.resolve(l); u < _; )
        c = c.then(v[u++], v[u++]);
      return c;
    }
    _ = q.length;
    let A = l;
    for (; u < _; ) {
      const v = q[u++], b = q[u++];
      try {
        A = v ? v(A) : A;
      } catch (h) {
        if (!b) {
          c = Promise.reject(h);
          break;
        }
        try {
          const d = b.call(this, h);
          P.isThenable(d) && (c = Promise.resolve(d).then(
            () => P3.call(this, A)
          ));
        } catch (d) {
          c = Promise.reject(d);
        }
        break;
      }
    }
    if (!c)
      try {
        c = P3.call(this, A);
      } catch (v) {
        c = Promise.reject(v);
      }
    for (u = 0, _ = s.length; u < _; )
      c = c.then(s[u++], s[u++]);
    return c;
  }
  getUri(t) {
    t = F4(this.defaults, t);
    const l = _5(t.baseURL, t.url, t.allowAbsoluteUrls, t);
    return x5(l, t.params, t.paramsSerializer);
  }
};
P.forEach(["delete", "get", "head", "options"], function(t) {
  z4.prototype[t] = function(l, r) {
    return this.request(
      F4(r || {}, {
        method: t,
        url: l,
        data: r && P.hasOwnProp(r, "data") ? r.data : void 0
      })
    );
  };
});
P.forEach(["post", "put", "patch", "query"], function(t) {
  function l(r) {
    return function(o, i, q) {
      return this.request(
        F4(q || {}, {
          method: t,
          headers: r ? {
            "Content-Type": "multipart/form-data"
          } : {},
          url: o,
          data: i
        })
      );
    };
  }
  z4.prototype[t] = l(), t !== "query" && (z4.prototype[t + "Form"] = l(!0));
});
let Ol = class E5 {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let l;
    this.promise = new Promise(function(o) {
      l = o;
    });
    const r = this;
    this.promise.then((n) => {
      if (!r._listeners) return;
      let o = r._listeners.length;
      for (; o-- > 0; )
        r._listeners[o](n);
      r._listeners = null;
    }), this.promise.then = (n) => {
      let o;
      const i = new Promise((q) => {
        r.subscribe(q), o = q;
      }).then(n);
      return i.cancel = function() {
        r.unsubscribe(o);
      }, i;
    }, t(function(o, i, q) {
      r.reason || (r.reason = new v2(o, i, q), l(r.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const l = this._listeners.indexOf(t);
    l !== -1 && this._listeners.splice(l, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), l = (r) => {
      t.abort(r);
    };
    return this.subscribe(l), t.signal.unsubscribe = () => this.unsubscribe(l), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new E5(function(n) {
        t = n;
      }),
      cancel: t
    };
  }
};
function Tl(e) {
  return function(l) {
    return e.apply(null, l);
  };
}
function wl(e) {
  return P.isObject(e) && e.isAxiosError === !0;
}
const i6 = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511,
  WebServerReturnsAnUnknownError: 520,
  WebServerIsDown: 521,
  ConnectionTimedOut: 522,
  OriginIsUnreachable: 523,
  TimeoutOccurred: 524,
  SslHandshakeFailed: 525,
  InvalidSslCertificate: 526
};
Object.entries(i6).forEach(([e, t]) => {
  i6[t] = e;
});
function A5(e) {
  const t = new z4(e), l = t5(z4.prototype.request, t);
  return P.extend(l, z4.prototype, t, { allOwnKeys: !0 }), P.extend(l, t, null, { allOwnKeys: !0 }), l.create = function(n) {
    return A5(F4(e, n));
  }, l;
}
const k1 = A5(_2);
k1.Axios = z4;
k1.CanceledError = v2;
k1.CancelToken = Ol;
k1.isCancel = g5;
k1.VERSION = V6;
k1.toFormData = m3;
k1.AxiosError = c1;
k1.Cancel = k1.CanceledError;
k1.all = function(t) {
  return Promise.all(t);
};
k1.spread = Tl;
k1.isAxiosError = wl;
k1.mergeConfig = F4;
k1.AxiosHeaders = Q1;
k1.formToJSON = (e) => p5(P.isHTMLForm(e) ? new FormData(e) : e);
k1.getAdapter = C5.getAdapter;
k1.HttpStatusCode = i6;
k1.default = k1;
const {
  Axios: oc,
  AxiosError: ic,
  CanceledError: ac,
  isCancel: qc,
  CancelToken: sc,
  VERSION: cc,
  all: uc,
  Cancel: mc,
  isAxiosError: dc,
  spread: fc,
  toFormData: xc,
  AxiosHeaders: hc,
  HttpStatusCode: pc,
  formToJSON: gc,
  getAdapter: bc,
  mergeConfig: _c,
  create: vc
} = k1, zl = (e) => ({
  getMapData: () => new Promise((i, q) => {
    e("/v1/mapit2/data").then((a) => {
      var c, u;
      const s = [];
      if ((c = a == null ? void 0 : a.data) != null && c.items)
        for (const _ of (u = a == null ? void 0 : a.data) == null ? void 0 : u.items)
          s.push({
            id: _.id,
            retailer_id: _.retailer_id,
            kiosk_id: _.kiosk_id,
            map_obj_name: _.map_obj_name,
            obj_type: _.obj_type,
            layer_type: _.layer_type,
            value: _.value,
            custom_text: _.custom_text,
            custom_image: _.custom_image,
            bg_color: _.bg_color,
            transparent: _.transparent,
            text_color: _.text_color,
            size: parseInt(_.size),
            rotate: parseInt(_.rotate),
            offset_x: parseInt(_.offset_x),
            offset_y: parseInt(_.offset_y),
            lock_size: !1
          });
      i(s);
    }).catch((a) => {
      console.error("Error mapApiService:getMapData()", a), i([]);
    });
  }),
  getMapFloors: (i) => new Promise((q, a) => {
    e.get("/v1/mapit2/floors", {
      params: {
        limit: 100,
        offset: 0,
        ...i.CENTER_ID ? { center_id: i.CENTER_ID } : {}
      }
    }).then(async (s) => {
      var u, _;
      const c = [];
      if ((u = s == null ? void 0 : s.data) != null && u.items) {
        const A = async (v) => {
          try {
            return (await fetch(v, { method: "HEAD" })).ok;
          } catch {
            try {
              return (await fetch(v, { method: "GET" })).ok;
            } catch {
              return !1;
            }
          }
        };
        for (const v of (_ = s == null ? void 0 : s.data) == null ? void 0 : _.items)
          await A(J2(v.svg, i)) && c.push({
            id: v.id,
            name: v.title,
            svgUrl: v.svg
          });
      }
      q(c);
    }).catch((s) => {
      console.error("Error mapApiService:getMapFloors()", s), q([]);
    });
  }),
  getMapKiosks: () => new Promise((i, q) => {
    e("/v1/display_kiosks?limit=100&page=1&display_type_id=1").then((a) => {
      var c, u;
      const s = [];
      if ((c = a == null ? void 0 : a.data) != null && c.items)
        for (const _ of (u = a == null ? void 0 : a.data) == null ? void 0 : u.items)
          s.push({
            id: _.id,
            name: _.title
          });
      i(s);
    }).catch((a) => {
      console.error("Error mapApiService:getMapKiosks()", a), i([]);
    });
  }),
  getMapSettings: () => new Promise((i, q) => {
    e("/v1/mapit2/settings").then((a) => {
      var _, A;
      const s = { ...y4 };
      let c = H1;
      (_ = a == null ? void 0 : a.data) != null && _.settings && (c = (A = a == null ? void 0 : a.data) == null ? void 0 : A.settings, c.MAP_BACKGROUND_COLOR && (s.MAP_BACKGROUND_COLOR = P1(c.MAP_BACKGROUND_COLOR)), c.STORE_DEFAULT_COLOR && (s.STORE_DEFAULT_COLOR = P1(c.STORE_DEFAULT_COLOR)), c.ACCENT_COLOR && (s.ACCENT_COLOR = P1(c.ACCENT_COLOR)), c.BASE_COLOR && (s.BASE_COLOR = P1(c.BASE_COLOR)), c.BOUNDARY_COLOR && (s.BOUNDARY_COLOR = P1(c.BOUNDARY_COLOR)), c.BASE_COLOR && (s.BASE_COLOR = P1(c.BASE_COLOR)), c.WALL_COLOR && (s.WALL_COLOR = P1(c.WALL_COLOR)), c.STORE_TEXT_COLOR && (s.STORE_TEXT_COLOR = P1(c.STORE_TEXT_COLOR)), c.OVERLAY_COLOR && (s.OVERLAY_COLOR = P1(c.OVERLAY_COLOR)), c.BOUNDARY_THICKNESS && (s.BOUNDARY_THICKNESS = c.BOUNDARY_THICKNESS), c.WALL_THICKNESS && (s.WALL_THICKNESS = c.WALL_THICKNESS), c.OVERLAY_OPACITY && (s.OVERLAY_OPACITY = c.OVERLAY_OPACITY), c.KIOSK_SIZE && (s.KIOSK_SIZE = c.KIOSK_SIZE), c.ZOOM_STEP && (s.ZOOM_STEP = c.ZOOM_STEP), c.SELECTED_ZOOM_LIMIT && (s.SELECTED_ZOOM_LIMIT = c.SELECTED_ZOOM_LIMIT), s.CAMERA.minDistance = c.CAMERA_MIN_DISTANCE ? c.CAMERA_MIN_DISTANCE : s.CAMERA.minDistance, s.CAMERA.maxDistance = c.CAMERA_MAX_DISTANCE ? c.CAMERA_MAX_DISTANCE : s.CAMERA.maxDistance, s.CAMERA = { ...s.CAMERA });
      const u = { ...s };
      delete u.DEVICE, delete u.HOST, delete u.PARKING_LINE_COLOR, delete u.PARKING_ICON_COLOR, delete u.PARKING_LANE_COLOR, delete u.GREEN_AREA_COLOR, delete u.WATER_AREA_COLOR, delete u.PARKING_LINE_THICKNESS, i({
        apiResponse: c,
        responseConfig: u
      });
    }).catch((a) => {
      console.error("Error mapApiService:getMapSettings()", a);
      const { DEVICE: s, HOST: c, PARKING_LINE_COLOR: u, PARKING_ICON_COLOR: _, PARKING_LANE_COLOR: A, GREEN_AREA_COLOR: v, WATER_AREA_COLOR: b, PARKING_LINE_THICKNESS: h, ...d } = y4;
      i({
        apiResponse: H1,
        responseConfig: d
      });
    });
  }),
  getMapResponsiveSettings: () => new Promise((i, q) => {
    e("/v1/mapit2/responsive").then((a) => {
      const s = { ...y4.CAMERA_CONTROLS_STATES };
      if (a.data)
        if (Array.isArray(a.data)) {
          s.perFloor = s.perFloor || {};
          for (const c of a.data)
            s.perFloor[c.floor_id] = c, s.perFloor[c.floor_id].display_app = c.display_app || JSON.parse(JSON.stringify(x4)), s.perFloor[c.floor_id].desktop = c.desktop || JSON.parse(JSON.stringify(x4)), s.perFloor[c.floor_id].tablet = c.tablet || JSON.parse(JSON.stringify(x4)), s.perFloor[c.floor_id].mobile = c.mobile || JSON.parse(JSON.stringify(x4));
        } else
          a.data.display_app && (s.display_app = a.data.display_app), a.data.desktop && (s.desktop = a.data.desktop), a.data.tablet && (s.tablet = a.data.tablet), a.data.mobile && (s.mobile = a.data.mobile), a.data.perFloor && (s.perFloor = a.data.perFloor);
      i(s);
    }).catch((a) => {
      console.error("Error mapApiService:getMapResponsiveSettings()", a), i({ ...y4.CAMERA_CONTROLS_STATES });
    });
  })
}), Nl = (e) => ({
  getAllRetailers: () => new Promise((r, n) => {
    let o = [];
    const i = (q = 1) => {
      e(`/v1/retailers?limit=100&page=${q}`).then((a) => {
        var s, c;
        if ((s = a == null ? void 0 : a.data) != null && s.items)
          if (o = [...o, ...a.data.items], a.data.count > o.length)
            i(q + 1);
          else {
            const u = [], _ = [];
            for (const A of o) {
              const v = {
                id: A.id,
                location: A.location,
                retailer_phone: A.retailer_phone,
                map_obj_name: ""
              };
              A.global_retailer ? (v.global_retailer_id = A.global_retailer.id, v.retail_name = A.global_retailer.name, v.slug = A.global_retailer.slug, v.retailer_description = A.global_retailer.description, v.logo = ((c = A.global_retailer.media) == null ? void 0 : c.url) || "") : (v.global_retailer_id = A.global_retailer_id, v.retail_name = A.name, v.slug = A.slug, v.retailer_description = A.description, v.logo = A.media.url || ""), u.push(v), v.global_retailer_id && _.push(v.global_retailer_id);
            }
            u.sort((A, v) => {
              const b = (A.retail_name || "").toLowerCase(), h = (v.retail_name || "").toLowerCase();
              return b < h ? -1 : b > h ? 1 : 0;
            }), r({ retailers: u, globalRetailerIds: _ });
          }
      }).catch((a) => {
        console.error("Error fetching retailers", a), r({ retailers: [], globalRetailerIds: [] });
      });
    };
    i();
  }),
  getRetailer: (r) => new Promise((n, o) => {
    e(`/v1/retailers/${r}`).then((i) => {
      var q;
      if ((q = i == null ? void 0 : i.data) != null && q.id) {
        const a = i == null ? void 0 : i.data, s = {
          id: a.id,
          global_retailer_id: a.global_retailer_id,
          retail_name: a.name,
          slug: a.slug,
          retailer_description: a.description,
          location: a.location,
          retailer_phone: a.retailer_phone,
          logo: a.media.url || "",
          map_obj_name: "",
          opening_hours: a.opening_hours
        };
        n(s);
      }
    }).catch((i) => {
      console.error("Error fetching retailers", i), o(i);
    });
  })
}), Ml = (e, t) => {
  const l = {
    baseURL: e,
    timeout: 3e4,
    // Set the request timeout in milliseconds
    withCredentials: !0,
    headers: {
      "Content-Type": "application/json"
    },
    // Always send center_id when set so admin-portal-backend (and Storybook)
    // can scope mapit2/retailers; public APIs ignore the extra query param.
    params: t.CENTER_ID ? {
      center_id: t.CENTER_ID
    } : void 0
  }, r = k1.create(l);
  r.interceptors.response.use(
    (i) => i,
    (i) => {
      console.error("Axios Interceptor Error: ", i.response);
    }
  );
  const n = zl(r), o = Nl(r);
  return {
    mapApiService: n,
    retailersService: o
  };
}, S5 = C6(void 0), Pl = ({ children: e, initialData: t, mapApiResponseRef: l, cachedMapApiResponse: r, onNewMapApiResponse: n = void 0, rerenderMapOnNewMapApiResponse: o = !1 }) => {
  const i = t.webApiBaseUrl, [q, a] = m1(!1), [s, c] = m1(
    R3({ ...y4, ...t.config })
  ), [u, _] = m1({
    retailers: [],
    globalRetailerIds: [],
    floors: [],
    kiosks: [],
    map_objs: [],
    mapSettings: { apiResponse: H1, responseConfig: {} },
    responsiveSettings: y4.CAMERA_CONTROLS_STATES
  });
  l && (l.current = u), g1(() => {
    r && _(r);
  }, [r]);
  const A = r != null, [v, b] = m1(/* @__PURE__ */ new Map()), [h, d] = m1([]), [C, f] = m1({}), [m, p] = m1({}), [I, w] = m1({}), [T, L] = m1([]), [j, $] = m1({}), [k, t1] = m1(Qe()), [e1, Q] = m1(v0), [Z, X] = m1(null), [G, a1] = m1(), F = j1(() => Ml(i, s), [i, s.CENTER_ID]);
  g1(() => {
    c((W) => R3({ ...W, ...t.config }));
  }, [t.config, t.config.CENTER_ID]);
  const M = o1(() => {
    s.CENTER_ID > 0 && Promise.all([
      F.retailersService.getAllRetailers(),
      F.mapApiService.getMapData(),
      F.mapApiService.getMapFloors(s),
      F.mapApiService.getMapKiosks(),
      F.mapApiService.getMapSettings(),
      F.mapApiService.getMapResponsiveSettings()
    ]).then(([
      { retailers: W, globalRetailerIds: S },
      E,
      g,
      x,
      R,
      Y
    ]) => {
      const B = E.map((z) => z.map_obj_name);
      E = E.filter((z, l1) => B.indexOf(z.map_obj_name) === l1);
      const K = {
        retailers: W,
        globalRetailerIds: S,
        map_objs: E,
        floors: g,
        kiosks: x,
        mapSettings: R,
        responsiveSettings: Y
      };
      (o || !A) && _(K), n && n(K);
    }).catch((W) => {
      console.error("Error: MapBoxContextProvider fetching api data:", W), a(!0);
    });
  }, [F, s.CENTER_ID, o, A, n]);
  g1(() => {
    c((W) => R3({
      ...W,
      ...u.mapSettings.responseConfig,
      CAMERA_CONTROLS_STATES: u.responsiveSettings,
      CENTER_ID: t.config.CENTER_ID || W.CENTER_ID,
      KIOSK_ID: t.config.KIOSK_ID || W.KIOSK_ID,
      SELECTED_RETAILER_ID: t.config.SELECTED_RETAILER_ID || W.SELECTED_RETAILER_ID
    })), p(u.retailers.reduce(
      (W, S) => (W[S.id] = S, W),
      {}
    )), w(u.kiosks.reduce(
      (W, S) => {
        W[S.id] = S;
        const E = u.map_objs.find((g) => g.kiosk_id === S.id);
        return E && (W[S.id].map_obj_name = E.map_obj_name), W;
      },
      {}
    )), f(u.map_objs.reduce(
      (W, S) => (W[S.map_obj_name] = { ...G2, ...S }, W),
      {}
    )), L(u.floors.map((W) => {
      const S = new ge();
      return S.scale.y *= -1, S.lookAt(0, 1, 0), {
        ...W,
        objsGroup: S,
        interactiveObjs: [],
        escalatorsObjs: [],
        escalatorsNodes: {},
        escalatorMeshes: [],
        route_points: [],
        route_tube: void 0,
        route_texture: null,
        routeMeshes: [],
        route_active: !1
      };
    })), a(!0);
  }, [u]), g1(() => {
    A || a(!1), M();
  }, [M, A]);
  const H = {
    refetchMapData: M,
    apiServices: F,
    initialFloorsDataIsLoaded: q,
    setInitialFloorsDataIsLoaded: a,
    mapConfig: s,
    setMapConfig: c,
    mapApiResponse: u,
    setMapApiResponse: _,
    meshByObjectId: v,
    setMeshByObjectId: b,
    allMapObjects: h,
    setAllMapObjects: d,
    allIndexedMapObjects: C,
    setAllIndexedMapObjects: f,
    allIndexedRetailers: m,
    setAllIndexedRetailers: p,
    indexedKiosks: I,
    setIndexedKiosks: w,
    floorsData: T,
    setFloorsData: L,
    allNodesFloor: j,
    setAllNodesFloor: $,
    pathFinderGraph: k,
    setPathFinderGraph: t1,
    ngraphPath: e1,
    setNgraphPath: Q,
    meshObject: Z,
    setMeshObject: X,
    cameraLength: G,
    setCameraLength: a1
  };
  return q ? T.length <= 0 ? /* @__PURE__ */ V("div", { className: "eyeon-map-status", children: "Map doesn't have any floors" }) : /* @__PURE__ */ V(S5.Provider, { value: H, children: e }) : /* @__PURE__ */ V("div", { className: "eyeon-map-status", children: "Map loading, please wait..." });
};
function o4() {
  const e = e4(S5);
  if (e === void 0)
    throw new Error("useMapBoxContext must be used within MapBoxContextProvider");
  return e;
}
const Ll = (e, t) => {
  const l = e[0].index !== null, r = new Set(Object.keys(e[0].attributes)), n = new Set(Object.keys(e[0].morphAttributes)), o = {}, i = {}, q = e[0].morphTargetsRelative, a = new R6();
  if (e.forEach((s, c) => {
    let u = 0;
    if (l !== (s.index !== null))
      return console.error(
        "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them."
      ), null;
    for (let _ in s.attributes) {
      if (!r.has(_))
        return console.error(
          "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + '. All geometries must have compatible attributes; make sure "' + _ + '" attribute exists among all geometries, or in none of them.'
        ), null;
      o[_] === void 0 && (o[_] = []), o[_].push(s.attributes[_]), u++;
    }
    if (u !== r.size)
      return console.error(
        "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". Make sure all geometries have the same number of attributes."
      ), null;
    if (q !== s.morphTargetsRelative)
      return console.error(
        "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ". .morphTargetsRelative must be consistent throughout all geometries."
      ), null;
    for (let _ in s.morphAttributes) {
      if (!n.has(_))
        return console.error(
          "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + c + ".  .morphAttributes must be consistent throughout all geometries."
        ), null;
      i[_] === void 0 && (i[_] = []), i[_].push(s.morphAttributes[_]);
    }
    a.userData.mergedUserData = a.userData.mergedUserData || [], a.userData.mergedUserData.push(s.userData);
  }), l) {
    let s = 0;
    const c = [];
    e.forEach((u) => {
      const _ = u.index;
      for (let A = 0; A < _.count; ++A)
        c.push(_.getX(A) + s);
      s += u.attributes.position.count;
    }), a.setIndex(c);
  }
  for (let s in o) {
    const c = F8(o[s]);
    if (!c)
      return console.error(
        "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + s + " attribute."
      ), null;
    a.setAttribute(s, c);
  }
  for (let s in i) {
    const c = i[s][0].length;
    if (c === 0)
      break;
    a.morphAttributes = a.morphAttributes || {}, a.morphAttributes[s] = [];
    for (let u = 0; u < c; ++u) {
      const _ = [];
      for (let v = 0; v < i[s].length; ++v)
        _.push(i[s][v][u]);
      const A = F8(_);
      if (!A)
        return console.error(
          "THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + s + " morphAttribute."
        ), null;
      a.morphAttributes[s].push(A);
    }
  }
  return a;
}, F8 = (e) => {
  let t, l, r, n = 0;
  if (e.forEach((o) => {
    if (t === void 0 && (t = o.array.constructor), t !== o.array.constructor)
      return console.error(
        "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes."
      ), null;
    if (l === void 0 && (l = o.itemSize), l !== o.itemSize)
      return console.error(
        "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes."
      ), null;
    if (r === void 0 && (r = o.normalized), r !== o.normalized)
      return console.error(
        "THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes."
      ), null;
    n += o.array.length;
  }), t && l) {
    const o = new t(n);
    let i = 0;
    return e.forEach((q) => {
      o.set(q.array, i), i += q.array.length;
    }), new be(o, l, r);
  }
};
class R5 extends O6 {
  constructor(t, l = {}) {
    const {
      bevelEnabled: r = !1,
      bevelSize: n = 8,
      bevelThickness: o = 10,
      font: i,
      height: q = 50,
      size: a = 100,
      lineHeight: s = 1,
      letterSpacing: c = 0,
      ...u
    } = l;
    if (i === void 0)
      super();
    else {
      const _ = i.generateShapes(t, a, { lineHeight: s, letterSpacing: c });
      super(_, { ...u, bevelEnabled: r, bevelSize: n, bevelThickness: o, depth: q });
    }
    this.type = "TextGeometry";
  }
}
function Fl(e, t = 3, l = 0) {
  let r = new X9(), n = new L1(e.v1.x, e.v1.y, 0), o = new L1(e.v2.x, e.v2.y, 0), i = o.clone().sub(n).normalize().multiplyScalar(-t * l), q = n.clone().add(i);
  i = n.clone().sub(o).normalize().multiplyScalar(-t * l);
  let a = o.clone().add(i), s = n.distanceTo(a);
  if (s === 0)
    return r;
  let c = {
    x: q.x - (o.y - q.y) * t / s,
    y: q.y - (q.x - o.x) * t / s
  }, u = {
    x: q.x + (o.y - q.y) * t / s,
    y: q.y + (q.x - o.x) * t / s
  }, _ = {
    x: a.x + (n.y - a.y) * t / s,
    y: a.y + (a.x - n.x) * t / s
  }, A = {
    x: a.x - (n.y - a.y) * t / s,
    y: a.y - (a.x - n.x) * t / s
  };
  return r.moveTo(c.x, c.y), r.lineTo(u.x, u.y), r.lineTo(A.x, A.y), r.lineTo(_.x, _.y), r;
}
function Bl(e, t, l, r = 0, n) {
  const o = "MaterialAndGeometry", i = [];
  if (e.subPaths.forEach((q) => {
    q.curves.forEach((a) => {
      if (a.type === "LineCurve") {
        const s = Fl(a, t, r);
        i.push(new O6(s, {
          depth: -l,
          bevelEnabled: !1
        }));
      } else n && console.warn(o + '"%s" found in line layer. Check layer "%s"', a.type, n);
    });
  }), i.length === 1)
    return i[0];
  if (i.length > 1)
    return Ll(i) ?? void 0;
  n && console.warn(o + 'Unneccessary line exists "%s"', n);
}
const W1 = {
  Entrance: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path fill="none" stroke="#444444" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" d="M8.25 3.75h8.25A3.5 3.5 0 0 1 20 7.25v9.5a3.5 3.5 0 0 1-3.5 3.5H8.25"/>
            <path fill="none" stroke="#444444" stroke-width="2.25" stroke-linecap="round" stroke-linejoin="round" d="M3.5 12h12.35M12.2 7.85 16.4 12l-4.2 4.15"/>
          </svg>`,
  Kiosk: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 443.83 787.21">
            <path fill="#444444" d="M451,587.7V8.14H7.14V589.5H111.43V730.89H71.27L38.59,763.58v31.78H416.36V764.93l-34.05-34H345.78V587.7ZM396.91,71.23v452.7H59.85V71.23Z" transform="translate(-7.14 -8.14)" />
          </svg>`,
  Escalator: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 576 445.3">
                <path fill="#444444" d="M243.4,75.9c21.2,0,38.1-16.8,38.1-38S264.6,0,243.4,0c-21.2,0-38.1,16.8-38.1,38S222.1,75.9,243.4,75.9z M508.5,41.2h-88.7 c-18.5,0-41.9,7.6-56.1,21.7l-82.2,81.9V121c0-51-75.7-50.4-75.7,0v98.2l-71.3,71c-6.5,6.5-7.6,7.1-20.7,7.1H70.2 C26.1,297.2,0,336.8,0,369.9c0,33.6,26.1,75.4,74,75.4h77.9c18.5,0,40.8-7.1,58.8-24.4l228.1-226.7c4.9-4.3,7.6-5.4,15.8-5.4h56.1 c27.2,0,65.3-30.4,65.3-74.8C576.5,70.5,537.9,41.2,508.5,41.2z M504.7,150.8h-47.9c-20.1,0-29.4,2.7-41.4,14.7L185.7,394.3 c-9.3,9.2-21.2,13-36.5,13H73.5c-19.6,0-36.5-16.3-36.5-38c0-21.7,16.3-33.6,33.2-33.6H122c15.2,0,25-4.3,33.7-13L389.3,90 c9.8-9.8,19.1-10.9,35.4-10.9h80c19.6,0,32.7,21.7,32.7,34.7C537.9,126.4,528.6,150.8,504.7,150.8z" />
              </svg>`,
  EscalatorUp: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 576 445.3">
                <path fill="#444444" d="M243.4,75.9c21.2,0,38.1-16.8,38.1-38S264.6,0,243.4,0c-21.2,0-38.1,16.8-38.1,38S222.1,75.9,243.4,75.9z M508.5,41.2h-88.7 c-18.5,0-41.9,7.6-56.1,21.7l-82.2,81.9V121c0-51-75.7-50.4-75.7,0v98.2l-71.3,71c-6.5,6.5-7.6,7.1-20.7,7.1H70.2 C26.1,297.2,0,336.8,0,369.9c0,33.6,26.1,75.4,74,75.4h77.9c18.5,0,40.8-7.1,58.8-24.4l228.1-226.7c4.9-4.3,7.6-5.4,15.8-5.4h56.1 c27.2,0,65.3-30.4,65.3-74.8C576.5,70.5,537.9,41.2,508.5,41.2z M504.7,150.8h-47.9c-20.1,0-29.4,2.7-41.4,14.7L185.7,394.3 c-9.3,9.2-21.2,13-36.5,13H73.5c-19.6,0-36.5-16.3-36.5-38c0-21.7,16.3-33.6,33.2-33.6H122c15.2,0,25-4.3,33.7-13L389.3,90 c9.8-9.8,19.1-10.9,35.4-10.9h80c19.6,0,32.7,21.7,32.7,34.7C537.9,126.4,528.6,150.8,504.7,150.8z" />
                <path fill="#444444" d="M165.81,131.14l-56.28-74.94c-1.74-2.31-5.21-2.31-6.95,0l-56.28,74.94c-2.15,2.87-.1,6.97,3.49,6.95l41.87-.17v129.17c0,2.4,1.94,4.34,4.34,4.34h20.1c2.4,0,4.34-1.94,4.34-4.34v-129.17l41.87.17c3.59.01,5.64-4.08,3.49-6.95Z"/>
              </svg>`,
  EscalatorDown: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 576 445.3">
              <path fill="#444444" d="M243.4,75.9c21.2,0,38.1-16.8,38.1-38S264.6,0,243.4,0c-21.2,0-38.1,16.8-38.1,38S222.1,75.9,243.4,75.9z M508.5,41.2h-88.7 c-18.5,0-41.9,7.6-56.1,21.7l-82.2,81.9V121c0-51-75.7-50.4-75.7,0v98.2l-71.3,71c-6.5,6.5-7.6,7.1-20.7,7.1H70.2 C26.1,297.2,0,336.8,0,369.9c0,33.6,26.1,75.4,74,75.4h77.9c18.5,0,40.8-7.1,58.8-24.4l228.1-226.7c4.9-4.3,7.6-5.4,15.8-5.4h56.1 c27.2,0,65.3-30.4,65.3-74.8C576.5,70.5,537.9,41.2,508.5,41.2z M504.7,150.8h-47.9c-20.1,0-29.4,2.7-41.4,14.7L185.7,394.3 c-9.3,9.2-21.2,13-36.5,13H73.5c-19.6,0-36.5-16.3-36.5-38c0-21.7,16.3-33.6,33.2-33.6H122c15.2,0,25-4.3,33.7-13L389.3,90 c9.8-9.8,19.1-10.9,35.4-10.9h80c19.6,0,32.7,21.7,32.7,34.7C537.9,126.4,528.6,150.8,504.7,150.8z" />
              <path fill="#444444" d="M165.81,194.77l-56.28,74.94c-1.74,2.31-5.21,2.31-6.95,0l-56.28-74.94c-2.15-2.87-.1-6.97,3.49-6.95l41.87.17V58.81c0-2.4,1.94-4.34,4.34-4.34h20.1c2.4,0,4.34,1.94,4.34,4.34v129.17l41.87-.17c3.59-.01,5.64,4.08,3.49,6.95Z"/>
            </svg>`,
  ATM: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 577.8 577">
          <path fill="#444444" d="M388.7,314c-3.7-10.3-10.3-19.8-17.7-27.2c-7.4-7.4-17.7-14-29.5-19.1c-6.6-2.9-19.2-6.6-39.1-11.8V144.2 c13.3,2.2,22.8,8.1,30.2,16.2c7.4,8.1,11.8,19.9,14,35.3l39.8-5.9c-2.9-24.3-13.3-44.1-30.2-58.1c-13.3-11-31-17.7-53.8-19.8V93.4 h-24.3v18.4c-25.8,2.2-45,9.6-58.2,21.3c-19.9,17.7-29.5,39.7-29.5,67.6c0,15.5,3.7,29.4,10.3,41.9s16.2,22,28.7,28.7 c17,9.6,33.2,16.2,49.4,20.6v121.3c-14.8-1.5-28-8.8-39.1-22.8c-7.4-9.6-13.3-25-16.2-46.3l-39.1,7.4c1.5,20.6,6.6,37.5,15.5,51.5 s19.9,23.5,31.7,30.1c12.5,6.6,28,11,47.9,13.2v39v-0.1V483h22.1v-39c28-0.7,50.1-11,67.1-28.7c17-18.4,25.8-40.4,25.8-67.6 C394.6,336,392.4,324.3,388.7,314z M278.9,145.1v107.2c-17.7-5.2-30.2-11.8-37.6-20.6s-11.1-19.8-11.1-33.1c0-14,4.4-25.7,13.3-35.3 C252.2,153.9,263.7,147.4,278.9,145.1V145h0.7C279.3,145,279.1,145,278.9,145.1z M340,394.2c-9.6,11-22.1,18.4-37.6,19.8l0,0V297.9 c20.6,5.2,34.6,11.8,42,20.6c6.6,8.1,10.3,19.8,10.3,33.8C354.8,369.2,349.6,383.1,340,394.2z" />
          <path fill="#444444" d="M289.8,2.5c-158.7,0-288,128-288,287.2c0,158.3,129.3,287.2,288,287.2s288-128.9,288-287.2S448.6,2.5,289.8,2.5z M289.9,533.9C155,533.9,45.2,424.3,45.2,289.8C45.2,154.5,155,45.7,289.9,45.7s244.7,109.5,244.7,244.1S424.8,533.9,289.9,533.9z" />
        </svg>`,
  Management: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 576 414.6">
                  <path fill="#444444" d="M371.6,180.4c66.8,0,101,58.5,121.4,121.9l16.4,50.4c2.7,8.8-7.5,16.3-16.4,16.3h-56.6l-7.5-27.2 c-17.7-53.1-45-106.2-94.8-125.9c13-8.8,23.9-21.1,30.7-35.4C366.1,180.4,368.8,180.4,371.6,180.4z M441.2,145.7 c64.8,2,98.2,59.2,118.7,121.9l15.7,49.7c2.7,8.8-7.5,17.7-16.4,17.7h-35.5l-12.3-38.1c-16.4-53.1-44.3-106.2-94.8-125.9 C426.2,162.7,434.3,155.2,441.2,145.7z M51.6,334.3H16.8c-9.6,0-19.1-8.2-16.4-17.7l15.7-49.7C35.9,204.2,70.1,147.1,134.9,145 c6.1,9.5,15,18.4,24.6,24.5c-49.8,19.7-77.8,72.8-94.8,125.9L51.6,334.3L51.6,334.3z M437.7,0c35.5,0,64.8,28.6,64.8,64.7 c0,31.3-22.5,57.2-52.5,62.6c3.4-8.8,5.5-18.4,5.5-27.9c0-39.5-27.3-71.5-62.8-81C403.6,6.8,419.3,0,437.7,0L437.7,0z M137.6,0 c17.7,0,34.1,6.8,45,18.4c-35.5,9.5-62.8,41.5-62.8,81c0,9.5,2.1,19.1,5.5,27.9C96,121.9,72.8,96,72.8,64.7 C73.5,28.6,102.1,0,137.6,0L137.6,0z M287.7,0c19.8,0,37.5,8.8,49.8,22.5c-15.7,6.8-29.3,19.1-38.2,34l-3.4,5.5c-2.7,0-5.5,0-7.5,0 c-2,0-6.1,0-8.9,0l-3.4-5.5c-9.6-15-22.5-27.2-38.2-34C250.2,8.9,267.9,0,287.7,0L287.7,0z M287.7,226c66.8,0,101,58.5,122.1,121.9 l15.7,50.4c2.7,8.8-8.2,16.3-16.4,16.3H166.2c-9.6,0-19.8-8.2-16.4-16.3l15.7-50.4C186,284.6,220.8,226,287.7,226z M287.7,81 c35.5,0,64.8,28.6,64.8,64.7s-28.7,64.7-64.8,64.7c-35.5,0-64.8-28.6-64.8-64.7S252.2,81,287.7,81z M138.3,369H82.3 c-9.6,0-19.1-8.2-16.4-16.3l15.7-50.4c21.1-63.3,55.3-121.9,122.1-121.9c2.7,0,5.5,0,7.5,0c6.1,15,17.7,27.2,30.7,35.4 c-49.8,19.7-78.5,72.8-94.8,125.9C147.1,341.8,138.3,369,138.3,369z M203.8,34.7c23.9,0,44.3,12.9,55.9,31.3 c-32.1,12.2-55.9,42.9-55.9,79c0,6.1,0.7,12.2,2.1,18.4h-2.1c-35.5,0-64.8-28.6-64.8-64.7S168.3,34.7,203.8,34.7z M371.6,34.7 c35.5,0,64.8,28.6,64.8,64.7s-29.3,64-64.8,64h-2.7c2.1-6.1,2.7-12.2,2.7-18.4c0-36.8-23.9-66.7-55.9-79 C327.2,47.7,347,34.7,371.6,34.7z" />
                </svg>`,
  PlayArea: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 576 537.9">
                <path fill="#444444" d="M384.3,137c38,0,68.8-30.7,68.8-68.5S422.3,0,384.3,0s-68.8,30.7-68.8,68.5S346.4,137,384.3,137z" />
                <path fill="#444444" d="M283.3,96c20,26.3,35.9,53.3,67.6,64.4c31.2,11.1,60.5,11.1,83.5-5.3c22.9-16.4,34.7-46.8,54.1-87.2 c18.8-40.4,34.1-48,57-48c23.5,0,31.2,28.1,30.6,39.8s-10.6,31-40,52.7c-49.4,36.3-57.6,108.3-59.4,127.7 c-1.8,19.3-2.9,50.4,17.6,169.2c20.6,118.9-20,125.9-25.3,127.1c-5.3,0.6-21.2,8.2-31.1-16.4c-10-24.6-11.8-91.3-14.1-120 c-2.9-28.7-6.5-70.9-35.9-79c-30-8.2-40.6,39.8-51.7,76.1c-10.6,36.9-40,71.4-72.3,59.1s-29.4-50.4-10-78.5 c19.4-27.5,61.7-57.4,67.6-124.1c5.9-66.8-11.8-69.1-68.2-90.8c-55.8-22.3-60.5-33.4-67.6-48.6s7.6-46.8,31.1-52.7 C239.2,55.1,259.1,63.9,283.3,96L283.3,96z" />
                <path fill="#444444" d="M134.7,251.7c26.9,0,48.8-21.8,48.8-48.6s-21.8-48.6-48.8-48.6s-48.8,21.8-48.8,48.6S107.7,251.7,134.7,251.7z" />
                <path fill="#444444" d="M204,227.8c-15.3,17.6-28.2,35.7-51.1,41.6c-22.9,6.4-43.5,4.7-58.8-8.2c-15.3-12.9-21.7-35.1-32.9-64.4S40,161,23.5,159.8 C7.1,158.7,0,178,0,186.2c-0.6,8.2,5.9,22.3,25.3,39.2C58.2,253.5,60,305.1,60,318.5c0.6,13.5-0.6,35.7-21.7,118.3 s7.1,89.6,10.6,90.8s14.7,7,22.9-10s12.9-63.8,16.5-83.7c3.5-19.9,8.2-49.8,29.4-53.9s26.5,30.4,32.3,56.8 c5.9,26.3,24.7,52.7,47.6,45.7c22.9-7,23.5-34,11.2-54.4c-12.3-20.5-40-43.9-40.6-90.8c-0.6-47.4,12.3-48,52.9-60.3 c40.6-12.3,44.7-20.5,50.5-30.4c5.9-10-2.9-33.4-18.8-38.6C237.5,201.4,222.8,206.7,204,227.8L204,227.8z" />
              </svg>`,
  RestRoom: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 576 533.9">
              <path fill="#444444" d="M282.3,533.9h9.2V0h-9.2V533.9z" />
              <path fill="#444444" d="M118.2,97.1c25.4-4.6,41.6-30.1,34.7-55.5C146,16.2,122.9,2.3,97.4,6.9S58.1,39.3,62.8,62.4S95.1,104,118.2,97.1z" />
              <path fill="#444444" d="M159.8,145.6h4.6c0,0,2.3,0,2.3,2.3L183,270.4c2.3,9.2,9.2,16.2,18.5,16.2c11.6,0,18.5-9.2,18.5-20.8l-18.5-129.4 c-2.3-13.9-13.9-23.1-27.7-23.1H44.3c-13.9,0-25.4,9.2-27.7,23.1L0.4,265.8c-2.3,11.6,6.9,20.8,18.5,20.8c9.2,0,16.2-6.9,18.5-16.2 l16.2-122.5c0,0,0-2.3,2.3-2.3h4.6c0,0,2.3,0,2.3,2.3L30.4,390.6c0,0,0,2.3,2.3,2.3h37c0,0,2.3,0,2.3,2.3v117.9 c0,9.2,6.9,16.2,16.2,16.2s16.2-6.9,16.2-16.2V393c0,0,0-2.3,2.3-2.3h11.6c0,0,2.3,0,2.3,2.3v117.9c0,9.2,6.9,16.2,16.2,16.2 c9.2,0,16.2-6.9,16.2-16.2V393c0,0,0-2.3,2.3-2.3h30.1c0,0,2.3,0,2.3-2.3l-27.7-242.7l0,0l0,0L159.8,145.6z" />
              <path fill="#444444" d="M497.3,76.3c13.9-23.1,4.6-50.9-16.2-62.4s-50.9-6.9-64.7,16.2c-13.9,23.1-4.6,50.9,16.2,62.4 C455.7,106.3,483.5,99.4,497.3,76.3z" />
              <path fill="#444444" d="M545.9,113.3h-178c-13.9,0-25.4,9.2-27.7,23.1v129.4c0,11.6,9.2,20.8,20.8,20.8s18.5-9.2,18.5-20.8V159.5c0,0,0-2.3,2.3-2.3 h2.3c0,0,2.3,0,2.3,2.3l25.4,161.8v187.2c0,11.6,9.2,20.8,20.8,20.8l0,0c11.6,0,20.8-9.2,20.8-20.8V323.6c0,0,0-2.3,2.3-2.3h6.9 c0,0,2.3,0,2.3,2.3v184.9c0,11.6,9.2,20.8,20.8,20.8l0,0c11.6,0,20.8-9.2,20.8-20.8V321.3l25.4-161.8c0,0,0-2.3,2.3-2.3h-2.3 c0,0,2.3,0,2.3,2.3v106.3c0,11.6,9.2,20.8,20.8,20.8s20.8-9.2,20.8-20.8V136.4C571.4,122.5,559.8,113.3,545.9,113.3L545.9,113.3 L545.9,113.3z" />
            </svg>`,
  FamilyRestRoom: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 576 522.5">
                    <path fill="#444444" d="M119.8,91.5c25-5.9,40.5-30.8,34.6-55.7c-5.9-24.9-30.9-40.4-55.9-34.5S58,32,63.9,56.9S94.8,97.3,119.8,91.5z" />
                    <path fill="#444444" d="M160.6,139.1h4.5c0.6,0,1.3,0.6,1.3,1.3l15.3,123.1c1.3,8.9,8.9,15.9,17.8,15.9c10.8,0,19.1-9.5,17.8-20.3l-15.9-128.9 c-1.9-13.3-13.4-24.1-27.4-24.1H43.4c-14,0-25.5,10.2-27.4,24.1L0.1,259.1c-1.3,10.8,7,20.3,17.8,20.3c8.9,0,16.5-7,17.8-15.9 l15.3-123.8c0-0.6,0.6-1.3,1.3-1.3h4.5c0.6,0,1.3,0.6,1.3,1.3L29.4,384.1c0,0.6,0.6,1.3,1.3,1.3H67c0.6,0,1.3,0.6,1.3,1.3v118.1 c0,9.5,7.6,16.5,16.5,16.5c9.5,0,16.5-7.6,16.5-16.5V387.3c0-0.6,0.6-1.3,1.3-1.3h10.8c0.6,0,1.3,0.6,1.3,1.3v118.1 c0,9.5,7.6,16.5,16.5,16.5c9.5,0,16.5-7.6,16.5-16.5V387.3c0-0.6,0.6-1.3,1.3-1.3h36.3c0.6,0,1.3-0.6,1.3-1.3L158,140.3 C159.3,139.7,159.9,139.1,160.6,139.1L160.6,139.1z" />
                    <path fill="#444444" d="M498.9,69.8c12.9-22.1,5.4-50.5-16.8-63.4c-22.2-12.9-50.6-5.4-63.6,16.7c-12.9,22.1-5.4,50.5,16.8,63.4 C457.5,99.4,486,91.9,498.9,69.8z" />
                    <path fill="#444444" d="M547.9,106.1H369.6c-14,0-25.5,10.2-27.4,24.1v128.9c0,10.8,8.9,19.7,19.7,19.7s19.7-8.9,19.7-19.7v-106 c0-0.6,0.6-1.3,1.3-1.3h2.5c0.6,0,1.3,0.6,1.3,1.3l25.5,162.5v187.3c0,10.8,8.9,19.7,19.7,19.7h0.6c10.8,0,19.7-8.9,19.7-19.7v-186 c0-0.6,0.6-1.3,1.3-1.3h10.8c0.6,0,1.3,0.6,1.3,1.3v186c0,10.8,8.9,19.7,19.7,19.7h0.6c10.8,0,19.7-8.9,19.7-19.7V315.6l25.5-162.5 c0-0.6,0.6-1.3,1.3-1.3h2.6c0.6,0,1.3,0.6,1.3,1.3v106c0,10.8,8.9,19.7,19.7,19.7s19.7-8.9,19.7-19.7V130.2 C573.4,116.2,562,106.1,547.9,106.1L547.9,106.1z" />
                    <path fill="#444444" d="M259.6,480l19.7-19.7L251.9,433L229,455.8c-7.6,7.6-5.7,20.3,1.3,27.3l32.5,33.6c12.7,12.7,29.3-5.1,17.2-17.1L259.6,480 L259.6,480z M288.9,347.9c19.1,0,34.4-15.2,34.4-34.3s-15.3-34.3-34.4-34.3s-34.4,15.2-34.4,34.3S269.7,347.9,288.9,347.9z  M369.7,405.7l-46.5-46.3c-3.8-3.8-8.3-6.3-14.7-6.3h-41.4c-6.4,0-10.8,2.5-14,6.3l-45.9,45.7c-12.7,12.7,4.5,28.6,17.2,15.9 l28-27.9v26h72.6v-26l28.6,28.6C364.6,433.6,381.8,417.1,369.7,405.7L369.7,405.7z M324.5,433l-27.4,27.3l19.7,19.7l-20.4,20.3 c-12.1,12.1,4.5,29.2,17.2,17.1l32.5-33.6c7-7,8.9-20.3,1.3-27.3C347.4,455.9,324.5,433,324.5,433z" />
                  </svg>`,
  Elevator: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 576 576">
                <path fill="#444444" d="M576,145.2v268.6c-0.1,1.6-0.3,3.1-0.3,4.7c-0.3,33.3-0.6,66.6-0.8,99.9c-0.1,21.1-9.7,37.2-26.7,49 c-7.7,5.4-15.9,9.3-25.9,8c-3.8-0.5-7.7-0.1-11.5-0.1c-115.3,0.1-230.6,0.2-345.9,0.3c-1.1,0-2.2,0.2-3.3,0.3h-16.9 c-1.2-0.1-2.4-0.3-3.6-0.3c-30.2-0.3-60.4-0.6-90.7-0.8c-11.1-0.1-20.7-4.1-29.1-11.2c-8.7-7.4-15.5-16.7-19.9-27.3l-0.2-0.5 c-0.7-1.6-1.1-3.4-1.2-5.4v0C0,492.8,0,455.1,0,417.4c0-124.1,0-248.1,0-372.2c0-0.2,0-0.3,0-0.5c0-1.5,0.3-2.9,0.7-4.2l0,0.1 C8.3,22.5,20.5,8.9,38.7,1c1.2-0.5,2.6-0.9,4-0.9h0c162.8,0,325.6,0,488.4,0c1.5,0,2.8,0.4,4.1,0.9l-0.1,0c3.4,1.4,6.1,2.7,8.8,4.2 l-0.4-0.2c19.7,11.2,30.9,27.8,31.3,50.8c0.4,28.2,0.6,56.3,0.8,84.5C575.7,141.8,575.8,143.5,576,145.2L576,145.2z M536.4,288.6 h0.3c0-56.7,0-113.4,0-170c0-18.2-0.4-36.4-0.7-54.6c-0.1-8-8.4-19.8-15.9-22.7c-1-0.4-2.1-0.6-3.2-0.7h0c-3.2-0.3-6.4-0.6-9.5-0.6 c-25.5-0.4-51-0.9-76.6-1c-96.4-0.2-192.7-0.4-289.1-0.4c-22.9,0-45.8,0.1-68.7,0.3c-3.4,0-6.8,0.1-10,0.9 c-9.9,2.3-17.1,8.3-21.7,17.3c-1,1.9-2,3.9-2.1,5.9c-0.1,149.8-0.1,299.6-0.1,449.4c0,0.9-0.1,2,0.3,2.7c2.7,4.2,5.1,8.6,8.3,12.3 c5.6,6.3,13.2,8.4,21.6,8.4c23.7,0.1,47.5,0.6,71.2,0.6c123.5,0,247,0,370.5,0c0.1,0,0.2,0,0.3,0c1.1,0,2.1-0.2,3-0.6l-0.1,0 c8.3-3.5,15.4-8.4,20.2-16.3c1.2-1.8,2-4.1,2-6.5l0,0C536.4,438.2,536.4,363.4,536.4,288.6L536.4,288.6z" />
                <path fill="#444444" d="M307,277.5l75.9,68.4l0.9-0.2V150.9h49.7v194.8l1,0.3l78.2-67.4c0.1,1,0.2,1.7,0.3,2.4c0.3,19.9,0.6,39.8,0.8,59.7 c0,0,0,0,0,0.1c0,1.4-0.5,2.6-1.4,3.6l0,0c-34.1,32.7-68.2,65.3-102.3,97.9c-0.3,0.3-0.6,0.5-1,0.9c-0.6-0.5-1.3-1-1.9-1.5 c-32.7-30.7-65.5-61.4-98.2-92c-1.4-1.2-2.3-3-2.3-5c0-0.1,0-0.3,0-0.4v0c0.2-20.9,0.3-41.9,0.4-62.8C307,280.5,307,279.4,307,277.5 L307,277.5z" />
                <path fill="#444444" d="M142.2,234.5L67,301.8c-0.1-1.2-0.3-1.9-0.3-2.7c-0.3-20.7-0.7-41.5-1-62.2c0-1.3,0.5-2.5,1.3-3.4l0,0 c33.3-31.4,66.7-62.8,100.1-94.1c0.3-0.3,0.6-0.5,1-0.8c5.9,5.7,11.8,11.3,17.7,16.9c28.1,26.9,56.2,53.9,84.3,80.9 c0.9,0.8,1.4,2,1.5,3.3v0c-0.5,20.2-1.1,40.3-1.6,60.5c0,0.3-0.1,0.7-0.2,1.7l-77.4-67.1l-0.9,0.1v193.9h-48.3v-194L142.2,234.5z" />
              </svg>`,
  Security: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 576 597.6">
                <path fill="#444444" d="M554,80.7L298.5,1.5c-6.6-2-13.2-2-19.9,0L23.2,80.7C9.3,84.7,0,97.9,0,112.4c0,352.5,178.7,436.4,274,481.9 c4.6,2,9.3,3.3,13.9,3.3c4.6,0,9.9-1.3,13.9-3.3c96-45.5,274-129.4,274-481.9C577.2,97.9,567.9,85.3,554,80.7z M288.6,527.6 C197.2,484.1,73.5,411.4,66.2,136.2l222.4-68.6L511,136.8C503.7,412.1,379.3,484.1,288.6,527.6z" />
                <path fill="#444444" d="M278.7,152l-26.5,87.1l-90.7-2.6c-4.6,0-8.6,2.6-9.9,7.3c-1.3,4.6,0,9.2,4,11.9l74.8,51.5L200.6,393c-1.3,4.6,0,9.2,4,11.9 c4,2.6,8.6,2.6,12.6,0l72.1-54.8l72.1,54.8c4,2.6,8.6,2.6,12.6,0c4-2.6,5.3-7.3,4-11.9l-29.8-85.8l74.8-51.5c4-2.6,5.3-7.3,4-11.9 c-1.3-4.6-5.3-7.3-9.9-7.3l-90.7,2l-26.5-87.1c-1.3-4.6-5.3-7.3-9.9-7.3C283.9,144.1,280,147.4,278.7,152L278.7,152z" />
              </svg>`,
  ChildStroller: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 432 370.06">
                    <path fill="#444444" d="M130.29,178.61l-42.67,34L33.24,254.13c-15.48,12.09-28.32-2.64-28.32-2.64-12.08-15.86,1.89-26.06,1.89-26.06l68-53.24s7.55-7.93,26.81-2.26l28.7,8.68"/>
                    <path fill="#444444" d="M210,111A38.52,38.52,0,1,1,248.48,72.5,38.68,38.68,0,0,1,210,111"/>
                    <path fill="#444444" d="M390.84,0a42.88,42.88,0,0,0-24.92,8.31L80.44,235.63a43.71,43.71,0,0,0-13.59,22.28,40.67,40.67,0,0,0,1.89,23.41,47.9,47.9,0,0,0-22.28,41.16A47.58,47.58,0,1,0,94,274.9,41.43,41.43,0,0,0,84.22,276a22.77,22.77,0,0,1-1.51-14.35,25.82,25.82,0,0,1,8.68-13.59l17.37-14,88,29.08a33.54,33.54,0,0,0,42.67-21.53l1.51-4.91,18.88,45.32a47.09,47.09,0,0,0-22.28,40.4,47.58,47.58,0,1,0,47.58-47.58,41.43,41.43,0,0,0-9.82,1.13l-26.43-62.68,43.8-126.12,83.08-66.08a23.7,23.7,0,0,1,15.1-5.29,25.3,25.3,0,0,1,25.3,25.3,25.72,25.72,0,0,1-10.2,20.39,8,8,0,0,0,10.58,12.08A41.37,41.37,0,0,0,390.84,0ZM93.66,301.33A20.77,20.77,0,1,1,72.89,322.1,20.71,20.71,0,0,1,93.66,301.33Zm191.07,0A20.77,20.77,0,1,1,264,322.1,20.71,20.71,0,0,1,284.73,301.33Z"/>
                  </svg>`,
  VendingMachine: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 432 594">
                      <circle fill="#444444" cx="324" cy="175.5" r="13.5"/>
                      <circle fill="#444444" cx="364.5" cy="175.5" r="13.5"/>
                      <circle fill="#444444" cx="324" cy="243" r="13.5"/>
                      <circle fill="#444444" cx="364.5" cy="243" r="13.5"/>
                      <circle fill="#444444" cx="324" cy="310.5" r="13.5"/>
                      <circle fill="#444444" cx="364.5" cy="310.5" r="13.5"/>
                      <path fill="#444444" d="M216,94.5H67.5C59.4,94.5,54,99.9,54,108c0,8.1,5.4,13.5,13.5,13.5H216c8.1,0,13.5-5.4,13.5-13.5 C229.5,99.9,224.1,94.5,216,94.5z"/>
                      <path fill="#444444" d="M216,162H67.5c-8.1,0-13.5,5.4-13.5,13.5c0,8.1,5.4,13.5,13.5,13.5H216c8.1,0,13.5-5.4,13.5-13.5 C229.5,167.4,224.1,162,216,162z"/>
                      <path fill="#444444" d="M216,229.5H67.5c-8.1,0-13.5,5.4-13.5,13.5c0,8.1,5.4,13.5,13.5,13.5H216c8.1,0,13.5-5.4,13.5-13.5 C229.5,234.9,224.1,229.5,216,229.5z"/>
                      <path fill="#444444" d="M216,297H67.5c-8.1,0-13.5,5.4-13.5,13.5S59.4,324,67.5,324H216c8.1,0,13.5-5.4,13.5-13.5S224.1,297,216,297z"/>
                      <path fill="#444444" d="M391.5,0H324c-8.1,0-13.5,5.4-13.5,13.5S315.9,27,324,27h67.5c8.1,0,13.5,5.4,13.5,13.5V567H27V40.5 C27,32.4,32.4,27,40.5,27h216v499.5c0,8.1,5.4,13.5,13.5,13.5s13.5-5.4,13.5-13.5v-513C283.5,5.4,278.1,0,270,0H40.5 C17.5,0,0,17.5,0,40.5v540c0,8.1,5.4,13.5,13.5,13.5h405c8.1,0,13.5-5.4,13.5-13.5v-540C432,17.5,414.5,0,391.5,0z"/>
                      <path fill="#444444" d="M364.5,94.5H324c-8.1,0-13.5,5.4-13.5,13.5c0,8.1,5.4,13.5,13.5,13.5h40.5c8.1,0,13.5-5.4,13.5-13.5 C378,99.9,372.6,94.5,364.5,94.5z"/>
                      <path fill="#444444" d="M216,432H67.5c-8.1,0-13.5,5.4-13.5,13.5V513c0,8.1,5.4,13.5,13.5,13.5H216c8.1,0,13.5-5.4,13.5-13.5v-67.5 C229.5,437.4,224.1,432,216,432z M81,499.5V459h121.5v40.5H81z"/>
                    </svg>`,
  Stairs: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 432 448.5">
              <path fill="#444444" d="M432,243.3h-81.7v33.1h-72.2v33.1h-72.2v33.1h-72.2v33.1H61.5v33.1H0v39.7h101.2v-33.1h72.2v-33.1h72.2v-33.1h72.2v-33.1 h72.2V283H432L432,243.3"/>
              <path fill="#444444" d="M99.9,109.3c12,0,21.8-9.7,21.8-21.8c0-12-9.8-21.8-21.8-21.8c-12,0-21.8,9.7-21.8,21.8C78.1,99.6,87.9,109.3,99.9,109.3"/>
              <path fill="#444444" d="M179.4,299.8l-56.5-47.4l11.7-82.9c12.5,14.8,20.7,33.4,22.7,53.8l17.8-4.8c-0.9-32.2-14.2-61.3-35.3-82.6 c-14.4-14.5-32.9-19.2-45.9-20.6c-0.1,0-0.2,0-0.3,0c-1.6,0-2.9,1.2-3.2,2.7c-6.5,34.7-27.7,64.2-56.9,81.9l9.3,16.1 c15.6-6.6,29.5-16.4,40.9-28.6v177.3H107l10.4-73.7l57.7,33.3L179.4,299.8"/>
              <path fill="#444444" d="M294.1,43.6c12,0,21.8-9.8,21.8-21.8c0-12-9.8-21.8-21.8-21.8c-12,0-21.8,9.8-21.8,21.8C272.3,33.8,282.1,43.6,294.1,43.6" />
              <path fill="#444444" d="M337.2,154.3l-41.8-24.1l3.9-20c1.4-7.5,2.2-15.2,2.2-23.1c0-12-1.8-23.7-5-34.6c-0.4-1.4-1.7-2.4-3.1-2.4c0,0-0.1,0-0.1,0 c-46.7,1.6-84.1,40-84.1,87.1c0,2.3,0.1,4.6,0.3,6.9l18.3,3.2c0-0.5,0-0.9,0-1.4c0-19.5,8.6-36.9,22.3-48.7l-10.5,201.1h23.3 l24.9-128l23,10.7L294.9,240l16.6,16.6l34.6-74.3c1.3-2.8,2-5.9,2-9.2C348.1,165.1,343.8,158,337.2,154.3"/>
            </svg>`,
  ChargingStation: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 432 627.4">
                      <polygon fill="#444444" points="314.4,282.1 133.8,467.8 188.6,334.2 114.9,334.2 225.6,148.6 314.4,148.6 236.7,282.1 "/>
                      <path fill="#444444" d="M374.2,0H63.3C28.4,0.1,0.1,28.4,0,63.3v503.6c0,32.8,30.1,60.5,62.6,60.5h309.2c33.3,0,60.3-27,60.3-60.3V374.2l0,0V57.8 C432,25.9,406.1,0,374.2,0z M220.3,600.4c-8.3,0.2-15.2-6.4-15.4-14.7c0-0.2,0-0.5,0-0.7c0.1-8.5,6.9-15.3,15.4-15.4 c8.3-0.2,15.2,6.4,15.4,14.7c0,0.2,0,0.5,0,0.7C235.4,593.8,229.1,600.4,220.3,600.4z M391.1,544.8H44v-465h346.7v294.4l0.4,55 V544.8z"/>
                    </svg>`,
  WheelChair: `<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 432 492.2">
                  <path fill="#444444" d="M134.7,80.1l9.5,103h104.6v33.3H146.6l3.2,30.9h147.4l66.6,157l56.3-23.8l11.9,27l-84,36.4l-69.7-163.3H118.9l-19-221.9 c-3.2-5.5-4.7-11.9-4.7-18.2C95.1,18.2,112.5,0,134.7,0c22.2,0,40.4,18.2,40.4,40.4C175.2,61.8,156.9,80.1,134.7,80.1L134.7,80.1z" />
                  <path fill="#444444" d="M306.7,397.1c-25.3,56.3-81.6,95.1-146.6,95.1C72.1,492.2,0,420.9,0,332.1C0,268.7,37.2,214,91.1,187.9l3.2,36.5 c-36.5,22.2-61,61.8-61,107.8c0,69.8,57.1,126.8,126.8,126.8c65,0,118.1-48.3,126-110.2L306.7,397.1"/>
                </svg>`
}, t2 = [
  {
    name: "ATM",
    type: "atm",
    svgCode: W1.ATM
  },
  {
    name: "Management",
    type: "management",
    svgCode: W1.Management
  },
  {
    name: "Kids Area",
    type: "playarea",
    svgCode: W1.PlayArea
  },
  {
    name: "Restroom",
    type: "restroom",
    svgCode: W1.RestRoom
  },
  {
    name: "Family Restroom",
    type: "family-restroom",
    svgCode: W1.FamilyRestRoom
  },
  {
    name: "Elevator",
    type: "elevator",
    svgCode: W1.Elevator
  },
  {
    name: "Security",
    type: "security",
    svgCode: W1.Security
  },
  {
    name: "Escalator",
    type: "escalator",
    svgCode: W1.Escalator
  },
  {
    name: "Child Stroller",
    type: "child-stroller",
    svgCode: W1.ChildStroller
  },
  {
    name: "Vending Machine",
    type: "vending-machine",
    svgCode: W1.VendingMachine
  },
  {
    name: "Stairs",
    type: "stairs",
    svgCode: W1.Stairs
  },
  {
    name: "Charging Station",
    type: "charging-station",
    svgCode: W1.ChargingStation
  },
  {
    name: "Wheelchair",
    type: "wheelchair",
    svgCode: W1.WheelChair
  }
], B8 = {
  "route-path": 0,
  escalator: 0,
  underlay: 0,
  overlay: 1,
  "building-base": 1,
  base: 2,
  "green-area": 2,
  "water-area": 2,
  "parking-lane": 2,
  store: 3,
  "big-store": 4,
  kiosk: 5,
  wall: 6,
  "parking-line": 6,
  "parking-icon": 7,
  "outer-wall": 7,
  boundary: 8,
  amenity: 9,
  "layer-image": 10,
  "layer-text": 11,
  "route-tube": 12,
  "special-shape": 13
}, f3 = () => {
  const { mapConfig: e, allMapObjects: t, allIndexedMapObjects: l, allIndexedRetailers: r, floorsData: n } = o4(), o = o1((s) => s != null && B8[s] !== void 0 ? B8[s] : 0, []), i = o1((s, c, u, _) => {
    var b;
    const A = {
      color: u instanceof m2 ? u : P1(u),
      side: d2,
      transparent: !1,
      depthWrite: !0,
      depthTest: !0,
      opacity: 1
    };
    (e.STYLE === "2D" || s === "base" || s == null) && s !== "boundary" && (A.depthWrite = !1, A.depthTest = !1), s === "overlay" && (A.color = e.OVERLAY_COLOR, A.opacity = e.OVERLAY_OPACITY), s && ["store", "big-store", "kiosk"].includes(s) && e.HOST !== "PORTAL" && l[c] && l[c].transparent && (A.opacity = 0);
    var v = new I4(A);
    return s && ["store", "big-store", "kiosk", "amenity"].includes(s) && ((s === "amenity" || ((b = l[c]) == null ? void 0 : b.layer_type) === "amenity") && (v.color = u4.GREEN_AREA_COLOR.clone()), v.colorDefault = v.color.clone(), l[c] && l[c].bg_color !== "" && (v.color = P1(l[c].bg_color), v.colorDefault = v.color.clone()), v.active = !1), e.HOST !== "PORTAL" && _ && (v.opacity = 0, v.transparent = !0), v.transparent = v.opacity !== 1, v;
  }, [l, e.OVERLAY_COLOR, e.OVERLAY_OPACITY, e.HOST, e.STYLE]), q = o1((s, c, u, _, A) => {
    const v = "MaterialAndGeometry";
    let b = A.toShapes(!0), h;
    e.STYLE === "2D" ? h = ["building-base"] : h = ["store", "big-store", "base", "building-base"];
    let d = ["wall", "outer-wall", "boundary", "parking-line"];
    var C;
    if (s && h.includes(s))
      C = new O6(b, {
        depth: -u,
        bevelEnabled: !1
      });
    else if (s && d.includes(s)) {
      let f = 0;
      s === "boundary" && (f = 1), C = Bl(A, _, u, f, c);
    } else {
      C = new S3(b);
      try {
        C.attributes.position.count === 0 && console.warn(v + 'Unneccessary map shape "%s"', c, A.userData.node);
      } catch (f) {
        console.error(f.message);
      }
    }
    return C;
  }, [e.STYLE]), a = o1((s, c, u, _, A, v, b, h, d, C) => {
    var w, T;
    const f = i(s, c, u, _), m = q(s, c, b, h, C), p = new Y2(m ?? new S3(), f);
    p.object_id = c, p.mesh_type = s, p.floor_index = d, p.visible = A, p.position.z = v;
    let I = "";
    if (["retail_logo", "retail_name", "retail_text", "custom_text", "amenity"].includes((w = l[c]) == null ? void 0 : w.layer_type)) {
      if (l[c].layer_type && ["retail_name", "retail_logo"].includes(l[c].layer_type) && l[c].retailer_id && r[((T = l[c]) == null ? void 0 : T.retailer_id) || 0])
        I = r[l[c].retailer_id].retail_name;
      else if (["retail_text", "custom_text"].includes(l[c].layer_type))
        I = l[c].custom_text, I === "" && l[c].retailer_id && r[l[c].retailer_id] && (I = r[l[c].retailer_id].retail_name);
      else if (["amenity"].includes(l[c].layer_type) && (I = l[c].value, I)) {
        const L = t2.find((j) => j.type === I);
        L && (I = L.name);
      }
    }
    return p.userData.storeName = I, e.STYLE === "2D" && (p.renderOrder = o(s), c && c.includes("underlay") && (p.renderOrder = o("underlay"))), n[d].objsGroup.add(p), s === "escalator" && (n[d].escalatorsNodes[c] = null, n[d].escalatorsObjs.push(p), p.escalator_id = d + "-" + c), s && ["store", "big-store", "kiosk", "amenity"].includes(s) && (p.route_node_id = null, l[c] && l[c].layer_type, t.push(c), (e.HOST !== "PORTAL" && s === "kiosk" || e.HOST !== "PORTAL" && e.HOST !== "PORTAL_KIOSK" && l[c] && l[c].obj_type === "retailer" && l[c].retailer_id != null || e.HOST !== "PORTAL" && e.HOST !== "PORTAL_KIOSK" && l[c] && l[c].obj_type === "custom" && l[c].custom_text !== "" || e.HOST !== "PORTAL" && e.HOST !== "PORTAL_KIOSK" && l[c] && l[c].layer_type === "amenity" && l[c].value !== null || e.HOST === "PORTAL" && l[c] && (l[c].obj_type === "special" || l[c].obj_type === "custom") || e.HOST === "PORTAL" && ["store", "kiosk", "amenity"].includes(p.mesh_type ?? "") || e.HOST === "PORTAL") && n[d].interactiveObjs.push(p)), {
      mesh: p,
      geometry: m ?? new S3(),
      material: f,
      object_id: c,
      mesh_type: s,
      floor_index: d,
      visible: A,
      renderOrder: p.renderOrder
    };
  }, [l, r, t, n, q, i, o, e.HOST, e.STYLE]);
  return {
    getRenderOrder: o,
    getMaterial: i,
    getGeometry: q,
    getMaterialAndGeometry: a
  };
}, L3 = "ROUTE: ", Gl = 1e4, O5 = () => {
  const { floorsData: e, allNodesFloor: t, ngraphPath: l, pathFinderGraph: r, allIndexedMapObjects: n } = o4(), { getRenderOrder: o } = f3(), i = o1((d, C, f) => {
    if (!f.data) return !1;
    let m = f.data.weight;
    const p = t[d.id], I = t[C.id];
    return p !== I ? m + Gl + Math.abs(p - I) : m;
  }, [t]), q = o1((d) => {
    var C;
    for (let f = 0; f < d.length; f++) {
      const m = d[f];
      m.route_active = !1, m.route_tube != null && (m.route_tube.geometry.dispose(), m.route_tube.material.dispose(), (C = m.objsGroup) == null || C.remove(m.route_tube)), m.route_tube = void 0, m.route_texture = null, m.escalatorMeshes = [];
    }
  }, []), a = o1((d, C, f) => {
    let m = f.find(d, C);
    return m.length === 0 ? !1 : m;
  }, []), s = o1((d, C, f) => {
    let p = document.createElement("canvas").getContext("2d");
    if (p) {
      p.canvas.width = d, p.canvas.height = 80, p.fillStyle = "#4ea5ff", p.fillRect(0, 0, d, 80);
      let I = 0.1 * d;
      const w = 60, T = 120;
      I < w && (I = w), I > T && (I = T);
      let L = p.createLinearGradient(0, 0, I, 0);
      L.addColorStop(0, "#4ea5ff"), L.addColorStop(0.4, "white"), L.addColorStop(0.6, "white"), L.addColorStop(1, "#4ea5ff"), p.fillStyle = L, p.fillRect(10, 0, I, 80);
      let j = new Z9(p.canvas);
      return j.offset.x = 1, j.colorSpace = "srgb", f[C].route_texture = j, j;
    } else
      return;
  }, []), c = o1((d, C, f, m = "2D") => {
    var j;
    let p = 0, I = new _e();
    for (let $ = 1; $ < d.length; $++) {
      let k = new L1(d[$ - 1].data.x, d[$ - 1].data.y, 0), t1 = new L1(d[$].data.x, d[$].data.y, 0);
      I.add(new ve(k, t1)), p += k.distanceTo(t1);
    }
    var w = new ye(I, 400, 6, 8);
    w = new R6().copy(w);
    var T = new I4({
      map: s(p, C, f),
      transparent: !0,
      side: d2,
      depthTest: !1,
      depthWrite: !1
    });
    let L = new Y2(w, T);
    return m === "2D" && (L.position.z = -10, L.scale.z = 0.1), L.position.z = 0, L.renderOrder = o("route-tube"), L.mesh_type = "route-tube", L.geometry.index !== null ? L.geometry.setDrawRange(0, L.geometry.index.count) : console.warn("route_tube.geometry.index is null"), f[C].route_tube = L, (j = f[C].objsGroup) == null || j.add(L), L;
  }, [o, s]), u = o1((d, C, f, m, p, I, w, T, L = null) => {
    var M, H, W, S, E, g;
    const j = [];
    q(I);
    let $ = f.getObjectByProperty("object_id", d), k = f.getObjectByProperty("object_id", C), t1 = $.route_node_id, e1 = k.route_node_id;
    if (t1 || console.error(L3 + 'Route Anchor point missing for "%s"', d), e1 || console.error(L3 + 'Route Anchor point missing for "%s"', C), !t1 || !e1) return j;
    const Q = $.floor_index, Z = k.floor_index, X = l.nba(w, {
      distance: i,
      oriented: !0,
      blocked(x, R, Y) {
        return Y.data.blocked;
      },
      //@ts-ignore
      debug: !0
    }), G = a(t1, e1, X), a1 = [];
    if (!G)
      return [];
    G.reverse();
    const F = [];
    for (let x = 0; x < G.length; x++) {
      const R = G[x];
      F[m[R.id]] ? F[m[R.id]].push(R) : F[m[R.id]] = [R], p.includes(R.id) && p.includes(G[x - 1].id) && p.includes(G[x + 1].id), a1.push(R);
    }
    for (let x = 0; x < a1.length; x++) {
      const R = a1[x];
      if (m[a1[0].id] !== m[a1[a1.length - 1].id] && p.includes(R.id)) {
        const Y = Object.keys(I[m[R.id]].escalatorsNodes).find((z) => {
          var l1, U;
          return ((U = (l1 = I[m[R.id]]) == null ? void 0 : l1.escalatorsNodes) == null ? void 0 : U[z]) === R.id;
        }), B = f.getObjectByProperty("escalator_id", m[R.id] + "-" + Y);
        let K = null;
        if (m[R.id] !== m[a1[x + 1].id] && p.includes(a1[x + 1].id) && (K = {
          index: m[a1[x + 1].id],
          direction: "To"
        }), m[R.id] !== m[a1[x - 1].id] && p.includes(a1[x - 1].id) && (K = {
          index: m[a1[x - 1].id],
          direction: "From"
        }), K && B) {
          B.goToFloor = K;
          const z = B.clone();
          z.goToFloor = K, z.object_id = Y, (H = (M = I[m[R.id]]) == null ? void 0 : M.escalatorMeshes) == null || H.push(z);
        }
      }
    }
    for (let x = 0; x < F.length; x++) {
      const R = F[x];
      if (R && R.length > 1) {
        const Y = c(R, x, I, T);
        j[x] = Y, I[x].route_active = !0, I[x].routeMeshes = [Y], x === Q && ((S = (W = I[x]) == null ? void 0 : W.routeMeshes) == null || S.push($)), x === Z && ((g = (E = I[x]) == null ? void 0 : E.routeMeshes) == null || g.push(k));
      }
    }
    return j;
  }, [c, a, l, q, i]), _ = o1((d, C, f, m, p, I, w, T) => {
    if (C === f)
      return {
        routePaths: [],
        fromFloor: void 0
      };
    const L = u(C, f, m, d, I, p, w, T);
    L.length || console.warn(L3 + 'No route found in between "%s" and "%s"', C, f);
    let j = m.getObjectByProperty("object_id", C);
    return {
      routePaths: L,
      fromFloor: j.floor_index
    };
  }, [u]), A = o1((d, C, f, m) => {
    let p = 0, I = f.find(C, d);
    if (I.length === 0) return !1;
    for (let w = 1; w < I.length; w++) {
      let T = m.getLink(I[w - 1].id, I[w].id);
      p += (T == null ? void 0 : T.data.weight) || 0;
    }
    return p;
  }, []), v = o1(() => {
    if (e.length > 1) {
      const d = [], C = [];
      for (let f = 0; f < e.length; f++)
        C[f] = [], e[f].escalatorsNodes && (d[f] = Object.fromEntries(
          Object.entries(e[f].escalatorsNodes).map(([m, p]) => {
            const I = m.split("-"), w = I.slice(0, 2).join("-"), T = I.includes("end"), L = I.includes("start"), j = I.includes("up"), $ = I.includes("down"), k = j ? "up" : $ ? "down" : "both";
            return C[f].push(w), [w, {
              node: p,
              escalatorId: w,
              isExitOnly: T,
              isEntranceOnly: L,
              upOnly: j,
              downOnly: $,
              direction: k,
              floorsTo: []
            }];
          })
        ));
      for (let f = 0; f < e.length; f++)
        for (let m = 0; m < C[f].length; m++) {
          const p = C[f][m], I = d[f][p];
          for (let w = f + 1; w < e.length; w++)
            for (let T = 0; T < C[w].length; T++) {
              const L = C[w][T];
              p === L && I.floorsTo.push(w);
            }
        }
      for (let f = 0; f < e.length - 1; f++) {
        const m = d[f];
        for (const p in m) {
          const I = m[p], w = I.node;
          I.floorsTo.forEach((T) => {
            const j = d[T][p].node;
            j && (I.isExitOnly ? (r.addLink(w, j, { blocked: !0 }), r.addLink(j, w, { weight: 1 })) : I.isEntranceOnly ? (r.addLink(j, w, { blocked: !0 }), r.addLink(w, j, { weight: 1 })) : (r.addLink(w, j, { weight: 1 }), r.addLink(j, w, { weight: 1 })));
          });
        }
      }
    }
  }, [e, r]), b = o1((d, C, f, m, p) => {
    let I = f.getObjectByProperty("object_id", d), w = I ? I.route_node_id : "";
    var T = null, L = 9999;
    const j = [];
    for (let $ in n) {
      const k = n[$];
      k.layer_type === "amenity" && k.obj_type === "special" && k.value === C && j.push($);
    }
    return j.forEach(($) => {
      let k = f.getObjectByProperty("object_id", $);
      const t1 = l.aStar(r, {
        distance: i,
        //@ts-ignore
        debug: !0
      });
      if (k && w) {
        var e1 = k.route_node_id;
        try {
          var Q = A(w || "", e1 || "", t1, r);
          Q && Q < L && (L = Q, T = $);
        } catch (Z) {
          console.warn(`Amenity Path: ${Z.message}`);
        }
      }
      !w && k && (T = e1);
    }), _(t, d, T ?? "", f, e, m, r, p);
  }, [n, t, _, e, A, l, r, i]), h = o1((d, C, f) => {
    const m = /* @__PURE__ */ new Map(), p = e[d];
    return p && p.route_points && p.route_points.forEach((I) => {
      let w = new L1(I.node.x, I.node.y, -10), T = new L1(0, 0, 1);
      f.set(w, T);
      var L = f.intersectObjects(e[d].interactiveObjs);
      L.length && (L[0].object.route_node_id = I.name, m.set(L[0].object.object_id, I.name));
      var j = f.intersectObjects(e[d].escalatorsObjs);
      if (j.length) {
        let k = j[0].object.object_id;
        const t1 = e[d].escalatorsNodes;
        t1 && (t1[k] = I.name, t[I.name] = d, C.push(I.name));
      }
    }), m;
  }, [t, e]);
  return {
    delete_route_path: q,
    create_route: _,
    create_route_paths: u,
    create_route_path: c,
    get_route_nodes: a,
    get_nodes_distance: A,
    get_route_texture: s,
    linkFloorEscalators: v,
    make_amenity_route: b,
    assign_route_nodes_to_stores: h
  };
};
function Dl(e) {
  if (!e || e.nodeType !== 1) return;
  let t = e;
  for (; t; ) {
    const l = t.getAttribute("id");
    if (l) return l;
    t = t.parentElement;
  }
}
function kl(e) {
  return "node-" + e;
}
function G8(e, t, l, r) {
  let n = !1, o = "-name-not-found-";
  const i = l[t];
  if (i.route_points !== void 0) {
    for (let q = 0; q < i.route_points.length; q++)
      if (e.x === i.route_points[q].node.x && e.y === i.route_points[q].node.y) {
        n = !0, o = i.route_points[q].name;
        break;
      }
    n || (o = kl(r));
  }
  return [o, n];
}
const Vl = () => {
  const { mapConfig: e, floorsData: t, allNodesFloor: l, pathFinderGraph: r } = o4();
  return {
    getMeshParams: o1((o, i, q, a) => {
      var p;
      const s = "MeshParams";
      let c = null;
      var u = o.color.clone(), _ = 0, A = 0, v = !0, b = !0, h = !1, d = e.WALL_THICKNESS, C = !0, f = Dl((p = o.userData) == null ? void 0 : p.node);
      return f !== void 0 ? f.startsWith("boundary") ? (c = "boundary", u = e.BOUNDARY_COLOR, d = e.BOUNDARY_THICKNESS, e.STYLE === "3D" && (_ = 9)) : f.startsWith("wall") ? (c = "wall", u = e.WALL_COLOR, e.STYLE === "3D" && (_ = 8.5)) : f.startsWith("outer-wall") ? (c = "outer-wall", u = e.WALL_COLOR, e.STYLE === "3D" && (b = !1)) : f.startsWith("base") ? (c = "base", u = e.BASE_COLOR) : f.startsWith("store") ? (c = "store", u = e.STORE_DEFAULT_COLOR, e.STYLE === "3D" && (_ = e.STORE_HEIGHT), f.startsWith("store-underlay") && (C = !1)) : f.startsWith("route-path") ? (c = "route-path", b = !1, o.subPaths.forEach((I) => {
        I.curves.length === 0 && console.warn(s + 'Route-path standalone anchor point exists, layer_name: "%s"', f), I.curves.forEach((w) => {
          var e1, Q;
          const T = w.v1, L = w.v2, [j, $] = G8(T, q, t, a);
          $ || ((e1 = t[q].route_points) == null || e1.push({
            name: j,
            node: new L1(T.x, T.y, 1)
          }), l[j] = q);
          const [k, t1] = G8(L, q, t, a);
          t1 || ((Q = t[q].route_points) == null || Q.push({
            name: k,
            node: new L1(L.x, L.y, 1)
          }), l[k] = q), r.addNode(j, { ...T }), r.addNode(k, { ...L }), r.addLink(j, k, { weight: T.distanceTo(L) }), r.addLink(k, j, { weight: T.distanceTo(L) });
        });
      })) : f.startsWith("escalator-") ? (c = "escalator", v = !1, h = !0) : f.startsWith("kiosk-") ? (c = "kiosk", h = !0) : f.startsWith("amenity-") ? (c = "amenity", h = !0, A = 1, u = u4.GREEN_AREA_COLOR) : f.startsWith("overlay") ? c = "overlay" : f.startsWith("special-shape") ? c = "special-shape" : f.startsWith("parking-lane") ? (c = "parking-lane", u = u4.PARKING_LANE_COLOR, e.STYLE === "3D" && (_ = 1)) : f.startsWith("parking-line") ? (c = "parking-line", u = u4.PARKING_LINE_COLOR, d = u4.PARKING_LINE_THICKNESS, e.STYLE === "3D" && (_ = 0.5)) : f.startsWith("parking-icon") ? (c = "parking-icon", u = u4.PARKING_ICON_COLOR, e.STYLE === "3D" && (_ = 1)) : f.startsWith("green-area") ? (c = "green-area", u = u4.GREEN_AREA_COLOR, e.STYLE === "3D" && (_ = 1)) : f.startsWith("water-area") ? (c = "water-area", u = u4.WATER_AREA_COLOR, e.STYLE === "3D" && (_ = 1)) : _ = 1 : console.warn(s + "Layer name is undefined, path", o), {
        mesh_type: c,
        layer_color: u,
        extrude: _,
        z_index: A,
        mesh_visible: v,
        mesh_draw: b,
        mesh_transparent: h,
        line_thickness: d,
        interactiveMesh: C,
        path: o,
        layer_name: f
      };
    }, [l, t, e.STORE_HEIGHT, e.STYLE, e.BASE_COLOR, e.BOUNDARY_COLOR, e.BOUNDARY_THICKNESS, e.STORE_DEFAULT_COLOR, e.WALL_COLOR, e.WALL_THICKNESS, r])
  };
};
let D8 = 0;
const Hl = (e) => {
  const { mapConfig: t, pathFinderGraph: l, floorsData: r } = o4(), { getMaterialAndGeometry: n } = f3(), { getMeshParams: o } = Vl(), { assign_route_nodes_to_stores: i, linkFloorEscalators: q } = O5(), [a, s, c] = j1(() => {
    D8 = 0;
    const u = /* @__PURE__ */ new Set(), _ = [], A = [];
    e.forEach((v, b) => {
      var h, d;
      if (r[b] && v && v.paths && v.paths.length) {
        const C = [];
        for (let I = 0; I < v.paths.length; I++)
          C.push((d = (h = v.paths[I]) == null ? void 0 : h.userData) == null ? void 0 : d.node.id);
        const f = v.paths;
        for (let I = 0; I < f.length; I++) {
          const {
            mesh_type: w,
            layer_color: T,
            extrude: L,
            z_index: j,
            mesh_visible: $,
            mesh_draw: k,
            mesh_transparent: t1,
            line_thickness: e1,
            path: Q,
            layer_name: Z
          } = o(
            f[I],
            f,
            b,
            ++D8
          );
          if (k && Z) {
            const X = n(
              w,
              Z,
              T,
              t1,
              $,
              j,
              L,
              e1,
              b,
              Q
            );
            Z.startsWith("kiosk-") && t.HOST, _[b] || (_[b] = []), _[b].push(X);
          }
        }
        const m = new Ie(), p = i(
          b,
          A,
          m
        );
        if (p.size && _[b].length)
          for (let I = 0; I < _[b].length; I++)
            p.has(_[b][I].mesh.object_id) && (_[b][I].mesh.route_node_id = p.get(_[b][I].mesh.object_id));
        q();
      }
    });
    for (let v = 0; v < _.length; v++) {
      const b = _[v];
      for (let h = 0; h < b.length; h++)
        u.add(b[h].object_id);
    }
    return [_, A, u];
  }, [i, r, n, o, q, t.HOST, e]);
  return {
    GeometriesAndMaterials: a,
    graph: l,
    escalator_nodes: s,
    allSvgObjectIds: c
  };
}, T5 = () => {
  const { allIndexedRetailers: e, allIndexedMapObjects: t, floorsData: l, mapConfig: r } = o4(), { getRenderOrder: n } = f3(), o = (v, b, h, d, C, f, m, p) => {
    for (let I = 0; I < v.length; I++)
      i(v[I], b, h, d, C, f, m, p);
  }, i = (v, b, h, d, C, f, m, p) => {
    let I = b.getObjectByProperty("object_id", v.map_obj_name);
    I && add_store_name_logo(I, h, d, C, f, m, p, b);
  }, q = (v) => (Array.isArray(v) || (v = [v]), v.reduce((h, d) => (d.geometry.boundingBox || d.geometry.computeBoundingBox(), h.union(d.geometry.boundingBox), h), new Y9())), a = (v, b, h, d, C) => {
    let f = C[v];
    b.z = -h.z, d.rotateZ(((f == null ? void 0 : f.rotate) || 0) * Math.PI / 180), d.scale.y *= -1, b.x += (f == null ? void 0 : f.offset_x) || 0, b.y += (f == null ? void 0 : f.offset_y) || 0, d.position.set(b.x, b.y, b.z + 1);
  }, s = async (v) => {
    try {
      const b = J2(v, r);
      return b;
    } catch (b) {
      return console.error("Error fetching or converting the image:", b), "";
    }
  }, c = (v, b) => new Promise((h, d) => {
    var C;
    if (v.obj_type === "retailer")
      b ? s(b.logo).then((f) => {
        h(f || b.logo);
      }) : (console.error("retailer not found"), h(""));
    else if (v.obj_type === "special") {
      let f = v.value;
      if (v.layer_type === "kiosk" && (f = "kiosk"), v.layer_type === "escalator" && (f = "escalator"), f) {
        let m = "222222";
        v.text_color != null && (m = v.text_color.replace("#", ""));
        const p = document.getElementById("map-special-svg-" + f);
        if (p) {
          const I = p.querySelector("svg");
          if (I) {
            const w = I.cloneNode(!0);
            w.querySelectorAll("[fill]").forEach((k) => {
              k.setAttribute("fill", "#" + m);
            });
            const L = new XMLSerializer().serializeToString(w), j = new Blob([L], { type: "image/svg+xml" }), $ = URL.createObjectURL(j);
            h($);
          } else
            console.error("svg_element not found", f), h("");
        } else
          console.error("svg_block not found", f), h("");
      }
    } else
      v.custom_image !== "" && ((C = v == null ? void 0 : v.custom_image) != null && C.startsWith("http")) ? h(J2(v.custom_image, r)) : (console.error("custom_image URL not found"), h(""));
  }), u = (v, b, h) => {
    const d = document.createElement("img");
    d.crossOrigin = "anonymous", d.src = v, d.onload = function() {
      const C = document.getElementById("temp-image-rendering");
      C && (d.style.height = "100px", C.appendChild(d), setTimeout(() => {
        const f = document.createElement("canvas"), m = f.getContext("2d");
        if (m) {
          f.width = d.width * x8, f.height = d.height * x8, m == null || m.drawImage(d, 0, 0, f.width, f.height);
          let p = new Z9(f);
          p.colorSpace = "srgb";
          const I = new Ce(b.size, b.size * d.height / d.width), w = new I4({
            map: p,
            transparent: !0,
            side: d2,
            depthTest: !1,
            depthWrite: !1
          });
          b.layer_type === "kiosk" && (w.visible = !1), h(I, w);
        }
      }, 100));
    }, d.onerror = function() {
      console.error("processImage():: Error loading image:", v);
    };
  }, _ = o1((v, b, h, d, C, f, m, p, I, w) => {
    c(h, b[h.retailer_id]).then((T) => {
      T && u(T, h, (L, j) => {
        var t1;
        const $ = new Y2(L, j), k = d.floor_index;
        a(C, m, p, $, v), $.object_id = f, $.floor_index = k, $.renderOrder = n("layer-image"), (t1 = I[k]) == null || t1.objsGroup.add($), w({ storeLogo: $ });
      });
    });
  }, [n]), A = o1((v, b, h, d, C, f) => {
    const m = d + b;
    let p = null;
    if (v.boundingBox || v.computeBoundingBox(), !v.boundingBox)
      return null;
    const I = v.boundingBox, w = new L1();
    I.getCenter(w);
    const T = new L1();
    I.getSize(T);
    let L = t[b] ? t[b] : { layer_type: b.startsWith("escalator") ? "escalator" : "custom_text", custom_text: "", size: 8 };
    if (["retail_name", "retail_text", "custom_text"].includes(L.layer_type)) {
      let j = "";
      L.layer_type === "retail_name" && L.retailer_id && e[L.retailer_id] ? j = e[L.retailer_id].retail_name : ["retail_text", "custom_text"].includes(L.layer_type) ? j = L.custom_text : j = "";
      let $ = r.STORE_TEXT_COLOR;
      L.text_color && ($ = P1(L.text_color));
      const k = {
        color: $,
        transparent: !1,
        side: d2,
        depthWrite: !1,
        depthTest: !1
      };
      let t1 = new I4(k), e1 = new R5(j, {
        font: C,
        size: parseInt(L.size),
        height: 0.01,
        curveSegments: 4
      });
      e1.center();
      const Q = new Y2(e1, t1);
      Q.userData.debug_name = j, Q.userData.font = C, a(b, w, T, Q, t), Q.object_id = m, Q.floor_index = h, Q.renderOrder = n("layer-text"), L.layer_type === "retail_name" && (Q.userData.retail_name = j), l[h].objsGroup.add(Q), p = { textMesh: Q };
    } else (L.layer_type === "retail_logo" || L.layer_type === "custom_image" || L.obj_type === "special" && L.layer_type === "kiosk" && L.kiosk_id != null || L.obj_type === "special" && L.layer_type === "amenity" && L.value !== "" || L.layer_type === "escalator") && _(t, e, L, v, b, m, w, T, l, f);
    return p;
  }, [t, e, l, _, n, r.STORE_TEXT_COLOR]);
  return {
    drawTextLogoStoreOnMap: o,
    addTextOrLogoOnStore: i,
    getMeshGroupBoundingBox: q,
    layer_text_logo_position_by_id: a,
    getImage: c,
    processImage: u,
    getImageLogo: _,
    get_store_name_logo_geometry: A
  };
};
let F3 = [];
const Wl = () => {
  const { mapConfig: e, initialFloorsDataIsLoaded: t, allIndexedMapObjects: l, allIndexedRetailers: r, allMapObjects: n, allNodesFloor: o, pathFinderGraph: i, setPathFinderGraph: q, mapApiResponse: a } = o4(), [s, c] = m1([]), [u, _] = m1([]), [A, v] = m1([]), [b, h] = m1([]), d = v1(0);
  let C = ue(Le, a.floors.map(($) => J2($.svgUrl, e)));
  const { GeometriesAndMaterials: f, graph: m, escalator_nodes: p, allSvgObjectIds: I } = Hl(C), { get_store_name_logo_geometry: w } = T5(), T = J9(U9), L = o1(($, k) => (t1) => {
    if (k !== d.current) return;
    const e1 = t1.storeLogo.uuid;
    v((Q) => {
      const Z = Q[$] ?? [];
      if (Z.some((G) => G.storeLogo.uuid === e1))
        return Q;
      const X = Q.slice();
      return X[$] = [...Z, { storeLogo: t1.storeLogo }], X;
    });
  }, []), j = o1(() => {
    c(($) => ($ && $.forEach((k) => {
      k && k.forEach((t1) => {
        t1.mesh.removeFromParent();
      });
    }), [])), _(($) => ($ && $.forEach((k) => {
      k && k.forEach((t1) => {
        t1.textMesh.removeFromParent();
      });
    }), [])), v(($) => ($ && $.forEach((k) => {
      k && k.forEach((t1) => {
        t1.storeLogo.removeFromParent();
      });
    }), []));
  }, []);
  return g1(() => {
    if (t && e.HOST === "PORTAL")
      return () => {
        j();
      };
  }, [j, t]), g1(() => () => {
    j();
  }, []), g1(() => {
    if (!T || !C) return;
    const $ = ++d.current;
    v([]);
    const k = [];
    if (F3.forEach((Q) => {
      let Z;
      for (let G = 0; G < f.length && (Z = f[G].find((a1) => a1.object_id === Q.map_obj_name), Z === void 0); G++)
        ;
      if (!Z) return null;
      const X = w(Z.geometry, Q.map_obj_name, Z.floor_index, U2, T, L(Z.floor_index, $));
      X && (k[Z.floor_index] || (k[Z.floor_index] = []), k[Z.floor_index].push(X));
    }), f.reduce((Q, Z) => Q + Z.length, 0) - F3.length !== 0) {
      const Q = /* @__PURE__ */ new Set();
      F3.forEach((Z) => {
        Q.add(Z.map_obj_name);
      }), f.forEach((Z) => {
        Z.forEach((X) => {
          if (!Q.has(X.object_id)) {
            const G = w(
              X.geometry,
              X.object_id,
              X.floor_index,
              U2,
              T,
              L(X.floor_index, $)
            );
            G && (k[X.floor_index] || (k[X.floor_index] = []), k[X.floor_index].push(G));
          }
        });
      });
    }
    c([...f]), _(k), q(m), h([...p]);
  }, [C, T, l, r, n, o, i, e, q, L, f, w, m, p]), j1(() => ({
    meshParams: s,
    textParams: u,
    storeLogos: A,
    pathFinderGraph: i,
    escalator_nodes: b,
    allSvgObjectIds: I
  }), [s, u, A, i, b, I]);
}, jl = (e) => {
  const { scene: t } = S6();
  return e.background && (t.background = new m2(e.background)), null;
}, Xl = (e) => {
  const { camera: t } = S6(), l = e.far || e.near || e.fov;
  return e.far && (t.far = e.far), e.near && (t.near = e.near), t instanceof B2 && e.fov && (t.fov = e.fov), l && t.updateProjectionMatrix(), null;
}, Zl = 10;
function R2(e) {
  return e === "WEBSITE" || e === "DISPLAY_APP";
}
function Yl() {
  return { pointerId: null, x: 0, y: 0, maxDist: 0, active: !1 };
}
function k8(e, t, l, r = null) {
  e.active || (e.active = !0, e.pointerId = r, e.x = t, e.y = l, e.maxDist = 0);
}
function a6(e, t, l, r = null) {
  if (!e.active || e.pointerId != null && r != null && r !== e.pointerId) return;
  const n = Math.hypot(t - e.x, l - e.y);
  n > e.maxDist && (e.maxDist = n);
}
function Jl(e, t, l, r = null) {
  e.active && (e.pointerId != null && r != null && r !== e.pointerId || (a6(e, t, l, r), e.active = !1, e.pointerId = null));
}
function a2(e) {
  var r, n, o;
  const t = e.clientX ?? ((r = e.nativeEvent) == null ? void 0 : r.clientX), l = e.clientY ?? ((n = e.nativeEvent) == null ? void 0 : n.clientY);
  return typeof t != "number" || typeof l != "number" || !Number.isFinite(t) || !Number.isFinite(l) ? null : { x: t, y: l, pointerId: e.pointerId ?? ((o = e.nativeEvent) == null ? void 0 : o.pointerId) ?? null };
}
function Ul(e, t) {
  const l = Number.isFinite(t) ? t : 0;
  return Math.max(e, l) > Zl;
}
function V8(e) {
  return e < 0.5 ? 4 * e * e * e : 1 - Math.pow(-2 * e + 2, 3) / 2;
}
function $l({ mesh: e }) {
  const t = v1(null);
  return g1(() => {
    var o;
    if (!e)
      return;
    if (!((o = e.geometry.index) != null && o.count)) {
      console.log("NO ROUTE TUBE GEOMETRY INDEX COUNT");
      return;
    }
    if (!(e.material instanceof I4))
      return;
    if (!e.material.map) {
      console.log("NO ROUTE TEXTURE");
      return;
    }
    e.geometry.setDrawRange(0, 0);
    const l = e.geometry.index.count, r = (() => {
      const q = performance.now();
      return () => {
        const a = (performance.now() - q) / 1e3, s = Math.floor(V8(a) * l);
        a >= 1 && (t.current = n), e.geometry.setDrawRange(0, s);
      };
    })(), n = (() => {
      if (!(e.material instanceof I4) || !e.material.map)
        return null;
      const i = e.material.map.offset, q = 2e3, a = 0.1, s = 1 + a, c = performance.now();
      return () => {
        const u = (performance.now() - c) / q % 1;
        i.x = a - s * V8(u);
      };
    })();
    return t.current = r, () => {
      t.current = null, e.removeFromParent(), e.material instanceof I4 && e.material.dispose(), e.geometry && e.geometry.dispose();
    };
  }, [e]), j9(() => {
    if (t.current)
      try {
        t.current();
      } catch (l) {
        console.error(`ERROR ANIMATE ROUTE: ${l.message}`), t.current = null;
      }
  }), e ? /* @__PURE__ */ V("primitive", { object: e }) : null;
}
const Kl = "_escalator_elems_1kqb9_1", Ql = "_element_1kqb9_4", en = "_svgIcon_1kqb9_21", tn = "_label_1kqb9_34", O2 = {
  escalator_elems: Kl,
  element: Ql,
  svgIcon: en,
  label: tn
}, ln = "_mapCenterMarker_1eu0j_18", nn = {
  mapCenterMarker: ln
}, H8 = ({ size: e, lockSize: t, blink: l, cameraLength: r, text_color: n = "black" }) => {
  const { mapConfig: o } = o4(), [, i] = m1(1), [q, a] = m1(null), s = t ? 5 * e / 256 : 8 * e;
  g1(() => {
    !t && r !== void 0 && i(1 - (r - o.CAMERA.minDistance) / (o.CAMERA.maxDistance - o.CAMERA.minDistance));
  }, [t, o, r]);
  const c = j1(() => q ? new Ee({ map: q, sizeAttenuation: !t, depthTest: !1, depthWrite: !1, color: n }) : null, [t, q, n]);
  return g1(() => {
    var _;
    const u = (_ = document.getElementById("map-special-svg-kiosk")) == null ? void 0 : _.querySelector("svg");
    if (u) {
      const A = u.cloneNode(!0), v = new XMLSerializer().serializeToString(A), b = new Blob([v], { type: "image/svg+xml" }), h = URL.createObjectURL(b), d = document.createElement("canvas");
      d.width = 256, d.height = 256;
      const C = d.getContext("2d"), f = document.createElement("img");
      f.src = h, f.onload = () => {
        C == null || C.drawImage(f, 96, 0, 64, 128);
        const m = new Ae(d);
        m.needsUpdate = !0, a(m);
      };
    }
  }, []), c ? /* @__PURE__ */ x1("group", { children: [
    /* @__PURE__ */ V("sprite", { scale: s, material: c }),
    l && /* @__PURE__ */ V(T6, { children: /* @__PURE__ */ V("div", { className: `mapCenterMarker ${nn.mapCenterMarker}` }) })
  ] }) : null;
}, W8 = (e) => {
  const { type: t, mesh: l, currentFloorIndex: r } = e;
  g1(() => (l.userData.triggerUpdate = () => {
  }, () => l.userData.triggerUpdate = void 0), [l.userData]);
  const { cameraLength: n } = o4();
  switch (t) {
    case "storeLogo":
      return l.userData.kioskConfig && l.userData.kioskConfig.floorIndex === r ? /* @__PURE__ */ V("primitive", { object: l, children: /* @__PURE__ */ V(H8, { size: l.userData.kioskConfig.size, blink: l.userData.kioskConfig.blink, cameraLength: n, lockSize: l.userData.kioskConfig.lockSize, text_color: l.userData.kioskConfig.text_color }) }, l.uuid) : /* @__PURE__ */ V("primitive", { object: l, children: l.userData.htmlContent ? /* @__PURE__ */ V(T6, { style: { pointerEvents: "none" }, distanceFactor: l.userData.distanceFactor, children: l.userData.htmlContent }) : null }, l.uuid);
    case "kiosk":
      return l.userData.kioskConfig && l.userData.kioskConfig.floorIndex === r ? /* @__PURE__ */ V(H8, { size: l.userData.kioskConfig.size, blink: l.userData.kioskConfig.blink, cameraLength: n, lockSize: l.userData.kioskConfig.lockSize, text_color: l.userData.kioskConfig.text_color }) : null;
    default:
      return null;
  }
}, rn = (e) => {
  const { meshFloors: t, routeTube: l, floorIndex: r, currentFloorIndex: n, activeObjectId: o, hoverObjectId: i, visible: q, handleChangeFloor: a } = e, { mapConfig: s, floorsData: c } = o4(), { meshParams: u, textParams: _, storeLogos: A } = t, v = c[r], b = e.onPointerMove, h = e.onPointerEnter, d = e.onPointerLeave, C = e.onPointerDown, f = e.onClick, m = u[r], p = _[r], I = A[r], w = c[r].escalatorMeshes;
  return /* @__PURE__ */ x1("group", { visible: q, children: [
    m == null ? void 0 : m.map((T, L) => {
      if (!T.mesh) return null;
      const j = q && T.mesh.visible && v.interactiveObjs && v.interactiveObjs.includes(T.mesh), $ = i && T.mesh.object_id === i, k = o && T.mesh.object_id === o;
      if (j && T.mesh.material instanceof I4) {
        const t1 = T.mesh.material.colorDefault;
        if (t1) {
          const e1 = k ? s.ACCENT_COLOR : t1;
          T.mesh.material.color.copy(
            $ ? Ye(e1) : $9(e1)
          );
        }
      }
      return /* @__PURE__ */ V("group", { ...j ? { onPointerOver: h, onPointerDown: C, onPointerMove: b, onPointerOut: d, onClick: f } : {}, children: /* @__PURE__ */ V("primitive", { object: T.mesh }) }, `mesh-${r}-${L}-${T.mesh.uuid}`);
    }),
    p == null ? void 0 : p.map((T, L) => T.textMesh ? /* @__PURE__ */ V(J1.Fragment, { children: /* @__PURE__ */ V("primitive", { object: T.textMesh, children: T.textMesh.userData.kioskConfig ? /* @__PURE__ */ V(W8, { mesh: T.textMesh, currentFloorIndex: n, type: "kiosk", visible: q }) : null }) }, `text-${r}-${L}-${T.textMesh.uuid}`) : null),
    I == null ? void 0 : I.filter((T, L, j) => T.storeLogo ? j.findIndex(($) => {
      var k;
      return ((k = $.storeLogo) == null ? void 0 : k.uuid) === T.storeLogo.uuid;
    }) === L : !1).map((T, L) => /* @__PURE__ */ V(W8, { mesh: T.storeLogo, currentFloorIndex: n, type: "storeLogo", visible: q }, `logo-${r}-${L}-${T.storeLogo.uuid}`)),
    w == null ? void 0 : w.map((T, L) => {
      var j, $;
      return /* @__PURE__ */ V("primitive", { object: T, children: /* @__PURE__ */ V(T6, { visible: !0, position: (j = T.geometry.boundingSphere) == null ? void 0 : j.center, children: /* @__PURE__ */ V(
        "div",
        {
          className: `escalator_elems ${O2.escalator_elems}`,
          style: { display: q ? "block" : "none" },
          onClick: (k) => {
            var t1;
            return k.stopPropagation(), a(((t1 = T.goToFloor) == null ? void 0 : t1.index) || 0), !1;
          },
          onPointerMove: (k) => k.stopPropagation(),
          children: /* @__PURE__ */ x1("div", { className: `element ${O2.element}`, id: T.object_id, children: [
            /* @__PURE__ */ V("div", { className: `svgIcon ${O2.svgIcon}`, dangerouslySetInnerHTML: { __html: K9("escalator") } }),
            /* @__PURE__ */ x1("div", { className: `label ${O2.label}`, children: [
              ($ = T.goToFloor) == null ? void 0 : $.direction,
              ": ",
              T.goToFloor ? c[T.goToFloor.index].name : ""
            ] })
          ] })
        }
      ) }) }, `escalator-${r}-${L}-${T.object_id}`);
    }),
    /* @__PURE__ */ V($l, { mesh: l })
  ] });
};
function j8(e, t, l, r) {
  if (Array.isArray(e) || (e = [e]), !e.length)
    return console.warn("get_camera_focus_object: no objects passed"), { position: new L1(), target: new L1() };
  const n = e.reduce((b, h) => (h.geometry.boundingBox || h.geometry.computeBoundingBox(), h.geometry.boundingBox && b.union(h.geometry.boundingBox), b), new Y9()), o = new L1();
  n.getSize(o);
  const i = new L1();
  n.getCenter(i), e[0].localToWorld(i);
  let q = Math.tan(Math.PI * t / 360), a = 1.1, s = o.x * a / 2 / (q * l), c = o.y * a / 2 / q, u = Math.max(s, c), _ = on(u, r);
  const A = new L1(i.x, 0, i.z);
  return { position: new L1(i.x, u, i.z + _), target: A };
}
function on(e, t) {
  let l = 60;
  return t === "2D" && (l = 89.9), e / Math.tan(l * Math.PI / 180);
}
const an = G4((e, t) => {
  const { mapConfig: l, allMapObjects: r, allIndexedMapObjects: n, allNodesFloor: o, mapApiResponse: i, pathFinderGraph: q, setCameraLength: a, floorsData: s } = o4(), { make_amenity_route: c, create_route: u } = O5(), [_, A] = m1(!1), {
    meshFloors: v,
    currentFloorIndex: b,
    currKioskObj: h,
    currKioskFloorIndex: d,
    routeTargetId: C,
    routeTargetFromId: f,
    selectedAmenityType: m,
    handleChangeFloor: p,
    escalatorNodes: I,
    zoom: w,
    handleCameraLength: T,
    handleCameraAndControlsChange: L,
    activeObjectId: j,
    isSelectedRetailerSlug: $,
    setIsCameraInit: k,
    handleObjectClick: t1,
    triggerClick: e1,
    cameraControlsPosition: Q,
    deviceType: Z
  } = e, [X, G] = m1({ min: l.CAMERA.minDistance, max: l.CAMERA.maxDistance, initialDistance: 0, needsUpdate: !0 }), a1 = v1(null), [F, M] = m1([]), H = v1(null), { camera: W, scene: S } = S6(), E = v1(null), g = l.STYLE, x = l.ACCENT_COLOR, R = h ? h.object_id : f || void 0, Y = l.HOST === "PORTAL" && C, B = o1((D = !1) => {
    if (!(W instanceof B2)) {
      console.error("Camera is not a PerspectiveCamera");
      return;
    }
    const O = v.meshParams[d];
    if (!(O != null && O.length)) {
      console.warn("objects not loaded yet");
      return;
    }
    let y;
    y = O.map((I1) => I1.mesh);
    const n1 = j8(y, W.fov, W.aspect, l.HOST === "PORTAL" ? "2D" : g);
    let i1 = !0;
    if (Q) {
      let I1 = Q.camera;
      I1 instanceof L1 || (I1 = new L1(I1.x, I1.y, I1.z)), i1 = I1.length() === 0;
    }
    !D && Q && !i1 && !["PORTAL"].includes(l.HOST) && (n1.position.set(Q.camera.x, Q.camera.y, Q.camera.z), n1.target.set(Q.controls.x, Q.controls.y, Q.controls.z));
    const y1 = Math.min(
      X.max,
      Math.max(
        X.min,
        n1.position.distanceTo(n1.target)
      )
    );
    n1.position.sub(n1.target).setLength(y1).add(n1.target), E.current = {
      ...n1,
      fromPosition: H.current.object.position.clone(),
      fromTarget: H.current.target.clone(),
      animationStartTime: performance.now(),
      duration: l.CAMERA.animSpeed
      // how long it takes to move camera to get to new position
    }, ["DISPLAY_APP", "WEBSITE"].includes(l.HOST) && X.needsUpdate === !1 && X.initialDistance > 0 && G((I1) => ({
      ...I1,
      min: l.CAMERA.minDistance < 0.1 ? 0.1 : l.CAMERA.minDistance,
      max: l.CAMERA.maxDistance
    }));
  }, [W, X.needsUpdate, l.CAMERA.animSpeed, l.CAMERA.maxDistance, l.CAMERA.minDistance, Q, l.HOST, d, v.meshParams, g]), K = E.current ? E.current.position.distanceTo(E.current.target) : 0;
  g1(() => {
    Q && B();
  }, [Q, B]), g1(() => {
    K > 0 && X.needsUpdate && (G({ min: l.CAMERA.minDistance < 0.1 ? 0.1 : l.CAMERA.minDistance, max: l.CAMERA.maxDistance, initialDistance: K, needsUpdate: !1 }), k(!0));
  }, [K, X.needsUpdate, l.CAMERA, k]), g1(() => {
    G((D) => ({ ...D, needsUpdate: !0 }));
  }, [l.CAMERA]), g1(() => {
    v.meshParams.length > 0 && B();
  }, [v.meshParams.length, B]), g1(() => {
    if (!m || l.HOST === "PORTAL") {
      M([]);
      return;
    }
    const { routePaths: D, fromFloor: O } = c(R ?? "", m, S, I, g);
    M(D), O !== void 0 && p(O), h && l.HOST === "DISPLAY_APP" && p(d);
  }, [m, S, q, s, I, g, R, l.HOST, o, n, c, h, p, d]);
  const z = o1(() => {
    s.flat().forEach((D) => D.escalatorMeshes = []);
  }, [s]);
  g1(() => {
    if (!R || !C || l.HOST === "PORTAL") {
      if (l.HOST === "PORTAL")
        if (C) {
          const y = S.getObjectByProperty("object_id", C);
          y && M([y]);
        } else
          z(), M([]);
      else m || (z(), M([]));
      return;
    }
    m || s.forEach((y) => {
      y.escalatorMeshes = [];
    });
    const { routePaths: D, fromFloor: O } = u(o, R, C, S, s, v.escalator_nodes, q, g);
    M(D), O !== void 0 && p(O);
  }, [R, C, S, W, s, x, q, g, v.escalator_nodes, m, l.HOST, o, e1, u, z, p]);
  const l1 = v.meshParams[b];
  g1(() => {
    var i1;
    if (l.HOST === "PORTAL_RESPONSIVE") return;
    if (!(W instanceof B2)) {
      console.error("Camera is not a PerspectiveCamera");
      return;
    }
    if (!(l1 != null && l1.length)) {
      console.warn("objects not loaded yet");
      return;
    }
    let D = (i1 = s[b]) == null ? void 0 : i1.routeMeshes;
    if (!j && !m)
      return;
    let O = [];
    if (F[b] && (D != null && D.length))
      O = [...D];
    else if (j && (l.HOST === "PORTAL" || $)) {
      const y1 = C && l1.find((I1) => I1.mesh.object_id === C);
      y1 && (O = [y1.mesh]);
    }
    O.length || (O = l1.map((y1) => y1.mesh));
    const y = j8(O, W.fov, W.aspect, l.HOST === "PORTAL" || l.HOST === "WEBSITE" ? "2D" : g), n1 = Math.min(
      Y ? l.CAMERA.maxDistance : X.max,
      Math.max(
        Y ? l.CAMERA.minDistance : X.min,
        y.position.distanceTo(y.target)
      )
    );
    y.position.sub(y.target).setLength(n1).add(y.target), E.current = {
      ...y,
      fromPosition: H.current.object.position.clone(),
      fromTarget: H.current.target.clone(),
      animationStartTime: performance.now(),
      duration: l.CAMERA.animSpeed
      // how long it takes to move camera to get to new position
    };
  }, [F, l1, b, g, W, C, l.HOST, l.CAMERA.maxDistance, l.CAMERA.minDistance, l.CAMERA.animSpeed, s, j, m, $, Y, X.max, X.min]), g1(() => {
    if (w != null && w.direction && H.current) {
      if (!(W instanceof B2)) {
        console.error("Camera is not a PerspectiveCamera");
        return;
      }
      if (!l1.length) {
        console.warn("objects not loaded yet");
        return;
      }
      let D;
      if (F[b]) {
        D = [F[b]];
        const n1 = C && l1.find((i1) => i1.mesh.object_id === C);
        n1 && D.push(n1.mesh);
      } else
        D = l1.map((n1) => n1.mesh);
      const O = {
        position: H.current.object.position.clone(),
        target: H.current.target.clone()
      };
      let y = parseInt(O.position.distanceTo(O.target));
      w.direction === "in" ? y -= l.ZOOM_STEP : y += l.ZOOM_STEP, y = Math.min(
        X.max,
        Math.max(
          X.min,
          y
        )
      ), O.position.sub(O.target).setLength(y).add(O.target), E.current = {
        ...O,
        fromPosition: H.current.object.position.clone(),
        fromTarget: H.current.target.clone(),
        animationStartTime: performance.now(),
        duration: l.CAMERA.animSpeed
        // how long it takes to move camera to get to new position
      };
    }
  }, [w]);
  const U = () => X.initialDistance, J = o1((D) => {
    if (T) {
      const O = new L1();
      O.copy(D.target.object.position), O.sub(H.current.target), T(O.length()), a(O.length()), L && L({
        camera: H.current.object.position.clone(),
        controls: H.current.target.clone()
      });
    }
  }, [T, L, a]);
  j9(() => {
    var D, O;
    if ((D = E.current) != null && D.duration && ((O = E.current) == null ? void 0 : O.duration) > 0) {
      _ || (A(!0), E.current.duration = 0);
      const y = E.current, n1 = (performance.now() - y.animationStartTime) / 1e3, i1 = Math.min(1, n1 / (y == null ? void 0 : y.duration));
      H.current.object.position.lerpVectors(y.fromPosition, y.position, i1), H.current.target.lerpVectors(y == null ? void 0 : y.fromTarget, y.target, i1), H.current.object.updateProjectionMatrix(), i1 >= 1 && (E.current = null);
    }
  });
  const N = o1((D) => {
    if (D > 0) {
      const O = i.retailers.find((y) => y.id === D);
      if (O) {
        const y = i.map_objs.filter((n1) => n1.retailer_id === O.id);
        for (let n1 = 0; n1 < y.length; n1++)
          if (r.includes(y[n1].map_obj_name)) {
            const i1 = S.getObjectByProperty("object_id", y[n1].map_obj_name);
            i1 && t1(i1, y[n1].map_obj_name, !0);
            break;
          }
      }
    }
  }, [t1, i, S]);
  return E6(t, () => ({
    resetCamera: B,
    createRouteToStore: N,
    getInitialDistance: U
  })), /* @__PURE__ */ x1("group", { rotation: [Math.PI / 2, 0, 0], ref: a1, children: [
    /* @__PURE__ */ V(
      Re,
      {
        makeDefault: !0,
        onChange: J,
        ref: H,
        maxPolarAngle: Math.PI / 2,
        minDistance: Y ? y4.CAMERA.minDistance : X.min,
        maxDistance: Y ? y4.CAMERA.maxDistance : X.max,
        enableZoom: l.HOST === "PORTAL" || l.HOST === "DISPLAY_APP" || l.HOST === "WEBSITE" && ["mobile", "tablet"].includes(Z),
        enableRotate: l.HOST !== "WEBSITE" && l.HOST !== "PORTAL_RESPONSIVE" && l.HOST !== "DISPLAY_APP",
        enableDamping: !1,
        zoomSpeed: 1,
        zoomToCursor: !0
      }
    ),
    s && s.map((D, O) => /* @__PURE__ */ V(
      rn,
      {
        visible: b === O,
        floorIndex: O,
        currentFloorIndex: b,
        currKioskObj: e.currKioskObj,
        activeObjectId: e.activeObjectId,
        hoverObjectId: e.hoverObjectId,
        meshFloors: v,
        routeTube: l.HOST !== "PORTAL" ? F && F[O] : void 0,
        onPointerEnter: e.onPointerEnter,
        onPointerLeave: e.onPointerLeave,
        onPointerMove: e.onPointerMove,
        onPointerDown: e.onPointerDown,
        onClick: e.onClick,
        handleChangeFloor: p
      },
      `Map-${O}`
    ))
  ] });
}), qn = "_threejsMapWrapper_42rlr_1", sn = "_threejsMap_42rlr_1", cn = "_map_controls_42rlr_23", un = "_amenities_42rlr_112", mn = "_amenity_42rlr_124", dn = "_content_42rlr_157", fn = "_icon_42rlr_166", xn = "_name_42rlr_179", _4 = {
  threejsMapWrapper: qn,
  threejsMap: sn,
  map_controls: cn,
  amenities: un,
  amenity: mn,
  content: dn,
  icon: fn,
  name: xn
}, hn = (e) => {
  const { selectedFloorIndex: t, handleFloorChange: l, amenitiesList: r, zoomIn: n, zoomOut: o, reset: i, handleAmenityClick: q, onExtractedAmenities: a } = e, { mapConfig: s, mapApiResponse: c, floorsData: u, allMapObjects: _ } = o4(), A = (b) => {
    b.preventDefault(), i instanceof Function && (s.HOST === "PORTAL_RESPONSIVE" || s.HOST === "PORTAL" ? i(!0) : i());
  }, v = j1(() => c != null && c.map_objs ? c == null ? void 0 : c.map_objs.filter((b) => b.layer_type === "amenity" && _.includes(b.map_obj_name)).map((b) => b.value) : [], [c, _]);
  return g1(() => {
    a && a(v);
  }, [a, v]), /* @__PURE__ */ V("div", { className: _4.threejsMapWrapper, children: /* @__PURE__ */ x1("div", { className: _4.threejsMap, children: [
    u.length > 0 && /* @__PURE__ */ V("div", { className: `map_controls ${_4.map_controls}`, children: /* @__PURE__ */ x1("div", { className: "map_controls_wrapper", children: [
      /* @__PURE__ */ V("div", { className: "floors btn_group", children: u.length > 1 && u.map((b, h) => /* @__PURE__ */ V("div", { className: `floor control_btn ${h === t ? "active" : ""}`, onClick: () => {
        l(h);
      }, children: b.name }, h)) }),
      /* @__PURE__ */ x1("div", { className: "reset-zoom", children: [
        /* @__PURE__ */ V("div", { onClick: A, className: "reset_btn control_btn", children: "RESET" }),
        /* @__PURE__ */ x1("div", { className: "zoom_btns", children: [
          /* @__PURE__ */ V("div", { onClick: o, className: "zoom-out control_btn", children: "–" }),
          /* @__PURE__ */ V("div", { onClick: n, className: "zoom-in control_btn", children: "+" })
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ V("div", { className: "loading_map", children: "Map loading, please wait..." }),
    !["PORTAL", "DISPLAY_APP"].includes(s.HOST) && /* @__PURE__ */ V("div", { className: `amenities ${_4.amenities}`, style: { display: "block" }, children: r.map((b, h) => v.includes(b.type) ? /* @__PURE__ */ V(
      "div",
      {
        className: `amenity ${_4.amenity}`,
        onClick: () => q(b.type),
        children: /* @__PURE__ */ x1("div", { className: `content ${_4.content}`, children: [
          /* @__PURE__ */ V("div", { className: `icon ${_4.icon}`, dangerouslySetInnerHTML: { __html: K9(b.type) } }),
          /* @__PURE__ */ V("div", { className: `name ${_4.name}`, children: b.name })
        ] })
      },
      `amenity-${b.name}-${h}`
    ) : null) })
  ] }) });
}, pn = "_mapBoxSidebar_1kqms_1", gn = "_active_1kqms_8", bn = "_sidebarWrapper_1kqms_12", _n = "_sidebarBox_1kqms_17", vn = "_mapBox_1kqms_1", yn = "_storeNamePlaceholder_1kqms_31", In = "_stats_1kqms_46", A4 = {
  mapBoxSidebar: pn,
  active: gn,
  sidebarWrapper: bn,
  sidebarBox: _n,
  mapBox: vn,
  storeNamePlaceholder: yn,
  stats: In
};
function W6(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var w5 = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function l() {
      for (var o = "", i = 0; i < arguments.length; i++) {
        var q = arguments[i];
        q && (o = n(o, r(q)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return l.apply(null, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var i = "";
      for (var q in o)
        t.call(o, q) && o[q] && (i = n(i, q));
      return i;
    }
    function n(o, i) {
      return i ? o ? o + " " + i : o + i : o;
    }
    e.exports ? (l.default = l, e.exports = l) : window.classNames = l;
  })();
})(w5);
var Cn = w5.exports;
const F1 = /* @__PURE__ */ W6(Cn);
function p1() {
  return p1 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = arguments[t];
      for (var r in l) ({}).hasOwnProperty.call(l, r) && (e[r] = l[r]);
    }
    return e;
  }, p1.apply(null, arguments);
}
function z5(e, t) {
  if (e == null) return {};
  var l = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    l[r] = e[r];
  }
  return l;
}
function e3(e, t) {
  return e3 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(l, r) {
    return l.__proto__ = r, l;
  }, e3(e, t);
}
function En(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, e3(e, t);
}
const An = ["xxl", "xl", "lg", "md", "sm", "xs"], Sn = "xs", y2 = /* @__PURE__ */ s1.createContext({
  prefixes: {},
  breakpoints: An,
  minBreakpoint: Sn
}), {
  Consumer: yc,
  Provider: Ic
} = y2;
function X1(e, t) {
  const {
    prefixes: l
  } = e4(y2);
  return e || l[t] || t;
}
function Rn() {
  const {
    breakpoints: e
  } = e4(y2);
  return e;
}
function On() {
  const {
    minBreakpoint: e
  } = e4(y2);
  return e;
}
function Tn() {
  const {
    dir: e
  } = e4(y2);
  return e === "rtl";
}
function x3(e) {
  return e && e.ownerDocument || document;
}
function wn(e) {
  var t = x3(e);
  return t && t.defaultView || window;
}
function zn(e, t) {
  return wn(e).getComputedStyle(e, t);
}
var Nn = /([A-Z])/g;
function Mn(e) {
  return e.replace(Nn, "-$1").toLowerCase();
}
var Pn = /^ms-/;
function T2(e) {
  return Mn(e).replace(Pn, "-ms-");
}
var Ln = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function Fn(e) {
  return !!(e && Ln.test(e));
}
function N4(e, t) {
  var l = "", r = "";
  if (typeof t == "string")
    return e.style.getPropertyValue(T2(t)) || zn(e).getPropertyValue(T2(t));
  Object.keys(t).forEach(function(n) {
    var o = t[n];
    !o && o !== 0 ? e.style.removeProperty(T2(n)) : Fn(n) ? r += n + "(" + o + ") " : l += T2(n) + ": " + o + ";";
  }), r && (l += "transform: " + r + ";"), e.style.cssText += ";" + l;
}
var q6 = { exports: {} }, w2 = { exports: {} }, R1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var X8;
function Bn() {
  if (X8) return R1;
  X8 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, l = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, q = e ? Symbol.for("react.context") : 60110, a = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, d = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function f(p) {
    if (typeof p == "object" && p !== null) {
      var I = p.$$typeof;
      switch (I) {
        case t:
          switch (p = p.type, p) {
            case a:
            case s:
            case r:
            case o:
            case n:
            case u:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case q:
                case c:
                case v:
                case A:
                case i:
                  return p;
                default:
                  return I;
              }
          }
        case l:
          return I;
      }
    }
  }
  function m(p) {
    return f(p) === s;
  }
  return R1.AsyncMode = a, R1.ConcurrentMode = s, R1.ContextConsumer = q, R1.ContextProvider = i, R1.Element = t, R1.ForwardRef = c, R1.Fragment = r, R1.Lazy = v, R1.Memo = A, R1.Portal = l, R1.Profiler = o, R1.StrictMode = n, R1.Suspense = u, R1.isAsyncMode = function(p) {
    return m(p) || f(p) === a;
  }, R1.isConcurrentMode = m, R1.isContextConsumer = function(p) {
    return f(p) === q;
  }, R1.isContextProvider = function(p) {
    return f(p) === i;
  }, R1.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, R1.isForwardRef = function(p) {
    return f(p) === c;
  }, R1.isFragment = function(p) {
    return f(p) === r;
  }, R1.isLazy = function(p) {
    return f(p) === v;
  }, R1.isMemo = function(p) {
    return f(p) === A;
  }, R1.isPortal = function(p) {
    return f(p) === l;
  }, R1.isProfiler = function(p) {
    return f(p) === o;
  }, R1.isStrictMode = function(p) {
    return f(p) === n;
  }, R1.isSuspense = function(p) {
    return f(p) === u;
  }, R1.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === s || p === o || p === n || p === u || p === _ || typeof p == "object" && p !== null && (p.$$typeof === v || p.$$typeof === A || p.$$typeof === i || p.$$typeof === q || p.$$typeof === c || p.$$typeof === h || p.$$typeof === d || p.$$typeof === C || p.$$typeof === b);
  }, R1.typeOf = f, R1;
}
var O1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Z8;
function Gn() {
  return Z8 || (Z8 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, l = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, q = e ? Symbol.for("react.context") : 60110, a = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, d = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function f(z) {
      return typeof z == "string" || typeof z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      z === r || z === s || z === o || z === n || z === u || z === _ || typeof z == "object" && z !== null && (z.$$typeof === v || z.$$typeof === A || z.$$typeof === i || z.$$typeof === q || z.$$typeof === c || z.$$typeof === h || z.$$typeof === d || z.$$typeof === C || z.$$typeof === b);
    }
    function m(z) {
      if (typeof z == "object" && z !== null) {
        var l1 = z.$$typeof;
        switch (l1) {
          case t:
            var U = z.type;
            switch (U) {
              case a:
              case s:
              case r:
              case o:
              case n:
              case u:
                return U;
              default:
                var J = U && U.$$typeof;
                switch (J) {
                  case q:
                  case c:
                  case v:
                  case A:
                  case i:
                    return J;
                  default:
                    return l1;
                }
            }
          case l:
            return l1;
        }
      }
    }
    var p = a, I = s, w = q, T = i, L = t, j = c, $ = r, k = v, t1 = A, e1 = l, Q = o, Z = n, X = u, G = !1;
    function a1(z) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), F(z) || m(z) === a;
    }
    function F(z) {
      return m(z) === s;
    }
    function M(z) {
      return m(z) === q;
    }
    function H(z) {
      return m(z) === i;
    }
    function W(z) {
      return typeof z == "object" && z !== null && z.$$typeof === t;
    }
    function S(z) {
      return m(z) === c;
    }
    function E(z) {
      return m(z) === r;
    }
    function g(z) {
      return m(z) === v;
    }
    function x(z) {
      return m(z) === A;
    }
    function R(z) {
      return m(z) === l;
    }
    function Y(z) {
      return m(z) === o;
    }
    function B(z) {
      return m(z) === n;
    }
    function K(z) {
      return m(z) === u;
    }
    O1.AsyncMode = p, O1.ConcurrentMode = I, O1.ContextConsumer = w, O1.ContextProvider = T, O1.Element = L, O1.ForwardRef = j, O1.Fragment = $, O1.Lazy = k, O1.Memo = t1, O1.Portal = e1, O1.Profiler = Q, O1.StrictMode = Z, O1.Suspense = X, O1.isAsyncMode = a1, O1.isConcurrentMode = F, O1.isContextConsumer = M, O1.isContextProvider = H, O1.isElement = W, O1.isForwardRef = S, O1.isFragment = E, O1.isLazy = g, O1.isMemo = x, O1.isPortal = R, O1.isProfiler = Y, O1.isStrictMode = B, O1.isSuspense = K, O1.isValidElementType = f, O1.typeOf = m;
  }()), O1;
}
var Y8;
function N5() {
  return Y8 || (Y8 = 1, process.env.NODE_ENV === "production" ? w2.exports = Bn() : w2.exports = Gn()), w2.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var B3, J8;
function Dn() {
  if (J8) return B3;
  J8 = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, l = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var i = {}, q = 0; q < 10; q++)
        i["_" + String.fromCharCode(q)] = q;
      var a = Object.getOwnPropertyNames(i).map(function(c) {
        return i[c];
      });
      if (a.join("") !== "0123456789")
        return !1;
      var s = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        s[c] = c;
      }), Object.keys(Object.assign({}, s)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return B3 = n() ? Object.assign : function(o, i) {
    for (var q, a = r(o), s, c = 1; c < arguments.length; c++) {
      q = Object(arguments[c]);
      for (var u in q)
        t.call(q, u) && (a[u] = q[u]);
      if (e) {
        s = e(q);
        for (var _ = 0; _ < s.length; _++)
          l.call(q, s[_]) && (a[s[_]] = q[s[_]]);
      }
    }
    return a;
  }, B3;
}
var G3, U8;
function j6() {
  if (U8) return G3;
  U8 = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return G3 = e, G3;
}
var D3, $8;
function M5() {
  return $8 || ($8 = 1, D3 = Function.call.bind(Object.prototype.hasOwnProperty)), D3;
}
var k3, K8;
function kn() {
  if (K8) return k3;
  K8 = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = j6(), l = {}, r = M5();
    e = function(o) {
      var i = "Warning: " + o;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function n(o, i, q, a, s) {
    if (process.env.NODE_ENV !== "production") {
      for (var c in o)
        if (r(o, c)) {
          var u;
          try {
            if (typeof o[c] != "function") {
              var _ = Error(
                (a || "React class") + ": " + q + " type `" + c + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[c] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw _.name = "Invariant Violation", _;
            }
            u = o[c](i, c, a, q, null, t);
          } catch (v) {
            u = v;
          }
          if (u && !(u instanceof Error) && e(
            (a || "React class") + ": type specification of " + q + " `" + c + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof u + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), u instanceof Error && !(u.message in l)) {
            l[u.message] = !0;
            var A = s ? s() : "";
            e(
              "Failed " + q + " type: " + u.message + (A ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (l = {});
  }, k3 = n, k3;
}
var V3, Q8;
function Vn() {
  if (Q8) return V3;
  Q8 = 1;
  var e = N5(), t = Dn(), l = j6(), r = M5(), n = kn(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(q) {
    var a = "Warning: " + q;
    typeof console < "u" && console.error(a);
    try {
      throw new Error(a);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return V3 = function(q, a) {
    var s = typeof Symbol == "function" && Symbol.iterator, c = "@@iterator";
    function u(F) {
      var M = F && (s && F[s] || F[c]);
      if (typeof M == "function")
        return M;
    }
    var _ = "<<anonymous>>", A = {
      array: d("array"),
      bigint: d("bigint"),
      bool: d("boolean"),
      func: d("function"),
      number: d("number"),
      object: d("object"),
      string: d("string"),
      symbol: d("symbol"),
      any: C(),
      arrayOf: f,
      element: m(),
      elementType: p(),
      instanceOf: I,
      node: j(),
      objectOf: T,
      oneOf: w,
      oneOfType: L,
      shape: k,
      exact: t1
    };
    function v(F, M) {
      return F === M ? F !== 0 || 1 / F === 1 / M : F !== F && M !== M;
    }
    function b(F, M) {
      this.message = F, this.data = M && typeof M == "object" ? M : {}, this.stack = "";
    }
    b.prototype = Error.prototype;
    function h(F) {
      if (process.env.NODE_ENV !== "production")
        var M = {}, H = 0;
      function W(E, g, x, R, Y, B, K) {
        if (R = R || _, B = B || x, K !== l) {
          if (a) {
            var z = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw z.name = "Invariant Violation", z;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var l1 = R + ":" + x;
            !M[l1] && // Avoid spamming the console because they are often not actionable except for lib authors
            H < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + B + "` prop on `" + R + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), M[l1] = !0, H++);
          }
        }
        return g[x] == null ? E ? g[x] === null ? new b("The " + Y + " `" + B + "` is marked as required " + ("in `" + R + "`, but its value is `null`.")) : new b("The " + Y + " `" + B + "` is marked as required in " + ("`" + R + "`, but its value is `undefined`.")) : null : F(g, x, R, Y, B);
      }
      var S = W.bind(null, !1);
      return S.isRequired = W.bind(null, !0), S;
    }
    function d(F) {
      function M(H, W, S, E, g, x) {
        var R = H[W], Y = Z(R);
        if (Y !== F) {
          var B = X(R);
          return new b(
            "Invalid " + E + " `" + g + "` of type " + ("`" + B + "` supplied to `" + S + "`, expected ") + ("`" + F + "`."),
            { expectedType: F }
          );
        }
        return null;
      }
      return h(M);
    }
    function C() {
      return h(i);
    }
    function f(F) {
      function M(H, W, S, E, g) {
        if (typeof F != "function")
          return new b("Property `" + g + "` of component `" + S + "` has invalid PropType notation inside arrayOf.");
        var x = H[W];
        if (!Array.isArray(x)) {
          var R = Z(x);
          return new b("Invalid " + E + " `" + g + "` of type " + ("`" + R + "` supplied to `" + S + "`, expected an array."));
        }
        for (var Y = 0; Y < x.length; Y++) {
          var B = F(x, Y, S, E, g + "[" + Y + "]", l);
          if (B instanceof Error)
            return B;
        }
        return null;
      }
      return h(M);
    }
    function m() {
      function F(M, H, W, S, E) {
        var g = M[H];
        if (!q(g)) {
          var x = Z(g);
          return new b("Invalid " + S + " `" + E + "` of type " + ("`" + x + "` supplied to `" + W + "`, expected a single ReactElement."));
        }
        return null;
      }
      return h(F);
    }
    function p() {
      function F(M, H, W, S, E) {
        var g = M[H];
        if (!e.isValidElementType(g)) {
          var x = Z(g);
          return new b("Invalid " + S + " `" + E + "` of type " + ("`" + x + "` supplied to `" + W + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return h(F);
    }
    function I(F) {
      function M(H, W, S, E, g) {
        if (!(H[W] instanceof F)) {
          var x = F.name || _, R = a1(H[W]);
          return new b("Invalid " + E + " `" + g + "` of type " + ("`" + R + "` supplied to `" + S + "`, expected ") + ("instance of `" + x + "`."));
        }
        return null;
      }
      return h(M);
    }
    function w(F) {
      if (!Array.isArray(F))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), i;
      function M(H, W, S, E, g) {
        for (var x = H[W], R = 0; R < F.length; R++)
          if (v(x, F[R]))
            return null;
        var Y = JSON.stringify(F, function(K, z) {
          var l1 = X(z);
          return l1 === "symbol" ? String(z) : z;
        });
        return new b("Invalid " + E + " `" + g + "` of value `" + String(x) + "` " + ("supplied to `" + S + "`, expected one of " + Y + "."));
      }
      return h(M);
    }
    function T(F) {
      function M(H, W, S, E, g) {
        if (typeof F != "function")
          return new b("Property `" + g + "` of component `" + S + "` has invalid PropType notation inside objectOf.");
        var x = H[W], R = Z(x);
        if (R !== "object")
          return new b("Invalid " + E + " `" + g + "` of type " + ("`" + R + "` supplied to `" + S + "`, expected an object."));
        for (var Y in x)
          if (r(x, Y)) {
            var B = F(x, Y, S, E, g + "." + Y, l);
            if (B instanceof Error)
              return B;
          }
        return null;
      }
      return h(M);
    }
    function L(F) {
      if (!Array.isArray(F))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var M = 0; M < F.length; M++) {
        var H = F[M];
        if (typeof H != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + G(H) + " at index " + M + "."
          ), i;
      }
      function W(S, E, g, x, R) {
        for (var Y = [], B = 0; B < F.length; B++) {
          var K = F[B], z = K(S, E, g, x, R, l);
          if (z == null)
            return null;
          z.data && r(z.data, "expectedType") && Y.push(z.data.expectedType);
        }
        var l1 = Y.length > 0 ? ", expected one of type [" + Y.join(", ") + "]" : "";
        return new b("Invalid " + x + " `" + R + "` supplied to " + ("`" + g + "`" + l1 + "."));
      }
      return h(W);
    }
    function j() {
      function F(M, H, W, S, E) {
        return e1(M[H]) ? null : new b("Invalid " + S + " `" + E + "` supplied to " + ("`" + W + "`, expected a ReactNode."));
      }
      return h(F);
    }
    function $(F, M, H, W, S) {
      return new b(
        (F || "React class") + ": " + M + " type `" + H + "." + W + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + S + "`."
      );
    }
    function k(F) {
      function M(H, W, S, E, g) {
        var x = H[W], R = Z(x);
        if (R !== "object")
          return new b("Invalid " + E + " `" + g + "` of type `" + R + "` " + ("supplied to `" + S + "`, expected `object`."));
        for (var Y in F) {
          var B = F[Y];
          if (typeof B != "function")
            return $(S, E, g, Y, X(B));
          var K = B(x, Y, S, E, g + "." + Y, l);
          if (K)
            return K;
        }
        return null;
      }
      return h(M);
    }
    function t1(F) {
      function M(H, W, S, E, g) {
        var x = H[W], R = Z(x);
        if (R !== "object")
          return new b("Invalid " + E + " `" + g + "` of type `" + R + "` " + ("supplied to `" + S + "`, expected `object`."));
        var Y = t({}, H[W], F);
        for (var B in Y) {
          var K = F[B];
          if (r(F, B) && typeof K != "function")
            return $(S, E, g, B, X(K));
          if (!K)
            return new b(
              "Invalid " + E + " `" + g + "` key `" + B + "` supplied to `" + S + "`.\nBad object: " + JSON.stringify(H[W], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(F), null, "  ")
            );
          var z = K(x, B, S, E, g + "." + B, l);
          if (z)
            return z;
        }
        return null;
      }
      return h(M);
    }
    function e1(F) {
      switch (typeof F) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !F;
        case "object":
          if (Array.isArray(F))
            return F.every(e1);
          if (F === null || q(F))
            return !0;
          var M = u(F);
          if (M) {
            var H = M.call(F), W;
            if (M !== F.entries) {
              for (; !(W = H.next()).done; )
                if (!e1(W.value))
                  return !1;
            } else
              for (; !(W = H.next()).done; ) {
                var S = W.value;
                if (S && !e1(S[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function Q(F, M) {
      return F === "symbol" ? !0 : M ? M["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && M instanceof Symbol : !1;
    }
    function Z(F) {
      var M = typeof F;
      return Array.isArray(F) ? "array" : F instanceof RegExp ? "object" : Q(M, F) ? "symbol" : M;
    }
    function X(F) {
      if (typeof F > "u" || F === null)
        return "" + F;
      var M = Z(F);
      if (M === "object") {
        if (F instanceof Date)
          return "date";
        if (F instanceof RegExp)
          return "regexp";
      }
      return M;
    }
    function G(F) {
      var M = X(F);
      switch (M) {
        case "array":
        case "object":
          return "an " + M;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + M;
        default:
          return M;
      }
    }
    function a1(F) {
      return !F.constructor || !F.constructor.name ? _ : F.constructor.name;
    }
    return A.checkPropTypes = n, A.resetWarningCache = n.resetWarningCache, A.PropTypes = A, A;
  }, V3;
}
var H3, e9;
function Hn() {
  if (e9) return H3;
  e9 = 1;
  var e = j6();
  function t() {
  }
  function l() {
  }
  return l.resetWarningCache = t, H3 = function() {
    function r(i, q, a, s, c, u) {
      if (u !== e) {
        var _ = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw _.name = "Invariant Violation", _;
      }
    }
    r.isRequired = r;
    function n() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: n,
      element: r,
      elementType: r,
      instanceOf: n,
      node: r,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: l,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, H3;
}
if (process.env.NODE_ENV !== "production") {
  var Wn = N5(), jn = !0;
  q6.exports = Vn()(Wn.isElement, jn);
} else
  q6.exports = Hn()();
var Xn = q6.exports;
const d1 = /* @__PURE__ */ W6(Xn), t9 = {
  disabled: !1
};
var Zn = process.env.NODE_ENV !== "production" ? d1.oneOfType([d1.number, d1.shape({
  enter: d1.number,
  exit: d1.number,
  appear: d1.number
}).isRequired]) : null;
process.env.NODE_ENV !== "production" && d1.oneOfType([d1.string, d1.shape({
  enter: d1.string,
  exit: d1.string,
  active: d1.string
}), d1.shape({
  enter: d1.string,
  enterDone: d1.string,
  enterActive: d1.string,
  exit: d1.string,
  exitDone: d1.string,
  exitActive: d1.string
})]);
const P5 = J1.createContext(null);
var Yn = function(t) {
  return t.scrollTop;
}, c2 = "unmounted", S4 = "exited", v4 = "entering", R4 = "entered", s6 = "exiting", g4 = /* @__PURE__ */ function(e) {
  En(t, e);
  function t(r, n) {
    var o;
    o = e.call(this, r, n) || this;
    var i = n, q = i && !i.isMounting ? r.enter : r.appear, a;
    return o.appearStatus = null, r.in ? q ? (a = S4, o.appearStatus = v4) : a = R4 : r.unmountOnExit || r.mountOnEnter ? a = c2 : a = S4, o.state = {
      status: a
    }, o.nextCallback = null, o;
  }
  t.getDerivedStateFromProps = function(n, o) {
    var i = n.in;
    return i && o.status === c2 ? {
      status: S4
    } : null;
  };
  var l = t.prototype;
  return l.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, l.componentDidUpdate = function(n) {
    var o = null;
    if (n !== this.props) {
      var i = this.state.status;
      this.props.in ? i !== v4 && i !== R4 && (o = v4) : (i === v4 || i === R4) && (o = s6);
    }
    this.updateStatus(!1, o);
  }, l.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, l.getTimeouts = function() {
    var n = this.props.timeout, o, i, q;
    return o = i = q = n, n != null && typeof n != "number" && (o = n.exit, i = n.enter, q = n.appear !== void 0 ? n.appear : i), {
      exit: o,
      enter: i,
      appear: q
    };
  }, l.updateStatus = function(n, o) {
    if (n === void 0 && (n = !1), o !== null)
      if (this.cancelNextCallback(), o === v4) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var i = this.props.nodeRef ? this.props.nodeRef.current : J4.findDOMNode(this);
          i && Yn(i);
        }
        this.performEnter(n);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === S4 && this.setState({
      status: c2
    });
  }, l.performEnter = function(n) {
    var o = this, i = this.props.enter, q = this.context ? this.context.isMounting : n, a = this.props.nodeRef ? [q] : [J4.findDOMNode(this), q], s = a[0], c = a[1], u = this.getTimeouts(), _ = q ? u.appear : u.enter;
    if (!n && !i || t9.disabled) {
      this.safeSetState({
        status: R4
      }, function() {
        o.props.onEntered(s);
      });
      return;
    }
    this.props.onEnter(s, c), this.safeSetState({
      status: v4
    }, function() {
      o.props.onEntering(s, c), o.onTransitionEnd(_, function() {
        o.safeSetState({
          status: R4
        }, function() {
          o.props.onEntered(s, c);
        });
      });
    });
  }, l.performExit = function() {
    var n = this, o = this.props.exit, i = this.getTimeouts(), q = this.props.nodeRef ? void 0 : J4.findDOMNode(this);
    if (!o || t9.disabled) {
      this.safeSetState({
        status: S4
      }, function() {
        n.props.onExited(q);
      });
      return;
    }
    this.props.onExit(q), this.safeSetState({
      status: s6
    }, function() {
      n.props.onExiting(q), n.onTransitionEnd(i.exit, function() {
        n.safeSetState({
          status: S4
        }, function() {
          n.props.onExited(q);
        });
      });
    });
  }, l.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, l.safeSetState = function(n, o) {
    o = this.setNextCallback(o), this.setState(n, o);
  }, l.setNextCallback = function(n) {
    var o = this, i = !0;
    return this.nextCallback = function(q) {
      i && (i = !1, o.nextCallback = null, n(q));
    }, this.nextCallback.cancel = function() {
      i = !1;
    }, this.nextCallback;
  }, l.onTransitionEnd = function(n, o) {
    this.setNextCallback(o);
    var i = this.props.nodeRef ? this.props.nodeRef.current : J4.findDOMNode(this), q = n == null && !this.props.addEndListener;
    if (!i || q) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var a = this.props.nodeRef ? [this.nextCallback] : [i, this.nextCallback], s = a[0], c = a[1];
      this.props.addEndListener(s, c);
    }
    n != null && setTimeout(this.nextCallback, n);
  }, l.render = function() {
    var n = this.state.status;
    if (n === c2)
      return null;
    var o = this.props, i = o.children;
    o.in, o.mountOnEnter, o.unmountOnExit, o.appear, o.enter, o.exit, o.timeout, o.addEndListener, o.onEnter, o.onEntering, o.onEntered, o.onExit, o.onExiting, o.onExited, o.nodeRef;
    var q = z5(o, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ J1.createElement(P5.Provider, {
        value: null
      }, typeof i == "function" ? i(n, q) : J1.cloneElement(J1.Children.only(i), q))
    );
  }, t;
}(J1.Component);
g4.contextType = P5;
g4.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A React reference to DOM element that need to transition:
   * https://stackoverflow.com/a/51127130/4671932
   *
   *   - When `nodeRef` prop is used, `node` is not passed to callback functions
   *      (e.g. `onEnter`) because user already has direct access to the node.
   *   - When changing `key` prop of `Transition` in a `TransitionGroup` a new
   *     `nodeRef` need to be provided to `Transition` with changed `key` prop
   *     (see
   *     [test/CSSTransition-test.js](https://github.com/reactjs/react-transition-group/blob/13435f897b3ab71f6e19d724f145596f5910581c/test/CSSTransition-test.js#L362-L437)).
   */
  nodeRef: d1.shape({
    current: typeof Element > "u" ? d1.any : function(e, t, l, r, n, o) {
      var i = e[t];
      return d1.instanceOf(i && "ownerDocument" in i ? i.ownerDocument.defaultView.Element : Element)(e, t, l, r, n, o);
    }
  }),
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: d1.oneOfType([d1.func.isRequired, d1.element.isRequired]).isRequired,
  /**
   * Show the component; triggers the enter or exit states
   */
  in: d1.bool,
  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: d1.bool,
  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: d1.bool,
  /**
   * By default the child component does not perform the enter transition when
   * it first mounts, regardless of the value of `in`. If you want this
   * behavior, set both `appear` and `in` to `true`.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: d1.bool,
  /**
   * Enable or disable enter transitions.
   */
  enter: d1.bool,
  /**
   * Enable or disable exit transitions.
   */
  exit: d1.bool,
  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function(t) {
    var l = Zn;
    t.addEndListener || (l = l.isRequired);
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      n[o - 1] = arguments[o];
    return l.apply(void 0, [t].concat(n));
  },
  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. Timeouts are still used as a fallback if provided.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: d1.func,
  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: d1.func,
  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: d1.func,
  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: d1.func,
  /**
   * Callback fired before the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: d1.func,
  /**
   * Callback fired after the "exiting" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: d1.func,
  /**
   * Callback fired after the "exited" status is applied.
   *
   * **Note**: when `nodeRef` prop is passed, `node` is not passed
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: d1.func
} : {};
function j4() {
}
g4.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: j4,
  onEntering: j4,
  onEntered: j4,
  onExit: j4,
  onExiting: j4,
  onExited: j4
};
g4.UNMOUNTED = c2;
g4.EXITED = S4;
g4.ENTERING = v4;
g4.ENTERED = R4;
g4.EXITING = s6;
function Jn(e) {
  return e.code === "Escape" || e.keyCode === 27;
}
function Un() {
  const e = s1.version.split(".");
  return {
    major: +e[0],
    minor: +e[1],
    patch: +e[2]
  };
}
function h3(e) {
  if (!e || typeof e == "function")
    return null;
  const {
    major: t
  } = Un();
  return t >= 19 ? e.props.ref : e.ref;
}
const l2 = !!(typeof window < "u" && window.document && window.document.createElement);
var c6 = !1, u6 = !1;
try {
  var W3 = {
    get passive() {
      return c6 = !0;
    },
    get once() {
      return u6 = c6 = !0;
    }
  };
  l2 && (window.addEventListener("test", W3, W3), window.removeEventListener("test", W3, !0));
} catch {
}
function L5(e, t, l, r) {
  if (r && typeof r != "boolean" && !u6) {
    var n = r.once, o = r.capture, i = l;
    !u6 && n && (i = l.__once || function q(a) {
      this.removeEventListener(t, q, o), l.call(this, a);
    }, l.__once = i), e.addEventListener(t, i, c6 ? r : o);
  }
  e.addEventListener(t, l, r);
}
function m6(e, t, l, r) {
  var n = r && typeof r != "boolean" ? r.capture : r;
  e.removeEventListener(t, l, n), l.__once && e.removeEventListener(t, l.__once, n);
}
function t3(e, t, l, r) {
  return L5(e, t, l, r), function() {
    m6(e, t, l, r);
  };
}
function $n(e, t, l, r) {
  if (r === void 0 && (r = !0), e) {
    var n = document.createEvent("HTMLEvents");
    n.initEvent(t, l, r), e.dispatchEvent(n);
  }
}
function Kn(e) {
  var t = N4(e, "transitionDuration") || "", l = t.indexOf("ms") === -1 ? 1e3 : 1;
  return parseFloat(t) * l;
}
function Qn(e, t, l) {
  l === void 0 && (l = 5);
  var r = !1, n = setTimeout(function() {
    r || $n(e, "transitionend", !0);
  }, t + l), o = t3(e, "transitionend", function() {
    r = !0;
  }, {
    once: !0
  });
  return function() {
    clearTimeout(n), o();
  };
}
function F5(e, t, l, r) {
  l == null && (l = Kn(e) || 0);
  var n = Qn(e, l, r), o = t3(e, "transitionend", t);
  return function() {
    n(), o();
  };
}
function l9(e, t) {
  const l = N4(e, t) || "", r = l.indexOf("ms") === -1 ? 1e3 : 1;
  return parseFloat(l) * r;
}
function er(e, t) {
  const l = l9(e, "transitionDuration"), r = l9(e, "transitionDelay"), n = F5(e, (o) => {
    o.target === e && (n(), t(o));
  }, l + r);
}
function tr(e) {
  e.offsetHeight;
}
const n9 = (e) => !e || typeof e == "function" ? e : (t) => {
  e.current = t;
};
function lr(e, t) {
  const l = n9(e), r = n9(t);
  return (n) => {
    l && l(n), r && r(n);
  };
}
function B5(e, t) {
  return j1(() => lr(e, t), [e, t]);
}
function nr(e) {
  return e && "setState" in e ? J4.findDOMNode(e) : e ?? null;
}
const G5 = /* @__PURE__ */ J1.forwardRef(({
  onEnter: e,
  onEntering: t,
  onEntered: l,
  onExit: r,
  onExiting: n,
  onExited: o,
  addEndListener: i,
  children: q,
  childRef: a,
  ...s
}, c) => {
  const u = v1(null), _ = B5(u, a), A = (I) => {
    _(nr(I));
  }, v = (I) => (w) => {
    I && u.current && I(u.current, w);
  }, b = o1(v(e), [e]), h = o1(v(t), [t]), d = o1(v(l), [l]), C = o1(v(r), [r]), f = o1(v(n), [n]), m = o1(v(o), [o]), p = o1(v(i), [i]);
  return /* @__PURE__ */ V(g4, {
    ref: c,
    ...s,
    onEnter: b,
    onEntered: d,
    onEntering: h,
    onExit: C,
    onExited: m,
    onExiting: f,
    addEndListener: p,
    nodeRef: u,
    children: typeof q == "function" ? (I, w) => (
      // TODO: Types for RTG missing innerProps, so need to cast.
      q(I, {
        ...w,
        ref: A
      })
    ) : /* @__PURE__ */ J1.cloneElement(q, {
      ref: A
    })
  });
});
G5.displayName = "TransitionWrapper";
function rr(e) {
  const t = v1(e);
  return g1(() => {
    t.current = e;
  }, [e]), t;
}
function d6(e) {
  const t = rr(e);
  return o1(function(...l) {
    return t.current && t.current(...l);
  }, [t]);
}
const or = (e) => (
  // eslint-disable-next-line react/display-name
  /* @__PURE__ */ s1.forwardRef((t, l) => /* @__PURE__ */ V("div", {
    ...t,
    ref: l,
    className: F1(t.className, e)
  }))
);
function ir(e) {
  const t = v1(e);
  return g1(() => {
    t.current = e;
  }, [e]), t;
}
function O4(e) {
  const t = ir(e);
  return o1(function(...l) {
    return t.current && t.current(...l);
  }, [t]);
}
function ar() {
  const e = v1(!0), t = v1(() => e.current);
  return g1(() => (e.current = !0, () => {
    e.current = !1;
  }), []), t.current;
}
function qr(e) {
  const t = v1(null);
  return g1(() => {
    t.current = e;
  }), t.current;
}
const sr = typeof global < "u" && // @ts-ignore
global.navigator && // @ts-ignore
global.navigator.product === "ReactNative", cr = typeof document < "u", r9 = cr || sr ? H9 : g1, ur = {
  [v4]: "show",
  [R4]: "show"
}, X6 = /* @__PURE__ */ s1.forwardRef(({
  className: e,
  children: t,
  transitionClasses: l = {},
  onEnter: r,
  ...n
}, o) => {
  const i = {
    in: !1,
    timeout: 300,
    mountOnEnter: !1,
    unmountOnExit: !1,
    appear: !1,
    ...n
  }, q = o1((a, s) => {
    tr(a), r == null || r(a, s);
  }, [r]);
  return /* @__PURE__ */ V(G5, {
    ref: o,
    addEndListener: er,
    ...i,
    onEnter: q,
    childRef: h3(t),
    children: (a, s) => /* @__PURE__ */ s1.cloneElement(t, {
      ...s,
      className: F1("fade", e, t.props.className, ur[a], l[a])
    })
  });
});
X6.displayName = "Fade";
const mr = {
  /** An accessible label indicating the relevant information about the Close Button. */
  "aria-label": d1.string,
  /** A callback fired after the Close Button is clicked. */
  onClick: d1.func,
  /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */
  variant: d1.oneOf(["white"])
}, Z6 = /* @__PURE__ */ s1.forwardRef(({
  className: e,
  variant: t,
  "aria-label": l = "Close",
  ...r
}, n) => /* @__PURE__ */ V("button", {
  ref: n,
  type: "button",
  className: F1("btn-close", t && `btn-close-${t}`, e),
  "aria-label": l,
  ...r
}));
Z6.displayName = "CloseButton";
Z6.propTypes = mr;
function dr(e) {
  const t = v1(e);
  return t.current = e, t;
}
function fr(e) {
  const t = dr(e);
  g1(() => () => t.current(), []);
}
function xr(e, t) {
  return s1.Children.toArray(e).some((l) => /* @__PURE__ */ s1.isValidElement(l) && l.type === t);
}
function hr({
  as: e,
  bsPrefix: t,
  className: l,
  ...r
}) {
  t = X1(t, "col");
  const n = Rn(), o = On(), i = [], q = [];
  return n.forEach((a) => {
    const s = r[a];
    delete r[a];
    let c, u, _;
    typeof s == "object" && s != null ? {
      span: c,
      offset: u,
      order: _
    } = s : c = s;
    const A = a !== o ? `-${a}` : "";
    c && i.push(c === !0 ? `${t}${A}` : `${t}${A}-${c}`), _ != null && q.push(`order${A}-${_}`), u != null && q.push(`offset${A}-${u}`);
  }), [{
    ...r,
    className: F1(l, ...i, ...q)
  }, {
    as: e,
    bsPrefix: t,
    spans: i
  }];
}
const D5 = /* @__PURE__ */ s1.forwardRef(
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  (e, t) => {
    const [{
      className: l,
      ...r
    }, {
      as: n = "div",
      bsPrefix: o,
      spans: i
    }] = hr(e);
    return /* @__PURE__ */ V(n, {
      ...r,
      ref: t,
      className: F1(l, !i.length && o)
    });
  }
);
D5.displayName = "Col";
var pr = Function.prototype.bind.call(Function.prototype.call, [].slice);
function X4(e, t) {
  return pr(e.querySelectorAll(t));
}
function o9(e, t) {
  if (e.contains) return e.contains(t);
  if (e.compareDocumentPosition) return e === t || !!(e.compareDocumentPosition(t) & 16);
}
var gr = process.env.NODE_ENV !== "production", k5 = function() {
};
if (gr) {
  var br = function(t, l) {
    var r = arguments.length;
    l = new Array(r > 1 ? r - 1 : 0);
    for (var n = 1; n < r; n++)
      l[n - 1] = arguments[n];
    var o = 0, i = "Warning: " + t.replace(/%s/g, function() {
      return l[o++];
    });
    typeof console < "u" && console.error(i);
    try {
      throw new Error(i);
    } catch {
    }
  };
  k5 = function(e, t, l) {
    var r = arguments.length;
    l = new Array(r > 2 ? r - 2 : 0);
    for (var n = 2; n < r; n++)
      l[n - 2] = arguments[n];
    if (t === void 0)
      throw new Error(
        "`warning(condition, format, ...args)` requires a warning message argument"
      );
    e || br.apply(null, [t].concat(l));
  };
}
var _r = k5;
const V5 = /* @__PURE__ */ W6(_r), vr = "data-rr-ui-";
function yr(e) {
  return `${vr}${e}`;
}
const H5 = /* @__PURE__ */ C6(l2 ? window : void 0);
H5.Provider;
function Y6() {
  return e4(H5);
}
const Ir = {
  /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */
  type: d1.string,
  /** Display feedback as a tooltip. */
  tooltip: d1.bool,
  as: d1.elementType
}, p3 = /* @__PURE__ */ s1.forwardRef(
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  ({
    as: e = "div",
    className: t,
    type: l = "valid",
    tooltip: r = !1,
    ...n
  }, o) => /* @__PURE__ */ V(e, {
    ...n,
    ref: o,
    className: F1(t, `${l}-${r ? "tooltip" : "feedback"}`)
  })
);
p3.displayName = "Feedback";
p3.propTypes = Ir;
const p4 = /* @__PURE__ */ s1.createContext({}), J6 = /* @__PURE__ */ s1.forwardRef(({
  id: e,
  bsPrefix: t,
  className: l,
  type: r = "checkbox",
  isValid: n = !1,
  isInvalid: o = !1,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: i = "input",
  ...q
}, a) => {
  const {
    controlId: s
  } = e4(p4);
  return t = X1(t, "form-check-input"), /* @__PURE__ */ V(i, {
    ...q,
    ref: a,
    type: r,
    id: e || s,
    className: F1(l, t, n && "is-valid", o && "is-invalid")
  });
});
J6.displayName = "FormCheckInput";
const l3 = /* @__PURE__ */ s1.forwardRef(({
  bsPrefix: e,
  className: t,
  htmlFor: l,
  ...r
}, n) => {
  const {
    controlId: o
  } = e4(p4);
  return e = X1(e, "form-check-label"), /* @__PURE__ */ V("label", {
    ...r,
    ref: n,
    htmlFor: l || o,
    className: F1(t, e)
  });
});
l3.displayName = "FormCheckLabel";
const W5 = /* @__PURE__ */ s1.forwardRef(({
  id: e,
  bsPrefix: t,
  bsSwitchPrefix: l,
  inline: r = !1,
  reverse: n = !1,
  disabled: o = !1,
  isValid: i = !1,
  isInvalid: q = !1,
  feedbackTooltip: a = !1,
  feedback: s,
  feedbackType: c,
  className: u,
  style: _,
  title: A = "",
  type: v = "checkbox",
  label: b,
  children: h,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: d = "input",
  ...C
}, f) => {
  t = X1(t, "form-check"), l = X1(l, "form-switch");
  const {
    controlId: m
  } = e4(p4), p = j1(() => ({
    controlId: e || m
  }), [m, e]), I = !h && b != null && b !== !1 || xr(h, l3), w = /* @__PURE__ */ V(J6, {
    ...C,
    type: v === "switch" ? "checkbox" : v,
    ref: f,
    isValid: i,
    isInvalid: q,
    disabled: o,
    as: d
  });
  return /* @__PURE__ */ V(p4.Provider, {
    value: p,
    children: /* @__PURE__ */ V("div", {
      style: _,
      className: F1(u, I && t, r && `${t}-inline`, n && `${t}-reverse`, v === "switch" && l),
      children: h || /* @__PURE__ */ x1(w4, {
        children: [w, I && /* @__PURE__ */ V(l3, {
          title: A,
          children: b
        }), s && /* @__PURE__ */ V(p3, {
          type: c,
          tooltip: a,
          children: s
        })]
      })
    })
  });
});
W5.displayName = "FormCheck";
const n3 = Object.assign(W5, {
  Input: J6,
  Label: l3
}), j5 = /* @__PURE__ */ s1.forwardRef(({
  bsPrefix: e,
  type: t,
  size: l,
  htmlSize: r,
  id: n,
  className: o,
  isValid: i = !1,
  isInvalid: q = !1,
  plaintext: a,
  readOnly: s,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: c = "input",
  ...u
}, _) => {
  const {
    controlId: A
  } = e4(p4);
  return e = X1(e, "form-control"), process.env.NODE_ENV !== "production" && V5(A == null || !n, "`controlId` is ignored on `<FormControl>` when `id` is specified."), /* @__PURE__ */ V(c, {
    ...u,
    type: t,
    size: r,
    ref: _,
    readOnly: s,
    id: n || A,
    className: F1(o, a ? `${e}-plaintext` : e, l && `${e}-${l}`, t === "color" && `${e}-color`, i && "is-valid", q && "is-invalid")
  });
});
j5.displayName = "FormControl";
const Cr = Object.assign(j5, {
  Feedback: p3
}), X5 = /* @__PURE__ */ s1.forwardRef(({
  className: e,
  bsPrefix: t,
  as: l = "div",
  ...r
}, n) => (t = X1(t, "form-floating"), /* @__PURE__ */ V(l, {
  ref: n,
  className: F1(e, t),
  ...r
})));
X5.displayName = "FormFloating";
const U6 = /* @__PURE__ */ s1.forwardRef(({
  controlId: e,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: t = "div",
  ...l
}, r) => {
  const n = j1(() => ({
    controlId: e
  }), [e]);
  return /* @__PURE__ */ V(p4.Provider, {
    value: n,
    children: /* @__PURE__ */ V(t, {
      ...l,
      ref: r
    })
  });
});
U6.displayName = "FormGroup";
const Z5 = /* @__PURE__ */ s1.forwardRef(({
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: e = "label",
  bsPrefix: t,
  column: l = !1,
  visuallyHidden: r = !1,
  className: n,
  htmlFor: o,
  ...i
}, q) => {
  const {
    controlId: a
  } = e4(p4);
  t = X1(t, "form-label");
  let s = "col-form-label";
  typeof l == "string" && (s = `${s} ${s}-${l}`);
  const c = F1(n, t, r && "visually-hidden", l && s);
  return process.env.NODE_ENV !== "production" && V5(a == null || !o, "`controlId` is ignored on `<FormLabel>` when `htmlFor` is specified."), o = o || a, l ? /* @__PURE__ */ V(D5, {
    ref: q,
    as: "label",
    className: c,
    htmlFor: o,
    ...i
  }) : /* @__PURE__ */ V(e, {
    ref: q,
    className: c,
    htmlFor: o,
    ...i
  });
});
Z5.displayName = "FormLabel";
const Y5 = /* @__PURE__ */ s1.forwardRef(({
  bsPrefix: e,
  className: t,
  id: l,
  ...r
}, n) => {
  const {
    controlId: o
  } = e4(p4);
  return e = X1(e, "form-range"), /* @__PURE__ */ V("input", {
    ...r,
    type: "range",
    ref: n,
    className: F1(t, e),
    id: l || o
  });
});
Y5.displayName = "FormRange";
const J5 = /* @__PURE__ */ s1.forwardRef(({
  bsPrefix: e,
  size: t,
  htmlSize: l,
  className: r,
  isValid: n = !1,
  isInvalid: o = !1,
  id: i,
  ...q
}, a) => {
  const {
    controlId: s
  } = e4(p4);
  return e = X1(e, "form-select"), /* @__PURE__ */ V("select", {
    ...q,
    size: l,
    ref: a,
    className: F1(r, e, t && `${e}-${t}`, n && "is-valid", o && "is-invalid"),
    id: i || s
  });
});
J5.displayName = "FormSelect";
const U5 = /* @__PURE__ */ s1.forwardRef(
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  ({
    bsPrefix: e,
    className: t,
    as: l = "small",
    muted: r,
    ...n
  }, o) => (e = X1(e, "form-text"), /* @__PURE__ */ V(l, {
    ...n,
    ref: o,
    className: F1(t, e, r && "text-muted")
  }))
);
U5.displayName = "FormText";
const $5 = /* @__PURE__ */ s1.forwardRef((e, t) => /* @__PURE__ */ V(n3, {
  ...e,
  ref: t,
  type: "switch"
}));
$5.displayName = "Switch";
const Er = Object.assign($5, {
  Input: n3.Input,
  Label: n3.Label
}), K5 = /* @__PURE__ */ s1.forwardRef(({
  bsPrefix: e,
  className: t,
  children: l,
  controlId: r,
  label: n,
  ...o
}, i) => (e = X1(e, "form-floating"), /* @__PURE__ */ x1(U6, {
  ref: i,
  className: F1(t, e),
  controlId: r,
  ...o,
  children: [l, /* @__PURE__ */ V("label", {
    htmlFor: r,
    children: n
  })]
})));
K5.displayName = "FloatingLabel";
const Ar = {
  /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */
  _ref: d1.any,
  /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */
  validated: d1.bool,
  as: d1.elementType
}, $6 = /* @__PURE__ */ s1.forwardRef(({
  className: e,
  validated: t,
  // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
  as: l = "form",
  ...r
}, n) => /* @__PURE__ */ V(l, {
  ...r,
  ref: n,
  className: F1(e, t && "was-validated")
}));
$6.displayName = "Form";
$6.propTypes = Ar;
const Sr = Object.assign($6, {
  Group: U6,
  Control: Cr,
  Floating: X5,
  Check: n3,
  Switch: Er,
  Label: Z5,
  Text: U5,
  Range: Y5,
  Select: J5,
  FloatingLabel: K5
}), i9 = (e) => !e || typeof e == "function" ? e : (t) => {
  e.current = t;
};
function Rr(e, t) {
  const l = i9(e), r = i9(t);
  return (n) => {
    l && l(n), r && r(n);
  };
}
function K6(e, t) {
  return j1(() => Rr(e, t), [e, t]);
}
var z2;
function a9(e) {
  if ((!z2 && z2 !== 0 || e) && l2) {
    var t = document.createElement("div");
    t.style.position = "absolute", t.style.top = "-9999px", t.style.width = "50px", t.style.height = "50px", t.style.overflow = "scroll", document.body.appendChild(t), z2 = t.offsetWidth - t.clientWidth, document.body.removeChild(t);
  }
  return z2;
}
function Or() {
  return m1(null);
}
function j3(e) {
  e === void 0 && (e = x3());
  try {
    var t = e.activeElement;
    return !t || !t.nodeName ? null : t;
  } catch {
    return e.body;
  }
}
function Tr(e) {
  const t = v1(e);
  return t.current = e, t;
}
function wr(e) {
  const t = Tr(e);
  g1(() => () => t.current(), []);
}
function zr(e = document) {
  const t = e.defaultView;
  return Math.abs(t.innerWidth - e.documentElement.clientWidth);
}
const q9 = yr("modal-open");
class Q6 {
  constructor({
    ownerDocument: t,
    handleContainerOverflow: l = !0,
    isRTL: r = !1
  } = {}) {
    this.handleContainerOverflow = l, this.isRTL = r, this.modals = [], this.ownerDocument = t;
  }
  getScrollbarWidth() {
    return zr(this.ownerDocument);
  }
  getElement() {
    return (this.ownerDocument || document).body;
  }
  setModalAttributes(t) {
  }
  removeModalAttributes(t) {
  }
  setContainerStyle(t) {
    const l = {
      overflow: "hidden"
    }, r = this.isRTL ? "paddingLeft" : "paddingRight", n = this.getElement();
    t.style = {
      overflow: n.style.overflow,
      [r]: n.style[r]
    }, t.scrollBarWidth && (l[r] = `${parseInt(N4(n, r) || "0", 10) + t.scrollBarWidth}px`), n.setAttribute(q9, ""), N4(n, l);
  }
  reset() {
    [...this.modals].forEach((t) => this.remove(t));
  }
  removeContainerStyle(t) {
    const l = this.getElement();
    l.removeAttribute(q9), Object.assign(l.style, t.style);
  }
  add(t) {
    let l = this.modals.indexOf(t);
    return l !== -1 || (l = this.modals.length, this.modals.push(t), this.setModalAttributes(t), l !== 0) || (this.state = {
      scrollBarWidth: this.getScrollbarWidth(),
      style: {}
    }, this.handleContainerOverflow && this.setContainerStyle(this.state)), l;
  }
  remove(t) {
    const l = this.modals.indexOf(t);
    l !== -1 && (this.modals.splice(l, 1), !this.modals.length && this.handleContainerOverflow && this.removeContainerStyle(this.state), this.removeModalAttributes(t));
  }
  isTopModal(t) {
    return !!this.modals.length && this.modals[this.modals.length - 1] === t;
  }
}
const X3 = (e, t) => l2 ? e == null ? (t || x3()).body : (typeof e == "function" && (e = e()), e && "current" in e && (e = e.current), e && ("nodeType" in e || e.getBoundingClientRect) ? e : null) : null;
function Nr(e, t) {
  const l = Y6(), [r, n] = m1(() => X3(e, l == null ? void 0 : l.document));
  if (!r) {
    const o = X3(e);
    o && n(o);
  }
  return g1(() => {
  }, [t, r]), g1(() => {
    const o = X3(e);
    o !== r && n(o);
  }, [e, r]), r;
}
function Mr({
  children: e,
  in: t,
  onExited: l,
  mountOnEnter: r,
  unmountOnExit: n
}) {
  const o = v1(null), i = v1(t), q = O4(l);
  g1(() => {
    t ? i.current = !0 : q(o.current);
  }, [t, q]);
  const a = K6(o, h3(e)), s = /* @__PURE__ */ A6(e, {
    ref: a
  });
  return t ? s : n || !i.current && r ? null : s;
}
const Pr = ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "addEndListener", "children"];
function Lr(e, t) {
  if (e == null) return {};
  var l = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) >= 0) continue;
    l[r] = e[r];
  }
  return l;
}
function Fr(e) {
  let {
    onEnter: t,
    onEntering: l,
    onEntered: r,
    onExit: n,
    onExiting: o,
    onExited: i,
    addEndListener: q,
    children: a
  } = e, s = Lr(e, Pr);
  const c = v1(null), u = K6(c, h3(a)), _ = (m) => (p) => {
    m && c.current && m(c.current, p);
  }, A = o1(_(t), [t]), v = o1(_(l), [l]), b = o1(_(r), [r]), h = o1(_(n), [n]), d = o1(_(o), [o]), C = o1(_(i), [i]), f = o1(_(q), [q]);
  return Object.assign({}, s, {
    nodeRef: c
  }, t && {
    onEnter: A
  }, l && {
    onEntering: v
  }, r && {
    onEntered: b
  }, n && {
    onExit: h
  }, o && {
    onExiting: d
  }, i && {
    onExited: C
  }, q && {
    addEndListener: f
  }, {
    children: typeof a == "function" ? (m, p) => (
      // TODO: Types for RTG missing innerProps, so need to cast.
      a(m, Object.assign({}, p, {
        ref: u
      }))
    ) : /* @__PURE__ */ A6(a, {
      ref: u
    })
  });
}
const Br = ["component"];
function Gr(e, t) {
  if (e == null) return {};
  var l = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) >= 0) continue;
    l[r] = e[r];
  }
  return l;
}
const Dr = /* @__PURE__ */ s1.forwardRef((e, t) => {
  let {
    component: l
  } = e, r = Gr(e, Br);
  const n = Fr(r);
  return /* @__PURE__ */ V(l, Object.assign({
    ref: t
  }, n));
});
function kr({
  in: e,
  onTransition: t
}) {
  const l = v1(null), r = v1(!0), n = O4(t);
  return r9(() => {
    if (!l.current)
      return;
    let o = !1;
    return n({
      in: e,
      element: l.current,
      initial: r.current,
      isStale: () => o
    }), () => {
      o = !0;
    };
  }, [e, n]), r9(() => (r.current = !1, () => {
    r.current = !0;
  }), []), l;
}
function Vr({
  children: e,
  in: t,
  onExited: l,
  onEntered: r,
  transition: n
}) {
  const [o, i] = m1(!t);
  t && o && i(!1);
  const q = kr({
    in: !!t,
    onTransition: (s) => {
      const c = () => {
        s.isStale() || (s.in ? r == null || r(s.element, s.initial) : (i(!0), l == null || l(s.element)));
      };
      Promise.resolve(n(s)).then(c, (u) => {
        throw s.in || i(!0), u;
      });
    }
  }), a = K6(q, h3(e));
  return o && !t ? null : /* @__PURE__ */ A6(e, {
    ref: a
  });
}
function s9(e, t, l) {
  return e ? /* @__PURE__ */ V(Dr, Object.assign({}, l, {
    component: e
  })) : t ? /* @__PURE__ */ V(Vr, Object.assign({}, l, {
    transition: t
  })) : /* @__PURE__ */ V(Mr, Object.assign({}, l));
}
const Hr = ["show", "role", "className", "style", "children", "backdrop", "keyboard", "onBackdropClick", "onEscapeKeyDown", "transition", "runTransition", "backdropTransition", "runBackdropTransition", "autoFocus", "enforceFocus", "restoreFocus", "restoreFocusOptions", "renderDialog", "renderBackdrop", "manager", "container", "onShow", "onHide", "onExit", "onExited", "onExiting", "onEnter", "onEntering", "onEntered"];
function Wr(e, t) {
  if (e == null) return {};
  var l = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) >= 0) continue;
    l[r] = e[r];
  }
  return l;
}
let Z3;
function jr(e) {
  return Z3 || (Z3 = new Q6({
    ownerDocument: e == null ? void 0 : e.document
  })), Z3;
}
function Xr(e) {
  const t = Y6(), l = e || jr(t), r = v1({
    dialog: null,
    backdrop: null
  });
  return Object.assign(r.current, {
    add: () => l.add(r.current),
    remove: () => l.remove(r.current),
    isTopModal: () => l.isTopModal(r.current),
    setDialogRef: o1((n) => {
      r.current.dialog = n;
    }, []),
    setBackdropRef: o1((n) => {
      r.current.backdrop = n;
    }, [])
  });
}
const Q5 = /* @__PURE__ */ G4((e, t) => {
  let {
    show: l = !1,
    role: r = "dialog",
    className: n,
    style: o,
    children: i,
    backdrop: q = !0,
    keyboard: a = !0,
    onBackdropClick: s,
    onEscapeKeyDown: c,
    transition: u,
    runTransition: _,
    backdropTransition: A,
    runBackdropTransition: v,
    autoFocus: b = !0,
    enforceFocus: h = !0,
    restoreFocus: d = !0,
    restoreFocusOptions: C,
    renderDialog: f,
    renderBackdrop: m = (J) => /* @__PURE__ */ V("div", Object.assign({}, J)),
    manager: p,
    container: I,
    onShow: w,
    onHide: T = () => {
    },
    onExit: L,
    onExited: j,
    onExiting: $,
    onEnter: k,
    onEntering: t1,
    onEntered: e1
  } = e, Q = Wr(e, Hr);
  const Z = Y6(), X = Nr(I), G = Xr(p), a1 = ar(), F = qr(l), [M, H] = m1(!l), W = v1(null);
  E6(t, () => G, [G]), l2 && !F && l && (W.current = j3(Z == null ? void 0 : Z.document)), l && M && H(!1);
  const S = O4(() => {
    if (G.add(), B.current = t3(document, "keydown", R), Y.current = t3(
      document,
      "focus",
      // the timeout is necessary b/c this will run before the new modal is mounted
      // and so steals focus from it
      () => setTimeout(g),
      !0
    ), w && w(), b) {
      var J, N;
      const D = j3((J = (N = G.dialog) == null ? void 0 : N.ownerDocument) != null ? J : Z == null ? void 0 : Z.document);
      G.dialog && D && !o9(G.dialog, D) && (W.current = D, G.dialog.focus());
    }
  }), E = O4(() => {
    if (G.remove(), B.current == null || B.current(), Y.current == null || Y.current(), d) {
      var J;
      (J = W.current) == null || J.focus == null || J.focus(C), W.current = null;
    }
  });
  g1(() => {
    !l || !X || S();
  }, [
    l,
    X,
    /* should never change: */
    S
  ]), g1(() => {
    M && E();
  }, [M, E]), wr(() => {
    E();
  });
  const g = O4(() => {
    if (!h || !a1() || !G.isTopModal())
      return;
    const J = j3(Z == null ? void 0 : Z.document);
    G.dialog && J && !o9(G.dialog, J) && G.dialog.focus();
  }), x = O4((J) => {
    J.target === J.currentTarget && (s == null || s(J), q === !0 && T());
  }), R = O4((J) => {
    a && Jn(J) && G.isTopModal() && (c == null || c(J), J.defaultPrevented || T());
  }), Y = v1(), B = v1(), K = (...J) => {
    H(!0), j == null || j(...J);
  };
  if (!X)
    return null;
  const z = Object.assign({
    role: r,
    ref: G.setDialogRef,
    // apparently only works on the dialog role element
    "aria-modal": r === "dialog" ? !0 : void 0
  }, Q, {
    style: o,
    className: n,
    tabIndex: -1
  });
  let l1 = f ? f(z) : /* @__PURE__ */ V("div", Object.assign({}, z, {
    children: /* @__PURE__ */ s1.cloneElement(i, {
      role: "document"
    })
  }));
  l1 = s9(u, _, {
    unmountOnExit: !0,
    mountOnEnter: !0,
    appear: !0,
    in: !!l,
    onExit: L,
    onExiting: $,
    onExited: K,
    onEnter: k,
    onEntering: t1,
    onEntered: e1,
    children: l1
  });
  let U = null;
  return q && (U = m({
    ref: G.setBackdropRef,
    onClick: x
  }), U = s9(A, v, {
    in: !!l,
    appear: !0,
    mountOnEnter: !0,
    unmountOnExit: !0,
    children: U
  })), /* @__PURE__ */ V(w4, {
    children: /* @__PURE__ */ J4.createPortal(/* @__PURE__ */ x1(w4, {
      children: [U, l1]
    }), X)
  });
});
Q5.displayName = "Modal";
const Zr = Object.assign(Q5, {
  Manager: Q6
});
function Yr(e, t) {
  return e.classList ? e.classList.contains(t) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + t + " ") !== -1;
}
function Jr(e, t) {
  e.classList ? e.classList.add(t) : Yr(e, t) || (typeof e.className == "string" ? e.className = e.className + " " + t : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + t));
}
function c9(e, t) {
  return e.replace(new RegExp("(^|\\s)" + t + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function Ur(e, t) {
  e.classList ? e.classList.remove(t) : typeof e.className == "string" ? e.className = c9(e.className, t) : e.setAttribute("class", c9(e.className && e.className.baseVal || "", t));
}
const Z4 = {
  FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
  STICKY_CONTENT: ".sticky-top",
  NAVBAR_TOGGLER: ".navbar-toggler"
};
class $r extends Q6 {
  adjustAndStore(t, l, r) {
    const n = l.style[t];
    l.dataset[t] = n, N4(l, {
      [t]: `${parseFloat(N4(l, t)) + r}px`
    });
  }
  restore(t, l) {
    const r = l.dataset[t];
    r !== void 0 && (delete l.dataset[t], N4(l, {
      [t]: r
    }));
  }
  setContainerStyle(t) {
    super.setContainerStyle(t);
    const l = this.getElement();
    if (Jr(l, "modal-open"), !t.scrollBarWidth) return;
    const r = this.isRTL ? "paddingLeft" : "paddingRight", n = this.isRTL ? "marginLeft" : "marginRight";
    X4(l, Z4.FIXED_CONTENT).forEach((o) => this.adjustAndStore(r, o, t.scrollBarWidth)), X4(l, Z4.STICKY_CONTENT).forEach((o) => this.adjustAndStore(n, o, -t.scrollBarWidth)), X4(l, Z4.NAVBAR_TOGGLER).forEach((o) => this.adjustAndStore(n, o, t.scrollBarWidth));
  }
  removeContainerStyle(t) {
    super.removeContainerStyle(t);
    const l = this.getElement();
    Ur(l, "modal-open");
    const r = this.isRTL ? "paddingLeft" : "paddingRight", n = this.isRTL ? "marginLeft" : "marginRight";
    X4(l, Z4.FIXED_CONTENT).forEach((o) => this.restore(r, o)), X4(l, Z4.STICKY_CONTENT).forEach((o) => this.restore(n, o)), X4(l, Z4.NAVBAR_TOGGLER).forEach((o) => this.restore(n, o));
  }
}
let Y3;
function Kr(e) {
  return Y3 || (Y3 = new $r(e)), Y3;
}
const e7 = /* @__PURE__ */ s1.forwardRef(({
  className: e,
  bsPrefix: t,
  as: l = "div",
  ...r
}, n) => (t = X1(t, "modal-body"), /* @__PURE__ */ V(l, {
  ref: n,
  className: F1(e, t),
  ...r
})));
e7.displayName = "ModalBody";
const t7 = /* @__PURE__ */ s1.createContext({
  onHide() {
  }
}), e8 = /* @__PURE__ */ s1.forwardRef(({
  bsPrefix: e,
  className: t,
  contentClassName: l,
  centered: r,
  size: n,
  fullscreen: o,
  children: i,
  scrollable: q,
  ...a
}, s) => {
  e = X1(e, "modal");
  const c = `${e}-dialog`, u = typeof o == "string" ? `${e}-fullscreen-${o}` : `${e}-fullscreen`;
  return /* @__PURE__ */ V("div", {
    ...a,
    ref: s,
    className: F1(c, t, n && `${e}-${n}`, r && `${c}-centered`, q && `${c}-scrollable`, o && u),
    children: /* @__PURE__ */ V("div", {
      className: F1(`${e}-content`, l),
      children: i
    })
  });
});
e8.displayName = "ModalDialog";
const l7 = /* @__PURE__ */ s1.forwardRef(({
  className: e,
  bsPrefix: t,
  as: l = "div",
  ...r
}, n) => (t = X1(t, "modal-footer"), /* @__PURE__ */ V(l, {
  ref: n,
  className: F1(e, t),
  ...r
})));
l7.displayName = "ModalFooter";
const n7 = /* @__PURE__ */ s1.forwardRef(({
  closeLabel: e = "Close",
  closeVariant: t,
  closeButton: l = !1,
  onHide: r,
  children: n,
  ...o
}, i) => {
  const q = e4(t7), a = d6(() => {
    q == null || q.onHide(), r == null || r();
  });
  return /* @__PURE__ */ x1("div", {
    ref: i,
    ...o,
    children: [n, l && /* @__PURE__ */ V(Z6, {
      "aria-label": e,
      variant: t,
      onClick: a
    })]
  });
});
n7.displayName = "AbstractModalHeader";
const r7 = /* @__PURE__ */ s1.forwardRef(({
  bsPrefix: e,
  className: t,
  closeLabel: l = "Close",
  closeButton: r = !1,
  ...n
}, o) => (e = X1(e, "modal-header"), /* @__PURE__ */ V(n7, {
  ref: o,
  ...n,
  className: F1(t, e),
  closeLabel: l,
  closeButton: r
})));
r7.displayName = "ModalHeader";
const Qr = or("h4"), o7 = /* @__PURE__ */ s1.forwardRef(({
  className: e,
  bsPrefix: t,
  as: l = Qr,
  ...r
}, n) => (t = X1(t, "modal-title"), /* @__PURE__ */ V(l, {
  ref: n,
  className: F1(e, t),
  ...r
})));
o7.displayName = "ModalTitle";
function eo(e) {
  return /* @__PURE__ */ V(X6, {
    ...e,
    timeout: null
  });
}
function to(e) {
  return /* @__PURE__ */ V(X6, {
    ...e,
    timeout: null
  });
}
const i7 = /* @__PURE__ */ s1.forwardRef(({
  bsPrefix: e,
  className: t,
  style: l,
  dialogClassName: r,
  contentClassName: n,
  children: o,
  dialogAs: i = e8,
  "data-bs-theme": q,
  "aria-labelledby": a,
  "aria-describedby": s,
  "aria-label": c,
  /* BaseModal props */
  show: u = !1,
  animation: _ = !0,
  backdrop: A = !0,
  keyboard: v = !0,
  onEscapeKeyDown: b,
  onShow: h,
  onHide: d,
  container: C,
  autoFocus: f = !0,
  enforceFocus: m = !0,
  restoreFocus: p = !0,
  restoreFocusOptions: I,
  onEntered: w,
  onExit: T,
  onExiting: L,
  onEnter: j,
  onEntering: $,
  onExited: k,
  backdropClassName: t1,
  manager: e1,
  ...Q
}, Z) => {
  const [X, G] = m1({}), [a1, F] = m1(!1), M = v1(!1), H = v1(!1), W = v1(null), [S, E] = Or(), g = B5(Z, E), x = d6(d), R = Tn();
  e = X1(e, "modal");
  const Y = j1(() => ({
    onHide: x
  }), [x]);
  function B() {
    return e1 || Kr({
      isRTL: R
    });
  }
  function K(_1) {
    if (!l2) return;
    const i4 = B().getScrollbarWidth() > 0, U1 = _1.scrollHeight > x3(_1).documentElement.clientHeight;
    G({
      paddingRight: i4 && !U1 ? a9() : void 0,
      paddingLeft: !i4 && U1 ? a9() : void 0
    });
  }
  const z = d6(() => {
    S && K(S.dialog);
  });
  fr(() => {
    m6(window, "resize", z), W.current == null || W.current();
  });
  const l1 = () => {
    M.current = !0;
  }, U = (_1) => {
    M.current && S && _1.target === S.dialog && (H.current = !0), M.current = !1;
  }, J = () => {
    F(!0), W.current = F5(S.dialog, () => {
      F(!1);
    });
  }, N = (_1) => {
    _1.target === _1.currentTarget && J();
  }, D = (_1) => {
    if (A === "static") {
      N(_1);
      return;
    }
    if (H.current || _1.target !== _1.currentTarget) {
      H.current = !1;
      return;
    }
    d == null || d();
  }, O = (_1) => {
    v ? b == null || b(_1) : (_1.preventDefault(), A === "static" && J());
  }, y = (_1, i4) => {
    _1 && K(_1), j == null || j(_1, i4);
  }, n1 = (_1) => {
    W.current == null || W.current(), T == null || T(_1);
  }, i1 = (_1, i4) => {
    $ == null || $(_1, i4), L5(window, "resize", z);
  }, y1 = (_1) => {
    _1 && (_1.style.display = ""), k == null || k(_1), m6(window, "resize", z);
  }, I1 = o1((_1) => /* @__PURE__ */ V("div", {
    ..._1,
    className: F1(`${e}-backdrop`, t1, !_ && "show")
  }), [_, t1, e]), N1 = {
    ...l,
    ...X
  };
  N1.display = "block";
  const l4 = (_1) => /* @__PURE__ */ V("div", {
    role: "dialog",
    ..._1,
    style: N1,
    className: F1(t, e, a1 && `${e}-static`, !_ && "show"),
    onClick: A ? D : void 0,
    onMouseUp: U,
    "data-bs-theme": q,
    "aria-label": c,
    "aria-labelledby": a,
    "aria-describedby": s,
    children: /* @__PURE__ */ V(i, {
      ...Q,
      onMouseDown: l1,
      className: r,
      contentClassName: n,
      children: o
    })
  });
  return /* @__PURE__ */ V(t7.Provider, {
    value: Y,
    children: /* @__PURE__ */ V(Zr, {
      show: u,
      ref: g,
      backdrop: A,
      container: C,
      keyboard: !0,
      autoFocus: f,
      enforceFocus: m,
      restoreFocus: p,
      restoreFocusOptions: I,
      onEscapeKeyDown: O,
      onShow: h,
      onHide: d,
      onEnter: y,
      onEntering: i1,
      onEntered: w,
      onExit: n1,
      onExiting: L,
      onExited: y1,
      manager: B(),
      transition: _ ? eo : void 0,
      backdropTransition: _ ? to : void 0,
      renderBackdrop: I1,
      renderDialog: l4
    })
  });
});
i7.displayName = "Modal";
const u9 = Object.assign(i7, {
  Body: e7,
  Header: r7,
  Title: o7,
  Footer: l7,
  Dialog: e8,
  TRANSITION_DURATION: 300,
  BACKDROP_TRANSITION_DURATION: 150
});
function f6() {
  return f6 = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = arguments[t];
      for (var r in l)
        Object.prototype.hasOwnProperty.call(l, r) && (e[r] = l[r]);
    }
    return e;
  }, f6.apply(this, arguments);
}
function lo(e, t) {
  if (e == null) return {};
  var l = no(e, t), r, n;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (n = 0; n < o.length; n++)
      r = o[n], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
  }
  return l;
}
function no(e, t) {
  if (e == null) return {};
  var l = {}, r = Object.keys(e), n, o;
  for (o = 0; o < r.length; o++)
    n = r[o], !(t.indexOf(n) >= 0) && (l[n] = e[n]);
  return l;
}
var t8 = G4(function(e, t) {
  var l = e.color, r = l === void 0 ? "currentColor" : l, n = e.size, o = n === void 0 ? 24 : n, i = lo(e, ["color", "size"]);
  return /* @__PURE__ */ J1.createElement("svg", f6({
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    width: o,
    height: o,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: r,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, i), /* @__PURE__ */ J1.createElement("circle", {
    cx: "12",
    cy: "12",
    r: "10"
  }), /* @__PURE__ */ J1.createElement("line", {
    x1: "15",
    y1: "9",
    x2: "9",
    y2: "15"
  }), /* @__PURE__ */ J1.createElement("line", {
    x1: "9",
    y1: "9",
    x2: "15",
    y2: "15"
  }));
});
t8.propTypes = {
  color: d1.string,
  size: d1.oneOfType([d1.string, d1.number])
};
t8.displayName = "XCircle";
const ro = "_retailerInfoModalRoot_tw7ne_21", oo = "_retailerInfoModal_tw7ne_21", io = "_retailerInfoCloseBtn_tw7ne_44", ao = "_closeBtn_tw7ne_54", qo = "_modalBody_tw7ne_68", so = "_contentWrapper_tw7ne_78", co = "_content_tw7ne_78", uo = "_retailerLogo_tw7ne_85", mo = "_img_tw7ne_90", fo = "_retailerInfoContent_tw7ne_96", xo = "_getDirectionsFrom_tw7ne_108", ho = "_retailerDropdown_tw7ne_114", po = "_btn_tw7ne_121", a4 = {
  retailerInfoModalRoot: ro,
  retailerInfoModal: oo,
  retailerInfoCloseBtn: io,
  closeBtn: ao,
  modalBody: qo,
  contentWrapper: so,
  content: co,
  retailerLogo: uo,
  img: mo,
  retailerInfoContent: fo,
  getDirectionsFrom: xo,
  retailerDropdown: ho,
  btn: po
};
function B4(e) {
  "@babel/helpers - typeof";
  return B4 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, B4(e);
}
function go(e, t) {
  if (B4(e) != "object" || !e) return e;
  var l = e[Symbol.toPrimitive];
  if (l !== void 0) {
    var r = l.call(e, t);
    if (B4(r) != "object") return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function a7(e) {
  var t = go(e, "string");
  return B4(t) == "symbol" ? t : t + "";
}
function u2(e, t, l) {
  return (t = a7(t)) in e ? Object.defineProperty(e, t, {
    value: l,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = l, e;
}
function m9(e, t) {
  var l = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(n) {
      return Object.getOwnPropertyDescriptor(e, n).enumerable;
    })), l.push.apply(l, r);
  }
  return l;
}
function h1(e) {
  for (var t = 1; t < arguments.length; t++) {
    var l = arguments[t] != null ? arguments[t] : {};
    t % 2 ? m9(Object(l), !0).forEach(function(r) {
      u2(e, r, l[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(l)) : m9(Object(l)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(l, r));
    });
  }
  return e;
}
function bo(e) {
  if (Array.isArray(e)) return e;
}
function _o(e, t) {
  var l = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (l != null) {
    var r, n, o, i, q = [], a = !0, s = !1;
    try {
      if (o = (l = l.call(e)).next, t === 0) {
        if (Object(l) !== l) return;
        a = !1;
      } else for (; !(a = (r = o.call(l)).done) && (q.push(r.value), q.length !== t); a = !0) ;
    } catch (c) {
      s = !0, n = c;
    } finally {
      try {
        if (!a && l.return != null && (i = l.return(), Object(i) !== i)) return;
      } finally {
        if (s) throw n;
      }
    }
    return q;
  }
}
function x6(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var l = 0, r = Array(t); l < t; l++) r[l] = e[l];
  return r;
}
function q7(e, t) {
  if (e) {
    if (typeof e == "string") return x6(e, t);
    var l = {}.toString.call(e).slice(8, -1);
    return l === "Object" && e.constructor && (l = e.constructor.name), l === "Map" || l === "Set" ? Array.from(e) : l === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(l) ? x6(e, t) : void 0;
  }
}
function vo() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function h4(e, t) {
  return bo(e) || _o(e, t) || q7(e, t) || vo();
}
function b4(e, t) {
  if (e == null) return {};
  var l, r, n = z5(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++) l = o[r], t.indexOf(l) === -1 && {}.propertyIsEnumerable.call(e, l) && (n[l] = e[l]);
  }
  return n;
}
var yo = ["defaultInputValue", "defaultMenuIsOpen", "defaultValue", "inputValue", "menuIsOpen", "onChange", "onInputChange", "onMenuClose", "onMenuOpen", "value"];
function Io(e) {
  var t = e.defaultInputValue, l = t === void 0 ? "" : t, r = e.defaultMenuIsOpen, n = r === void 0 ? !1 : r, o = e.defaultValue, i = o === void 0 ? null : o, q = e.inputValue, a = e.menuIsOpen, s = e.onChange, c = e.onInputChange, u = e.onMenuClose, _ = e.onMenuOpen, A = e.value, v = b4(e, yo), b = m1(q !== void 0 ? q : l), h = h4(b, 2), d = h[0], C = h[1], f = m1(a !== void 0 ? a : n), m = h4(f, 2), p = m[0], I = m[1], w = m1(A !== void 0 ? A : i), T = h4(w, 2), L = T[0], j = T[1], $ = o1(function(G, a1) {
    typeof s == "function" && s(G, a1), j(G);
  }, [s]), k = o1(function(G, a1) {
    var F;
    typeof c == "function" && (F = c(G, a1)), C(F !== void 0 ? F : G);
  }, [c]), t1 = o1(function() {
    typeof _ == "function" && _(), I(!0);
  }, [_]), e1 = o1(function() {
    typeof u == "function" && u(), I(!1);
  }, [u]), Q = q !== void 0 ? q : d, Z = a !== void 0 ? a : p, X = A !== void 0 ? A : L;
  return h1(h1({}, v), {}, {
    inputValue: Q,
    menuIsOpen: Z,
    onChange: $,
    onInputChange: k,
    onMenuClose: e1,
    onMenuOpen: t1,
    value: X
  });
}
function Co(e, t) {
  if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
}
function d9(e, t) {
  for (var l = 0; l < t.length; l++) {
    var r = t[l];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, a7(r.key), r);
  }
}
function Eo(e, t, l) {
  return t && d9(e.prototype, t), l && d9(e, l), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function Ao(e, t) {
  if (typeof t != "function" && t !== null) throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && e3(e, t);
}
function r3(e) {
  return r3 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, r3(e);
}
function s7() {
  try {
    var e = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (s7 = function() {
    return !!e;
  })();
}
function So(e) {
  if (e === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function Ro(e, t) {
  if (t && (B4(t) == "object" || typeof t == "function")) return t;
  if (t !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
  return So(e);
}
function Oo(e) {
  var t = s7();
  return function() {
    var l, r = r3(e);
    if (t) {
      var n = r3(this).constructor;
      l = Reflect.construct(r, arguments, n);
    } else l = r.apply(this, arguments);
    return Ro(this, l);
  };
}
function To(e) {
  if (Array.isArray(e)) return x6(e);
}
function wo(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function zo() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function l8(e) {
  return To(e) || wo(e) || q7(e) || zo();
}
function No(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function Mo(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var Po = /* @__PURE__ */ function() {
  function e(l) {
    var r = this;
    this._insertTag = function(n) {
      var o;
      r.tags.length === 0 ? r.insertionPoint ? o = r.insertionPoint.nextSibling : r.prepend ? o = r.container.firstChild : o = r.before : o = r.tags[r.tags.length - 1].nextSibling, r.container.insertBefore(n, o), r.tags.push(n);
    }, this.isSpeedy = l.speedy === void 0 ? !0 : l.speedy, this.tags = [], this.ctr = 0, this.nonce = l.nonce, this.key = l.key, this.container = l.container, this.prepend = l.prepend, this.insertionPoint = l.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(r) {
    r.forEach(this._insertTag);
  }, t.insert = function(r) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(Mo(this));
    var n = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var o = No(n);
      try {
        o.insertRule(r, o.cssRules.length);
      } catch {
      }
    } else
      n.appendChild(document.createTextNode(r));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(r) {
      var n;
      return (n = r.parentNode) == null ? void 0 : n.removeChild(r);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), K1 = "-ms-", o3 = "-moz-", E1 = "-webkit-", c7 = "comm", n8 = "rule", r8 = "decl", Lo = "@import", u7 = "@keyframes", Fo = "@layer", Bo = Math.abs, g3 = String.fromCharCode, Go = Object.assign;
function Do(e, t) {
  return Z1(e, 0) ^ 45 ? (((t << 2 ^ Z1(e, 0)) << 2 ^ Z1(e, 1)) << 2 ^ Z1(e, 2)) << 2 ^ Z1(e, 3) : 0;
}
function m7(e) {
  return e.trim();
}
function ko(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function A1(e, t, l) {
  return e.replace(t, l);
}
function h6(e, t) {
  return e.indexOf(t);
}
function Z1(e, t) {
  return e.charCodeAt(t) | 0;
}
function x2(e, t, l) {
  return e.slice(t, l);
}
function m4(e) {
  return e.length;
}
function o8(e) {
  return e.length;
}
function N2(e, t) {
  return t.push(e), e;
}
function Vo(e, t) {
  return e.map(t).join("");
}
var b3 = 1, K4 = 1, d7 = 0, r4 = 0, V1 = 0, n2 = "";
function _3(e, t, l, r, n, o, i) {
  return { value: e, root: t, parent: l, type: r, props: n, children: o, line: b3, column: K4, length: i, return: "" };
}
function q2(e, t) {
  return Go(_3("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function Ho() {
  return V1;
}
function Wo() {
  return V1 = r4 > 0 ? Z1(n2, --r4) : 0, K4--, V1 === 10 && (K4 = 1, b3--), V1;
}
function q4() {
  return V1 = r4 < d7 ? Z1(n2, r4++) : 0, K4++, V1 === 10 && (K4 = 1, b3++), V1;
}
function f4() {
  return Z1(n2, r4);
}
function H2() {
  return r4;
}
function I2(e, t) {
  return x2(n2, e, t);
}
function h2(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function f7(e) {
  return b3 = K4 = 1, d7 = m4(n2 = e), r4 = 0, [];
}
function x7(e) {
  return n2 = "", e;
}
function W2(e) {
  return m7(I2(r4 - 1, p6(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function jo(e) {
  for (; (V1 = f4()) && V1 < 33; )
    q4();
  return h2(e) > 2 || h2(V1) > 3 ? "" : " ";
}
function Xo(e, t) {
  for (; --t && q4() && !(V1 < 48 || V1 > 102 || V1 > 57 && V1 < 65 || V1 > 70 && V1 < 97); )
    ;
  return I2(e, H2() + (t < 6 && f4() == 32 && q4() == 32));
}
function p6(e) {
  for (; q4(); )
    switch (V1) {
      case e:
        return r4;
      case 34:
      case 39:
        e !== 34 && e !== 39 && p6(V1);
        break;
      case 40:
        e === 41 && p6(e);
        break;
      case 92:
        q4();
        break;
    }
  return r4;
}
function Zo(e, t) {
  for (; q4() && e + V1 !== 57; )
    if (e + V1 === 84 && f4() === 47)
      break;
  return "/*" + I2(t, r4 - 1) + "*" + g3(e === 47 ? e : q4());
}
function Yo(e) {
  for (; !h2(f4()); )
    q4();
  return I2(e, r4);
}
function Jo(e) {
  return x7(j2("", null, null, null, [""], e = f7(e), 0, [0], e));
}
function j2(e, t, l, r, n, o, i, q, a) {
  for (var s = 0, c = 0, u = i, _ = 0, A = 0, v = 0, b = 1, h = 1, d = 1, C = 0, f = "", m = n, p = o, I = r, w = f; h; )
    switch (v = C, C = q4()) {
      case 40:
        if (v != 108 && Z1(w, u - 1) == 58) {
          h6(w += A1(W2(C), "&", "&\f"), "&\f") != -1 && (d = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        w += W2(C);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        w += jo(v);
        break;
      case 92:
        w += Xo(H2() - 1, 7);
        continue;
      case 47:
        switch (f4()) {
          case 42:
          case 47:
            N2(Uo(Zo(q4(), H2()), t, l), a);
            break;
          default:
            w += "/";
        }
        break;
      case 123 * b:
        q[s++] = m4(w) * d;
      case 125 * b:
      case 59:
      case 0:
        switch (C) {
          case 0:
          case 125:
            h = 0;
          case 59 + c:
            d == -1 && (w = A1(w, /\f/g, "")), A > 0 && m4(w) - u && N2(A > 32 ? x9(w + ";", r, l, u - 1) : x9(A1(w, " ", "") + ";", r, l, u - 2), a);
            break;
          case 59:
            w += ";";
          default:
            if (N2(I = f9(w, t, l, s, c, n, q, f, m = [], p = [], u), o), C === 123)
              if (c === 0)
                j2(w, t, I, I, m, o, u, q, p);
              else
                switch (_ === 99 && Z1(w, 3) === 110 ? 100 : _) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    j2(e, I, I, r && N2(f9(e, I, I, 0, 0, n, q, f, n, m = [], u), p), n, p, u, q, r ? m : p);
                    break;
                  default:
                    j2(w, I, I, I, [""], p, 0, q, p);
                }
        }
        s = c = A = 0, b = d = 1, f = w = "", u = i;
        break;
      case 58:
        u = 1 + m4(w), A = v;
      default:
        if (b < 1) {
          if (C == 123)
            --b;
          else if (C == 125 && b++ == 0 && Wo() == 125)
            continue;
        }
        switch (w += g3(C), C * b) {
          case 38:
            d = c > 0 ? 1 : (w += "\f", -1);
            break;
          case 44:
            q[s++] = (m4(w) - 1) * d, d = 1;
            break;
          case 64:
            f4() === 45 && (w += W2(q4())), _ = f4(), c = u = m4(f = w += Yo(H2())), C++;
            break;
          case 45:
            v === 45 && m4(w) == 2 && (b = 0);
        }
    }
  return o;
}
function f9(e, t, l, r, n, o, i, q, a, s, c) {
  for (var u = n - 1, _ = n === 0 ? o : [""], A = o8(_), v = 0, b = 0, h = 0; v < r; ++v)
    for (var d = 0, C = x2(e, u + 1, u = Bo(b = i[v])), f = e; d < A; ++d)
      (f = m7(b > 0 ? _[d] + " " + C : A1(C, /&\f/g, _[d]))) && (a[h++] = f);
  return _3(e, t, l, n === 0 ? n8 : q, a, s, c);
}
function Uo(e, t, l) {
  return _3(e, t, l, c7, g3(Ho()), x2(e, 2, -2), 0);
}
function x9(e, t, l, r) {
  return _3(e, t, l, r8, x2(e, 0, r), x2(e, r + 1, -1), r);
}
function U4(e, t) {
  for (var l = "", r = o8(e), n = 0; n < r; n++)
    l += t(e[n], n, e, t) || "";
  return l;
}
function $o(e, t, l, r) {
  switch (e.type) {
    case Fo:
      if (e.children.length) break;
    case Lo:
    case r8:
      return e.return = e.return || e.value;
    case c7:
      return "";
    case u7:
      return e.return = e.value + "{" + U4(e.children, r) + "}";
    case n8:
      e.value = e.props.join(",");
  }
  return m4(l = U4(e.children, r)) ? e.return = e.value + "{" + l + "}" : "";
}
function Ko(e) {
  var t = o8(e);
  return function(l, r, n, o) {
    for (var i = "", q = 0; q < t; q++)
      i += e[q](l, r, n, o) || "";
    return i;
  };
}
function Qo(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function ei(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(l) {
    return t[l] === void 0 && (t[l] = e(l)), t[l];
  };
}
var ti = function(t, l, r) {
  for (var n = 0, o = 0; n = o, o = f4(), n === 38 && o === 12 && (l[r] = 1), !h2(o); )
    q4();
  return I2(t, r4);
}, li = function(t, l) {
  var r = -1, n = 44;
  do
    switch (h2(n)) {
      case 0:
        n === 38 && f4() === 12 && (l[r] = 1), t[r] += ti(r4 - 1, l, r);
        break;
      case 2:
        t[r] += W2(n);
        break;
      case 4:
        if (n === 44) {
          t[++r] = f4() === 58 ? "&\f" : "", l[r] = t[r].length;
          break;
        }
      default:
        t[r] += g3(n);
    }
  while (n = q4());
  return t;
}, ni = function(t, l) {
  return x7(li(f7(t), l));
}, h9 = /* @__PURE__ */ new WeakMap(), ri = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var l = t.value, r = t.parent, n = t.column === r.column && t.line === r.line; r.type !== "rule"; )
      if (r = r.parent, !r) return;
    if (!(t.props.length === 1 && l.charCodeAt(0) !== 58 && !h9.get(r)) && !n) {
      h9.set(t, !0);
      for (var o = [], i = ni(l, o), q = r.props, a = 0, s = 0; a < i.length; a++)
        for (var c = 0; c < q.length; c++, s++)
          t.props[s] = o[a] ? i[a].replace(/&\f/g, q[c]) : q[c] + " " + i[a];
    }
  }
}, oi = function(t) {
  if (t.type === "decl") {
    var l = t.value;
    // charcode for l
    l.charCodeAt(0) === 108 && // charcode for b
    l.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function h7(e, t) {
  switch (Do(e, t)) {
    case 5103:
      return E1 + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return E1 + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return E1 + e + o3 + e + K1 + e + e;
    case 6828:
    case 4268:
      return E1 + e + K1 + e + e;
    case 6165:
      return E1 + e + K1 + "flex-" + e + e;
    case 5187:
      return E1 + e + A1(e, /(\w+).+(:[^]+)/, E1 + "box-$1$2" + K1 + "flex-$1$2") + e;
    case 5443:
      return E1 + e + K1 + "flex-item-" + A1(e, /flex-|-self/, "") + e;
    case 4675:
      return E1 + e + K1 + "flex-line-pack" + A1(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return E1 + e + K1 + A1(e, "shrink", "negative") + e;
    case 5292:
      return E1 + e + K1 + A1(e, "basis", "preferred-size") + e;
    case 6060:
      return E1 + "box-" + A1(e, "-grow", "") + E1 + e + K1 + A1(e, "grow", "positive") + e;
    case 4554:
      return E1 + A1(e, /([^-])(transform)/g, "$1" + E1 + "$2") + e;
    case 6187:
      return A1(A1(A1(e, /(zoom-|grab)/, E1 + "$1"), /(image-set)/, E1 + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return A1(e, /(image-set\([^]*)/, E1 + "$1$`$1");
    case 4968:
      return A1(A1(e, /(.+:)(flex-)?(.*)/, E1 + "box-pack:$3" + K1 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + E1 + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return A1(e, /(.+)-inline(.+)/, E1 + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (m4(e) - 1 - t > 6) switch (Z1(e, t + 1)) {
        case 109:
          if (Z1(e, t + 4) !== 45) break;
        case 102:
          return A1(e, /(.+:)(.+)-([^]+)/, "$1" + E1 + "$2-$3$1" + o3 + (Z1(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~h6(e, "stretch") ? h7(A1(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Z1(e, t + 1) !== 115) break;
    case 6444:
      switch (Z1(e, m4(e) - 3 - (~h6(e, "!important") && 10))) {
        case 107:
          return A1(e, ":", ":" + E1) + e;
        case 101:
          return A1(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + E1 + (Z1(e, 14) === 45 ? "inline-" : "") + "box$3$1" + E1 + "$2$3$1" + K1 + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Z1(e, t + 11)) {
        case 114:
          return E1 + e + K1 + A1(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return E1 + e + K1 + A1(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return E1 + e + K1 + A1(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return E1 + e + K1 + e + e;
  }
  return e;
}
var ii = function(t, l, r, n) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case r8:
      t.return = h7(t.value, t.length);
      break;
    case u7:
      return U4([q2(t, {
        value: A1(t.value, "@", "@" + E1)
      })], n);
    case n8:
      if (t.length) return Vo(t.props, function(o) {
        switch (ko(o, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return U4([q2(t, {
              props: [A1(o, /:(read-\w+)/, ":" + o3 + "$1")]
            })], n);
          case "::placeholder":
            return U4([q2(t, {
              props: [A1(o, /:(plac\w+)/, ":" + E1 + "input-$1")]
            }), q2(t, {
              props: [A1(o, /:(plac\w+)/, ":" + o3 + "$1")]
            }), q2(t, {
              props: [A1(o, /:(plac\w+)/, K1 + "input-$1")]
            })], n);
        }
        return "";
      });
  }
}, ai = [ii], qi = function(t) {
  var l = t.key;
  if (l === "css") {
    var r = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(r, function(b) {
      var h = b.getAttribute("data-emotion");
      h.indexOf(" ") !== -1 && (document.head.appendChild(b), b.setAttribute("data-s", ""));
    });
  }
  var n = t.stylisPlugins || ai, o = {}, i, q = [];
  i = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + l + ' "]'),
    function(b) {
      for (var h = b.getAttribute("data-emotion").split(" "), d = 1; d < h.length; d++)
        o[h[d]] = !0;
      q.push(b);
    }
  );
  var a, s = [ri, oi];
  {
    var c, u = [$o, Qo(function(b) {
      c.insert(b);
    })], _ = Ko(s.concat(n, u)), A = function(h) {
      return U4(Jo(h), _);
    };
    a = function(h, d, C, f) {
      c = C, A(h ? h + "{" + d.styles + "}" : d.styles), f && (v.inserted[d.name] = !0);
    };
  }
  var v = {
    key: l,
    sheet: new Po({
      key: l,
      container: i,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: o,
    registered: {},
    insert: a
  };
  return v.sheet.hydrate(q), v;
}, g6 = { exports: {} }, T1 = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var p9;
function si() {
  if (p9) return T1;
  p9 = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, l = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, q = e ? Symbol.for("react.context") : 60110, a = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, d = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function f(p) {
    if (typeof p == "object" && p !== null) {
      var I = p.$$typeof;
      switch (I) {
        case t:
          switch (p = p.type, p) {
            case a:
            case s:
            case r:
            case o:
            case n:
            case u:
              return p;
            default:
              switch (p = p && p.$$typeof, p) {
                case q:
                case c:
                case v:
                case A:
                case i:
                  return p;
                default:
                  return I;
              }
          }
        case l:
          return I;
      }
    }
  }
  function m(p) {
    return f(p) === s;
  }
  return T1.AsyncMode = a, T1.ConcurrentMode = s, T1.ContextConsumer = q, T1.ContextProvider = i, T1.Element = t, T1.ForwardRef = c, T1.Fragment = r, T1.Lazy = v, T1.Memo = A, T1.Portal = l, T1.Profiler = o, T1.StrictMode = n, T1.Suspense = u, T1.isAsyncMode = function(p) {
    return m(p) || f(p) === a;
  }, T1.isConcurrentMode = m, T1.isContextConsumer = function(p) {
    return f(p) === q;
  }, T1.isContextProvider = function(p) {
    return f(p) === i;
  }, T1.isElement = function(p) {
    return typeof p == "object" && p !== null && p.$$typeof === t;
  }, T1.isForwardRef = function(p) {
    return f(p) === c;
  }, T1.isFragment = function(p) {
    return f(p) === r;
  }, T1.isLazy = function(p) {
    return f(p) === v;
  }, T1.isMemo = function(p) {
    return f(p) === A;
  }, T1.isPortal = function(p) {
    return f(p) === l;
  }, T1.isProfiler = function(p) {
    return f(p) === o;
  }, T1.isStrictMode = function(p) {
    return f(p) === n;
  }, T1.isSuspense = function(p) {
    return f(p) === u;
  }, T1.isValidElementType = function(p) {
    return typeof p == "string" || typeof p == "function" || p === r || p === s || p === o || p === n || p === u || p === _ || typeof p == "object" && p !== null && (p.$$typeof === v || p.$$typeof === A || p.$$typeof === i || p.$$typeof === q || p.$$typeof === c || p.$$typeof === h || p.$$typeof === d || p.$$typeof === C || p.$$typeof === b);
  }, T1.typeOf = f, T1;
}
var w1 = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var g9;
function ci() {
  return g9 || (g9 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, l = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, q = e ? Symbol.for("react.context") : 60110, a = e ? Symbol.for("react.async_mode") : 60111, s = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, u = e ? Symbol.for("react.suspense") : 60113, _ = e ? Symbol.for("react.suspense_list") : 60120, A = e ? Symbol.for("react.memo") : 60115, v = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, d = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function f(z) {
      return typeof z == "string" || typeof z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      z === r || z === s || z === o || z === n || z === u || z === _ || typeof z == "object" && z !== null && (z.$$typeof === v || z.$$typeof === A || z.$$typeof === i || z.$$typeof === q || z.$$typeof === c || z.$$typeof === h || z.$$typeof === d || z.$$typeof === C || z.$$typeof === b);
    }
    function m(z) {
      if (typeof z == "object" && z !== null) {
        var l1 = z.$$typeof;
        switch (l1) {
          case t:
            var U = z.type;
            switch (U) {
              case a:
              case s:
              case r:
              case o:
              case n:
              case u:
                return U;
              default:
                var J = U && U.$$typeof;
                switch (J) {
                  case q:
                  case c:
                  case v:
                  case A:
                  case i:
                    return J;
                  default:
                    return l1;
                }
            }
          case l:
            return l1;
        }
      }
    }
    var p = a, I = s, w = q, T = i, L = t, j = c, $ = r, k = v, t1 = A, e1 = l, Q = o, Z = n, X = u, G = !1;
    function a1(z) {
      return G || (G = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), F(z) || m(z) === a;
    }
    function F(z) {
      return m(z) === s;
    }
    function M(z) {
      return m(z) === q;
    }
    function H(z) {
      return m(z) === i;
    }
    function W(z) {
      return typeof z == "object" && z !== null && z.$$typeof === t;
    }
    function S(z) {
      return m(z) === c;
    }
    function E(z) {
      return m(z) === r;
    }
    function g(z) {
      return m(z) === v;
    }
    function x(z) {
      return m(z) === A;
    }
    function R(z) {
      return m(z) === l;
    }
    function Y(z) {
      return m(z) === o;
    }
    function B(z) {
      return m(z) === n;
    }
    function K(z) {
      return m(z) === u;
    }
    w1.AsyncMode = p, w1.ConcurrentMode = I, w1.ContextConsumer = w, w1.ContextProvider = T, w1.Element = L, w1.ForwardRef = j, w1.Fragment = $, w1.Lazy = k, w1.Memo = t1, w1.Portal = e1, w1.Profiler = Q, w1.StrictMode = Z, w1.Suspense = X, w1.isAsyncMode = a1, w1.isConcurrentMode = F, w1.isContextConsumer = M, w1.isContextProvider = H, w1.isElement = W, w1.isForwardRef = S, w1.isFragment = E, w1.isLazy = g, w1.isMemo = x, w1.isPortal = R, w1.isProfiler = Y, w1.isStrictMode = B, w1.isSuspense = K, w1.isValidElementType = f, w1.typeOf = m;
  }()), w1;
}
process.env.NODE_ENV === "production" ? g6.exports = si() : g6.exports = ci();
var ui = g6.exports, p7 = ui, mi = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, di = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, g7 = {};
g7[p7.ForwardRef] = mi;
g7[p7.Memo] = di;
var fi = !0;
function xi(e, t, l) {
  var r = "";
  return l.split(" ").forEach(function(n) {
    e[n] !== void 0 ? t.push(e[n] + ";") : n && (r += n + " ");
  }), r;
}
var b7 = function(t, l, r) {
  var n = t.key + "-" + l.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (r === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  fi === !1) && t.registered[n] === void 0 && (t.registered[n] = l.styles);
}, hi = function(t, l, r) {
  b7(t, l, r);
  var n = t.key + "-" + l.name;
  if (t.inserted[l.name] === void 0) {
    var o = l;
    do
      t.insert(l === o ? "." + n : "", o, t.sheet, !0), o = o.next;
    while (o !== void 0);
  }
};
function pi(e) {
  for (var t = 0, l, r = 0, n = e.length; n >= 4; ++r, n -= 4)
    l = e.charCodeAt(r) & 255 | (e.charCodeAt(++r) & 255) << 8 | (e.charCodeAt(++r) & 255) << 16 | (e.charCodeAt(++r) & 255) << 24, l = /* Math.imul(k, m): */
    (l & 65535) * 1540483477 + ((l >>> 16) * 59797 << 16), l ^= /* k >>> r: */
    l >>> 24, t = /* Math.imul(k, m): */
    (l & 65535) * 1540483477 + ((l >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (n) {
    case 3:
      t ^= (e.charCodeAt(r + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(r + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(r) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var gi = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, bi = /[A-Z]|^ms/g, _i = /_EMO_([^_]+?)_([^]*?)_EMO_/g, _7 = function(t) {
  return t.charCodeAt(1) === 45;
}, b9 = function(t) {
  return t != null && typeof t != "boolean";
}, J3 = /* @__PURE__ */ ei(function(e) {
  return _7(e) ? e : e.replace(bi, "-$&").toLowerCase();
}), _9 = function(t, l) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof l == "string")
        return l.replace(_i, function(r, n, o) {
          return d4 = {
            name: n,
            styles: o,
            next: d4
          }, n;
        });
  }
  return gi[t] !== 1 && !_7(t) && typeof l == "number" && l !== 0 ? l + "px" : l;
};
function p2(e, t, l) {
  if (l == null)
    return "";
  var r = l;
  if (r.__emotion_styles !== void 0)
    return r;
  switch (typeof l) {
    case "boolean":
      return "";
    case "object": {
      var n = l;
      if (n.anim === 1)
        return d4 = {
          name: n.name,
          styles: n.styles,
          next: d4
        }, n.name;
      var o = l;
      if (o.styles !== void 0) {
        var i = o.next;
        if (i !== void 0)
          for (; i !== void 0; )
            d4 = {
              name: i.name,
              styles: i.styles,
              next: d4
            }, i = i.next;
        var q = o.styles + ";";
        return q;
      }
      return vi(e, t, l);
    }
    case "function": {
      if (e !== void 0) {
        var a = d4, s = l(e);
        return d4 = a, p2(e, t, s);
      }
      break;
    }
  }
  var c = l;
  return c;
}
function vi(e, t, l) {
  var r = "";
  if (Array.isArray(l))
    for (var n = 0; n < l.length; n++)
      r += p2(e, t, l[n]) + ";";
  else
    for (var o in l) {
      var i = l[o];
      if (typeof i != "object") {
        var q = i;
        b9(q) && (r += J3(o) + ":" + _9(o, q) + ";");
      } else if (Array.isArray(i) && typeof i[0] == "string" && t == null)
        for (var a = 0; a < i.length; a++)
          b9(i[a]) && (r += J3(o) + ":" + _9(o, i[a]) + ";");
      else {
        var s = p2(e, t, i);
        switch (o) {
          case "animation":
          case "animationName": {
            r += J3(o) + ":" + s + ";";
            break;
          }
          default:
            r += o + "{" + s + "}";
        }
      }
    }
  return r;
}
var v9 = /label:\s*([^\s;{]+)\s*(;|$)/g, d4;
function v7(e, t, l) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var r = !0, n = "";
  d4 = void 0;
  var o = e[0];
  if (o == null || o.raw === void 0)
    r = !1, n += p2(l, t, o);
  else {
    var i = o;
    n += i[0];
  }
  for (var q = 1; q < e.length; q++)
    if (n += p2(l, t, e[q]), r) {
      var a = o;
      n += a[q];
    }
  v9.lastIndex = 0;
  for (var s = "", c; (c = v9.exec(n)) !== null; )
    s += "-" + c[1];
  var u = pi(n) + s;
  return {
    name: u,
    styles: n,
    next: d4
  };
}
var yi = function(t) {
  return t();
}, Ii = s1.useInsertionEffect ? s1.useInsertionEffect : !1, Ci = Ii || yi, y7 = /* @__PURE__ */ s1.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ qi({
    key: "css"
  }) : null
);
y7.Provider;
var Ei = function(t) {
  return /* @__PURE__ */ G4(function(l, r) {
    var n = e4(y7);
    return t(l, n, r);
  });
}, Ai = /* @__PURE__ */ s1.createContext({}), i8 = {}.hasOwnProperty, b6 = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", Si = function(t, l) {
  var r = {};
  for (var n in l)
    i8.call(l, n) && (r[n] = l[n]);
  return r[b6] = t, r;
}, Ri = function(t) {
  var l = t.cache, r = t.serialized, n = t.isStringTag;
  return b7(l, r, n), Ci(function() {
    return hi(l, r, n);
  }), null;
}, Oi = /* @__PURE__ */ Ei(function(e, t, l) {
  var r = e.css;
  typeof r == "string" && t.registered[r] !== void 0 && (r = t.registered[r]);
  var n = e[b6], o = [r], i = "";
  typeof e.className == "string" ? i = xi(t.registered, o, e.className) : e.className != null && (i = e.className + " ");
  var q = v7(o, void 0, s1.useContext(Ai));
  i += t.key + "-" + q.name;
  var a = {};
  for (var s in e)
    i8.call(e, s) && s !== "css" && s !== b6 && (a[s] = e[s]);
  return a.className = i, l && (a.ref = l), /* @__PURE__ */ s1.createElement(s1.Fragment, null, /* @__PURE__ */ s1.createElement(Ri, {
    cache: t,
    serialized: q,
    isStringTag: typeof n == "string"
  }), /* @__PURE__ */ s1.createElement(n, a));
}), Ti = Oi, f1 = function(t, l) {
  var r = arguments;
  if (l == null || !i8.call(l, "css"))
    return s1.createElement.apply(void 0, r);
  var n = r.length, o = new Array(n);
  o[0] = Ti, o[1] = Si(t, l);
  for (var i = 2; i < n; i++)
    o[i] = r[i];
  return s1.createElement.apply(null, o);
};
(function(e) {
  var t;
  t || (t = e.JSX || (e.JSX = {}));
})(f1 || (f1 = {}));
function a8() {
  for (var e = arguments.length, t = new Array(e), l = 0; l < e; l++)
    t[l] = arguments[l];
  return v7(t);
}
function wi() {
  var e = a8.apply(void 0, arguments), t = "animation-" + e.name;
  return {
    name: t,
    styles: "@keyframes " + t + "{" + e.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}
function zi(e, t) {
  return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
    raw: {
      value: Object.freeze(t)
    }
  }));
}
const Ni = Math.min, Mi = Math.max, i3 = Math.round, M2 = Math.floor, _6 = (e) => ({
  x: e,
  y: e
});
function Pi(e) {
  const {
    x: t,
    y: l,
    width: r,
    height: n
  } = e;
  return {
    width: r,
    height: n,
    top: l,
    left: t,
    right: t + r,
    bottom: l + n,
    x: t,
    y: l
  };
}
function v3() {
  return typeof window < "u";
}
function I7(e) {
  return E7(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function D4(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function C7(e) {
  var t;
  return (t = (E7(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function E7(e) {
  return v3() ? e instanceof Node || e instanceof D4(e).Node : !1;
}
function Li(e) {
  return v3() ? e instanceof Element || e instanceof D4(e).Element : !1;
}
function q8(e) {
  return v3() ? e instanceof HTMLElement || e instanceof D4(e).HTMLElement : !1;
}
function y9(e) {
  return !v3() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof D4(e).ShadowRoot;
}
function A7(e) {
  const {
    overflow: t,
    overflowX: l,
    overflowY: r,
    display: n
  } = S7(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + l) && n !== "inline" && n !== "contents";
}
function Fi(e) {
  return /^(html|body|#document)$/.test(I7(e));
}
function S7(e) {
  return D4(e).getComputedStyle(e);
}
function Bi(e) {
  if (I7(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    y9(e) && e.host || // Fallback.
    C7(e)
  );
  return y9(t) ? t.host : t;
}
function R7(e) {
  const t = Bi(e);
  return Fi(t) ? (e.ownerDocument || e).body : q8(t) && A7(t) ? t : R7(t);
}
function a3(e, t, l) {
  var r;
  t === void 0 && (t = []), l === void 0 && (l = !0);
  const n = R7(e), o = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = D4(n);
  if (o) {
    const q = Gi(i);
    return t.concat(i, i.visualViewport || [], A7(n) ? n : [], q && l ? a3(q) : []);
  } else
    return t.concat(n, a3(n, [], l));
}
function Gi(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Di(e) {
  const t = S7(e);
  let l = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const n = q8(e), o = n ? e.offsetWidth : l, i = n ? e.offsetHeight : r, q = i3(l) !== o || i3(r) !== i;
  return q && (l = o, r = i), {
    width: l,
    height: r,
    $: q
  };
}
function s8(e) {
  return Li(e) ? e : e.contextElement;
}
function ki(e) {
  const t = s8(e);
  if (!q8(t))
    return _6(1);
  const l = t.getBoundingClientRect(), {
    width: r,
    height: n,
    $: o
  } = Di(t);
  let i = (o ? i3(l.width) : l.width) / r, q = (o ? i3(l.height) : l.height) / n;
  return (!i || !Number.isFinite(i)) && (i = 1), (!q || !Number.isFinite(q)) && (q = 1), {
    x: i,
    y: q
  };
}
function I9(e, t, l, r) {
  t === void 0 && (t = !1);
  const n = e.getBoundingClientRect();
  s8(e);
  let o = _6(1);
  t && (o = ki(e));
  const i = _6(0);
  let q = (n.left + i.x) / o.x, a = (n.top + i.y) / o.y, s = n.width / o.x, c = n.height / o.y;
  return Pi({
    width: s,
    height: c,
    x: q,
    y: a
  });
}
function O7(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Vi(e, t, l) {
  let r = null, n;
  const o = C7(e);
  function i() {
    var c;
    clearTimeout(n), (c = r) == null || c.disconnect(), r = null;
  }
  function q(c, u) {
    c === void 0 && (c = !1), u === void 0 && (u = 1), i();
    const _ = e.getBoundingClientRect(), {
      left: A,
      top: v,
      width: b,
      height: h
    } = _;
    if (c || t(), !b || !h)
      return;
    const d = M2(v), C = M2(o.clientWidth - (A + b)), f = M2(o.clientHeight - (v + h)), m = M2(A), I = {
      rootMargin: -d + "px " + -C + "px " + -f + "px " + -m + "px",
      threshold: Mi(0, Ni(1, u)) || 1
    };
    let w = !0;
    function T(L) {
      const j = L[0].intersectionRatio;
      if (!O7(_, e.getBoundingClientRect()))
        return q();
      if (j !== u) {
        if (!w)
          return q();
        j ? q(!1, j) : n = setTimeout(() => {
          q(!1, 1e-7);
        }, 1e3);
      }
      w = !1;
    }
    try {
      r = new IntersectionObserver(T, {
        ...I,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(T, I);
    }
    r.observe(e);
  }
  const a = D4(e), s = () => q(l);
  return a.addEventListener("resize", s), q(!0), () => {
    a.removeEventListener("resize", s), i();
  };
}
function Hi(e, t, l, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: o = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: q = typeof IntersectionObserver == "function",
    animationFrame: a = !1
  } = r, s = s8(e), c = n || o ? [...s ? a3(s) : [], ...t ? a3(t) : []] : [];
  c.forEach((d) => {
    n && d.addEventListener("scroll", l), o && d.addEventListener("resize", l);
  });
  const u = s && q ? Vi(s, l, o) : null;
  let _ = -1, A = null;
  i && (A = new ResizeObserver((d) => {
    let [C] = d;
    C && C.target === s && A && t && (A.unobserve(t), cancelAnimationFrame(_), _ = requestAnimationFrame(() => {
      var f;
      (f = A) == null || f.observe(t);
    })), l();
  }), s && !a && A.observe(s), t && A.observe(t));
  let v, b = a ? I9(e) : null;
  a && h();
  function h() {
    const d = I9(e);
    b && !O7(b, d) && l(), b = d, v = requestAnimationFrame(h);
  }
  return l(), () => {
    var d;
    c.forEach((C) => {
      n && C.removeEventListener("scroll", l), o && C.removeEventListener("resize", l);
    }), u == null || u(), (d = A) == null || d.disconnect(), A = null, a && cancelAnimationFrame(v);
  };
}
var v6 = H9, Wi = ["className", "clearValue", "cx", "getStyles", "getClassNames", "getValue", "hasValue", "isMulti", "isRtl", "options", "selectOption", "selectProps", "setValue", "theme"], q3 = function() {
};
function ji(e, t) {
  return t ? t[0] === "-" ? e + t : e + "__" + t : e;
}
function Xi(e, t) {
  for (var l = arguments.length, r = new Array(l > 2 ? l - 2 : 0), n = 2; n < l; n++)
    r[n - 2] = arguments[n];
  var o = [].concat(r);
  if (t && e)
    for (var i in t)
      t.hasOwnProperty(i) && t[i] && o.push("".concat(ji(e, i)));
  return o.filter(function(q) {
    return q;
  }).map(function(q) {
    return String(q).trim();
  }).join(" ");
}
var C9 = function(t) {
  return ta(t) ? t.filter(Boolean) : B4(t) === "object" && t !== null ? [t] : [];
}, T7 = function(t) {
  t.className, t.clearValue, t.cx, t.getStyles, t.getClassNames, t.getValue, t.hasValue, t.isMulti, t.isRtl, t.options, t.selectOption, t.selectProps, t.setValue, t.theme;
  var l = b4(t, Wi);
  return h1({}, l);
}, D1 = function(t, l, r) {
  var n = t.cx, o = t.getStyles, i = t.getClassNames, q = t.className;
  return {
    css: o(l, t),
    className: n(r ?? {}, i(l, t), q)
  };
};
function y3(e) {
  return [document.documentElement, document.body, window].indexOf(e) > -1;
}
function Zi(e) {
  return y3(e) ? window.innerHeight : e.clientHeight;
}
function w7(e) {
  return y3(e) ? window.pageYOffset : e.scrollTop;
}
function s3(e, t) {
  if (y3(e)) {
    window.scrollTo(0, t);
    return;
  }
  e.scrollTop = t;
}
function Yi(e) {
  var t = getComputedStyle(e), l = t.position === "absolute", r = /(auto|scroll)/;
  if (t.position === "fixed") return document.documentElement;
  for (var n = e; n = n.parentElement; )
    if (t = getComputedStyle(n), !(l && t.position === "static") && r.test(t.overflow + t.overflowY + t.overflowX))
      return n;
  return document.documentElement;
}
function Ji(e, t, l, r) {
  return l * ((e = e / r - 1) * e * e + 1) + t;
}
function P2(e, t) {
  var l = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 200, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : q3, n = w7(e), o = t - n, i = 10, q = 0;
  function a() {
    q += i;
    var s = Ji(q, n, o, l);
    s3(e, s), q < l ? window.requestAnimationFrame(a) : r(e);
  }
  a();
}
function E9(e, t) {
  var l = e.getBoundingClientRect(), r = t.getBoundingClientRect(), n = t.offsetHeight / 3;
  r.bottom + n > l.bottom ? s3(e, Math.min(t.offsetTop + t.clientHeight - e.offsetHeight + n, e.scrollHeight)) : r.top - n < l.top && s3(e, Math.max(t.offsetTop - n, 0));
}
function Ui(e) {
  var t = e.getBoundingClientRect();
  return {
    bottom: t.bottom,
    height: t.height,
    left: t.left,
    right: t.right,
    top: t.top,
    width: t.width
  };
}
function A9() {
  try {
    return document.createEvent("TouchEvent"), !0;
  } catch {
    return !1;
  }
}
function $i() {
  try {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  } catch {
    return !1;
  }
}
var z7 = !1, Ki = {
  get passive() {
    return z7 = !0;
  }
}, L2 = typeof window < "u" ? window : {};
L2.addEventListener && L2.removeEventListener && (L2.addEventListener("p", q3, Ki), L2.removeEventListener("p", q3, !1));
var Qi = z7;
function ea(e) {
  return e != null;
}
function ta(e) {
  return Array.isArray(e);
}
function F2(e, t, l) {
  return e ? t : l;
}
var la = function(t) {
  for (var l = arguments.length, r = new Array(l > 1 ? l - 1 : 0), n = 1; n < l; n++)
    r[n - 1] = arguments[n];
  var o = Object.entries(t).filter(function(i) {
    var q = h4(i, 1), a = q[0];
    return !r.includes(a);
  });
  return o.reduce(function(i, q) {
    var a = h4(q, 2), s = a[0], c = a[1];
    return i[s] = c, i;
  }, {});
}, na = ["children", "innerProps"], ra = ["children", "innerProps"];
function oa(e) {
  var t = e.maxHeight, l = e.menuEl, r = e.minHeight, n = e.placement, o = e.shouldScroll, i = e.isFixedPosition, q = e.controlHeight, a = Yi(l), s = {
    placement: "bottom",
    maxHeight: t
  };
  if (!l || !l.offsetParent) return s;
  var c = a.getBoundingClientRect(), u = c.height, _ = l.getBoundingClientRect(), A = _.bottom, v = _.height, b = _.top, h = l.offsetParent.getBoundingClientRect(), d = h.top, C = i ? window.innerHeight : Zi(a), f = w7(a), m = parseInt(getComputedStyle(l).marginBottom, 10), p = parseInt(getComputedStyle(l).marginTop, 10), I = d - p, w = C - b, T = I + f, L = u - f - b, j = A - C + f + m, $ = f + b - p, k = 160;
  switch (n) {
    case "auto":
    case "bottom":
      if (w >= v)
        return {
          placement: "bottom",
          maxHeight: t
        };
      if (L >= v && !i)
        return o && P2(a, j, k), {
          placement: "bottom",
          maxHeight: t
        };
      if (!i && L >= r || i && w >= r) {
        o && P2(a, j, k);
        var t1 = i ? w - m : L - m;
        return {
          placement: "bottom",
          maxHeight: t1
        };
      }
      if (n === "auto" || i) {
        var e1 = t, Q = i ? I : T;
        return Q >= r && (e1 = Math.min(Q - m - q, t)), {
          placement: "top",
          maxHeight: e1
        };
      }
      if (n === "bottom")
        return o && s3(a, j), {
          placement: "bottom",
          maxHeight: t
        };
      break;
    case "top":
      if (I >= v)
        return {
          placement: "top",
          maxHeight: t
        };
      if (T >= v && !i)
        return o && P2(a, $, k), {
          placement: "top",
          maxHeight: t
        };
      if (!i && T >= r || i && I >= r) {
        var Z = t;
        return (!i && T >= r || i && I >= r) && (Z = i ? I - p : T - p), o && P2(a, $, k), {
          placement: "top",
          maxHeight: Z
        };
      }
      return {
        placement: "bottom",
        maxHeight: t
      };
    default:
      throw new Error('Invalid placement provided "'.concat(n, '".'));
  }
  return s;
}
function ia(e) {
  var t = {
    bottom: "top",
    top: "bottom"
  };
  return e ? t[e] : "bottom";
}
var N7 = function(t) {
  return t === "auto" ? "bottom" : t;
}, aa = function(t, l) {
  var r, n = t.placement, o = t.theme, i = o.borderRadius, q = o.spacing, a = o.colors;
  return h1((r = {
    label: "menu"
  }, u2(r, ia(n), "100%"), u2(r, "position", "absolute"), u2(r, "width", "100%"), u2(r, "zIndex", 1), r), l ? {} : {
    backgroundColor: a.neutral0,
    borderRadius: i,
    boxShadow: "0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)",
    marginBottom: q.menuGutter,
    marginTop: q.menuGutter
  });
}, M7 = /* @__PURE__ */ C6(null), qa = function(t) {
  var l = t.children, r = t.minMenuHeight, n = t.maxMenuHeight, o = t.menuPlacement, i = t.menuPosition, q = t.menuShouldScrollIntoView, a = t.theme, s = e4(M7) || {}, c = s.setPortalPlacement, u = v1(null), _ = m1(n), A = h4(_, 2), v = A[0], b = A[1], h = m1(null), d = h4(h, 2), C = d[0], f = d[1], m = a.spacing.controlHeight;
  return v6(function() {
    var p = u.current;
    if (p) {
      var I = i === "fixed", w = q && !I, T = oa({
        maxHeight: n,
        menuEl: p,
        minHeight: r,
        placement: o,
        shouldScroll: w,
        isFixedPosition: I,
        controlHeight: m
      });
      b(T.maxHeight), f(T.placement), c == null || c(T.placement);
    }
  }, [n, o, i, q, r, c, m]), l({
    ref: u,
    placerProps: h1(h1({}, t), {}, {
      placement: C || N7(o),
      maxHeight: v
    })
  });
}, sa = function(t) {
  var l = t.children, r = t.innerRef, n = t.innerProps;
  return f1("div", p1({}, D1(t, "menu", {
    menu: !0
  }), {
    ref: r
  }, n), l);
}, ca = sa, ua = function(t, l) {
  var r = t.maxHeight, n = t.theme.spacing.baseUnit;
  return h1({
    maxHeight: r,
    overflowY: "auto",
    position: "relative",
    // required for offset[Height, Top] > keyboard scroll
    WebkitOverflowScrolling: "touch"
  }, l ? {} : {
    paddingBottom: n,
    paddingTop: n
  });
}, ma = function(t) {
  var l = t.children, r = t.innerProps, n = t.innerRef, o = t.isMulti;
  return f1("div", p1({}, D1(t, "menuList", {
    "menu-list": !0,
    "menu-list--is-multi": o
  }), {
    ref: n
  }, r), l);
}, P7 = function(t, l) {
  var r = t.theme, n = r.spacing.baseUnit, o = r.colors;
  return h1({
    textAlign: "center"
  }, l ? {} : {
    color: o.neutral40,
    padding: "".concat(n * 2, "px ").concat(n * 3, "px")
  });
}, da = P7, fa = P7, xa = function(t) {
  var l = t.children, r = l === void 0 ? "No options" : l, n = t.innerProps, o = b4(t, na);
  return f1("div", p1({}, D1(h1(h1({}, o), {}, {
    children: r,
    innerProps: n
  }), "noOptionsMessage", {
    "menu-notice": !0,
    "menu-notice--no-options": !0
  }), n), r);
}, ha = function(t) {
  var l = t.children, r = l === void 0 ? "Loading..." : l, n = t.innerProps, o = b4(t, ra);
  return f1("div", p1({}, D1(h1(h1({}, o), {}, {
    children: r,
    innerProps: n
  }), "loadingMessage", {
    "menu-notice": !0,
    "menu-notice--loading": !0
  }), n), r);
}, pa = function(t) {
  var l = t.rect, r = t.offset, n = t.position;
  return {
    left: l.left,
    position: n,
    top: r,
    width: l.width,
    zIndex: 1
  };
}, ga = function(t) {
  var l = t.appendTo, r = t.children, n = t.controlElement, o = t.innerProps, i = t.menuPlacement, q = t.menuPosition, a = v1(null), s = v1(null), c = m1(N7(i)), u = h4(c, 2), _ = u[0], A = u[1], v = j1(function() {
    return {
      setPortalPlacement: A
    };
  }, []), b = m1(null), h = h4(b, 2), d = h[0], C = h[1], f = o1(function() {
    if (n) {
      var w = Ui(n), T = q === "fixed" ? 0 : window.pageYOffset, L = w[_] + T;
      (L !== (d == null ? void 0 : d.offset) || w.left !== (d == null ? void 0 : d.rect.left) || w.width !== (d == null ? void 0 : d.rect.width)) && C({
        offset: L,
        rect: w
      });
    }
  }, [n, q, _, d == null ? void 0 : d.offset, d == null ? void 0 : d.rect.left, d == null ? void 0 : d.rect.width]);
  v6(function() {
    f();
  }, [f]);
  var m = o1(function() {
    typeof s.current == "function" && (s.current(), s.current = null), n && a.current && (s.current = Hi(n, a.current, f, {
      elementResize: "ResizeObserver" in window
    }));
  }, [n, f]);
  v6(function() {
    m();
  }, [m]);
  var p = o1(function(w) {
    a.current = w, m();
  }, [m]);
  if (!l && q !== "fixed" || !d) return null;
  var I = f1("div", p1({
    ref: p
  }, D1(h1(h1({}, t), {}, {
    offset: d.offset,
    position: q,
    rect: d.rect
  }), "menuPortal", {
    "menu-portal": !0
  }), o), r);
  return f1(M7.Provider, {
    value: v
  }, l ? /* @__PURE__ */ Te(I, l) : I);
}, ba = function(t) {
  var l = t.isDisabled, r = t.isRtl;
  return {
    label: "container",
    direction: r ? "rtl" : void 0,
    pointerEvents: l ? "none" : void 0,
    // cancel mouse events when disabled
    position: "relative"
  };
}, _a = function(t) {
  var l = t.children, r = t.innerProps, n = t.isDisabled, o = t.isRtl;
  return f1("div", p1({}, D1(t, "container", {
    "--is-disabled": n,
    "--is-rtl": o
  }), r), l);
}, va = function(t, l) {
  var r = t.theme.spacing, n = t.isMulti, o = t.hasValue, i = t.selectProps.controlShouldRenderValue;
  return h1({
    alignItems: "center",
    display: n && o && i ? "flex" : "grid",
    flex: 1,
    flexWrap: "wrap",
    WebkitOverflowScrolling: "touch",
    position: "relative",
    overflow: "hidden"
  }, l ? {} : {
    padding: "".concat(r.baseUnit / 2, "px ").concat(r.baseUnit * 2, "px")
  });
}, ya = function(t) {
  var l = t.children, r = t.innerProps, n = t.isMulti, o = t.hasValue;
  return f1("div", p1({}, D1(t, "valueContainer", {
    "value-container": !0,
    "value-container--is-multi": n,
    "value-container--has-value": o
  }), r), l);
}, Ia = function() {
  return {
    alignItems: "center",
    alignSelf: "stretch",
    display: "flex",
    flexShrink: 0
  };
}, Ca = function(t) {
  var l = t.children, r = t.innerProps;
  return f1("div", p1({}, D1(t, "indicatorsContainer", {
    indicators: !0
  }), r), l);
}, S9, Ea = ["size"], Aa = ["innerProps", "isRtl", "size"];
function Sa() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Ra = process.env.NODE_ENV === "production" ? {
  name: "8mmkcg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
} : {
  name: "tj5bde-Svg",
  styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0;label:Svg;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: Sa
}, L7 = function(t) {
  var l = t.size, r = b4(t, Ea);
  return f1("svg", p1({
    height: l,
    width: l,
    viewBox: "0 0 20 20",
    "aria-hidden": "true",
    focusable: "false",
    css: Ra
  }, r));
}, c8 = function(t) {
  return f1(L7, p1({
    size: 20
  }, t), f1("path", {
    d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
  }));
}, F7 = function(t) {
  return f1(L7, p1({
    size: 20
  }, t), f1("path", {
    d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
  }));
}, B7 = function(t, l) {
  var r = t.isFocused, n = t.theme, o = n.spacing.baseUnit, i = n.colors;
  return h1({
    label: "indicatorContainer",
    display: "flex",
    transition: "color 150ms"
  }, l ? {} : {
    color: r ? i.neutral60 : i.neutral20,
    padding: o * 2,
    ":hover": {
      color: r ? i.neutral80 : i.neutral40
    }
  });
}, Oa = B7, Ta = function(t) {
  var l = t.children, r = t.innerProps;
  return f1("div", p1({}, D1(t, "dropdownIndicator", {
    indicator: !0,
    "dropdown-indicator": !0
  }), r), l || f1(F7, null));
}, wa = B7, za = function(t) {
  var l = t.children, r = t.innerProps;
  return f1("div", p1({}, D1(t, "clearIndicator", {
    indicator: !0,
    "clear-indicator": !0
  }), r), l || f1(c8, null));
}, Na = function(t, l) {
  var r = t.isDisabled, n = t.theme, o = n.spacing.baseUnit, i = n.colors;
  return h1({
    label: "indicatorSeparator",
    alignSelf: "stretch",
    width: 1
  }, l ? {} : {
    backgroundColor: r ? i.neutral10 : i.neutral20,
    marginBottom: o * 2,
    marginTop: o * 2
  });
}, Ma = function(t) {
  var l = t.innerProps;
  return f1("span", p1({}, l, D1(t, "indicatorSeparator", {
    "indicator-separator": !0
  })));
}, Pa = wi(S9 || (S9 = zi([`
  0%, 80%, 100% { opacity: 0; }
  40% { opacity: 1; }
`]))), La = function(t, l) {
  var r = t.isFocused, n = t.size, o = t.theme, i = o.colors, q = o.spacing.baseUnit;
  return h1({
    label: "loadingIndicator",
    display: "flex",
    transition: "color 150ms",
    alignSelf: "center",
    fontSize: n,
    lineHeight: 1,
    marginRight: n,
    textAlign: "center",
    verticalAlign: "middle"
  }, l ? {} : {
    color: r ? i.neutral60 : i.neutral20,
    padding: q * 2
  });
}, U3 = function(t) {
  var l = t.delay, r = t.offset;
  return f1("span", {
    css: /* @__PURE__ */ a8({
      animation: "".concat(Pa, " 1s ease-in-out ").concat(l, "ms infinite;"),
      backgroundColor: "currentColor",
      borderRadius: "1em",
      display: "inline-block",
      marginLeft: r ? "1em" : void 0,
      height: "1em",
      verticalAlign: "top",
      width: "1em"
    }, process.env.NODE_ENV === "production" ? "" : ";label:LoadingDot;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  });
}, Fa = function(t) {
  var l = t.innerProps, r = t.isRtl, n = t.size, o = n === void 0 ? 4 : n, i = b4(t, Aa);
  return f1("div", p1({}, D1(h1(h1({}, i), {}, {
    innerProps: l,
    isRtl: r,
    size: o
  }), "loadingIndicator", {
    indicator: !0,
    "loading-indicator": !0
  }), l), f1(U3, {
    delay: 0,
    offset: r
  }), f1(U3, {
    delay: 160,
    offset: !0
  }), f1(U3, {
    delay: 320,
    offset: !r
  }));
}, Ba = function(t, l) {
  var r = t.isDisabled, n = t.isFocused, o = t.theme, i = o.colors, q = o.borderRadius, a = o.spacing;
  return h1({
    label: "control",
    alignItems: "center",
    cursor: "default",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    minHeight: a.controlHeight,
    outline: "0 !important",
    position: "relative",
    transition: "all 100ms"
  }, l ? {} : {
    backgroundColor: r ? i.neutral5 : i.neutral0,
    borderColor: r ? i.neutral10 : n ? i.primary : i.neutral20,
    borderRadius: q,
    borderStyle: "solid",
    borderWidth: 1,
    boxShadow: n ? "0 0 0 1px ".concat(i.primary) : void 0,
    "&:hover": {
      borderColor: n ? i.primary : i.neutral30
    }
  });
}, Ga = function(t) {
  var l = t.children, r = t.isDisabled, n = t.isFocused, o = t.innerRef, i = t.innerProps, q = t.menuIsOpen;
  return f1("div", p1({
    ref: o
  }, D1(t, "control", {
    control: !0,
    "control--is-disabled": r,
    "control--is-focused": n,
    "control--menu-is-open": q
  }), i, {
    "aria-disabled": r || void 0
  }), l);
}, Da = Ga, ka = ["data"], Va = function(t, l) {
  var r = t.theme.spacing;
  return l ? {} : {
    paddingBottom: r.baseUnit * 2,
    paddingTop: r.baseUnit * 2
  };
}, Ha = function(t) {
  var l = t.children, r = t.cx, n = t.getStyles, o = t.getClassNames, i = t.Heading, q = t.headingProps, a = t.innerProps, s = t.label, c = t.theme, u = t.selectProps;
  return f1("div", p1({}, D1(t, "group", {
    group: !0
  }), a), f1(i, p1({}, q, {
    selectProps: u,
    theme: c,
    getStyles: n,
    getClassNames: o,
    cx: r
  }), s), f1("div", null, l));
}, Wa = function(t, l) {
  var r = t.theme, n = r.colors, o = r.spacing;
  return h1({
    label: "group",
    cursor: "default",
    display: "block"
  }, l ? {} : {
    color: n.neutral40,
    fontSize: "75%",
    fontWeight: 500,
    marginBottom: "0.25em",
    paddingLeft: o.baseUnit * 3,
    paddingRight: o.baseUnit * 3,
    textTransform: "uppercase"
  });
}, ja = function(t) {
  var l = T7(t);
  l.data;
  var r = b4(l, ka);
  return f1("div", p1({}, D1(t, "groupHeading", {
    "group-heading": !0
  }), r));
}, Xa = Ha, Za = ["innerRef", "isDisabled", "isHidden", "inputClassName"], Ya = function(t, l) {
  var r = t.isDisabled, n = t.value, o = t.theme, i = o.spacing, q = o.colors;
  return h1(h1({
    visibility: r ? "hidden" : "visible",
    // force css to recompute when value change due to @emotion bug.
    // We can remove it whenever the bug is fixed.
    transform: n ? "translateZ(0)" : ""
  }, Ja), l ? {} : {
    margin: i.baseUnit / 2,
    paddingBottom: i.baseUnit / 2,
    paddingTop: i.baseUnit / 2,
    color: q.neutral80
  });
}, G7 = {
  gridArea: "1 / 2",
  font: "inherit",
  minWidth: "2px",
  border: 0,
  margin: 0,
  outline: 0,
  padding: 0
}, Ja = {
  flex: "1 1 auto",
  display: "inline-grid",
  gridArea: "1 / 1 / 2 / 3",
  gridTemplateColumns: "0 min-content",
  "&:after": h1({
    content: 'attr(data-value) " "',
    visibility: "hidden",
    whiteSpace: "pre"
  }, G7)
}, Ua = function(t) {
  return h1({
    label: "input",
    color: "inherit",
    background: 0,
    opacity: t ? 0 : 1,
    width: "100%"
  }, G7);
}, $a = function(t) {
  var l = t.cx, r = t.value, n = T7(t), o = n.innerRef, i = n.isDisabled, q = n.isHidden, a = n.inputClassName, s = b4(n, Za);
  return f1("div", p1({}, D1(t, "input", {
    "input-container": !0
  }), {
    "data-value": r || ""
  }), f1("input", p1({
    className: l({
      input: !0
    }, a),
    ref: o,
    style: Ua(q),
    disabled: i
  }, s)));
}, Ka = $a, Qa = function(t, l) {
  var r = t.theme, n = r.spacing, o = r.borderRadius, i = r.colors;
  return h1({
    label: "multiValue",
    display: "flex",
    minWidth: 0
  }, l ? {} : {
    backgroundColor: i.neutral10,
    borderRadius: o / 2,
    margin: n.baseUnit / 2
  });
}, eq = function(t, l) {
  var r = t.theme, n = r.borderRadius, o = r.colors, i = t.cropWithEllipsis;
  return h1({
    overflow: "hidden",
    textOverflow: i || i === void 0 ? "ellipsis" : void 0,
    whiteSpace: "nowrap"
  }, l ? {} : {
    borderRadius: n / 2,
    color: o.neutral80,
    fontSize: "85%",
    padding: 3,
    paddingLeft: 6
  });
}, tq = function(t, l) {
  var r = t.theme, n = r.spacing, o = r.borderRadius, i = r.colors, q = t.isFocused;
  return h1({
    alignItems: "center",
    display: "flex"
  }, l ? {} : {
    borderRadius: o / 2,
    backgroundColor: q ? i.dangerLight : void 0,
    paddingLeft: n.baseUnit,
    paddingRight: n.baseUnit,
    ":hover": {
      backgroundColor: i.dangerLight,
      color: i.danger
    }
  });
}, D7 = function(t) {
  var l = t.children, r = t.innerProps;
  return f1("div", r, l);
}, lq = D7, nq = D7;
function rq(e) {
  var t = e.children, l = e.innerProps;
  return f1("div", p1({
    role: "button"
  }, l), t || f1(c8, {
    size: 14
  }));
}
var oq = function(t) {
  var l = t.children, r = t.components, n = t.data, o = t.innerProps, i = t.isDisabled, q = t.removeProps, a = t.selectProps, s = r.Container, c = r.Label, u = r.Remove;
  return f1(s, {
    data: n,
    innerProps: h1(h1({}, D1(t, "multiValue", {
      "multi-value": !0,
      "multi-value--is-disabled": i
    })), o),
    selectProps: a
  }, f1(c, {
    data: n,
    innerProps: h1({}, D1(t, "multiValueLabel", {
      "multi-value__label": !0
    })),
    selectProps: a
  }, l), f1(u, {
    data: n,
    innerProps: h1(h1({}, D1(t, "multiValueRemove", {
      "multi-value__remove": !0
    })), {}, {
      "aria-label": "Remove ".concat(l || "option")
    }, q),
    selectProps: a
  }));
}, iq = oq, aq = function(t, l) {
  var r = t.isDisabled, n = t.isFocused, o = t.isSelected, i = t.theme, q = i.spacing, a = i.colors;
  return h1({
    label: "option",
    cursor: "default",
    display: "block",
    fontSize: "inherit",
    width: "100%",
    userSelect: "none",
    WebkitTapHighlightColor: "rgba(0, 0, 0, 0)"
  }, l ? {} : {
    backgroundColor: o ? a.primary : n ? a.primary25 : "transparent",
    color: r ? a.neutral20 : o ? a.neutral0 : "inherit",
    padding: "".concat(q.baseUnit * 2, "px ").concat(q.baseUnit * 3, "px"),
    // provide some affordance on touch devices
    ":active": {
      backgroundColor: r ? void 0 : o ? a.primary : a.primary50
    }
  });
}, qq = function(t) {
  var l = t.children, r = t.isDisabled, n = t.isFocused, o = t.isSelected, i = t.innerRef, q = t.innerProps;
  return f1("div", p1({}, D1(t, "option", {
    option: !0,
    "option--is-disabled": r,
    "option--is-focused": n,
    "option--is-selected": o
  }), {
    ref: i,
    "aria-disabled": r
  }, q), l);
}, sq = qq, cq = function(t, l) {
  var r = t.theme, n = r.spacing, o = r.colors;
  return h1({
    label: "placeholder",
    gridArea: "1 / 1 / 2 / 3"
  }, l ? {} : {
    color: o.neutral50,
    marginLeft: n.baseUnit / 2,
    marginRight: n.baseUnit / 2
  });
}, uq = function(t) {
  var l = t.children, r = t.innerProps;
  return f1("div", p1({}, D1(t, "placeholder", {
    placeholder: !0
  }), r), l);
}, mq = uq, dq = function(t, l) {
  var r = t.isDisabled, n = t.theme, o = n.spacing, i = n.colors;
  return h1({
    label: "singleValue",
    gridArea: "1 / 1 / 2 / 3",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
  }, l ? {} : {
    color: r ? i.neutral40 : i.neutral80,
    marginLeft: o.baseUnit / 2,
    marginRight: o.baseUnit / 2
  });
}, fq = function(t) {
  var l = t.children, r = t.isDisabled, n = t.innerProps;
  return f1("div", p1({}, D1(t, "singleValue", {
    "single-value": !0,
    "single-value--is-disabled": r
  }), n), l);
}, xq = fq, hq = {
  ClearIndicator: za,
  Control: Da,
  DropdownIndicator: Ta,
  DownChevron: F7,
  CrossIcon: c8,
  Group: Xa,
  GroupHeading: ja,
  IndicatorsContainer: Ca,
  IndicatorSeparator: Ma,
  Input: Ka,
  LoadingIndicator: Fa,
  Menu: ca,
  MenuList: ma,
  MenuPortal: ga,
  LoadingMessage: ha,
  NoOptionsMessage: xa,
  MultiValue: iq,
  MultiValueContainer: lq,
  MultiValueLabel: nq,
  MultiValueRemove: rq,
  Option: sq,
  Placeholder: mq,
  SelectContainer: _a,
  SingleValue: xq,
  ValueContainer: ya
}, pq = function(t) {
  return h1(h1({}, hq), t.components);
}, R9 = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function gq(e, t) {
  return !!(e === t || R9(e) && R9(t));
}
function bq(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var l = 0; l < e.length; l++)
    if (!gq(e[l], t[l]))
      return !1;
  return !0;
}
function _q(e, t) {
  t === void 0 && (t = bq);
  var l = null;
  function r() {
    for (var n = [], o = 0; o < arguments.length; o++)
      n[o] = arguments[o];
    if (l && l.lastThis === this && t(n, l.lastArgs))
      return l.lastResult;
    var i = e.apply(this, n);
    return l = {
      lastResult: i,
      lastArgs: n,
      lastThis: this
    }, i;
  }
  return r.clear = function() {
    l = null;
  }, r;
}
function vq() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var yq = process.env.NODE_ENV === "production" ? {
  name: "7pg0cj-a11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
} : {
  name: "1f43avz-a11yText-A11yText",
  styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap;label:A11yText;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkExMXlUZXh0LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFPSSIsImZpbGUiOiJBMTF5VGV4dC50c3giLCJzb3VyY2VzQ29udGVudCI6WyIvKiogQGpzeCBqc3ggKi9cbmltcG9ydCB7IEpTWCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCB7IGpzeCB9IGZyb20gJ0BlbW90aW9uL3JlYWN0JztcblxuLy8gQXNzaXN0aXZlIHRleHQgdG8gZGVzY3JpYmUgdmlzdWFsIGVsZW1lbnRzLiBIaWRkZW4gZm9yIHNpZ2h0ZWQgdXNlcnMuXG5jb25zdCBBMTF5VGV4dCA9IChwcm9wczogSlNYLkludHJpbnNpY0VsZW1lbnRzWydzcGFuJ10pID0+IChcbiAgPHNwYW5cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAnYTExeVRleHQnLFxuICAgICAgekluZGV4OiA5OTk5LFxuICAgICAgYm9yZGVyOiAwLFxuICAgICAgY2xpcDogJ3JlY3QoMXB4LCAxcHgsIDFweCwgMXB4KScsXG4gICAgICBoZWlnaHQ6IDEsXG4gICAgICB3aWR0aDogMSxcbiAgICAgIHBvc2l0aW9uOiAnYWJzb2x1dGUnLFxuICAgICAgb3ZlcmZsb3c6ICdoaWRkZW4nLFxuICAgICAgcGFkZGluZzogMCxcbiAgICAgIHdoaXRlU3BhY2U6ICdub3dyYXAnLFxuICAgIH19XG4gICAgey4uLnByb3BzfVxuICAvPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgQTExeVRleHQ7XG4iXX0= */",
  toString: vq
}, Iq = function(t) {
  return f1("span", p1({
    css: yq
  }, t));
}, O9 = Iq, Cq = {
  guidance: function(t) {
    var l = t.isSearchable, r = t.isMulti, n = t.tabSelectsValue, o = t.context, i = t.isInitialFocus;
    switch (o) {
      case "menu":
        return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(n ? ", press Tab to select the option and exit the menu" : "", ".");
      case "input":
        return i ? "".concat(t["aria-label"] || "Select", " is focused ").concat(l ? ",type to refine list" : "", ", press Down to open the menu, ").concat(r ? " press left to focus selected values" : "") : "";
      case "value":
        return "Use left and right to toggle between focused values, press Backspace to remove the currently focused value";
      default:
        return "";
    }
  },
  onChange: function(t) {
    var l = t.action, r = t.label, n = r === void 0 ? "" : r, o = t.labels, i = t.isDisabled;
    switch (l) {
      case "deselect-option":
      case "pop-value":
      case "remove-value":
        return "option ".concat(n, ", deselected.");
      case "clear":
        return "All selected options have been cleared.";
      case "initial-input-focus":
        return "option".concat(o.length > 1 ? "s" : "", " ").concat(o.join(","), ", selected.");
      case "select-option":
        return i ? "option ".concat(n, " is disabled. Select another option.") : "option ".concat(n, ", selected.");
      default:
        return "";
    }
  },
  onFocus: function(t) {
    var l = t.context, r = t.focused, n = t.options, o = t.label, i = o === void 0 ? "" : o, q = t.selectValue, a = t.isDisabled, s = t.isSelected, c = t.isAppleDevice, u = function(b, h) {
      return b && b.length ? "".concat(b.indexOf(h) + 1, " of ").concat(b.length) : "";
    };
    if (l === "value" && q)
      return "value ".concat(i, " focused, ").concat(u(q, r), ".");
    if (l === "menu" && c) {
      var _ = a ? " disabled" : "", A = "".concat(s ? " selected" : "").concat(_);
      return "".concat(i).concat(A, ", ").concat(u(n, r), ".");
    }
    return "";
  },
  onFilter: function(t) {
    var l = t.inputValue, r = t.resultsMessage;
    return "".concat(r).concat(l ? " for search term " + l : "", ".");
  }
}, Eq = function(t) {
  var l = t.ariaSelection, r = t.focusedOption, n = t.focusedValue, o = t.focusableOptions, i = t.isFocused, q = t.selectValue, a = t.selectProps, s = t.id, c = t.isAppleDevice, u = a.ariaLiveMessages, _ = a.getOptionLabel, A = a.inputValue, v = a.isMulti, b = a.isOptionDisabled, h = a.isSearchable, d = a.menuIsOpen, C = a.options, f = a.screenReaderStatus, m = a.tabSelectsValue, p = a.isLoading, I = a["aria-label"], w = a["aria-live"], T = j1(function() {
    return h1(h1({}, Cq), u || {});
  }, [u]), L = j1(function() {
    var Q = "";
    if (l && T.onChange) {
      var Z = l.option, X = l.options, G = l.removedValue, a1 = l.removedValues, F = l.value, M = function(R) {
        return Array.isArray(R) ? null : R;
      }, H = G || Z || M(F), W = H ? _(H) : "", S = X || a1 || void 0, E = S ? S.map(_) : [], g = h1({
        // multiSelected items are usually items that have already been selected
        // or set by the user as a default value so we assume they are not disabled
        isDisabled: H && b(H, q),
        label: W,
        labels: E
      }, l);
      Q = T.onChange(g);
    }
    return Q;
  }, [l, T, b, q, _]), j = j1(function() {
    var Q = "", Z = r || n, X = !!(r && q && q.includes(r));
    if (Z && T.onFocus) {
      var G = {
        focused: Z,
        label: _(Z),
        isDisabled: b(Z, q),
        isSelected: X,
        options: o,
        context: Z === r ? "menu" : "value",
        selectValue: q,
        isAppleDevice: c
      };
      Q = T.onFocus(G);
    }
    return Q;
  }, [r, n, _, b, T, o, q, c]), $ = j1(function() {
    var Q = "";
    if (d && C.length && !p && T.onFilter) {
      var Z = f({
        count: o.length
      });
      Q = T.onFilter({
        inputValue: A,
        resultsMessage: Z
      });
    }
    return Q;
  }, [o, A, d, T, C, f, p]), k = (l == null ? void 0 : l.action) === "initial-input-focus", t1 = j1(function() {
    var Q = "";
    if (T.guidance) {
      var Z = n ? "value" : d ? "menu" : "input";
      Q = T.guidance({
        "aria-label": I,
        context: Z,
        isDisabled: r && b(r, q),
        isMulti: v,
        isSearchable: h,
        tabSelectsValue: m,
        isInitialFocus: k
      });
    }
    return Q;
  }, [I, r, n, v, b, h, d, T, q, m, k]), e1 = f1(l6, null, f1("span", {
    id: "aria-selection"
  }, L), f1("span", {
    id: "aria-focused"
  }, j), f1("span", {
    id: "aria-results"
  }, $), f1("span", {
    id: "aria-guidance"
  }, t1));
  return f1(l6, null, f1(O9, {
    id: s
  }, k && e1), f1(O9, {
    "aria-live": w,
    "aria-atomic": "false",
    "aria-relevant": "additions text",
    role: "log"
  }, i && !k && e1));
}, Aq = Eq, y6 = [{
  base: "A",
  letters: "AⒶＡÀÁÂẦẤẪẨÃĀĂẰẮẴẲȦǠÄǞẢÅǺǍȀȂẠẬẶḀĄȺⱯ"
}, {
  base: "AA",
  letters: "Ꜳ"
}, {
  base: "AE",
  letters: "ÆǼǢ"
}, {
  base: "AO",
  letters: "Ꜵ"
}, {
  base: "AU",
  letters: "Ꜷ"
}, {
  base: "AV",
  letters: "ꜸꜺ"
}, {
  base: "AY",
  letters: "Ꜽ"
}, {
  base: "B",
  letters: "BⒷＢḂḄḆɃƂƁ"
}, {
  base: "C",
  letters: "CⒸＣĆĈĊČÇḈƇȻꜾ"
}, {
  base: "D",
  letters: "DⒹＤḊĎḌḐḒḎĐƋƊƉꝹ"
}, {
  base: "DZ",
  letters: "ǱǄ"
}, {
  base: "Dz",
  letters: "ǲǅ"
}, {
  base: "E",
  letters: "EⒺＥÈÉÊỀẾỄỂẼĒḔḖĔĖËẺĚȄȆẸỆȨḜĘḘḚƐƎ"
}, {
  base: "F",
  letters: "FⒻＦḞƑꝻ"
}, {
  base: "G",
  letters: "GⒼＧǴĜḠĞĠǦĢǤƓꞠꝽꝾ"
}, {
  base: "H",
  letters: "HⒽＨĤḢḦȞḤḨḪĦⱧⱵꞍ"
}, {
  base: "I",
  letters: "IⒾＩÌÍÎĨĪĬİÏḮỈǏȈȊỊĮḬƗ"
}, {
  base: "J",
  letters: "JⒿＪĴɈ"
}, {
  base: "K",
  letters: "KⓀＫḰǨḲĶḴƘⱩꝀꝂꝄꞢ"
}, {
  base: "L",
  letters: "LⓁＬĿĹĽḶḸĻḼḺŁȽⱢⱠꝈꝆꞀ"
}, {
  base: "LJ",
  letters: "Ǉ"
}, {
  base: "Lj",
  letters: "ǈ"
}, {
  base: "M",
  letters: "MⓂＭḾṀṂⱮƜ"
}, {
  base: "N",
  letters: "NⓃＮǸŃÑṄŇṆŅṊṈȠƝꞐꞤ"
}, {
  base: "NJ",
  letters: "Ǌ"
}, {
  base: "Nj",
  letters: "ǋ"
}, {
  base: "O",
  letters: "OⓄＯÒÓÔỒỐỖỔÕṌȬṎŌṐṒŎȮȰÖȪỎŐǑȌȎƠỜỚỠỞỢỌỘǪǬØǾƆƟꝊꝌ"
}, {
  base: "OI",
  letters: "Ƣ"
}, {
  base: "OO",
  letters: "Ꝏ"
}, {
  base: "OU",
  letters: "Ȣ"
}, {
  base: "P",
  letters: "PⓅＰṔṖƤⱣꝐꝒꝔ"
}, {
  base: "Q",
  letters: "QⓆＱꝖꝘɊ"
}, {
  base: "R",
  letters: "RⓇＲŔṘŘȐȒṚṜŖṞɌⱤꝚꞦꞂ"
}, {
  base: "S",
  letters: "SⓈＳẞŚṤŜṠŠṦṢṨȘŞⱾꞨꞄ"
}, {
  base: "T",
  letters: "TⓉＴṪŤṬȚŢṰṮŦƬƮȾꞆ"
}, {
  base: "TZ",
  letters: "Ꜩ"
}, {
  base: "U",
  letters: "UⓊＵÙÚÛŨṸŪṺŬÜǛǗǕǙỦŮŰǓȔȖƯỪỨỮỬỰỤṲŲṶṴɄ"
}, {
  base: "V",
  letters: "VⓋＶṼṾƲꝞɅ"
}, {
  base: "VY",
  letters: "Ꝡ"
}, {
  base: "W",
  letters: "WⓌＷẀẂŴẆẄẈⱲ"
}, {
  base: "X",
  letters: "XⓍＸẊẌ"
}, {
  base: "Y",
  letters: "YⓎＹỲÝŶỸȲẎŸỶỴƳɎỾ"
}, {
  base: "Z",
  letters: "ZⓏＺŹẐŻŽẒẔƵȤⱿⱫꝢ"
}, {
  base: "a",
  letters: "aⓐａẚàáâầấẫẩãāăằắẵẳȧǡäǟảåǻǎȁȃạậặḁąⱥɐ"
}, {
  base: "aa",
  letters: "ꜳ"
}, {
  base: "ae",
  letters: "æǽǣ"
}, {
  base: "ao",
  letters: "ꜵ"
}, {
  base: "au",
  letters: "ꜷ"
}, {
  base: "av",
  letters: "ꜹꜻ"
}, {
  base: "ay",
  letters: "ꜽ"
}, {
  base: "b",
  letters: "bⓑｂḃḅḇƀƃɓ"
}, {
  base: "c",
  letters: "cⓒｃćĉċčçḉƈȼꜿↄ"
}, {
  base: "d",
  letters: "dⓓｄḋďḍḑḓḏđƌɖɗꝺ"
}, {
  base: "dz",
  letters: "ǳǆ"
}, {
  base: "e",
  letters: "eⓔｅèéêềếễểẽēḕḗĕėëẻěȅȇẹệȩḝęḙḛɇɛǝ"
}, {
  base: "f",
  letters: "fⓕｆḟƒꝼ"
}, {
  base: "g",
  letters: "gⓖｇǵĝḡğġǧģǥɠꞡᵹꝿ"
}, {
  base: "h",
  letters: "hⓗｈĥḣḧȟḥḩḫẖħⱨⱶɥ"
}, {
  base: "hv",
  letters: "ƕ"
}, {
  base: "i",
  letters: "iⓘｉìíîĩīĭïḯỉǐȉȋịįḭɨı"
}, {
  base: "j",
  letters: "jⓙｊĵǰɉ"
}, {
  base: "k",
  letters: "kⓚｋḱǩḳķḵƙⱪꝁꝃꝅꞣ"
}, {
  base: "l",
  letters: "lⓛｌŀĺľḷḹļḽḻſłƚɫⱡꝉꞁꝇ"
}, {
  base: "lj",
  letters: "ǉ"
}, {
  base: "m",
  letters: "mⓜｍḿṁṃɱɯ"
}, {
  base: "n",
  letters: "nⓝｎǹńñṅňṇņṋṉƞɲŉꞑꞥ"
}, {
  base: "nj",
  letters: "ǌ"
}, {
  base: "o",
  letters: "oⓞｏòóôồốỗổõṍȭṏōṑṓŏȯȱöȫỏőǒȍȏơờớỡởợọộǫǭøǿɔꝋꝍɵ"
}, {
  base: "oi",
  letters: "ƣ"
}, {
  base: "ou",
  letters: "ȣ"
}, {
  base: "oo",
  letters: "ꝏ"
}, {
  base: "p",
  letters: "pⓟｐṕṗƥᵽꝑꝓꝕ"
}, {
  base: "q",
  letters: "qⓠｑɋꝗꝙ"
}, {
  base: "r",
  letters: "rⓡｒŕṙřȑȓṛṝŗṟɍɽꝛꞧꞃ"
}, {
  base: "s",
  letters: "sⓢｓßśṥŝṡšṧṣṩșşȿꞩꞅẛ"
}, {
  base: "t",
  letters: "tⓣｔṫẗťṭțţṱṯŧƭʈⱦꞇ"
}, {
  base: "tz",
  letters: "ꜩ"
}, {
  base: "u",
  letters: "uⓤｕùúûũṹūṻŭüǜǘǖǚủůűǔȕȗưừứữửựụṳųṷṵʉ"
}, {
  base: "v",
  letters: "vⓥｖṽṿʋꝟʌ"
}, {
  base: "vy",
  letters: "ꝡ"
}, {
  base: "w",
  letters: "wⓦｗẁẃŵẇẅẘẉⱳ"
}, {
  base: "x",
  letters: "xⓧｘẋẍ"
}, {
  base: "y",
  letters: "yⓨｙỳýŷỹȳẏÿỷẙỵƴɏỿ"
}, {
  base: "z",
  letters: "zⓩｚźẑżžẓẕƶȥɀⱬꝣ"
}], Sq = new RegExp("[" + y6.map(function(e) {
  return e.letters;
}).join("") + "]", "g"), k7 = {};
for (var $3 = 0; $3 < y6.length; $3++)
  for (var K3 = y6[$3], Q3 = 0; Q3 < K3.letters.length; Q3++)
    k7[K3.letters[Q3]] = K3.base;
var V7 = function(t) {
  return t.replace(Sq, function(l) {
    return k7[l];
  });
}, Rq = _q(V7), T9 = function(t) {
  return t.replace(/^\s+|\s+$/g, "");
}, Oq = function(t) {
  return "".concat(t.label, " ").concat(t.value);
}, Tq = function(t) {
  return function(l, r) {
    if (l.data.__isNew__) return !0;
    var n = h1({
      ignoreCase: !0,
      ignoreAccents: !0,
      stringify: Oq,
      trim: !0,
      matchFrom: "any"
    }, t), o = n.ignoreCase, i = n.ignoreAccents, q = n.stringify, a = n.trim, s = n.matchFrom, c = a ? T9(r) : r, u = a ? T9(q(l)) : q(l);
    return o && (c = c.toLowerCase(), u = u.toLowerCase()), i && (c = Rq(c), u = V7(u)), s === "start" ? u.substr(0, c.length) === c : u.indexOf(c) > -1;
  };
}, wq = ["innerRef"];
function zq(e) {
  var t = e.innerRef, l = b4(e, wq), r = la(l, "onExited", "in", "enter", "exit", "appear");
  return f1("input", p1({
    ref: t
  }, r, {
    css: /* @__PURE__ */ a8({
      label: "dummyInput",
      // get rid of any default styles
      background: 0,
      border: 0,
      // important! this hides the flashing cursor
      caretColor: "transparent",
      fontSize: "inherit",
      gridArea: "1 / 1 / 2 / 3",
      outline: 0,
      padding: 0,
      // important! without `width` browsers won't allow focus
      width: 1,
      // remove cursor on desktop
      color: "transparent",
      // remove cursor on mobile whilst maintaining "scroll into view" behaviour
      left: -100,
      opacity: 0,
      position: "relative",
      transform: "scale(.01)"
    }, process.env.NODE_ENV === "production" ? "" : ";label:DummyInput;", process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkR1bW15SW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQXlCTSIsImZpbGUiOiJEdW1teUlucHV0LnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsgSlNYLCBSZWYgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5pbXBvcnQgeyByZW1vdmVQcm9wcyB9IGZyb20gJy4uL3V0aWxzJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gRHVtbXlJbnB1dCh7XG4gIGlubmVyUmVmLFxuICAuLi5wcm9wc1xufTogSlNYLkludHJpbnNpY0VsZW1lbnRzWydpbnB1dCddICYge1xuICByZWFkb25seSBpbm5lclJlZjogUmVmPEhUTUxJbnB1dEVsZW1lbnQ+O1xufSkge1xuICAvLyBSZW1vdmUgYW5pbWF0aW9uIHByb3BzIG5vdCBtZWFudCBmb3IgSFRNTCBlbGVtZW50c1xuICBjb25zdCBmaWx0ZXJlZFByb3BzID0gcmVtb3ZlUHJvcHMoXG4gICAgcHJvcHMsXG4gICAgJ29uRXhpdGVkJyxcbiAgICAnaW4nLFxuICAgICdlbnRlcicsXG4gICAgJ2V4aXQnLFxuICAgICdhcHBlYXInXG4gICk7XG5cbiAgcmV0dXJuIChcbiAgICA8aW5wdXRcbiAgICAgIHJlZj17aW5uZXJSZWZ9XG4gICAgICB7Li4uZmlsdGVyZWRQcm9wc31cbiAgICAgIGNzcz17e1xuICAgICAgICBsYWJlbDogJ2R1bW15SW5wdXQnLFxuICAgICAgICAvLyBnZXQgcmlkIG9mIGFueSBkZWZhdWx0IHN0eWxlc1xuICAgICAgICBiYWNrZ3JvdW5kOiAwLFxuICAgICAgICBib3JkZXI6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgdGhpcyBoaWRlcyB0aGUgZmxhc2hpbmcgY3Vyc29yXG4gICAgICAgIGNhcmV0Q29sb3I6ICd0cmFuc3BhcmVudCcsXG4gICAgICAgIGZvbnRTaXplOiAnaW5oZXJpdCcsXG4gICAgICAgIGdyaWRBcmVhOiAnMSAvIDEgLyAyIC8gMycsXG4gICAgICAgIG91dGxpbmU6IDAsXG4gICAgICAgIHBhZGRpbmc6IDAsXG4gICAgICAgIC8vIGltcG9ydGFudCEgd2l0aG91dCBgd2lkdGhgIGJyb3dzZXJzIHdvbid0IGFsbG93IGZvY3VzXG4gICAgICAgIHdpZHRoOiAxLFxuXG4gICAgICAgIC8vIHJlbW92ZSBjdXJzb3Igb24gZGVza3RvcFxuICAgICAgICBjb2xvcjogJ3RyYW5zcGFyZW50JyxcblxuICAgICAgICAvLyByZW1vdmUgY3Vyc29yIG9uIG1vYmlsZSB3aGlsc3QgbWFpbnRhaW5pbmcgXCJzY3JvbGwgaW50byB2aWV3XCIgYmVoYXZpb3VyXG4gICAgICAgIGxlZnQ6IC0xMDAsXG4gICAgICAgIG9wYWNpdHk6IDAsXG4gICAgICAgIHBvc2l0aW9uOiAncmVsYXRpdmUnLFxuICAgICAgICB0cmFuc2Zvcm06ICdzY2FsZSguMDEpJyxcbiAgICAgIH19XG4gICAgLz5cbiAgKTtcbn1cbiJdfQ== */")
  }));
}
var Nq = function(t) {
  t.cancelable && t.preventDefault(), t.stopPropagation();
};
function Mq(e) {
  var t = e.isEnabled, l = e.onBottomArrive, r = e.onBottomLeave, n = e.onTopArrive, o = e.onTopLeave, i = v1(!1), q = v1(!1), a = v1(0), s = v1(null), c = o1(function(h, d) {
    if (s.current !== null) {
      var C = s.current, f = C.scrollTop, m = C.scrollHeight, p = C.clientHeight, I = s.current, w = d > 0, T = m - p - f, L = !1;
      T > d && i.current && (r && r(h), i.current = !1), w && q.current && (o && o(h), q.current = !1), w && d > T ? (l && !i.current && l(h), I.scrollTop = m, L = !0, i.current = !0) : !w && -d > f && (n && !q.current && n(h), I.scrollTop = 0, L = !0, q.current = !0), L && Nq(h);
    }
  }, [l, r, n, o]), u = o1(function(h) {
    c(h, h.deltaY);
  }, [c]), _ = o1(function(h) {
    a.current = h.changedTouches[0].clientY;
  }, []), A = o1(function(h) {
    var d = a.current - h.changedTouches[0].clientY;
    c(h, d);
  }, [c]), v = o1(function(h) {
    if (h) {
      var d = Qi ? {
        passive: !1
      } : !1;
      h.addEventListener("wheel", u, d), h.addEventListener("touchstart", _, d), h.addEventListener("touchmove", A, d);
    }
  }, [A, _, u]), b = o1(function(h) {
    h && (h.removeEventListener("wheel", u, !1), h.removeEventListener("touchstart", _, !1), h.removeEventListener("touchmove", A, !1));
  }, [A, _, u]);
  return g1(function() {
    if (t) {
      var h = s.current;
      return v(h), function() {
        b(h);
      };
    }
  }, [t, v, b]), function(h) {
    s.current = h;
  };
}
var w9 = ["boxSizing", "height", "overflow", "paddingRight", "position"], z9 = {
  boxSizing: "border-box",
  // account for possible declaration `width: 100%;` on body
  overflow: "hidden",
  position: "relative",
  height: "100%"
};
function N9(e) {
  e.cancelable && e.preventDefault();
}
function M9(e) {
  e.stopPropagation();
}
function P9() {
  var e = this.scrollTop, t = this.scrollHeight, l = e + this.offsetHeight;
  e === 0 ? this.scrollTop = 1 : l === t && (this.scrollTop = e - 1);
}
function L9() {
  return "ontouchstart" in window || navigator.maxTouchPoints;
}
var F9 = !!(typeof window < "u" && window.document && window.document.createElement), s2 = 0, Y4 = {
  capture: !1,
  passive: !1
};
function Pq(e) {
  var t = e.isEnabled, l = e.accountForScrollbars, r = l === void 0 ? !0 : l, n = v1({}), o = v1(null), i = o1(function(a) {
    if (F9) {
      var s = document.body, c = s && s.style;
      if (r && w9.forEach(function(v) {
        var b = c && c[v];
        n.current[v] = b;
      }), r && s2 < 1) {
        var u = parseInt(n.current.paddingRight, 10) || 0, _ = document.body ? document.body.clientWidth : 0, A = window.innerWidth - _ + u || 0;
        Object.keys(z9).forEach(function(v) {
          var b = z9[v];
          c && (c[v] = b);
        }), c && (c.paddingRight = "".concat(A, "px"));
      }
      s && L9() && (s.addEventListener("touchmove", N9, Y4), a && (a.addEventListener("touchstart", P9, Y4), a.addEventListener("touchmove", M9, Y4))), s2 += 1;
    }
  }, [r]), q = o1(function(a) {
    if (F9) {
      var s = document.body, c = s && s.style;
      s2 = Math.max(s2 - 1, 0), r && s2 < 1 && w9.forEach(function(u) {
        var _ = n.current[u];
        c && (c[u] = _);
      }), s && L9() && (s.removeEventListener("touchmove", N9, Y4), a && (a.removeEventListener("touchstart", P9, Y4), a.removeEventListener("touchmove", M9, Y4)));
    }
  }, [r]);
  return g1(function() {
    if (t) {
      var a = o.current;
      return i(a), function() {
        q(a);
      };
    }
  }, [t, i, q]), function(a) {
    o.current = a;
  };
}
function Lq() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var Fq = function(t) {
  var l = t.target;
  return l.ownerDocument.activeElement && l.ownerDocument.activeElement.blur();
}, Bq = process.env.NODE_ENV === "production" ? {
  name: "1kfdb0e",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0"
} : {
  name: "bp8cua-ScrollManager",
  styles: "position:fixed;left:0;bottom:0;right:0;top:0;label:ScrollManager;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNjcm9sbE1hbmFnZXIudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQW9EVSIsImZpbGUiOiJTY3JvbGxNYW5hZ2VyLnRzeCIsInNvdXJjZXNDb250ZW50IjpbIi8qKiBAanN4IGpzeCAqL1xuaW1wb3J0IHsganN4IH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuaW1wb3J0IHsgRnJhZ21lbnQsIFJlYWN0RWxlbWVudCwgUmVmQ2FsbGJhY2ssIE1vdXNlRXZlbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgdXNlU2Nyb2xsQ2FwdHVyZSBmcm9tICcuL3VzZVNjcm9sbENhcHR1cmUnO1xuaW1wb3J0IHVzZVNjcm9sbExvY2sgZnJvbSAnLi91c2VTY3JvbGxMb2NrJztcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgcmVhZG9ubHkgY2hpbGRyZW46IChyZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PikgPT4gUmVhY3RFbGVtZW50O1xuICByZWFkb25seSBsb2NrRW5hYmxlZDogYm9vbGVhbjtcbiAgcmVhZG9ubHkgY2FwdHVyZUVuYWJsZWQ6IGJvb2xlYW47XG4gIHJlYWRvbmx5IG9uQm90dG9tQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Cb3R0b21MZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG4gIHJlYWRvbmx5IG9uVG9wQXJyaXZlPzogKGV2ZW50OiBXaGVlbEV2ZW50IHwgVG91Y2hFdmVudCkgPT4gdm9pZDtcbiAgcmVhZG9ubHkgb25Ub3BMZWF2ZT86IChldmVudDogV2hlZWxFdmVudCB8IFRvdWNoRXZlbnQpID0+IHZvaWQ7XG59XG5cbmNvbnN0IGJsdXJTZWxlY3RJbnB1dCA9IChldmVudDogTW91c2VFdmVudDxIVE1MRGl2RWxlbWVudD4pID0+IHtcbiAgY29uc3QgZWxlbWVudCA9IGV2ZW50LnRhcmdldCBhcyBIVE1MRGl2RWxlbWVudDtcbiAgcmV0dXJuIChcbiAgICBlbGVtZW50Lm93bmVyRG9jdW1lbnQuYWN0aXZlRWxlbWVudCAmJlxuICAgIChlbGVtZW50Lm93bmVyRG9jdW1lbnQuYWN0aXZlRWxlbWVudCBhcyBIVE1MRWxlbWVudCkuYmx1cigpXG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBTY3JvbGxNYW5hZ2VyKHtcbiAgY2hpbGRyZW4sXG4gIGxvY2tFbmFibGVkLFxuICBjYXB0dXJlRW5hYmxlZCA9IHRydWUsXG4gIG9uQm90dG9tQXJyaXZlLFxuICBvbkJvdHRvbUxlYXZlLFxuICBvblRvcEFycml2ZSxcbiAgb25Ub3BMZWF2ZSxcbn06IFByb3BzKSB7XG4gIGNvbnN0IHNldFNjcm9sbENhcHR1cmVUYXJnZXQgPSB1c2VTY3JvbGxDYXB0dXJlKHtcbiAgICBpc0VuYWJsZWQ6IGNhcHR1cmVFbmFibGVkLFxuICAgIG9uQm90dG9tQXJyaXZlLFxuICAgIG9uQm90dG9tTGVhdmUsXG4gICAgb25Ub3BBcnJpdmUsXG4gICAgb25Ub3BMZWF2ZSxcbiAgfSk7XG4gIGNvbnN0IHNldFNjcm9sbExvY2tUYXJnZXQgPSB1c2VTY3JvbGxMb2NrKHsgaXNFbmFibGVkOiBsb2NrRW5hYmxlZCB9KTtcblxuICBjb25zdCB0YXJnZXRSZWY6IFJlZkNhbGxiYWNrPEhUTUxFbGVtZW50PiA9IChlbGVtZW50KSA9PiB7XG4gICAgc2V0U2Nyb2xsQ2FwdHVyZVRhcmdldChlbGVtZW50KTtcbiAgICBzZXRTY3JvbGxMb2NrVGFyZ2V0KGVsZW1lbnQpO1xuICB9O1xuXG4gIHJldHVybiAoXG4gICAgPEZyYWdtZW50PlxuICAgICAge2xvY2tFbmFibGVkICYmIChcbiAgICAgICAgPGRpdlxuICAgICAgICAgIG9uQ2xpY2s9e2JsdXJTZWxlY3RJbnB1dH1cbiAgICAgICAgICBjc3M9e3sgcG9zaXRpb246ICdmaXhlZCcsIGxlZnQ6IDAsIGJvdHRvbTogMCwgcmlnaHQ6IDAsIHRvcDogMCB9fVxuICAgICAgICAvPlxuICAgICAgKX1cbiAgICAgIHtjaGlsZHJlbih0YXJnZXRSZWYpfVxuICAgIDwvRnJhZ21lbnQ+XG4gICk7XG59XG4iXX0= */",
  toString: Lq
};
function Gq(e) {
  var t = e.children, l = e.lockEnabled, r = e.captureEnabled, n = r === void 0 ? !0 : r, o = e.onBottomArrive, i = e.onBottomLeave, q = e.onTopArrive, a = e.onTopLeave, s = Mq({
    isEnabled: n,
    onBottomArrive: o,
    onBottomLeave: i,
    onTopArrive: q,
    onTopLeave: a
  }), c = Pq({
    isEnabled: l
  }), u = function(A) {
    s(A), c(A);
  };
  return f1(l6, null, l && f1("div", {
    onClick: Fq,
    css: Bq
  }), t(u));
}
function Dq() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var kq = process.env.NODE_ENV === "production" ? {
  name: "1a0ro4n-requiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
} : {
  name: "5kkxb2-requiredInput-RequiredInput",
  styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%;label:RequiredInput;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJlcXVpcmVkSW5wdXQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQWNJIiwiZmlsZSI6IlJlcXVpcmVkSW5wdXQudHN4Iiwic291cmNlc0NvbnRlbnQiOlsiLyoqIEBqc3gganN4ICovXG5pbXBvcnQgeyBGb2N1c0V2ZW50SGFuZGxlciwgRnVuY3Rpb25Db21wb25lbnQgfSBmcm9tICdyZWFjdCc7XG5pbXBvcnQgeyBqc3ggfSBmcm9tICdAZW1vdGlvbi9yZWFjdCc7XG5cbmNvbnN0IFJlcXVpcmVkSW5wdXQ6IEZ1bmN0aW9uQ29tcG9uZW50PHtcbiAgcmVhZG9ubHkgbmFtZT86IHN0cmluZztcbiAgcmVhZG9ubHkgb25Gb2N1czogRm9jdXNFdmVudEhhbmRsZXI8SFRNTElucHV0RWxlbWVudD47XG59PiA9ICh7IG5hbWUsIG9uRm9jdXMgfSkgPT4gKFxuICA8aW5wdXRcbiAgICByZXF1aXJlZFxuICAgIG5hbWU9e25hbWV9XG4gICAgdGFiSW5kZXg9ey0xfVxuICAgIGFyaWEtaGlkZGVuPVwidHJ1ZVwiXG4gICAgb25Gb2N1cz17b25Gb2N1c31cbiAgICBjc3M9e3tcbiAgICAgIGxhYmVsOiAncmVxdWlyZWRJbnB1dCcsXG4gICAgICBvcGFjaXR5OiAwLFxuICAgICAgcG9pbnRlckV2ZW50czogJ25vbmUnLFxuICAgICAgcG9zaXRpb246ICdhYnNvbHV0ZScsXG4gICAgICBib3R0b206IDAsXG4gICAgICBsZWZ0OiAwLFxuICAgICAgcmlnaHQ6IDAsXG4gICAgICB3aWR0aDogJzEwMCUnLFxuICAgIH19XG4gICAgLy8gUHJldmVudCBgU3dpdGNoaW5nIGZyb20gdW5jb250cm9sbGVkIHRvIGNvbnRyb2xsZWRgIGVycm9yXG4gICAgdmFsdWU9XCJcIlxuICAgIG9uQ2hhbmdlPXsoKSA9PiB7fX1cbiAgLz5cbik7XG5cbmV4cG9ydCBkZWZhdWx0IFJlcXVpcmVkSW5wdXQ7XG4iXX0= */",
  toString: Dq
}, Vq = function(t) {
  var l = t.name, r = t.onFocus;
  return f1("input", {
    required: !0,
    name: l,
    tabIndex: -1,
    "aria-hidden": "true",
    onFocus: r,
    css: kq,
    value: "",
    onChange: function() {
    }
  });
}, Hq = Vq;
function u8(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function Wq() {
  return u8(/^iPhone/i);
}
function H7() {
  return u8(/^Mac/i);
}
function jq() {
  return u8(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  H7() && navigator.maxTouchPoints > 1;
}
function Xq() {
  return Wq() || jq();
}
function Zq() {
  return H7() || Xq();
}
var Yq = function(t) {
  return t.label;
}, Jq = function(t) {
  return t.label;
}, Uq = function(t) {
  return t.value;
}, $q = function(t) {
  return !!t.isDisabled;
}, Kq = {
  clearIndicator: wa,
  container: ba,
  control: Ba,
  dropdownIndicator: Oa,
  group: Va,
  groupHeading: Wa,
  indicatorsContainer: Ia,
  indicatorSeparator: Na,
  input: Ya,
  loadingIndicator: La,
  loadingMessage: fa,
  menu: aa,
  menuList: ua,
  menuPortal: pa,
  multiValue: Qa,
  multiValueLabel: eq,
  multiValueRemove: tq,
  noOptionsMessage: da,
  option: aq,
  placeholder: cq,
  singleValue: dq,
  valueContainer: va
}, Qq = {
  primary: "#2684FF",
  primary75: "#4C9AFF",
  primary50: "#B2D4FF",
  primary25: "#DEEBFF",
  danger: "#DE350B",
  dangerLight: "#FFBDAD",
  neutral0: "hsl(0, 0%, 100%)",
  neutral5: "hsl(0, 0%, 95%)",
  neutral10: "hsl(0, 0%, 90%)",
  neutral20: "hsl(0, 0%, 80%)",
  neutral30: "hsl(0, 0%, 70%)",
  neutral40: "hsl(0, 0%, 60%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 40%)",
  neutral70: "hsl(0, 0%, 30%)",
  neutral80: "hsl(0, 0%, 20%)",
  neutral90: "hsl(0, 0%, 10%)"
}, es = 4, W7 = 4, ts = 38, ls = W7 * 2, ns = {
  baseUnit: W7,
  controlHeight: ts,
  menuGutter: ls
}, e6 = {
  borderRadius: es,
  colors: Qq,
  spacing: ns
}, rs = {
  "aria-live": "polite",
  backspaceRemovesValue: !0,
  blurInputOnSelect: A9(),
  captureMenuScroll: !A9(),
  classNames: {},
  closeMenuOnSelect: !0,
  closeMenuOnScroll: !1,
  components: {},
  controlShouldRenderValue: !0,
  escapeClearsValue: !1,
  filterOption: Tq(),
  formatGroupLabel: Yq,
  getOptionLabel: Jq,
  getOptionValue: Uq,
  isDisabled: !1,
  isLoading: !1,
  isMulti: !1,
  isRtl: !1,
  isSearchable: !0,
  isOptionDisabled: $q,
  loadingMessage: function() {
    return "Loading...";
  },
  maxMenuHeight: 300,
  minMenuHeight: 140,
  menuIsOpen: !1,
  menuPlacement: "bottom",
  menuPosition: "absolute",
  menuShouldBlockScroll: !1,
  menuShouldScrollIntoView: !$i(),
  noOptionsMessage: function() {
    return "No options";
  },
  openMenuOnFocus: !1,
  openMenuOnClick: !0,
  options: [],
  pageSize: 5,
  placeholder: "Select...",
  screenReaderStatus: function(t) {
    var l = t.count;
    return "".concat(l, " result").concat(l !== 1 ? "s" : "", " available");
  },
  styles: {},
  tabIndex: 0,
  tabSelectsValue: !0,
  unstyled: !1
};
function B9(e, t, l, r) {
  var n = Z7(e, t, l), o = Y7(e, t, l), i = X7(e, t), q = c3(e, t);
  return {
    type: "option",
    data: t,
    isDisabled: n,
    isSelected: o,
    label: i,
    value: q,
    index: r
  };
}
function X2(e, t) {
  return e.options.map(function(l, r) {
    if ("options" in l) {
      var n = l.options.map(function(i, q) {
        return B9(e, i, t, q);
      }).filter(function(i) {
        return D9(e, i);
      });
      return n.length > 0 ? {
        type: "group",
        data: l,
        options: n,
        index: r
      } : void 0;
    }
    var o = B9(e, l, t, r);
    return D9(e, o) ? o : void 0;
  }).filter(ea);
}
function j7(e) {
  return e.reduce(function(t, l) {
    return l.type === "group" ? t.push.apply(t, l8(l.options.map(function(r) {
      return r.data;
    }))) : t.push(l.data), t;
  }, []);
}
function G9(e, t) {
  return e.reduce(function(l, r) {
    return r.type === "group" ? l.push.apply(l, l8(r.options.map(function(n) {
      return {
        data: n.data,
        id: "".concat(t, "-").concat(r.index, "-").concat(n.index)
      };
    }))) : l.push({
      data: r.data,
      id: "".concat(t, "-").concat(r.index)
    }), l;
  }, []);
}
function os(e, t) {
  return j7(X2(e, t));
}
function D9(e, t) {
  var l = e.inputValue, r = l === void 0 ? "" : l, n = t.data, o = t.isSelected, i = t.label, q = t.value;
  return (!U7(e) || !o) && J7(e, {
    label: i,
    value: q,
    data: n
  }, r);
}
function is(e, t) {
  var l = e.focusedValue, r = e.selectValue, n = r.indexOf(l);
  if (n > -1) {
    var o = t.indexOf(l);
    if (o > -1)
      return l;
    if (n < t.length)
      return t[n];
  }
  return null;
}
function as(e, t) {
  var l = e.focusedOption;
  return l && t.indexOf(l) > -1 ? l : t[0];
}
var t6 = function(t, l) {
  var r, n = (r = t.find(function(o) {
    return o.data === l;
  })) === null || r === void 0 ? void 0 : r.id;
  return n || null;
}, X7 = function(t, l) {
  return t.getOptionLabel(l);
}, c3 = function(t, l) {
  return t.getOptionValue(l);
};
function Z7(e, t, l) {
  return typeof e.isOptionDisabled == "function" ? e.isOptionDisabled(t, l) : !1;
}
function Y7(e, t, l) {
  if (l.indexOf(t) > -1) return !0;
  if (typeof e.isOptionSelected == "function")
    return e.isOptionSelected(t, l);
  var r = c3(e, t);
  return l.some(function(n) {
    return c3(e, n) === r;
  });
}
function J7(e, t, l) {
  return e.filterOption ? e.filterOption(t, l) : !0;
}
var U7 = function(t) {
  var l = t.hideSelectedOptions, r = t.isMulti;
  return l === void 0 ? r : l;
}, qs = 1, $7 = /* @__PURE__ */ function(e) {
  Ao(l, e);
  var t = Oo(l);
  function l(r) {
    var n;
    if (Co(this, l), n = t.call(this, r), n.state = {
      ariaSelection: null,
      focusedOption: null,
      focusedOptionId: null,
      focusableOptionsWithIds: [],
      focusedValue: null,
      inputIsHidden: !1,
      isFocused: !1,
      selectValue: [],
      clearFocusValueOnUpdate: !1,
      prevWasFocused: !1,
      inputIsHiddenAfterUpdate: void 0,
      prevProps: void 0,
      instancePrefix: "",
      isAppleDevice: !1
    }, n.blockOptionHover = !1, n.isComposing = !1, n.commonProps = void 0, n.initialTouchX = 0, n.initialTouchY = 0, n.openAfterFocus = !1, n.scrollToFocusedOptionOnUpdate = !1, n.userIsDragging = void 0, n.controlRef = null, n.getControlRef = function(a) {
      n.controlRef = a;
    }, n.focusedOptionRef = null, n.getFocusedOptionRef = function(a) {
      n.focusedOptionRef = a;
    }, n.menuListRef = null, n.getMenuListRef = function(a) {
      n.menuListRef = a;
    }, n.inputRef = null, n.getInputRef = function(a) {
      n.inputRef = a;
    }, n.focus = n.focusInput, n.blur = n.blurInput, n.onChange = function(a, s) {
      var c = n.props, u = c.onChange, _ = c.name;
      s.name = _, n.ariaOnChange(a, s), u(a, s);
    }, n.setValue = function(a, s, c) {
      var u = n.props, _ = u.closeMenuOnSelect, A = u.isMulti, v = u.inputValue;
      n.onInputChange("", {
        action: "set-value",
        prevInputValue: v
      }), _ && (n.setState({
        inputIsHiddenAfterUpdate: !A
      }), n.onMenuClose()), n.setState({
        clearFocusValueOnUpdate: !0
      }), n.onChange(a, {
        action: s,
        option: c
      });
    }, n.selectOption = function(a) {
      var s = n.props, c = s.blurInputOnSelect, u = s.isMulti, _ = s.name, A = n.state.selectValue, v = u && n.isOptionSelected(a, A), b = n.isOptionDisabled(a, A);
      if (v) {
        var h = n.getOptionValue(a);
        n.setValue(A.filter(function(d) {
          return n.getOptionValue(d) !== h;
        }), "deselect-option", a);
      } else if (!b)
        u ? n.setValue([].concat(l8(A), [a]), "select-option", a) : n.setValue(a, "select-option");
      else {
        n.ariaOnChange(a, {
          action: "select-option",
          option: a,
          name: _
        });
        return;
      }
      c && n.blurInput();
    }, n.removeValue = function(a) {
      var s = n.props.isMulti, c = n.state.selectValue, u = n.getOptionValue(a), _ = c.filter(function(v) {
        return n.getOptionValue(v) !== u;
      }), A = F2(s, _, _[0] || null);
      n.onChange(A, {
        action: "remove-value",
        removedValue: a
      }), n.focusInput();
    }, n.clearValue = function() {
      var a = n.state.selectValue;
      n.onChange(F2(n.props.isMulti, [], null), {
        action: "clear",
        removedValues: a
      });
    }, n.popValue = function() {
      var a = n.props.isMulti, s = n.state.selectValue, c = s[s.length - 1], u = s.slice(0, s.length - 1), _ = F2(a, u, u[0] || null);
      c && n.onChange(_, {
        action: "pop-value",
        removedValue: c
      });
    }, n.getFocusedOptionId = function(a) {
      return t6(n.state.focusableOptionsWithIds, a);
    }, n.getFocusableOptionsWithIds = function() {
      return G9(X2(n.props, n.state.selectValue), n.getElementId("option"));
    }, n.getValue = function() {
      return n.state.selectValue;
    }, n.cx = function() {
      for (var a = arguments.length, s = new Array(a), c = 0; c < a; c++)
        s[c] = arguments[c];
      return Xi.apply(void 0, [n.props.classNamePrefix].concat(s));
    }, n.getOptionLabel = function(a) {
      return X7(n.props, a);
    }, n.getOptionValue = function(a) {
      return c3(n.props, a);
    }, n.getStyles = function(a, s) {
      var c = n.props.unstyled, u = Kq[a](s, c);
      u.boxSizing = "border-box";
      var _ = n.props.styles[a];
      return _ ? _(u, s) : u;
    }, n.getClassNames = function(a, s) {
      var c, u;
      return (c = (u = n.props.classNames)[a]) === null || c === void 0 ? void 0 : c.call(u, s);
    }, n.getElementId = function(a) {
      return "".concat(n.state.instancePrefix, "-").concat(a);
    }, n.getComponents = function() {
      return pq(n.props);
    }, n.buildCategorizedOptions = function() {
      return X2(n.props, n.state.selectValue);
    }, n.getCategorizedOptions = function() {
      return n.props.menuIsOpen ? n.buildCategorizedOptions() : [];
    }, n.buildFocusableOptions = function() {
      return j7(n.buildCategorizedOptions());
    }, n.getFocusableOptions = function() {
      return n.props.menuIsOpen ? n.buildFocusableOptions() : [];
    }, n.ariaOnChange = function(a, s) {
      n.setState({
        ariaSelection: h1({
          value: a
        }, s)
      });
    }, n.onMenuMouseDown = function(a) {
      a.button === 0 && (a.stopPropagation(), a.preventDefault(), n.focusInput());
    }, n.onMenuMouseMove = function(a) {
      n.blockOptionHover = !1;
    }, n.onControlMouseDown = function(a) {
      if (!a.defaultPrevented) {
        var s = n.props.openMenuOnClick;
        n.state.isFocused ? n.props.menuIsOpen ? a.target.tagName !== "INPUT" && a.target.tagName !== "TEXTAREA" && n.onMenuClose() : s && n.openMenu("first") : (s && (n.openAfterFocus = !0), n.focusInput()), a.target.tagName !== "INPUT" && a.target.tagName !== "TEXTAREA" && a.preventDefault();
      }
    }, n.onDropdownIndicatorMouseDown = function(a) {
      if (!(a && a.type === "mousedown" && a.button !== 0) && !n.props.isDisabled) {
        var s = n.props, c = s.isMulti, u = s.menuIsOpen;
        n.focusInput(), u ? (n.setState({
          inputIsHiddenAfterUpdate: !c
        }), n.onMenuClose()) : n.openMenu("first"), a.preventDefault();
      }
    }, n.onClearIndicatorMouseDown = function(a) {
      a && a.type === "mousedown" && a.button !== 0 || (n.clearValue(), a.preventDefault(), n.openAfterFocus = !1, a.type === "touchend" ? n.focusInput() : setTimeout(function() {
        return n.focusInput();
      }));
    }, n.onScroll = function(a) {
      typeof n.props.closeMenuOnScroll == "boolean" ? a.target instanceof HTMLElement && y3(a.target) && n.props.onMenuClose() : typeof n.props.closeMenuOnScroll == "function" && n.props.closeMenuOnScroll(a) && n.props.onMenuClose();
    }, n.onCompositionStart = function() {
      n.isComposing = !0;
    }, n.onCompositionEnd = function() {
      n.isComposing = !1;
    }, n.onTouchStart = function(a) {
      var s = a.touches, c = s && s.item(0);
      c && (n.initialTouchX = c.clientX, n.initialTouchY = c.clientY, n.userIsDragging = !1);
    }, n.onTouchMove = function(a) {
      var s = a.touches, c = s && s.item(0);
      if (c) {
        var u = Math.abs(c.clientX - n.initialTouchX), _ = Math.abs(c.clientY - n.initialTouchY), A = 5;
        n.userIsDragging = u > A || _ > A;
      }
    }, n.onTouchEnd = function(a) {
      n.userIsDragging || (n.controlRef && !n.controlRef.contains(a.target) && n.menuListRef && !n.menuListRef.contains(a.target) && n.blurInput(), n.initialTouchX = 0, n.initialTouchY = 0);
    }, n.onControlTouchEnd = function(a) {
      n.userIsDragging || n.onControlMouseDown(a);
    }, n.onClearIndicatorTouchEnd = function(a) {
      n.userIsDragging || n.onClearIndicatorMouseDown(a);
    }, n.onDropdownIndicatorTouchEnd = function(a) {
      n.userIsDragging || n.onDropdownIndicatorMouseDown(a);
    }, n.handleInputChange = function(a) {
      var s = n.props.inputValue, c = a.currentTarget.value;
      n.setState({
        inputIsHiddenAfterUpdate: !1
      }), n.onInputChange(c, {
        action: "input-change",
        prevInputValue: s
      }), n.props.menuIsOpen || n.onMenuOpen();
    }, n.onInputFocus = function(a) {
      n.props.onFocus && n.props.onFocus(a), n.setState({
        inputIsHiddenAfterUpdate: !1,
        isFocused: !0
      }), (n.openAfterFocus || n.props.openMenuOnFocus) && n.openMenu("first"), n.openAfterFocus = !1;
    }, n.onInputBlur = function(a) {
      var s = n.props.inputValue;
      if (n.menuListRef && n.menuListRef.contains(document.activeElement)) {
        n.inputRef.focus();
        return;
      }
      n.props.onBlur && n.props.onBlur(a), n.onInputChange("", {
        action: "input-blur",
        prevInputValue: s
      }), n.onMenuClose(), n.setState({
        focusedValue: null,
        isFocused: !1
      });
    }, n.onOptionHover = function(a) {
      if (!(n.blockOptionHover || n.state.focusedOption === a)) {
        var s = n.getFocusableOptions(), c = s.indexOf(a);
        n.setState({
          focusedOption: a,
          focusedOptionId: c > -1 ? n.getFocusedOptionId(a) : null
        });
      }
    }, n.shouldHideSelectedOptions = function() {
      return U7(n.props);
    }, n.onValueInputFocus = function(a) {
      a.preventDefault(), a.stopPropagation(), n.focus();
    }, n.onKeyDown = function(a) {
      var s = n.props, c = s.isMulti, u = s.backspaceRemovesValue, _ = s.escapeClearsValue, A = s.inputValue, v = s.isClearable, b = s.isDisabled, h = s.menuIsOpen, d = s.onKeyDown, C = s.tabSelectsValue, f = s.openMenuOnFocus, m = n.state, p = m.focusedOption, I = m.focusedValue, w = m.selectValue;
      if (!b && !(typeof d == "function" && (d(a), a.defaultPrevented))) {
        switch (n.blockOptionHover = !0, a.key) {
          case "ArrowLeft":
            if (!c || A) return;
            n.focusValue("previous");
            break;
          case "ArrowRight":
            if (!c || A) return;
            n.focusValue("next");
            break;
          case "Delete":
          case "Backspace":
            if (A) return;
            if (I)
              n.removeValue(I);
            else {
              if (!u) return;
              c ? n.popValue() : v && n.clearValue();
            }
            break;
          case "Tab":
            if (n.isComposing || a.shiftKey || !h || !C || !p || // don't capture the event if the menu opens on focus and the focused
            // option is already selected; it breaks the flow of navigation
            f && n.isOptionSelected(p, w))
              return;
            n.selectOption(p);
            break;
          case "Enter":
            if (a.keyCode === 229)
              break;
            if (h) {
              if (!p || n.isComposing) return;
              n.selectOption(p);
              break;
            }
            return;
          case "Escape":
            h ? (n.setState({
              inputIsHiddenAfterUpdate: !1
            }), n.onInputChange("", {
              action: "menu-close",
              prevInputValue: A
            }), n.onMenuClose()) : v && _ && n.clearValue();
            break;
          case " ":
            if (A)
              return;
            if (!h) {
              n.openMenu("first");
              break;
            }
            if (!p) return;
            n.selectOption(p);
            break;
          case "ArrowUp":
            h ? n.focusOption("up") : n.openMenu("last");
            break;
          case "ArrowDown":
            h ? n.focusOption("down") : n.openMenu("first");
            break;
          case "PageUp":
            if (!h) return;
            n.focusOption("pageup");
            break;
          case "PageDown":
            if (!h) return;
            n.focusOption("pagedown");
            break;
          case "Home":
            if (!h) return;
            n.focusOption("first");
            break;
          case "End":
            if (!h) return;
            n.focusOption("last");
            break;
          default:
            return;
        }
        a.preventDefault();
      }
    }, n.state.instancePrefix = "react-select-" + (n.props.instanceId || ++qs), n.state.selectValue = C9(r.value), r.menuIsOpen && n.state.selectValue.length) {
      var o = n.getFocusableOptionsWithIds(), i = n.buildFocusableOptions(), q = i.indexOf(n.state.selectValue[0]);
      n.state.focusableOptionsWithIds = o, n.state.focusedOption = i[q], n.state.focusedOptionId = t6(o, i[q]);
    }
    return n;
  }
  return Eo(l, [{
    key: "componentDidMount",
    value: function() {
      this.startListeningComposition(), this.startListeningToTouch(), this.props.closeMenuOnScroll && document && document.addEventListener && document.addEventListener("scroll", this.onScroll, !0), this.props.autoFocus && this.focusInput(), this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef && E9(this.menuListRef, this.focusedOptionRef), Zq() && this.setState({
        isAppleDevice: !0
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function(n) {
      var o = this.props, i = o.isDisabled, q = o.menuIsOpen, a = this.state.isFocused;
      // ensure focus is restored correctly when the control becomes enabled
      (a && !i && n.isDisabled || // ensure focus is on the Input when the menu opens
      a && q && !n.menuIsOpen) && this.focusInput(), a && i && !n.isDisabled ? this.setState({
        isFocused: !1
      }, this.onMenuClose) : !a && !i && n.isDisabled && this.inputRef === document.activeElement && this.setState({
        isFocused: !0
      }), this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate && (E9(this.menuListRef, this.focusedOptionRef), this.scrollToFocusedOptionOnUpdate = !1);
    }
  }, {
    key: "componentWillUnmount",
    value: function() {
      this.stopListeningComposition(), this.stopListeningToTouch(), document.removeEventListener("scroll", this.onScroll, !0);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
  }, {
    key: "onMenuOpen",
    value: function() {
      this.props.onMenuOpen();
    }
  }, {
    key: "onMenuClose",
    value: function() {
      this.onInputChange("", {
        action: "menu-close",
        prevInputValue: this.props.inputValue
      }), this.props.onMenuClose();
    }
  }, {
    key: "onInputChange",
    value: function(n, o) {
      this.props.onInputChange(n, o);
    }
    // ==============================
    // Methods
    // ==============================
  }, {
    key: "focusInput",
    value: function() {
      this.inputRef && this.inputRef.focus();
    }
  }, {
    key: "blurInput",
    value: function() {
      this.inputRef && this.inputRef.blur();
    }
    // aliased for consumers
  }, {
    key: "openMenu",
    value: function(n) {
      var o = this, i = this.state, q = i.selectValue, a = i.isFocused, s = this.buildFocusableOptions(), c = n === "first" ? 0 : s.length - 1;
      if (!this.props.isMulti) {
        var u = s.indexOf(q[0]);
        u > -1 && (c = u);
      }
      this.scrollToFocusedOptionOnUpdate = !(a && this.menuListRef), this.setState({
        inputIsHiddenAfterUpdate: !1,
        focusedValue: null,
        focusedOption: s[c],
        focusedOptionId: this.getFocusedOptionId(s[c])
      }, function() {
        return o.onMenuOpen();
      });
    }
  }, {
    key: "focusValue",
    value: function(n) {
      var o = this.state, i = o.selectValue, q = o.focusedValue;
      if (this.props.isMulti) {
        this.setState({
          focusedOption: null
        });
        var a = i.indexOf(q);
        q || (a = -1);
        var s = i.length - 1, c = -1;
        if (i.length) {
          switch (n) {
            case "previous":
              a === 0 ? c = 0 : a === -1 ? c = s : c = a - 1;
              break;
            case "next":
              a > -1 && a < s && (c = a + 1);
              break;
          }
          this.setState({
            inputIsHidden: c !== -1,
            focusedValue: i[c]
          });
        }
      }
    }
  }, {
    key: "focusOption",
    value: function() {
      var n = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "first", o = this.props.pageSize, i = this.state.focusedOption, q = this.getFocusableOptions();
      if (q.length) {
        var a = 0, s = q.indexOf(i);
        i || (s = -1), n === "up" ? a = s > 0 ? s - 1 : q.length - 1 : n === "down" ? a = (s + 1) % q.length : n === "pageup" ? (a = s - o, a < 0 && (a = 0)) : n === "pagedown" ? (a = s + o, a > q.length - 1 && (a = q.length - 1)) : n === "last" && (a = q.length - 1), this.scrollToFocusedOptionOnUpdate = !0, this.setState({
          focusedOption: q[a],
          focusedValue: null,
          focusedOptionId: this.getFocusedOptionId(q[a])
        });
      }
    }
  }, {
    key: "getTheme",
    value: (
      // ==============================
      // Getters
      // ==============================
      function() {
        return this.props.theme ? typeof this.props.theme == "function" ? this.props.theme(e6) : h1(h1({}, e6), this.props.theme) : e6;
      }
    )
  }, {
    key: "getCommonProps",
    value: function() {
      var n = this.clearValue, o = this.cx, i = this.getStyles, q = this.getClassNames, a = this.getValue, s = this.selectOption, c = this.setValue, u = this.props, _ = u.isMulti, A = u.isRtl, v = u.options, b = this.hasValue();
      return {
        clearValue: n,
        cx: o,
        getStyles: i,
        getClassNames: q,
        getValue: a,
        hasValue: b,
        isMulti: _,
        isRtl: A,
        options: v,
        selectOption: s,
        selectProps: u,
        setValue: c,
        theme: this.getTheme()
      };
    }
  }, {
    key: "hasValue",
    value: function() {
      var n = this.state.selectValue;
      return n.length > 0;
    }
  }, {
    key: "hasOptions",
    value: function() {
      return !!this.getFocusableOptions().length;
    }
  }, {
    key: "isClearable",
    value: function() {
      var n = this.props, o = n.isClearable, i = n.isMulti;
      return o === void 0 ? i : o;
    }
  }, {
    key: "isOptionDisabled",
    value: function(n, o) {
      return Z7(this.props, n, o);
    }
  }, {
    key: "isOptionSelected",
    value: function(n, o) {
      return Y7(this.props, n, o);
    }
  }, {
    key: "filterOption",
    value: function(n, o) {
      return J7(this.props, n, o);
    }
  }, {
    key: "formatOptionLabel",
    value: function(n, o) {
      if (typeof this.props.formatOptionLabel == "function") {
        var i = this.props.inputValue, q = this.state.selectValue;
        return this.props.formatOptionLabel(n, {
          context: o,
          inputValue: i,
          selectValue: q
        });
      } else
        return this.getOptionLabel(n);
    }
  }, {
    key: "formatGroupLabel",
    value: function(n) {
      return this.props.formatGroupLabel(n);
    }
    // ==============================
    // Mouse Handlers
    // ==============================
  }, {
    key: "startListeningComposition",
    value: (
      // ==============================
      // Composition Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("compositionstart", this.onCompositionStart, !1), document.addEventListener("compositionend", this.onCompositionEnd, !1));
      }
    )
  }, {
    key: "stopListeningComposition",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("compositionstart", this.onCompositionStart), document.removeEventListener("compositionend", this.onCompositionEnd));
    }
  }, {
    key: "startListeningToTouch",
    value: (
      // ==============================
      // Touch Handlers
      // ==============================
      function() {
        document && document.addEventListener && (document.addEventListener("touchstart", this.onTouchStart, !1), document.addEventListener("touchmove", this.onTouchMove, !1), document.addEventListener("touchend", this.onTouchEnd, !1));
      }
    )
  }, {
    key: "stopListeningToTouch",
    value: function() {
      document && document.removeEventListener && (document.removeEventListener("touchstart", this.onTouchStart), document.removeEventListener("touchmove", this.onTouchMove), document.removeEventListener("touchend", this.onTouchEnd));
    }
  }, {
    key: "renderInput",
    value: (
      // ==============================
      // Renderers
      // ==============================
      function() {
        var n = this.props, o = n.isDisabled, i = n.isSearchable, q = n.inputId, a = n.inputValue, s = n.tabIndex, c = n.form, u = n.menuIsOpen, _ = n.required, A = this.getComponents(), v = A.Input, b = this.state, h = b.inputIsHidden, d = b.ariaSelection, C = this.commonProps, f = q || this.getElementId("input"), m = h1(h1(h1({
          "aria-autocomplete": "list",
          "aria-expanded": u,
          "aria-haspopup": !0,
          "aria-errormessage": this.props["aria-errormessage"],
          "aria-invalid": this.props["aria-invalid"],
          "aria-label": this.props["aria-label"],
          "aria-labelledby": this.props["aria-labelledby"],
          "aria-required": _,
          role: "combobox",
          "aria-activedescendant": this.state.isAppleDevice ? void 0 : this.state.focusedOptionId || ""
        }, u && {
          "aria-controls": this.getElementId("listbox")
        }), !i && {
          "aria-readonly": !0
        }), this.hasValue() ? (d == null ? void 0 : d.action) === "initial-input-focus" && {
          "aria-describedby": this.getElementId("live-region")
        } : {
          "aria-describedby": this.getElementId("placeholder")
        });
        return i ? /* @__PURE__ */ s1.createElement(v, p1({}, C, {
          autoCapitalize: "none",
          autoComplete: "off",
          autoCorrect: "off",
          id: f,
          innerRef: this.getInputRef,
          isDisabled: o,
          isHidden: h,
          onBlur: this.onInputBlur,
          onChange: this.handleInputChange,
          onFocus: this.onInputFocus,
          spellCheck: "false",
          tabIndex: s,
          form: c,
          type: "text",
          value: a
        }, m)) : /* @__PURE__ */ s1.createElement(zq, p1({
          id: f,
          innerRef: this.getInputRef,
          onBlur: this.onInputBlur,
          onChange: q3,
          onFocus: this.onInputFocus,
          disabled: o,
          tabIndex: s,
          inputMode: "none",
          form: c,
          value: ""
        }, m));
      }
    )
  }, {
    key: "renderPlaceholderOrValue",
    value: function() {
      var n = this, o = this.getComponents(), i = o.MultiValue, q = o.MultiValueContainer, a = o.MultiValueLabel, s = o.MultiValueRemove, c = o.SingleValue, u = o.Placeholder, _ = this.commonProps, A = this.props, v = A.controlShouldRenderValue, b = A.isDisabled, h = A.isMulti, d = A.inputValue, C = A.placeholder, f = this.state, m = f.selectValue, p = f.focusedValue, I = f.isFocused;
      if (!this.hasValue() || !v)
        return d ? null : /* @__PURE__ */ s1.createElement(u, p1({}, _, {
          key: "placeholder",
          isDisabled: b,
          isFocused: I,
          innerProps: {
            id: this.getElementId("placeholder")
          }
        }), C);
      if (h)
        return m.map(function(T, L) {
          var j = T === p, $ = "".concat(n.getOptionLabel(T), "-").concat(n.getOptionValue(T));
          return /* @__PURE__ */ s1.createElement(i, p1({}, _, {
            components: {
              Container: q,
              Label: a,
              Remove: s
            },
            isFocused: j,
            isDisabled: b,
            key: $,
            index: L,
            removeProps: {
              onClick: function() {
                return n.removeValue(T);
              },
              onTouchEnd: function() {
                return n.removeValue(T);
              },
              onMouseDown: function(t1) {
                t1.preventDefault();
              }
            },
            data: T
          }), n.formatOptionLabel(T, "value"));
        });
      if (d)
        return null;
      var w = m[0];
      return /* @__PURE__ */ s1.createElement(c, p1({}, _, {
        data: w,
        isDisabled: b
      }), this.formatOptionLabel(w, "value"));
    }
  }, {
    key: "renderClearIndicator",
    value: function() {
      var n = this.getComponents(), o = n.ClearIndicator, i = this.commonProps, q = this.props, a = q.isDisabled, s = q.isLoading, c = this.state.isFocused;
      if (!this.isClearable() || !o || a || !this.hasValue() || s)
        return null;
      var u = {
        onMouseDown: this.onClearIndicatorMouseDown,
        onTouchEnd: this.onClearIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ s1.createElement(o, p1({}, i, {
        innerProps: u,
        isFocused: c
      }));
    }
  }, {
    key: "renderLoadingIndicator",
    value: function() {
      var n = this.getComponents(), o = n.LoadingIndicator, i = this.commonProps, q = this.props, a = q.isDisabled, s = q.isLoading, c = this.state.isFocused;
      if (!o || !s) return null;
      var u = {
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ s1.createElement(o, p1({}, i, {
        innerProps: u,
        isDisabled: a,
        isFocused: c
      }));
    }
  }, {
    key: "renderIndicatorSeparator",
    value: function() {
      var n = this.getComponents(), o = n.DropdownIndicator, i = n.IndicatorSeparator;
      if (!o || !i) return null;
      var q = this.commonProps, a = this.props.isDisabled, s = this.state.isFocused;
      return /* @__PURE__ */ s1.createElement(i, p1({}, q, {
        isDisabled: a,
        isFocused: s
      }));
    }
  }, {
    key: "renderDropdownIndicator",
    value: function() {
      var n = this.getComponents(), o = n.DropdownIndicator;
      if (!o) return null;
      var i = this.commonProps, q = this.props.isDisabled, a = this.state.isFocused, s = {
        onMouseDown: this.onDropdownIndicatorMouseDown,
        onTouchEnd: this.onDropdownIndicatorTouchEnd,
        "aria-hidden": "true"
      };
      return /* @__PURE__ */ s1.createElement(o, p1({}, i, {
        innerProps: s,
        isDisabled: q,
        isFocused: a
      }));
    }
  }, {
    key: "renderMenu",
    value: function() {
      var n = this, o = this.getComponents(), i = o.Group, q = o.GroupHeading, a = o.Menu, s = o.MenuList, c = o.MenuPortal, u = o.LoadingMessage, _ = o.NoOptionsMessage, A = o.Option, v = this.commonProps, b = this.state.focusedOption, h = this.props, d = h.captureMenuScroll, C = h.inputValue, f = h.isLoading, m = h.loadingMessage, p = h.minMenuHeight, I = h.maxMenuHeight, w = h.menuIsOpen, T = h.menuPlacement, L = h.menuPosition, j = h.menuPortalTarget, $ = h.menuShouldBlockScroll, k = h.menuShouldScrollIntoView, t1 = h.noOptionsMessage, e1 = h.onMenuScrollToTop, Q = h.onMenuScrollToBottom;
      if (!w) return null;
      var Z = function(W, S) {
        var E = W.type, g = W.data, x = W.isDisabled, R = W.isSelected, Y = W.label, B = W.value, K = b === g, z = x ? void 0 : function() {
          return n.onOptionHover(g);
        }, l1 = x ? void 0 : function() {
          return n.selectOption(g);
        }, U = "".concat(n.getElementId("option"), "-").concat(S), J = {
          id: U,
          onClick: l1,
          onMouseMove: z,
          onMouseOver: z,
          tabIndex: -1,
          role: "option",
          "aria-selected": n.state.isAppleDevice ? void 0 : R
          // is not supported on Apple devices
        };
        return /* @__PURE__ */ s1.createElement(A, p1({}, v, {
          innerProps: J,
          data: g,
          isDisabled: x,
          isSelected: R,
          key: U,
          label: Y,
          type: E,
          value: B,
          isFocused: K,
          innerRef: K ? n.getFocusedOptionRef : void 0
        }), n.formatOptionLabel(W.data, "menu"));
      }, X;
      if (this.hasOptions())
        X = this.getCategorizedOptions().map(function(H) {
          if (H.type === "group") {
            var W = H.data, S = H.options, E = H.index, g = "".concat(n.getElementId("group"), "-").concat(E), x = "".concat(g, "-heading");
            return /* @__PURE__ */ s1.createElement(i, p1({}, v, {
              key: g,
              data: W,
              options: S,
              Heading: q,
              headingProps: {
                id: x,
                data: H.data
              },
              label: n.formatGroupLabel(H.data)
            }), H.options.map(function(R) {
              return Z(R, "".concat(E, "-").concat(R.index));
            }));
          } else if (H.type === "option")
            return Z(H, "".concat(H.index));
        });
      else if (f) {
        var G = m({
          inputValue: C
        });
        if (G === null) return null;
        X = /* @__PURE__ */ s1.createElement(u, v, G);
      } else {
        var a1 = t1({
          inputValue: C
        });
        if (a1 === null) return null;
        X = /* @__PURE__ */ s1.createElement(_, v, a1);
      }
      var F = {
        minMenuHeight: p,
        maxMenuHeight: I,
        menuPlacement: T,
        menuPosition: L,
        menuShouldScrollIntoView: k
      }, M = /* @__PURE__ */ s1.createElement(qa, p1({}, v, F), function(H) {
        var W = H.ref, S = H.placerProps, E = S.placement, g = S.maxHeight;
        return /* @__PURE__ */ s1.createElement(a, p1({}, v, F, {
          innerRef: W,
          innerProps: {
            onMouseDown: n.onMenuMouseDown,
            onMouseMove: n.onMenuMouseMove
          },
          isLoading: f,
          placement: E
        }), /* @__PURE__ */ s1.createElement(Gq, {
          captureEnabled: d,
          onTopArrive: e1,
          onBottomArrive: Q,
          lockEnabled: $
        }, function(x) {
          return /* @__PURE__ */ s1.createElement(s, p1({}, v, {
            innerRef: function(Y) {
              n.getMenuListRef(Y), x(Y);
            },
            innerProps: {
              role: "listbox",
              "aria-multiselectable": v.isMulti,
              id: n.getElementId("listbox")
            },
            isLoading: f,
            maxHeight: g,
            focusedOption: b
          }), X);
        }));
      });
      return j || L === "fixed" ? /* @__PURE__ */ s1.createElement(c, p1({}, v, {
        appendTo: j,
        controlElement: this.controlRef,
        menuPlacement: T,
        menuPosition: L
      }), M) : M;
    }
  }, {
    key: "renderFormField",
    value: function() {
      var n = this, o = this.props, i = o.delimiter, q = o.isDisabled, a = o.isMulti, s = o.name, c = o.required, u = this.state.selectValue;
      if (c && !this.hasValue() && !q)
        return /* @__PURE__ */ s1.createElement(Hq, {
          name: s,
          onFocus: this.onValueInputFocus
        });
      if (!(!s || q))
        if (a)
          if (i) {
            var _ = u.map(function(b) {
              return n.getOptionValue(b);
            }).join(i);
            return /* @__PURE__ */ s1.createElement("input", {
              name: s,
              type: "hidden",
              value: _
            });
          } else {
            var A = u.length > 0 ? u.map(function(b, h) {
              return /* @__PURE__ */ s1.createElement("input", {
                key: "i-".concat(h),
                name: s,
                type: "hidden",
                value: n.getOptionValue(b)
              });
            }) : /* @__PURE__ */ s1.createElement("input", {
              name: s,
              type: "hidden",
              value: ""
            });
            return /* @__PURE__ */ s1.createElement("div", null, A);
          }
        else {
          var v = u[0] ? this.getOptionValue(u[0]) : "";
          return /* @__PURE__ */ s1.createElement("input", {
            name: s,
            type: "hidden",
            value: v
          });
        }
    }
  }, {
    key: "renderLiveRegion",
    value: function() {
      var n = this.commonProps, o = this.state, i = o.ariaSelection, q = o.focusedOption, a = o.focusedValue, s = o.isFocused, c = o.selectValue, u = this.getFocusableOptions();
      return /* @__PURE__ */ s1.createElement(Aq, p1({}, n, {
        id: this.getElementId("live-region"),
        ariaSelection: i,
        focusedOption: q,
        focusedValue: a,
        isFocused: s,
        selectValue: c,
        focusableOptions: u,
        isAppleDevice: this.state.isAppleDevice
      }));
    }
  }, {
    key: "render",
    value: function() {
      var n = this.getComponents(), o = n.Control, i = n.IndicatorsContainer, q = n.SelectContainer, a = n.ValueContainer, s = this.props, c = s.className, u = s.id, _ = s.isDisabled, A = s.menuIsOpen, v = this.state.isFocused, b = this.commonProps = this.getCommonProps();
      return /* @__PURE__ */ s1.createElement(q, p1({}, b, {
        className: c,
        innerProps: {
          id: u,
          onKeyDown: this.onKeyDown
        },
        isDisabled: _,
        isFocused: v
      }), this.renderLiveRegion(), /* @__PURE__ */ s1.createElement(o, p1({}, b, {
        innerRef: this.getControlRef,
        innerProps: {
          onMouseDown: this.onControlMouseDown,
          onTouchEnd: this.onControlTouchEnd
        },
        isDisabled: _,
        isFocused: v,
        menuIsOpen: A
      }), /* @__PURE__ */ s1.createElement(a, p1({}, b, {
        isDisabled: _
      }), this.renderPlaceholderOrValue(), this.renderInput()), /* @__PURE__ */ s1.createElement(i, p1({}, b, {
        isDisabled: _
      }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(n, o) {
      var i = o.prevProps, q = o.clearFocusValueOnUpdate, a = o.inputIsHiddenAfterUpdate, s = o.ariaSelection, c = o.isFocused, u = o.prevWasFocused, _ = o.instancePrefix, A = n.options, v = n.value, b = n.menuIsOpen, h = n.inputValue, d = n.isMulti, C = C9(v), f = {};
      if (i && (v !== i.value || A !== i.options || b !== i.menuIsOpen || h !== i.inputValue)) {
        var m = b ? os(n, C) : [], p = b ? G9(X2(n, C), "".concat(_, "-option")) : [], I = q ? is(o, C) : null, w = as(o, m), T = t6(p, w);
        f = {
          selectValue: C,
          focusedOption: w,
          focusedOptionId: T,
          focusableOptionsWithIds: p,
          focusedValue: I,
          clearFocusValueOnUpdate: !1
        };
      }
      var L = a != null && n !== i ? {
        inputIsHidden: a,
        inputIsHiddenAfterUpdate: void 0
      } : {}, j = s, $ = c && u;
      return c && !$ && (j = {
        value: F2(d, C, C[0] || null),
        options: C,
        action: "initial-input-focus"
      }, $ = !u), (s == null ? void 0 : s.action) === "initial-input-focus" && (j = null), h1(h1(h1({}, f), L), {}, {
        prevProps: n,
        ariaSelection: j,
        prevWasFocused: $
      });
    }
  }]), l;
}(ce);
$7.defaultProps = rs;
var ss = /* @__PURE__ */ G4(function(e, t) {
  var l = Io(e);
  return /* @__PURE__ */ s1.createElement($7, p1({
    ref: t
  }, l));
}), Z2 = ss;
const cs = ({ show: e, onHide: t, amenity: l, selectedAmenityMapObjName: r, mapObjectName: n, onClickMapObj: o, allSvgObjectIds: i }) => {
  const { mapConfig: q, allIndexedMapObjects: a, allIndexedRetailers: s } = o4(), [c, u] = m1(), [_, A] = m1([]), [v, b] = m1([]), [h, d] = m1(-1);
  g1(() => {
    if (n) {
      const I = a[n];
      if (I && I.retailer_id) {
        const w = s[I.retailer_id];
        w && u(w);
      }
    } else
      u(void 0);
  }, [a, s, n]);
  const C = (I) => {
    I.preventDefault(), I.stopPropagation();
    let w;
    if (q.KIOSK_ID ? w = Object.values(a).filter((L) => L.kiosk_id === q.KIOSK_ID && i.has(L.map_obj_name))[0] : w = Object.values(a).filter((L) => L.retailer_id === h && i.has(L.map_obj_name))[0], !w) {
      console.error("Map object not found");
      return;
    }
    l ? o(w.map_obj_name, r) : o(w.map_obj_name);
  };
  g1(() => {
    const I = new Set(
      Object.values(a).filter((T) => T.retailer_id !== null).filter((T) => i.has(T.map_obj_name)).map((T) => T.retailer_id)
    ), w = Array.from(I).map((T) => s[T]).filter(Boolean).sort((T, L) => T.retail_name.localeCompare(L.retail_name));
    b(w.map((T) => T.global_retailer_id)), A(w);
  }, [a, s, i]);
  const f = j1(() => _.filter((w) => !(c && w.id === c.id)).map((w) => {
    const L = v.filter(
      (j) => j === w.global_retailer_id
    ).length > 1 && w.location ? `${w.retail_name} (${w.location})` : w.retail_name;
    return { value: w.id, label: L };
  }), [_, v, c]), m = j1(() => f.find((I) => I.value === h) || null, [f, h]), p = (I) => {
    d((I == null ? void 0 : I.value) ?? -1);
  };
  return e ? /* @__PURE__ */ x1(
    u9,
    {
      show: e,
      dialogClassName: a4.retailerInfoModal,
      className: `${a4.retailerInfoModalRoot} eyeon-map-modal px-2`,
      backdropClassName: "eyeon-map-modal-backdrop",
      onHide: t,
      centered: !0,
      scrollable: !0,
      unmountOnClose: !0,
      onExited: () => d(-1),
      children: [
        /* @__PURE__ */ V("div", { className: a4.retailerInfoCloseBtn, children: /* @__PURE__ */ V(t8, { onClick: t, size: 24, color: "white", className: a4.closeBtn }) }),
        /* @__PURE__ */ x1(u9.Body, { className: a4.modalBody, children: [
          /* @__PURE__ */ V("div", { className: a4.contentWrapper, children: c ? /* @__PURE__ */ x1("div", { className: a4.content, children: [
            /* @__PURE__ */ V("div", { className: a4.retailerLogo, children: /* @__PURE__ */ V("img", { className: a4.img, src: c.logo, alt: c.retail_name }) }),
            /* @__PURE__ */ x1("div", { className: a4.retailerInfoContent, children: [
              /* @__PURE__ */ x1("div", { children: [
                /* @__PURE__ */ V("b", { children: "Retailer:" }),
                " ",
                c.retail_name
              ] }),
              c.location && /* @__PURE__ */ x1("div", { children: [
                /* @__PURE__ */ V("b", { children: "Location:" }),
                " ",
                c.location
              ] }),
              c.retailer_phone && /* @__PURE__ */ x1("div", { children: [
                /* @__PURE__ */ V("b", { children: "Phone:" }),
                " ",
                /* @__PURE__ */ V("a", { href: `tel:${c.retailer_phone}`, children: Je(c.retailer_phone) })
              ] }),
              c.retailer_description && /* @__PURE__ */ V("div", { dangerouslySetInnerHTML: { __html: c.retailer_description } })
            ] })
          ] }) : null }),
          /* @__PURE__ */ x1(Sr, { className: a4.getDirectionsFrom, children: [
            /* @__PURE__ */ V(
              Z2,
              {
                name: "retailer",
                className: a4.retailerDropdown,
                classNamePrefix: "eyeon-retailer-select",
                menuPortalTarget: typeof document < "u" ? document.body : void 0,
                "aria-label": "Choose a Retailer",
                options: f,
                isLoading: !1,
                noOptionsMessage: () => "Retailer not found",
                placeholder: "Get direction from ...",
                value: m,
                onChange: p,
                styles: {
                  menuPortal: (I) => ({ ...I, zIndex: 2e3 }),
                  menu: (I) => ({ ...I, zIndex: 2e3 }),
                  option: (I, w) => ({
                    ...I,
                    color: "#000",
                    backgroundColor: w.isFocused || w.isSelected ? "#f1f5f9" : "#fff"
                  }),
                  dropdownIndicator: (I) => ({
                    ...I,
                    color: "#64748b",
                    ":hover": { color: "#64748b" }
                  })
                },
                isClearable: !0
              }
            ),
            /* @__PURE__ */ V("button", { type: "button", disabled: h === -1, onClick: C, className: a4.btn, children: "Map IT" })
          ] })
        ] })
      ]
    }
  ) : null;
};
var us = ["color", "size", "title", "className"];
function I6() {
  return I6 = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var l = arguments[t];
      for (var r in l) ({}).hasOwnProperty.call(l, r) && (e[r] = l[r]);
    }
    return e;
  }, I6.apply(null, arguments);
}
function ms(e, t) {
  if (e == null) return {};
  var l, r, n = ds(e, t);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    for (r = 0; r < o.length; r++) l = o[r], t.indexOf(l) === -1 && {}.propertyIsEnumerable.call(e, l) && (n[l] = e[l]);
  }
  return n;
}
function ds(e, t) {
  if (e == null) return {};
  var l = {};
  for (var r in e) if ({}.hasOwnProperty.call(e, r)) {
    if (t.indexOf(r) !== -1) continue;
    l[r] = e[r];
  }
  return l;
}
var K7 = /* @__PURE__ */ G4(function(e, t) {
  var l = e.color, r = l === void 0 ? "currentColor" : l, n = e.size, o = n === void 0 ? "1em" : n, i = e.title, q = i === void 0 ? null : i, a = e.className, s = a === void 0 ? "" : a, c = ms(e, us);
  return /* @__PURE__ */ J1.createElement("svg", I6({
    ref: t,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: o,
    height: o,
    fill: r,
    className: ["bi", "bi-arrow-clockwise", s].filter(Boolean).join(" ")
  }, c), q ? /* @__PURE__ */ J1.createElement("title", null, q) : null, /* @__PURE__ */ J1.createElement("path", {
    fillRule: "evenodd",
    d: "M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
  }), /* @__PURE__ */ J1.createElement("path", {
    d: "M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466"
  }));
});
K7.propTypes = {
  color: d1.string,
  size: d1.oneOfType([d1.string, d1.number]),
  title: d1.string,
  className: d1.string
};
const fs = (e) => {
  const t = (e || "").trim();
  return !t || t === "-" ? "" : t;
}, k9 = (e) => e.global_retailer_id ? `g:${e.global_retailer_id}` : `n:${(e.retail_name || "").toLowerCase()}`, xs = (e = []) => {
  const t = /* @__PURE__ */ new Map();
  for (const l of e) {
    const r = k9(l);
    t.set(r, (t.get(r) || 0) + 1);
  }
  return e.map((l) => {
    const r = (t.get(k9(l)) || 0) > 1;
    return {
      value: l.id,
      label: l.retail_name,
      location: r ? fs(l.location) : void 0
    };
  });
}, hs = (e) => e.location ? `${e.label} (${e.location})` : e.label, ps = "_sidebarComp_1b6ud_1", gs = "_sidebarFields_1b6ud_2", bs = "_tabOptions_1b6ud_7", _s = "_mainBtnsGroup_1b6ud_12", vs = "_deleteBtn_1b6ud_17", ys = "_btnsGroup_1b6ud_27", Is = "_active_1b6ud_38", Cs = "_sidebarField_1b6ud_2", Es = "_label_1b6ud_50", As = "_fieldWrapper_1b6ud_56", Ss = "_numberFieldGroup_1b6ud_62", Rs = "_button_1b6ud_68", Os = "_decrement_1b6ud_78", Ts = "_increment_1b6ud_84", ws = "_input_1b6ud_95", zs = "_colorFieldGroup_1b6ud_104", Ns = "_colorField_1b6ud_104", Ms = "_inputField_1b6ud_118", Ps = "_rotateButton_1b6ud_130", Ls = "_selectField_1b6ud_148", Fs = "_textareaField_1b6ud_179", Bs = "_textField_1b6ud_187", q1 = {
  sidebarComp: ps,
  sidebarFields: gs,
  tabOptions: bs,
  mainBtnsGroup: _s,
  deleteBtn: vs,
  btnsGroup: ys,
  active: Is,
  sidebarField: Cs,
  label: Es,
  fieldWrapper: As,
  numberFieldGroup: Ss,
  button: Rs,
  decrement: Os,
  increment: Ts,
  input: ws,
  colorFieldGroup: zs,
  colorField: Ns,
  inputField: Ms,
  rotateButton: Ps,
  selectField: Ls,
  textareaField: Fs,
  textField: Bs
}, Gs = (e) => {
  const { setData: t, selectedId: l, floorIndex: r, onObjectResetData: n, onObjectChangeData: o, onObjectNewData: i, triggerSceneUpdate: q } = e, { mapApiResponse: a, meshObject: s, allIndexedRetailers: c } = o4(), { getImage: u, processImage: _, layer_text_logo_position_by_id: A } = T5(), { getMaterial: v } = f3(), b = J9(U9), [h, d] = m1("retailer"), [C, f] = m1("retail_name"), [m, p] = m1(G2), [I, w] = m1(null), [, T] = W9(), L = v1({}), [j, $] = m1([]), k = o1((N) => {
    if (N) {
      const D = N.reduce((O, y) => y.kiosk_id !== null ? [...O, y.kiosk_id] : O, []);
      $([...D]);
    }
  }, []);
  g1(() => {
    k(a.map_objs);
  }, [a, k]);
  const t1 = (N, D, O) => {
    const y = N.userData.kioskConfig;
    y ? (N.userData.distanceFactor = D != null && D.lock_size ? 1500 : void 0, N.userData.kioskConfig = {
      ...y,
      lockSize: D.lock_size,
      blink: y.blink,
      size: Number(D.size),
      floorIndex: O,
      text_color: D.text_color
    }) : N.userData.kioskConfig = {
      lockSize: D.lock_size,
      blink: !1,
      size: Number(D.size),
      floorIndex: O,
      text_color: D.text_color
    };
  }, e1 = o1(async (N, D) => {
    if (I !== (N == null ? void 0 : N.map_obj_name)) return;
    let O = "";
    N.layer_type === "retail_logo" ? O = await u(N, c[N.retailer_id || 0]) : O = await u(N), O && _(O, N, (y, n1) => {
      D.geometry = y, D.material = n1;
      const i1 = y.boundingBox, y1 = new L1();
      if (i1) {
        i1.getCenter(y1);
        const I1 = new L1();
        i1.getSize(I1), D.object_id && A(D.object_id, y1, I1, D, { [D.object_id]: { ...N } });
      }
    });
  }, [u, A, I, _, c]), Q = o1((N, D) => {
    e.meshFloors.meshParams.flat().filter((O) => O !== void 0).forEach((O) => {
      O.mesh.object_id === D && (O.mesh.userData.storeName = N);
    });
  }, [e.meshFloors.meshParams]), Z = o1((N, D, O) => {
    if (!N || I !== (m == null ? void 0 : m.map_obj_name)) return;
    let y = new R5(D, {
      font: N.userData && N.userData.font ? N.userData.font : b,
      size: O,
      height: 0.01,
      curveSegments: 4
    });
    y.center(), N.geometry && N.geometry.dispose(), N.geometry = y, Q(D, m.map_obj_name);
  }, [m == null ? void 0 : m.map_obj_name, b, I, Q]), X = o1((N, D = !1) => {
    const O = a.map_objs.findIndex((y) => y.map_obj_name === N.map_obj_name);
    O !== -1 ? (N.id = a.map_objs[O].id, a.map_objs[O] = { ...N }, t(O, { ...N }), k(a.map_objs), D && (o == null || o(N))) : D && (i == null || i(N));
  }, [a, t, k, i, o]), G = () => {
    if (s) {
      const N = s.textImageMeshObject;
      N && N.userData && N.userData.kioskConfig && (N.userData.kioskConfig = null, e.meshFloors.storeLogos.flat().filter((D) => D !== void 0).forEach((D) => {
        D.storeLogo.object_id === N.object_id && D.storeLogo.userData.kioskConfig !== void 0 && (D.storeLogo.userData.kioskConfig = null);
      }));
    }
  }, a1 = (N) => {
    if (d(N), m.obj_type = N, G(), N === "retailer" && (["retail_name", "retail_logo", "retail_text"].includes(C) || F("retail_name"), m.kiosk_id = null), N === "special" && (["kiosk", "amenity"].includes(C) || F("kiosk"), m.retailer_id = null, s)) {
      const D = s.textImageMeshObject;
      Z(D, "", m.size);
    }
    N === "custom" && (["custom_text", "custom_image"].includes(C) || F("custom_text"), m.retailer_id = null, m.kiosk_id = null), E("size", m.size.toString()), E("text_color", m.text_color || a.mapSettings.apiResponse.STORE_TEXT_COLOR), p({ ...m }), X({ ...m });
  }, F = (N) => {
    m && (f(N), m.layer_type = N, G(), N === "retail_name" || N === "retail_logo" || N === "retail_text" || (N === "kiosk" ? (m.value = "", s && e1(m, s.textImageMeshObject)) : N === "amenity" && (m.kiosk_id = null)), E("size", m.size.toString()), p({ ...m }), X({ ...m }));
  }, M = () => {
    m && (Object.assign(m, G2, { id: m.id, map_obj_name: m.map_obj_name }), a1("retailer"), F("retail_name"), Q("", m.map_obj_name), n && n({ ...m }));
  }, H = (N, D) => {
    N && m && (m.retailer_id = N.value, F(m.layer_type), p({ ...m }), X({ ...m }, !0));
  }, W = (N, D) => {
    N && m && (m.kiosk_id = N.value, p({ ...m }), X({ ...m }, !0), s && (t1(s.textImageMeshObject, m, r), q()));
  }, S = (N, D) => {
    N && m && (m.value = N.value, p({ ...m }), X({ ...m }, !0), s && e1(m, s.textImageMeshObject));
  }, E = o1((N, D) => {
    var O, y, n1;
    if (m && s) {
      const i1 = s.textImageMeshObject, y1 = new L1(), I1 = s.svgShapeMeshObject.geometry.boundingBox;
      switch (I1 && I1.getCenter(y1), N) {
        case "custom_text":
          m.custom_text = D, ["retail_text", "custom_text"].includes(m.layer_type) && Z(i1, m.custom_text, m.size);
          break;
        case "custom_image":
          m.custom_image = D, e1(m, i1), X({ ...m }, !0);
          break;
        case "size":
          if (m.size = parseInt(D), ["retail_logo", "kiosk", "amenity", "custom_image"].includes(m.layer_type))
            m.layer_type === "retail_logo" || m.layer_type === "custom_image" ? (e1(m, i1), setTimeout(() => {
              X({ ...m }, !0);
            }, 300)) : m.layer_type === "amenity" ? (e1(m, i1), T(() => {
              p({ ...m }), X({ ...m }, !0);
            })) : m.kiosk_id && m.layer_type === "kiosk" && (t1(i1, m, r), q());
          else {
            let N1 = "";
            m.layer_type === "retail_name" && ((O = c[m.retailer_id || 0]) != null && O.retail_name) ? N1 = (y = c[m.retailer_id || 0]) == null ? void 0 : y.retail_name : ["retail_text", "custom_text"].includes(m.layer_type) && (N1 = m.custom_text), Z(i1, N1 || "", m.size);
          }
          break;
        case "lock_size":
          m.lock_size = !1, m.value = D, m.layer_type === "kiosk" && (t1(i1, m, r), q());
          break;
        case "rotate":
          m.rotate = parseInt(D), i1.rotation.set(
            i1.rotation.x,
            i1.rotation.y,
            m.rotate * Math.PI / 180
          );
          break;
        case "offset_x":
          y1.x += parseFloat(D), i1.position.setX(y1.x), m.offset_x = parseInt(D);
          break;
        case "offset_y":
          y1.y += parseFloat(D), i1.position.setY(y1.y), m.offset_y = parseInt(D);
          break;
        case "bg_color":
          m.bg_color = D, (n1 = i1.object_id) != null && n1.startsWith("big-store"), s.svgShapeMeshObject.material.colorDefault = P1(m.bg_color);
          break;
        case "text_color":
          if (m.text_color = D, ["retail_name", "retail_text", "custom_text"].includes(m.layer_type)) {
            const N1 = {
              color: m.text_color,
              transparent: !0,
              side: d2,
              depthWrite: !1,
              depthTest: !1
            };
            let l4 = new Se(N1);
            i1.material = l4;
          } else (m.layer_type === "retail_logo" || m.layer_type === "custom_image" || m.obj_type === "special" && m.layer_type === "kiosk" && m.kiosk_id != null || m.obj_type === "special" && m.layer_type === "amenity" && m.value !== null) && (e1(m, i1), m.layer_type === "kiosk" && t1(i1, m, r), T(() => {
            X({
              ...m,
              text_color: m.text_color && m.text_color.replace("#", "")
            }, !0);
          }));
          break;
      }
      T(() => {
        p({ ...m }), X({ ...m }, !0);
      });
    }
  }, [r, m, v, e1, Z, a.retailers, s, q, X]), g = o1((N) => {
    const D = N.target;
    E(D.name, D.value);
  }, [E]);
  g1(() => {
    if (l) {
      const N = a.map_objs.findIndex((D) => D.map_obj_name === l);
      if (N !== -1) {
        const D = { ...a.map_objs[N] };
        p(D), d(D.obj_type), f(D.layer_type);
      } else
        p({
          ...G2,
          map_obj_name: l,
          id: (/* @__PURE__ */ new Date()).getTime()
        });
    }
  }, [a, l]), g1(() => {
    m && w(m.map_obj_name);
  }, [m]);
  const x = (N) => {
    m && Object.hasOwn(m, N) && E(N, (m[N] - 1).toString());
  }, R = (N) => {
    m && Object.hasOwn(m, N) && E(N, (m[N] + 1).toString());
  }, Y = (N, D = 45) => {
    if (m && Object.hasOwn(m, N)) {
      let O = m[N];
      const y = O % D;
      y !== 0 && (O -= y), O += D, O > 360 ? O = D : O === 360 && (O = 0), E(N, O.toString());
    }
  }, B = (N) => {
    const D = window.setInterval(() => {
      x(N);
    }, 200);
    L.current[N] = D;
  }, K = (N) => {
    const D = window.setInterval(() => {
      R(N);
    }, 200);
    L.current[N] = D;
  }, z = (N) => {
    L.current[N] && (clearInterval(L.current[N]), L.current[N] = null);
  }, l1 = xs(a == null ? void 0 : a.retailers), U = (a == null ? void 0 : a.kiosks.map((N) => ({
    value: N.id,
    label: N.name,
    isDisabled: j.includes(N.id)
  }))) || [], J = t2.map((N) => ({
    value: N.type,
    label: N.name
  })) || [];
  return m ? /* @__PURE__ */ V("div", { className: `sidebarComp ${q1.sidebarComp}`, children: /* @__PURE__ */ x1("div", { className: q1.sidebarFields, children: [
    /* @__PURE__ */ x1("div", { className: q1.tabOptions, children: [
      /* @__PURE__ */ x1("div", { className: q1.mainBtnsGroup, children: [
        /* @__PURE__ */ x1("div", { className: q1.btnsGroup, children: [
          /* @__PURE__ */ V("button", { onClick: () => a1("retailer"), className: h === "retailer" ? q1.active : "", children: "Retailer" }),
          /* @__PURE__ */ V("button", { onClick: () => a1("special"), className: h === "special" ? q1.active : "", children: "Special" }),
          /* @__PURE__ */ V("button", { onClick: () => a1("custom"), className: h === "custom" ? q1.active : "", children: "Custom" })
        ] }),
        /* @__PURE__ */ V("button", { className: q1.deleteBtn, onClick: M, children: "Delete" })
      ] }),
      h === "retailer" && /* @__PURE__ */ x1(w4, { children: [
        /* @__PURE__ */ V(
          Z2,
          {
            className: q1.selectField,
            classNamePrefix: "custom",
            menuPortalTarget: document.body,
            "aria-label": "Choose a Retailer",
            options: l1,
            formatOptionLabel: hs,
            filterOption: (N, D) => {
              const O = D.toLowerCase(), y = N.data;
              return y.label.toLowerCase().includes(O) || !!(y.location && y.location.toLowerCase().includes(O));
            },
            isLoading: !1,
            noOptionsMessage: () => "Retailers not found",
            placeholder: "Choose a Retailer...",
            value: l1.find((N) => N.value === m.retailer_id) || null,
            onChange: H
          }
        ),
        m.retailer_id > 0 && /* @__PURE__ */ x1("div", { className: q1.btnsGroup, children: [
          /* @__PURE__ */ V("button", { onClick: () => F("retail_name"), className: C === "retail_name" ? q1.active : "", children: "Retail Name" }),
          /* @__PURE__ */ V("button", { onClick: () => F("retail_logo"), className: C === "retail_logo" ? q1.active : "", children: "Retail Logo" }),
          /* @__PURE__ */ V("button", { onClick: () => F("retail_text"), className: C === "retail_text" ? q1.active : "", children: "Custom Text" })
        ] })
      ] }),
      h === "special" && /* @__PURE__ */ x1(w4, { children: [
        /* @__PURE__ */ x1("div", { className: q1.btnsGroup, children: [
          /* @__PURE__ */ V("button", { onClick: () => F("kiosk"), className: C === "kiosk" ? q1.active : "", children: "Kiosk" }),
          /* @__PURE__ */ V("button", { onClick: () => F("amenity"), className: C === "amenity" ? q1.active : "", children: "Amenity" })
        ] }),
        C === "kiosk" && /* @__PURE__ */ V(
          Z2,
          {
            className: q1.selectField,
            classNamePrefix: "custom",
            "aria-label": "Choose a Kiosk",
            options: U,
            noOptionsMessage: () => "Kiosks not found",
            placeholder: "Choose a Kiosk...",
            value: U.find((N) => N.value === m.kiosk_id) || null,
            onChange: W
          }
        ),
        C === "amenity" && /* @__PURE__ */ V(
          Z2,
          {
            className: q1.selectField,
            classNamePrefix: "custom",
            "aria-label": "Choose Amenity",
            options: J,
            noOptionsMessage: () => "Amenity not found",
            placeholder: "Choose Amenity...",
            value: J.find((N) => N.value === m.value) || null,
            onChange: S
          }
        )
      ] }),
      h === "custom" && /* @__PURE__ */ x1(w4, { children: [
        /* @__PURE__ */ x1("div", { className: q1.btnsGroup, children: [
          /* @__PURE__ */ V("button", { onClick: () => F("custom_text"), className: C === "custom_text" ? q1.active : "", children: "Text" }),
          /* @__PURE__ */ V("button", { onClick: () => F("custom_image"), className: C === "custom_image" ? q1.active : "", children: "Image" })
        ] }),
        C === "custom_image" && /* @__PURE__ */ x1("div", { className: q1.sidebarField, children: [
          /* @__PURE__ */ V("label", { className: q1.label, children: "Image URL" }),
          /* @__PURE__ */ V("div", { className: q1.fieldWrapper, children: /* @__PURE__ */ V(
            "input",
            {
              name: "custom_image",
              type: "text",
              className: q1.textField,
              value: m.custom_image,
              onChange: g
            }
          ) })
        ] })
      ] }),
      (h === "retailer" && C === "retail_text" || h === "custom" && C === "custom_text") && /* @__PURE__ */ x1("div", { className: q1.sidebarField, children: [
        /* @__PURE__ */ V("label", { className: q1.label, children: "Text" }),
        /* @__PURE__ */ V("div", { className: q1.fieldWrapper, children: /* @__PURE__ */ V(
          "textarea",
          {
            name: "custom_text",
            rows: 3,
            className: q1.textareaField,
            value: m.custom_text,
            onChange: g
          }
        ) })
      ] })
    ] }),
    /* @__PURE__ */ x1("div", { className: q1.sidebarField, children: [
      /* @__PURE__ */ V("label", { className: q1.label, children: "Size" }),
      /* @__PURE__ */ V("div", { className: q1.fieldWrapper, children: /* @__PURE__ */ x1("div", { className: q1.numberFieldGroup, children: [
        /* @__PURE__ */ V(
          "button",
          {
            className: `${q1.button} ${q1.decrement}`,
            onClick: () => x("size"),
            onMouseDown: () => B("size"),
            onMouseUp: () => z("size"),
            onMouseLeave: () => z("size"),
            children: "-"
          }
        ),
        /* @__PURE__ */ V(
          "input",
          {
            type: "number",
            value: m.size,
            onChange: (N) => E("size", N.target.value),
            className: q1.input
          }
        ),
        /* @__PURE__ */ V(
          "button",
          {
            className: `${q1.button} ${q1.increment}`,
            onClick: () => R("size"),
            onMouseDown: () => K("size"),
            onMouseUp: () => z("size"),
            onMouseLeave: () => z("size"),
            children: "+"
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ x1("div", { className: q1.sidebarField, children: [
      /* @__PURE__ */ V("label", { className: q1.label, children: "Rotate" }),
      /* @__PURE__ */ x1("div", { className: q1.fieldWrapper, children: [
        /* @__PURE__ */ x1("div", { className: q1.numberFieldGroup, children: [
          /* @__PURE__ */ V(
            "button",
            {
              className: `${q1.button} ${q1.decrement}`,
              onClick: () => x("rotate"),
              onMouseDown: () => B("rotate"),
              onMouseUp: () => z("rotate"),
              onMouseLeave: () => z("rotate"),
              children: "-"
            }
          ),
          /* @__PURE__ */ V(
            "input",
            {
              type: "number",
              value: m.rotate,
              onChange: (N) => E("rotate", N.target.value),
              className: q1.input
            }
          ),
          /* @__PURE__ */ V(
            "button",
            {
              className: `${q1.button} ${q1.increment}`,
              onClick: () => R("rotate"),
              onMouseDown: () => K("rotate"),
              onMouseUp: () => z("rotate"),
              onMouseLeave: () => z("rotate"),
              children: "+"
            }
          )
        ] }),
        /* @__PURE__ */ V(
          "button",
          {
            className: q1.rotateButton,
            onClick: () => Y("rotate"),
            children: /* @__PURE__ */ V(K7, { size: 24 })
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ x1("div", { className: q1.sidebarField, children: [
      /* @__PURE__ */ V("label", { className: q1.label, children: "Offset X" }),
      /* @__PURE__ */ V("div", { className: q1.fieldWrapper, children: /* @__PURE__ */ x1("div", { className: q1.numberFieldGroup, children: [
        /* @__PURE__ */ V(
          "button",
          {
            className: `${q1.button} ${q1.decrement}`,
            onClick: () => x("offset_x"),
            onMouseDown: () => B("offset_x"),
            onMouseUp: () => z("offset_x"),
            onMouseLeave: () => z("offset_x"),
            children: "-"
          }
        ),
        /* @__PURE__ */ V(
          "input",
          {
            type: "number",
            value: m.offset_x,
            onChange: (N) => E("offset_x", N.target.value),
            className: q1.input
          }
        ),
        /* @__PURE__ */ V(
          "button",
          {
            className: `${q1.button} ${q1.increment}`,
            onClick: () => R("offset_x"),
            onMouseDown: () => K("offset_x"),
            onMouseUp: () => z("offset_x"),
            onMouseLeave: () => z("offset_x"),
            children: "+"
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ x1("div", { className: q1.sidebarField, children: [
      /* @__PURE__ */ V("label", { className: q1.label, children: "Offset Y" }),
      /* @__PURE__ */ V("div", { className: q1.fieldWrapper, children: /* @__PURE__ */ x1("div", { className: q1.numberFieldGroup, children: [
        /* @__PURE__ */ V(
          "button",
          {
            className: `${q1.button} ${q1.decrement}`,
            onClick: () => x("offset_y"),
            onMouseDown: () => B("offset_y"),
            onMouseUp: () => z("offset_y"),
            onMouseLeave: () => z("offset_y"),
            children: "-"
          }
        ),
        /* @__PURE__ */ V(
          "input",
          {
            type: "number",
            value: m.offset_y,
            onChange: (N) => E("offset_y", N.target.value),
            className: q1.input
          }
        ),
        /* @__PURE__ */ V(
          "button",
          {
            className: `${q1.button} ${q1.increment}`,
            onClick: () => R("offset_y"),
            onMouseDown: () => K("offset_y"),
            onMouseUp: () => z("offset_y"),
            onMouseLeave: () => z("offset_y"),
            children: "+"
          }
        )
      ] }) })
    ] }),
    /* @__PURE__ */ x1("div", { className: q1.sidebarField, children: [
      /* @__PURE__ */ V("label", { className: q1.label, children: "BG Color" }),
      /* @__PURE__ */ V("div", { className: q1.fieldWrapper, children: /* @__PURE__ */ x1("div", { className: q1.colorFieldGroup, children: [
        /* @__PURE__ */ V(
          "input",
          {
            type: "color",
            name: "bg_color",
            className: q1.colorField,
            value: m.bg_color,
            onChange: g
          }
        ),
        /* @__PURE__ */ V(
          "input",
          {
            type: "text",
            name: "bg_color",
            className: q1.inputField,
            value: m.bg_color,
            onChange: g
          }
        )
      ] }) })
    ] }),
    ["retail_name", "custom_text", "retail_text", "kiosk", "amenity"].includes(m.layer_type) && /* @__PURE__ */ x1("div", { className: q1.sidebarField, children: [
      /* @__PURE__ */ x1("label", { className: q1.label, children: [
        ["kiosk", "amenity"].includes(m.layer_type) ? "Icon" : "Text",
        " Color"
      ] }),
      /* @__PURE__ */ V("div", { className: q1.fieldWrapper, children: /* @__PURE__ */ x1("div", { className: q1.colorFieldGroup, children: [
        /* @__PURE__ */ V(
          "input",
          {
            name: "text_color",
            type: "color",
            className: q1.colorField,
            value: m.text_color,
            onChange: g
          }
        ),
        /* @__PURE__ */ V(
          "input",
          {
            type: "text",
            name: "text_color",
            className: q1.inputField,
            value: m.text_color,
            onChange: g
          }
        )
      ] }) })
    ] })
  ] }) }) : null;
}, Ds = G4((e, t) => {
  const { selectedActiveObjectId: l, setSelectedActiveObjectId: r, onMapDataUpdate: n, onChangeCameraControlPosition: o, handleClickOnRetailer: i } = e, [q, a] = m1(!1), [s, c] = m1(""), [u, _] = m1(!1), [A, v] = m1(-1), [b, h] = m1([]), [d, C] = m1(x4), [f, m] = m1(0), [p, I] = m1("desktop"), [w, T] = m1(!1), [L, j] = m1(!1), [, $] = W9(), [k, t1] = m1(0), [e1, Q] = m1(""), [Z, X] = m1(""), [G, a1] = m1(null), [, F] = m1(0), M = v1(null), H = v1(null);
  H.current = f;
  const W = v1(null), S = o1((r1) => {
    F(r1);
  }, []), { setMapConfig: E, refetchMapData: g, mapApiResponse: x, mapConfig: R, floorsData: Y, setMeshObject: B, indexedKiosks: K, initialFloorsDataIsLoaded: z } = o4(), l1 = o1((r1) => {
    v(r1);
  }, [v]), U = Wl(), { meshParams: J, storeLogos: N, textParams: D, allSvgObjectIds: O } = U, y = v1(null), n1 = v1(Yl()), [i1, y1] = m1(null), [, I1] = m1(0), N1 = o1(() => {
    I1((r1) => r1 + 1);
  }, []), [l4, _1] = m1(!1);
  E6(t, () => {
    var r1, u1;
    return {
      refetchMapData: g,
      createRouteToAmenity: E2,
      createRouteToStore: (r1 = W.current) == null ? void 0 : r1.createRouteToStore,
      getInitialDistance: (u1 = W.current) == null ? void 0 : u1.getInitialDistance,
      resetMap: m8,
      setMapConfig: E,
      refreshState: j
    };
  });
  const i4 = o1((r1) => {
    R.HOST === "DISPLAY_APP" ? I("display_app") : R.HOST === "PORTAL_RESPONSIVE" ? I(R.DEVICE) : r1 > 1024 ? I("desktop") : r1 > 767 ? I("tablet") : I("mobile");
  }, [R]);
  g1(() => {
    if (M.current) {
      const r1 = M.current.offsetWidth;
      m(r1), i4(r1);
      const u1 = () => {
        if (M.current) {
          const b1 = M.current.offsetWidth;
          m(b1), i4(b1);
        }
      };
      return window.addEventListener("resize", u1), u1(), () => {
        window.removeEventListener("resize", u1);
      };
    }
  }, [M.current, L, i4]);
  const [U1, c4, C4] = j1(() => {
    let r1 = "", u1 = null, b1 = Y.length ? Y.length - 1 : 0;
    if (K[R.KIOSK_ID]) {
      const C1 = K[R.KIOSK_ID].map_obj_name, S1 = J == null ? void 0 : J.flat().find((B1) => B1.object_id === C1);
      S1 && (u1 = S1.mesh, b1 = S1.floor_index);
    } else
      R.HOST === "DEMO" && console.error("Kiosk not found in config");
    return [u1, b1, r1];
  }, [R, J, Y, K]), t4 = A > -1 && A < Y.length ? A : c4;
  g1(() => {
    var b1;
    let r1;
    const u1 = ((b1 = Y[t4]) == null ? void 0 : b1.id) || null;
    u1 && R.CAMERA_CONTROLS_STATES.perFloor && R.CAMERA_CONTROLS_STATES.perFloor[u1] ? r1 = R.CAMERA_CONTROLS_STATES.perFloor[u1] : r1 = R.CAMERA_CONTROLS_STATES, R.HOST === "DISPLAY_APP" ? C(JSON.parse(JSON.stringify(r1.display_app))) : R.HOST === "WEBSITE" ? C(JSON.parse(JSON.stringify(p === "desktop" ? r1.desktop : p === "tablet" ? r1.tablet : r1.mobile))) : R.HOST === "PORTAL_RESPONSIVE" && (R.DEVICE === "desktop" ? C(JSON.parse(JSON.stringify(r1.desktop))) : R.DEVICE === "display_app" ? C(JSON.parse(JSON.stringify(r1.display_app))) : R.DEVICE === "mobile" ? C(JSON.parse(JSON.stringify(r1.mobile))) : R.DEVICE === "tablet" && C(JSON.parse(JSON.stringify(r1.tablet))));
  }, [p, R, t4, Y]);
  const C2 = o1((r1) => {
    var b1;
    const u1 = ((b1 = Y[t4]) == null ? void 0 : b1.id) || null;
    o && o(R.CAMERA_CONTROLS_STATES, r1, u1);
  }, [o, t4, Y, R.CAMERA_CONTROLS_STATES]);
  let r2 = "", k4 = R.DEFAULT_SELECTED_STORE ?? "";
  l ? (k4 = l, r2 = s) : e1 && (k4 = "", r2 = s);
  const ee = o1((r1, u1) => {
    h((b1) => {
      const C1 = b1.findIndex((S1) => S1.data.map_obj_name === u1.map_obj_name);
      return C1 !== -1 ? b1[C1] = { index: r1, data: { ...u1 } } : b1.push({ index: r1, data: { ...u1 } }), [...b1];
    });
  }, []), te = o1((r1) => {
    e.onObjectSaveData && e.onObjectSaveData(r1, g);
  }, [e, g]);
  g1(() => {
    document.body.style.cursor = i1 ? "pointer" : "default";
  }, [i1]);
  const m8 = o1((r1 = !1) => {
    var u1, b1;
    r(""), c(""), Q(""), t1(0), l1(c4), W.current && (R.HOST === "PORTAL_RESPONSIVE" ? (u1 = W == null ? void 0 : W.current) == null || u1.resetCamera(r1) : (b1 = W == null ? void 0 : W.current) == null || b1.resetCamera(r1));
  }, [c4, l1, R.HOST, r]);
  g1(() => {
    const r1 = [];
    J.forEach((C1) => {
      C1.forEach((S1) => {
        (S1 == null ? void 0 : S1.mesh_type) === "kiosk" && r1.push(S1);
      });
    });
    const u1 = /* @__PURE__ */ new Map();
    N.filter((C1) => C1 !== void 0).forEach((C1) => {
      C1.forEach((S1) => {
        u1.set(S1.storeLogo.object_id, S1.storeLogo);
      });
    });
    const b1 = U1 == null ? void 0 : U1.object_id;
    r1.forEach((C1) => {
      const S1 = C1.mesh, B1 = u1.get("custom-layer-" + C1.object_id), z1 = x.map_objs.find((se) => se.map_obj_name === S1.object_id);
      S1 && B1 && B1.userData.kioskConfig !== null && (B1.userData.kioskConfig = {
        lockSize: z1 == null ? void 0 : z1.lock_size,
        blink: C1.object_id === b1,
        size: z1 ? z1.size : R.KIOSK_SIZE,
        floorIndex: S1.floor_index
      }, B1.userData.distanceFactor = z1 != null && z1.lock_size ? 1500 : void 0, B1.visible = !0);
    });
  }, [N, J, U1, R, x.map_objs]), g1(() => {
    if (n) {
      const r1 = [];
      b.forEach((u1) => {
        r1.push({ ...u1.data });
      });
    }
  }, [b, n]), g1(() => {
    document.body.style.cursor = u ? "pointer" : "auto";
  }, [u]), g1(() => {
    R != null && R.SELECTED_RETAILER_ID && w && t1(R.SELECTED_RETAILER_ID);
  }, [R, w]), g1(() => {
    if (R && k > 0) {
      const r1 = x.retailers.find((u1) => u1.id === k);
      if (r1) {
        const u1 = x.map_objs.find((C1) => C1.retailer_id === r1.id), b1 = J == null ? void 0 : J.flat().find((C1) => C1.object_id === (u1 == null ? void 0 : u1.map_obj_name));
        b1 && v(b1.floor_index), u1 && r(u1.map_obj_name);
      }
    }
  }, [R, r, k, J, x.map_objs, x.retailers]);
  const V4 = o1((r1) => {
    var S1, B1;
    const u1 = (S1 = D[t4]) == null ? void 0 : S1.find((z1) => z1.textMesh.object_id === `${U2}${r1.object_id}`), b1 = (B1 = N[t4]) == null ? void 0 : B1.find((z1) => z1.storeLogo.object_id === `${U2}${r1.object_id}`);
    let C1 = null;
    u1 && (C1 = {
      svgShapeMeshObject: r1,
      textImageMeshObject: u1.textMesh
    }), b1 && (C1 = {
      svgShapeMeshObject: r1,
      textImageMeshObject: b1.storeLogo
    }), B(C1);
  }, [N, D, B, t4]);
  g1(() => {
    var r1, u1;
    if (J && J.length && l) {
      const b1 = (u1 = (r1 = J[t4]) == null ? void 0 : r1.find((C1) => C1.object_id === l)) == null ? void 0 : u1.mesh;
      b1 && V4(b1);
    }
  }, [J, V4, l, t4]);
  const E2 = o1((r1, u1) => {
    r(""), c(""), Q(r1), u1 && (X(u1), R.HOST === "DISPLAY_APP" && r(u1)), R.HOST === "WEBSITE" && _1(!0);
  }, [R.HOST, r]), I3 = o1((r1, u1, b1) => {
    var C1;
    if (!b1 && R.HOST === "DISPLAY_APP" && i && ((C1 = r1.mesh_type) != null && C1.startsWith("store"))) {
      const S1 = x.map_objs.find((B1) => B1.map_obj_name === r1.object_id && B1.obj_type === "retailer");
      if (S1) {
        const B1 = x.retailers.find((z1) => z1.id === S1.retailer_id);
        B1 && i(B1.id);
      }
      return !1;
    }
    R.HOST === "DISPLAY_APP" && U1 && l1(c4), $(() => {
      V4(r1), r(u1 ?? ""), a((S1) => !S1), t1(0), Q(""), c("");
    });
  }, [c4, U1, i, l1, V4, x.map_objs, x.retailers, R.HOST, r]), le = o1((r1) => {
    if (r1.stopPropagation(), R2(R.HOST)) {
      if (Ul(n1.current.maxDist, r1.delta))
        return;
    } else if (r1.delta > 15)
      return;
    const u1 = r1.object.object_id, b1 = x.map_objs.find((C1) => C1.map_obj_name === u1);
    b1 && b1.layer_type === "amenity" ? (E2(b1.value, u1), R.HOST === "PORTAL" && (V4(r1.object), r(u1 ?? ""))) : (I3(r1.object, u1 ?? ""), R.HOST !== "PORTAL" && !R.KIOSK_ID && (b1 != null && b1.retailer_id) && _1(!0));
  }, [R, E2, r, V4, I3, x.map_objs]), ne = o1((r1) => {
    if (!R2(R.HOST)) return;
    const u1 = a2(r1);
    u1 && k8(n1.current, u1.x, u1.y, u1.pointerId);
  }, [R.HOST]), re = o1((r1) => {
    r1.stopPropagation(), _(!0), r1.object.userData.storeName !== "" && y1(r1.object);
  }, []), oe = o1((r1) => {
    r1.stopPropagation(), y1(null), _(!1), y && y.current && (y.current.style.display = "none");
  }, []);
  g1(() => {
    if (!R2(R.HOST)) return;
    const r1 = M.current;
    if (!r1) return;
    const u1 = n1.current, b1 = (B1) => {
      const z1 = a2(B1);
      z1 && k8(u1, z1.x, z1.y, z1.pointerId);
    }, C1 = (B1) => {
      const z1 = a2(B1);
      z1 && a6(u1, z1.x, z1.y, z1.pointerId);
    }, S1 = (B1) => {
      const z1 = a2(B1);
      z1 && Jl(u1, z1.x, z1.y, z1.pointerId);
    };
    return r1.addEventListener("pointerdown", b1, !0), window.addEventListener("pointermove", C1, { passive: !0 }), window.addEventListener("pointerup", S1), window.addEventListener("pointercancel", S1), () => {
      r1.removeEventListener("pointerdown", b1, !0), window.removeEventListener("pointermove", C1), window.removeEventListener("pointerup", S1), window.removeEventListener("pointercancel", S1);
    };
  }, [R.HOST, L]);
  const ie = o1((r1) => {
    if (r1.stopPropagation(), R2(R.HOST)) {
      const u1 = a2(r1);
      u1 && a6(n1.current, u1.x, u1.y, u1.pointerId);
    }
    y && y.current && r1.object.userData.storeName && r1.object.userData.storeName !== "" ? (y.current.style.top = `${r1.offsetY - 65}px`, y.current.style.left = `${r1.offsetX}px`, y.current.style.display = "block") : y.current && (y.current.style.display = "none");
  }, [R.HOST]), ae = o1((r1, u1) => {
    c(r1), u1 && r(u1 || ""), _1(!1);
  }, [c, _1, r]);
  if (C4)
    return /* @__PURE__ */ V("div", { className: "eyeon-map-status", children: C4 });
  !U1 && R.HOST === "DEMO" && console.error("NO KIOSK OBJECT FOUND");
  const qe = U;
  let C3 = i1, d8 = "";
  return C3 && C3.object_id && (d8 = C3.object_id), /* @__PURE__ */ x1(w4, { children: [
    R.HOST === "PORTAL" && /* @__PURE__ */ V("div", { className: `mapBoxSidebar ${A4.mapBoxSidebar} ${l ? A4.active : ""}`, children: /* @__PURE__ */ V("div", { className: `sidebarWrapper ${A4.sidebarWrapper}`, children: /* @__PURE__ */ V("div", { className: `sidebarBox ${A4.sidebarBox}`, children: l ? /* @__PURE__ */ V(
      Gs,
      {
        floorIndex: t4,
        meshFloors: U,
        setData: ee,
        selectedId: l,
        onObjectSaveData: te,
        onObjectResetData: e.onObjectResetData,
        onObjectChangeData: e.onObjectChangeData,
        onObjectNewData: e.onObjectNewData,
        triggerSceneUpdate: N1
      }
    ) : null }) }) }),
    /* @__PURE__ */ x1("div", { ref: M, className: `mapBox ${A4.mapBox}`, children: [
      /* @__PURE__ */ V(
        hn,
        {
          selectedFloorIndex: t4,
          handleFloorChange: l1,
          reset: m8,
          zoomIn: () => a1({ direction: "in" }),
          zoomOut: () => a1({ direction: "out" }),
          amenitiesList: t2,
          handleAmenityClick: E2,
          onExtractedAmenities: e.onExtractedAmenities
        }
      ),
      /* @__PURE__ */ x1(me, { style: { position: "absolute", top: 0, left: 0 }, flat: !0, children: [
        Number(R.STATS) ? /* @__PURE__ */ V(Oe, { className: A4.stats }) : null,
        /* @__PURE__ */ V(jl, { background: R.MAP_BACKGROUND_COLOR }),
        /* @__PURE__ */ V(Xl, { near: 1, far: R.CAMERA.far, fov: R.CAMERA.fov }),
        /* @__PURE__ */ V("ambientLight", { intensity: 4, color: "#c4c4c4" }),
        /* @__PURE__ */ V("directionalLight", { position: [0, 400, 0], color: "#ffffff", intensity: 0.3 }),
        /* @__PURE__ */ V("directionalLight", { position: [0, 0, 400], color: "#c4c4c4", intensity: 0.2 }),
        /* @__PURE__ */ V("directionalLight", { position: [0, 0, -400], color: "#c4c4c4", intensity: 0.2 }),
        /* @__PURE__ */ V(
          an,
          {
            meshFloors: qe,
            activeObjectId: k4,
            hoverObjectId: d8,
            currKioskObj: U1,
            currKioskFloorIndex: c4,
            routeTargetId: k4,
            routeTargetFromId: r2,
            currentFloorIndex: t4,
            onPointerEnter: re,
            onPointerLeave: oe,
            onPointerMove: ie,
            onPointerDown: ne,
            onClick: le,
            handleChangeFloor: l1,
            selectedAmenityType: e1,
            escalatorNodes: U.escalator_nodes,
            zoom: G,
            handleCameraLength: S,
            ref: W,
            cameraControlsPosition: d,
            handleCameraAndControlsChange: C2,
            isSelectedRetailerSlug: !0,
            setIsCameraInit: T,
            handleObjectClick: I3,
            triggerClick: q,
            deviceType: p
          }
        )
      ] }),
      R.HOST !== "DISPLAY_APP" && (R.HOST !== "WEBSITE" || !["mobile", "tablet"].includes(p)) && /* @__PURE__ */ V(
        "div",
        {
          ref: y,
          className: `store-name-placeholder ${A4.storeNamePlaceholder}`,
          style: { display: i1 ? "block" : "none" },
          children: i1 && i1.userData.storeName
        }
      )
    ] }),
    R.HOST === "WEBSITE" && /* @__PURE__ */ V(
      cs,
      {
        show: l4,
        onHide: () => _1(!1),
        amenity: e1,
        selectedAmenityMapObjName: Z,
        mapObjectName: l,
        onClickMapObj: ae,
        allSvgObjectIds: O
      }
    )
  ] });
}), ks = "_mapBoxComponent_18958_1", Vs = "_tempImageRendering_18958_13", V9 = {
  mapBoxComponent: ks,
  tempImageRendering: Vs
}, Cc = (e) => {
  const {
    config: t,
    webApiURI: l,
    cachedMapApiResponse: r,
    onNewMapApiResponse: n,
    rerenderMapOnNewMapApiResponse: o,
    mapBoxRefObj: i,
    onObjectSaveData: q,
    onObjectResetData: a,
    onObjectChangeData: s,
    onObjectNewData: c,
    mapApiResponseRef: u,
    onChangeCameraControlPosition: _,
    onExtractedAmenities: A,
    handleClickOnRetailer: v
  } = e, [b, h] = J1.useState("");
  return /* @__PURE__ */ V(Pl, { mapApiResponseRef: u, initialData: {
    webApiBaseUrl: l,
    config: t
  }, cachedMapApiResponse: r, onNewMapApiResponse: n, rerenderMapOnNewMapApiResponse: o, children: /* @__PURE__ */ x1("div", { className: `mapBoxComponent ${V9.mapBoxComponent} MAP_HOST_${t.HOST ?? "WEBSITE"}`, children: [
    /* @__PURE__ */ V(
      Ds,
      {
        ref: i,
        setSelectedActiveObjectId: h,
        selectedActiveObjectId: b,
        onObjectSaveData: q,
        onObjectResetData: a,
        onObjectChangeData: s,
        onObjectNewData: c,
        onChangeCameraControlPosition: _,
        onExtractedAmenities: A,
        handleClickOnRetailer: v
      }
    ),
    /* @__PURE__ */ x1("div", { className: "hide", children: [
      /* @__PURE__ */ V("div", { id: "map-special-svg-kiosk", dangerouslySetInnerHTML: { __html: W1.Kiosk } }),
      /* @__PURE__ */ V("div", { id: "map-special-svg-escalator", dangerouslySetInnerHTML: { __html: W1.Escalator } }),
      t2.map((C, f) => /* @__PURE__ */ V("div", { id: `map-special-svg-${C.type}`, dangerouslySetInnerHTML: { __html: C.svgCode } }, f))
    ] }),
    /* @__PURE__ */ V("div", { id: "temp-image-rendering", className: V9.tempImageRendering })
  ] }) });
}, Hs = /* @__PURE__ */ new Set([
  "elevator",
  "escalator"
]), Q7 = t2.filter(
  (e) => !Hs.has(e.type)
), Ws = W1.Kiosk, js = W1.Entrance, Xs = W1.EscalatorUp, Zs = W1.EscalatorDown;
function Ec(e) {
  return Q7.some((t) => t.type === e);
}
function Ys(e) {
  return Q7.find((t) => t.type === e) ?? t2.find((t) => t.type === e);
}
function Ac(e) {
  var t;
  return e === "kiosk" ? Ws : e === "entrance" ? js : e === "escalator-up" ? Xs : e === "escalator-down" ? Zs : (t = Ys(e)) == null ? void 0 : t.svgCode;
}
function Js(e, t) {
  const l = t.startsWith("#") ? t : `#${t}`;
  return e.replace(/fill="(?!none")[^"]*"/gi, `fill="${l}"`).replace(/stroke="(?!none")[^"]*"/gi, `stroke="${l}"`);
}
function Sc(e, t) {
  const l = t ? Js(e, t) : e;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(l)}`;
}
export {
  t2 as AllAmenities,
  Q7 as AssignAmenities,
  js as EntranceSvg,
  Ws as KioskSvg,
  Cc as MapBox,
  Ys as getAmenityByType,
  Ac as getMapSpecialSvg,
  Ec as isAssignAmenity,
  Sc as mapSpecialSvgToDataUrl,
  Js as recolorMapSvg
};
//# sourceMappingURL=index.module.js.map
